
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired00e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired00e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("h5l15", function(module, exports) {

$parcel$export(module.exports, "doEval", () => doEval);
$parcel$export(module.exports, "isElement", () => isElement);
$parcel$export(module.exports, "isNullish", () => isNullish);
$parcel$export(module.exports, "log", () => log);
$parcel$export(module.exports, "mixInto", () => mixInto);
$parcel$export(module.exports, "matchBinaryMask", () => matchBinaryMask);
/*
Copyright 2025-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
var $cBHcM = parcelRequire("cBHcM");

var $4vC7I = parcelRequire("4vC7I");
const doEval = (expression)=>{
    // eslint-disable-next-line no-eval -- valid here as we want this function to be the only place in the codebase that uses eval
    return eval(expression);
};
const isElement = (node)=>node?.nodeType === (0, $cBHcM.NODE_TYPE).ELEMENT;
const isNullish = (v)=>v == undefined;
const log = ()=>(0, $4vC7I.GlobalConfig).logger;
const mixInto = (dest)=>(mixin)=>{
        const keys = Reflect.ownKeys(mixin);
        try {
            for (const key of keys)Object.defineProperty(dest.prototype, key, {
                value: mixin[key],
                writable: true
            });
        } catch (e) {
            log().error('Error while mixing', e);
        }
    };
const matchBinaryMask = (value, mask)=>{
    return (value & mask) === mask;
};

});
parcelRegister("cBHcM", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $92da74620dbab0b3$export$a4ad2735b021c132);
$parcel$export(module.exports, "DEFAULT_HOTSPOT", () => $92da74620dbab0b3$export$f7fdd7e569916a58);
$parcel$export(module.exports, "MIN_HOTSPOT_SIZE", () => $92da74620dbab0b3$export$75b832a0283729cc);
$parcel$export(module.exports, "MAX_HOTSPOT_SIZE", () => $92da74620dbab0b3$export$ad6e3a03749beed0);
$parcel$export(module.exports, "IDENTITY_FIELD_NAME", () => $92da74620dbab0b3$export$9dcbbc63dd363a6d);
$parcel$export(module.exports, "NS_SVG", () => $92da74620dbab0b3$export$f851f360b0a1c430);
$parcel$export(module.exports, "NS_XLINK", () => $92da74620dbab0b3$export$84b1416dc9f08e0d);
$parcel$export(module.exports, "SHADOWCOLOR", () => $92da74620dbab0b3$export$69af724fb6132a95);
$parcel$export(module.exports, "SHADOW_OFFSET_X", () => $92da74620dbab0b3$export$7580626912afa380);
$parcel$export(module.exports, "SHADOW_OFFSET_Y", () => $92da74620dbab0b3$export$78f9b902190452ff);
$parcel$export(module.exports, "SHADOW_OPACITY", () => $92da74620dbab0b3$export$cc9f2e7af7b43ffd);
$parcel$export(module.exports, "TOOLTIP_VERTICAL_OFFSET", () => $92da74620dbab0b3$export$559a5cd2cf4fb607);
$parcel$export(module.exports, "DEFAULT_VALID_COLOR", () => $92da74620dbab0b3$export$a244955c8add8869);
$parcel$export(module.exports, "DEFAULT_INVALID_COLOR", () => $92da74620dbab0b3$export$51648b5beab2f93c);
$parcel$export(module.exports, "OUTLINE_HIGHLIGHT_COLOR", () => $92da74620dbab0b3$export$e485645086d33982);
$parcel$export(module.exports, "OUTLINE_HIGHLIGHT_STROKEWIDTH", () => $92da74620dbab0b3$export$baa303f54b2c28d0);
$parcel$export(module.exports, "HIGHLIGHT_STROKEWIDTH", () => $92da74620dbab0b3$export$b057518f1734d1a6);
$parcel$export(module.exports, "HIGHLIGHT_SIZE", () => $92da74620dbab0b3$export$ff1d3aecce5662dc);
$parcel$export(module.exports, "HIGHLIGHT_OPACITY", () => $92da74620dbab0b3$export$a9857cbe2590b779);
$parcel$export(module.exports, "HIGHLIGHT_COLOR", () => $92da74620dbab0b3$export$e1f7817aa0536571);
$parcel$export(module.exports, "CONNECT_TARGET_COLOR", () => $92da74620dbab0b3$export$1b75e272bbd948d5);
$parcel$export(module.exports, "INVALID_CONNECT_TARGET_COLOR", () => $92da74620dbab0b3$export$1c2ff68c1d7dffe0);
$parcel$export(module.exports, "DROP_TARGET_COLOR", () => $92da74620dbab0b3$export$fd2cf6362cc03a17);
$parcel$export(module.exports, "VALID_COLOR", () => $92da74620dbab0b3$export$17636c4ce9145ef9);
$parcel$export(module.exports, "INVALID_COLOR", () => $92da74620dbab0b3$export$c74a1c6a7d8703df);
$parcel$export(module.exports, "EDGE_SELECTION_COLOR", () => $92da74620dbab0b3$export$93e7a18a26f01c6d);
$parcel$export(module.exports, "VERTEX_SELECTION_COLOR", () => $92da74620dbab0b3$export$69cc02d045793560);
$parcel$export(module.exports, "VERTEX_SELECTION_STROKEWIDTH", () => $92da74620dbab0b3$export$8eaf34f121ff095d);
$parcel$export(module.exports, "EDGE_SELECTION_STROKEWIDTH", () => $92da74620dbab0b3$export$4e929dcda0818e13);
$parcel$export(module.exports, "VERTEX_SELECTION_DASHED", () => $92da74620dbab0b3$export$5eb8afaa7ef18d06);
$parcel$export(module.exports, "EDGE_SELECTION_DASHED", () => $92da74620dbab0b3$export$5c5fabec2ff767e9);
$parcel$export(module.exports, "GUIDE_COLOR", () => $92da74620dbab0b3$export$b2786c4f0995e71c);
$parcel$export(module.exports, "GUIDE_STROKEWIDTH", () => $92da74620dbab0b3$export$dc6ed24b95c2be5e);
$parcel$export(module.exports, "OUTLINE_COLOR", () => $92da74620dbab0b3$export$a04467ee0a29cc8c);
$parcel$export(module.exports, "OUTLINE_STROKEWIDTH", () => $92da74620dbab0b3$export$1e688fae006aa510);
$parcel$export(module.exports, "HANDLE_SIZE", () => $92da74620dbab0b3$export$60a3a7903436da3f);
$parcel$export(module.exports, "LABEL_HANDLE_SIZE", () => $92da74620dbab0b3$export$f2e8db6ac758d11e);
$parcel$export(module.exports, "HANDLE_FILLCOLOR", () => $92da74620dbab0b3$export$9898c1b681fa062b);
$parcel$export(module.exports, "HANDLE_STROKECOLOR", () => $92da74620dbab0b3$export$90b1a72829fa1802);
$parcel$export(module.exports, "LABEL_HANDLE_FILLCOLOR", () => $92da74620dbab0b3$export$1f4605121aa2e6ad);
$parcel$export(module.exports, "CONNECT_HANDLE_FILLCOLOR", () => $92da74620dbab0b3$export$a3709086650d7844);
$parcel$export(module.exports, "LOCKED_HANDLE_FILLCOLOR", () => $92da74620dbab0b3$export$bcea8028d777e8c9);
$parcel$export(module.exports, "OUTLINE_HANDLE_FILLCOLOR", () => $92da74620dbab0b3$export$4350067adb3202f1);
$parcel$export(module.exports, "OUTLINE_HANDLE_STROKECOLOR", () => $92da74620dbab0b3$export$aea09d6aaee88f3a);
$parcel$export(module.exports, "DEFAULT_FONTFAMILY", () => $92da74620dbab0b3$export$8d2486252e7b0838);
$parcel$export(module.exports, "DEFAULT_FONTSIZE", () => $92da74620dbab0b3$export$b7bf38c5dcbaffca);
$parcel$export(module.exports, "DEFAULT_TEXT_DIRECTION", () => $92da74620dbab0b3$export$cb56847335dfe5e5);
$parcel$export(module.exports, "LINE_HEIGHT", () => $92da74620dbab0b3$export$42510bee89f29ff9);
$parcel$export(module.exports, "WORD_WRAP", () => $92da74620dbab0b3$export$89c18ea02a532361);
$parcel$export(module.exports, "ABSOLUTE_LINE_HEIGHT", () => $92da74620dbab0b3$export$265bdc5845319e89);
$parcel$export(module.exports, "DEFAULT_FONTSTYLE", () => $92da74620dbab0b3$export$5e8c79e550956de0);
$parcel$export(module.exports, "DEFAULT_STARTSIZE", () => $92da74620dbab0b3$export$3fdd7bd979cb1c8);
$parcel$export(module.exports, "DEFAULT_MARKERSIZE", () => $92da74620dbab0b3$export$ce3a7b1259f60dfc);
$parcel$export(module.exports, "DEFAULT_IMAGESIZE", () => $92da74620dbab0b3$export$4bbbbbf8ba94a250);
$parcel$export(module.exports, "ENTITY_SEGMENT", () => $92da74620dbab0b3$export$ac790cb430416212);
$parcel$export(module.exports, "RECTANGLE_ROUNDING_FACTOR", () => $92da74620dbab0b3$export$5aaac99403c20e50);
$parcel$export(module.exports, "LINE_ARCSIZE", () => $92da74620dbab0b3$export$b4e45edac83aca7);
$parcel$export(module.exports, "ARROW_SPACING", () => $92da74620dbab0b3$export$f14205646fc3af72);
$parcel$export(module.exports, "ARROW_WIDTH", () => $92da74620dbab0b3$export$f2abfe307624e252);
$parcel$export(module.exports, "ARROW_SIZE", () => $92da74620dbab0b3$export$f17f1fa6cf87e34f);
$parcel$export(module.exports, "PAGE_FORMAT_A4_PORTRAIT", () => $92da74620dbab0b3$export$dcc264d4cee27e6a);
$parcel$export(module.exports, "PAGE_FORMAT_A4_LANDSCAPE", () => $92da74620dbab0b3$export$3b481a9081af1e27);
$parcel$export(module.exports, "PAGE_FORMAT_LETTER_PORTRAIT", () => $92da74620dbab0b3$export$6ab0f742f21a51c4);
$parcel$export(module.exports, "PAGE_FORMAT_LETTER_LANDSCAPE", () => $92da74620dbab0b3$export$7df65dabb1a45e7b);
$parcel$export(module.exports, "NONE", () => $92da74620dbab0b3$export$c53d0f541b41b88e);
$parcel$export(module.exports, "FONT_STYLE_MASK", () => $92da74620dbab0b3$export$f9455ecfe07b2b14);
$parcel$export(module.exports, "DIRECTION_MASK", () => $92da74620dbab0b3$export$6e3484e530cbb8d6);
$parcel$export(module.exports, "NODE_TYPE", () => $92da74620dbab0b3$export$accaa52ddae3fe58);
/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /**
 * The version of the `maxGraph` library.
 */ // WARN: this constant is updated at release time by the script located at 'scripts/update-versions.mjs'.
// So, if you modify the name of this file or this constant, please update the script accordingly.
const $92da74620dbab0b3$export$a4ad2735b021c132 = '0.25.0';
const $92da74620dbab0b3$export$f7fdd7e569916a58 = 0.3;
const $92da74620dbab0b3$export$75b832a0283729cc = 8;
const $92da74620dbab0b3$export$ad6e3a03749beed0 = 0;
const $92da74620dbab0b3$export$9dcbbc63dd363a6d = 'mxObjectId';
const $92da74620dbab0b3$export$f851f360b0a1c430 = 'http://www.w3.org/2000/svg';
const $92da74620dbab0b3$export$84b1416dc9f08e0d = 'http://www.w3.org/1999/xlink';
const $92da74620dbab0b3$export$69af724fb6132a95 = 'gray';
const $92da74620dbab0b3$export$7580626912afa380 = 2;
const $92da74620dbab0b3$export$78f9b902190452ff = 3;
const $92da74620dbab0b3$export$cc9f2e7af7b43ffd = 1;
const $92da74620dbab0b3$export$559a5cd2cf4fb607 = 16;
const $92da74620dbab0b3$export$a244955c8add8869 = '#00FF00';
const $92da74620dbab0b3$export$51648b5beab2f93c = '#FF0000';
const $92da74620dbab0b3$export$e485645086d33982 = '#00FF00';
const $92da74620dbab0b3$export$baa303f54b2c28d0 = 5;
const $92da74620dbab0b3$export$b057518f1734d1a6 = 3;
const $92da74620dbab0b3$export$ff1d3aecce5662dc = 2;
const $92da74620dbab0b3$export$a9857cbe2590b779 = 100;
const $92da74620dbab0b3$export$e1f7817aa0536571 = '#00FF00';
const $92da74620dbab0b3$export$1b75e272bbd948d5 = '#0000FF';
const $92da74620dbab0b3$export$1c2ff68c1d7dffe0 = '#FF0000';
const $92da74620dbab0b3$export$fd2cf6362cc03a17 = '#0000FF';
const $92da74620dbab0b3$export$17636c4ce9145ef9 = '#00FF00';
const $92da74620dbab0b3$export$c74a1c6a7d8703df = '#FF0000';
const $92da74620dbab0b3$export$93e7a18a26f01c6d = '#00FF00';
const $92da74620dbab0b3$export$69cc02d045793560 = '#00FF00';
const $92da74620dbab0b3$export$8eaf34f121ff095d = 1;
const $92da74620dbab0b3$export$4e929dcda0818e13 = 1;
const $92da74620dbab0b3$export$5eb8afaa7ef18d06 = true;
const $92da74620dbab0b3$export$5c5fabec2ff767e9 = true;
const $92da74620dbab0b3$export$b2786c4f0995e71c = '#FF0000';
const $92da74620dbab0b3$export$dc6ed24b95c2be5e = 1;
const $92da74620dbab0b3$export$a04467ee0a29cc8c = '#0099FF';
const $92da74620dbab0b3$export$1e688fae006aa510 = 3;
const $92da74620dbab0b3$export$60a3a7903436da3f = 6;
const $92da74620dbab0b3$export$f2e8db6ac758d11e = 4;
const $92da74620dbab0b3$export$9898c1b681fa062b = '#00FF00';
const $92da74620dbab0b3$export$90b1a72829fa1802 = 'black';
const $92da74620dbab0b3$export$1f4605121aa2e6ad = 'yellow';
const $92da74620dbab0b3$export$a3709086650d7844 = '#0000FF';
const $92da74620dbab0b3$export$bcea8028d777e8c9 = '#FF0000';
const $92da74620dbab0b3$export$4350067adb3202f1 = '#00FFFF';
const $92da74620dbab0b3$export$aea09d6aaee88f3a = '#0033FF';
const $92da74620dbab0b3$export$8d2486252e7b0838 = 'Arial,Helvetica,sans-serif';
const $92da74620dbab0b3$export$b7bf38c5dcbaffca = 11;
const $92da74620dbab0b3$export$cb56847335dfe5e5 = '';
const $92da74620dbab0b3$export$42510bee89f29ff9 = 1.2;
const $92da74620dbab0b3$export$89c18ea02a532361 = 'normal';
const $92da74620dbab0b3$export$265bdc5845319e89 = false;
const $92da74620dbab0b3$export$5e8c79e550956de0 = 0;
const $92da74620dbab0b3$export$3fdd7bd979cb1c8 = 40;
const $92da74620dbab0b3$export$ce3a7b1259f60dfc = 6;
const $92da74620dbab0b3$export$4bbbbbf8ba94a250 = 24;
const $92da74620dbab0b3$export$ac790cb430416212 = 30;
const $92da74620dbab0b3$export$5aaac99403c20e50 = 0.15;
const $92da74620dbab0b3$export$b4e45edac83aca7 = 20;
const $92da74620dbab0b3$export$f14205646fc3af72 = 0;
const $92da74620dbab0b3$export$f2abfe307624e252 = 30;
const $92da74620dbab0b3$export$f17f1fa6cf87e34f = 30;
const $92da74620dbab0b3$export$dcc264d4cee27e6a = [
    0,
    0,
    827,
    1169
];
const $92da74620dbab0b3$export$3b481a9081af1e27 = [
    0,
    0,
    1169,
    827
];
const $92da74620dbab0b3$export$6ab0f742f21a51c4 = [
    0,
    0,
    850,
    1100
];
const $92da74620dbab0b3$export$7df65dabb1a45e7b = [
    0,
    0,
    1100,
    850
];
const $92da74620dbab0b3$export$c53d0f541b41b88e = 'none';
const $92da74620dbab0b3$export$f9455ecfe07b2b14 = {
    /** for bold fonts. */ BOLD: 1,
    /** for italic fonts. */ ITALIC: 2,
    /** for underlined fonts. */ UNDERLINE: 4,
    /** for strikethrough fonts. */ STRIKETHROUGH: 8
};
const $92da74620dbab0b3$export$6e3484e530cbb8d6 = {
    /** No direction. */ NONE: 0,
    WEST: 1,
    NORTH: 2,
    SOUTH: 4,
    EAST: 8,
    /** All directions. */ ALL: 15
};
const $92da74620dbab0b3$export$accaa52ddae3fe58 = {
    ELEMENT: 1,
    ATTRIBUTE: 2,
    TEXT: 3,
    CDATA: 4,
    ENTITY_REFERENCE: 5,
    ENTITY: 6,
    PROCESSING_INSTRUCTION: 7,
    COMMENT: 8,
    DOCUMENT: 9,
    DOCUMENT_TYPE: 10,
    DOCUMENT_FRAGMENT: 11,
    NOTATION: 12
};

});

parcelRegister("4vC7I", function(module, exports) {

$parcel$export(module.exports, "GlobalConfig", () => $3487a133cb2514e6$export$8edddc2fb2fcfb3a);
$parcel$export(module.exports, "StyleDefaultsConfig", () => $3487a133cb2514e6$export$d8fd26e8d70814c0);
/*
Copyright 2024-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
var $dayGk = parcelRequire("dayGk");

var $cBHcM = parcelRequire("cBHcM");

var $iy79G = parcelRequire("iy79G");

var $8YQgE = parcelRequire("8YQgE");
const $3487a133cb2514e6$export$8edddc2fb2fcfb3a = {
    /**
     * Configure the {@link I18nProvider} to use for all translated messages.
     *
     * Available implementations provided by maxGraph are:
     * * {@link NoOpI18n} - Default implementation that does nothing.
     * * {@link TranslationsAsI18n} - Uses {@link Translations} to manage translations.
     *
     * To change the i18n provider, set this property to an instance of the desired provider:
     * ```js
     * // To use the i18n system provided by maxGraph
     * GlobalConfig.i18n = new TranslationsAsI18n();
     * ```
     *
     * @default {@link NoOpI18n}
     * @since 0.17.0
     */ i18n: new (0, $8YQgE.NoOpI18n)(),
    /**
     * Configure the logger to use for all log messages.
     *
     * Available implementations provided by maxGraph are:
     * * {@link ConsoleLogger} - Directs logs to the browser console.
     * * {@link NoOpLogger} - Default implementation that does nothing.
     * * {@link MaxLogAsLogger} - Directs logs to {@link MaxLog}.
     *
     * To change the logger, set this property to an instance of the desired logger:
     * ```js
     * // To direct logs to the browser console
     * GlobalConfig.logger = new ConsoleLogger();
     * // To direct logs to MaxLog
     * GlobalConfig.logger = new MaxLogAsLogger();
     * ```
     *
     * @default {@link NoOpLogger}
     */ logger: new (0, $dayGk.NoOpLogger)()
};
const $3487a133cb2514e6$var$defaultGlobalConfig = {
    ...$3487a133cb2514e6$export$8edddc2fb2fcfb3a
};
const $3487a133cb2514e6$export$7ff83afbb0ad439e = ()=>{
    (0, $iy79G.shallowCopy)($3487a133cb2514e6$var$defaultGlobalConfig, $3487a133cb2514e6$export$8edddc2fb2fcfb3a);
};
const $3487a133cb2514e6$export$d8fd26e8d70814c0 = {
    /**
     * Defines the size (in px) of the arrowhead in the arrow shape.
     * @default {@link ARROW_SIZE}
     * @since 0.22.0
     */ arrowSize: (0, $cBHcM.ARROW_SIZE),
    /**
     * Defines the spacing (in px) between the arrow shape and its terminals.
     * @default {@link ARROW_SPACING}
     * @since 0.22.0
     */ arrowSpacing: (0, $cBHcM.ARROW_SPACING),
    /**
     * Defines the width (in px) of the arrow shape.
     * @default {@link ARROW_WIDTH}
     * @since 0.22.0
     */ arrowWidth: (0, $cBHcM.ARROW_WIDTH),
    /**
     * Defines the default family for all fonts.
     * @default {@link DEFAULT_FONTFAMILY}
     * @since 0.22.0
     */ fontFamily: (0, $cBHcM.DEFAULT_FONTFAMILY),
    /**
     * Defines the default size (in px).
     * @default {@link DEFAULT_FONTSIZE}
     * @since 0.22.0
     */ fontSize: (0, $cBHcM.DEFAULT_FONTSIZE),
    /**
     * Defines the default width and height (in px) for images used in the label shape.
     * @default {@link DEFAULT_IMAGESIZE}
     * @since 0.22.0
     */ imageSize: (0, $cBHcM.DEFAULT_IMAGESIZE),
    /**
     * Defines the default size (in px) of the arcs for the rounded edges.
     * See {@link CellStateStyle.arcSize}.
     * @default {@link LINE_ARCSIZE}
     * @since 0.22.0
     */ lineArcSize: (0, $cBHcM.LINE_ARCSIZE),
    /**
     * Defines the default size (in px) for all markers.
     * @default {@link DEFAULT_MARKERSIZE}
     * @since 0.22.0
     */ markerSize: (0, $cBHcM.DEFAULT_MARKERSIZE),
    /**
     * Defines the default rounding factor for the rounded vertices in percent between `0` and `1`.
     * Values should be smaller than `0.5`.
     * See {@link CellStateStyle.arcSize}.
     * @default {@link RECTANGLE_ROUNDING_FACTOR}
     * @since 0.22.0
     */ roundingFactor: (0, $cBHcM.RECTANGLE_ROUNDING_FACTOR),
    /**
     * Defines the color to be used to draw shadows in shapes and windows.
     * @default {@link SHADOWCOLOR}
     */ shadowColor: (0, $cBHcM.SHADOWCOLOR),
    /**
     * Specifies the x-offset of the shadow.
     * @default {@link SHADOW_OFFSET_X}
     */ shadowOffsetX: (0, $cBHcM.SHADOW_OFFSET_X),
    /**
     * Specifies the y-offset of the shadow.
     * @default {@link SHADOW_OFFSET_Y}
     */ shadowOffsetY: (0, $cBHcM.SHADOW_OFFSET_Y),
    /**
     * Defines the opacity for shadow. Possible values are between 1 (opaque) and 0 (transparent).
     * @default {@link SHADOW_OPACITY}
     */ shadowOpacity: (0, $cBHcM.SHADOW_OPACITY),
    /**
     * Defines the default start size (in px) for swimlanes.
     * @default {@link DEFAULT_STARTSIZE}
     * @since 0.22.0
     */ startSize: (0, $cBHcM.DEFAULT_STARTSIZE)
};
const $3487a133cb2514e6$var$defaultStyleDefaultsConfig = {
    ...$3487a133cb2514e6$export$d8fd26e8d70814c0
};
const $3487a133cb2514e6$export$7014222a8010bb5b = ()=>{
    (0, $iy79G.shallowCopy)($3487a133cb2514e6$var$defaultStyleDefaultsConfig, $3487a133cb2514e6$export$d8fd26e8d70814c0);
};

});
parcelRegister("dayGk", function(module, exports) {

$parcel$export(module.exports, "NoOpLogger", () => $99671c9cc4d2466a$export$4147bde06f294c2e);
/*
Copyright 2024-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
var $klJDc = parcelRequire("klJDc");
class $99671c9cc4d2466a$export$4147bde06f294c2e {
    debug(_message) {}
    enter(_message) {
        return undefined;
    }
    error(_message, ..._optionalParams) {}
    info(_message) {}
    leave(_message, _baseTimestamp) {}
    show() {}
    trace(_message) {}
    warn(_message) {}
}
class $99671c9cc4d2466a$export$ba6a9c7ac8291f7f {
    constructor(){
        this.debugEnabled = false;
        this.infoEnabled = false;
        this.traceEnabled = false;
    }
    /* eslint-disable no-console -- we must use "console" to direct logs to the browser console */ enter(message) {
        if (this.traceEnabled) {
            console.trace(`Entering ${message}`);
            return new Date().getTime();
        }
        return undefined;
    }
    leave(message, baseTimestamp) {
        if (this.traceEnabled) {
            const dt = (0, $klJDc.getElapseMillisecondsMessage)(baseTimestamp);
            console.trace(`Leaving ${message}${dt}`);
        }
    }
    show() {}
    trace(message) {
        if (this.traceEnabled) console.trace(message);
    }
    debug(message) {
        if (this.debugEnabled) console.debug(message);
    }
    info(message) {
        if (this.infoEnabled) console.info(message);
    }
    warn(message) {
        console.warn(message);
    }
    error(message, ...optionalParams) {
        console.error(message, ...optionalParams);
    }
} /* eslint-enable no-console */ 

});
parcelRegister("klJDc", function(module, exports) {

$parcel$export(module.exports, "getElapseMillisecondsMessage", () => $ed092a3efed9a327$export$beb117e18d44e2c);
/*
Copyright 2025-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /**
 * If `baseTimestamp` is provided and not zero, returns a message describing the elapsed milliseconds since this value.
 * Otherwise, returns an empty string.
 * @param baseTimestamp the base timestamp to compute the elapsed milliseconds from
 *
 * @private not part of the public API, can be removed or changed without prior notice
 */ const $ed092a3efed9a327$export$beb117e18d44e2c = (baseTimestamp)=>baseTimestamp ? ` (${new Date().getTime() - baseTimestamp} ms)` : '';

});


parcelRegister("iy79G", function(module, exports) {

$parcel$export(module.exports, "shallowCopy", () => $d810f3d64649efcc$export$9c13236873b118a5);
/*
Copyright 2025-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /**
 * Shallow copies properties from the source object to the target object.
 *
 * **WARNING**: This function performs only a **shallow** copy i.e. there is no deep copy of the properties that are objects, expect for arrays.
 *
 * @template T The type of the objects.
 *
 * @param source The source object from which properties will be copied.
 * @param target The target object to which properties will be copied.
 *
 * @private not part of the public API, can be removed or changed without prior notice
 * @since 0.14.0
 */ const $d810f3d64649efcc$export$9c13236873b118a5 = (source, target)=>{
    for(const key in source)// attempt to prevent prototype pollution
    if (Object.prototype.hasOwnProperty.call(source, key)) {
        const sourceValue = source[key];
        if (Array.isArray(sourceValue)) // TypeScript cannot infer that the key in target will also be an array when source and target are of the same type
        target[key] = [
            ...sourceValue
        ];
        else target[key] = sourceValue;
    }
};

});

parcelRegister("8YQgE", function(module, exports) {

$parcel$export(module.exports, "NoOpI18n", () => $689c78967eeffe01$export$8b7dfd651a90b61a);
/*
Copyright 2025-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /**
 * A {@link I18nProvider} that does nothing.
 *
 * @experimental subject to change or removal. The I18n system may be modified in the future without prior notice.
 * @since 0.17.0
 * @category I18n
 */ class $689c78967eeffe01$export$8b7dfd651a90b61a {
    isEnabled() {
        return false;
    }
    get() {
        return null;
    }
    addResource() {
    // do nothing
    }
}

});






/*
Copyright 2025-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /**
 * Encapsulates the URL, width and height of an image.
 */ class $6af2797f00fe3156$var$ImageBox {
    constructor(src, width, height){
        this.src = src;
        this.width = width;
        this.height = height;
    }
}
var $6af2797f00fe3156$export$2e2bcd8739ae039 = $6af2797f00fe3156$var$ImageBox;


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /**
 * `EventObject` is a wrapper for all properties of a single event.
 *
 * Additionally, it also offers functions to consume the event and check if it was consumed as follows:
 *
 * ```javascript
 * evt.consume();
 * INV: evt.isConsumed() == true
 * ```
 *
 * @category Event
 */ class $9f60d86b38132780$var$EventObject {
    /**
     * Constructs a new event object with the specified name. An optional
     * sequence of key, value pairs can be appended to define properties.
     *
     * Example:
     *
     * ```javascript
     * new EventObject("eventName", key1, val1, .., keyN, valN)
     * ```
     *
     * @param name
     * @param args
     */ constructor(name = '', ...args){
        /**
         * Holds the consumed state. Default is false.
         */ this.consumed = false;
        this.name = name;
        this.properties = {};
        if (!!args[0] && args[0].constructor === Object) // A literal object ({})
        for (const [key, value] of Object.entries(args[0]))this.properties[key] = value;
        else {
            // two-values [key, value, key, value, ...]
            for(let i = 0; i < args.length; i += 2)if (args[i + 1] !== null) this.properties[args[i]] = args[i + 1];
        }
    }
    /**
     * Returns <name>.
     */ getName() {
        return this.name;
    }
    /**
     * Returns <properties>.
     */ getProperties() {
        return this.properties;
    }
    /**
     * Returns the property for the given key.
     */ getProperty(key) {
        return this.properties[key];
    }
    /**
     * Returns true if the event has been consumed.
     */ isConsumed() {
        return this.consumed;
    }
    /**
     * Consumes the event.
     */ consume() {
        this.consumed = true;
    }
}
var $9f60d86b38132780$export$2e2bcd8739ae039 = $9f60d86b38132780$var$EventObject;


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
/**
 * Base class for objects that dispatch named events.
 *
 * To create a subclass that inherits from `EventSource`, the following code is used:
 *
 * ```javascript
 * class MyClass extends EventSource {
 *   // implement the logic here
 * };
 * ```
 *
 * Known Subclasses:
 * - {@link CellOverlay}
 * - {@link Editor}
 * - {@link AbstractGraph}
 * - {@link GraphDataModel}
 * - {@link GraphView}
 * - {@link MaxToolbar}
 * - {@link MaxWindow}
 *
 * @category Event
 */ class $17f25eceeba97548$var$EventSource {
    constructor(eventSource = null){
        /**
         * Holds the event names and associated listeners in an array. The array
         * contains the event name followed by the respective listener for each
         * registered listener.
         */ this.eventListeners = [];
        /**
         * Specifies if events can be fired. Default is true.
         */ this.eventsEnabled = true;
        /**
         * Optional source for events.
         * @default null
         */ this.eventSource = null;
        this.eventSource = eventSource;
    }
    /**
     * Returns {@link eventsEnabled}.
     */ isEventsEnabled() {
        return this.eventsEnabled;
    }
    /**
     * Sets {@link eventsEnabled}.
     */ setEventsEnabled(value) {
        this.eventsEnabled = value;
    }
    /**
     * Returns {@link eventSource}.
     */ getEventSource() {
        return this.eventSource;
    }
    /**
     * Sets {@link eventSource}.
     */ setEventSource(value) {
        this.eventSource = value;
    }
    /**
     * Binds the specified function to the given event name. If no event name
     * is given, then the listener is registered for all events.
     *
     * The parameters of the listener are the sender and an {@link EventObject}.
     */ addListener(name, funct) {
        this.eventListeners.push({
            name: name,
            funct: funct
        });
    }
    /**
     * Removes all occurrences of the given listener from {@link eventListeners}.
     */ removeListener(funct) {
        let i = 0;
        while(i < this.eventListeners.length)if (this.eventListeners[i].funct === funct) this.eventListeners.splice(i, 1);
        else i += 1;
    }
    /**
     * Dispatches the given event to the listeners which are registered for the event.
     * The sender argument is optional.
     * The current execution scope ("this") is used for the listener invocation.
     *
     * Example:
     *
     * ```javascript
     * fireEvent(new EventObject("eventName", key1, val1, .., keyN, valN))
     * ```
     *
     * @param evt {@link EventObject} that represents the event.
     * @param sender Optional sender to be passed to the listener. Default value is the return value of {@link getEventSource}.
     */ fireEvent(evt, sender = null) {
        if (this.isEventsEnabled()) {
            if (!evt) evt = new (0, $9f60d86b38132780$export$2e2bcd8739ae039)('');
            if (!sender) sender = this.getEventSource();
            if (!sender) sender = this;
            for (const eventListener of this.eventListeners)if (eventListener.name === null || eventListener.name === evt.getName()) eventListener.funct.apply(this, [
                sender,
                evt
            ]);
        }
    }
    /**
     * Clears all registered event listeners.
     *
     * Subclasses with a `destroy` method should call `super.destroy()` at the end
     * of their own cleanup to ensure no stale listeners remain.
     */ destroy() {
        this.eventListeners.length = 0;
    }
}
var $17f25eceeba97548$export$2e2bcd8739ae039 = $17f25eceeba97548$var$EventSource;


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2017, JGraph Ltd
Copyright (c) 2006-2017, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
var $cBHcM = parcelRequire("cBHcM");
const $d47e32a58f71e01d$var$isWindowObjectAvailable = ()=>typeof window !== 'undefined';
const $d47e32a58f71e01d$var$isUserAgentAvailable = ()=>!!navigator.userAgent;
const $d47e32a58f71e01d$var$isUserAgentIncludes = (substring)=>navigator.userAgent.includes(substring);
const $d47e32a58f71e01d$var$isAppVersionAvailable = ()=>!!navigator.appVersion;
const $d47e32a58f71e01d$var$isAppVersionIncludes = (substring)=>navigator.appVersion.includes(substring);
/**
 * @category Configuration
 */ class $d47e32a58f71e01d$var$Client {
}
/**
 * Base path for all URLs in the core without trailing slash.
 *
 * When using a relative path, the path is relative to the URL of the page that contains the assignment. Trailing slashes are automatically removed.
 * @default '.'
 */ $d47e32a58f71e01d$var$Client.basePath = '.';
$d47e32a58f71e01d$var$Client.setBasePath = (value)=>{
    if (typeof value !== 'undefined' && value.length > 0) {
        // Adds a trailing slash if required
        if (value.substring(value.length - 1) === '/') value = value.substring(0, value.length - 1);
        $d47e32a58f71e01d$var$Client.basePath = value;
    } else $d47e32a58f71e01d$var$Client.basePath = '.';
};
/**
 * Base path for all images URLs in the core without trailing slash.
 *
 * When using a relative path, the path is relative to the URL of the page that
 * contains the assignment. Trailing slashes are automatically removed.
 * @default '.'
 */ $d47e32a58f71e01d$var$Client.imageBasePath = '.';
$d47e32a58f71e01d$var$Client.setImageBasePath = (value)=>{
    if (typeof value !== 'undefined' && value.length > 0) {
        // Adds a trailing slash if required
        if (value.substring(value.length - 1) === '/') value = value.substring(0, value.length - 1);
        $d47e32a58f71e01d$var$Client.imageBasePath = value;
    } else $d47e32a58f71e01d$var$Client.imageBasePath = `${$d47e32a58f71e01d$var$Client.basePath}/images`;
};
/**
 * `true` if the current browser is Microsoft Edge.
 */ $d47e32a58f71e01d$var$Client.IS_EDGE = $d47e32a58f71e01d$var$isWindowObjectAvailable() && $d47e32a58f71e01d$var$isUserAgentAvailable() && !!navigator.userAgent.match(/Edge\//);
/**
 * `true` if the current browser is Netscape (including Firefox).
 */ $d47e32a58f71e01d$var$Client.IS_NS = $d47e32a58f71e01d$var$isWindowObjectAvailable() && $d47e32a58f71e01d$var$isUserAgentAvailable() && $d47e32a58f71e01d$var$isUserAgentIncludes('Mozilla/') && !$d47e32a58f71e01d$var$isUserAgentIncludes('MSIE') && !$d47e32a58f71e01d$var$isUserAgentIncludes('Edge/');
/**
 * `true` if the current browser is Safari.
 */ $d47e32a58f71e01d$var$Client.IS_SF = $d47e32a58f71e01d$var$isWindowObjectAvailable() && /Apple Computer, Inc/.test(navigator.vendor);
/**
 * Returns `true` if the user agent contains Android.
 */ $d47e32a58f71e01d$var$Client.IS_ANDROID = $d47e32a58f71e01d$var$isWindowObjectAvailable() && $d47e32a58f71e01d$var$isAppVersionAvailable() && $d47e32a58f71e01d$var$isAppVersionIncludes('Android');
/**
 * Returns `true` if the user agent is an iPad, iPhone or iPod.
 */ $d47e32a58f71e01d$var$Client.IS_IOS = $d47e32a58f71e01d$var$isWindowObjectAvailable() && /iP(hone|od|ad)/.test(navigator.platform);
/**
 * `true` if the current browser is Google Chrome.
 */ $d47e32a58f71e01d$var$Client.IS_GC = $d47e32a58f71e01d$var$isWindowObjectAvailable() && /Google Inc/.test(navigator.vendor);
/**
 * `true` if this is running inside a Chrome App.
 */ $d47e32a58f71e01d$var$Client.IS_CHROMEAPP = $d47e32a58f71e01d$var$isWindowObjectAvailable() && // @ts-ignore
window.chrome != null && // @ts-ignore
chrome.app != null && // @ts-ignore
chrome.app.runtime != null;
/**
 * `true` if the current browser is Firefox.
 */ $d47e32a58f71e01d$var$Client.IS_FF = $d47e32a58f71e01d$var$isUserAgentAvailable() && navigator.userAgent.toLowerCase().includes('firefox');
/**
 * `true` if -moz-transform is available as a CSS style. This is the case
 * for all Firefox-based browsers newer than or equal 3, such as Camino,
 * Iceweasel, Seamonkey and Iceape.
 */ $d47e32a58f71e01d$var$Client.IS_MT = $d47e32a58f71e01d$var$isWindowObjectAvailable() && $d47e32a58f71e01d$var$isUserAgentAvailable() && ($d47e32a58f71e01d$var$isUserAgentIncludes('Firefox/') && !$d47e32a58f71e01d$var$isUserAgentIncludes('Firefox/1.') && !$d47e32a58f71e01d$var$isUserAgentIncludes('Firefox/2.') || $d47e32a58f71e01d$var$isUserAgentIncludes('Iceweasel/') && !$d47e32a58f71e01d$var$isUserAgentIncludes('Iceweasel/1.') && !$d47e32a58f71e01d$var$isUserAgentIncludes('Iceweasel/2.') || $d47e32a58f71e01d$var$isUserAgentIncludes('SeaMonkey/') && !$d47e32a58f71e01d$var$isUserAgentIncludes('SeaMonkey/1.') || $d47e32a58f71e01d$var$isUserAgentIncludes('Iceape/') && !$d47e32a58f71e01d$var$isUserAgentIncludes('Iceape/1.'));
/**
 * `true` if the browser supports SVG.
 */ $d47e32a58f71e01d$var$Client.IS_SVG = $d47e32a58f71e01d$var$isWindowObjectAvailable() && navigator.appName?.toUpperCase() !== 'MICROSOFT INTERNET EXPLORER';
/**
 * `true` if foreignObject support is not available. This is the case for
 * Opera, older SVG-based browsers and all versions of IE.
 */ $d47e32a58f71e01d$var$Client.NO_FO = $d47e32a58f71e01d$var$isWindowObjectAvailable() && (!document.createElementNS || document.createElementNS((0, $cBHcM.NS_SVG), 'foreignObject').toString() !== '[object SVGForeignObjectElement]' || $d47e32a58f71e01d$var$isUserAgentIncludes('Opera/'));
/**
 * `true` if the client is a Windows.
 */ $d47e32a58f71e01d$var$Client.IS_WIN = $d47e32a58f71e01d$var$isWindowObjectAvailable() && $d47e32a58f71e01d$var$isAppVersionAvailable() && $d47e32a58f71e01d$var$isAppVersionIncludes('Win');
/**
 * `true` if the client is a Mac.
 */ $d47e32a58f71e01d$var$Client.IS_MAC = $d47e32a58f71e01d$var$isWindowObjectAvailable() && $d47e32a58f71e01d$var$isAppVersionAvailable() && $d47e32a58f71e01d$var$isAppVersionIncludes('Mac');
/**
 * `true` if the client is a Chrome OS.
 */ $d47e32a58f71e01d$var$Client.IS_CHROMEOS = $d47e32a58f71e01d$var$isWindowObjectAvailable() && /\bCrOS\b/.test(navigator.appVersion);
/**
 * `true` if this device supports touchstart/-move/-end events (Apple iOS,
 * Android, Chromebook and Chrome Browser on touch-enabled devices).
 */ $d47e32a58f71e01d$var$Client.IS_TOUCH = $d47e32a58f71e01d$var$isWindowObjectAvailable() && 'ontouchstart' in document.documentElement;
/**
 * `true` if this device supports Microsoft pointer events (always false on Macs).
 */ $d47e32a58f71e01d$var$Client.IS_POINTER = $d47e32a58f71e01d$var$isWindowObjectAvailable() && !!window.PointerEvent && $d47e32a58f71e01d$var$isAppVersionAvailable() && !$d47e32a58f71e01d$var$isAppVersionIncludes('Mac');
/**
 * `true` if the documents location does not start with http:// or https://.
 */ $d47e32a58f71e01d$var$Client.IS_LOCAL = $d47e32a58f71e01d$var$isWindowObjectAvailable() && !document.location.href.includes('http://') && !document.location.href.includes('https://');
var $d47e32a58f71e01d$export$2e2bcd8739ae039 = $d47e32a58f71e01d$var$Client;


const $f192e93a2fd1153c$export$5b0b05d206f62d48 = (evt)=>{
    let t = evt;
    if ((t.type === 'touchstart' || t.type === 'touchmove') && t.touches && t.touches[0]) t = t.touches[0];
    else if (t.type === 'touchend' && t.changedTouches && t.changedTouches[0]) t = t.changedTouches[0];
    return t;
};
const $f192e93a2fd1153c$export$87583e2c100c6a4f = (evt)=>{
    return $f192e93a2fd1153c$export$5b0b05d206f62d48(evt).clientX;
};
const $f192e93a2fd1153c$export$195fc3609401443f = (evt)=>{
    return $f192e93a2fd1153c$export$5b0b05d206f62d48(evt).clientY;
};
const $f192e93a2fd1153c$export$dd2b6e807fb37ba3 = (evt)=>{
    return evt.target;
};
const $f192e93a2fd1153c$export$f6e93dab47d340de = (evt)=>{
    const t = evt;
    return t.isConsumed !== undefined && t.isConsumed;
};
const $f192e93a2fd1153c$export$c4dfce035d43d1e0 = (evt)=>{
    const t = evt;
    return t.pointerType ? t.pointerType === 'touch' || t.pointerType === t.MSPOINTER_TYPE_TOUCH : t.mozInputSource !== undefined ? t.mozInputSource === 5 : t.type.indexOf('touch') === 0;
};
const $f192e93a2fd1153c$export$147fc2f150568226 = (evt)=>{
    const t = evt;
    return t.pointerType ? t.pointerType == 'pen' || t.pointerType === t.MSPOINTER_TYPE_PEN : t.mozInputSource !== undefined ? t.mozInputSource === 2 : t.type.indexOf('pen') === 0;
};
const $f192e93a2fd1153c$export$d06464d6b74eedc4 = (evt)=>{
    const t = evt;
    return t.type && t.type.indexOf('touch') == 0 && t.touches !== undefined && t.touches.length > 1;
};
const $f192e93a2fd1153c$export$764db16956f554f8 = (evt)=>{
    const t = evt;
    return t.pointerType ? t.pointerType == 'mouse' || t.pointerType === t.MSPOINTER_TYPE_MOUSE : t.mozInputSource !== undefined ? t.mozInputSource === 1 : t.type.indexOf('mouse') === 0;
};
const $f192e93a2fd1153c$export$94d43346060bc767 = (evt)=>{
    // Special case for mousemove and mousedown we check the buttons
    // if it exists because which is 0 even if no button is pressed
    if ('buttons' in evt && (evt.type === 'mousedown' || evt.type === 'mousemove')) return evt.buttons === 1;
    if (evt.which !== undefined) return evt.which === 1;
    return evt.button === 1;
};
const $f192e93a2fd1153c$export$150d9643c14ac5c1 = (evt)=>{
    return evt.button === 4;
};
const $f192e93a2fd1153c$export$9cf437433c0a27cf = (evt)=>{
    return evt.button === 2;
};
const $f192e93a2fd1153c$export$e9cb688973f06c96 = (evt)=>{
    return $f192e93a2fd1153c$export$9cf437433c0a27cf(evt) || (0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_MAC && $f192e93a2fd1153c$export$aec581d3997aa3aa(evt) && !$f192e93a2fd1153c$export$1d7fd696f3493e74(evt) && !$f192e93a2fd1153c$export$77ae9bb78030b9bf(evt) && !$f192e93a2fd1153c$export$bdc3218ff6eba0d8(evt);
};
const $f192e93a2fd1153c$export$1d7fd696f3493e74 = (evt)=>{
    return evt.shiftKey;
};
const $f192e93a2fd1153c$export$bdc3218ff6eba0d8 = (evt)=>{
    return evt.altKey;
};
const $f192e93a2fd1153c$export$aec581d3997aa3aa = (evt)=>{
    return evt.ctrlKey;
};
const $f192e93a2fd1153c$export$77ae9bb78030b9bf = (evt)=>{
    return evt.metaKey;
};


/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
var $cBHcM = parcelRequire("cBHcM");

var $h5l15 = parcelRequire("h5l15");
// Known block elements for handling linefeed (list is not complete)
const $b1d29c834e82fef5$var$blocks = new Set([
    'BLOCKQUOTE',
    'DIV',
    'H1',
    'H2',
    'H3',
    'H4',
    'H5',
    'H6',
    'OL',
    'P',
    'PRE',
    'TABLE',
    'UL'
]);
const $b1d29c834e82fef5$export$bd6c631d45dacdd2 = (elems)=>{
    const ret = [];
    function doExtract(elts) {
        // Single break should be ignored
        if (elts.length == 1 && (elts[0].nodeName == 'BR' || elts[0].innerHTML == '\n')) return;
        for(let i = 0; i < elts.length; i += 1){
            const elem = elts[i];
            // DIV with a br or linefeed forces a linefeed
            if (elem.nodeName == 'BR' || elem.innerHTML == '\n' || (elts.length == 1 || i == 0) && elem.nodeName == 'DIV' && elem.innerHTML.toLowerCase() == '<br>') ret.push('\n');
            else {
                if (elem.nodeType === 3 || elem.nodeType === 4) {
                    if (elem.nodeValue && elem.nodeValue.length > 0) ret.push(elem.nodeValue);
                } else if (elem.nodeType !== 8 && elem.childNodes.length > 0) doExtract(Array.from(elem.childNodes));
                if (i < elts.length - 1 && $b1d29c834e82fef5$var$blocks.has(elts[i + 1].nodeName)) ret.push('\n');
            }
        }
    }
    doExtract(elems);
    return ret.join('');
};
const $b1d29c834e82fef5$export$132e79e4118a78e0 = (node)=>{
    return node?.textContent ?? '';
};
const $b1d29c834e82fef5$export$94b0296cab6203e = (node, text)=>{
    if ('innerText' in node) node.innerText = text;
    else node.textContent = text;
};
const $b1d29c834e82fef5$export$682b6adc566f5392 = (node)=>{
    if (node != null) {
        const serializer = new XMLSerializer();
        return serializer.serializeToString(node);
    }
    return '';
};
const $b1d29c834e82fef5$export$d7ffce4a86cc2d66 = (node)=>{
    if (node != null) {
        const serializer = new XMLSerializer();
        return serializer.serializeToString(node);
    }
    return '';
};
const $b1d29c834e82fef5$export$68d8715fc104d294 = (parent, text)=>{
    const doc = parent.ownerDocument;
    const node = doc.createTextNode(text);
    if (parent) parent.appendChild(node);
    return node;
};
const $b1d29c834e82fef5$export$967509e57ed3acf7 = (parent, text)=>{
    const doc = parent.ownerDocument;
    const node = doc.createTextNode(text);
    if (parent) {
        parent.appendChild(node);
        parent.appendChild(document.createElement('br'));
    }
    return node;
};
const $b1d29c834e82fef5$export$479ac0420f53ed26 = (parent, count = 1)=>{
    let br = null;
    for(let i = 0; i < count; i += 1)if (parent != null) {
        br = parent.ownerDocument.createElement('br');
        parent.appendChild(br);
    }
    return br;
};
const $b1d29c834e82fef5$export$bc31b96302c4c50a = (parent, text)=>{
    const p = document.createElement('p');
    $b1d29c834e82fef5$export$68d8715fc104d294(p, text);
    if (parent != null) parent.appendChild(p);
    return p;
};
const $b1d29c834e82fef5$export$8ee0fc9ee280b4ee = (value, nodeName = null, attributeName, attributeValue)=>{
    if (!(0, $h5l15.isNullish)(value) && typeof value.nodeType === 'number' && ((0, $h5l15.isNullish)(nodeName) || value.nodeName.toLowerCase() == nodeName.toLowerCase())) // Intentionally using loose equality to treat null and undefined as equivalent here.
    return (0, $h5l15.isNullish)(attributeName) || value.getAttribute(attributeName) == attributeValue;
    return false;
};
const $b1d29c834e82fef5$export$2aabb72607e628e0 = (ancestor, child)=>{
    let parent = child;
    while(parent != null){
        if (parent === ancestor) return true;
        parent = parent.parentNode;
    }
    return false;
};
const $b1d29c834e82fef5$export$1005530eda016c13 = (node, nodeType = (0, $cBHcM.NODE_TYPE).ELEMENT)=>{
    const children = [];
    let tmp = node.firstChild;
    while(tmp != null){
        if (tmp.nodeType === nodeType) children.push(tmp);
        tmp = tmp.nextSibling;
    }
    return children;
};
const $b1d29c834e82fef5$export$ce5e1f6513119f55 = (doc, node, allChildren)=>{
    return doc.importNode(node, allChildren);
};
const $b1d29c834e82fef5$export$a3d02541b0ebf605 = ()=>{
    // @ts-ignore
    const sel = window.getSelection ? window.getSelection() : document.selection;
    if (sel) {
        if (sel.removeAllRanges) sel.removeAllRanges();
        else if (sel.empty) sel.empty();
    }
};
const $b1d29c834e82fef5$export$ec664d7487540b = (src)=>{
    let imageNode = null;
    imageNode = document.createElement('img');
    imageNode.setAttribute('src', src);
    imageNode.setAttribute('border', '0');
    return imageNode;
};
const $b1d29c834e82fef5$export$51f417a84b384183 = (rel, href, doc = null, id = null)=>{
    doc = doc || document;
    // Workaround for Operation Aborted in IE6 if base tag is used in head
    const link = doc.createElement('link');
    link.setAttribute('rel', rel);
    link.setAttribute('href', href);
    link.setAttribute('charset', 'UTF-8');
    link.setAttribute('type', 'text/css');
    if (id) link.setAttribute('id', id);
    const head = doc.getElementsByTagName('head')[0];
    head.appendChild(link);
};


/**
 * Base class for all mouse events in mxGraph. A listener for this event should
 * implement the following methods:
 *
 * ```javascript
 * graph.addMouseListener({
 *   mouseDown: (sender, evt) => {
 *     GlobalConfig.logger.debug('mouseDown');
 *   },
 *   mouseMove: (sender, evt) => {
 *     GlobalConfig.logger.debug('mouseMove');
 *   },
 *   mouseUp: (sender, evt) => {
 *     GlobalConfig.logger.debug('mouseUp');
 *   }
 * });
 * ```
 *
 * @category Event
 */ class $2051fd5f8fd06bc7$var$InternalMouseEvent {
    /**
     * Constructs a new event object for the given arguments.
     *
     * @param evt Native mouse event.
     * @param state Optional {@link CellState} under the mouse.
     */ constructor(evt, state = null){
        /**
         * Holds the consumed state of this event.
         */ this.consumed = false;
        this.evt = evt;
        this.state = state;
        this.sourceState = state;
        // graphX and graphY are updated right after this constructor is executed,
        // so let them default to 0 and make them not nullable.
        this.graphX = 0;
        this.graphY = 0;
    }
    /**
     * Returns <evt>.
     */ getEvent() {
        return this.evt;
    }
    /**
     * Returns the target DOM element using {@link Event#getSource} for <evt>.
     */ getSource() {
        return (0, $f192e93a2fd1153c$export$dd2b6e807fb37ba3)(this.evt);
    }
    /**
     * Returns true if the given {@link Shape} is the source of <evt>.
     */ isSource(shape) {
        return shape ? (0, $b1d29c834e82fef5$export$2aabb72607e628e0)(shape.node, this.getSource()) : false;
    }
    /**
     * Returns <evt.clientX>.
     */ getX() {
        return (0, $f192e93a2fd1153c$export$87583e2c100c6a4f)(this.getEvent());
    }
    /**
     * Returns <evt.clientY>.
     */ getY() {
        return (0, $f192e93a2fd1153c$export$195fc3609401443f)(this.getEvent());
    }
    /**
     * Returns <graphX>.
     */ getGraphX() {
        return this.graphX;
    }
    /**
     * Returns <graphY>.
     */ getGraphY() {
        return this.graphY;
    }
    /**
     * Returns <state>.
     */ getState() {
        return this.state;
    }
    /**
     * Returns the <Cell> in <state> is not null.
     */ getCell() {
        const state = this.getState();
        return state ? state.cell : null;
    }
    /**
     * Returns true if the event is a popup trigger.
     */ isPopupTrigger() {
        return (0, $f192e93a2fd1153c$export$e9cb688973f06c96)(this.getEvent());
    }
    /**
     * Returns <consumed>.
     */ isConsumed() {
        return this.consumed;
    }
    /**
     * Sets <consumed> to true and invokes preventDefault on the native event
     * if such a method is defined. This is used mainly to avoid the cursor from
     * being changed to a text cursor in Webkit. You can use the preventDefault
     * flag to disable this functionality.
     *
     * @param preventDefault Specifies if the native event should be canceled. Default
     * is true.
     */ consume(preventDefault) {
        preventDefault = preventDefault ? preventDefault : window.TouchEvent && this.evt instanceof TouchEvent || (0, $f192e93a2fd1153c$export$764db16956f554f8)(this.evt);
        if (preventDefault && this.evt.preventDefault) this.evt.preventDefault();
        // Sets local consumed state
        this.consumed = true;
    }
}
var $2051fd5f8fd06bc7$export$2e2bcd8739ae039 = $2051fd5f8fd06bc7$var$InternalMouseEvent;




// Checks if passive event listeners are supported
// see https://github.com/Modernizr/Modernizr/issues/1894
let $7f545ffa3f1c932b$var$supportsPassive = false;
try {
    document.addEventListener('test', ()=>{
        return;
    }, Object.defineProperty && Object.defineProperty({}, 'passive', {
        get: ()=>{
            $7f545ffa3f1c932b$var$supportsPassive = true;
        }
    }));
} catch (e) {
// ignore
}
/**
 * @class InternalEvent
 *
 * Cross-browser DOM event support. For internal event handling,
 * {@link EventSource} and the graph event dispatch loop in {@link AbstractGraph} are used.
 *
 * ### Memory Leaks:
 *
 * Use this class for adding and removing listeners to/from DOM nodes. The
 * {@link removeAllListeners} function is provided to remove all listeners that
 * have been added using {@link addListener}. The function should be invoked when
 * the last reference is removed in the JavaScript code, typically when the
 * referenced DOM node is removed from the DOM.
 *
 * @category Event
 */ class $7f545ffa3f1c932b$var$InternalEvent {
    /**
     * Binds the function to the specified event on the given element.
     */ static addListener(element, eventName, funct) {
        element.addEventListener(eventName, funct, $7f545ffa3f1c932b$var$supportsPassive ? {
            passive: false
        } : false);
        if (!element.mxListenerList) element.mxListenerList = [];
        const entry = {
            name: eventName,
            f: funct
        };
        element.mxListenerList.push(entry);
    }
    /**
     * Removes the specified listener from the given element.
     */ static removeListener(element, eventName, funct) {
        element.removeEventListener(eventName, funct, false);
        if (element.mxListenerList) {
            const listenerCount = element.mxListenerList.length;
            for(let i = 0; i < listenerCount; i += 1){
                const entry = element.mxListenerList[i];
                if (entry.f === funct) {
                    element.mxListenerList.splice(i, 1);
                    break;
                }
            }
        }
    }
    /**
     * Removes all listeners from the given element.
     */ static removeAllListeners(element) {
        const list = element.mxListenerList;
        if (list) while(list.length > 0){
            const entry = list[0];
            $7f545ffa3f1c932b$var$InternalEvent.removeListener(element, entry.name, entry.f);
        }
    }
    /**
     * Adds the given listeners for touch, mouse and/or pointer events. If
     * <Client.IS_POINTER> is true then pointer events will be registered,
     * else the respective mouse events will be registered. If <Client.IS_POINTER>
     * is false and <Client.IS_TOUCH> is true then the respective touch events
     * will be registered as well as the mouse events.
     */ static addGestureListeners(node, startListener = null, moveListener = null, endListener = null) {
        if (startListener) $7f545ffa3f1c932b$var$InternalEvent.addListener(node, (0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_POINTER ? 'pointerdown' : 'mousedown', startListener);
        if (moveListener) $7f545ffa3f1c932b$var$InternalEvent.addListener(node, (0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_POINTER ? 'pointermove' : 'mousemove', moveListener);
        if (endListener) $7f545ffa3f1c932b$var$InternalEvent.addListener(node, (0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_POINTER ? 'pointerup' : 'mouseup', endListener);
        if (!(0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_POINTER && (0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_TOUCH) {
            if (startListener) $7f545ffa3f1c932b$var$InternalEvent.addListener(node, 'touchstart', startListener);
            if (moveListener) $7f545ffa3f1c932b$var$InternalEvent.addListener(node, 'touchmove', moveListener);
            if (endListener) $7f545ffa3f1c932b$var$InternalEvent.addListener(node, 'touchend', endListener);
        }
    }
    /**
     * Removes the given listeners from mousedown, mousemove, mouseup and the
     * respective touch events if <Client.IS_TOUCH> is true.
     */ static removeGestureListeners(node, startListener, moveListener, endListener) {
        if (startListener) $7f545ffa3f1c932b$var$InternalEvent.removeListener(node, (0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_POINTER ? 'pointerdown' : 'mousedown', startListener);
        if (moveListener) $7f545ffa3f1c932b$var$InternalEvent.removeListener(node, (0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_POINTER ? 'pointermove' : 'mousemove', moveListener);
        if (endListener) $7f545ffa3f1c932b$var$InternalEvent.removeListener(node, (0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_POINTER ? 'pointerup' : 'mouseup', endListener);
        if (!(0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_POINTER && (0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_TOUCH) {
            if (startListener) $7f545ffa3f1c932b$var$InternalEvent.removeListener(node, 'touchstart', startListener);
            if (moveListener) $7f545ffa3f1c932b$var$InternalEvent.removeListener(node, 'touchmove', moveListener);
            if (endListener) $7f545ffa3f1c932b$var$InternalEvent.removeListener(node, 'touchend', endListener);
        }
    }
    /**
     * Redirects the mouse events from the given DOM node to the graph dispatch
     * loop using the event and given state as event arguments. State can
     * either be an instance of <CellState> or a function that returns an
     * <CellState>. The down, move, up and dblClick arguments are optional
     * functions that take the trigger event as arguments and replace the
     * default behaviour.
     */ static redirectMouseEvents(node, graph, state = null, down = null, move = null, up = null, dblClick = null) {
        const getState = (evt)=>{
            return typeof state === 'function' ? state(evt) : state;
        };
        $7f545ffa3f1c932b$var$InternalEvent.addGestureListeners(node, (evt)=>{
            if (down) down(evt);
            else if (!(0, $f192e93a2fd1153c$export$f6e93dab47d340de)(evt)) graph.fireMouseEvent($7f545ffa3f1c932b$var$InternalEvent.MOUSE_DOWN, new (0, $2051fd5f8fd06bc7$export$2e2bcd8739ae039)(evt, getState(evt)));
        }, (evt)=>{
            if (move) move(evt);
            else if (!(0, $f192e93a2fd1153c$export$f6e93dab47d340de)(evt)) graph.fireMouseEvent($7f545ffa3f1c932b$var$InternalEvent.MOUSE_MOVE, new (0, $2051fd5f8fd06bc7$export$2e2bcd8739ae039)(evt, getState(evt)));
        }, (evt)=>{
            if (up) up(evt);
            else if (!(0, $f192e93a2fd1153c$export$f6e93dab47d340de)(evt)) graph.fireMouseEvent($7f545ffa3f1c932b$var$InternalEvent.MOUSE_UP, new (0, $2051fd5f8fd06bc7$export$2e2bcd8739ae039)(evt, getState(evt)));
        });
        $7f545ffa3f1c932b$var$InternalEvent.addListener(node, 'dblclick', (evt)=>{
            if (dblClick) dblClick(evt);
            else if (!(0, $f192e93a2fd1153c$export$f6e93dab47d340de)(evt)) {
                const tmp = getState(evt);
                graph.dblClick(evt, tmp?.cell);
            }
        });
    }
    /**
     * Removes the known listeners from the given DOM node and its descendants.
     *
     * @param element DOM node to remove the listeners from.
     */ static release(element) {
        try {
            $7f545ffa3f1c932b$var$InternalEvent.removeAllListeners(element);
            // @ts-ignore
            const children = element.childNodes;
            if (children !== undefined) {
                const childCount = children.length;
                for(let i = 0; i < childCount; i += 1)$7f545ffa3f1c932b$var$InternalEvent.release(children[i]);
            }
        } catch (e) {
        // ignores errors as this is typically called in cleanup code
        }
    }
    /**
     * Installs the given function as a handler for mouse wheel events. The
     * function has two arguments: the mouse event and a boolean that specifies
     * if the wheel was moved up or down.
     *
     * This has been tested with IE 6 and 7, Firefox (all versions), Opera and
     * Safari. It does currently not work on Safari for Mac.
     *
     * ### Example
     *
     * @example
     * ```javascript
     * mxEvent.addMouseWheelListener(function (evt, up)
     * {
     *   GlobalConfig.logger.show();
     *   GlobalConfig.logger.debug('mouseWheel: up='+up);
     * });
     * ```
     *
     * @param funct Handler function that takes the event argument and a boolean up
     * argument for the mousewheel direction.
     * @param target Target for installing the listener in Google Chrome. See
     * https://www.chromestatus.com/features/6662647093133312.
     */ static addMouseWheelListener(funct, target) {
        if (funct != null) {
            const wheelHandler = (evt)=>{
                // To prevent window zoom on trackpad pinch
                if (evt.ctrlKey) evt.preventDefault();
                // Handles the event using the given function
                if (Math.abs(evt.deltaX) > 0.5 || Math.abs(evt.deltaY) > 0.5) funct(evt, evt.deltaY == 0 ? -evt.deltaX > 0 : -evt.deltaY > 0);
            };
            target = target != null ? target : window;
            if ((0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_SF && !(0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_TOUCH) {
                let scale = 1;
                $7f545ffa3f1c932b$var$InternalEvent.addListener(target, 'gesturestart', (evt)=>{
                    $7f545ffa3f1c932b$var$InternalEvent.consume(evt);
                    scale = 1;
                });
                $7f545ffa3f1c932b$var$InternalEvent.addListener(target, 'gesturechange', (evt)=>{
                    $7f545ffa3f1c932b$var$InternalEvent.consume(evt);
                    if (typeof evt.scale === 'number') {
                        const diff = scale - evt.scale;
                        if (Math.abs(diff) > 0.2) {
                            funct(evt, diff < 0, true);
                            scale = evt.scale;
                        }
                    }
                });
                $7f545ffa3f1c932b$var$InternalEvent.addListener(target, 'gestureend', (evt)=>{
                    $7f545ffa3f1c932b$var$InternalEvent.consume(evt);
                });
            } else {
                let evtCache = [];
                let dx0 = 0;
                let dy0 = 0;
                // Adds basic listeners for graph event dispatching
                $7f545ffa3f1c932b$var$InternalEvent.addGestureListeners(target, (evt)=>{
                    if (!(0, $f192e93a2fd1153c$export$764db16956f554f8)(evt) && evt.pointerId != null) evtCache.push(evt);
                }, (evt)=>{
                    if (!(0, $f192e93a2fd1153c$export$764db16956f554f8)(evt) && evtCache.length == 2) {
                        // Find this event in the cache and update its record with this event
                        for(let i = 0; i < evtCache.length; i += 1)if (evt.pointerId == evtCache[i].pointerId) {
                            evtCache[i] = evt;
                            break;
                        }
                        // Calculate the distance between the two pointers
                        const dx = Math.abs(evtCache[0].clientX - evtCache[1].clientX);
                        const dy = Math.abs(evtCache[0].clientY - evtCache[1].clientY);
                        const tx = Math.abs(dx - dx0);
                        const ty = Math.abs(dy - dy0);
                        if (tx > $7f545ffa3f1c932b$var$InternalEvent.PINCH_THRESHOLD || ty > $7f545ffa3f1c932b$var$InternalEvent.PINCH_THRESHOLD) {
                            const cx = evtCache[0].clientX + (evtCache[1].clientX - evtCache[0].clientX) / 2;
                            const cy = evtCache[0].clientY + (evtCache[1].clientY - evtCache[0].clientY) / 2;
                            funct(evtCache[0], tx > ty ? dx > dx0 : dy > dy0, true, cx, cy);
                            // Cache the distance for the next move event
                            dx0 = dx;
                            dy0 = dy;
                        }
                    }
                }, (evt)=>{
                    evtCache = [];
                    dx0 = 0;
                    dy0 = 0;
                });
            }
            $7f545ffa3f1c932b$var$InternalEvent.addListener(target, 'wheel', wheelHandler);
        }
    }
    /**
     * Disables the context menu for the given element.
     */ static disableContextMenu(element) {
        $7f545ffa3f1c932b$var$InternalEvent.addListener(element, 'contextmenu', (evt)=>{
            if (evt.preventDefault) evt.preventDefault();
            return false;
        });
    }
    /**
     * Consumes the given event.
     *
     * @param evt Native event to be consumed.
     * @param {boolean} [preventDefault=true] Optional boolean to prevent the default for the event.
     * Default is true.
     * @param {boolean} [stopPropagation=true] Option boolean to stop event propagation. Default is
     * true.
     */ static consume(evt, preventDefault = true, stopPropagation = true) {
        if (preventDefault) {
            if (evt.preventDefault) {
                if (stopPropagation) evt.stopPropagation();
                evt.preventDefault();
            } else if (stopPropagation) evt.cancelBubble = true;
        }
        // Opera
        // @ts-ignore This is a non-standard property.
        evt.isConsumed = true;
        // Other browsers
        if (!evt.preventDefault) evt.returnValue = false;
    }
}
//
// Special handles in mouse events
//
/**
 * Index for the label handle in an mxMouseEvent. This should be a negative
 * value that does not interfere with any possible handle indices.
 * @default -1
 */ $7f545ffa3f1c932b$var$InternalEvent.LABEL_HANDLE = -1;
/**
 * Index for the rotation handle in an mxMouseEvent. This should be a
 * negative value that does not interfere with any possible handle indices.
 * @default -2
 */ $7f545ffa3f1c932b$var$InternalEvent.ROTATION_HANDLE = -2;
/**
 * Start index for the custom handles in an mxMouseEvent. This should be a
 * negative value and is the start index which is decremented for each
 * custom handle.
 * @default -100
 */ $7f545ffa3f1c932b$var$InternalEvent.CUSTOM_HANDLE = -100;
/**
 * Start index for the virtual handles in an mxMouseEvent. This should be a
 * negative value and is the start index which is decremented for each
 * virtual handle.
 * This assumes that there are no more
 * than VIRTUAL_HANDLE - CUSTOM_HANDLE custom handles.
 *
 * @default -100000
 */ $7f545ffa3f1c932b$var$InternalEvent.VIRTUAL_HANDLE = -100000;
//
// Event names
//
/**
 * Specifies the event name for mouseDown.
 */ $7f545ffa3f1c932b$var$InternalEvent.MOUSE_DOWN = 'mouseDown';
/**
 * Specifies the event name for mouseMove.
 */ $7f545ffa3f1c932b$var$InternalEvent.MOUSE_MOVE = 'mouseMove';
/**
 * Specifies the event name for mouseUp.
 */ $7f545ffa3f1c932b$var$InternalEvent.MOUSE_UP = 'mouseUp';
/**
 * Specifies the event name for activate.
 */ $7f545ffa3f1c932b$var$InternalEvent.ACTIVATE = 'activate';
/**
 * Specifies the event name for resizeStart.
 */ $7f545ffa3f1c932b$var$InternalEvent.RESIZE_START = 'resizeStart';
/**
 * Specifies the event name for resize.
 */ $7f545ffa3f1c932b$var$InternalEvent.RESIZE = 'resize';
/**
 * Specifies the event name for resizeEnd.
 */ $7f545ffa3f1c932b$var$InternalEvent.RESIZE_END = 'resizeEnd';
/**
 * Specifies the event name for moveStart.
 */ $7f545ffa3f1c932b$var$InternalEvent.MOVE_START = 'moveStart';
/**
 * Specifies the event name for move.
 */ $7f545ffa3f1c932b$var$InternalEvent.MOVE = 'move';
/**
 * Specifies the event name for moveEnd.
 */ $7f545ffa3f1c932b$var$InternalEvent.MOVE_END = 'moveEnd';
/**
 * Specifies the event name for panStart.
 */ $7f545ffa3f1c932b$var$InternalEvent.PAN_START = 'panStart';
/**
 * Specifies the event name for pan.
 */ $7f545ffa3f1c932b$var$InternalEvent.PAN = 'pan';
/**
 * Specifies the event name for panEnd.
 */ $7f545ffa3f1c932b$var$InternalEvent.PAN_END = 'panEnd';
/**
 * Specifies the event name for minimize.
 */ $7f545ffa3f1c932b$var$InternalEvent.MINIMIZE = 'minimize';
/**
 * Specifies the event name for normalize.
 */ $7f545ffa3f1c932b$var$InternalEvent.NORMALIZE = 'normalize';
/**
 * Specifies the event name for maximize.
 */ $7f545ffa3f1c932b$var$InternalEvent.MAXIMIZE = 'maximize';
/**
 * Specifies the event name for hide.
 */ $7f545ffa3f1c932b$var$InternalEvent.HIDE = 'hide';
/**
 * Specifies the event name for show.
 */ $7f545ffa3f1c932b$var$InternalEvent.SHOW = 'show';
/**
 * Specifies the event name for close.
 */ $7f545ffa3f1c932b$var$InternalEvent.CLOSE = 'close';
/**
 * Specifies the event name for destroy.
 */ $7f545ffa3f1c932b$var$InternalEvent.DESTROY = 'destroy';
/**
 * Specifies the event name for refresh.
 */ $7f545ffa3f1c932b$var$InternalEvent.REFRESH = 'refresh';
/**
 * Specifies the event name for size.
 */ $7f545ffa3f1c932b$var$InternalEvent.SIZE = 'size';
/**
 * Specifies the event name for select.
 */ $7f545ffa3f1c932b$var$InternalEvent.SELECT = 'select';
/**
 * Specifies the event name for fired.
 */ $7f545ffa3f1c932b$var$InternalEvent.FIRED = 'fired';
/**
 * Specifies the event name for fireMouseEvent.
 */ $7f545ffa3f1c932b$var$InternalEvent.FIRE_MOUSE_EVENT = 'fireMouseEvent';
/**
 * Specifies the event name for gesture.
 */ $7f545ffa3f1c932b$var$InternalEvent.GESTURE = 'gesture';
/**
 * Specifies the event name for tapAndHold.
 */ $7f545ffa3f1c932b$var$InternalEvent.TAP_AND_HOLD = 'tapAndHold';
/**
 * Specifies the event name for get.
 */ $7f545ffa3f1c932b$var$InternalEvent.GET = 'get';
/**
 * Specifies the event name for receive.
 */ $7f545ffa3f1c932b$var$InternalEvent.RECEIVE = 'receive';
/**
 * Specifies the event name for connect.
 */ $7f545ffa3f1c932b$var$InternalEvent.CONNECT = 'connect';
/**
 * Specifies the event name for disconnect.
 */ $7f545ffa3f1c932b$var$InternalEvent.DISCONNECT = 'disconnect';
/**
 * Specifies the event name for suspend.
 */ $7f545ffa3f1c932b$var$InternalEvent.SUSPEND = 'suspend';
/**
 * Specifies the event name for suspend.
 */ $7f545ffa3f1c932b$var$InternalEvent.RESUME = 'resume';
/**
 * Specifies the event name for mark.
 */ $7f545ffa3f1c932b$var$InternalEvent.MARK = 'mark';
/**
 * Specifies the event name for root.
 */ $7f545ffa3f1c932b$var$InternalEvent.ROOT = 'root';
/**
 * Specifies the event name for post.
 */ $7f545ffa3f1c932b$var$InternalEvent.POST = 'post';
/**
 * Specifies the event name for open.
 */ $7f545ffa3f1c932b$var$InternalEvent.OPEN = 'open';
/**
 * Specifies the event name for open.
 */ $7f545ffa3f1c932b$var$InternalEvent.SAVE = 'save';
/**
 * Specifies the event name for beforeAddVertex.
 */ $7f545ffa3f1c932b$var$InternalEvent.BEFORE_ADD_VERTEX = 'beforeAddVertex';
/**
 * Specifies the event name for addVertex.
 */ $7f545ffa3f1c932b$var$InternalEvent.ADD_VERTEX = 'addVertex';
/**
 * Specifies the event name for afterAddVertex.
 */ $7f545ffa3f1c932b$var$InternalEvent.AFTER_ADD_VERTEX = 'afterAddVertex';
/**
 * Specifies the event name for done.
 */ $7f545ffa3f1c932b$var$InternalEvent.DONE = 'done';
/**
 * Specifies the event name for execute.
 */ $7f545ffa3f1c932b$var$InternalEvent.EXECUTE = 'execute';
/**
 * Specifies the event name for executed.
 */ $7f545ffa3f1c932b$var$InternalEvent.EXECUTED = 'executed';
/**
 * Specifies the event name for beginUpdate.
 */ $7f545ffa3f1c932b$var$InternalEvent.BEGIN_UPDATE = 'beginUpdate';
/**
 * Specifies the event name for startEdit.
 */ $7f545ffa3f1c932b$var$InternalEvent.START_EDIT = 'startEdit';
/**
 * Specifies the event name for endUpdate.
 */ $7f545ffa3f1c932b$var$InternalEvent.END_UPDATE = 'endUpdate';
/**
 * Specifies the event name for endEdit.
 */ $7f545ffa3f1c932b$var$InternalEvent.END_EDIT = 'endEdit';
/**
 * Specifies the event name for beforeUndo.
 */ $7f545ffa3f1c932b$var$InternalEvent.BEFORE_UNDO = 'beforeUndo';
/**
 * Specifies the event name for undo.
 */ $7f545ffa3f1c932b$var$InternalEvent.UNDO = 'undo';
/**
 * Specifies the event name for redo.
 */ $7f545ffa3f1c932b$var$InternalEvent.REDO = 'redo';
/**
 * Specifies the event name for change.
 */ $7f545ffa3f1c932b$var$InternalEvent.CHANGE = 'change';
/**
 * Specifies the event name for notify.
 */ $7f545ffa3f1c932b$var$InternalEvent.NOTIFY = 'notify';
/**
 * Specifies the event name for layoutCells.
 */ $7f545ffa3f1c932b$var$InternalEvent.LAYOUT_CELLS = 'layoutCells';
/**
 * Specifies the event name for click.
 */ $7f545ffa3f1c932b$var$InternalEvent.CLICK = 'click';
/**
 * Specifies the event name for scale.
 */ $7f545ffa3f1c932b$var$InternalEvent.SCALE = 'scale';
/**
 * Specifies the event name for translate.
 */ $7f545ffa3f1c932b$var$InternalEvent.TRANSLATE = 'translate';
/**
 * Specifies the event name for scaleAndTranslate.
 */ $7f545ffa3f1c932b$var$InternalEvent.SCALE_AND_TRANSLATE = 'scaleAndTranslate';
/**
 * Specifies the event name for up.
 */ $7f545ffa3f1c932b$var$InternalEvent.UP = 'up';
/**
 * Specifies the event name for down.
 */ $7f545ffa3f1c932b$var$InternalEvent.DOWN = 'down';
/**
 * Specifies the event name for add.
 */ $7f545ffa3f1c932b$var$InternalEvent.ADD = 'add';
/**
 * Specifies the event name for remove.
 */ $7f545ffa3f1c932b$var$InternalEvent.REMOVE = 'remove';
/**
 * Specifies the event name for clear.
 */ $7f545ffa3f1c932b$var$InternalEvent.CLEAR = 'clear';
/**
 * Specifies the event name for addCells.
 */ $7f545ffa3f1c932b$var$InternalEvent.ADD_CELLS = 'addCells';
/**
 * Specifies the event name for cellsAdded.
 */ $7f545ffa3f1c932b$var$InternalEvent.CELLS_ADDED = 'cellsAdded';
/**
 * Specifies the event name for moveCells.
 */ $7f545ffa3f1c932b$var$InternalEvent.MOVE_CELLS = 'moveCells';
/**
 * Specifies the event name for cellsMoved.
 */ $7f545ffa3f1c932b$var$InternalEvent.CELLS_MOVED = 'cellsMoved';
/**
 * Specifies the event name for resizeCells.
 */ $7f545ffa3f1c932b$var$InternalEvent.RESIZE_CELLS = 'resizeCells';
/**
 * Specifies the event name for cellsResized.
 */ $7f545ffa3f1c932b$var$InternalEvent.CELLS_RESIZED = 'cellsResized';
/**
 * Specifies the event name for toggleCells.
 */ $7f545ffa3f1c932b$var$InternalEvent.TOGGLE_CELLS = 'toggleCells';
/**
 * Specifies the event name for cellsToggled.
 */ $7f545ffa3f1c932b$var$InternalEvent.CELLS_TOGGLED = 'cellsToggled';
/**
 * Specifies the event name for orderCells.
 */ $7f545ffa3f1c932b$var$InternalEvent.ORDER_CELLS = 'orderCells';
/**
 * Specifies the event name for cellsOrdered.
 */ $7f545ffa3f1c932b$var$InternalEvent.CELLS_ORDERED = 'cellsOrdered';
/**
 * Specifies the event name for removeCells.
 */ $7f545ffa3f1c932b$var$InternalEvent.REMOVE_CELLS = 'removeCells';
/**
 * Specifies the event name for cellsRemoved.
 */ $7f545ffa3f1c932b$var$InternalEvent.CELLS_REMOVED = 'cellsRemoved';
/**
 * Specifies the event name for groupCells.
 */ $7f545ffa3f1c932b$var$InternalEvent.GROUP_CELLS = 'groupCells';
/**
 * Specifies the event name for ungroupCells.
 */ $7f545ffa3f1c932b$var$InternalEvent.UNGROUP_CELLS = 'ungroupCells';
/**
 * Specifies the event name for removeCellsFromParent.
 */ $7f545ffa3f1c932b$var$InternalEvent.REMOVE_CELLS_FROM_PARENT = 'removeCellsFromParent';
/**
 * Specifies the event name for foldCells.
 */ $7f545ffa3f1c932b$var$InternalEvent.FOLD_CELLS = 'foldCells';
/**
 * Specifies the event name for cellsFolded.
 */ $7f545ffa3f1c932b$var$InternalEvent.CELLS_FOLDED = 'cellsFolded';
/**
 * Specifies the event name for alignCells.
 */ $7f545ffa3f1c932b$var$InternalEvent.ALIGN_CELLS = 'alignCells';
/**
 * Specifies the event name for labelChanged.
 */ $7f545ffa3f1c932b$var$InternalEvent.LABEL_CHANGED = 'labelChanged';
/**
 * Specifies the event name for connectCell.
 */ $7f545ffa3f1c932b$var$InternalEvent.CONNECT_CELL = 'connectCell';
/**
 * Specifies the event name for cellConnected.
 */ $7f545ffa3f1c932b$var$InternalEvent.CELL_CONNECTED = 'cellConnected';
/**
 * Specifies the event name for splitEdge.
 */ $7f545ffa3f1c932b$var$InternalEvent.SPLIT_EDGE = 'splitEdge';
/**
 * Specifies the event name for flipEdge.
 */ $7f545ffa3f1c932b$var$InternalEvent.FLIP_EDGE = 'flipEdge';
/**
 * Specifies the event name for startEditing.
 */ $7f545ffa3f1c932b$var$InternalEvent.START_EDITING = 'startEditing';
/**
 * Specifies the event name for editingStarted.
 */ $7f545ffa3f1c932b$var$InternalEvent.EDITING_STARTED = 'editingStarted';
/**
 * Specifies the event name for editingStopped.
 */ $7f545ffa3f1c932b$var$InternalEvent.EDITING_STOPPED = 'editingStopped';
/**
 * Specifies the event name for addOverlay.
 */ $7f545ffa3f1c932b$var$InternalEvent.ADD_OVERLAY = 'addOverlay';
/**
 * Specifies the event name for removeOverlay.
 */ $7f545ffa3f1c932b$var$InternalEvent.REMOVE_OVERLAY = 'removeOverlay';
/**
 * Specifies the event name for updateCellSize.
 */ $7f545ffa3f1c932b$var$InternalEvent.UPDATE_CELL_SIZE = 'updateCellSize';
/**
 * Specifies the event name for escape.
 */ $7f545ffa3f1c932b$var$InternalEvent.ESCAPE = 'escape';
/**
 * Specifies the event name for doubleClick.
 */ $7f545ffa3f1c932b$var$InternalEvent.DOUBLE_CLICK = 'doubleClick';
/**
 * Specifies the event name for start.
 */ $7f545ffa3f1c932b$var$InternalEvent.START = 'start';
/**
 * Specifies the event name for reset.
 */ $7f545ffa3f1c932b$var$InternalEvent.RESET = 'reset';
/**
 * Threshold for pinch gestures to fire a mouse wheel event.
 * Default value is 10.
 */ $7f545ffa3f1c932b$var$InternalEvent.PINCH_THRESHOLD = 10;
var $7f545ffa3f1c932b$export$2e2bcd8739ae039 = $7f545ffa3f1c932b$var$InternalEvent;


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /**
 * Implements a 2-dimensional vector with double precision coordinates.
 *
 * @category Geometry
 */ class $d32f79fa744af3c6$var$Point {
    /**
     * Constructs a new point for the optional x and y coordinates.
     *
     * @param x - The x-coordinate (default is 0).
     * @param y - The y-coordinate (default is 0).
     */ constructor(x = 0, y = 0){
        /**
         * Holds the x-coordinate of the point. Default is 0.
         */ this._x = 0;
        /**
         * Holds the y-coordinate of the point. Default is 0.
         */ this._y = 0;
        this.x = x;
        this.y = y;
    }
    get x() {
        return this._x;
    }
    set x(x) {
        if (Number.isNaN(x)) throw new Error('Invalid x supplied.');
        this._x = x;
    }
    get y() {
        return this._y;
    }
    set y(y) {
        if (Number.isNaN(y)) throw new Error('Invalid y supplied.');
        this._y = y;
    }
    /**
     * Returns true if the given object equals this point.
     */ equals(p) {
        if (!p) return false;
        return p.x === this.x && p.y === this.y;
    }
    /**
     * Returns a clone of this {@link Point}.
     */ clone() {
        return new $d32f79fa744af3c6$var$Point(this.x, this.y);
    }
}
var $d32f79fa744af3c6$export$2e2bcd8739ae039 = $d32f79fa744af3c6$var$Point;


/**
 * Extends {@link Point} to implement a 2-dimensional rectangle with double precision coordinates.
 *
 * @category Geometry
 */ class $2997c239141ea844$var$Rectangle extends (0, $d32f79fa744af3c6$export$2e2bcd8739ae039) {
    /**
     * Constructs a new rectangle for the optional parameters.
     */ constructor(x = 0, y = 0, width = 0, height = 0){
        super(x, y);
        /**
         * Holds the width of the rectangle.
         * @default 0
         */ this._width = 0;
        /**
         * Holds the height of the rectangle.
         * @default 0
         */ this._height = 0;
        this.width = width;
        this.height = height;
    }
    get width() {
        return this._width;
    }
    set width(width) {
        if (Number.isNaN(width)) throw new Error('Invalid width supplied.');
        this._width = width;
    }
    get height() {
        return this._height;
    }
    set height(height) {
        if (Number.isNaN(height)) throw new Error('Invalid height supplied.');
        this._height = height;
    }
    /**
     * Sets this rectangle to the specified values
     */ setRect(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    /**
     * Returns the x-coordinate of the center point.
     */ getCenterX() {
        return this.x + this.width / 2;
    }
    /**
     * Returns the y-coordinate of the center point.
     */ getCenterY() {
        return this.y + this.height / 2;
    }
    /**
     * Adds the given rectangle to this rectangle.
     */ add(rect) {
        const minX = Math.min(this.x, rect.x);
        const minY = Math.min(this.y, rect.y);
        const maxX = Math.max(this.x + this.width, rect.x + rect.width);
        const maxY = Math.max(this.y + this.height, rect.y + rect.height);
        this.x = minX;
        this.y = minY;
        this.width = maxX - minX;
        this.height = maxY - minY;
    }
    /**
     * Changes this rectangle to where it overlaps with the given rectangle.
     */ intersect(rect) {
        const r1 = this.x + this.width;
        const r2 = rect.x + rect.width;
        const b1 = this.y + this.height;
        const b2 = rect.y + rect.height;
        this.x = Math.max(this.x, rect.x);
        this.y = Math.max(this.y, rect.y);
        this.width = Math.min(r1, r2) - this.x;
        this.height = Math.min(b1, b2) - this.y;
    }
    /**
     * Grows the rectangle by the given amount, that is, this method subtracts
     * the given amount from the x- and y-coordinates and adds twice the amount
     * to the width and height.
     */ grow(amount) {
        this.x -= amount;
        this.y -= amount;
        this.width += 2 * amount;
        this.height += 2 * amount;
    }
    /**
     * Returns the top, left corner as a new {@link Point}.
     */ getPoint() {
        return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(this.x, this.y);
    }
    /**
     * Rotates this rectangle by 90 degree around its center point.
     */ rotate90() {
        const t = (this.width - this.height) / 2;
        this.x += t;
        this.y -= t;
        const tmp = this.width;
        this.width = this.height;
        this.height = tmp;
    }
    /**
     * Returns true if the given object equals this rectangle.
     */ equals(rect) {
        if (!rect) return false;
        return rect.x === this.x && rect.y === this.y && rect.width === this.width && rect.height === this.height;
    }
    clone() {
        return new $2997c239141ea844$var$Rectangle(this.x, this.y, this.width, this.height);
    }
}
/**
 * Returns a new {@link Rectangle} which is a copy of the given rectangle.
 */ $2997c239141ea844$var$Rectangle.fromRectangle = (rect)=>{
    return new $2997c239141ea844$var$Rectangle(rect.x, rect.y, rect.width, rect.height);
};
var $2997c239141ea844$export$2e2bcd8739ae039 = $2997c239141ea844$var$Rectangle;



/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 

var $cBHcM = parcelRequire("cBHcM");

/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /**
 * Implements a mechanism for temporary cell Ids.
 * @class CellPath
 */ class $368e61f06e799719$var$CellPath {
    constructor(){
        throw new Error("Static class can't be instantiated!");
    }
    /**
     * Creates the cell path for the given cell. The cell path is a
     * concatenation of the indices of all ancestors on the (finite) path to
     * the root, eg. "0.0.0.1".
     *
     * @param cell Cell whose path should be returned.
     */ static create(cell) {
        let result = '';
        let parent = cell.getParent();
        while(parent){
            const index = parent.getIndex(cell);
            result = index + $368e61f06e799719$var$CellPath.PATH_SEPARATOR + result;
            cell = parent;
            parent = cell.getParent();
        }
        // Remove trailing separator
        const n = result.length;
        if (n > 1) result = result.substring(0, n - 1);
        return result;
    }
    /**
     * Returns the path for the parent of the cell represented by the given
     * path. Returns null if the given path has no parent.
     *
     * @param path Path whose parent path should be returned.
     */ static getParentPath(path) {
        const index = path.lastIndexOf($368e61f06e799719$var$CellPath.PATH_SEPARATOR);
        if (index >= 0) return path.substring(0, index);
        if (path.length > 0) return '';
        return null;
    }
    /**
     * Returns the cell for the specified cell path using the given root as the
     * root of the path.
     *
     * @param root Root cell of the path to be resolved.
     * @param path String that defines the path.
     */ static resolve(root, path) {
        let parent = root;
        const tokens = path.split($368e61f06e799719$var$CellPath.PATH_SEPARATOR);
        for(let i = 0; i < tokens.length; i += 1)parent = parent.getChildAt(Number.parseInt(tokens[i]));
        return parent;
    }
    /**
     * Compares the given cell paths and returns -1 if p1 is smaller, 0 if
     * p1 is equal and 1 if p1 is greater than p2.
     */ static compare(p1, p2) {
        const min = Math.min(p1.length, p2.length);
        let comp = 0;
        for(let i = 0; i < min; i += 1)if (p1[i] !== p2[i]) {
            if (p1[i].length === 0 || p2[i].length === 0) comp = p1[i] === p2[i] ? 0 : p1[i] > p2[i] ? 1 : -1;
            else {
                const t1 = Number.parseInt(p1[i]);
                const t2 = Number.parseInt(p2[i]);
                comp = t1 === t2 ? 0 : t1 > t2 ? 1 : -1;
            }
            break;
        }
        // Compares path length if both paths are equal to this point
        if (comp === 0) {
            const t1 = p1.length;
            const t2 = p2.length;
            if (t1 !== t2) comp = t1 > t2 ? 1 : -1;
        }
        return comp;
    }
}
/**
 * Defines the separator between the path components. Default is ".".
 */ $368e61f06e799719$var$CellPath.PATH_SEPARATOR = '.';
var $368e61f06e799719$export$2e2bcd8739ae039 = $368e61f06e799719$var$CellPath;




var $h5l15 = parcelRequire("h5l15");

var $4vC7I = parcelRequire("4vC7I");
const $b55d6ca3b42398e2$export$993bd4408c228972 = (element)=>{
    if (element.style) element.style.cursor = '';
    const children = element.children;
    if (children) {
        const childCount = children.length;
        for(let i = 0; i < childCount; i += 1)$b55d6ca3b42398e2$export$993bd4408c228972(children[i]);
    }
};
const $b55d6ca3b42398e2$export$6e10775a92bc4d41 = (element)=>{
    return !element || element.toString() === '[object ShadowRoot]' ? null : window.getComputedStyle(element, '');
};
const $b55d6ca3b42398e2$export$7f55d6cdd504ed6 = (value)=>{
    switch(value){
        case 'thin':
            value = '2';
            break;
        case 'medium':
            value = '4';
            break;
        case 'thick':
            value = '6';
            break;
    }
    let n = Number.parseFloat(value);
    if (Number.isNaN(n)) n = 0;
    return n;
};
const $b55d6ca3b42398e2$export$5cd002036665463c = (style, name, value)=>{
    // Custom properties have no attribute on CSSStyleDeclaration, unlike the standard properties handled below, so
    // assigning one would only create a JavaScript property and no CSS declaration. They are never vendor prefixed.
    if (name.startsWith('--')) {
        style.setProperty(name, value);
        return;
    }
    let prefix = null;
    if ((0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_SF || (0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_GC) prefix = 'Webkit';
    else if ((0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_MT) prefix = 'Moz';
    // Assign the property instead of calling CSSStyleDeclaration.setProperty, which only accepts kebab-case names
    // and therefore silently discards both the camelCase names documented above and the vendor prefixed names
    // computed below. See https://github.com/maxGraph/maxGraph/issues/1046
    const properties = style;
    properties[name] = value;
    if (!(0, $h5l15.isNullish)(prefix) && name.length > 0) {
        name = prefix + name.substring(0, 1).toUpperCase() + name.substring(1);
        properties[name] = value;
    }
};
const $b55d6ca3b42398e2$export$988b38dbf6859d61 = (node)=>{
    const style = $b55d6ca3b42398e2$export$6e10775a92bc4d41(node);
    return !!style && (style.overflow === 'scroll' || style.overflow === 'auto');
};
const $b55d6ca3b42398e2$export$cad4be202afb34d5 = ()=>{
    const b = document.body;
    const d = document.documentElement;
    try {
        return new (0, $2997c239141ea844$export$2e2bcd8739ae039)(0, 0, b.clientWidth ?? d.clientWidth, Math.max(b.clientHeight ?? 0, d.clientHeight));
    } catch (e) {
        return new (0, $2997c239141ea844$export$2e2bcd8739ae039)();
    }
};
const $b55d6ca3b42398e2$export$1e044b7877db048c = (node)=>{
    const ds = $b55d6ca3b42398e2$export$cad4be202afb34d5();
    const left = node.offsetLeft;
    const width = node.offsetWidth;
    const offset = $b55d6ca3b42398e2$export$d801aa93dad401af(node.ownerDocument);
    const sl = offset.x;
    const st = offset.y;
    const right = sl + ds.width;
    if (left + width > right) node.style.left = `${Math.max(sl, right - width)}px`;
    const top = node.offsetTop;
    const height = node.offsetHeight;
    const bottom = st + ds.height;
    if (top + height > bottom) node.style.top = `${Math.max(st, bottom - height)}px`;
};
const $b55d6ca3b42398e2$export$622cea445a1c5b7d = (container, scrollOffset = false)=>{
    let offsetLeft = 0;
    let offsetTop = 0;
    // Ignores document scroll origin for fixed elements
    let fixed = false;
    let node = container;
    const b = document.body;
    const d = document.documentElement;
    while(node != null && node != b && node != d && !fixed){
        const style = $b55d6ca3b42398e2$export$6e10775a92bc4d41(node);
        if (style != null) fixed = fixed || style.position == 'fixed';
        node = node.parentNode;
    }
    if (!scrollOffset && !fixed) {
        const offset = $b55d6ca3b42398e2$export$d801aa93dad401af(container.ownerDocument);
        offsetLeft += offset.x;
        offsetTop += offset.y;
    }
    const r = container.getBoundingClientRect();
    if (r != null) {
        offsetLeft += r.left;
        offsetTop += r.top;
    }
    return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(offsetLeft, offsetTop);
};
const $b55d6ca3b42398e2$export$d801aa93dad401af = (doc)=>{
    // @ts-ignore 'parentWindow' is an unknown property.
    const wnd = doc.defaultView || doc.parentWindow;
    const x = wnd != null && window.pageXOffset !== undefined ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft;
    const y = wnd != null && window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y);
};
const $b55d6ca3b42398e2$export$744922fd1f3b32b = (node = null, includeAncestors = false, includeDocument = true)=>{
    const doc = node != null ? node.ownerDocument : document;
    const b = doc.body;
    const d = doc.documentElement;
    const result = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)();
    let fixed = false;
    while(node != null && node != b && node != d){
        if (!Number.isNaN(node.scrollLeft) && !Number.isNaN(node.scrollTop)) {
            result.x += node.scrollLeft;
            result.y += node.scrollTop;
        }
        const style = $b55d6ca3b42398e2$export$6e10775a92bc4d41(node);
        if (style != null) fixed = fixed || style.position == 'fixed';
        node = includeAncestors ? node.parentNode : null;
    }
    if (!fixed && includeDocument) {
        const origin = $b55d6ca3b42398e2$export$d801aa93dad401af(doc);
        result.x += origin.x;
        result.y += origin.y;
    }
    return result;
};
const $b55d6ca3b42398e2$export$864dc177f7f5bda1 = (container, x, y)=>{
    const origin = $b55d6ca3b42398e2$export$744922fd1f3b32b(container, false);
    const offset = $b55d6ca3b42398e2$export$622cea445a1c5b7d(container);
    offset.x -= origin.x;
    offset.y -= origin.y;
    return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x - offset.x, y - offset.y);
};
const $b55d6ca3b42398e2$export$b2bb58a38ab5c0a2 = (model, cells, key, value)=>{
    if (cells.length > 0) model.batchUpdate(()=>{
        for(let i = 0; i < cells.length; i += 1){
            const cell = cells[i];
            if (cell) {
                // Currently, the style object must be cloned, otherwise model.setStyle does not trigger the change event and the cell state in the view is not updated
                const style = cell.getClonedStyle();
                style[key] = value;
                model.setStyle(cell, style);
            }
        }
    });
};
const $b55d6ca3b42398e2$export$135e2decb04b2f7d = (model, cells, key, flag, value)=>{
    if (cells.length > 0) model.batchUpdate(()=>{
        for(let i = 0; i < cells.length; i += 1){
            const cell = cells[i];
            if (cell) {
                // Currently, the style object must be cloned, otherwise model.setStyle does not trigger the change event and the cell state in the view is not updated
                const style = $b55d6ca3b42398e2$export$f7f507f529419584(cell.getClonedStyle(), key, flag, value);
                model.setStyle(cell, style);
            }
        }
    });
};
const $b55d6ca3b42398e2$export$f7f507f529419584 = (style, key, flag, value)=>{
    const v = style[key];
    if (v === undefined) style[key] = value === undefined || value ? flag : 0;
    else {
        if (value === undefined) style[key] = v ^ flag;
        else if (value) style[key] = v | flag;
        else style[key] = v & ~flag;
    }
    return style;
};
const $b55d6ca3b42398e2$export$2646c6b151d2e8 = (node, value)=>{
    node.style.opacity = String(value / 100);
};
const $b55d6ca3b42398e2$export$dc54ded44a3ca0f2 = (text, fontSize = (0, $4vC7I.StyleDefaultsConfig).fontSize, fontFamily = (0, $4vC7I.StyleDefaultsConfig).fontFamily, textWidth = null, fontStyle = null)=>{
    const div = document.createElement('div');
    // Sets the font size and family
    div.style.fontFamily = fontFamily;
    div.style.fontSize = `${Math.round(fontSize)}px`;
    div.style.lineHeight = `${Math.round(fontSize * (0, $cBHcM.LINE_HEIGHT))}px`;
    // Sets the font style
    if (fontStyle !== null) {
        (0, $h5l15.matchBinaryMask)(fontStyle, (0, $cBHcM.FONT_STYLE_MASK).BOLD) && (div.style.fontWeight = 'bold');
        (0, $h5l15.matchBinaryMask)(fontStyle, (0, $cBHcM.FONT_STYLE_MASK).ITALIC) && (div.style.fontStyle = 'italic');
        const txtDecor = [];
        (0, $h5l15.matchBinaryMask)(fontStyle, (0, $cBHcM.FONT_STYLE_MASK).UNDERLINE) && txtDecor.push('underline');
        (0, $h5l15.matchBinaryMask)(fontStyle, (0, $cBHcM.FONT_STYLE_MASK).STRIKETHROUGH) && txtDecor.push('line-through');
        txtDecor.length > 0 && (div.style.textDecoration = txtDecor.join(' '));
    }
    // Disables block layout and outside wrapping and hides the div
    div.style.position = 'absolute';
    div.style.visibility = 'hidden';
    div.style.display = 'inline-block';
    if (textWidth !== null) {
        div.style.width = `${textWidth}px`;
        div.style.whiteSpace = 'normal';
    } else div.style.whiteSpace = 'nowrap';
    // Adds the text and inserts into DOM for updating of size
    div.innerHTML = text;
    document.body.appendChild(div);
    // Gets the size and removes from DOM
    const size = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(0, 0, div.offsetWidth, div.offsetHeight);
    document.body.removeChild(div);
    return size;
};
const $b55d6ca3b42398e2$export$35c9ae3c728354cd = (cells, ascending = true)=>{
    const lookup = new Map();
    cells.sort((o1, o2)=>{
        let p1 = lookup.get(o1);
        if (p1 == null) {
            p1 = (0, $368e61f06e799719$export$2e2bcd8739ae039).create(o1).split((0, $368e61f06e799719$export$2e2bcd8739ae039).PATH_SEPARATOR);
            lookup.set(o1, p1);
        }
        let p2 = lookup.get(o2);
        if (p2 == null) {
            p2 = (0, $368e61f06e799719$export$2e2bcd8739ae039).create(o2).split((0, $368e61f06e799719$export$2e2bcd8739ae039).PATH_SEPARATOR);
            lookup.set(o2, p2);
        }
        const comp = (0, $368e61f06e799719$export$2e2bcd8739ae039).compare(p1, p2);
        return comp == 0 ? 0 : comp > 0 == ascending ? 1 : -1;
    });
    return cells;
};
const $b55d6ca3b42398e2$export$29d173e672cfdc1f = (align, valign)=>{
    let dx = -0.5;
    let dy = -0.5;
    // Horizontal alignment
    if (align === 'left') dx = 0;
    else if (align === 'right') dx = -1;
    // Vertical alignment
    if (valign === 'top') dy = 0;
    else if (valign === 'bottom') dy = -1;
    return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(dx, dy);
};


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
var $cBHcM = parcelRequire("cBHcM");
/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
var $cBHcM = parcelRequire("cBHcM");

const $6bb3a85a9cf63e97$export$c6a55a9d77585122 = (str, chars = '\\s')=>str != null ? str.replace(new RegExp(`^[${chars}]+`, 'g'), '') : null;
const $6bb3a85a9cf63e97$export$770c7916125832a9 = (str, chars = '\\s')=>str != null ? str.replace(new RegExp(`[${chars}]+$`, 'g'), '') : null;
const $6bb3a85a9cf63e97$export$87c2784dc9fc4ab = (str, chars)=>$6bb3a85a9cf63e97$export$c6a55a9d77585122($6bb3a85a9cf63e97$export$770c7916125832a9(str, chars), chars);
const $6bb3a85a9cf63e97$export$aad197c7121a6651 = (f)=>{
    let str = null;
    if (f != null) {
        if (f.name != null) str = f.name;
        else {
            str = $6bb3a85a9cf63e97$export$87c2784dc9fc4ab(f.toString());
            if (str !== null && /^function\s/.test(str)) {
                str = $6bb3a85a9cf63e97$export$c6a55a9d77585122(str.substring(9));
                if (str !== null) {
                    const idx2 = str.indexOf('(');
                    if (idx2 > 0) str = str.substring(0, idx2);
                }
            }
        }
    }
    return str;
};
const $6bb3a85a9cf63e97$export$c480f75734bc04c9 = (str, pattern)=>{
    // LATER: Check is this can be done with a regular expression
    let postfix = '';
    while(str.length > 0 && str.charAt(str.length - 1) == '\n'){
        str = str.substring(0, str.length - 1);
        postfix += pattern;
    }
    return str + postfix;
};
const $6bb3a85a9cf63e97$export$2903f02042bf33f2 = (node, before)=>{
    let tmp = before ? node.previousSibling : node.nextSibling;
    while(tmp != null && tmp.nodeType === (0, $cBHcM.NODE_TYPE).TEXT){
        const next = before ? tmp.previousSibling : tmp.nextSibling;
        const text = (0, $b1d29c834e82fef5$export$132e79e4118a78e0)(tmp);
        if ($6bb3a85a9cf63e97$export$87c2784dc9fc4ab(text)?.length === 0) tmp.parentNode?.removeChild(tmp);
        tmp = next;
    }
};
const $6bb3a85a9cf63e97$export$324699496a105db8 = (s, newline = true)=>{
    s = String(s || '');
    s = s.replace(/&/g, '&amp;'); // 38 26
    s = s.replace(/"/g, '&quot;'); // 34 22
    s = s.replace(/'/g, '&#39;'); // 39 27
    s = s.replace(/</g, '&lt;'); // 60 3C
    s = s.replace(/>/g, '&gt;'); // 62 3E
    if (newline) s = s.replace(/\n/g, '&#xa;');
    return s;
};
const $6bb3a85a9cf63e97$export$f84e8e69fd4488a5 = (obj)=>{
    let output = '';
    for(const i in obj)try {
        if (obj[i] == null) output += `${i} = [null]\n`;
        else if (typeof obj[i] === 'function') output += `${i} => [Function]\n`;
        else if (typeof obj[i] === 'object') {
            const ctor = $6bb3a85a9cf63e97$export$aad197c7121a6651(obj[i].constructor);
            output += `${i} => [${ctor}]\n`;
        } else output += `${i} = ${obj[i]}\n`;
    } catch (e) {
        output += `${i}=${e.message}`;
    }
    return output;
};


/**
 * Identity for JavaScript objects and functions.
 *
 * This is implemented using a simple incrementing counter which is stored in each object under {@link FIELD_NAME}.
 *
 * The identity for an object does not change during its lifecycle.
 */ class $92bf72f6edcd79a5$var$ObjectIdentity {
    /**
     * Returns the ID for the given object or function.
     */ static get(obj) {
        if (obj) {
            if (obj[0, $cBHcM.IDENTITY_FIELD_NAME] === null || obj[0, $cBHcM.IDENTITY_FIELD_NAME] === undefined) {
                if (typeof obj === 'object') {
                    const ctor = (0, $6bb3a85a9cf63e97$export$aad197c7121a6651)(obj.constructor);
                    obj[0, $cBHcM.IDENTITY_FIELD_NAME] = `${ctor}#${$92bf72f6edcd79a5$var$ObjectIdentity.counter++}`;
                } else if (typeof obj === 'function') obj[0, $cBHcM.IDENTITY_FIELD_NAME] = `Function#${$92bf72f6edcd79a5$var$ObjectIdentity.counter++}`;
            }
            return obj[0, $cBHcM.IDENTITY_FIELD_NAME];
        }
        return null;
    }
    /**
     * Deletes the ID from the given object or function.
     */ static clear(obj) {
        delete obj[0, $cBHcM.IDENTITY_FIELD_NAME];
    }
}
/**
 * Name of the field to be used to store the object ID.
 * @default {@IDENTITY_FIELD_NAME}
 */ $92bf72f6edcd79a5$var$ObjectIdentity.FIELD_NAME = (0, $cBHcM.IDENTITY_FIELD_NAME);
/**
 * Current counter.
 */ $92bf72f6edcd79a5$var$ObjectIdentity.counter = 0;
var $92bf72f6edcd79a5$export$2e2bcd8739ae039 = $92bf72f6edcd79a5$var$ObjectIdentity;


const $a200c5dda16aedca$export$9cd59f9826255e47 = function _clone(obj, transients = null, shallow = false) {
    shallow = shallow != null ? shallow : false;
    let clone = null;
    if (obj != null && typeof obj.constructor === 'function') {
        clone = new obj.constructor();
        for(const i in obj)if (i != (0, $92bf72f6edcd79a5$export$2e2bcd8739ae039).FIELD_NAME && (transients == null || !transients.includes(i))) {
            if (!shallow && typeof obj[i] === 'object') clone[i] = _clone(obj[i]);
            else clone[i] = obj[i];
        }
    }
    return clone;
};





var $h5l15 = parcelRequire("h5l15");
class $0e256159624f4593$export$f6f0c3fe4ec306ea {
    constructor(value = null, geometry = null, style = {}){
        // TODO: Document me!
        // used by invalidate() of GraphView
        this.invalidating = false;
        this.onInit = null;
        // used by addCellOverlay() of mxGraph
        this.overlays = [];
        /**
         * Holds the identifier of the Cell.
         * @default null
         */ this.id = null;
        /**
         * Holds the user object.
         * @default null
         */ this.value = null;
        /**
         * Holds the {@link Geometry}.
         * @default null
         */ this.geometry = null;
        /**
         * Holds the style of the Cell.
         * @default {}
         */ this.style = {};
        /**
         * Specifies whether the cell is a vertex.
         * @default false
         */ this.vertex = false;
        /**
         * Specifies whether the cell is an edge.
         * @default false
         */ this.edge = false;
        /**
         * Specifies whether the cell is connectable.
         * @default true
         */ this.connectable = true;
        /**
         * Specifies whether the cell is visible.
         * @default true
         */ this.visible = true;
        /**
         * Specifies whether the cell is collapsed.
         * @default false
         */ this.collapsed = false;
        /**
         * Reference to the parent cell.
         * @default null
         */ this.parent = null;
        /**
         * Reference to the source terminal.
         * @default null
         */ this.source = null;
        /**
         * Reference to the target terminal.
         * @default null
         */ this.target = null;
        /**
         * Holds the child cells.
         * @default []
         */ this.children = [];
        /**
         * Holds the edges.
         * @default []
         */ this.edges = [];
        /**
         * List of members that should not be cloned inside {@link clone}. This field is
         * passed to {@link utils.clone} and is not made persistent in {@link CellCodec}.
         * This is not a convention for all classes, it is only used in this class
         * to mark transient fields since transient modifiers are not supported by
         * the language.
         */ this.mxTransient = [
            'id',
            'value',
            'parent',
            'source',
            'target',
            'children',
            'edges'
        ];
        this.value = value;
        this.setGeometry(geometry);
        this.setStyle(style);
        if (this.onInit) this.onInit();
    }
    // TODO: Document me!!!
    getChildren() {
        return this.children || [];
    }
    /**
     * Returns the Id of the cell as a string.
     */ getId() {
        return this.id;
    }
    /**
     * Sets the Id of the cell to the given string.
     */ setId(id) {
        this.id = id;
    }
    /**
     * Returns the user object of the cell. The user object is stored in {@link value}.
     */ getValue() {
        return this.value;
    }
    /**
     * Sets the user object of the cell. The user object is stored in {@link value}.
     */ setValue(value) {
        this.value = value;
    }
    /**
     * Changes the user object after an in-place edit
     * and returns the previous value. This implementation
     * replaces the user object with the given value and
     * returns the old user object.
     */ valueChanged(newValue) {
        const previous = this.getValue();
        this.setValue(newValue);
        return previous;
    }
    /**
     * Returns the {@link Geometry} that describes the {@link geometry}.
     */ getGeometry() {
        return this.geometry;
    }
    /**
     * Sets the {@link Geometry} to be used as the {@link geometry}.
     */ setGeometry(geometry) {
        this.geometry = geometry;
    }
    /**
     * Returns a string that describes the {@link style}.
     *
     * **IMPORTANT**: if you want to get the style object to later update it and propagate changes to the view, use {@link getClonedStyle} instead.
     */ getStyle() {
        return this.style;
    }
    /**
     * Use this method to get the style object to later update it and propagate changes to the view.
     *
     * See {@link GraphDataModel.setStyle} for more details.
     */ getClonedStyle() {
        return (0, $a200c5dda16aedca$export$9cd59f9826255e47)(this.getStyle());
    }
    /**
     * Sets the string to be used as the {@link style}.
     */ setStyle(style) {
        this.style = style;
    }
    /**
     * Returns true if the cell is a vertex.
     */ isVertex() {
        return this.vertex;
    }
    /**
     * Specifies if the cell is a vertex. This should only be assigned at
     * construction of the cell and not be changed during its lifecycle.
     *
     * @param vertex Boolean that specifies if the cell is a vertex.
     */ setVertex(vertex) {
        this.vertex = vertex;
    }
    /**
     * Returns true if the cell is an edge.
     */ isEdge() {
        return this.edge;
    }
    /**
     * Specifies if the cell is an edge. This should only be assigned at
     * construction of the cell and not be changed during its lifecycle.
     *
     * @param edge Boolean that specifies if the cell is an edge.
     */ setEdge(edge) {
        this.edge = edge;
    }
    /**
     * Returns true if the cell is connectable.
     */ isConnectable() {
        return this.connectable;
    }
    /**
     * Sets the connectable state.
     *
     * @param connectable Boolean that specifies the new connectable state.
     */ setConnectable(connectable) {
        this.connectable = connectable;
    }
    /**
     * Returns true if the cell is visibile.
     */ isVisible() {
        return this.visible;
    }
    /**
     * Specifies if the cell is visible.
     *
     * @param visible Boolean that specifies the new visible state.
     */ setVisible(visible) {
        this.visible = visible;
    }
    /**
     * Returns true if the cell is collapsed.
     */ isCollapsed() {
        return this.collapsed;
    }
    /**
     * Sets the collapsed state.
     *
     * @param collapsed Boolean that specifies the new collapsed state.
     */ setCollapsed(collapsed) {
        this.collapsed = collapsed;
    }
    /**
     * Returns the cell's parent.
     */ getParent() {
        return this.parent;
    }
    /**
     * Sets the parent cell.
     *
     * @param parent<Cell> that represents the new parent.
     */ setParent(parent) {
        this.parent = parent;
    }
    /**
     * Returns the source or target terminal.
     *
     * @param source Boolean that specifies if the source terminal should be
     * returned.
     */ getTerminal(source = false) {
        return source ? this.source : this.target;
    }
    /**
     * Sets the source or target terminal and returns the new terminal.
     *
     * @param terminal  Cell that represents the new source or target terminal.
     * @param isSource  boolean that specifies if the source or target terminal should be set.
     */ setTerminal(terminal, isSource) {
        if (isSource) this.source = terminal;
        else this.target = terminal;
        return terminal;
    }
    /**
     * Returns the number of child cells.
     */ getChildCount() {
        return this.children.length;
    }
    /**
     * Returns the index of the specified child in the child array.
     *
     * @param child Child whose index should be returned.
     */ getIndex(child) {
        if (child === null) return -1;
        return this.children.indexOf(child);
    }
    /**
     * Returns the child at the specified index.
     *
     * @param index Integer that specifies the child to be returned.
     */ getChildAt(index) {
        return this.children[index];
    }
    /**
     * Inserts the specified child into the child array at the specified index and updates the parent reference of the child.
     * If not index is specified, then the child is appended to the child array.
     * Returns the inserted child.
     *
     * @param child {@link Cell} to be inserted or appended to the child array.
     * @param index Optional integer that specifies the index at which the child should be inserted into the child array.
     */ insert(child, index) {
        if (index === undefined) {
            index = this.getChildCount();
            if (child.getParent() === this) index--;
        }
        child.removeFromParent();
        child.setParent(this);
        this.children.splice(index, 0, child);
        return child;
    }
    /**
     * Removes the child at the specified index from the child array and returns the child that was removed.
     * Will remove the parent reference of the child.
     *
     * @param index Integer that specifies the index of the child to be removed.
     */ remove(index) {
        let child = null;
        if (index >= 0) {
            child = this.getChildAt(index);
            if (child) {
                this.children.splice(index, 1);
                child.setParent(null);
            }
        }
        return child;
    }
    /**
     * Removes the cell from its parent.
     */ removeFromParent() {
        if (this.parent) {
            const index = this.parent.getIndex(this);
            this.parent.remove(index);
        }
    }
    /**
     * Returns the number of edges in the edge array.
     */ getEdgeCount() {
        return this.edges.length;
    }
    /**
     * Returns the index of the specified edge in {@link edges}.
     *
     * @param edge {@link Cell} whose index in {@link edges} should be returned.
     */ getEdgeIndex(edge) {
        return this.edges.indexOf(edge);
    }
    /**
     * Returns the edge at the specified index in {@link edges}.
     *
     * @param index Integer that specifies the index of the edge to be returned.
     */ getEdgeAt(index) {
        return this.edges[index];
    }
    /**
     * Inserts the specified edge into the edge array and returns the edge.
     * Will update the respective terminal reference of the edge.
     *
     * @param edge {@link Cell} to be inserted into the edge array.
     * @param isOutgoing Boolean that specifies if the edge is outgoing.
     */ insertEdge(edge, isOutgoing = false) {
        edge.removeFromTerminal(isOutgoing);
        edge.setTerminal(this, isOutgoing);
        if (this.edges.length === 0 || edge.getTerminal(!isOutgoing) !== this || !this.edges.includes(edge)) this.edges.push(edge);
        return edge;
    }
    /**
     * Removes the specified edge from the edge array and returns the edge.
     * Will remove the respective terminal reference from the edge.
     *
     * @param edge {@link Cell} to be removed from the edge array.
     * @param isOutgoing Boolean that specifies if the edge is outgoing.
     */ removeEdge(edge, isOutgoing = false) {
        if (edge != null) {
            if (edge.getTerminal(!isOutgoing) !== this && this.edges != null) {
                const index = this.getEdgeIndex(edge);
                if (index >= 0) this.edges.splice(index, 1);
            }
            edge.setTerminal(null, isOutgoing);
        }
        return edge;
    }
    /**
     * Removes the edge from its source or target terminal.
     *
     * @param isSource Boolean that specifies if the edge should be removed from its source or target terminal.
     */ removeFromTerminal(isSource) {
        const terminal = this.getTerminal(isSource);
        if (terminal) terminal.removeEdge(this, isSource);
    }
    /**
     * Returns true if the user object is an XML node that contains the given attribute.
     *
     * @param name Name nameName of the attribute.
     */ hasAttribute(name) {
        const userObject = this.getValue();
        return (0, $h5l15.isElement)(userObject) && userObject.hasAttribute ? userObject.hasAttribute(name) : !(0, $h5l15.isNullish)(userObject.getAttribute?.(name));
    }
    /**
     * Returns the specified attribute from the user object if it is an XML node.
     *
     * @param name Name of the attribute whose value should be returned.
     * @param defaultValue Optional default value to use if the attribute has no
     * value.
     */ getAttribute(name, defaultValue) {
        const userObject = this.getValue();
        const val = (0, $h5l15.isElement)(userObject) ? userObject.getAttribute?.(name) : null;
        return val ?? defaultValue;
    }
    /**
     * Sets the specified attribute on the user object if it is an XML node.
     *
     * @param name Name of the attribute whose value should be set.
     * @param value New value of the attribute.
     */ setAttribute(name, value) {
        const userObject = this.getValue();
        if ((0, $h5l15.isElement)(userObject)) userObject.setAttribute?.(name, value);
    }
    /**
     * Returns a clone of the cell.
     *
     * Uses {@link cloneValue} to clone the user object.
     *
     * All fields in {@link mxTransient} are ignored during the cloning.
     */ clone() {
        const c = (0, $a200c5dda16aedca$export$9cd59f9826255e47)(this, this.mxTransient);
        c.setValue(this.cloneValue());
        return c;
    }
    /**
     * Returns a clone of the cell's user object.
     */ cloneValue() {
        let value = this.getValue();
        // The declared `UserObject` type hides that `getValue()` returns `any`: at runtime
        // the user object is most often a string, so truthiness would treat an empty string
        // as an absent value.
        if (!(0, $h5l15.isNullish)(value)) {
            if (typeof value.clone === 'function') value = value.clone();
            else if (!(0, $h5l15.isNullish)(value.nodeType) && value.cloneNode) value = value.cloneNode(true);
        }
        return value;
    }
    /**
     * Returns the nearest common ancestor for the specified cells to `this`.
     *
     * @param {Cell} cell2 that specifies the second cell in the tree.
     */ getNearestCommonAncestor(cell2) {
        // Creates the cell path for the second cell
        let path = (0, $368e61f06e799719$export$2e2bcd8739ae039).create(cell2);
        if (path.length > 0) {
            // Bubbles through the ancestors of the first cell to find the nearest common ancestor.
            // eslint-disable-next-line @typescript-eslint/no-this-alias -- we need to use `this` to refer to the instance to start processing
            let cell = this;
            let current = (0, $368e61f06e799719$export$2e2bcd8739ae039).create(cell);
            // Inverts arguments
            if (path.length < current.length) {
                cell = cell2;
                const tmp = current;
                current = path;
                path = tmp;
            }
            while(cell && current){
                const parent = cell.getParent();
                // Checks if the cell path is equal to the beginning of the given cell path
                if (path.indexOf(current + (0, $368e61f06e799719$export$2e2bcd8739ae039).PATH_SEPARATOR) === 0 && parent) return cell;
                current = (0, $368e61f06e799719$export$2e2bcd8739ae039).getParentPath(current);
                cell = parent;
            }
        }
        return null;
    }
    /**
     * Returns true if the given parent is an ancestor of the given child. Note
     * returns true if child == parent.
     *
     * @param {Cell} child  that specifies the child.
     */ isAncestor(child) {
        while(child && child !== this)child = child.getParent();
        return child === this;
    }
    /**
     * Returns the child vertices of the given parent.
     */ getChildVertices() {
        return this.getChildCells(true, false);
    }
    /**
     * Returns the child edges of the given parent.
     */ getChildEdges() {
        return this.getChildCells(false, true);
    }
    /**
     * Returns the children of the given cell that are vertices and/or edges
     * depending on the arguments.
     *
     * @param vertices  Boolean indicating if child vertices should be returned.
     * Default is false.
     * @param edges  Boolean indicating if child edges should be returned.
     * Default is false.
     */ getChildCells(vertices = false, edges = false) {
        const childCount = this.getChildCount();
        const result = [];
        for(let i = 0; i < childCount; i += 1){
            const child = this.getChildAt(i);
            if (!edges && !vertices || edges && child.isEdge() || vertices && child.isVertex()) result.push(child);
        }
        return result;
    }
    /**
     * Returns the number of incoming or outgoing edges, ignoring the given
     * edge.
     *
     * @param outgoing  Boolean that specifies if the number of outgoing or
     * incoming edges should be returned.
     * @param {Cell} ignoredEdge  that represents an edge to be ignored.
     */ getDirectedEdgeCount(outgoing, ignoredEdge = null) {
        let count = 0;
        const edgeCount = this.getEdgeCount();
        for(let i = 0; i < edgeCount; i += 1){
            const edge = this.getEdgeAt(i);
            if (edge !== ignoredEdge && edge && edge.getTerminal(outgoing) === this) count += 1;
        }
        return count;
    }
    /**
     * Returns all edges of the given cell without loops.
     */ getConnections() {
        return this.getEdges(true, true, false);
    }
    /**
     * Returns the incoming edges of the given cell without loops.
     */ getIncomingEdges() {
        return this.getEdges(true, false, false);
    }
    /**
     * Returns the outgoing edges of the given cell without loops.
     */ getOutgoingEdges() {
        return this.getEdges(false, true, false);
    }
    /**
     * Returns all distinct edges connected to this cell as a new array of
     * {@link Cell}. If at least one of incoming or outgoing is true, then loops
     * are ignored, otherwise if both are false, then all edges connected to
     * the given cell are returned including loops.
     *
     * @param incoming  Optional boolean that specifies if incoming edges should be
     * returned. Default is true.
     * @param outgoing  Optional boolean that specifies if outgoing edges should be
     * returned. Default is true.
     * @param includeLoops  Optional boolean that specifies if loops should be returned.
     * Default is true.
     */ getEdges(incoming = true, outgoing = true, includeLoops = true) {
        const edgeCount = this.getEdgeCount();
        const result = [];
        for(let i = 0; i < edgeCount; i += 1){
            const edge = this.getEdgeAt(i);
            const source = edge.getTerminal(true);
            const target = edge.getTerminal(false);
            if (includeLoops && source === target || source !== target && (incoming && target === this || outgoing && source === this)) result.push(edge);
        }
        return result;
    }
    /**
     * Returns the absolute, accumulated origin for the children inside the
     * given parent as an {@link Point}.
     */ getOrigin() {
        let result = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)();
        const parent = this.getParent();
        if (parent) {
            result = parent.getOrigin();
            if (!this.isEdge()) {
                const geo = this.getGeometry();
                if (geo) {
                    result.x += geo.x;
                    result.y += geo.y;
                }
            }
        }
        return result;
    }
    /**
     * Returns all descendants of the given cell and the cell itself in an array.
     */ getDescendants() {
        return this.filterDescendants(null);
    }
    /**
     * Visits all cells recursively and applies the specified filter function
     * to each cell. If the function returns true then the cell is added
     * to the resulting array. The parent and result paramters are optional.
     * If parent is not specified then the recursion starts at {@link root}.
     *
     * Example:
     * The following example extracts all vertices from a given model:
     * ```javascript
     * var filter(cell)
     * {
     * 	return model.isVertex(cell);
     * }
     * var vertices = model.filterDescendants(filter);
     * ```
     *
     * @param filter  JavaScript function that takes an {@link Cell} as an argument
     * and returns a boolean.
     */ filterDescendants(filter) {
        // Creates a new array for storing the result
        let result = [];
        // Checks if the filter returns true for the cell
        // and adds it to the result array
        if (filter === null || filter(this)) result.push(this);
        // Visits the children of the cell
        const childCount = this.getChildCount();
        for(let i = 0; i < childCount; i += 1){
            const child = this.getChildAt(i);
            result = result.concat(child.filterDescendants(filter));
        }
        return result;
    }
    /**
     * Returns the root of the model or the topmost parent of the given cell.
     */ getRoot() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias -- we need to use `this` to refer to the instance to start processing
        let cell = this;
        let root = cell;
        while(cell){
            root = cell;
            cell = cell.getParent();
        }
        return root;
    }
}
var $0e256159624f4593$export$2e2bcd8739ae039 = $0e256159624f4593$export$f6f0c3fe4ec306ea;



var $cBHcM = parcelRequire("cBHcM");
/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /**
 * Action to add or remove a child in a model.
 *
 * @category Change
 */ class $12157cc2312b9a0d$export$f4a203fb9458ccc9 {
    constructor(model, parent, child, index = 0){
        this.model = model;
        this.parent = parent;
        this.previous = parent;
        this.child = child;
        this.index = index;
        this.previousIndex = index;
    }
    /**
     * Changes the parent of {@link child} using {@link GraphDataModel.parentForCellChanged} and removes or restores the cell's connections.
     */ execute() {
        let tmp = this.child.getParent();
        const tmp2 = tmp ? tmp.getIndex(this.child) : 0;
        if (!this.previous) this.connect(this.child, false);
        tmp = this.model.parentForCellChanged(this.child, this.previous, this.previousIndex);
        if (this.previous) this.connect(this.child, true);
        this.parent = this.previous;
        this.previous = tmp;
        this.index = this.previousIndex;
        this.previousIndex = tmp2;
    }
    /**
     * Connects the source and the target of the given cell.
     *
     * If {@link isConnect} is true, the source and target terminals are referenced  as such in the model. Otherwise, they are removed.
     */ connect(cell, isConnect = true) {
        const source = cell.getTerminal(true);
        const target = cell.getTerminal(false);
        if (source) {
            if (isConnect) this.model.terminalForCellChanged(cell, source, true);
            else this.model.terminalForCellChanged(cell, null, true);
        }
        if (target) {
            if (isConnect) this.model.terminalForCellChanged(cell, target, false);
            else this.model.terminalForCellChanged(cell, null, false);
        }
        cell.setTerminal(source, true);
        cell.setTerminal(target, false);
        const childCount = cell.getChildCount();
        for(let i = 0; i < childCount; i += 1)this.connect(cell.getChildAt(i), isConnect);
    }
}
var $12157cc2312b9a0d$export$2e2bcd8739ae039 = $12157cc2312b9a0d$export$f4a203fb9458ccc9;


/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /**
 * Action to change a cell's geometry in a model.
 *
 * @category Change
 */ class $f343bbd443ab0083$var$GeometryChange {
    constructor(model, cell, geometry){
        this.model = model;
        this.cell = cell;
        this.geometry = geometry;
        this.previous = geometry;
    }
    /**
     * Changes the geometry of {@link cell} to {@link previous} using{@link GraphDataModel.geometryForCellChanged}.
     */ execute() {
        this.geometry = this.previous;
        this.previous = this.model.geometryForCellChanged(this.cell, this.previous);
    }
}
var $f343bbd443ab0083$export$2e2bcd8739ae039 = $f343bbd443ab0083$var$GeometryChange;


/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /**
 * Action to change the root in a model.
 *
 * @category Change
 */ class $eb24dd3dae295813$export$aa1a8146cd4414fa {
    constructor(model, root){
        this.model = model;
        this.root = root;
        this.previous = root;
    }
    /**
     * Carries out a change of the root using {@link GraphDataModel.rootChanged}.
     */ execute() {
        this.root = this.previous;
        this.previous = this.model.rootChanged(this.previous);
    }
}
var $eb24dd3dae295813$export$2e2bcd8739ae039 = $eb24dd3dae295813$export$aa1a8146cd4414fa;


/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /**
 * Action to change a cell's style in a model.
 *
 * @category Change
 */ class $97bd40c34c614402$var$StyleChange {
    constructor(model, cell, style){
        this.model = model;
        this.cell = cell;
        this.style = style;
        this.previous = style;
    }
    /**
     * Changes the style of {@link cell} to {@link previous} using {@link GraphDataModel.styleForCellChanged}.
     */ execute() {
        this.style = this.previous;
        this.previous = this.model.styleForCellChanged(this.cell, this.previous);
    }
}
var $97bd40c34c614402$export$2e2bcd8739ae039 = $97bd40c34c614402$var$StyleChange;


/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /**
 * Action to change a terminal in a model.
 *
 * @category Change
 */ class $530d9ffa074b4f5b$export$b8b16c6338d91a1e {
    constructor(model, cell, terminal, source){
        this.model = model;
        this.cell = cell;
        this.terminal = terminal;
        this.previous = terminal;
        this.source = source;
    }
    /**
     * Changes the terminal of {@link cell} to {@link previous} using {@link GraphDataModel.terminalForCellChanged}.
     */ execute() {
        this.terminal = this.previous;
        this.previous = this.model.terminalForCellChanged(this.cell, this.previous, this.source);
    }
}
var $530d9ffa074b4f5b$export$2e2bcd8739ae039 = $530d9ffa074b4f5b$export$b8b16c6338d91a1e;


/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /**
 * Action to change a user object in a model.
 *
 * @category Change
 */ class $eca1687eb224877d$var$ValueChange {
    constructor(model, cell, value){
        this.model = model;
        this.cell = cell;
        this.value = value;
        this.previous = value;
    }
    /**
     * Changes the value of {@link cell} to {@link previous} using {@link GraphDataModel.valueForCellChanged}.
     */ execute() {
        this.value = this.previous;
        this.previous = this.model.valueForCellChanged(this.cell, this.previous);
    }
}
var $eca1687eb224877d$export$2e2bcd8739ae039 = $eca1687eb224877d$var$ValueChange;



var $dea342649dfec9b9$exports = {};

$parcel$export($dea342649dfec9b9$exports, "ElbowConnector", () => $2d63e7af481dcf3d$export$310010001127f926);
$parcel$export($dea342649dfec9b9$exports, "EntityRelation", () => $fe02744973dbf73b$export$3d8c6cc5031aca5d);
$parcel$export($dea342649dfec9b9$exports, "Loop", () => $75d64e99b04a290d$export$550acbd06a1f5a6a);
$parcel$export($dea342649dfec9b9$exports, "ManhattanConnector", () => $093725d3137e05e8$export$cec5549c6ac6c73);
$parcel$export($dea342649dfec9b9$exports, "OrthConnector", () => $ce86dce9f518bafe$export$f8421c630280c361);
$parcel$export($dea342649dfec9b9$exports, "SegmentConnector", () => $7c381263c777720e$export$4ee6d6acbd0456a7);
$parcel$export($dea342649dfec9b9$exports, "SideToSide", () => $08e98ea50cd5e4fa$export$577d7eb664254b8f);
$parcel$export($dea342649dfec9b9$exports, "TopToBottom", () => $0bd38f1534358cf6$export$f518ac6c438bcd9c);
/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 


var $cBHcM = parcelRequire("cBHcM");
/**
 * Represents the current state of a cell in a given {@link GraphView}.
 *
 * For edges, the edge label position is stored in {@link absoluteOffset}.
 *
 * The size for oversize labels can be retrieved using the `boundingBox` property of the {@link text} field as shown below.
 *
 * ```javascript
 * const bbox = state.text?.boundingBox ?? null;
 * ```
 */ class $a9ad68c2c04d1a53$var$CellState extends (0, $2997c239141ea844$export$2e2bcd8739ae039) {
    /**
     * Constructs a new object that represents the current state of the given Cell in the specified view.
     *
     * @param view {@link GraphView} that contains the state.
     * @param cell {@link Cell} that this state represents.
     * @param style the style of the Cell.
     */ constructor(view = null, cell = null, style = null){
        super();
        // referenced in CellRenderer
        this.node = null;
        // TODO: Document me!!
        this.cellBounds = null;
        this.paintBounds = null;
        this.boundingBox = null;
        // Used by CellRenderer.createControl
        this.control = null;
        // Used by CellRenderer.createCellOverlays
        this.overlays = new Map();
        /**
         * Specifies if the style is invalid.
         * @default false
         */ this.invalidStyle = false;
        /**
         * Specifies if the state is invalid.
         * @default true
         */ this.invalid = true;
        /**
         * Holds an array of {@link Point} that represent the absolute points of an edge.
         */ this.absolutePoints = [];
        /**
         * Caches the visible source terminal state.
         */ this.visibleSourceState = null;
        /**
         * Caches the visible target terminal state.
         */ this.visibleTargetState = null;
        /**
         * Caches the distance between the end points for an edge.
         */ this.terminalDistance = 0;
        /**
         * Caches the length of an edge.
         */ this.length = 0;
        /**
         * Array of numbers that represent the cached length of each segment of the edge.
         */ this.segments = [];
        /**
         * Holds the {@link Shape} that represents the cell graphically.
         */ this.shape = null;
        /**
         * Holds the {@link Text} that represents the label of the cell.
         * This may be `null` if the cell has no label.
         */ this.text = null;
        /**
         * Holds the unscaled width of the state.
         */ this.unscaledWidth = 0;
        /**
         * Holds the unscaled height of the state.
         */ this.unscaledHeight = 0;
        this.parentHighlight = null;
        this.point = null;
        if (view) this.view = view;
        if (cell) this.cell = cell;
        this.style = style ?? {};
        this.origin = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)();
        this.absoluteOffset = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)();
    }
    /**
     * Returns the {@link Rectangle} that should be used as the perimeter of the cell.
     *
     * @param border Optional border to be added around the perimeter bounds.
     * @param bounds Optional {@link Rectangle} to be used as the initial bounds.
     */ getPerimeterBounds(border = 0, bounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(this.x, this.y, this.width, this.height)) {
        if (this.shape?.stencil?.aspect === 'fixed') {
            const aspect = this.shape.stencil.computeAspect(this.shape, bounds.x, bounds.y, bounds.width, bounds.height);
            bounds.x = aspect.x;
            bounds.y = aspect.y;
            bounds.width = this.shape.stencil.w0 * aspect.width;
            bounds.height = this.shape.stencil.h0 * aspect.height;
        }
        if (border !== 0) bounds.grow(border);
        return bounds;
    }
    /**
     * Sets the first or last point in <absolutePoints> depending on isSource.
     *
     * @param point {@link Point} that represents the terminal point.
     * @param isSource Boolean that specifies if the first or last point should be assigned.
     */ setAbsoluteTerminalPoint(point, isSource = false) {
        if (isSource) {
            if (this.absolutePoints.length === 0) this.absolutePoints.push(point);
            else this.absolutePoints[0] = point;
        } else if (this.absolutePoints.length === 0) {
            this.absolutePoints.push(null);
            this.absolutePoints.push(point);
        } else if (this.absolutePoints.length === 1) this.absolutePoints.push(point);
        else this.absolutePoints[this.absolutePoints.length - 1] = point;
    }
    /**
     * Sets the given cursor on the shape and text shape.
     */ setCursor(cursor) {
        if (this.shape) this.shape.setCursor(cursor);
        if (this.text) this.text.setCursor(cursor);
    }
    /**
     * Returns the visible source or target terminal cell.
     *
     * @param source Boolean that specifies if the source or target cell should be returned.
     */ getVisibleTerminal(source = false) {
        return this.getVisibleTerminalState(source)?.cell ?? null;
    }
    /**
     * Returns the visible source or target terminal state.
     *
     * @param source Boolean that specifies if the source or target state should be returned.
     */ getVisibleTerminalState(source = false) {
        return source ? this.visibleSourceState : this.visibleTargetState;
    }
    /**
     * Sets the visible source or target terminal state.
     *
     * @param terminalState {@link CellState} that represents the terminal.
     * @param source Boolean that specifies if the source or target state should be set.
     */ setVisibleTerminalState(terminalState, source = false) {
        if (source) this.visibleSourceState = terminalState;
        else this.visibleTargetState = terminalState;
    }
    /**
     * Returns the unscaled, untranslated bounds.
     */ getCellBounds() {
        return this.cellBounds;
    }
    /**
     * Returns the unscaled, untranslated paint bounds.
     *
     * This is the same as {@link getCellBounds} but with a 90-degrees rotation if the  {@link Shape.isPaintBoundsInverted} returns `true`.
     */ getPaintBounds() {
        return this.paintBounds;
    }
    /**
     * Updates the {@link cellBounds} and {@link paintBounds}.
     */ updateCachedBounds() {
        const view = this.view;
        const tr = view.translate;
        const s = view.scale;
        this.cellBounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(this.x / s - tr.x, this.y / s - tr.y, this.width / s, this.height / s);
        this.paintBounds = (0, $2997c239141ea844$export$2e2bcd8739ae039).fromRectangle(this.cellBounds);
        if (this.shape && this.shape.isPaintBoundsInverted()) this.paintBounds.rotate90();
    }
    /**
     * Copies all fields from the given state to this state.
     */ setState(state) {
        this.view = state.view;
        this.cell = state.cell;
        this.style = state.style;
        this.absolutePoints = state.absolutePoints;
        this.origin = state.origin;
        this.absoluteOffset = state.absoluteOffset;
        this.boundingBox = state.boundingBox;
        this.terminalDistance = state.terminalDistance;
        this.segments = state.segments;
        this.length = state.length;
        this.x = state.x;
        this.y = state.y;
        this.width = state.width;
        this.height = state.height;
        this.unscaledWidth = state.unscaledWidth;
        this.unscaledHeight = state.unscaledHeight;
    }
    clone() {
        const clone = new $a9ad68c2c04d1a53$var$CellState(this.view, this.cell, this.style);
        // Clones the absolute points
        for(let i = 0; i < this.absolutePoints.length; i += 1){
            const p = this.absolutePoints[i];
            clone.absolutePoints[i] = p ? p.clone() : null;
        }
        if (this.origin) clone.origin = this.origin.clone();
        if (this.absoluteOffset) clone.absoluteOffset = this.absoluteOffset.clone();
        if (this.boundingBox) clone.boundingBox = this.boundingBox.clone();
        clone.terminalDistance = this.terminalDistance;
        clone.segments = this.segments;
        clone.length = this.length;
        clone.x = this.x;
        clone.y = this.y;
        clone.width = this.width;
        clone.height = this.height;
        clone.unscaledWidth = this.unscaledWidth;
        clone.unscaledHeight = this.unscaledHeight;
        return clone;
    }
    /**
     * Destroys the state and all associated resources.
     */ destroy() {
        this.view.graph.cellRenderer.destroy(this);
    }
    /**
     * Returns `true` if the given cell state is a loop.
     *
     * @param state {@link CellState} that represents a potential loop.
     */ isLoop(state) {
        const src = this.getVisibleTerminalState(true);
        return src && src === this.getVisibleTerminalState(false);
    }
    /*****************************************************************************
     * Group: Graph appearance
     *****************************************************************************/ /**
     * Returns the vertical alignment for the given cell state.
     * This implementation returns the value stored in the {@link CellStateStyle.verticalAlign}
     * property of {@link style}.
     */ getVerticalAlign() {
        return this.style.verticalAlign ?? 'middle';
    }
    /**
     * Returns `true` if the given state has no stroke, no fill color and no image.
     */ isTransparentState() {
        return (this.style.strokeColor ?? (0, $cBHcM.NONE)) === (0, $cBHcM.NONE) && (this.style.fillColor ?? (0, $cBHcM.NONE)) === (0, $cBHcM.NONE) && !this.getImageSrc();
    }
    /**
     * Returns the image URL for the given cell state.
     * This implementation returns the value stored in the {@link CellStateStyle.image} property
     * of {@link style}.
     */ getImageSrc() {
        return this.style.image || null;
    }
    /**
     * Returns the indicator color for the given cell state.
     * This implementation returns the value stored in the {@link CellStateStyle.indicatorColor}
     * property of {@link style}.
     */ getIndicatorColor() {
        return this.style.indicatorColor || null;
    }
    /**
     * Returns the indicator gradient color for the given cell state.
     * This implementation returns the value stored in the {@link CellStateStyle.gradientColor}
     * property of {@link style}.
     */ getIndicatorGradientColor() {
        return this.style.gradientColor || null;
    }
    /**
     * Returns the indicator shape for the given cell state.
     * This implementation returns the value stored in the {@link CellStateStyle.indicatorShape}
     * property of {@link style}.
     */ getIndicatorShape() {
        return this.style.indicatorShape || null;
    }
    /**
     * Returns the indicator image for the given cell state.
     * This implementation returns the value stored in the {@link CellStateStyle.indicatorImage}
     * property of {@link style}.
     */ getIndicatorImageSrc() {
        return this.style.indicatorImage || null;
    }
}
var $a9ad68c2c04d1a53$export$2e2bcd8739ae039 = $a9ad68c2c04d1a53$var$CellState;



/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
var $cBHcM = parcelRequire("cBHcM");



var $h5l15 = parcelRequire("h5l15");
const $f7ff90b8964488a6$export$cba01ba138429a1d = (deg)=>{
    return Math.PI * deg / 180;
};
const $f7ff90b8964488a6$export$c796d9d3e501591f = (rad)=>{
    return rad * 180 / Math.PI;
};
const $f7ff90b8964488a6$export$a434bae21ada3b6b = (x0, y0, r1, r2, angle, largeArcFlag, sweepFlag, x, y)=>{
    x -= x0;
    y -= y0;
    if (r1 === 0 || r2 === 0) return [];
    const fS = sweepFlag;
    const psai = angle;
    r1 = Math.abs(r1);
    r2 = Math.abs(r2);
    const ctx = -x / 2;
    const cty = -y / 2;
    const cpsi = Math.cos(psai * Math.PI / 180);
    const spsi = Math.sin(psai * Math.PI / 180);
    const rxd = cpsi * ctx + spsi * cty;
    const ryd = -1 * spsi * ctx + cpsi * cty;
    const rxdd = rxd * rxd;
    const rydd = ryd * ryd;
    const r1x = r1 * r1;
    const r2y = r2 * r2;
    const lamda = rxdd / r1x + rydd / r2y;
    let sds;
    if (lamda > 1) {
        r1 = Math.sqrt(lamda) * r1;
        r2 = Math.sqrt(lamda) * r2;
        sds = 0;
    } else {
        let seif = 1;
        if (largeArcFlag === fS) seif = -1;
        sds = seif * Math.sqrt((r1x * r2y - r1x * rydd - r2y * rxdd) / (r1x * rydd + r2y * rxdd));
    }
    const txd = sds * r1 * ryd / r2;
    const tyd = -1 * sds * r2 * rxd / r1;
    const tx = cpsi * txd - spsi * tyd + x / 2;
    const ty = spsi * txd + cpsi * tyd + y / 2;
    let rad = Math.atan2((ryd - tyd) / r2, (rxd - txd) / r1) - Math.atan2(0, 1);
    let s1 = rad >= 0 ? rad : 2 * Math.PI + rad;
    rad = Math.atan2((-ryd - tyd) / r2, (-rxd - txd) / r1) - Math.atan2((ryd - tyd) / r2, (rxd - txd) / r1);
    let dr = rad >= 0 ? rad : 2 * Math.PI + rad;
    if (!fS && dr > 0) dr -= 2 * Math.PI;
    else if (fS && dr < 0) dr += 2 * Math.PI;
    const sse = dr * 2 / Math.PI;
    const seg = Math.ceil(sse < 0 ? -1 * sse : sse);
    const segr = dr / seg;
    const t = 8 / 3 * Math.sin(segr / 4) * Math.sin(segr / 4) / Math.sin(segr / 2);
    const cpsir1 = cpsi * r1;
    const cpsir2 = cpsi * r2;
    const spsir1 = spsi * r1;
    const spsir2 = spsi * r2;
    let mc = Math.cos(s1);
    let ms = Math.sin(s1);
    let x2 = -t * (cpsir1 * ms + spsir2 * mc);
    let y2 = -t * (spsir1 * ms - cpsir2 * mc);
    let x3 = 0;
    let y3 = 0;
    const result = [];
    for(let n = 0; n < seg; ++n){
        s1 += segr;
        mc = Math.cos(s1);
        ms = Math.sin(s1);
        x3 = cpsir1 * mc - spsir2 * ms + tx;
        y3 = spsir1 * mc + cpsir2 * ms + ty;
        const dx = -t * (cpsir1 * ms + spsir2 * mc);
        const dy = -t * (spsir1 * ms - cpsir2 * mc);
        // CurveTo updates x0, y0 so need to restore it
        const index = n * 6;
        result[index] = Number(x2 + x0);
        result[index + 1] = Number(y2 + y0);
        result[index + 2] = Number(x3 - dx + x0);
        result[index + 3] = Number(y3 - dy + y0);
        result[index + 4] = Number(x3 + x0);
        result[index + 5] = Number(y3 + y0);
        x2 = x3 + dx;
        y2 = y3 + dy;
    }
    return result;
};
const $f7ff90b8964488a6$export$895c5e634403eaa7 = (rect, rotation, cx = null)=>{
    let result = null;
    if (rect && rotation !== 0) {
        const rad = $f7ff90b8964488a6$export$cba01ba138429a1d(rotation);
        const cos = Math.cos(rad);
        const sin = Math.sin(rad);
        cx = cx != null ? cx : new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(rect.x + rect.width / 2, rect.y + rect.height / 2);
        let p1 = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(rect.x, rect.y);
        let p2 = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(rect.x + rect.width, rect.y);
        let p3 = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(p2.x, rect.y + rect.height);
        let p4 = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(rect.x, p3.y);
        p1 = $f7ff90b8964488a6$export$ad2a0af3fbffd7c1(p1, cos, sin, cx);
        p2 = $f7ff90b8964488a6$export$ad2a0af3fbffd7c1(p2, cos, sin, cx);
        p3 = $f7ff90b8964488a6$export$ad2a0af3fbffd7c1(p3, cos, sin, cx);
        p4 = $f7ff90b8964488a6$export$ad2a0af3fbffd7c1(p4, cos, sin, cx);
        result = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(p1.x, p1.y, 0, 0);
        result.add(new (0, $2997c239141ea844$export$2e2bcd8739ae039)(p2.x, p2.y, 0, 0));
        result.add(new (0, $2997c239141ea844$export$2e2bcd8739ae039)(p3.x, p3.y, 0, 0));
        result.add(new (0, $2997c239141ea844$export$2e2bcd8739ae039)(p4.x, p4.y, 0, 0));
    }
    return result;
};
const $f7ff90b8964488a6$export$ad2a0af3fbffd7c1 = (pt, cos, sin, c = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)())=>{
    const x = pt.x - c.x;
    const y = pt.y - c.y;
    const x1 = x * cos - y * sin;
    const y1 = y * cos + x * sin;
    return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x1 + c.x, y1 + c.y);
};
const $f7ff90b8964488a6$export$eebe7cc623dc82c0 = (terminal, edge, source, defaultValue)=>{
    const value = terminal.style.portConstraint ?? (source ? edge.style.sourcePortConstraint : edge.style.targetPortConstraint);
    if ((0, $h5l15.isNullish)(value)) return defaultValue;
    // The implementation here is derived from the mxGraph implementation
    // In mxGraph, the configuration of several directions was done by concatenating them in a string without separator like in "portConstraint=northsouth"
    // See https://github.com/jgraph/mxgraph/blob/v4.2.2/javascript/examples/orthogonal.html#L101-L102
    // Other examples exist in draw.io: https://github.com/jgraph/drawio/blob/acd938b1/src/main/webapp/js/diagramly/Dialogs.js#L2302-L2305
    // The implementation here still supports the string concatenation of several directions to allow import of mxGraph XML models without additional transformations.
    const directions = value.toString();
    let returnValue = (0, $cBHcM.DIRECTION_MASK).NONE;
    const constraintRotationEnabled = terminal.style.portConstraintRotation ?? false;
    const rotation = constraintRotationEnabled ? terminal.style.rotation ?? 0 : 0;
    let quad = 0;
    if (rotation > 45) {
        quad = 1;
        if (rotation >= 135) quad = 2;
    } else if (rotation < -45) {
        quad = 3;
        if (rotation <= -135) quad = 2;
    }
    if (directions.includes('north')) switch(quad){
        case 0:
            returnValue |= (0, $cBHcM.DIRECTION_MASK).NORTH;
            break;
        case 1:
            returnValue |= (0, $cBHcM.DIRECTION_MASK).EAST;
            break;
        case 2:
            returnValue |= (0, $cBHcM.DIRECTION_MASK).SOUTH;
            break;
        case 3:
            returnValue |= (0, $cBHcM.DIRECTION_MASK).WEST;
            break;
    }
    if (directions.includes('west')) switch(quad){
        case 0:
            returnValue |= (0, $cBHcM.DIRECTION_MASK).WEST;
            break;
        case 1:
            returnValue |= (0, $cBHcM.DIRECTION_MASK).NORTH;
            break;
        case 2:
            returnValue |= (0, $cBHcM.DIRECTION_MASK).EAST;
            break;
        case 3:
            returnValue |= (0, $cBHcM.DIRECTION_MASK).SOUTH;
            break;
    }
    if (directions.includes('south')) switch(quad){
        case 0:
            returnValue |= (0, $cBHcM.DIRECTION_MASK).SOUTH;
            break;
        case 1:
            returnValue |= (0, $cBHcM.DIRECTION_MASK).WEST;
            break;
        case 2:
            returnValue |= (0, $cBHcM.DIRECTION_MASK).NORTH;
            break;
        case 3:
            returnValue |= (0, $cBHcM.DIRECTION_MASK).EAST;
            break;
    }
    if (directions.includes('east')) switch(quad){
        case 0:
            returnValue |= (0, $cBHcM.DIRECTION_MASK).EAST;
            break;
        case 1:
            returnValue |= (0, $cBHcM.DIRECTION_MASK).SOUTH;
            break;
        case 2:
            returnValue |= (0, $cBHcM.DIRECTION_MASK).WEST;
            break;
        case 3:
            returnValue |= (0, $cBHcM.DIRECTION_MASK).NORTH;
            break;
    }
    return returnValue;
};
const $f7ff90b8964488a6$export$747c07263c520aa0 = (constraint)=>{
    let result = 0;
    result = (constraint & (0, $cBHcM.DIRECTION_MASK).WEST) << 3;
    result |= (constraint & (0, $cBHcM.DIRECTION_MASK).NORTH) << 1;
    result |= (constraint & (0, $cBHcM.DIRECTION_MASK).SOUTH) >> 1;
    result |= (constraint & (0, $cBHcM.DIRECTION_MASK).EAST) >> 3;
    return result;
};
const $f7ff90b8964488a6$export$d6d91d741b272ab = (state, x, y)=>{
    let index = -1;
    if (state.absolutePoints.length > 0) {
        let last = state.absolutePoints[0];
        let min = null;
        for(let i = 1; i < state.absolutePoints.length; i += 1){
            const current = state.absolutePoints[i];
            if (!last || !current) continue;
            const dist = $f7ff90b8964488a6$export$545acef63fa0c8(last.x, last.y, current.x, current.y, x, y);
            if (min == null || dist < min) {
                min = dist;
                index = i - 1;
            }
            last = current;
        }
    }
    return index;
};
const $f7ff90b8964488a6$export$3b8a4d2abb6b1293 = (rect, m, style, flipH, flipV)=>{
    const d = style?.direction ?? 'east';
    flipH ?? (flipH = style?.flipH ?? false);
    flipV ?? (flipV = style?.flipV ?? false);
    m.x = Math.round(Math.max(0, Math.min(rect.width, m.x)));
    m.y = Math.round(Math.max(0, Math.min(rect.height, m.y)));
    m.width = Math.round(Math.max(0, Math.min(rect.width, m.width)));
    m.height = Math.round(Math.max(0, Math.min(rect.height, m.height)));
    if (flipV && (d === 'south' || d === 'north') || flipH && (d === 'east' || d === 'west')) {
        const tmp = m.x;
        m.x = m.width;
        m.width = tmp;
    }
    if (flipH && (d === 'south' || d === 'north') || flipV && (d === 'east' || d === 'west')) {
        const tmp = m.y;
        m.y = m.height;
        m.height = tmp;
    }
    const m2 = (0, $2997c239141ea844$export$2e2bcd8739ae039).fromRectangle(m);
    switch(d){
        case 'south':
            m2.y = m.x;
            m2.x = m.height;
            m2.width = m.y;
            m2.height = m.width;
            break;
        case 'west':
            m2.y = m.height;
            m2.x = m.width;
            m2.width = m.x;
            m2.height = m.y;
            break;
        case 'north':
            m2.y = m.width;
            m2.x = m.y;
            m2.width = m.height;
            m2.height = m.x;
            break;
    }
    return new (0, $2997c239141ea844$export$2e2bcd8739ae039)(rect.x + m2.x, rect.y + m2.y, rect.width - m2.width - m2.x, rect.height - m2.height - m2.y);
};
const $f7ff90b8964488a6$export$e4ad389975a6050 = (pts, center, point)=>{
    let min = null;
    for(let i = 0; i < pts.length - 1; i += 1){
        const pt = $f7ff90b8964488a6$export$bc86dfbf7795668c(pts[i].x, pts[i].y, pts[i + 1].x, pts[i + 1].y, center.x, center.y, point.x, point.y);
        if (pt != null) {
            const dx = point.x - pt.x;
            const dy = point.y - pt.y;
            const ip = {
                p: pt,
                distSq: dy * dy + dx * dx
            };
            if (ip != null && (min == null || min.distSq > ip.distSq)) min = ip;
        }
    }
    return min != null ? min.p : null;
};
const $f7ff90b8964488a6$export$3e44036c04de1245 = (bounds, p1, p2)=>{
    const top = bounds.y;
    const left = bounds.x;
    const bottom = top + bounds.height;
    const right = left + bounds.width;
    // Find min and max X for the segment
    let minX = p1.x;
    let maxX = p2.x;
    if (p1.x > p2.x) {
        minX = p2.x;
        maxX = p1.x;
    }
    // Find the intersection of the segment's and rectangle's x-projections
    if (maxX > right) maxX = right;
    if (minX < left) minX = left;
    if (minX > maxX) // If their projections do not intersect return false
    return false;
    // Find corresponding min and max Y for min and max X we found before
    let minY = p1.y;
    let maxY = p2.y;
    const dx = p2.x - p1.x;
    if (Math.abs(dx) > 0.0000001) {
        const a = (p2.y - p1.y) / dx;
        const b = p1.y - a * p1.x;
        minY = a * minX + b;
        maxY = a * maxX + b;
    }
    if (minY > maxY) {
        const tmp = maxY;
        maxY = minY;
        minY = tmp;
    }
    // Find the intersection of the segment's and rectangle's y-projections
    if (maxY > bottom) maxY = bottom;
    if (minY < top) minY = top;
    if (minY > maxY) // If Y-projections do not intersect return false
    return false;
    return true;
};
const $f7ff90b8964488a6$export$2344b14b097df817 = (bounds, x, y)=>{
    return bounds.x <= x && bounds.x + bounds.width >= x && bounds.y <= y && bounds.y + bounds.height >= y;
};
const $f7ff90b8964488a6$export$7b0a31e10bbff018 = (a, b)=>{
    let tw = a.width;
    let th = a.height;
    let rw = b.width;
    let rh = b.height;
    if (rw <= 0 || rh <= 0 || tw <= 0 || th <= 0) return false;
    const tx = a.x;
    const ty = a.y;
    const rx = b.x;
    const ry = b.y;
    rw += rx;
    rh += ry;
    tw += tx;
    th += ty;
    return (rw < rx || rw > tx) && (rh < ry || rh > ty) && (tw < tx || tw > rx) && (th < ty || th > ry);
};
const $f7ff90b8964488a6$export$72155a378789e697 = (state, x, y, hotspot, min, max)=>{
    hotspot = hotspot != null ? hotspot : 1;
    min = min != null ? min : 0;
    max = max != null ? max : 0;
    if (hotspot > 0) {
        let cx = state.getCenterX();
        let cy = state.getCenterY();
        let w = state.width;
        let h = state.height;
        const style = state.style;
        const start = (style?.startSize ?? 0) * state.view.scale;
        if (start > 0) {
            if (style?.horizontal ?? true) {
                cy = state.y + start / 2;
                h = start;
            } else {
                cx = state.x + start / 2;
                w = start;
            }
        }
        w = Math.max(min, w * hotspot);
        h = Math.max(min, h * hotspot);
        if (max > 0) {
            w = Math.min(w, max);
            h = Math.min(h, max);
        }
        const rect = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(cx - w / 2, cy - h / 2, w, h);
        const alpha = $f7ff90b8964488a6$export$cba01ba138429a1d(style?.rotation ?? 0);
        if (alpha != 0) {
            const cos = Math.cos(-alpha);
            const sin = Math.sin(-alpha);
            const cx = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(state.getCenterX(), state.getCenterY());
            const pt = $f7ff90b8964488a6$export$ad2a0af3fbffd7c1(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y), cos, sin, cx);
            x = pt.x;
            y = pt.y;
        }
        return $f7ff90b8964488a6$export$2344b14b097df817(rect, x, y);
    }
    return true;
};
const $f7ff90b8964488a6$export$e90fb89750dba83f = (n)=>{
    return !Number.isNaN(Number.parseFloat(n)) && Number.isFinite(+n) && (typeof n !== 'string' || !n.toLowerCase().includes('0x'));
};
const $f7ff90b8964488a6$export$a287f47fed4544b8 = (n)=>{
    return String(Number.parseInt(n)) === String(n);
};
const $f7ff90b8964488a6$export$842a2cf37af977e1 = (n, m)=>{
    return (n % m + m) % m;
};
const $f7ff90b8964488a6$export$bc86dfbf7795668c = (x0, y0, x1, y1, x2, y2, x3, y3)=>{
    const denom = (y3 - y2) * (x1 - x0) - (x3 - x2) * (y1 - y0);
    const nume_a = (x3 - x2) * (y0 - y2) - (y3 - y2) * (x0 - x2);
    const nume_b = (x1 - x0) * (y0 - y2) - (y1 - y0) * (x0 - x2);
    const ua = nume_a / denom;
    const ub = nume_b / denom;
    if (ua >= 0.0 && ua <= 1.0 && ub >= 0.0 && ub <= 1.0) {
        // Get the intersection point
        const x = x0 + ua * (x1 - x0);
        const y = y0 + ua * (y1 - y0);
        return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y);
    }
    // No intersection
    return null;
};
const $f7ff90b8964488a6$export$545acef63fa0c8 = (x1, y1, x2, y2, px, py)=>{
    x2 -= x1;
    y2 -= y1;
    px -= x1;
    py -= y1;
    let dotprod = px * x2 + py * y2;
    let projlenSq;
    if (dotprod <= 0.0) projlenSq = 0.0;
    else {
        px = x2 - px;
        py = y2 - py;
        dotprod = px * x2 + py * y2;
        if (dotprod <= 0.0) projlenSq = 0.0;
        else projlenSq = dotprod * dotprod / (x2 * x2 + y2 * y2);
    }
    let lenSq = px * px + py * py - projlenSq;
    if (lenSq < 0) lenSq = 0;
    return lenSq;
};
const $f7ff90b8964488a6$export$5e553cbbd8092f06 = (x1, y1, x2, y2, px, py)=>{
    return Math.abs((y2 - y1) * px - (x2 - x1) * py + x2 * y1 - y2 * x1) / Math.sqrt((y2 - y1) * (y2 - y1) + (x2 - x1) * (x2 - x1));
};
const $f7ff90b8964488a6$export$353ccb813a4d7574 = (x1, y1, x2, y2, px, py)=>{
    x2 -= x1;
    y2 -= y1;
    px -= x1;
    py -= y1;
    let ccw = px * y2 - py * x2;
    if (ccw == 0.0) {
        ccw = px * x2 + py * y2;
        if (ccw > 0.0) {
            px -= x2;
            py -= y2;
            ccw = px * x2 + py * y2;
            if (ccw < 0.0) ccw = 0.0;
        }
    }
    return ccw < 0.0 ? -1 : ccw > 0.0 ? 1 : 0;
};


const $08e98ea50cd5e4fa$export$577d7eb664254b8f = (state, source, target, points, result)=>{
    const { view: view } = state;
    let pt = points != null && points.length > 0 ? points[0] : null;
    const pts = state.absolutePoints;
    const p0 = pts[0];
    const pe = pts[pts.length - 1];
    if (pt != null) pt = view.transformControlPoint(state, pt);
    if (p0 != null) {
        source = new (0, $a9ad68c2c04d1a53$export$2e2bcd8739ae039)();
        source.x = p0.x;
        source.y = p0.y;
    }
    if (pe != null) {
        target = new (0, $a9ad68c2c04d1a53$export$2e2bcd8739ae039)();
        target.x = pe.x;
        target.y = pe.y;
    }
    if (source != null && target != null) {
        const l = Math.max(source.x, target.x);
        const r = Math.min(source.x + source.width, target.x + target.width);
        const x = pt != null ? pt.x : Math.round(r + (l - r) / 2);
        let y1 = view.getRoutingCenterY(source);
        let y2 = view.getRoutingCenterY(target);
        if (pt != null) {
            if (pt.y >= source.y && pt.y <= source.y + source.height) y1 = pt.y;
            if (pt.y >= target.y && pt.y <= target.y + target.height) y2 = pt.y;
        }
        if (!(0, $f7ff90b8964488a6$export$2344b14b097df817)(target, x, y1) && !(0, $f7ff90b8964488a6$export$2344b14b097df817)(source, x, y1)) result.push(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y1));
        if (!(0, $f7ff90b8964488a6$export$2344b14b097df817)(target, x, y2) && !(0, $f7ff90b8964488a6$export$2344b14b097df817)(source, x, y2)) result.push(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y2));
        if (result.length === 1) {
            if (pt != null) {
                if (!(0, $f7ff90b8964488a6$export$2344b14b097df817)(target, x, pt.y) && !(0, $f7ff90b8964488a6$export$2344b14b097df817)(source, x, pt.y)) result.push(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, pt.y));
            } else {
                const t = Math.max(source.y, target.y);
                const b = Math.min(source.y + source.height, target.y + target.height);
                result.push(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, t + (b - t) / 2));
            }
        }
    }
};


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 


const $0bd38f1534358cf6$export$f518ac6c438bcd9c = (state, source, target, points, result)=>{
    const { view: view } = state;
    let pt = points != null && points.length > 0 ? points[0] : null;
    const pts = state.absolutePoints;
    const p0 = pts[0];
    const pe = pts[pts.length - 1];
    if (pt != null) pt = view.transformControlPoint(state, pt);
    if (p0 != null) {
        source = new (0, $a9ad68c2c04d1a53$export$2e2bcd8739ae039)();
        source.x = p0.x;
        source.y = p0.y;
    }
    if (pe != null) {
        target = new (0, $a9ad68c2c04d1a53$export$2e2bcd8739ae039)();
        target.x = pe.x;
        target.y = pe.y;
    }
    if (source != null && target != null) {
        const t = Math.max(source.y, target.y);
        const b = Math.min(source.y + source.height, target.y + target.height);
        let x = view.getRoutingCenterX(source);
        if (pt != null && pt.x >= source.x && pt.x <= source.x + source.width) x = pt.x;
        const y = pt != null ? pt.y : Math.round(b + (t - b) / 2);
        if (!(0, $f7ff90b8964488a6$export$2344b14b097df817)(target, x, y) && !(0, $f7ff90b8964488a6$export$2344b14b097df817)(source, x, y)) result.push(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y));
        if (pt != null && pt.x >= target.x && pt.x <= target.x + target.width) x = pt.x;
        else x = view.getRoutingCenterX(target);
        if (!(0, $f7ff90b8964488a6$export$2344b14b097df817)(target, x, y) && !(0, $f7ff90b8964488a6$export$2344b14b097df817)(source, x, y)) result.push(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y));
        if (result.length === 1) {
            if (pt != null && result.length === 1) {
                if (!(0, $f7ff90b8964488a6$export$2344b14b097df817)(target, pt.x, y) && !(0, $f7ff90b8964488a6$export$2344b14b097df817)(source, pt.x, y)) result.push(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(pt.x, y));
            } else {
                const l = Math.max(source.x, target.x);
                const r = Math.min(source.x + source.width, target.x + target.width);
                result.push(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(l + (r - l) / 2, y));
            }
        }
    }
};


const $2d63e7af481dcf3d$export$310010001127f926 = (state, source, target, points, result)=>{
    let pt = points != null && points.length > 0 ? points[0] : null;
    let vertical = false;
    let horizontal = false;
    if (source != null && target != null) {
        if (pt != null) {
            const left = Math.min(source.x, target.x);
            const right = Math.max(source.x + source.width, target.x + target.width);
            const top = Math.min(source.y, target.y);
            const bottom = Math.max(source.y + source.height, target.y + target.height);
            pt = state.view.transformControlPoint(state, pt);
            vertical = pt.y < top || pt.y > bottom;
            horizontal = pt.x < left || pt.x > right;
        } else {
            const left = Math.max(source.x, target.x);
            const right = Math.min(source.x + source.width, target.x + target.width);
            vertical = left === right;
            if (!vertical) {
                const top = Math.max(source.y, target.y);
                const bottom = Math.min(source.y + source.height, target.y + target.height);
                horizontal = top === bottom;
            }
        }
    }
    if (!horizontal && (vertical || state.style.elbow === 'vertical')) (0, $0bd38f1534358cf6$export$f518ac6c438bcd9c)(state, source, target, points, result);
    else (0, $08e98ea50cd5e4fa$export$577d7eb664254b8f)(state, source, target, points, result);
};


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 


var $cBHcM = parcelRequire("cBHcM");

/*
Copyright 2025-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
var $cBHcM = parcelRequire("cBHcM");

var $iy79G = parcelRequire("iy79G");
const $4a16a9e0dce47da6$export$fb2cb74e0641c0fd = {
    /**
     * Defines the length of the horizontal segment of an `Entity Relation`.
     * This can be overridden using {@link CellStateStyle.segment} style.
     * @default {@link ENTITY_SEGMENT}
     */ segment: (0, $cBHcM.ENTITY_SEGMENT)
};
const $4a16a9e0dce47da6$export$5407f83d3faf0408 = ()=>{
    // implement the reset manually as there are a few properties for now
    $4a16a9e0dce47da6$export$fb2cb74e0641c0fd.segment = (0, $cBHcM.ENTITY_SEGMENT);
};
const $4a16a9e0dce47da6$export$63ddf7aef7eb70d4 = {
    /**
     * If the value is not set in {@link CellStateStyle.jettySize}, defines the jetty size of the connector.
     *
     * If the computed value of the jetty size coming from {@link CellStateStyle} is 'auto', it is used in the computation of the automatic jetty size.
     * See the implementation of {@link OrthConnector} for more details.
     *
     * @default 10
     */ buffer: 10,
    /**
     * See the implementation of {@link OrthConnector} for more details.
     * @default true
     */ pointsFallback: true
};
const $4a16a9e0dce47da6$var$originalOrthogonalConnectorConfig = {
    ...$4a16a9e0dce47da6$export$63ddf7aef7eb70d4
};
const $4a16a9e0dce47da6$export$402c7e38ababc822 = ()=>{
    (0, $iy79G.shallowCopy)($4a16a9e0dce47da6$var$originalOrthogonalConnectorConfig, $4a16a9e0dce47da6$export$63ddf7aef7eb70d4);
};
const $4a16a9e0dce47da6$var$allDirections = ()=>{
    return [
        'north',
        'south',
        'east',
        'west'
    ];
};
const $4a16a9e0dce47da6$export$109620daf7751fe0 = {
    maxAllowedDirectionChange: 90,
    maxLoops: 2000,
    endDirections: $4a16a9e0dce47da6$var$allDirections(),
    startDirections: $4a16a9e0dce47da6$var$allDirections(),
    step: 12
};
const $4a16a9e0dce47da6$var$originalManhattanConnectorConfig = {};
(0, $iy79G.shallowCopy)($4a16a9e0dce47da6$export$109620daf7751fe0, $4a16a9e0dce47da6$var$originalManhattanConnectorConfig);
const $4a16a9e0dce47da6$export$39cf428c73a73b07 = ()=>{
    (0, $iy79G.shallowCopy)($4a16a9e0dce47da6$var$originalManhattanConnectorConfig, $4a16a9e0dce47da6$export$109620daf7751fe0);
};


const $fe02744973dbf73b$export$3d8c6cc5031aca5d = (state, source, target, _points, result)=>{
    const { view: view } = state;
    const segment = (state.style?.segment ?? (0, $4a16a9e0dce47da6$export$fb2cb74e0641c0fd).segment) * view.scale;
    const pts = state.absolutePoints;
    const p0 = pts[0];
    const pe = pts[pts.length - 1];
    let isSourceLeft = false;
    if (source != null) {
        const sourceGeometry = source.cell.getGeometry();
        if (sourceGeometry.relative) isSourceLeft = sourceGeometry.x <= 0.5;
        else if (target != null) isSourceLeft = (pe != null ? pe.x : target.x + target.width) < (p0 != null ? p0.x : source.x);
    }
    if (p0 != null) {
        source = new (0, $a9ad68c2c04d1a53$export$2e2bcd8739ae039)();
        source.x = p0.x;
        source.y = p0.y;
    } else if (source != null) {
        const constraint = (0, $f7ff90b8964488a6$export$eebe7cc623dc82c0)(source, state, true, (0, $cBHcM.DIRECTION_MASK).NONE);
        if (constraint !== (0, $cBHcM.DIRECTION_MASK).NONE && constraint !== (0, $cBHcM.DIRECTION_MASK).WEST + (0, $cBHcM.DIRECTION_MASK).EAST) isSourceLeft = constraint === (0, $cBHcM.DIRECTION_MASK).WEST;
    } else return;
    let isTargetLeft = true;
    if (target != null) {
        const targetGeometry = target.cell.getGeometry();
        if (targetGeometry.relative) isTargetLeft = targetGeometry.x <= 0.5;
        else if (source != null) isTargetLeft = (p0 != null ? p0.x : source.x + source.width) < (pe != null ? pe.x : target.x);
    }
    if (pe != null) {
        target = new (0, $a9ad68c2c04d1a53$export$2e2bcd8739ae039)();
        target.x = pe.x;
        target.y = pe.y;
    } else if (target != null) {
        const constraint = (0, $f7ff90b8964488a6$export$eebe7cc623dc82c0)(target, state, false, (0, $cBHcM.DIRECTION_MASK).NONE);
        if (constraint !== (0, $cBHcM.DIRECTION_MASK).NONE && constraint != (0, $cBHcM.DIRECTION_MASK).WEST + (0, $cBHcM.DIRECTION_MASK).EAST) isTargetLeft = constraint === (0, $cBHcM.DIRECTION_MASK).WEST;
    }
    if (source != null && target != null) {
        const x0 = isSourceLeft ? source.x : source.x + source.width;
        const y0 = view.getRoutingCenterY(source);
        const xe = isTargetLeft ? target.x : target.x + target.width;
        const ye = view.getRoutingCenterY(target);
        const seg = segment;
        let dx = isSourceLeft ? -seg : seg;
        const dep = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x0 + dx, y0);
        dx = isTargetLeft ? -seg : seg;
        const arr = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(xe + dx, ye);
        // Adds intermediate points if both go out on same side
        if (isSourceLeft === isTargetLeft) {
            const x = isSourceLeft ? Math.min(x0, xe) - segment : Math.max(x0, xe) + segment;
            result.push(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y0));
            result.push(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, ye));
        } else if (dep.x < arr.x === isSourceLeft) {
            const midY = y0 + (ye - y0) / 2;
            result.push(dep);
            result.push(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(dep.x, midY));
            result.push(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(arr.x, midY));
            result.push(arr);
        } else {
            result.push(dep);
            result.push(arr);
        }
    }
};


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 

const $75d64e99b04a290d$export$550acbd06a1f5a6a = (state, source, _target, points, result)=>{
    const pts = state.absolutePoints;
    const p0 = pts[0];
    const pe = pts[pts.length - 1];
    if (p0 != null && pe != null) {
        if (points != null && points.length > 0) for(let i = 0; i < points.length; i += 1){
            let pt = points[i];
            pt = state.view.transformControlPoint(state, pt);
            result.push(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(pt.x, pt.y));
        }
        return;
    }
    if (source != null) {
        const { view: view } = state;
        const { graph: graph } = view;
        let pt = points != null && points.length > 0 ? points[0] : null;
        if (pt != null) {
            pt = view.transformControlPoint(state, pt);
            if ((0, $f7ff90b8964488a6$export$2344b14b097df817)(source, pt.x, pt.y)) pt = null;
        }
        let x = 0;
        let dx = 0;
        let y = 0;
        let dy = 0;
        const seg = (state.style.segment ?? graph.gridSize) * view.scale;
        const dir = state.style?.direction ?? 'west';
        if (dir === 'north' || dir === 'south') {
            x = view.getRoutingCenterX(source);
            dx = seg;
        } else {
            y = view.getRoutingCenterY(source);
            dy = seg;
        }
        if (pt == null || pt.x < source.x || pt.x > source.x + source.width) {
            if (pt != null) {
                x = pt.x;
                dy = Math.max(Math.abs(y - pt.y), dy);
            } else switch(dir){
                case 'north':
                    y = source.y - 2 * dx;
                    break;
                case 'south':
                    y = source.y + source.height + 2 * dx;
                    break;
                case 'east':
                    x = source.x - 2 * dy;
                    break;
                default:
                    x = source.x + source.width + 2 * dy;
            }
        } else if (pt !== null) {
            x = view.getRoutingCenterX(source);
            dx = Math.max(Math.abs(x - pt.x), dy);
            y = pt.y;
            dy = 0;
        }
        result.push(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x - dx, y - dy));
        result.push(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + dx, y + dy));
    }
};


/*
Copyright 2023-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /**
 * Removes all occurrences of the given object in the given array or
 * object. If there are multiple occurrences of the object, be they
 * associative or as an array entry, all occurrences are removed from
 * the array or deleted from the object. By removing the object from
 * the array, all elements following the removed element are shifted
 * by one step towards the beginning of the array.
 *
 * The length of arrays is not modified inside this function.
 *
 * @param obj Object to find in the given array.
 * @param array Array to check for the given obj.
 */ const $7798e91745d24e26$export$cd7f480d6b8286c3 = (obj, array)=>{
    let result = null;
    if (typeof array === 'object') {
        let index = array.indexOf(obj);
        while(index >= 0){
            array.splice(index, 1);
            result = obj;
            index = array.indexOf(obj);
        }
    }
    for(const key in array)if (array[key] == obj) {
        delete array[key];
        result = obj;
    }
    return result;
};
const $7798e91745d24e26$export$762de7b100cb21fe = (a, b)=>{
    if (!a && b || a && !b || a && b && a.length != b.length) return false;
    if (a && b) for(let i = 0; i < a.length; i += 1){
        const p = a[i];
        if (!p || p && !p.equals(b[i])) return false;
    }
    return true;
};
const $7798e91745d24e26$export$ddfc9eb811782af = (a, b)=>{
    // Counts keys in b to check if all values have been compared
    let count = 0;
    if (!a && b || a && !b || a && b && a.length != b.length) return false;
    if (a && b) {
        for(const key in b)count++;
        for(const key in a){
            count--;
            if ((!Number.isNaN(a[key]) || !Number.isNaN(b[key])) && a[key] !== b[key]) return false;
        }
    }
    return count === 0;
};
const $7798e91745d24e26$export$2e2262a44ac61957 = (arr)=>{
    const coveredEntries = new Map();
    const result = [];
    for(let i = 0; i < arr.length; i += 1)if (!coveredEntries.get(arr[i])) {
        result.push(arr[i]);
        coveredEntries.set(arr[i], true);
    }
    return result;
};



/**
 * For vertices, the geometry consists of the x- and y-location, and the width
 * and height. For edges, the geometry consists of the optional terminal- and
 * control points. The terminal points are only required if an edge is
 * unconnected, and are stored in the {@link sourcePoint} and {@link targetPoint}
 * variables, respectively.
 *
 * ### Example
 *
 * If an edge is unconnected, that is, it has no source or target terminal,
 * then a geometry with terminal points for a new edge can be defined as
 * follows.
 *
 * ```javascript
 * geometry.setTerminalPoint(new Point(x1, y1), true);
 * geometry.points: [new Point(x2, y2)];
 * geometry.setTerminalPoint(new Point(x3, y3), false);
 * ```
 *
 * Control points are used regardless of the connected state of an edge and may
 * be ignored or interpreted differently depending on the edge's {@link edgeStyle}.
 *
 * To disable automatic reset of control points after a cell has been moved or
 * resized, {@link AbstractGraph.resetEdgesOnMove} and {@link AbstractGraph.resetEdgesOnResize} may be used.
 *
 * ### Edge Labels
 *
 * Using the x- and y-coordinates of a cell's geometry, it is possible to
 * position the label on edges on a specific location on the actual edge shape
 * as it appears on the screen. The x-coordinate of an edge's geometry is used
 * to describe the distance from the center of the edge from -1 to 1 with 0
 * being the center of the edge and the default value. The y-coordinate of an
 * edge's geometry is used to describe the absolute, orthogonal distance in
 * pixels from that point. In addition, the {@link Geometry.offset} is used as an
 * absolute offset vector from the resulting point.
 *
 * This coordinate system is applied if {@link relative} is true, otherwise the
 * offset defines the absolute vector from the edge's center point to the
 * label and the values for {@link x} and {@link y} are ignored.
 *
 * The width and height parameter for edge geometries can be used to set the
 * label width and height (eg. for word wrapping).
 *
 * ### Ports
 *
 * The term "port" refers to a relatively positioned, connectable child cell,
 * which is used to specify the connection between the parent and another cell
 * in the graph. Ports are typically modeled as vertices with relative
 * geometries.
 *
 * ### Offsets
 *
 * The {@link offset} field is interpreted in 3 different ways, depending on the cell
 * and the geometry. For edges, the offset defines the absolute offset for the
 * edge label. For relative geometries, the offset defines the absolute offset
 * for the origin (top, left corner) of the vertex, otherwise the offset
 * defines the absolute offset for the label inside the vertex or group.
 *
 * @category Geometry
 */ class $6713282b00eec691$var$Geometry extends (0, $2997c239141ea844$export$2e2bcd8739ae039) {
    constructor(x = 0, y = 0, width = 0, height = 0){
        super(x, y, width, height);
        /**
         * Global switch to translate the points in translate. Default is true.
         */ this.TRANSLATE_CONTROL_POINTS = true;
        /**
         * Stores alternate values for x, y, width and height in a rectangle.
         * See {@link swap} to exchange the values. Default is null.
         *
         * @see {@link swap}
         */ this.alternateBounds = null;
        /**
         * Defines the source {@link Point} of the edge. This is used if the
         * corresponding edge does not have a source vertex. Otherwise, it is ignored.
         * @default null
         */ this.sourcePoint = null;
        /**
         * Defines the source {@link Point} of the edge. This is used if the
         * corresponding edge does not have a target vertex. Otherwise, it is ignored.
         * @default null
         */ this.targetPoint = null;
        /**
         * Array of {@link Point} which specifies the control points along the edge.
         * These points are the intermediate points on the edge, for the endpoints
         * use {@link targetPoint} and {@link sourcePoint} or set the terminals of the edge to
         * a non-null value.
         * @default null
         */ this.points = null;
        /**
         * For edges, this holds the offset (in pixels) from the position defined by {@link x} and {@link y} on the edge.
         *
         * For relative geometries (for vertices), this defines the absolute offset from the point defined by the relative
         * coordinates.
         *
         * For absolute geometries (for vertices), this defines the offset for the label.
         * @default null
         */ this.offset = null;
        /**
         * Specifies if the coordinates in the geometry are to be interpreted as relative coordinates.
         *
         * For edges, this is used to define the location of the edge label relative to the edge
         * as rendered on the display.
         *
         * For vertices, this specifies the relative location inside the bounds of the parent cell.
         *
         * If this is `false`, then the coordinates are relative to the origin of the parent cell or,
         * for edges, the edge label position is relative to the center of the edge as rendered on screen.
         *
         * @default false.
         */ this.relative = false;
    }
    setRelative(isRelative) {
        this.relative = isRelative;
    }
    /**
     * Swaps the x, y, width and height with the values stored in
     * {@link alternateBounds} and puts the previous values into {@link alternateBounds} as
     * a rectangle. This operation is carried-out in-place, that is, using the
     * existing geometry instance. If this operation is called during a graph
     * model transactional change, then the geometry should be cloned before
     * calling this method and setting the geometry of the cell using
     * {@link GraphDataModel.setGeometry}.
     */ swap() {
        if (this.alternateBounds) {
            const old = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(this.x, this.y, this.width, this.height);
            this.x = this.alternateBounds.x;
            this.y = this.alternateBounds.y;
            this.width = this.alternateBounds.width;
            this.height = this.alternateBounds.height;
            this.alternateBounds = old;
        }
    }
    /**
     * Returns the {@link Point} representing the source or target point of this
     * edge. This is only used if the edge has no source or target vertex.
     *
     * @param {Boolean} isSource that specifies if the source or target point should be returned.
     */ getTerminalPoint(isSource) {
        return isSource ? this.sourcePoint : this.targetPoint;
    }
    /**
     * Sets the {@link sourcePoint} or {@link targetPoint} to the given {@link Point} and
     * returns the new point.
     *
     * @param {Point} point to be used as the new source or target point.
     * @param {Boolean} isSource that specifies if the source or target point should be set.
     */ setTerminalPoint(point, isSource) {
        if (isSource) this.sourcePoint = point;
        else this.targetPoint = point;
        return point;
    }
    /**
     * Rotates the geometry by the given angle around the given center. That is,
     * {@link x} and {@link y} of the geometry, the {@link sourcePoint}, {@link targetPoint} and all
     * {@link points} are translated by the given amount. {@link x} and {@link y} are only
     * translated if {@link relative} is false.
     *
     * @param {Number} angle that specifies the rotation angle in degrees.
     * @param {Point} cx   that specifies the center of the rotation.
     */ rotate(angle, cx) {
        const rad = (0, $f7ff90b8964488a6$export$cba01ba138429a1d)(angle);
        const cos = Math.cos(rad);
        const sin = Math.sin(rad);
        // Rotates the geometry
        if (!this.relative) {
            const ct = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(this.getCenterX(), this.getCenterY());
            const pt = (0, $f7ff90b8964488a6$export$ad2a0af3fbffd7c1)(ct, cos, sin, cx);
            this.x = Math.round(pt.x - this.width / 2);
            this.y = Math.round(pt.y - this.height / 2);
        }
        // Rotates the source point
        if (this.sourcePoint) {
            const pt = (0, $f7ff90b8964488a6$export$ad2a0af3fbffd7c1)(this.sourcePoint, cos, sin, cx);
            this.sourcePoint.x = Math.round(pt.x);
            this.sourcePoint.y = Math.round(pt.y);
        }
        // Translates the target point
        if (this.targetPoint) {
            const pt = (0, $f7ff90b8964488a6$export$ad2a0af3fbffd7c1)(this.targetPoint, cos, sin, cx);
            this.targetPoint.x = Math.round(pt.x);
            this.targetPoint.y = Math.round(pt.y);
        }
        // Translate the control points
        if (this.points) {
            for(let i = 0; i < this.points.length; i += 1)if (this.points[i]) {
                const pt = (0, $f7ff90b8964488a6$export$ad2a0af3fbffd7c1)(this.points[i], cos, sin, cx);
                this.points[i].x = Math.round(pt.x);
                this.points[i].y = Math.round(pt.y);
            }
        }
    }
    /**
     * Translates the geometry by the specified amount. That is, {@link x} and {@link y} of the
     * geometry, the {@link sourcePoint}, {@link targetPoint} and all {@link points} are translated
     * by the given amount. {@link x} and {@link y} are only translated if {@link relative} is false.
     * If {@link TRANSLATE_CONTROL_POINTS} is false, then {@link points} are not modified by
     * this function.
     *
     * @param {Number} dx that specifies the x-coordinate of the translation.
     * @param {Number} dy that specifies the y-coordinate of the translation.
     */ translate(dx, dy) {
        // Translates the geometry
        if (!this.relative) {
            this.x += dx;
            this.y += dy;
        }
        // Translates the source point
        if (this.sourcePoint) {
            this.sourcePoint.x = this.sourcePoint.x + dx;
            this.sourcePoint.y = this.sourcePoint.y + dy;
        }
        // Translates the target point
        if (this.targetPoint) {
            this.targetPoint.x = this.targetPoint.x + dx;
            this.targetPoint.y = this.targetPoint.y + dy;
        }
        // Translate the control points
        if (this.TRANSLATE_CONTROL_POINTS && this.points) {
            for(let i = 0; i < this.points.length; i += 1)if (this.points[i]) {
                this.points[i].x = this.points[i].x + dx;
                this.points[i].y = this.points[i].y + dy;
            }
        }
    }
    /**
     * Scales the geometry by the given amount. That is, {@link x} and {@link y} of the
     * geometry, the {@link sourcePoint}, {@link targetPoint} and all {@link points} are scaled
     * by the given amount. {@link x}, {@link y}, {@link width} and {@link height} are only scaled if
     * {@link relative} is false. If {@link fixedAspect} is true, then the smaller value
     * is used to scale the width and the height.
     *
     * @param {Number} sx that specifies the horizontal scale factor.
     * @param {Number} sy that specifies the vertical scale factor.
     * @param {Optional} fixedAspect boolean to keep the aspect ratio fixed.
     */ scale(sx, sy, fixedAspect) {
        // Translates the source point
        if (this.sourcePoint) {
            this.sourcePoint.x = this.sourcePoint.x * sx;
            this.sourcePoint.y = this.sourcePoint.y * sy;
        }
        // Translates the target point
        if (this.targetPoint) {
            this.targetPoint.x = this.targetPoint.x * sx;
            this.targetPoint.y = this.targetPoint.y * sy;
        }
        // Translate the control points
        if (this.points) {
            for(let i = 0; i < this.points.length; i += 1)if (this.points[i]) {
                this.points[i].x = this.points[i].x * sx;
                this.points[i].y = this.points[i].y * sy;
            }
        }
        // Translates the geometry
        if (!this.relative) {
            this.x *= sx;
            this.y *= sy;
            if (fixedAspect) sy = sx = Math.min(sx, sy);
            this.width *= sx;
            this.height *= sy;
        }
    }
    /**
     * Returns true if the given object equals this geometry.
     */ equals(geom) {
        if (!geom) return false;
        return super.equals(geom) && this.relative === geom.relative && (this.sourcePoint === null && geom.sourcePoint === null || !!this.sourcePoint?.equals(geom.sourcePoint)) && (this.targetPoint === null && geom.targetPoint === null || !!this.targetPoint?.equals(geom.targetPoint)) && (0, $7798e91745d24e26$export$762de7b100cb21fe)(this.points, geom.points) && (this.alternateBounds === null && geom.alternateBounds === null || !!this.alternateBounds?.equals(geom.alternateBounds)) && (this.offset === null && geom.offset === null || !!this.offset?.equals(geom.offset));
    }
    clone() {
        return (0, $a200c5dda16aedca$export$9cd59f9826255e47)(this);
    }
}
var $6713282b00eec691$export$2e2bcd8739ae039 = $6713282b00eec691$var$Geometry;


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
function $621b52b11185b110$export$44cd41ea05af2638(points, scale) {
    let result = [];
    if (points != null) {
        for(let i = 0; i < points.length; i += 1)if (points[i] != null) result[i] = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(Math.round(points[i].x / scale * 10) / 10, Math.round(points[i].y / scale * 10) / 10);
        else result[i] = null;
    } else result = null;
    return result;
}
function $621b52b11185b110$export$c8d66802f2daa610(state, scale) {
    let result = null;
    if (state != null) {
        result = state.clone();
        result.setRect(Math.round(state.x / scale * 10) / 10, Math.round(state.y / scale * 10) / 10, Math.round(state.width / scale * 10) / 10, Math.round(state.height / scale * 10) / 10);
    }
    return result;
}



var $cBHcM = parcelRequire("cBHcM");



var $4vC7I = parcelRequire("4vC7I");


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 


const $7c381263c777720e$export$4ee6d6acbd0456a7 = (state, sourceScaled, targetScaled, controlHints, result)=>{
    // Creates array of all way- and terminal points
    // TODO: Figure out what to do when there are nulls in `pts`!
    const pts = (0, $621b52b11185b110$export$44cd41ea05af2638)(state.absolutePoints, state.view.scale);
    const source = (0, $621b52b11185b110$export$c8d66802f2daa610)(sourceScaled, state.view.scale);
    const target = (0, $621b52b11185b110$export$c8d66802f2daa610)(targetScaled, state.view.scale);
    const tol = 1;
    // Whether the first segment outgoing from the source end is horizontal
    let lastPushed = result.length > 0 ? result[0] : null;
    let horizontal = true;
    let hint = null;
    // Adds waypoints only if outside of tolerance
    function pushPoint(pt) {
        pt.x = Math.round(pt.x * state.view.scale * 10) / 10;
        pt.y = Math.round(pt.y * state.view.scale * 10) / 10;
        if (lastPushed == null || Math.abs(lastPushed.x - pt.x) >= tol || Math.abs(lastPushed.y - pt.y) >= Math.max(1, state.view.scale)) {
            result.push(pt);
            lastPushed = pt;
        }
        return lastPushed;
    }
    // Adds the first point
    let pt = pts[0];
    if (pt == null && source != null) pt = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(state.view.getRoutingCenterX(source), state.view.getRoutingCenterY(source));
    else if (pt != null) pt = pt.clone();
    const lastInx = pts.length - 1;
    let pe = null;
    // Adds the waypoints
    if (controlHints != null && controlHints.length > 0) {
        // Converts all hints and removes nulls
        let hints = [];
        for(let i = 0; i < controlHints.length; i += 1){
            const tmp = state.view.transformControlPoint(state, controlHints[i], true);
            if (tmp != null) hints.push(tmp);
        }
        if (hints.length === 0) return;
        // Aligns source and target hint to fixed points
        if (pt != null && hints[0] != null) {
            if (Math.abs(hints[0].x - pt.x) < tol) hints[0].x = pt.x;
            if (Math.abs(hints[0].y - pt.y) < tol) hints[0].y = pt.y;
        }
        pe = pts[lastInx];
        if (pe != null && hints[hints.length - 1] != null) {
            if (Math.abs(hints[hints.length - 1].x - pe.x) < tol) hints[hints.length - 1].x = pe.x;
            if (Math.abs(hints[hints.length - 1].y - pe.y) < tol) hints[hints.length - 1].y = pe.y;
        }
        hint = hints[0];
        let currentTerm = source;
        let currentPt = pts[0];
        let hozChan = false;
        let vertChan = false;
        let currentHint = hint;
        if (currentPt != null) currentTerm = null;
        // Check for alignment with fixed points and with channels
        // at source and target segments only
        for(let i = 0; i < 2; i += 1){
            const fixedVertAlign = currentPt != null && currentPt.x === currentHint.x;
            const fixedHozAlign = currentPt != null && currentPt.y === currentHint.y;
            const inHozChan = currentTerm != null && currentHint.y >= currentTerm.y && currentHint.y <= currentTerm.y + currentTerm.height;
            const inVertChan = currentTerm != null && currentHint.x >= currentTerm.x && currentHint.x <= currentTerm.x + currentTerm.width;
            hozChan = fixedHozAlign || currentPt == null && inHozChan;
            vertChan = fixedVertAlign || currentPt == null && inVertChan;
            // If the current hint falls in both the hor and vert channels in the case
            // of a floating port, or if the hint is exactly co-incident with a
            // fixed point, ignore the source and try to work out the orientation
            // from the target end
            if (!(i == 0 && (hozChan && vertChan || fixedVertAlign && fixedHozAlign))) {
                if (currentPt != null && !fixedHozAlign && !fixedVertAlign && (inHozChan || inVertChan)) {
                    horizontal = !inHozChan;
                    break;
                }
                if (vertChan || hozChan) {
                    horizontal = hozChan;
                    if (i === 1) // Work back from target end
                    horizontal = hints.length % 2 === 0 ? hozChan : vertChan;
                    break;
                }
            }
            currentTerm = target;
            currentPt = pts[lastInx];
            if (currentPt != null) currentTerm = null;
            currentHint = hints[hints.length - 1];
            if (fixedVertAlign && fixedHozAlign) hints = hints.slice(1);
        }
        if (horizontal && (pts[0] != null && pts[0].y !== hint.y || pts[0] == null && source != null && (hint.y < source.y || hint.y > source.y + source.height))) pushPoint(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(pt.x, hint.y));
        else if (!horizontal && (pts[0] != null && pts[0].x !== hint.x || pts[0] == null && source != null && (hint.x < source.x || hint.x > source.x + source.width))) pushPoint(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(hint.x, pt.y));
        if (horizontal) pt.y = hint.y;
        else pt.x = hint.x;
        for(let i = 0; i < hints.length; i += 1){
            horizontal = !horizontal;
            hint = hints[i];
            if (horizontal) pt.y = hint.y;
            else pt.x = hint.x;
            pushPoint(pt.clone());
        }
    } else {
        hint = pt;
        // FIXME: First click in connect preview toggles orientation
        horizontal = true;
    }
    // Adds the last point
    pt = pts[lastInx];
    if (pt == null && target != null) pt = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(state.view.getRoutingCenterX(target), state.view.getRoutingCenterY(target));
    if (pt != null) {
        if (hint != null) {
            if (horizontal && (pts[lastInx] != null && pts[lastInx].y !== hint.y || pts[lastInx] == null && target != null && (hint.y < target.y || hint.y > target.y + target.height))) pushPoint(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(pt.x, hint.y));
            else if (!horizontal && (pts[lastInx] != null && pts[lastInx].x !== hint.x || pts[lastInx] == null && target != null && (hint.x < target.x || hint.x > target.x + target.width))) pushPoint(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(hint.x, pt.y));
        }
    }
    // Removes bends inside the source terminal for floating ports
    if (pts[0] == null && source != null) while(result.length > 1 && result[1] != null && (0, $f7ff90b8964488a6$export$2344b14b097df817)(source, result[1].x, result[1].y))result.splice(1, 1);
    // Removes bends inside the target terminal
    if (pts[lastInx] == null && target != null) while(result.length > 1 && result[result.length - 1] != null && (0, $f7ff90b8964488a6$export$2344b14b097df817)(target, result[result.length - 1].x, result[result.length - 1].y))result.splice(result.length - 1, 1);
    // Removes last point if inside tolerance with end point
    if (pe != null && result[result.length - 1] != null && Math.abs(pe.x - result[result.length - 1].x) <= tol && Math.abs(pe.y - result[result.length - 1].y) <= tol) {
        result.splice(result.length - 1, 1);
        // Lines up second last point in result with end point
        if (result[result.length - 1] != null) {
            if (Math.abs(result[result.length - 1].x - pe.x) < tol) result[result.length - 1].x = pe.x;
            if (Math.abs(result[result.length - 1].y - pe.y) < tol) result[result.length - 1].y = pe.y;
        }
    }
};


const $ce86dce9f518bafe$var$dirVectors = [
    [
        -1,
        0
    ],
    [
        0,
        -1
    ],
    [
        1,
        0
    ],
    [
        0,
        1
    ],
    [
        -1,
        0
    ],
    [
        0,
        -1
    ],
    [
        1,
        0
    ]
];
const $ce86dce9f518bafe$var$wayPoints1 = [
    [
        0,
        0
    ],
    [
        0,
        0
    ],
    [
        0,
        0
    ],
    [
        0,
        0
    ],
    [
        0,
        0
    ],
    [
        0,
        0
    ],
    [
        0,
        0
    ],
    [
        0,
        0
    ],
    [
        0,
        0
    ],
    [
        0,
        0
    ],
    [
        0,
        0
    ],
    [
        0,
        0
    ]
];
const $ce86dce9f518bafe$var$routePatterns = [
    [
        [
            513,
            2308,
            2081,
            2562
        ],
        [
            513,
            1090,
            514,
            2184,
            2114,
            2561
        ],
        [
            513,
            1090,
            514,
            2564,
            2184,
            2562
        ],
        [
            513,
            2308,
            2561,
            1090,
            514,
            2568,
            2308
        ]
    ],
    [
        [
            514,
            1057,
            513,
            2308,
            2081,
            2562
        ],
        [
            514,
            2184,
            2114,
            2561
        ],
        [
            514,
            2184,
            2562,
            1057,
            513,
            2564,
            2184
        ],
        [
            514,
            1057,
            513,
            2568,
            2308,
            2561
        ]
    ],
    [
        [
            1090,
            514,
            1057,
            513,
            2308,
            2081,
            2562
        ],
        [
            2114,
            2561
        ],
        [
            1090,
            2562,
            1057,
            513,
            2564,
            2184
        ],
        [
            1090,
            514,
            1057,
            513,
            2308,
            2561,
            2568
        ]
    ],
    [
        [
            2081,
            2562
        ],
        [
            1057,
            513,
            1090,
            514,
            2184,
            2114,
            2561
        ],
        [
            1057,
            513,
            1090,
            514,
            2184,
            2562,
            2564
        ],
        [
            1057,
            2561,
            1090,
            514,
            2568,
            2308
        ]
    ]
];
const $ce86dce9f518bafe$var$vertexSeparations = [];
const $ce86dce9f518bafe$var$limits = [
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ]
];
// const LEFT_MASK = 32;
//
// const TOP_MASK = 64;
//
// const RIGHT_MASK = 128;
//
// const BOTTOM_MASK = 256;
//
// const LEFT = 1;
//
// const TOP = 2;
//
// const RIGHT = 4;
//
// const BOTTOM = 8;
// TODO remove magic numbers
const $ce86dce9f518bafe$var$SIDE_MASK = 480;
// LEFT_MASK | TOP_MASK | RIGHT_MASK | BOTTOM_MASK,
const $ce86dce9f518bafe$var$CENTER_MASK = 512;
const $ce86dce9f518bafe$var$SOURCE_MASK = 1024;
const $ce86dce9f518bafe$var$TARGET_MASK = 2048;
const $ce86dce9f518bafe$var$VERTEX_MASK = 3072;
// SOURCE_MASK | TARGET_MASK,
function $ce86dce9f518bafe$var$getJettySize(state, isSource) {
    const buffer = (0, $4a16a9e0dce47da6$export$63ddf7aef7eb70d4).buffer;
    let value = (isSource ? state.style.sourceJettySize : state.style.targetJettySize) ?? state.style.jettySize ?? buffer;
    if (value === 'auto') {
        // Computes the automatic jetty size
        const type = (isSource ? state.style.startArrow : state.style.endArrow) ?? (0, $cBHcM.NONE);
        if (type !== (0, $cBHcM.NONE)) {
            const size = (isSource ? state.style.startSize : state.style.endSize) ?? (0, $4vC7I.StyleDefaultsConfig).markerSize;
            value = Math.max(2, Math.ceil((size + buffer) / buffer)) * buffer;
        } else value = 2 * buffer;
    }
    return value;
}
const $ce86dce9f518bafe$export$f8421c630280c361 = (state, sourceScaled, targetScaled, controlHints, result)=>{
    // TODO: Figure out what to do when there are nulls in `pts`!
    const pts = (0, $621b52b11185b110$export$44cd41ea05af2638)(state.absolutePoints, state.view.scale);
    const source = (0, $621b52b11185b110$export$c8d66802f2daa610)(sourceScaled, state.view.scale);
    const target = (0, $621b52b11185b110$export$c8d66802f2daa610)(targetScaled, state.view.scale);
    const sourceEdge = source == null ? false : source.cell.isEdge();
    const targetEdge = target == null ? false : target.cell.isEdge();
    const p0 = pts[0];
    const pe = pts[pts.length - 1];
    let sourceX = source != null ? source.x : p0.x;
    let sourceY = source != null ? source.y : p0.y;
    let sourceWidth = source != null ? source.width : 0;
    let sourceHeight = source != null ? source.height : 0;
    let targetX = target != null ? target.x : pe.x;
    let targetY = target != null ? target.y : pe.y;
    let targetWidth = target != null ? target.width : 0;
    let targetHeight = target != null ? target.height : 0;
    let sourceBuffer = $ce86dce9f518bafe$var$getJettySize(state, true);
    let targetBuffer = $ce86dce9f518bafe$var$getJettySize(state, false);
    // Workaround for loop routing within buffer zone
    if (source != null && target === source) {
        targetBuffer = Math.max(sourceBuffer, targetBuffer);
        sourceBuffer = targetBuffer;
    }
    const totalBuffer = targetBuffer + sourceBuffer;
    let tooShort = false;
    // Checks minimum distance for fixed points and falls back to segment connector
    if (p0 != null && pe != null) {
        const dx = pe.x - p0.x;
        const dy = pe.y - p0.y;
        tooShort = dx * dx + dy * dy < totalBuffer * totalBuffer;
    }
    if (tooShort || (0, $4a16a9e0dce47da6$export$63ddf7aef7eb70d4).pointsFallback && controlHints != null && controlHints.length > 0 || sourceEdge || targetEdge) {
        (0, $7c381263c777720e$export$4ee6d6acbd0456a7)(state, sourceScaled, targetScaled, controlHints, result);
        return;
    }
    // Determine the side(s) of the source and target vertices
    // that the edge may connect to
    // portConstraint [source, target]
    const portConstraint = [
        (0, $cBHcM.DIRECTION_MASK).ALL,
        (0, $cBHcM.DIRECTION_MASK).ALL
    ];
    let rotation = 0;
    if (source != null) {
        portConstraint[0] = (0, $f7ff90b8964488a6$export$eebe7cc623dc82c0)(source, state, true, (0, $cBHcM.DIRECTION_MASK).ALL);
        rotation = source.style.rotation ?? 0;
        if (rotation !== 0) {
            const newRect = (0, $f7ff90b8964488a6$export$895c5e634403eaa7)(new (0, $2997c239141ea844$export$2e2bcd8739ae039)(sourceX, sourceY, sourceWidth, sourceHeight), rotation);
            sourceX = newRect.x;
            sourceY = newRect.y;
            sourceWidth = newRect.width;
            sourceHeight = newRect.height;
        }
    }
    if (target != null) {
        portConstraint[1] = (0, $f7ff90b8964488a6$export$eebe7cc623dc82c0)(target, state, false, (0, $cBHcM.DIRECTION_MASK).ALL);
        rotation = target.style.rotation ?? 0;
        if (rotation !== 0) {
            const newRect = (0, $f7ff90b8964488a6$export$895c5e634403eaa7)(new (0, $2997c239141ea844$export$2e2bcd8739ae039)(targetX, targetY, targetWidth, targetHeight), rotation);
            targetX = newRect.x;
            targetY = newRect.y;
            targetWidth = newRect.width;
            targetHeight = newRect.height;
        }
    }
    const dir = [
        0,
        0
    ];
    // Work out which faces of the vertices present against each other
    // in a way that would allow a 3-segment connection if port constraints
    // permitted.
    // geo -> [source, target] [x, y, width, height]
    const geo = [
        [
            sourceX,
            sourceY,
            sourceWidth,
            sourceHeight
        ],
        [
            targetX,
            targetY,
            targetWidth,
            targetHeight
        ]
    ];
    const buffer = [
        sourceBuffer,
        targetBuffer
    ];
    for(let i = 0; i < 2; i += 1){
        $ce86dce9f518bafe$var$limits[i][1] = geo[i][0] - buffer[i];
        $ce86dce9f518bafe$var$limits[i][2] = geo[i][1] - buffer[i];
        $ce86dce9f518bafe$var$limits[i][4] = geo[i][0] + geo[i][2] + buffer[i];
        $ce86dce9f518bafe$var$limits[i][8] = geo[i][1] + geo[i][3] + buffer[i];
    }
    // Work out which quad the target is in
    const sourceCenX = geo[0][0] + geo[0][2] / 2.0;
    const sourceCenY = geo[0][1] + geo[0][3] / 2.0;
    const targetCenX = geo[1][0] + geo[1][2] / 2.0;
    const targetCenY = geo[1][1] + geo[1][3] / 2.0;
    const dx = sourceCenX - targetCenX;
    const dy = sourceCenY - targetCenY;
    let quad = 0;
    // 0 | 1
    // -----
    // 3 | 2
    if (dx < 0) {
        if (dy < 0) quad = 2;
        else quad = 1;
    } else if (dy <= 0) {
        quad = 3;
        // Special case on x = 0 and negative y
        if (dx === 0) quad = 2;
    }
    // Check for connection constraints
    let currentTerm = null;
    if (source != null) currentTerm = p0;
    const constraint = [
        [
            0.5,
            0.5
        ],
        [
            0.5,
            0.5
        ]
    ];
    for(let i = 0; i < 2; i += 1){
        if (currentTerm != null) {
            constraint[i][0] = (currentTerm.x - geo[i][0]) / geo[i][2];
            if (Math.abs(currentTerm.x - geo[i][0]) <= 1) dir[i] = (0, $cBHcM.DIRECTION_MASK).WEST;
            else if (Math.abs(currentTerm.x - geo[i][0] - geo[i][2]) <= 1) dir[i] = (0, $cBHcM.DIRECTION_MASK).EAST;
            constraint[i][1] = (currentTerm.y - geo[i][1]) / geo[i][3];
            if (Math.abs(currentTerm.y - geo[i][1]) <= 1) dir[i] = (0, $cBHcM.DIRECTION_MASK).NORTH;
            else if (Math.abs(currentTerm.y - geo[i][1] - geo[i][3]) <= 1) dir[i] = (0, $cBHcM.DIRECTION_MASK).SOUTH;
        }
        currentTerm = null;
        if (target != null) currentTerm = pe;
    }
    const sourceTopDist = geo[0][1] - (geo[1][1] + geo[1][3]);
    const sourceLeftDist = geo[0][0] - (geo[1][0] + geo[1][2]);
    const sourceBottomDist = geo[1][1] - (geo[0][1] + geo[0][3]);
    const sourceRightDist = geo[1][0] - (geo[0][0] + geo[0][2]);
    $ce86dce9f518bafe$var$vertexSeparations[1] = Math.max(sourceLeftDist - totalBuffer, 0);
    $ce86dce9f518bafe$var$vertexSeparations[2] = Math.max(sourceTopDist - totalBuffer, 0);
    $ce86dce9f518bafe$var$vertexSeparations[4] = Math.max(sourceBottomDist - totalBuffer, 0);
    $ce86dce9f518bafe$var$vertexSeparations[3] = Math.max(sourceRightDist - totalBuffer, 0);
    //= =============================================================
    // Start of source and target direction determination
    // Work through the preferred orientations by relative positioning
    // of the vertices and list them in preferred and available order
    const dirPref = [];
    const horPref = [];
    const vertPref = [];
    horPref[0] = sourceLeftDist >= sourceRightDist ? (0, $cBHcM.DIRECTION_MASK).WEST : (0, $cBHcM.DIRECTION_MASK).EAST;
    vertPref[0] = sourceTopDist >= sourceBottomDist ? (0, $cBHcM.DIRECTION_MASK).NORTH : (0, $cBHcM.DIRECTION_MASK).SOUTH;
    horPref[1] = (0, $f7ff90b8964488a6$export$747c07263c520aa0)(horPref[0]);
    vertPref[1] = (0, $f7ff90b8964488a6$export$747c07263c520aa0)(vertPref[0]);
    const preferredHorizDist = sourceLeftDist >= sourceRightDist ? sourceLeftDist : sourceRightDist;
    const preferredVertDist = sourceTopDist >= sourceBottomDist ? sourceTopDist : sourceBottomDist;
    const prefOrdering = [
        [
            0,
            0
        ],
        [
            0,
            0
        ]
    ];
    let preferredOrderSet = false;
    // If the preferred port isn't available, switch it
    for(let i = 0; i < 2; i += 1){
        if (dir[i] !== 0x0) continue;
        if ((horPref[i] & portConstraint[i]) === 0) horPref[i] = (0, $f7ff90b8964488a6$export$747c07263c520aa0)(horPref[i]);
        if ((vertPref[i] & portConstraint[i]) === 0) vertPref[i] = (0, $f7ff90b8964488a6$export$747c07263c520aa0)(vertPref[i]);
        prefOrdering[i][0] = vertPref[i];
        prefOrdering[i][1] = horPref[i];
    }
    if (preferredVertDist > 0 && preferredHorizDist > 0) {
        // Possibility of two segment edge connection
        if ((horPref[0] & portConstraint[0]) > 0 && (vertPref[1] & portConstraint[1]) > 0) {
            prefOrdering[0][0] = horPref[0];
            prefOrdering[0][1] = vertPref[0];
            prefOrdering[1][0] = vertPref[1];
            prefOrdering[1][1] = horPref[1];
            preferredOrderSet = true;
        } else if ((vertPref[0] & portConstraint[0]) > 0 && (horPref[1] & portConstraint[1]) > 0) {
            prefOrdering[0][0] = vertPref[0];
            prefOrdering[0][1] = horPref[0];
            prefOrdering[1][0] = horPref[1];
            prefOrdering[1][1] = vertPref[1];
            preferredOrderSet = true;
        }
    }
    if (preferredVertDist > 0 && !preferredOrderSet) {
        prefOrdering[0][0] = vertPref[0];
        prefOrdering[0][1] = horPref[0];
        prefOrdering[1][0] = vertPref[1];
        prefOrdering[1][1] = horPref[1];
        preferredOrderSet = true;
    }
    if (preferredHorizDist > 0 && !preferredOrderSet) {
        prefOrdering[0][0] = horPref[0];
        prefOrdering[0][1] = vertPref[0];
        prefOrdering[1][0] = horPref[1];
        prefOrdering[1][1] = vertPref[1];
        preferredOrderSet = true;
    }
    // The source and target prefs are now an ordered list of
    // the preferred port selections
    // If the list contains gaps, compact it
    for(let i = 0; i < 2; i += 1){
        if (dir[i] !== 0x0) continue;
        if ((prefOrdering[i][0] & portConstraint[i]) === 0) prefOrdering[i][0] = prefOrdering[i][1];
        dirPref[i] = prefOrdering[i][0] & portConstraint[i];
        dirPref[i] |= (prefOrdering[i][1] & portConstraint[i]) << 8;
        dirPref[i] |= (prefOrdering[1 - i][i] & portConstraint[i]) << 16;
        dirPref[i] |= (prefOrdering[1 - i][1 - i] & portConstraint[i]) << 24;
        if ((dirPref[i] & 0xf) === 0) dirPref[i] = dirPref[i] << 8;
        if ((dirPref[i] & 0xf00) === 0) dirPref[i] = dirPref[i] & 0xf | dirPref[i] >> 8;
        if ((dirPref[i] & 0xf0000) === 0) dirPref[i] = dirPref[i] & 0xffff | (dirPref[i] & 0xf000000) >> 8;
        dir[i] = dirPref[i] & 0xf;
        if (portConstraint[i] === (0, $cBHcM.DIRECTION_MASK).WEST || portConstraint[i] === (0, $cBHcM.DIRECTION_MASK).NORTH || portConstraint[i] === (0, $cBHcM.DIRECTION_MASK).EAST || portConstraint[i] === (0, $cBHcM.DIRECTION_MASK).SOUTH) dir[i] = portConstraint[i];
    }
    //= =============================================================
    // End of source and target direction determination
    let sourceIndex = dir[0] === (0, $cBHcM.DIRECTION_MASK).EAST ? 3 : dir[0];
    let targetIndex = dir[1] === (0, $cBHcM.DIRECTION_MASK).EAST ? 3 : dir[1];
    sourceIndex -= quad;
    targetIndex -= quad;
    if (sourceIndex < 1) sourceIndex += 4;
    if (targetIndex < 1) targetIndex += 4;
    const routePattern = $ce86dce9f518bafe$var$routePatterns[sourceIndex - 1][targetIndex - 1];
    $ce86dce9f518bafe$var$wayPoints1[0][0] = geo[0][0];
    $ce86dce9f518bafe$var$wayPoints1[0][1] = geo[0][1];
    switch(dir[0]){
        case (0, $cBHcM.DIRECTION_MASK).WEST:
            $ce86dce9f518bafe$var$wayPoints1[0][0] -= sourceBuffer;
            $ce86dce9f518bafe$var$wayPoints1[0][1] += constraint[0][1] * geo[0][3];
            break;
        case (0, $cBHcM.DIRECTION_MASK).SOUTH:
            $ce86dce9f518bafe$var$wayPoints1[0][0] += constraint[0][0] * geo[0][2];
            $ce86dce9f518bafe$var$wayPoints1[0][1] += geo[0][3] + sourceBuffer;
            break;
        case (0, $cBHcM.DIRECTION_MASK).EAST:
            $ce86dce9f518bafe$var$wayPoints1[0][0] += geo[0][2] + sourceBuffer;
            $ce86dce9f518bafe$var$wayPoints1[0][1] += constraint[0][1] * geo[0][3];
            break;
        case (0, $cBHcM.DIRECTION_MASK).NORTH:
            $ce86dce9f518bafe$var$wayPoints1[0][0] += constraint[0][0] * geo[0][2];
            $ce86dce9f518bafe$var$wayPoints1[0][1] -= sourceBuffer;
            break;
    }
    let currentIndex = 0;
    // Orientation, 0 horizontal, 1 vertical
    let lastOrientation = (dir[0] & ((0, $cBHcM.DIRECTION_MASK).EAST | (0, $cBHcM.DIRECTION_MASK).WEST)) > 0 ? 0 : 1;
    const initialOrientation = lastOrientation;
    let currentOrientation = 0;
    for(let i = 0; i < routePattern.length; i += 1){
        const nextDirection = routePattern[i] & 0xf;
        // Rotate the index of this direction by the quad
        // to get the real direction
        let directionIndex = nextDirection === (0, $cBHcM.DIRECTION_MASK).EAST ? 3 : nextDirection;
        directionIndex += quad;
        if (directionIndex > 4) directionIndex -= 4;
        const direction = $ce86dce9f518bafe$var$dirVectors[directionIndex - 1];
        currentOrientation = directionIndex % 2 > 0 ? 0 : 1;
        // Only update the current index if the point moved
        // in the direction of the current segment move,
        // otherwise the same point is moved until there is
        // a segment direction change
        if (currentOrientation !== lastOrientation) {
            currentIndex++;
            // Copy the previous way point into the new one
            // We can't base the new position on index - 1
            // because sometime elbows turn out not to exist,
            // then we'd have to rewind.
            $ce86dce9f518bafe$var$wayPoints1[currentIndex][0] = $ce86dce9f518bafe$var$wayPoints1[currentIndex - 1][0];
            $ce86dce9f518bafe$var$wayPoints1[currentIndex][1] = $ce86dce9f518bafe$var$wayPoints1[currentIndex - 1][1];
        }
        const tar = (routePattern[i] & $ce86dce9f518bafe$var$TARGET_MASK) > 0;
        const sou = (routePattern[i] & $ce86dce9f518bafe$var$SOURCE_MASK) > 0;
        let side = (routePattern[i] & $ce86dce9f518bafe$var$SIDE_MASK) >> 5;
        side <<= quad;
        if (side > 0xf) side >>= 4;
        const center = (routePattern[i] & $ce86dce9f518bafe$var$CENTER_MASK) > 0;
        if ((sou || tar) && side < 9) {
            let limit = 0;
            const souTar = sou ? 0 : 1;
            if (center && currentOrientation === 0) limit = geo[souTar][0] + constraint[souTar][0] * geo[souTar][2];
            else if (center) limit = geo[souTar][1] + constraint[souTar][1] * geo[souTar][3];
            else limit = $ce86dce9f518bafe$var$limits[souTar][side];
            if (currentOrientation === 0) {
                const lastX = $ce86dce9f518bafe$var$wayPoints1[currentIndex][0];
                const deltaX = (limit - lastX) * direction[0];
                if (deltaX > 0) $ce86dce9f518bafe$var$wayPoints1[currentIndex][0] += direction[0] * deltaX;
            } else {
                const lastY = $ce86dce9f518bafe$var$wayPoints1[currentIndex][1];
                const deltaY = (limit - lastY) * direction[1];
                if (deltaY > 0) $ce86dce9f518bafe$var$wayPoints1[currentIndex][1] += direction[1] * deltaY;
            }
        } else if (center) {
            // Which center we're travelling to depend on the current direction
            $ce86dce9f518bafe$var$wayPoints1[currentIndex][0] += direction[0] * Math.abs($ce86dce9f518bafe$var$vertexSeparations[directionIndex] / 2);
            $ce86dce9f518bafe$var$wayPoints1[currentIndex][1] += direction[1] * Math.abs($ce86dce9f518bafe$var$vertexSeparations[directionIndex] / 2);
        }
        if (currentIndex > 0 && $ce86dce9f518bafe$var$wayPoints1[currentIndex][currentOrientation] === $ce86dce9f518bafe$var$wayPoints1[currentIndex - 1][currentOrientation]) currentIndex--;
        else lastOrientation = currentOrientation;
    }
    for(let i = 0; i <= currentIndex; i += 1){
        if (i === currentIndex) {
            // Last point can cause last segment to be in
            // same direction as jetty/approach. If so,
            // check the number of points is consistent
            // with the relative orientation of source and target
            // jx. Same orientation requires an even
            // number of turns (points), different requires
            // odd.
            const targetOrientation = (dir[1] & ((0, $cBHcM.DIRECTION_MASK).EAST | (0, $cBHcM.DIRECTION_MASK).WEST)) > 0 ? 0 : 1;
            const sameOrient = targetOrientation === initialOrientation ? 0 : 1;
            // (currentIndex + 1) % 2 is 0 for even number of points,
            // 1 for odd
            if (sameOrient !== (currentIndex + 1) % 2) break;
        }
        result.push(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(Math.round($ce86dce9f518bafe$var$wayPoints1[i][0] * state.view.scale * 10) / 10, Math.round($ce86dce9f518bafe$var$wayPoints1[i][1] * state.view.scale * 10) / 10));
    }
    // Removes duplicates
    let index = 1;
    while(index < result.length)if (result[index - 1] == null || result[index] == null || result[index - 1].x !== result[index].x || result[index - 1].y !== result[index].y) index++;
    else result.splice(index, 1);
};



const $093725d3137e05e8$export$cec5549c6ac6c73 = (state, source, target, points, result)=>{
    /**
     * Adds all values from source geometry to target.
     * Used to create padding box around cell geometry.
     * @param target
     * @param source
     * @returns
     */ function moveAndExpand(target, source) {
        target.x += source.x || 0;
        target.y += source.y || 0;
        target.width += source.width || 0;
        target.height += source.height || 0;
        return target;
    }
    function snapCoordinateToGrid(value, gridSize) {
        return gridSize * Math.round(value / gridSize);
    }
    function snapPointToGrid(p, gx, gy) {
        p.x = snapCoordinateToGrid(p.x, gx);
        p.y = snapCoordinateToGrid(p.y, gy || gx);
        return p;
    }
    function isPointInRectangle(rect, p) {
        return p.x >= rect.x && p.x <= rect.x + rect.width && p.y >= rect.y && p.y <= rect.y + rect.height;
    }
    function getRectangleCenter(rect) {
        return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(rect.x + rect.width / 2, rect.y + rect.height / 2);
    }
    function getDifferencePoint(p1, p2) {
        return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(p1.x - p2.x, p1.y - p2.y);
    }
    function movePoint(p, moveX, moveY) {
        p.x += moveX || 0;
        p.y += moveY || 0;
        return p;
    }
    function getPointTheta(p1, p2) {
        const p = p2.clone();
        const y = -(p.y - p1.y);
        const x = p.x - p1.x;
        const PRECISION = 10;
        const rad = y.toFixed(PRECISION) == '0' && x.toFixed(PRECISION) == '0' ? 0 : Math.atan2(y, x);
        return 180 * rad / Math.PI;
    }
    function normalizePoint(point) {
        return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(point.x === 0 ? 0 : Math.abs(point.x) / point.x, point.y === 0 ? 0 : Math.abs(point.y) / point.y);
    }
    function getManhattanDistance(p1, p2) {
        return Math.abs(p2.x - p1.x) + Math.abs(p2.y - p1.y);
    }
    function toPointFromString(pointString) {
        const xy = pointString.split(!pointString.includes('@') ? ' ' : '@');
        return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(Number.parseInt(xy[0], 10), Number.parseInt(xy[1], 10));
    }
    function pointToString(point) {
        return `${point.x}@${point.y}`;
    }
    function getCellAbsoluteBounds(cellState) {
        const graph = cellState.view.graph;
        const cellBounds = graph.getCellBounds(cellState.cell, false, false)?.clone();
        if (!cellBounds) return undefined;
        const view = graph.view;
        const { scale: scale, translate: translate } = view;
        const { x: x, y: y } = translate;
        const round = (v)=>Math.round(v * 10) / 10;
        const res = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(round(cellBounds.x / scale - x), round(cellBounds.y / scale - y), round(cellBounds.width / scale), round(cellBounds.height / scale));
        return res;
    }
    const mStep = (0, $4a16a9e0dce47da6$export$109620daf7751fe0).step;
    const config = {
        // Padding applied on the element bounding boxes
        paddingBox: new (0, $6713282b00eec691$export$2e2bcd8739ae039)(-mStep, -mStep, mStep * 2, mStep * 2),
        // An array of directions to find next points on the route
        directions: [
            {
                offsetX: mStep,
                offsetY: 0,
                cost: mStep,
                angle: normalizeAngle(getPointTheta(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(0, 0), new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(mStep, 0)))
            },
            {
                offsetX: 0,
                offsetY: mStep,
                cost: mStep,
                angle: normalizeAngle(getPointTheta(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(0, 0), new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(0, mStep)))
            },
            {
                offsetX: -mStep,
                offsetY: 0,
                cost: mStep,
                angle: normalizeAngle(getPointTheta(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(0, 0), new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(-mStep, 0)))
            },
            {
                offsetX: 0,
                offsetY: -mStep,
                cost: mStep,
                angle: normalizeAngle(getPointTheta(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(0, 0), new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(0, -mStep)))
            }
        ],
        directionMap: {
            east: {
                x: 1,
                y: 0
            },
            south: {
                x: 0,
                y: 1
            },
            west: {
                x: -1,
                y: 0
            },
            north: {
                x: 0,
                y: -1
            }
        },
        // A penalty received for direction change
        penaltiesGenerator: (angle)=>{
            if (angle == 45 || angle == 90 || angle == 180) return mStep / 2;
            return 0;
        },
        // If a function is provided, it's used to route the link while dragging an end
        // i.e. function(from, to, opts) { return []; }
        draggingRoute: null,
        previousDirAngle: 0
    };
    /**
     * Map of obstacles
     * Helper structure to identify whether a point lies in an obstacle.
     */ class ObstacleMap {
        constructor(opt){
            this.options = opt;
            this.mapGridSize = 100;
            this.map = new Map();
        }
        // Builds a map of all elements for quicker obstacle queries
        // The svg is divided to  cells, where each of them holds an information which
        // elements belong to it. When we query whether a point is in an obstacle we don't need
        // to go through all obstacles, we check only those in a particular cell.
        build(source, target) {
            const graph = source?.view.graph || target?.view.graph;
            if (!graph) return;
            return Array.from(graph.getView().getCellStates()).filter((s)=>s.cell && s.cell.isVertex() && !s.cell.isEdge()).map((s)=>getCellAbsoluteBounds(s)).map((bbox)=>bbox ? moveAndExpand(bbox, this.options.paddingBox) : null).forEach((bbox)=>{
                if (!bbox) return;
                const origin = snapPointToGrid(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(bbox.x, bbox.y), this.mapGridSize);
                const corner = snapPointToGrid(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(bbox.x + bbox.width, bbox.y + bbox.height), this.mapGridSize);
                for(let x = origin.x; x <= corner.x; x += this.mapGridSize)for(let y = origin.y; y <= corner.y; y += this.mapGridSize){
                    const gridKey = x + '@' + y;
                    const rectArr = this.map.get(gridKey) || [];
                    if (!this.map.has(gridKey)) this.map.set(gridKey, rectArr);
                    rectArr.push(bbox);
                }
            });
        }
        isPointAccessible(point) {
            const mapKey = pointToString(snapPointToGrid(point.clone(), this.mapGridSize));
            const obstacles = this.map.get(mapKey);
            if (obstacles) return obstacles.every((obstacle)=>!isPointInRectangle(obstacle, point));
            return true;
        }
    }
    class SortedSet {
        constructor(){
            this.items = [];
            this.hash = new Map();
        }
        add(key, value) {
            const hashItem = this.hash.get(key);
            if (hashItem) {
                hashItem.value = value;
                this.items.splice(this.items.indexOf(key), 1);
            } else this.hash.set(key, {
                value: value,
                open: true
            });
            this.items.push(key);
            this.items.sort((i1, i2)=>{
                const hashItem1 = this.hash.get(i1);
                const hashItem2 = this.hash.get(i2);
                if (!hashItem1 || !hashItem2) return 0;
                return hashItem1.value - hashItem2.value;
            });
        }
        remove(key) {
            const hashItem = this.hash.get(key);
            if (hashItem) hashItem.open = false;
        }
        isOpen(key) {
            const hashItem = this.hash.get(key);
            return hashItem && hashItem.open == true;
        }
        isClose(key) {
            const hashItem = this.hash.get(key);
            return hashItem && hashItem.open == false;
        }
        isEmpty() {
            return this.items.length == 0;
        }
        pop() {
            const key = this.items.shift();
            if (key) this.remove(key);
            return key;
        }
    }
    function reconstructRoute(parents, endPoint, startCenter, endCenter) {
        const route = [];
        let previousDirection = normalizePoint(getDifferencePoint(endCenter, endPoint));
        let current = endPoint;
        let parent;
        while(parents[pointToString(current)]){
            parent = parents[pointToString(current)];
            if (!parent) continue;
            const direction = normalizePoint(getDifferencePoint(current, parent));
            // Add point in when direction change
            if (!direction.equals(previousDirection)) {
                route.unshift(current);
                previousDirection = direction;
            }
            current = parent;
        }
        const startDirection = normalizePoint(getDifferencePoint(current, startCenter));
        if (!startDirection.equals(previousDirection)) route.unshift(current);
        return route;
    }
    function getRectPoints(bbox, directions, opt) {
        const step = (0, $4a16a9e0dce47da6$export$109620daf7751fe0).step;
        const center = getRectangleCenter(bbox);
        const res = [];
        for (const direction of directions){
            const directionPoint = opt.directionMap[direction];
            const x = directionPoint.x * bbox.width / 2;
            const y = directionPoint.y * bbox.height / 2;
            const point = movePoint(center.clone(), x, y);
            if (isPointInRectangle(bbox, point)) movePoint(point, directionPoint.x * step, directionPoint.y * step);
            res.push(snapPointToGrid(point, step));
        }
        return res;
    }
    function normalizeAngle(angle) {
        return angle % 360 + (angle < 0 ? 360 : 0);
    }
    function getDirectionAngle(start, end, directionLength) {
        const q = 360 / directionLength;
        return Math.floor(normalizeAngle(getPointTheta(start, end) + q / 2) / q) * q;
    }
    function getDirectionChange(angle1, angle2) {
        const dirChange = Math.abs(angle1 - angle2);
        return dirChange > 180 ? 360 - dirChange : dirChange;
    }
    function estimateCost(from, endPoints) {
        let min = Infinity;
        for(let i = 0, len = endPoints.length; i < len; i++){
            const cost = getManhattanDistance(from, endPoints[i]);
            if (cost < min) min = cost;
        }
        return min;
    }
    function alignPointToCell(point, edgeState, cellState, isSourceCell) {
        const cellBounds = getCellAbsoluteBounds(cellState);
        const y = isSourceCell ? edgeState.style.exitY : edgeState.style.entryY;
        const onlyHorizontalDirections = isSourceCell ? (0, $4a16a9e0dce47da6$export$109620daf7751fe0).startDirections.every((d)=>d != 'north' && d != 'south') : (0, $4a16a9e0dce47da6$export$109620daf7751fe0).endDirections.every((d)=>d != 'north' && d != 'south');
        if (y != undefined && onlyHorizontalDirections) {
            const cellHeight = cellBounds?.height || 0;
            point.y = cellBounds?.y != undefined ? cellBounds?.y + cellHeight * y : point.y - cellHeight / 2 + cellHeight * y;
        }
        const x = isSourceCell ? edgeState.style.exitX : edgeState.style.entryX;
        const onlyVerticalDirections = isSourceCell ? (0, $4a16a9e0dce47da6$export$109620daf7751fe0).startDirections.every((d)=>d != 'west' && d != 'east') : (0, $4a16a9e0dce47da6$export$109620daf7751fe0).endDirections.every((d)=>d != 'west' && d != 'east');
        if (x != undefined && onlyVerticalDirections) {
            const cellWidth = cellBounds?.width || 0;
            point.x = cellBounds?.x != undefined ? cellBounds?.x + cellWidth * x : point.x - cellWidth / 2 + cellWidth * (x || 0);
        }
    }
    function findRoute(start, end, obstacleMap, opt) {
        // Calculate start points and end points
        const step = (0, $4a16a9e0dce47da6$export$109620daf7751fe0).step;
        const startPoints = getRectPoints(start, (0, $4a16a9e0dce47da6$export$109620daf7751fe0).startDirections, opt).filter((p)=>obstacleMap.isPointAccessible(p));
        const startCenter = snapPointToGrid(getRectangleCenter(start), step);
        const endPoints = getRectPoints(end, (0, $4a16a9e0dce47da6$export$109620daf7751fe0).endDirections, opt).filter((p)=>obstacleMap.isPointAccessible(p));
        const endCenter = snapPointToGrid(getRectangleCenter(end), step);
        if (startPoints.length > 0 && endPoints.length > 0) {
            // The set of possible  points to be evaluated, initially containing the start points.
            const openSet = new SortedSet();
            // Keeps predecessor of given element.
            const parents = {};
            // Cost from start to a point along best known path.
            const costs = {};
            startPoints.forEach((p)=>{
                const key = pointToString(p);
                openSet.add(key, estimateCost(p, endPoints));
                costs[key] = 0;
            });
            let loopsRemain = (0, $4a16a9e0dce47da6$export$109620daf7751fe0).maxLoops;
            const endPointsKeys = endPoints.map((p)=>pointToString(p));
            let currentDirectionAngle;
            let previousDirectionAngle;
            // Main route finding loop
            while(!openSet.isEmpty() && loopsRemain > 0){
                const currentKey = openSet.pop();
                if (currentKey == undefined) continue;
                const currentPoint = toPointFromString(currentKey);
                const currentCost = costs[currentKey];
                previousDirectionAngle = currentDirectionAngle;
                currentDirectionAngle = parents[currentKey] ? getDirectionAngle(parents[currentKey], currentPoint, opt.directions.length) : opt.previousDirAngle != 0 ? opt.previousDirAngle : getDirectionAngle(startCenter, currentPoint, opt.directions.length);
                // if get the endpoint
                if (endPointsKeys.includes(currentKey)) {
                    // stop route to enter the end point in opposite direction.
                    const directionChangedAngle = getDirectionChange(currentDirectionAngle, getDirectionAngle(currentPoint, endCenter, opt.directions.length));
                    if (currentPoint.equals(endCenter) || directionChangedAngle < 180) {
                        opt.previousDirAngle = currentDirectionAngle;
                        return reconstructRoute(parents, currentPoint, startCenter, endCenter);
                    }
                }
                // Go over all possible directions and find neighbors.
                for(let i = 0; i < opt.directions.length; i++){
                    const direction = opt.directions[i];
                    const directionChangedAngle = getDirectionChange(currentDirectionAngle, direction.angle);
                    if (previousDirectionAngle && directionChangedAngle > (0, $4a16a9e0dce47da6$export$109620daf7751fe0).maxAllowedDirectionChange) continue;
                    const neighborPoint = movePoint(currentPoint.clone(), direction.offsetX, direction.offsetY);
                    const neighborKey = pointToString(neighborPoint);
                    if (openSet.isClose(neighborKey) || !obstacleMap.isPointAccessible(neighborPoint)) continue;
                    const costFromStart = currentCost + direction.cost + opt.penaltiesGenerator(directionChangedAngle);
                    if (!openSet.isOpen(neighborKey) || costFromStart < costs[neighborKey]) {
                        // Neighbor point has not been processed yet or the cost of the path
                        // from start is lesser than previously calcluated.
                        parents[neighborKey] = currentPoint;
                        costs[neighborKey] = costFromStart;
                        openSet.add(neighborKey, costFromStart + estimateCost(neighborPoint, endPoints));
                    }
                }
                loopsRemain--;
            }
            return null;
        }
        return null;
    }
    function router(state, source, target, points, result, opt) {
        // If edge is dragged after calculation, points will be filled, so fallback to SegmentConnector
        if (points != null && points.length > 0 || source == null || target == null) {
            (0, $7c381263c777720e$export$4ee6d6acbd0456a7)(state, source, target, points, result);
            return;
        }
        let sourceBBox = getCellAbsoluteBounds(source);
        sourceBBox = sourceBBox ? moveAndExpand(sourceBBox, opt.paddingBox) : undefined;
        let targetBBox = getCellAbsoluteBounds(target);
        targetBBox = targetBBox ? moveAndExpand(targetBBox, opt.paddingBox) : undefined;
        const obstacleMap = new ObstacleMap(opt);
        obstacleMap.build(source, target);
        if (!sourceBBox || !targetBBox) // Fallback to OrthogonalConnector
        return (0, $ce86dce9f518bafe$export$f8421c630280c361)(state, source, target, points, result);
        const routePoints = findRoute(sourceBBox, targetBBox, obstacleMap, opt);
        if (routePoints == null || routePoints.length == 0) // Fallback to OrthogonalConnector
        return (0, $ce86dce9f518bafe$export$f8421c630280c361)(state, source, target, points, result);
        if (state.style) {
            if (state.visibleSourceState && routePoints.length > 0) // If there are at least one point, align it to source cell
            alignPointToCell(routePoints[0], state, state.visibleSourceState, true);
            if (state.visibleTargetState && routePoints.length > 1) // If there are more than one point, align last point to target cell
            alignPointToCell(routePoints[routePoints.length - 1], state, state.visibleTargetState, false);
        }
        // Scaling and translating result points
        const scale = state.view.scale;
        routePoints.forEach((pt)=>result.push(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(Math.round((pt.x + state.view.translate.x) * scale * 10) / 10, Math.round((pt.y + state.view.translate.y) * scale * 10) / 10)));
    }
    router(state, source, target, points, result, config);
};








/*
Copyright 2025-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
var $h5l15 = parcelRequire("h5l15");
/*
Copyright 2025-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /**
 * Base implementation for all registries storing "style" configuration.
 * @private
 * @since 0.20.0
 */ class $f195b8ee628b1fc3$export$1ae599b19ef421f5 {
    constructor(){
        this.values = new Map();
    }
    add(name, value) {
        this.values.set(name, value);
    }
    get(name) {
        return this.values.get(name) ?? null;
    }
    getName(value) {
        // Currently, the code performs a linear search through all entries.
        // This implementation is straightforward and works well for small registries, but could become a performance bottleneck if the registry grows large.
        // For the current use case of style registries, this is likely acceptable since the number of registered styles is typically small.
        // If performance becomes an issue, consider maintaining a reverse lookup map.
        for (const [name, style] of this.values.entries()){
            if (style === value) return name;
        }
        return null;
    }
    clear() {
        this.values.clear();
    }
}


/**
 * @private
 */ class $130af394a0fcdee4$var$EdgeStyleRegistryImpl extends (0, $f195b8ee628b1fc3$export$1ae599b19ef421f5) {
    constructor(){
        super(...arguments);
        this.handlerMapping = new Map();
        this.orthogonalStates = new Map();
        this.intermediateHandlesStates = new Map();
    }
    add(name, edgeStyle, metaData) {
        super.add(name, edgeStyle);
        metaData?.handlerKind && this.handlerMapping.set(edgeStyle, metaData.handlerKind);
        !(0, $h5l15.isNullish)(metaData?.isOrthogonal) && this.orthogonalStates.set(edgeStyle, metaData.isOrthogonal);
        !(0, $h5l15.isNullish)(metaData?.allowIntermediateHandles) && this.intermediateHandlesStates.set(edgeStyle, metaData.allowIntermediateHandles);
    }
    isOrthogonal(edgeStyle) {
        return this.orthogonalStates.get(edgeStyle) ?? false;
    }
    getHandlerKind(edgeStyle) {
        return this.handlerMapping.get(edgeStyle) ?? 'default';
    }
    allowsIntermediateHandles(edgeStyle) {
        return this.intermediateHandlesStates.get(edgeStyle) ?? true;
    }
    clear() {
        super.clear();
        this.handlerMapping.clear();
        this.orthogonalStates.clear();
        this.intermediateHandlesStates.clear();
    }
}
const $130af394a0fcdee4$export$28d1530539966ca9 = new $130af394a0fcdee4$var$EdgeStyleRegistryImpl();


/*
Copyright 2024-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
var $h5l15 = parcelRequire("h5l15");
/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 


var $4vC7I = parcelRequire("4vC7I");





/*
Copyright 2022-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
const $bb684498f1d5d11b$export$4a02d4fd1f3ebe97 = (edges, terminal, includeSources = true, includeTargets = true)=>{
    return edges.reduce((terminals, edge)=>{
        const source = edge.getTerminal(true);
        const target = edge.getTerminal(false);
        // Checks if the terminal is the source of the edge and if the target should be stored in the result
        if (source === terminal && target != null && target !== terminal && includeTargets) terminals.push(target);
        else if (target === terminal && source != null && source !== terminal && includeSources) terminals.push(source);
        return terminals;
    }, []);
};
const $bb684498f1d5d11b$export$4552b09cfa920aec = (cells)=>{
    const coveredEntries = new Map();
    const tmp = [];
    for(let i = 0; i < cells.length; i += 1)coveredEntries.set(cells[i], true);
    for(let i = 0; i < cells.length; i += 1){
        const cell = cells[i];
        let topmost = true;
        let parent = cell.getParent();
        while(parent != null){
            if (coveredEntries.get(parent)) {
                topmost = false;
                break;
            }
            parent = parent.getParent();
        }
        if (topmost) tmp.push(cell);
    }
    return tmp;
};
const $bb684498f1d5d11b$export$85488b7eb1e4976f = (cells)=>{
    const parents = [];
    const coveredParents = new Map();
    for (const cell of cells){
        const parent = cell.getParent();
        if (parent && !coveredParents.get(parent)) {
            coveredParents.set(parent, true);
            parents.push(parent);
        }
    }
    return parents;
};
const $bb684498f1d5d11b$export$506365c444c42ce9 = (cell = null, includeChildren = true)=>{
    if (!cell) return null;
    return $bb684498f1d5d11b$export$f04bfe3efd32c2f7([
        cell
    ], includeChildren)[0];
};
const $bb684498f1d5d11b$export$f04bfe3efd32c2f7 = (cells, includeChildren = true, mapping = {})=>{
    const clones = [];
    for (const cell of cells)clones.push($bb684498f1d5d11b$var$cloneCellImpl(cell, mapping, includeChildren));
    for(let i = 0; i < clones.length; i += 1)if (clones[i] != null) $bb684498f1d5d11b$var$restoreClone(clones[i], cells[i], mapping);
    return clones;
};
/**
 * Inner helper method for cloning cells recursively.
 *
 * @private
 */ const $bb684498f1d5d11b$var$cloneCellImpl = (cell, mapping = {}, includeChildren = false)=>{
    const identity = (0, $92bf72f6edcd79a5$export$2e2bcd8739ae039).get(cell);
    let clone = mapping ? mapping[identity] : null;
    if (clone == null) {
        clone = cell.clone();
        mapping[identity] = clone;
        if (includeChildren) {
            const childCount = cell.getChildCount();
            for(let i = 0; i < childCount; i += 1){
                const cloneChild = $bb684498f1d5d11b$var$cloneCellImpl(cell.getChildAt(i), mapping, true);
                clone.insert(cloneChild);
            }
        }
    }
    return clone;
};
/**
 * Inner helper method for restoring the connections in a network of cloned cells.
 *
 * @private
 */ const $bb684498f1d5d11b$var$restoreClone = (clone, cell, mapping)=>{
    const source = cell.getTerminal(true);
    if (source != null) {
        const tmp = mapping[(0, $92bf72f6edcd79a5$export$2e2bcd8739ae039).get(source)];
        if (tmp != null) tmp.insertEdge(clone, true);
    }
    const target = cell.getTerminal(false);
    if (target != null) {
        const tmp = mapping[(0, $92bf72f6edcd79a5$export$2e2bcd8739ae039).get(target)];
        if (tmp != null) tmp.insertEdge(clone, false);
    }
    const childCount = clone.getChildCount();
    for(let i = 0; i < childCount; i += 1)$bb684498f1d5d11b$var$restoreClone(clone.getChildAt(i), cell.getChildAt(i), mapping);
};


const $dd22e0d3739891de$export$14c400dc30c508e6 = {
    cellsResizable: true,
    cellsBendable: true,
    cellsSelectable: true,
    cellsDisconnectable: true,
    autoSizeCells: false,
    autoSizeCellsOnAdd: false,
    cellsLocked: false,
    cellsCloneable: true,
    cellsDeletable: true,
    cellsMovable: true,
    extendParents: true,
    extendParentsOnAdd: true,
    extendParentsOnMove: false,
    getBoundingBox (cells) {
        let result = null;
        if (cells.length > 0) {
            for (const cell of cells)if (cell.isVertex() || cell.isEdge()) {
                const bbox = this.getView().getBoundingBox(this.getView().getState(cell), true);
                if (bbox) {
                    if (!result) result = (0, $2997c239141ea844$export$2e2bcd8739ae039).fromRectangle(bbox);
                    else result.add(bbox);
                }
            }
        }
        return result;
    },
    removeStateForCell (cell) {
        for (const child of cell.getChildren())this.removeStateForCell(child);
        this.getView().invalidate(cell, false, true);
        this.getView().removeState(cell);
    },
    /*****************************************************************************
     * Group: Cell styles
     *****************************************************************************/ getCurrentCellStyle (cell, ignoreState = false) {
        const state = ignoreState ? null : this.getView().getState(cell);
        return state ? state.style : this.getCellStyle(cell);
    },
    getCellStyle (cell) {
        const cellStyle = cell.getStyle();
        const stylesheet = this.getStylesheet();
        // Gets the default style for the cell
        const defaultStyle = cell.isEdge() ? stylesheet.getDefaultEdgeStyle() : stylesheet.getDefaultVertexStyle();
        // Resolves the stylename using the above as the default
        const style = this.postProcessCellStyle(stylesheet.getCellStyle(cellStyle, defaultStyle ?? {}));
        return style;
    },
    postProcessCellStyle (style) {
        if (!style.image) return style;
        const key = style.image;
        let image = this.getPlugin('image-bundle')?.getImageFromBundles(key) ?? null;
        if (image) style.image = image;
        else image = key;
        // Converts short data uris to normal data uris
        if (image && image.substring(0, 11) === 'data:image/') {
            if (image.substring(0, 20) === 'data:image/svg+xml,<') // Required for FF and IE11
            image = image.substring(0, 19) + encodeURIComponent(image.substring(19));
            else if (image.substring(0, 22) !== 'data:image/svg+xml,%3C') {
                const comma = image.indexOf(',');
                // Adds base64 encoding prefix if needed
                if (comma > 0 && image.substring(comma - 7, comma + 1) !== ';base64,') image = `${image.substring(0, comma)};base64,${image.substring(comma + 1)}`;
            }
            style.image = image;
        }
        return style;
    },
    setCellStyle (style, cells) {
        cells = cells ?? this.getSelectionCells();
        this.batchUpdate(()=>{
            for (const cell of cells)this.getDataModel().setStyle(cell, style);
        });
    },
    toggleCellStyle (key, defaultValue = false, cell) {
        cell = cell ?? this.getSelectionCell();
        return this.toggleCellStyles(key, defaultValue, [
            cell
        ]);
    },
    toggleCellStyles (key, defaultValue = false, cells) {
        let value = false;
        cells = cells ?? this.getSelectionCells();
        if (cells.length > 0) {
            const style = this.getCurrentCellStyle(cells[0]);
            value = !(style[key] ?? defaultValue);
            this.setCellStyles(key, value, cells);
        }
        return value;
    },
    setCellStyles (key, value, cells) {
        cells = cells ?? this.getSelectionCells();
        (0, $b55d6ca3b42398e2$export$b2bb58a38ab5c0a2)(this.getDataModel(), cells, key, value);
    },
    toggleCellStyleFlags (key, flag, cells) {
        cells = cells ?? this.getSelectionCells();
        this.setCellStyleFlags(key, flag, null, cells);
    },
    setCellStyleFlags (key, flag, value = null, cells) {
        cells = cells ?? this.getSelectionCells();
        if (cells.length > 0) {
            if (value === null) {
                const style = this.getCurrentCellStyle(cells[0]);
                const current = style[key] || 0;
                value = !((current & flag) === flag);
            }
            (0, $b55d6ca3b42398e2$export$135e2decb04b2f7d)(this.getDataModel(), cells, key, flag, value);
        }
    },
    /*****************************************************************************
     * Group: Cell alignment and orientation
     *****************************************************************************/ alignCells (align, cells, param = null) {
        cells = cells ?? this.getSelectionCells();
        if (cells.length > 1) {
            // Finds the required coordinate for the alignment
            if (param === null) for (const cell of cells){
                const state = this.getView().getState(cell);
                if (state && !cell.isEdge()) {
                    if (param === null) switch(align){
                        case 'center':
                            param = state.x + state.width / 2;
                            break;
                        case 'right':
                            param = state.x + state.width;
                            break;
                        case 'top':
                            param = state.y;
                            break;
                        case 'middle':
                            param = state.y + state.height / 2;
                            break;
                        case 'bottom':
                            param = state.y + state.height;
                            break;
                        default:
                            param = state.x;
                            break;
                    }
                    else switch(align){
                        case 'right':
                            param = Math.max(param, state.x + state.width);
                            break;
                        case 'top':
                            param = Math.min(param, state.y);
                            break;
                        case 'bottom':
                            param = Math.max(param, state.y + state.height);
                            break;
                        default:
                            param = Math.min(param, state.x);
                    }
                }
            }
            // Aligns the cells to the coordinate
            if (param !== null) {
                const s = this.getView().scale;
                this.batchUpdate(()=>{
                    const p = param;
                    for (const cell of cells){
                        const state = this.getView().getState(cell);
                        if (state != null) {
                            let geo = cell.getGeometry();
                            if (geo != null && !cell.isEdge()) {
                                geo = geo.clone();
                                switch(align){
                                    case 'center':
                                        geo.x += (p - state.x - state.width / 2) / s;
                                        break;
                                    case 'right':
                                        geo.x += (p - state.x - state.width) / s;
                                        break;
                                    case 'top':
                                        geo.y += (p - state.y) / s;
                                        break;
                                    case 'middle':
                                        geo.y += (p - state.y - state.height / 2) / s;
                                        break;
                                    case 'bottom':
                                        geo.y += (p - state.y - state.height) / s;
                                        break;
                                    default:
                                        geo.x += (p - state.x) / s;
                                }
                                this.resizeCell(cell, geo);
                            }
                        }
                    }
                    this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).ALIGN_CELLS, {
                        align: align,
                        cells: cells
                    }));
                });
            }
        }
        return cells;
    },
    /*****************************************************************************
     * Group: Cell cloning, insertion and removal
     *****************************************************************************/ cloneCell (cell, allowInvalidEdges = false, mapping = {}, keepPosition = false) {
        return this.cloneCells([
            cell
        ], allowInvalidEdges, mapping, keepPosition)[0];
    },
    cloneCells (cells, allowInvalidEdges = true, mapping = {}, keepPosition = false) {
        let clones;
        // Creates a map for fast lookups
        const dict = new Map();
        const tmp = [];
        for (const cell of cells){
            dict.set(cell, true);
            tmp.push(cell);
        }
        if (tmp.length > 0) {
            const { scale: scale } = this.getView();
            const trans = this.getView().translate;
            const out = [];
            clones = (0, $bb684498f1d5d11b$export$f04bfe3efd32c2f7)(cells, true, mapping);
            for(let i = 0; i < cells.length; i += 1){
                const cell = cells[i];
                const clone = clones[i];
                if (!allowInvalidEdges && clone.isEdge() && this.getEdgeValidationError(clone, clone.getTerminal(true), clone.getTerminal(false)) !== null) ;
                else {
                    out.push(clone);
                    const g = clone.getGeometry();
                    if (g) {
                        const state = this.getView().getState(cell);
                        const parent = cell.getParent();
                        const pstate = parent ? this.getView().getState(parent) : null;
                        if (state && pstate) {
                            const dx = keepPosition ? 0 : pstate.origin.x;
                            const dy = keepPosition ? 0 : pstate.origin.y;
                            if (clone.isEdge()) {
                                const pts = state.absolutePoints;
                                // Checks if the source is cloned or sets the terminal point
                                let src = cell.getTerminal(true);
                                while(src && !dict.get(src))src = src.getParent();
                                if (!src && pts[0]) g.setTerminalPoint(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(pts[0].x / scale - trans.x, pts[0].y / scale - trans.y), true);
                                // Checks if the target is cloned or sets the terminal point
                                let trg = cell.getTerminal(false);
                                while(trg && !dict.get(trg))trg = trg.getParent();
                                const n = pts.length - 1;
                                const p = pts[n];
                                if (!trg && p) g.setTerminalPoint(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(p.x / scale - trans.x, p.y / scale - trans.y), false);
                                // Translates the control points
                                const { points: points } = g;
                                if (points) for (const point of points){
                                    point.x += dx;
                                    point.y += dy;
                                }
                            } else g.translate(dx, dy);
                        }
                    }
                }
            }
            clones = out;
        } else clones = [];
        return clones;
    },
    addCell (cell, parent = null, index = null, source = null, target = null) {
        return this.addCells([
            cell
        ], parent, index, source, target)[0];
    },
    addCells (cells, parent = null, index = null, source = null, target = null, absolute = false) {
        const p = parent ?? this.getDefaultParent();
        const i = index ?? p.getChildCount();
        this.batchUpdate(()=>{
            this.cellsAdded(cells, p, i, source, target, absolute, true);
            this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).ADD_CELLS, {
                cells: cells,
                p: p,
                i: i,
                source: source,
                target: target
            }));
        });
        return cells;
    },
    cellsAdded (cells, parent, index, source = null, target = null, absolute = false, constrain = true, extend = true) {
        this.batchUpdate(()=>{
            const parentState = absolute ? this.getView().getState(parent) : null;
            const o1 = parentState ? parentState.origin : null;
            const zero = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(0, 0);
            cells.forEach((cell, i)=>{
                /* Can cells include null values?
                if (cell == null) {
                  index--;
                } else {
                */ const previous = cell.getParent();
                // Keeps the cell at its absolute location
                if (o1 && cell !== parent && parent !== previous) {
                    const oldState = previous ? this.getView().getState(previous) : null;
                    const o2 = oldState ? oldState.origin : zero;
                    let geo = cell.getGeometry();
                    if (geo) {
                        const dx = o2.x - o1.x;
                        const dy = o2.y - o1.y;
                        // FIXME: Cells should always be inserted first before any other edit
                        // to avoid forward references in sessions.
                        geo = geo.clone();
                        geo.translate(dx, dy);
                        if (!geo.relative && cell.isVertex() && !this.isAllowNegativeCoordinates()) {
                            geo.x = Math.max(0, geo.x);
                            geo.y = Math.max(0, geo.y);
                        }
                        this.getDataModel().setGeometry(cell, geo);
                    }
                }
                // Decrements all following indices
                // if cell is already in parent
                if (parent === previous && index + i > parent.getChildCount()) index--;
                this.getDataModel().add(parent, cell, index + i);
                if (this.autoSizeCellsOnAdd) this.autoSizeCell(cell, true);
                // Extends the parent or constrains the child
                if (extend && this.isExtendParentsOnAdd(cell) && this.isExtendParent(cell)) this.extendParent(cell);
                // Additionally constrains the child after extending the parent
                if (constrain) this.constrainChild(cell);
                // Sets the source terminal
                if (source) this.cellConnected(cell, source, true);
                // Sets the target terminal
                if (target) this.cellConnected(cell, target, false);
            /*}*/ });
            this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CELLS_ADDED, {
                cells: cells,
                parent: parent,
                index: index,
                source: source,
                target: target,
                absolute: absolute
            }));
        });
    },
    autoSizeCell (cell, recurse = true) {
        if (recurse) for (const child of cell.getChildren())this.autoSizeCell(child);
        if (cell.isVertex() && this.isAutoSizeCell(cell)) this.updateCellSize(cell);
    },
    removeCells (cells = null, includeEdges = true) {
        if (!cells) cells = this.getDeletableCells(this.getSelectionCells());
        // Adds all edges to the cells
        if (includeEdges) // FIXME: Remove duplicate cells in result or do not add if
        // in cells or descendant of cells
        cells = this.getDeletableCells(this.addAllEdges(cells));
        else {
            cells = cells.slice();
            // Removes edges that are currently not
            // visible as those cannot be updated
            const edges = this.getDeletableCells(this.getAllEdges(cells));
            const dict = new Map();
            for (const cell of cells)dict.set(cell, true);
            for (const edge of edges)if (!this.getView().getState(edge) && !dict.get(edge)) {
                dict.set(edge, true);
                cells.push(edge);
            }
        }
        this.batchUpdate(()=>{
            this.cellsRemoved(cells);
            this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).REMOVE_CELLS, {
                cells: cells,
                includeEdges: includeEdges
            }));
        });
        return cells ?? [];
    },
    cellsRemoved (cells) {
        if (cells.length > 0) {
            const { scale: scale } = this.getView();
            const tr = this.getView().translate;
            this.batchUpdate(()=>{
                // Creates hashtable for faster lookup
                const dict = new Map();
                for (const cell of cells)dict.set(cell, true);
                for (const cell of cells){
                    // Disconnects edges which are not being removed
                    const edges = this.getAllEdges([
                        cell
                    ]);
                    const disconnectTerminal = (edge, source)=>{
                        let geo = edge.getGeometry();
                        if (geo) {
                            // Checks if terminal is being removed
                            const terminal = edge.getTerminal(source);
                            let connected = false;
                            let tmp = terminal;
                            while(tmp){
                                if (cell === tmp) {
                                    connected = true;
                                    break;
                                }
                                tmp = tmp.getParent();
                            }
                            if (connected) {
                                geo = geo.clone();
                                const state = this.getView().getState(edge);
                                if (state) {
                                    const pts = state.absolutePoints;
                                    const n = source ? 0 : pts.length - 1;
                                    const p = pts[n];
                                    geo.setTerminalPoint(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(p.x / scale - tr.x - state.origin.x, p.y / scale - tr.y - state.origin.y), source);
                                } else if (terminal) {
                                    // Fallback to center of terminal if routing
                                    // points are not available to add new point
                                    // KNOWN: Should recurse to find parent offset
                                    // of edge for nested groups but invisible edges
                                    // should be removed in removeCells step
                                    const tstate = this.getView().getState(terminal);
                                    if (tstate) geo.setTerminalPoint(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(tstate.getCenterX() / scale - tr.x, tstate.getCenterY() / scale - tr.y), source);
                                }
                                this.getDataModel().setGeometry(edge, geo);
                                this.getDataModel().setTerminal(edge, null, source);
                            }
                        }
                    };
                    for (const edge of edges)if (!dict.get(edge)) {
                        dict.set(edge, true);
                        disconnectTerminal(edge, true);
                        disconnectTerminal(edge, false);
                    }
                    this.getDataModel().remove(cell);
                }
                this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CELLS_REMOVED, {
                    cells: cells
                }));
            });
        }
    },
    /*****************************************************************************
     * Group: Cell visibility
     *****************************************************************************/ toggleCells (show = false, cells, includeEdges = true) {
        cells = cells ?? this.getSelectionCells();
        // Adds all connected edges recursively
        if (includeEdges) cells = this.addAllEdges(cells);
        this.batchUpdate(()=>{
            this.cellsToggled(cells, show);
            this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).TOGGLE_CELLS, {
                show: show,
                cells: cells,
                includeEdges: includeEdges
            }));
        });
        return cells;
    },
    cellsToggled (cells, show = false) {
        if (cells.length > 0) this.batchUpdate(()=>{
            for (const cell of cells)this.getDataModel().setVisible(cell, show);
        });
    },
    /*****************************************************************************
     * Group: Cell sizing
     *****************************************************************************/ updateCellSize (cell, ignoreChildren = false) {
        this.batchUpdate(()=>{
            this.cellSizeUpdated(cell, ignoreChildren);
            this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).UPDATE_CELL_SIZE, {
                cell: cell,
                ignoreChildren: ignoreChildren
            }));
        });
        return cell;
    },
    cellSizeUpdated (cell, ignoreChildren = false) {
        this.batchUpdate(()=>{
            const size = this.getPreferredSizeForCell(cell);
            let geo = cell.getGeometry();
            if (size && geo) {
                const collapsed = cell.isCollapsed();
                geo = geo.clone();
                if (this.isSwimlane(cell)) {
                    const style = this.getCellStyle(cell);
                    const cellStyle = cell.getStyle();
                    if (style.horizontal ?? true) {
                        cellStyle.startSize = size.height + 8;
                        if (collapsed) geo.height = size.height + 8;
                        geo.width = size.width;
                    } else {
                        cellStyle.startSize = size.width + 8;
                        if (collapsed) geo.width = size.width + 8;
                        geo.height = size.height;
                    }
                    this.getDataModel().setStyle(cell, cellStyle);
                } else {
                    const state = this.getView().createState(cell);
                    const align = state.style.align ?? 'center';
                    if (align === 'right') geo.x += geo.width - size.width;
                    else if (align === 'center') geo.x += Math.round((geo.width - size.width) / 2);
                    const valign = state.getVerticalAlign();
                    if (valign === 'bottom') geo.y += geo.height - size.height;
                    else if (valign === 'middle') geo.y += Math.round((geo.height - size.height) / 2);
                    geo.width = size.width;
                    geo.height = size.height;
                }
                if (!ignoreChildren && !collapsed) {
                    const bounds = this.getView().getBounds(cell.getChildren());
                    if (bounds != null) {
                        const tr = this.getView().translate;
                        const { scale: scale } = this.getView();
                        const width = (bounds.x + bounds.width) / scale - geo.x - tr.x;
                        const height = (bounds.y + bounds.height) / scale - geo.y - tr.y;
                        geo.width = Math.max(geo.width, width);
                        geo.height = Math.max(geo.height, height);
                    }
                }
                this.cellsResized([
                    cell
                ], [
                    geo
                ], false);
            }
        });
    },
    getPreferredSizeForCell (cell, textWidth = null) {
        let result = null;
        const state = this.getView().createState(cell);
        const { style: style } = state;
        if (!cell.isEdge()) {
            const fontSize = style.fontSize || (0, $4vC7I.StyleDefaultsConfig).fontSize;
            let dx = 0;
            let dy = 0;
            // Adds dimension of image if shape is a label
            if (state.getImageSrc() || style.image) {
                if (style.shape === 'label') {
                    if (style.verticalAlign === 'middle') dx += style.imageWidth || (0, $4vC7I.StyleDefaultsConfig).imageSize;
                    if (style.align !== 'center') dy += style.imageHeight || (0, $4vC7I.StyleDefaultsConfig).imageSize;
                }
            }
            // Adds spacings
            dx += 2 * (style.spacing || 0);
            dx += style.spacingLeft || 0;
            dx += style.spacingRight || 0;
            dy += 2 * (style.spacing || 0);
            dy += style.spacingTop || 0;
            dy += style.spacingBottom || 0;
            // Add spacing for collapse/expand icon
            // LATER: Check alignment and use constants
            // for image spacing
            const image = this.getFoldingImage(state);
            if (image) dx += image.width + 8;
            // Adds space for label
            let value = this.getCellRenderer().getLabelValue(state);
            if (value && value.length > 0) {
                if (!this.isHtmlLabel(state.cell)) value = (0, $6bb3a85a9cf63e97$export$324699496a105db8)(value, false);
                value = value.replace(/\n/g, '<br>');
                const size = (0, $b55d6ca3b42398e2$export$dc54ded44a3ca0f2)(value, fontSize, style.fontFamily, textWidth, style.fontStyle);
                let width = size.width + dx;
                let height = size.height + dy;
                if (!(style.horizontal ?? true)) {
                    const tmp = height;
                    height = width;
                    width = tmp;
                }
                if (this.isGridEnabled()) {
                    width = this.snap(width + this.getGridSize() / 2);
                    height = this.snap(height + this.getGridSize() / 2);
                }
                result = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(0, 0, width, height);
            } else {
                const gs2 = 4 * this.getGridSize();
                result = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(0, 0, gs2, gs2);
            }
        }
        return result;
    },
    resizeCell (cell, bounds, recurse = false) {
        return this.resizeCells([
            cell
        ], [
            bounds
        ], recurse)[0];
    },
    resizeCells (cells, bounds, recurse) {
        recurse = recurse ?? this.isRecursiveResize();
        this.batchUpdate(()=>{
            const prev = this.cellsResized(cells, bounds, recurse);
            this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).RESIZE_CELLS, {
                cells: cells,
                bounds: bounds,
                prev: prev
            }));
        });
        return cells;
    },
    cellsResized (cells, bounds, recurse = false) {
        const prev = [];
        if (cells.length === bounds.length) this.batchUpdate(()=>{
            cells.forEach((cell, i)=>{
                prev.push(this.cellResized(cell, bounds[i], false, recurse));
                if (this.isExtendParent(cell)) this.extendParent(cell);
                this.constrainChild(cell);
            });
            if (this.isResetEdgesOnResize()) this.resetEdges(cells);
            this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CELLS_RESIZED, {
                cells: cells,
                bounds: bounds,
                prev: prev
            }));
        });
        return prev;
    },
    cellResized (cell, bounds, ignoreRelative = false, recurse = false) {
        const prev = cell.getGeometry();
        if (prev && (prev.x !== bounds.x || prev.y !== bounds.y || prev.width !== bounds.width || prev.height !== bounds.height)) {
            const geo = prev.clone();
            if (!ignoreRelative && geo.relative) {
                const { offset: offset } = geo;
                if (offset) {
                    offset.x += bounds.x - geo.x;
                    offset.y += bounds.y - geo.y;
                }
            } else {
                geo.x = bounds.x;
                geo.y = bounds.y;
            }
            geo.width = bounds.width;
            geo.height = bounds.height;
            if (!geo.relative && cell.isVertex() && !this.isAllowNegativeCoordinates()) {
                geo.x = Math.max(0, geo.x);
                geo.y = Math.max(0, geo.y);
            }
            this.batchUpdate(()=>{
                if (recurse) this.resizeChildCells(cell, geo);
                this.getDataModel().setGeometry(cell, geo);
                this.constrainChildCells(cell);
            });
        }
        return prev;
    },
    resizeChildCells (cell, newGeo) {
        const geo = cell.getGeometry();
        if (geo) {
            const dx = geo.width !== 0 ? newGeo.width / geo.width : 1;
            const dy = geo.height !== 0 ? newGeo.height / geo.height : 1;
            for (const child of cell.getChildren())this.scaleCell(child, dx, dy, true);
        }
    },
    constrainChildCells (cell) {
        for (const child of cell.getChildren())this.constrainChild(child);
    },
    scaleCell (cell, dx, dy, recurse = false) {
        let geo = cell.getGeometry();
        if (geo) {
            const style = this.getCurrentCellStyle(cell);
            geo = geo.clone();
            // Stores values for restoring based on style
            const { x: x } = geo;
            const { y: y } = geo;
            const w = geo.width;
            const h = geo.height;
            geo.scale(dx, dy, style.aspect === 'fixed');
            if (style.resizeWidth) geo.width = w * dx;
            else if (!style.resizeWidth) geo.width = w;
            if (style.resizeHeight) geo.height = h * dy;
            else if (!style.resizeHeight) geo.height = h;
            if (!this.isCellMovable(cell)) {
                geo.x = x;
                geo.y = y;
            }
            if (!this.isCellResizable(cell)) {
                geo.width = w;
                geo.height = h;
            }
            if (cell.isVertex()) this.cellResized(cell, geo, true, recurse);
            else this.getDataModel().setGeometry(cell, geo);
        }
    },
    extendParent (cell) {
        const parent = cell.getParent();
        let p = parent ? parent.getGeometry() : null;
        if (parent && p && !parent.isCollapsed()) {
            const geo = cell.getGeometry();
            if (geo && !geo.relative && (p.width < geo.x + geo.width || p.height < geo.y + geo.height)) {
                p = p.clone();
                p.width = Math.max(p.width, geo.x + geo.width);
                p.height = Math.max(p.height, geo.y + geo.height);
                this.cellsResized([
                    parent
                ], [
                    p
                ], false);
            }
        }
    },
    // *************************************************************************************
    // Group: Cell moving
    // *************************************************************************************
    importCells (cells, dx, dy, target = null, evt = null, mapping = {}) {
        return this.moveCells(cells, dx, dy, true, target, evt, mapping);
    },
    moveCells (cells, dx = 0, dy = 0, clone = false, target = null, evt = null, mapping = {}) {
        if (dx !== 0 || dy !== 0 || clone || target) {
            // Removes descendants with ancestors in cells to avoid multiple moving
            cells = (0, $bb684498f1d5d11b$export$4552b09cfa920aec)(cells);
            const origCells = cells;
            this.batchUpdate(()=>{
                // Faster cell lookups to remove relative edge labels with selected
                // terminals to avoid explicit and implicit move at same time
                const dict = new Map();
                for (const cell of cells)dict.set(cell, true);
                const isSelected = (cell)=>{
                    while(cell){
                        if (dict.get(cell)) return true;
                        cell = cell.getParent();
                    }
                    return false;
                };
                // Removes relative edge labels with selected terminals
                const checked = [];
                for (const cell of cells){
                    const geo = cell.getGeometry();
                    const parent = cell.getParent();
                    if (!geo || !geo.relative || parent && !parent.isEdge() || parent && !isSelected(parent.getTerminal(true)) && !isSelected(parent.getTerminal(false))) checked.push(cell);
                }
                cells = checked;
                if (clone) {
                    cells = this.cloneCells(cells, this.isCloneInvalidEdges(), mapping);
                    if (!target) target = this.getDefaultParent();
                }
                // FIXME: Cells should always be inserted first before any other edit
                // to avoid forward references in sessions.
                // Need to disable allowNegativeCoordinates if target not null to
                // allow for temporary negative numbers until cellsAdded is called.
                const previous = this.isAllowNegativeCoordinates();
                if (target) this.setAllowNegativeCoordinates(true);
                this.cellsMoved(cells, dx, dy, !clone && this.isDisconnectOnMove() && this.isAllowDanglingEdges(), !target, this.isExtendParentsOnMove() && !target);
                this.setAllowNegativeCoordinates(previous);
                if (target) {
                    const index = target.getChildCount();
                    this.cellsAdded(cells, target, index, null, null, true);
                    // Restores parent edge on cloned edge labels
                    if (clone) cells.forEach((cell, i)=>{
                        const geo = cell.getGeometry();
                        const parent = origCells[i].getParent();
                        if (geo && geo.relative && parent && parent.isEdge() && this.getDataModel().contains(parent)) this.getDataModel().add(parent, cell);
                    });
                }
                // Dispatches a move event
                this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOVE_CELLS, {
                    cells: cells,
                    dx: dx,
                    dy: dy,
                    clone: clone,
                    target: target,
                    event: evt
                }));
            });
        }
        return cells;
    },
    cellsMoved (cells, dx, dy, disconnect = false, constrain = false, extend = false) {
        if (dx !== 0 || dy !== 0) this.batchUpdate(()=>{
            if (disconnect) this.disconnectGraph(cells);
            for (const cell of cells){
                this.translateCell(cell, dx, dy);
                if (extend && this.isExtendParent(cell)) this.extendParent(cell);
                else if (constrain) this.constrainChild(cell);
            }
            if (this.isResetEdgesOnMove()) this.resetEdges(cells);
            this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CELLS_MOVED, {
                cells: cells,
                dx: dx,
                dy: dy,
                disconnect: disconnect
            }));
        });
    },
    translateCell (cell, dx, dy) {
        let geometry = cell.getGeometry();
        if (geometry) {
            geometry = geometry.clone();
            geometry.translate(dx, dy);
            if (!geometry.relative && cell.isVertex() && !this.isAllowNegativeCoordinates()) {
                geometry.x = Math.max(0, geometry.x);
                geometry.y = Math.max(0, geometry.y);
            }
            if (geometry.relative && !cell.isEdge()) {
                const parent = cell.getParent();
                let angle = 0;
                if (parent.isVertex()) {
                    const style = this.getCurrentCellStyle(parent);
                    angle = style.rotation ?? 0;
                }
                if (angle !== 0) {
                    const rad = (0, $f7ff90b8964488a6$export$cba01ba138429a1d)(-angle);
                    const cos = Math.cos(rad);
                    const sin = Math.sin(rad);
                    const pt = (0, $f7ff90b8964488a6$export$ad2a0af3fbffd7c1)(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(dx, dy), cos, sin, new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(0, 0));
                    dx = pt.x;
                    dy = pt.y;
                }
                if (!geometry.offset) geometry.offset = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(dx, dy);
                else {
                    geometry.offset.x = geometry.offset.x + dx;
                    geometry.offset.y = geometry.offset.y + dy;
                }
            }
            this.getDataModel().setGeometry(cell, geometry);
        }
    },
    getCellContainmentArea (cell) {
        if (!cell.isEdge()) {
            const parent = cell.getParent();
            if (parent && parent !== this.getDefaultParent()) {
                const g = parent.getGeometry();
                if (g) {
                    let x = 0;
                    let y = 0;
                    let w = g.width;
                    let h = g.height;
                    if (this.isSwimlane(parent)) {
                        const size = this.getStartSize(parent);
                        const style = this.getCurrentCellStyle(parent);
                        const dir = style.direction ?? 'east';
                        const flipH = style.flipH ?? false;
                        const flipV = style.flipV ?? false;
                        if (dir === 'south' || dir === 'north') {
                            const tmp = size.width;
                            size.width = size.height;
                            size.height = tmp;
                        }
                        if (dir === 'east' && !flipV || dir === 'north' && !flipH || dir === 'west' && flipV || dir === 'south' && flipH) {
                            x = size.width;
                            y = size.height;
                        }
                        w -= size.width;
                        h -= size.height;
                    }
                    return new (0, $2997c239141ea844$export$2e2bcd8739ae039)(x, y, w, h);
                }
            }
        }
        return null;
    },
    constrainChild (cell, sizeFirst = true) {
        let geo = cell.getGeometry();
        if (geo && (this.isConstrainRelativeChildren() || !geo.relative)) {
            const parent = cell.getParent();
            let max = this.getMaximumGraphBounds();
            // Finds parent offset
            if (max && parent) {
                const off = this.getBoundingBoxFromGeometry([
                    parent
                ], false);
                if (off) {
                    max = (0, $2997c239141ea844$export$2e2bcd8739ae039).fromRectangle(max);
                    max.x -= off.x;
                    max.y -= off.y;
                }
            }
            if (this.isConstrainChild(cell)) {
                let tmp = this.getCellContainmentArea(cell);
                if (tmp) {
                    const overlap = this.getOverlap(cell);
                    if (overlap > 0) {
                        tmp = (0, $2997c239141ea844$export$2e2bcd8739ae039).fromRectangle(tmp);
                        tmp.x -= tmp.width * overlap;
                        tmp.y -= tmp.height * overlap;
                        tmp.width += 2 * tmp.width * overlap;
                        tmp.height += 2 * tmp.height * overlap;
                    }
                    // Find the intersection between max and tmp
                    if (!max) max = tmp;
                    else {
                        max = (0, $2997c239141ea844$export$2e2bcd8739ae039).fromRectangle(max);
                        max.intersect(tmp);
                    }
                }
            }
            if (max) {
                const cells = [
                    cell
                ];
                if (!cell.isCollapsed()) {
                    const desc = cell.getDescendants();
                    for (const descItem of desc)if (descItem.isVisible()) cells.push(descItem);
                }
                const bbox = this.getBoundingBoxFromGeometry(cells, false);
                if (bbox) {
                    geo = geo.clone();
                    // Cumulative horizontal movement
                    let dx = 0;
                    if (geo.width > max.width) {
                        dx = geo.width - max.width;
                        geo.width -= dx;
                    }
                    if (bbox.x + bbox.width > max.x + max.width) dx -= bbox.x + bbox.width - max.x - max.width - dx;
                    // Cumulative vertical movement
                    let dy = 0;
                    if (geo.height > max.height) {
                        dy = geo.height - max.height;
                        geo.height -= dy;
                    }
                    if (bbox.y + bbox.height > max.y + max.height) dy -= bbox.y + bbox.height - max.y - max.height - dy;
                    if (bbox.x < max.x) dx -= bbox.x - max.x;
                    if (bbox.y < max.y) dy -= bbox.y - max.y;
                    if (dx !== 0 || dy !== 0) {
                        if (geo.relative) {
                            // Relative geometries are moved via absolute offset
                            if (!geo.offset) geo.offset = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)();
                            geo.offset.x += dx;
                            geo.offset.y += dy;
                        } else {
                            geo.x += dx;
                            geo.y += dy;
                        }
                    }
                    this.getDataModel().setGeometry(cell, geo);
                }
            }
        }
    },
    /*****************************************************************************
     * Group: Cell retrieval
     *****************************************************************************/ getChildCells (parent, vertices = false, edges = false) {
        parent = parent ?? this.getDefaultParent();
        const cells = parent.getChildCells(vertices, edges);
        const result = [];
        // Filters out the non-visible child cells
        for (const cell of cells)if (cell.isVisible()) result.push(cell);
        return result;
    },
    getCellAt (x, y, parent = null, vertices = true, edges = true, ignoreFn = null) {
        if (!parent) {
            parent = this.getCurrentRoot();
            if (!parent) parent = this.getDataModel().getRoot();
        }
        if (parent) {
            const childCount = parent.getChildCount();
            for(let i = childCount - 1; i >= 0; i--){
                const cell = parent.getChildAt(i);
                const result = this.getCellAt(x, y, cell, vertices, edges, ignoreFn);
                if (result) return result;
                if (cell.isVisible() && (edges && cell.isEdge() || vertices && cell.isVertex())) {
                    const state = this.getView().getState(cell);
                    if (state && (!ignoreFn || !ignoreFn(state, x, y)) && this.intersects(state, x, y)) return cell;
                }
            }
        }
        return null;
    },
    getCells (x, y, width, height, parent = null, result = [], intersection = null, ignoreFn = null, includeDescendants = false) {
        if (width > 0 || height > 0 || intersection) {
            const model = this.getDataModel();
            const right = x + width;
            const bottom = y + height;
            if (!parent) {
                parent = this.getCurrentRoot();
                if (!parent) parent = model.getRoot();
            }
            if (parent) for (const cell of parent.getChildren()){
                const state = this.getView().getState(cell);
                if (state && cell.isVisible() && (!ignoreFn || !ignoreFn(state))) {
                    const deg = state.style.rotation ?? 0;
                    let box = state; // TODO: CHECK ME!!!! ==========================================================
                    if (deg !== 0) box = (0, $f7ff90b8964488a6$export$895c5e634403eaa7)(box, deg);
                    const hit = intersection && cell.isVertex() && (0, $f7ff90b8964488a6$export$7b0a31e10bbff018)(intersection, box) || !intersection && (cell.isEdge() || cell.isVertex()) && box.x >= x && box.y + box.height <= bottom && box.y >= y && box.x + box.width <= right;
                    if (hit) result.push(cell);
                    if (!hit || includeDescendants) this.getCells(x, y, width, height, cell, result, intersection, ignoreFn, includeDescendants);
                }
            }
        }
        return result;
    },
    getCellsBeyond (x0, y0, parent = null, rightHalfpane = false, bottomHalfpane = false) {
        const result = [];
        if (rightHalfpane || bottomHalfpane) {
            if (!parent) parent = this.getDefaultParent();
            if (parent) for (const child of parent.getChildren()){
                const state = this.getView().getState(child);
                if (child.isVisible() && state) {
                    if ((!rightHalfpane || state.x >= x0) && (!bottomHalfpane || state.y >= y0)) result.push(child);
                }
            }
        }
        return result;
    },
    intersects (state, x, y) {
        const pts = state.absolutePoints;
        if (pts.length > 0) {
            const t2 = this.getEventTolerance() * this.getEventTolerance();
            let pt = pts[0];
            for(let i = 1; i < pts.length; i += 1){
                const next = pts[i];
                if (pt && next) {
                    const dist = (0, $f7ff90b8964488a6$export$545acef63fa0c8)(pt.x, pt.y, next.x, next.y, x, y);
                    if (dist <= t2) return true;
                }
                pt = next;
            }
        } else {
            const alpha = (0, $f7ff90b8964488a6$export$cba01ba138429a1d)(state.style.rotation ?? 0);
            if (alpha !== 0) {
                const cos = Math.cos(-alpha);
                const sin = Math.sin(-alpha);
                const cx = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(state.getCenterX(), state.getCenterY());
                const pt = (0, $f7ff90b8964488a6$export$ad2a0af3fbffd7c1)(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y), cos, sin, cx);
                x = pt.x;
                y = pt.y;
            }
            if ((0, $f7ff90b8964488a6$export$2344b14b097df817)(state, x, y)) return true;
        }
        return false;
    },
    isValidAncestor (cell, parent, recurse = false) {
        return recurse ? parent.isAncestor(cell) : cell?.getParent() === parent;
    },
    /*****************************************************************************
     * Group: Graph behaviour
     *****************************************************************************/ isCellLocked (cell) {
        const geometry = cell.getGeometry();
        return this.isCellsLocked() || !!geometry && cell.isVertex() && geometry.relative;
    },
    isCellsLocked () {
        return this.cellsLocked;
    },
    setCellsLocked (value) {
        this.cellsLocked = value;
    },
    getCloneableCells (cells) {
        return this.getDataModel().filterCells(cells, (cell)=>{
            return this.isCellCloneable(cell);
        });
    },
    isCellCloneable (cell) {
        return this.isCellsCloneable() && (this.getCurrentCellStyle(cell).cloneable ?? true);
    },
    isCellsCloneable () {
        return this.cellsCloneable;
    },
    setCellsCloneable (value) {
        this.cellsCloneable = value;
    },
    getExportableCells (cells) {
        return this.getDataModel().filterCells(cells, (cell)=>{
            return this.canExportCell(cell);
        });
    },
    canExportCell (_cell = null) {
        return this.isExportEnabled();
    },
    getImportableCells (cells) {
        return this.getDataModel().filterCells(cells, (cell)=>{
            return this.canImportCell(cell);
        });
    },
    canImportCell (cell = null) {
        return this.isImportEnabled();
    },
    isCellSelectable (_cell) {
        return this.isCellsSelectable();
    },
    isCellsSelectable () {
        return this.cellsSelectable;
    },
    setCellsSelectable (value) {
        this.cellsSelectable = value;
    },
    getDeletableCells (cells) {
        return this.getDataModel().filterCells(cells, (cell)=>{
            return this.isCellDeletable(cell);
        });
    },
    isCellDeletable (cell) {
        return this.isCellsDeletable() && (this.getCurrentCellStyle(cell).deletable ?? true);
    },
    isCellsDeletable () {
        return this.cellsDeletable;
    },
    setCellsDeletable (value) {
        this.cellsDeletable = value;
    },
    isCellRotatable (cell) {
        return this.getCurrentCellStyle(cell).rotatable ?? true;
    },
    getMovableCells (cells) {
        return this.getDataModel().filterCells(cells, (cell)=>{
            return this.isCellMovable(cell);
        });
    },
    isCellMovable (cell) {
        return this.isCellsMovable() && !this.isCellLocked(cell) && (this.getCurrentCellStyle(cell).movable ?? true);
    },
    isCellsMovable () {
        return this.cellsMovable;
    },
    setCellsMovable (value) {
        this.cellsMovable = value;
    },
    isCellResizable (cell) {
        return this.isCellsResizable() && !this.isCellLocked(cell) && (this.getCurrentCellStyle(cell).resizable ?? true);
    },
    isCellsResizable () {
        return this.cellsResizable;
    },
    setCellsResizable (value) {
        this.cellsResizable = value;
    },
    isCellBendable (cell) {
        return this.isCellsBendable() && !this.isCellLocked(cell) && (this.getCurrentCellStyle(cell).bendable ?? true);
    },
    isCellsBendable () {
        return this.cellsBendable;
    },
    setCellsBendable (value) {
        this.cellsBendable = value;
    },
    isAutoSizeCell (cell) {
        return this.isAutoSizeCells() || (this.getCurrentCellStyle(cell).autoSize ?? false);
    },
    isAutoSizeCells () {
        return this.autoSizeCells;
    },
    setAutoSizeCells (value) {
        this.autoSizeCells = value;
    },
    isExtendParent (cell) {
        return !cell.isEdge() && this.isExtendParents();
    },
    isExtendParents () {
        return this.extendParents;
    },
    setExtendParents (value) {
        this.extendParents = value;
    },
    isExtendParentsOnAdd (cell) {
        return this.extendParentsOnAdd;
    },
    setExtendParentsOnAdd (value) {
        this.extendParentsOnAdd = value;
    },
    isExtendParentsOnMove () {
        return this.extendParentsOnMove;
    },
    setExtendParentsOnMove (value) {
        this.extendParentsOnMove = value;
    },
    /*****************************************************************************
     * Group: Graph appearance
     *****************************************************************************/ getCursorForCell (_cell) {
        return null;
    },
    /*****************************************************************************
     * Group: Graph display
     *****************************************************************************/ getCellBounds (cell, includeEdges = false, includeDescendants = false) {
        let cells = [
            cell
        ];
        // Includes all connected edges
        if (includeEdges) cells = cells.concat(cell.getEdges());
        let result = this.getView().getBounds(cells);
        // Recursively includes the bounds of the children
        if (includeDescendants) for (const child of cell.getChildren()){
            const tmp = this.getCellBounds(child, includeEdges, true);
            if (result && tmp) result.add(tmp);
            else result = tmp;
        }
        return result;
    },
    getBoundingBoxFromGeometry (cells, includeEdges = false) {
        let result = null;
        let tmp = null;
        for (const cell of cells)if (includeEdges || cell.isVertex()) {
            // Computes the bounding box for the points in the geometry
            const geo = cell.getGeometry();
            if (geo) {
                let bbox = null;
                if (cell.isEdge()) {
                    const addPoint = (pt)=>{
                        if (pt) {
                            if (!tmp) tmp = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(pt.x, pt.y, 0, 0);
                            else tmp.add(new (0, $2997c239141ea844$export$2e2bcd8739ae039)(pt.x, pt.y, 0, 0));
                        }
                    };
                    if (!cell.getTerminal(true)) addPoint(geo.getTerminalPoint(true));
                    if (!cell.getTerminal(false)) addPoint(geo.getTerminalPoint(false));
                    const pts = geo.points;
                    if (pts && pts.length > 0) {
                        tmp = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(pts[0].x, pts[0].y, 0, 0);
                        for(let j = 1; j < pts.length; j++)addPoint(pts[j]);
                    }
                    bbox = tmp;
                } else {
                    const parent = cell.getParent();
                    if (geo.relative && parent) {
                        if (parent.isVertex() && parent !== this.getView().currentRoot) {
                            tmp = this.getBoundingBoxFromGeometry([
                                parent
                            ], false);
                            if (tmp) {
                                bbox = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(geo.x * tmp.width, geo.y * tmp.height, geo.width, geo.height);
                                if (cells.includes(parent)) {
                                    bbox.x += tmp.x;
                                    bbox.y += tmp.y;
                                }
                            }
                        }
                    } else {
                        bbox = (0, $2997c239141ea844$export$2e2bcd8739ae039).fromRectangle(geo);
                        if (parent && parent.isVertex() && cells.includes(parent)) {
                            tmp = this.getBoundingBoxFromGeometry([
                                parent
                            ], false);
                            if (tmp) {
                                bbox.x += tmp.x;
                                bbox.y += tmp.y;
                            }
                        }
                    }
                    if (bbox && geo.offset) {
                        bbox.x += geo.offset.x;
                        bbox.y += geo.offset.y;
                    }
                    const style = this.getCurrentCellStyle(cell);
                    if (bbox) {
                        const angle = style.rotation ?? 0;
                        if (angle !== 0) bbox = (0, $f7ff90b8964488a6$export$895c5e634403eaa7)(bbox, angle);
                    }
                }
                if (bbox) {
                    if (!result) result = (0, $2997c239141ea844$export$2e2bcd8739ae039).fromRectangle(bbox);
                    else result.add(bbox);
                }
            }
        }
        return result;
    }
};


/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /**
 * Defines an object that contains the constraints about how to connect one side of an edge to its terminal.
 */ class $cb4bce61eb363699$var$ConnectionConstraint {
    constructor(point, perimeter = true, name = null, dx = 0, dy = 0){
        /**
         * Boolean that specifies if the point should be projected onto the perimeter
         * of the terminal.
         */ this.perimeter = true;
        /**
         * Optional string that specifies the name of the constraint.
         */ this.name = null;
        /**
         * Optional float that specifies the horizontal offset of the constraint.
         */ this.dx = 0;
        /**
         * Optional float that specifies the vertical offset of the constraint.
         */ this.dy = 0;
        this.point = point;
        this.perimeter = perimeter;
        this.name = name;
        this.dx = dx;
        this.dy = dy;
    }
}
var $cb4bce61eb363699$export$2e2bcd8739ae039 = $cb4bce61eb363699$var$ConnectionConstraint;





const $6aea47dc5754b787$export$3af94bf8f5a305d1 = {
    /*****************************************************************************
     * Group: Cell connecting and connection constraints
     *****************************************************************************/ constrainChildren: true,
    constrainRelativeChildren: false,
    disconnectOnMove: true,
    cellsDisconnectable: true,
    getOutlineConstraint (point, terminalState, me) {
        if (terminalState.shape) {
            const bounds = this.getView().getPerimeterBounds(terminalState);
            const direction = terminalState.style.direction;
            if (direction === 'north' || direction === 'south') {
                bounds.x += bounds.width / 2 - bounds.height / 2;
                bounds.y += bounds.height / 2 - bounds.width / 2;
                const tmp = bounds.width;
                bounds.width = bounds.height;
                bounds.height = tmp;
            }
            const alpha = (0, $f7ff90b8964488a6$export$cba01ba138429a1d)(terminalState.shape.getShapeRotation());
            if (alpha !== 0) {
                const cos = Math.cos(-alpha);
                const sin = Math.sin(-alpha);
                const ct = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(bounds.getCenterX(), bounds.getCenterY());
                point = (0, $f7ff90b8964488a6$export$ad2a0af3fbffd7c1)(point, cos, sin, ct);
            }
            let sx = 1;
            let sy = 1;
            let dx = 0;
            let dy = 0;
            // LATER: Add flipping support for image shapes
            if (terminalState.cell.isVertex()) {
                let flipH = terminalState.style.flipH;
                let flipV = terminalState.style.flipV;
                if (direction === 'north' || direction === 'south') {
                    const tmp = flipH;
                    flipH = flipV;
                    flipV = tmp;
                }
                if (flipH) {
                    sx = -1;
                    dx = -bounds.width;
                }
                if (flipV) {
                    sy = -1;
                    dy = -bounds.height;
                }
            }
            point = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)((point.x - bounds.x) * sx - dx + bounds.x, (point.y - bounds.y) * sy - dy + bounds.y);
            const x = bounds.width === 0 ? 0 : Math.round((point.x - bounds.x) * 1000 / bounds.width) / 1000;
            const y = bounds.height === 0 ? 0 : Math.round((point.y - bounds.y) * 1000 / bounds.height) / 1000;
            return new (0, $cb4bce61eb363699$export$2e2bcd8739ae039)(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y), false);
        }
        return null;
    },
    getAllConnectionConstraints (terminal, _source) {
        return terminal?.shape?.stencil?.constraints ?? null;
    },
    getConnectionConstraint (edge, terminal, source = false) {
        let point = null;
        const x = edge.style[source ? 'exitX' : 'entryX'];
        if (x !== undefined) {
            const y = edge.style[source ? 'exitY' : 'entryY'];
            if (y !== undefined) point = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y);
        }
        let perimeter = false;
        let dx = 0;
        let dy = 0;
        if (point) {
            perimeter = edge.style[source ? 'exitPerimeter' : 'entryPerimeter'] || false;
            // Add entry/exit offset
            dx = edge.style[source ? 'exitDx' : 'entryDx'];
            dy = edge.style[source ? 'exitDy' : 'entryDy'];
            dx = Number.isFinite(dx) ? dx : 0;
            dy = Number.isFinite(dy) ? dy : 0;
        }
        return new (0, $cb4bce61eb363699$export$2e2bcd8739ae039)(point, perimeter, null, dx, dy);
    },
    setConnectionConstraint (edge, terminal, source = false, constraint = null) {
        if (constraint) this.batchUpdate(()=>{
            if (!constraint || !constraint.point) {
                this.setCellStyles(source ? 'exitX' : 'entryX', null, [
                    edge
                ]);
                this.setCellStyles(source ? 'exitY' : 'entryY', null, [
                    edge
                ]);
                this.setCellStyles(source ? 'exitDx' : 'entryDx', null, [
                    edge
                ]);
                this.setCellStyles(source ? 'exitDy' : 'entryDy', null, [
                    edge
                ]);
                this.setCellStyles(source ? 'exitPerimeter' : 'entryPerimeter', null, [
                    edge
                ]);
            } else if (constraint.point) {
                this.setCellStyles(source ? 'exitX' : 'entryX', constraint.point.x, [
                    edge
                ]);
                this.setCellStyles(source ? 'exitY' : 'entryY', constraint.point.y, [
                    edge
                ]);
                this.setCellStyles(source ? 'exitDx' : 'entryDx', constraint.dx, [
                    edge
                ]);
                this.setCellStyles(source ? 'exitDy' : 'entryDy', constraint.dy, [
                    edge
                ]);
                if (!constraint.perimeter) this.setCellStyles(source ? 'exitPerimeter' : 'entryPerimeter', false, [
                    edge
                ]);
                else this.setCellStyles(source ? 'exitPerimeter' : 'entryPerimeter', true, [
                    edge
                ]);
            }
        });
    },
    getConnectionPoint (vertex, constraint, round = true) {
        let point = null;
        if (constraint.point) {
            const bounds = this.getView().getPerimeterBounds(vertex);
            const cx = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(bounds.getCenterX(), bounds.getCenterY());
            const direction = vertex.style.direction;
            let r1 = 0;
            // Bounds need to be rotated by 90 degrees for further computation
            if (vertex.style.anchorPointDirection) {
                switch(direction){
                    case 'north':
                        r1 += 270;
                        break;
                    case 'west':
                        r1 += 180;
                        break;
                    case 'south':
                        r1 += 90;
                        break;
                }
                // Bounds need to be rotated by 90 degrees for further computation
                if (direction === 'north' || direction === 'south') bounds.rotate90();
            }
            const { scale: scale } = this.getView();
            point = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(bounds.x + constraint.point.x * bounds.width + constraint.dx * scale, bounds.y + constraint.point.y * bounds.height + constraint.dy * scale);
            // Rotation for direction before projection on perimeter
            let r2 = vertex.style.rotation || 0;
            if (constraint.perimeter) {
                if (r1 !== 0) {
                    // Only 90 degrees steps possible here so no trig needed
                    let cos = 0;
                    let sin = 0;
                    switch(r1){
                        case 90:
                            sin = 1;
                            break;
                        case 180:
                            cos = -1;
                            break;
                        case 270:
                            sin = -1;
                            break;
                    }
                    point = (0, $f7ff90b8964488a6$export$ad2a0af3fbffd7c1)(point, cos, sin, cx);
                }
                point = this.getView().getPerimeterPoint(vertex, point, false);
            } else {
                r2 += r1;
                if (vertex.cell.isVertex()) {
                    let flipH = vertex.style.flipH;
                    let flipV = vertex.style.flipV;
                    if (direction === 'north' || direction === 'south') {
                        const temp = flipH;
                        flipH = flipV;
                        flipV = temp;
                    }
                    if (flipH) point.x = 2 * bounds.getCenterX() - point.x;
                    if (flipV) point.y = 2 * bounds.getCenterY() - point.y;
                }
            }
            // Generic rotation after projection on perimeter
            if (r2 !== 0 && point) {
                const rad = (0, $f7ff90b8964488a6$export$cba01ba138429a1d)(r2);
                const cos = Math.cos(rad);
                const sin = Math.sin(rad);
                point = (0, $f7ff90b8964488a6$export$ad2a0af3fbffd7c1)(point, cos, sin, cx);
            }
        }
        if (round && point) {
            point.x = Math.round(point.x);
            point.y = Math.round(point.y);
        }
        return point;
    },
    connectCell (edge, terminal = null, source = false, constraint = null) {
        this.batchUpdate(()=>{
            const previous = edge.getTerminal(source);
            this.cellConnected(edge, terminal, source, constraint);
            this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CONNECT_CELL, 'edge', edge, 'terminal', terminal, 'source', source, 'previous', previous));
        });
        return edge;
    },
    cellConnected (edge, terminal, source = false, constraint = null) {
        this.batchUpdate(()=>{
            const previous = edge.getTerminal(source);
            // Updates the constraint
            this.setConnectionConstraint(edge, terminal, source, constraint);
            // Checks if the new terminal is a port, uses the ID of the port in the
            // style and the parent of the port as the actual terminal of the edge.
            if (this.isPortsEnabled()) {
                let id = null;
                if (terminal && this.isPort(terminal)) {
                    id = terminal.getId();
                    terminal = this.getTerminalForPort(terminal, source);
                }
                // Sets or resets all previous information for connecting to a child port
                const key = source ? 'sourcePort' : 'targetPort';
                this.setCellStyles(key, id, [
                    edge
                ]);
            }
            this.getDataModel().setTerminal(edge, terminal, source);
            if (this.isResetEdgesOnConnect()) this.resetEdge(edge);
            this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CELL_CONNECTED, 'edge', edge, 'terminal', terminal, 'source', source, 'previous', previous));
        });
    },
    disconnectGraph (cells) {
        this.batchUpdate(()=>{
            const { scale: scale, translate: tr } = this.getView();
            // Fast lookup for finding cells in array
            const dict = new Map();
            for(let i = 0; i < cells.length; i += 1)dict.set(cells[i], true);
            for (const cell of cells)if (cell.isEdge()) {
                let geo = cell.getGeometry();
                if (geo) {
                    const state = this.getView().getState(cell);
                    const parent = cell.getParent();
                    const pstate = parent ? this.getView().getState(parent) : null;
                    if (state && pstate) {
                        geo = geo.clone();
                        const dx = -pstate.origin.x;
                        const dy = -pstate.origin.y;
                        const pts = state.absolutePoints;
                        let src = cell.getTerminal(true);
                        if (src && this.isCellDisconnectable(cell, src, true)) {
                            while(src && !dict.get(src))src = src.getParent();
                            if (!src && pts[0]) {
                                geo.setTerminalPoint(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(pts[0].x / scale - tr.x + dx, pts[0].y / scale - tr.y + dy), true);
                                this.getDataModel().setTerminal(cell, null, true);
                            }
                        }
                        let trg = cell.getTerminal(false);
                        if (trg && this.isCellDisconnectable(cell, trg, false)) {
                            while(trg && !dict.get(trg))trg = trg.getParent();
                            if (!trg) {
                                const n = pts.length - 1;
                                const p = pts[n];
                                if (p) {
                                    geo.setTerminalPoint(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(p.x / scale - tr.x + dx, p.y / scale - tr.y + dy), false);
                                    this.getDataModel().setTerminal(cell, null, false);
                                }
                            }
                        }
                        this.getDataModel().setGeometry(cell, geo);
                    }
                }
            }
        });
    },
    getConnections (cell, parent = null) {
        return this.getEdges(cell, parent, true, true, false);
    },
    isConstrainChild (cell) {
        return this.isConstrainChildren() && !!cell.getParent() && !cell.getParent().isEdge();
    },
    isConstrainChildren () {
        return this.constrainChildren;
    },
    setConstrainChildren (value) {
        this.constrainChildren = value;
    },
    isConstrainRelativeChildren () {
        return this.constrainRelativeChildren;
    },
    setConstrainRelativeChildren (value) {
        this.constrainRelativeChildren = value;
    },
    /*****************************************************************************
     * Group: Graph behaviour
     *****************************************************************************/ isDisconnectOnMove () {
        return this.disconnectOnMove;
    },
    setDisconnectOnMove (value) {
        this.disconnectOnMove = value;
    },
    isCellDisconnectable (cell, terminal = null, source = false) {
        return this.isCellsDisconnectable() && !this.isCellLocked(cell);
    },
    isCellsDisconnectable () {
        return this.cellsDisconnectable;
    },
    setCellsDisconnectable (value) {
        this.cellsDisconnectable = value;
    },
    isValidSource (cell) {
        return cell == null && this.isAllowDanglingEdges() || cell != null && (!cell.isEdge() || this.isConnectableEdges()) && cell.isConnectable();
    },
    isValidTarget (cell) {
        return this.isValidSource(cell);
    },
    isValidConnection (source, target) {
        return this.isValidSource(source) && this.isValidTarget(target);
    },
    setConnectable (connectable) {
        const connectionHandler = this.getPlugin('ConnectionHandler');
        connectionHandler?.setEnabled(connectable);
    },
    isConnectable () {
        const connectionHandler = this.getPlugin('ConnectionHandler');
        return connectionHandler?.isEnabled() ?? false;
    }
};


/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ // @ts-expect-error The properties of PartialGraph are defined elsewhere.
const $54830583bb43eee7$export$a8c1e24dcf7fcdb6 = {
    dropEnabled: false,
    splitEnabled: true,
    autoScroll: true,
    isAutoScroll () {
        return this.autoScroll;
    },
    autoExtend: true,
    isAutoExtend () {
        return this.autoExtend;
    },
    /*****************************************************************************
     * Group: Graph behaviour
     *****************************************************************************/ isDropEnabled () {
        return this.dropEnabled;
    },
    setDropEnabled (value) {
        this.dropEnabled = value;
    },
    /*****************************************************************************
     * Group: Split behaviour
     *****************************************************************************/ isSplitEnabled () {
        return this.splitEnabled;
    },
    setSplitEnabled (value) {
        this.splitEnabled = value;
    },
    isSplitTarget (target, cells = [], evt) {
        if (target.isEdge() && cells.length === 1 && cells[0].isConnectable() && !this.getEdgeValidationError(target, target.getTerminal(true), cells[0])) {
            const src = target.getTerminal(true);
            const trg = target.getTerminal(false);
            return !cells[0].isAncestor(src) && !cells[0].isAncestor(trg);
        }
        return false;
    }
};


/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 





const $4209aee23314ac42$export$a39ff26707082afe = {
    resetEdgesOnResize: false,
    isResetEdgesOnResize () {
        return this.resetEdgesOnResize;
    },
    resetEdgesOnMove: false,
    isResetEdgesOnMove () {
        return this.resetEdgesOnMove;
    },
    resetEdgesOnConnect: true,
    isResetEdgesOnConnect () {
        return this.resetEdgesOnConnect;
    },
    connectableEdges: false,
    allowDanglingEdges: true,
    cloneInvalidEdges: false,
    edgeLabelsMovable: true,
    // ***************************************************************************
    // Group: Graph Behaviour
    // ***************************************************************************
    isEdgeLabelsMovable () {
        return this.edgeLabelsMovable;
    },
    setEdgeLabelsMovable (value) {
        this.edgeLabelsMovable = value;
    },
    setAllowDanglingEdges (value) {
        this.allowDanglingEdges = value;
    },
    isAllowDanglingEdges () {
        return this.allowDanglingEdges;
    },
    setConnectableEdges (value) {
        this.connectableEdges = value;
    },
    isConnectableEdges () {
        return this.connectableEdges;
    },
    setCloneInvalidEdges (value) {
        this.cloneInvalidEdges = value;
    },
    isCloneInvalidEdges () {
        return this.cloneInvalidEdges;
    },
    // ***************************************************************************
    // Group: Cell alignment and orientation
    // ***************************************************************************
    flipEdge (edge) {
        if (this.alternateEdgeStyle) this.batchUpdate(()=>{
            const style = edge.getStyle();
            if (Object.keys(style).length) this.getDataModel().setStyle(edge, this.alternateEdgeStyle);
            else this.getDataModel().setStyle(edge, {});
            // Removes all existing control points
            this.resetEdge(edge);
            this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).FLIP_EDGE, {
                edge: edge
            }));
        });
        return edge;
    },
    splitEdge (edge, cells, newEdge, dx = 0, dy = 0, x, y, parent = null) {
        parent = parent ?? edge.getParent();
        const source = edge.getTerminal(true);
        this.batchUpdate(()=>{
            if (!newEdge) {
                newEdge = this.cloneCell(edge);
                // Removes waypoints before/after new cell
                const state = this.getView().getState(edge);
                let geo = newEdge.getGeometry();
                if (geo && state) {
                    const t = this.getView().translate;
                    const s = this.getView().scale;
                    const idx = (0, $f7ff90b8964488a6$export$d6d91d741b272ab)(state, (dx + t.x) * s, (dy + t.y) * s);
                    geo.points = geo.points.slice(0, idx);
                    geo = edge.getGeometry();
                    if (geo) {
                        geo = geo.clone();
                        geo.points = geo.points.slice(idx);
                        this.getDataModel().setGeometry(edge, geo);
                    }
                }
            }
            this.cellsMoved(cells, dx, dy, false, false);
            this.cellsAdded(cells, parent, parent ? parent.getChildCount() : 0, null, null, true);
            this.cellsAdded([
                newEdge
            ], parent, parent ? parent.getChildCount() : 0, source, cells[0], false);
            this.cellConnected(edge, cells[0], true);
            this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).SPLIT_EDGE, {
                edge: edge,
                cells: cells,
                newEdge: newEdge,
                dx: dx,
                dy: dy
            }));
        });
        return newEdge;
    },
    insertEdge (...args) {
        let parent;
        let id;
        let value;
        let source;
        let target;
        let style;
        if (args.length === 1 && typeof args[0] === 'object') {
            const params = args[0];
            parent = params.parent;
            id = params.id;
            value = params.value;
            source = params.source;
            target = params.target;
            style = params.style;
        } else // otherwise treat as individual arguments
        [parent, id, value, source, target, style] = args;
        const edge = this.createEdge(parent, id, value, source, target, style);
        return this.addEdge(edge, parent, source, target);
    },
    createEdge (_parent = null, id, value, _source = null, _target = null, style = {}) {
        // Creates the edge
        const edge = new (0, $0e256159624f4593$export$2e2bcd8739ae039)(value, new (0, $6713282b00eec691$export$2e2bcd8739ae039)(), style);
        edge.setId(id); // this is not an issue to set undefined here. If so, the id will be auto-generated when adding the cell to the model
        edge.setEdge(true);
        edge.geometry.relative = true; // geometry is set when creating the cell above
        return edge;
    },
    addEdge (edge, parent = null, source = null, target = null, index = null) {
        return this.addCell(edge, parent, index, source, target);
    },
    // ***************************************************************************
    // Group: Folding
    // ***************************************************************************
    addAllEdges (cells) {
        const allCells = cells.slice();
        return (0, $7798e91745d24e26$export$2e2262a44ac61957)(allCells.concat(this.getAllEdges(cells)));
    },
    getAllEdges (cells) {
        let edges = [];
        if (cells) for(let i = 0; i < cells.length; i += 1){
            const edgeCount = cells[i].getEdgeCount();
            for(let j = 0; j < edgeCount; j++)edges.push(cells[i].getEdgeAt(j));
            // Recurses
            const children = cells[i].getChildren();
            edges = edges.concat(this.getAllEdges(children));
        }
        return edges;
    },
    getIncomingEdges (cell, parent = null) {
        return this.getEdges(cell, parent, true, false, false);
    },
    getOutgoingEdges (cell, parent = null) {
        return this.getEdges(cell, parent, false, true, false);
    },
    getEdges (cell, parent = null, incoming = true, outgoing = true, includeLoops = true, recurse = false) {
        let edges = [];
        const isCollapsed = cell.isCollapsed();
        const childCount = cell.getChildCount();
        for(let i = 0; i < childCount; i += 1){
            const child = cell.getChildAt(i);
            if (isCollapsed || !child.isVisible()) edges = edges.concat(child.getEdges(incoming, outgoing));
        }
        edges = edges.concat(cell.getEdges(incoming, outgoing));
        const result = [];
        for(let i = 0; i < edges.length; i += 1){
            const state = this.getView().getState(edges[i]);
            const source = state ? state.getVisibleTerminal(true) : this.getView().getVisibleTerminal(edges[i], true);
            const target = state ? state.getVisibleTerminal(false) : this.getView().getVisibleTerminal(edges[i], false);
            if (includeLoops && source === target || source !== target && (incoming && target === cell && (!parent || this.isValidAncestor(source, parent, recurse)) || outgoing && source === cell && (!parent || this.isValidAncestor(target, parent, recurse)))) result.push(edges[i]);
        }
        return result;
    },
    // ***************************************************************************
    // Group: Cell retrieval
    // ***************************************************************************
    getChildEdges (parent) {
        return this.getChildCells(parent, false, true);
    },
    getEdgesBetween (source, target, directed = false) {
        const edges = this.getEdges(source);
        const result = [];
        // Checks if the edge is connected to the correct
        // cell and returns the first match
        for(let i = 0; i < edges.length; i += 1){
            const state = this.getView().getState(edges[i]);
            const src = state ? state.getVisibleTerminal(true) : this.getView().getVisibleTerminal(edges[i], true);
            const trg = state ? state.getVisibleTerminal(false) : this.getView().getVisibleTerminal(edges[i], false);
            if (src === source && trg === target || !directed && src === target && trg === source) result.push(edges[i]);
        }
        return result;
    },
    // ***************************************************************************
    // Group: Cell moving
    // ***************************************************************************
    resetEdges (cells) {
        // Prepares faster cells lookup
        const dict = new Map();
        for(let i = 0; i < cells.length; i += 1)dict.set(cells[i], true);
        this.batchUpdate(()=>{
            for(let i = 0; i < cells.length; i += 1){
                const edges = cells[i].getEdges();
                for(let j = 0; j < edges.length; j++){
                    const state = this.getView().getState(edges[j]);
                    const source = state ? state.getVisibleTerminal(true) : this.getView().getVisibleTerminal(edges[j], true);
                    const target = state ? state.getVisibleTerminal(false) : this.getView().getVisibleTerminal(edges[j], false);
                    // Checks if one of the terminals is not in the given array
                    if (!dict.get(source) || !dict.get(target)) this.resetEdge(edges[j]);
                }
                this.resetEdges(cells[i].getChildren());
            }
        });
    },
    resetEdge (edge) {
        let geo = edge.getGeometry();
        // Resets the control points
        if (geo && geo.points && geo.points.length > 0) {
            geo = geo.clone();
            geo.points = [];
            this.getDataModel().setGeometry(edge, geo);
        }
        return edge;
    }
};


/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 


const $955dbf39e1d6c312$export$ab76d606b2038e62 = {
    cellsEditable: true,
    /*****************************************************************************
     * Group: Cell in-place editing
     *****************************************************************************/ startEditing (evt) {
        this.startEditingAtCell(null, evt);
    },
    startEditingAtCell (cell = null, evt) {
        if (!evt || !(0, $f192e93a2fd1153c$export$d06464d6b74eedc4)(evt)) {
            if (!cell) {
                cell = this.getSelectionCell();
                if (cell && !this.isCellEditable(cell)) cell = null;
            } else {
                this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).START_EDITING, {
                    cell: cell,
                    event: evt
                }));
                const cellEditorHandler = this.getPlugin('CellEditorHandler');
                cellEditorHandler?.startEditing(cell, evt);
                this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).EDITING_STARTED, {
                    cell: cell,
                    event: evt
                }));
            }
        }
    },
    getEditingValue (cell, evt) {
        return this.convertValueToString(cell);
    },
    stopEditing (cancel = false) {
        const cellEditorHandler = this.getPlugin('CellEditorHandler');
        cellEditorHandler?.stopEditing(cancel);
        this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).EDITING_STOPPED, {
            cancel: cancel
        }));
    },
    labelChanged (cell, value, evt) {
        this.batchUpdate(()=>{
            const old = cell.value;
            this.cellLabelChanged(cell, value, this.isAutoSizeCell(cell));
            this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).LABEL_CHANGED, {
                cell: cell,
                value: value,
                old: old,
                event: evt
            }));
        });
        return cell;
    },
    cellLabelChanged (cell, value, autoSize = false) {
        this.batchUpdate(()=>{
            this.getDataModel().setValue(cell, value);
            if (autoSize) this.cellSizeUpdated(cell, false);
        });
    },
    /*****************************************************************************
     * Group: Graph behaviour
     *****************************************************************************/ isEditing (cell = null) {
        const cellEditorHandler = this.getPlugin('CellEditorHandler');
        const editingCell = cellEditorHandler?.getEditingCell();
        return !cell ? !!editingCell : cell === editingCell;
    },
    isCellEditable (cell) {
        return this.isCellsEditable() && !this.isCellLocked(cell) && (this.getCurrentCellStyle(cell).editable ?? true);
    },
    isCellsEditable () {
        return this.cellsEditable;
    },
    setCellsEditable (value) {
        this.cellsEditable = value;
    }
};


/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 






var $cBHcM = parcelRequire("cBHcM");

const $29df245d7351981d$export$9dbbfd00a094a9ae = {
    // TODO: Document me!
    lastTouchEvent: null,
    doubleClickCounter: 0,
    lastTouchCell: null,
    fireDoubleClick: null,
    tapAndHoldThread: null,
    lastMouseX: null,
    lastMouseY: null,
    isMouseTrigger: null,
    ignoreMouseEvents: null,
    mouseMoveRedirect: null,
    mouseUpRedirect: null,
    lastEvent: null,
    escapeEnabled: true,
    invokesStopCellEditing: true,
    enterStopsCellEditing: false,
    isMouseDown: false,
    nativeDblClickEnabled: true,
    doubleTapEnabled: true,
    doubleTapTimeout: 500,
    doubleTapTolerance: 25,
    lastTouchX: 0,
    lastTouchY: 0,
    lastTouchTime: 0,
    tapAndHoldEnabled: true,
    tapAndHoldDelay: 500,
    tapAndHoldInProgress: false,
    tapAndHoldValid: false,
    initialTouchX: 0,
    initialTouchY: 0,
    tolerance: 4,
    isNativeDblClickEnabled () {
        return this.nativeDblClickEnabled;
    },
    getEventTolerance () {
        return this.tolerance;
    },
    setEventTolerance (tolerance) {
        this.tolerance = tolerance;
    },
    escape (evt) {
        this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).ESCAPE, {
            event: evt
        }));
    },
    click (me) {
        const evt = me.getEvent();
        let cell = me.getCell();
        const mxe = new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CLICK, {
            event: evt,
            cell: cell
        });
        if (me.isConsumed()) mxe.consume();
        this.fireEvent(mxe);
        if (this.isEnabled() && !(0, $f192e93a2fd1153c$export$f6e93dab47d340de)(evt) && !mxe.isConsumed()) {
            if (cell) {
                if (this.isTransparentClickEvent(evt)) {
                    let active = false;
                    const tmp = this.getCellAt(me.graphX, me.graphY, null, false, false, (state)=>{
                        const selected = this.isCellSelected(state.cell);
                        active = active || selected;
                        return !active || selected || state.cell !== cell && state.cell.isAncestor(cell);
                    });
                    if (tmp) cell = tmp;
                }
            } else if (this.isSwimlaneSelectionEnabled()) {
                cell = this.getSwimlaneAt(me.getGraphX(), me.getGraphY());
                if (cell != null && (!this.isToggleEvent(evt) || !(0, $f192e93a2fd1153c$export$bdc3218ff6eba0d8)(evt))) {
                    let temp = cell;
                    let swimlanes = [];
                    while(temp != null){
                        temp = temp.getParent();
                        const state = this.getView().getState(temp);
                        if (this.isSwimlane(temp) && state != null) swimlanes.push(temp);
                    }
                    // Selects ancestors for selected swimlanes
                    if (swimlanes.length > 0) {
                        swimlanes = swimlanes.reverse();
                        swimlanes.splice(0, 0, cell);
                        swimlanes.push(cell);
                        for(let i = 0; i < swimlanes.length - 1; i += 1)if (this.isCellSelected(swimlanes[i])) cell = swimlanes[this.isToggleEvent(evt) ? i : i + 1];
                    }
                }
            }
            if (cell) this.selectCellForEvent(cell, evt);
            else if (!this.isToggleEvent(evt)) this.clearSelection();
        }
        return false;
    },
    dblClick (evt, cell = null) {
        const mxe = new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).DOUBLE_CLICK, {
            event: evt,
            cell: cell
        });
        this.fireEvent(mxe);
        // Handles the event if it has not been consumed
        if (this.isEnabled() && !(0, $f192e93a2fd1153c$export$f6e93dab47d340de)(evt) && !mxe.isConsumed() && cell && this.isCellEditable(cell) && !this.isEditing(cell)) {
            this.startEditingAtCell(cell, evt);
            (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).consume(evt);
        }
    },
    tapAndHold (me) {
        const evt = me.getEvent();
        const mxe = new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).TAP_AND_HOLD, {
            event: evt,
            cell: me.getCell()
        });
        const panningHandler = this.getPlugin('PanningHandler');
        const connectionHandler = this.getPlugin('ConnectionHandler');
        // LATER: Check if event should be consumed if me is consumed
        this.fireEvent(mxe);
        if (mxe.isConsumed()) // Resets the state of the panning handler
        panningHandler && (panningHandler.panningTrigger = false);
        // Handles the event if it has not been consumed
        if (this.isEnabled() && !(0, $f192e93a2fd1153c$export$f6e93dab47d340de)(evt) && !mxe.isConsumed() && connectionHandler && connectionHandler.isEnabled()) {
            const cell = connectionHandler.marker.getCell(me);
            if (cell) {
                const state = this.getView().getState(cell);
                if (state) {
                    connectionHandler.marker.currentColor = connectionHandler.marker.validColor;
                    connectionHandler.marker.markedState = state;
                    connectionHandler.marker.mark();
                    connectionHandler.first = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(me.getGraphX(), me.getGraphY());
                    connectionHandler.edgeState = connectionHandler.createEdgeState(me);
                    connectionHandler.previous = state;
                    connectionHandler.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).START, {
                        state: connectionHandler.previous
                    }));
                }
            }
        }
    },
    addMouseListener (listener) {
        this.mouseListeners.push(listener);
    },
    removeMouseListener (listener) {
        for(let i = 0; i < this.mouseListeners.length; i += 1)if (this.mouseListeners[i] === listener) {
            this.mouseListeners.splice(i, 1);
            break;
        }
    },
    updateMouseEvent (me, evtName) {
        const pt = (0, $b55d6ca3b42398e2$export$864dc177f7f5bda1)(this.getContainer(), me.getX(), me.getY());
        me.graphX = pt.x - this.getPanDx();
        me.graphY = pt.y - this.getPanDy();
        // Searches for rectangles using method if native hit detection is disabled on shape
        if (!me.getCell() && this.isMouseDown && evtName === (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_MOVE) {
            const cell = this.getCellAt(pt.x, pt.y, null, true, true, (state)=>{
                return !state.shape || state.shape.paintBackground !== this.paintBackground || state.style.pointerEvents || state.shape.fill !== (0, $cBHcM.NONE);
            });
            me.state = cell ? this.getView().getState(cell) : null;
        }
        return me;
    },
    getStateForTouchEvent (evt) {
        const x = (0, $f192e93a2fd1153c$export$87583e2c100c6a4f)(evt);
        const y = (0, $f192e93a2fd1153c$export$195fc3609401443f)(evt);
        // Dispatches the drop event to the graph which
        // consumes and executes the source function
        const pt = (0, $b55d6ca3b42398e2$export$864dc177f7f5bda1)(this.getContainer(), x, y);
        const cell = this.getCellAt(pt.x, pt.y);
        return cell ? this.getView().getState(cell) : null;
    },
    isEventIgnored (evtName, me, sender) {
        const mouseEvent = (0, $f192e93a2fd1153c$export$764db16956f554f8)(me.getEvent());
        let result = false;
        // Drops events that are fired more than once
        if (me.getEvent() === this.lastEvent) result = true;
        else this.lastEvent = me.getEvent();
        // Installs event listeners to capture the complete gesture from the event source
        // for non-MS touch events as a workaround for all events for the same geture being
        // fired from the event source even if that was removed from the DOM.
        const eventSource = this.getEventSource();
        if (eventSource && evtName !== (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_MOVE) {
            (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).removeGestureListeners(eventSource, null, this.mouseMoveRedirect, this.mouseUpRedirect);
            this.mouseMoveRedirect = null;
            this.mouseUpRedirect = null;
            this.setEventSource(null);
        } else if (!(0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_GC && eventSource && me.getSource() !== eventSource) result = true;
        else if (eventSource && (0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_TOUCH && evtName === (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_DOWN && !mouseEvent && !(0, $f192e93a2fd1153c$export$147fc2f150568226)(me.getEvent())) {
            this.setEventSource(me.getSource());
            this.mouseMoveRedirect = (evt)=>{
                this.fireMouseEvent((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_MOVE, new (0, $2051fd5f8fd06bc7$export$2e2bcd8739ae039)(evt, this.getStateForTouchEvent(evt)));
            };
            this.mouseUpRedirect = (evt)=>{
                this.fireMouseEvent((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_UP, new (0, $2051fd5f8fd06bc7$export$2e2bcd8739ae039)(evt, this.getStateForTouchEvent(evt)));
            };
            (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addGestureListeners(eventSource, null, this.mouseMoveRedirect, this.mouseUpRedirect);
        }
        // Factored out the workarounds for FF to make it easier to override/remove
        // Note this method has side-effects!
        if (this.isSyntheticEventIgnored(evtName, me, sender)) result = true;
        // Never fires mouseUp/-Down for double clicks
        if (!(0, $f192e93a2fd1153c$export$e9cb688973f06c96)(this.lastEvent) && evtName !== (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_MOVE && this.lastEvent.detail === 2) return true;
        // Filters out of sequence events or mixed event types during a gesture
        if (evtName === (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_UP && this.isMouseDown) this.isMouseDown = false;
        else if (evtName === (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_DOWN && !this.isMouseDown) {
            this.isMouseDown = true;
            this.isMouseTrigger = mouseEvent;
        } else if (!result && ((!(0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_FF || evtName !== (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_MOVE) && this.isMouseDown && this.isMouseTrigger !== mouseEvent || evtName === (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_DOWN && this.isMouseDown || evtName === (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_UP && !this.isMouseDown)) result = true;
        if (!result && evtName === (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_DOWN) {
            this.lastMouseX = me.getX();
            this.lastMouseY = me.getY();
        }
        return result;
    },
    isSyntheticEventIgnored (evtName, me, sender) {
        let result = false;
        const mouseEvent = (0, $f192e93a2fd1153c$export$764db16956f554f8)(me.getEvent());
        // LATER: This does not cover all possible cases that can go wrong in FF
        if (this.ignoreMouseEvents && mouseEvent && evtName !== (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_MOVE) {
            this.ignoreMouseEvents = evtName !== (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_UP;
            result = true;
        } else if ((0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_FF && !mouseEvent && evtName === (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_UP) this.ignoreMouseEvents = true;
        return result;
    },
    isEventSourceIgnored (evtName, me) {
        const source = me.getSource();
        if (!source) return true;
        // @ts-ignore nodeName could exist
        const name = source.nodeName ? source.nodeName.toLowerCase() : '';
        const candidate = !(0, $f192e93a2fd1153c$export$764db16956f554f8)(me.getEvent()) || (0, $f192e93a2fd1153c$export$94d43346060bc767)(me.getEvent());
        return evtName === (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_DOWN && candidate && (name === 'select' || name === 'option' || name === 'input' && // @ts-ignore type could exist
        source.type !== 'checkbox' && // @ts-ignore type could exist
        source.type !== 'radio' && // @ts-ignore type could exist
        source.type !== 'button' && // @ts-ignore type could exist
        source.type !== 'submit' && // @ts-ignore type could exist
        source.type !== 'file');
    },
    getEventState (state) {
        return state;
    },
    fireMouseEvent (evtName, me, sender) {
        sender = sender ?? this;
        if (this.isEventSourceIgnored(evtName, me)) {
            const tooltipHandler = this.getPlugin('TooltipHandler');
            if (tooltipHandler) tooltipHandler.hide();
            return;
        }
        // Updates the graph coordinates in the event
        me = this.updateMouseEvent(me, evtName);
        // Detects and processes double taps for touch-based devices which do not have native double click events
        // or where detection of double click is not always possible (quirks, IE10+). Note that this can only handle
        // double clicks on cells because the sequence of events in IE prevents detection on the background, it fires
        // two mouse ups, one of which without a cell but no mousedown for the second click which means we cannot
        // detect which mouseup(s) are part of the first click, ie we do not know when the first click ends.
        if (!this.nativeDblClickEnabled && !(0, $f192e93a2fd1153c$export$e9cb688973f06c96)(me.getEvent()) || this.doubleTapEnabled && (0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_TOUCH && ((0, $f192e93a2fd1153c$export$c4dfce035d43d1e0)(me.getEvent()) || (0, $f192e93a2fd1153c$export$147fc2f150568226)(me.getEvent()))) {
            const currentTime = new Date().getTime();
            if (evtName === (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_DOWN) {
                if (this.lastTouchEvent && this.lastTouchEvent !== me.getEvent() && currentTime - this.lastTouchTime < this.doubleTapTimeout && Math.abs(this.lastTouchX - me.getX()) < this.doubleTapTolerance && Math.abs(this.lastTouchY - me.getY()) < this.doubleTapTolerance && this.doubleClickCounter < 2) {
                    this.doubleClickCounter += 1;
                    let doubleClickFired = false;
                    if (evtName === (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_UP) {
                        if (me.getCell() === this.lastTouchCell && this.lastTouchCell) {
                            this.lastTouchTime = 0;
                            const cell = this.lastTouchCell;
                            this.lastTouchCell = null;
                            this.dblClick(me.getEvent(), cell);
                            doubleClickFired = true;
                        }
                    } else {
                        this.fireDoubleClick = true;
                        this.lastTouchTime = 0;
                    }
                    if (doubleClickFired) {
                        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).consume(me.getEvent());
                        return;
                    }
                } else if (!this.lastTouchEvent || this.lastTouchEvent !== me.getEvent()) {
                    this.lastTouchCell = me.getCell();
                    this.lastTouchX = me.getX();
                    this.lastTouchY = me.getY();
                    this.lastTouchTime = currentTime;
                    this.lastTouchEvent = me.getEvent();
                    this.doubleClickCounter = 0;
                }
            } else if ((this.isMouseDown || evtName === (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_UP) && this.fireDoubleClick) {
                this.fireDoubleClick = false;
                const cell = this.lastTouchCell;
                this.lastTouchCell = null;
                this.isMouseDown = false;
                // Workaround for Chrome/Safari not firing native double click events for double touch on background
                const valid = cell || ((0, $f192e93a2fd1153c$export$c4dfce035d43d1e0)(me.getEvent()) || (0, $f192e93a2fd1153c$export$147fc2f150568226)(me.getEvent())) && ((0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_GC || (0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_SF);
                if (valid && Math.abs(this.lastTouchX - me.getX()) < this.doubleTapTolerance && Math.abs(this.lastTouchY - me.getY()) < this.doubleTapTolerance) this.dblClick(me.getEvent(), cell);
                else (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).consume(me.getEvent());
                return;
            }
        }
        if (!this.isEventIgnored(evtName, me, sender)) {
            const state = me.getState();
            // Updates the event state via getEventState
            me.state = state ? this.getEventState(state) : null;
            this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).FIRE_MOUSE_EVENT, {
                eventName: evtName,
                event: me
            }));
            if ((0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_SF || (0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_GC || me.getEvent().target !== this.getContainer()) {
                const container = this.getContainer();
                if (evtName === (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_MOVE && this.isMouseDown && this.isAutoScroll() && !(0, $f192e93a2fd1153c$export$d06464d6b74eedc4)(me.getEvent())) this.scrollPointToVisible(me.getGraphX(), me.getGraphY(), this.isAutoExtend());
                else if (evtName === (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_UP && this.isIgnoreScrollbars() && this.isTranslateToScrollPosition() && (container.scrollLeft !== 0 || container.scrollTop !== 0)) {
                    const s = this.getView().scale;
                    const tr = this.getView().translate;
                    this.getView().setTranslate(tr.x - container.scrollLeft / s, tr.y - container.scrollTop / s);
                    container.scrollLeft = 0;
                    container.scrollTop = 0;
                }
                const mouseListeners = this.mouseListeners;
                // Does not change returnValue in Opera
                if (!me.getEvent().preventDefault) me.getEvent().returnValue = true;
                for (const l of mouseListeners)switch(evtName){
                    case (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_DOWN:
                        l.mouseDown(sender, me);
                        break;
                    case (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_MOVE:
                        l.mouseMove(sender, me);
                        break;
                    case (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_UP:
                        l.mouseUp(sender, me);
                        break;
                }
                // Invokes the click handler
                if (evtName === (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_UP) this.click(me);
            }
            // Detects tapAndHold events using a timer
            if (((0, $f192e93a2fd1153c$export$c4dfce035d43d1e0)(me.getEvent()) || (0, $f192e93a2fd1153c$export$147fc2f150568226)(me.getEvent())) && evtName === (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_DOWN && this.tapAndHoldEnabled && !this.tapAndHoldInProgress) {
                this.tapAndHoldInProgress = true;
                this.initialTouchX = me.getGraphX();
                this.initialTouchY = me.getGraphY();
                const handler = ()=>{
                    if (this.tapAndHoldValid) this.tapAndHold(me);
                    this.tapAndHoldInProgress = false;
                    this.tapAndHoldValid = false;
                };
                if (this.tapAndHoldThread) window.clearTimeout(this.tapAndHoldThread);
                this.tapAndHoldThread = window.setTimeout(handler, this.tapAndHoldDelay);
                this.tapAndHoldValid = true;
            } else if (evtName === (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_UP) {
                this.tapAndHoldInProgress = false;
                this.tapAndHoldValid = false;
            } else if (this.tapAndHoldValid) this.tapAndHoldValid = Math.abs(this.initialTouchX - me.getGraphX()) < this.tolerance && Math.abs(this.initialTouchY - me.getGraphY()) < this.tolerance;
            const cellEditorHandler = this.getPlugin('CellEditorHandler');
            // Stops editing for all events other than from cellEditorHandler
            if (evtName === (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_DOWN && this.isEditing() && !cellEditorHandler?.isEventSource(me.getEvent())) this.stopEditing(!this.isInvokesStopCellEditing());
            this.consumeMouseEvent(evtName, me, sender);
        }
    },
    consumeMouseEvent (evtName, me, sender) {
        sender = sender ?? this;
        // Workaround for duplicate click in Windows 8 with Chrome/FF/Opera with touch
        if (evtName === (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_DOWN && (0, $f192e93a2fd1153c$export$c4dfce035d43d1e0)(me.getEvent())) me.consume(false);
    },
    fireGestureEvent (evt, cell = null) {
        // Resets double tap event handling when gestures take place
        this.lastTouchTime = 0;
        this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).GESTURE, {
            event: evt,
            cell: cell
        }));
    },
    sizeDidChange () {
        // This method reads container-sizing members only (getBorder, getMinimumContainerSize, isResizeContainer,
        // doResizeContainer, isPreferPageSize, getPreferredPageSize, getMinimumGraphSize) plus updatePageBreaks, so it
        // looks like an obvious candidate to move to a dedicated sizing unit, away from the event concern of this mixin.
        // It cannot move to a plugin for now: AbstractGraph calls it from its constructor, from graphModelChanged and from
        // refresh, and none of these can depend on an optional plugin being registered. Extracting the members it reads
        // while leaving the caller behind would only turn this method into a chain of getPlugin()?. calls with fallbacks.
        // Relocating it to AbstractGraph itself remains possible and is the natural next step.
        const bounds = this.getGraphBounds();
        const border = this.getBorder();
        let width = Math.max(0, bounds.x) + bounds.width + 2 * border;
        let height = Math.max(0, bounds.y) + bounds.height + 2 * border;
        const minimumContainerSize = this.getMinimumContainerSize();
        if (minimumContainerSize) {
            width = Math.max(width, minimumContainerSize.width);
            height = Math.max(height, minimumContainerSize.height);
        }
        if (this.isResizeContainer()) this.doResizeContainer(width, height);
        if (this.isPreferPageSize() || this.isPageVisible()) {
            const size = this.getPreferredPageSize(bounds, Math.max(1, width), Math.max(1, height));
            width = size.width * this.getView().scale;
            height = size.height * this.getView().scale;
        }
        const minimumGraphSize = this.getMinimumGraphSize();
        if (minimumGraphSize) {
            width = Math.max(width, minimumGraphSize.width * this.getView().scale);
            height = Math.max(height, minimumGraphSize.height * this.getView().scale);
        }
        width = Math.ceil(width);
        height = Math.ceil(height);
        // @ts-ignore
        const root = this.getView().getDrawPane().ownerSVGElement;
        if (root) {
            root.style.minWidth = `${Math.max(1, width)}px`;
            root.style.minHeight = `${Math.max(1, height)}px`;
            root.style.width = '100%';
            root.style.height = '100%';
        }
        this.updatePageBreaks(this.isPageBreaksVisible(), width, height);
        this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).SIZE, {
            bounds: bounds
        }));
    },
    isCloneEvent (evt) {
        return (0, $f192e93a2fd1153c$export$aec581d3997aa3aa)(evt);
    },
    isTransparentClickEvent (evt) {
        return false;
    },
    isToggleEvent (evt) {
        return (0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_MAC ? (0, $f192e93a2fd1153c$export$77ae9bb78030b9bf)(evt) : (0, $f192e93a2fd1153c$export$aec581d3997aa3aa)(evt);
    },
    isGridEnabledEvent (evt) {
        return !(0, $f192e93a2fd1153c$export$bdc3218ff6eba0d8)(evt);
    },
    isConstrainedEvent (evt) {
        return (0, $f192e93a2fd1153c$export$1d7fd696f3493e74)(evt);
    },
    isIgnoreTerminalEvent (_evt) {
        return false;
    },
    getPointForEvent (evt, addOffset = true) {
        const p = (0, $b55d6ca3b42398e2$export$864dc177f7f5bda1)(this.getContainer(), (0, $f192e93a2fd1153c$export$87583e2c100c6a4f)(evt), (0, $f192e93a2fd1153c$export$195fc3609401443f)(evt));
        const s = this.getView().scale;
        const tr = this.getView().translate;
        const off = addOffset ? this.getGridSize() / 2 : 0;
        p.x = this.snap(p.x / s - tr.x - off);
        p.y = this.snap(p.y / s - tr.y - off);
        return p;
    },
    isEscapeEnabled () {
        return this.escapeEnabled;
    },
    setEscapeEnabled (value) {
        this.escapeEnabled = value;
    },
    isInvokesStopCellEditing () {
        return this.invokesStopCellEditing;
    },
    setInvokesStopCellEditing (value) {
        this.invokesStopCellEditing = value;
    },
    isEnterStopsCellEditing () {
        return this.enterStopsCellEditing;
    },
    setEnterStopsCellEditing (value) {
        this.enterStopsCellEditing = value;
    },
    getCursorForMouseEvent (me) {
        const cell = me.getCell();
        return cell ? this.getCursorForCell(cell) : null;
    }
};


/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 



/*
Copyright 2025-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
var $4vC7I = parcelRequire("4vC7I");
function $78efedcb0f6c688d$export$ee28232f9313fcdf() {
    return (0, $4vC7I.GlobalConfig).i18n.isEnabled();
}
function $78efedcb0f6c688d$export$d73ee8ef04f5226a(key, params, defaultValue) {
    return (0, $4vC7I.GlobalConfig).i18n.get(key, params, defaultValue);
}


const $befecb7e189e687e$export$b883829f60f9e1f8 = {
    collapseExpandResource: (0, $78efedcb0f6c688d$export$ee28232f9313fcdf)() ? 'collapse-expand' : '',
    getCollapseExpandResource () {
        return this.collapseExpandResource;
    },
    isFoldingEnabled () {
        return this.options.foldingEnabled;
    },
    getFoldableCells (cells, collapse = false) {
        return this.getDataModel().filterCells(cells, (cell)=>{
            return this.isCellFoldable(cell, collapse);
        });
    },
    isCellFoldable (cell, _collapse) {
        return cell.getChildCount() > 0 && (this.getCurrentCellStyle(cell).foldable ?? true);
    },
    getFoldingImage (state) {
        if (state != null && this.isFoldingEnabled() && !state.cell.isEdge()) {
            const tmp = state.cell.isCollapsed();
            if (this.isCellFoldable(state.cell, !tmp)) return tmp ? this.options.collapsedImage : this.options.expandedImage;
        }
        return null;
    },
    foldCells (collapse = false, recurse = false, cells = null, checkFoldable = false, _evt = null) {
        if (cells == null) cells = this.getFoldableCells(this.getSelectionCells(), collapse);
        this.stopEditing(false);
        this.batchUpdate(()=>{
            this.cellsFolded(cells, collapse, recurse, checkFoldable);
            this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).FOLD_CELLS, 'collapse', collapse, 'recurse', recurse, 'cells', cells));
        });
        return cells;
    },
    cellsFolded (cells = null, collapse = false, recurse = false, checkFoldable = false) {
        if (cells != null && cells.length > 0) this.batchUpdate(()=>{
            for(let i = 0; i < cells.length; i += 1)if ((!checkFoldable || this.isCellFoldable(cells[i], collapse)) && collapse !== cells[i].isCollapsed()) {
                this.getDataModel().setCollapsed(cells[i], collapse);
                this.swapBounds(cells[i], collapse);
                if (this.isExtendParent(cells[i])) this.extendParent(cells[i]);
                if (recurse) {
                    const children = cells[i].getChildren();
                    this.cellsFolded(children, collapse, recurse);
                }
                this.constrainChild(cells[i]);
            }
            this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CELLS_FOLDED, {
                cells: cells,
                collapse: collapse,
                recurse: recurse
            }));
        });
    },
    swapBounds (cell, willCollapse = false) {
        let geo = cell.getGeometry();
        if (geo != null) {
            geo = geo.clone();
            this.updateAlternateBounds(cell, geo, willCollapse);
            geo.swap();
            this.getDataModel().setGeometry(cell, geo);
        }
    },
    updateAlternateBounds (cell = null, geo = null, _willCollapse = false) {
        if (cell != null && geo != null) {
            const style = this.getCurrentCellStyle(cell);
            if (geo.alternateBounds == null) {
                let bounds = geo;
                if (this.options.collapseToPreferredSize) {
                    const tmp = this.getPreferredSizeForCell(cell);
                    if (tmp != null) {
                        bounds = tmp;
                        const startSize = style.startSize ?? 0;
                        if (startSize > 0) bounds.height = Math.max(bounds.height, startSize);
                    }
                }
                geo.alternateBounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(0, 0, bounds.width, bounds.height);
            }
            if (geo.alternateBounds != null) {
                geo.alternateBounds.x = geo.x;
                geo.alternateBounds.y = geo.y;
                const alpha = (0, $f7ff90b8964488a6$export$cba01ba138429a1d)(style.rotation || 0);
                if (alpha !== 0) {
                    const dx = geo.alternateBounds.getCenterX() - geo.getCenterX();
                    const dy = geo.alternateBounds.getCenterY() - geo.getCenterY();
                    const cos = Math.cos(alpha);
                    const sin = Math.sin(alpha);
                    const dx2 = cos * dx - sin * dy;
                    const dy2 = sin * dx + cos * dy;
                    geo.alternateBounds.x += dx2 - dx;
                    geo.alternateBounds.y += dy2 - dy;
                }
            }
        }
    }
};


/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 





const $387ae64630512a7b$export$1935de4be750391c = {
    groupCells (group, border = 0, cells) {
        if (!cells) cells = (0, $b55d6ca3b42398e2$export$35c9ae3c728354cd)(this.getSelectionCells(), true);
        if (!cells) cells = this.getCellsForGroup(cells);
        if (group == null) group = this.createGroupCell(cells);
        const bounds = this.getBoundsForGroup(group, cells, border);
        if (cells.length > 1 && bounds != null) {
            // Uses parent of group or previous parent of first child
            let parent = group.getParent();
            if (parent == null) parent = cells[0].getParent();
            this.batchUpdate(()=>{
                // Checks if the group has a geometry and
                // creates one if one does not exist
                if (group.getGeometry() == null) this.getDataModel().setGeometry(group, new (0, $6713282b00eec691$export$2e2bcd8739ae039)());
                // Adds the group into the parent
                let index = parent.getChildCount();
                this.cellsAdded([
                    group
                ], parent, index, null, null, false, false, false);
                // Adds the children into the group and moves
                index = group.getChildCount();
                this.cellsAdded(cells, group, index, null, null, false, false, false);
                this.cellsMoved(cells, -bounds.x, -bounds.y, false, false, false);
                // Resizes the group
                this.cellsResized([
                    group
                ], [
                    bounds
                ], false);
                this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).GROUP_CELLS, {
                    group: group,
                    border: border,
                    cells: cells
                }));
            });
        }
        return group;
    },
    getCellsForGroup (cells) {
        const result = [];
        if (cells != null && cells.length > 0) {
            const parent = cells[0].getParent();
            result.push(cells[0]);
            // Filters selection cells with the same parent
            for(let i = 1; i < cells.length; i += 1)if (cells[i].getParent() === parent) result.push(cells[i]);
        }
        return result;
    },
    getBoundsForGroup (group, children, border) {
        const result = this.getBoundingBoxFromGeometry(children, true);
        if (result != null) {
            if (this.isSwimlane(group)) {
                const size = this.getStartSize(group);
                result.x -= size.width;
                result.y -= size.height;
                result.width += size.width;
                result.height += size.height;
            }
            // Adds the border
            if (border != null) {
                result.x -= border;
                result.y -= border;
                result.width += 2 * border;
                result.height += 2 * border;
            }
        }
        return result;
    },
    createGroupCell (cells) {
        const group = new (0, $0e256159624f4593$export$2e2bcd8739ae039)('');
        group.setVertex(true);
        group.setConnectable(false);
        return group;
    },
    ungroupCells (cells) {
        let result = [];
        if (cells == null) cells = this.getCellsForUngroup();
        if (cells != null && cells.length > 0) this.batchUpdate(()=>{
            const _cells = cells;
            for(let i = 0; i < _cells.length; i += 1){
                let children = _cells[i].getChildren();
                if (children != null && children.length > 0) {
                    children = children.slice();
                    const parent = _cells[i].getParent();
                    const index = parent.getChildCount();
                    this.cellsAdded(children, parent, index, null, null, true);
                    result = result.concat(children);
                    // Fix relative child cells
                    for (const child of children){
                        const state = this.getView().getState(child);
                        let geo = child.getGeometry();
                        if (state != null && geo != null && geo.relative) {
                            geo = geo.clone();
                            geo.x = state.origin.x;
                            geo.y = state.origin.y;
                            geo.relative = false;
                            this.getDataModel().setGeometry(child, geo);
                        }
                    }
                }
            }
            this.removeCellsAfterUngroup(_cells);
            this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).UNGROUP_CELLS, {
                cells: cells
            }));
        });
        return result;
    },
    getCellsForUngroup () {
        const cells = this.getSelectionCells();
        // Finds the cells with children
        const tmp = [];
        for(let i = 0; i < cells.length; i += 1)if (cells[i].isVertex() && cells[i].getChildCount() > 0) tmp.push(cells[i]);
        return tmp;
    },
    removeCellsAfterUngroup (cells) {
        this.cellsRemoved(this.addAllEdges(cells));
    },
    removeCellsFromParent (cells) {
        if (cells == null) cells = this.getSelectionCells();
        this.batchUpdate(()=>{
            const parent = this.getDefaultParent();
            const index = parent.getChildCount();
            this.cellsAdded(cells, parent, index, null, null, true);
            this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).REMOVE_CELLS_FROM_PARENT, {
                cells: cells
            }));
        });
        return cells;
    },
    updateGroupBounds (cells, border = 0, moveGroup = false, topBorder = 0, rightBorder = 0, bottomBorder = 0, leftBorder = 0) {
        if (cells == null) cells = this.getSelectionCells();
        border = border != null ? border : 0;
        moveGroup = moveGroup != null ? moveGroup : false;
        topBorder = topBorder != null ? topBorder : 0;
        rightBorder = rightBorder != null ? rightBorder : 0;
        bottomBorder = bottomBorder != null ? bottomBorder : 0;
        leftBorder = leftBorder != null ? leftBorder : 0;
        this.batchUpdate(()=>{
            for(let i = cells.length - 1; i >= 0; i--){
                let geo = cells[i].getGeometry();
                if (geo == null) continue;
                const children = this.getChildCells(cells[i]);
                if (children != null && children.length > 0) {
                    const bounds = this.getBoundingBoxFromGeometry(children, true);
                    if (bounds != null && bounds.width > 0 && bounds.height > 0) {
                        // Adds the size of the title area for swimlanes
                        const size = this.isSwimlane(cells[i]) ? this.getActualStartSize(cells[i], true) : new (0, $2997c239141ea844$export$2e2bcd8739ae039)();
                        geo = geo.clone();
                        if (moveGroup) {
                            geo.x = Math.round(geo.x + bounds.x - border - size.x - leftBorder);
                            geo.y = Math.round(geo.y + bounds.y - border - size.y - topBorder);
                        }
                        geo.width = Math.round(bounds.width + 2 * border + size.x + leftBorder + rightBorder + size.width);
                        geo.height = Math.round(bounds.height + 2 * border + size.y + topBorder + bottomBorder + size.height);
                        this.getDataModel().setGeometry(cells[i], geo);
                        this.moveCells(children, border + size.x - bounds.x + leftBorder, border + size.y - bounds.y + topBorder);
                    }
                }
            }
        });
        return cells;
    },
    /*****************************************************************************
     * Group: Drilldown
     *****************************************************************************/ enterGroup (cell) {
        cell = cell || this.getSelectionCell();
        if (cell != null && this.isValidRoot(cell)) {
            this.getView().setCurrentRoot(cell);
            this.clearSelection();
        }
    },
    exitGroup () {
        const root = this.getDataModel().getRoot();
        const current = this.getCurrentRoot();
        if (current != null) {
            let next = current.getParent();
            // Finds the next valid root in the hierarchy
            while(next !== root && !this.isValidRoot(next) && next.getParent() !== root)next = next.getParent();
            // Clears the current root if the new root is
            // the model's root or one of the layers.
            if (next === root || next.getParent() === root) this.getView().setCurrentRoot(null);
            else this.getView().setCurrentRoot(next);
            const state = this.getView().getState(current);
            // Selects the previous root in the graph
            if (state != null) this.setSelectionCell(current);
        }
    }
};


/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ // @ts-expect-error The properties of PartialGraph are defined elsewhere.
const $2ec6cb622eeb3713$export$cbcd29e611f64d3f = {
    getLabel (cell) {
        let result = '';
        if (this.isLabelsVisible() && cell) {
            const style = this.getCurrentCellStyle(cell);
            if (!(style.noLabel ?? false)) result = this.convertValueToString(cell);
        }
        return result;
    },
    isHtmlLabel (_cell) {
        return this.isHtmlLabels();
    },
    labelsVisible: true,
    isLabelsVisible () {
        return this.labelsVisible;
    },
    htmlLabels: false,
    isHtmlLabels () {
        return this.htmlLabels;
    },
    setHtmlLabels (value) {
        this.htmlLabels = value;
    },
    isWrapping (cell) {
        return this.getCurrentCellStyle(cell).whiteSpace === 'wrap';
    },
    isLabelClipped (cell) {
        return this.getCurrentCellStyle(cell).overflow === 'hidden';
    },
    isLabelMovable (cell) {
        return !this.isCellLocked(cell) && (cell.isEdge() && this.isEdgeLabelsMovable() || cell.isVertex() && this.isVertexLabelsMovable());
    }
};


/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 


const $a89fae7908329d67$export$e1d4ed99a3ebf40c = {
    orderCells (back = false, cells) {
        if (!cells) cells = this.getSelectionCells();
        if (!cells) cells = (0, $b55d6ca3b42398e2$export$35c9ae3c728354cd)(this.getSelectionCells(), true);
        this.batchUpdate(()=>{
            this.cellsOrdered(cells, back);
            const event = new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).ORDER_CELLS, 'back', back, 'cells', cells);
            this.fireEvent(event);
        });
        return cells;
    },
    cellsOrdered (cells, back = false) {
        this.batchUpdate(()=>{
            for(let i = 0; i < cells.length; i += 1){
                const parent = cells[i].getParent();
                if (back) this.getDataModel().add(parent, cells[i], i);
                else this.getDataModel().add(parent, cells[i], parent ? parent.getChildCount() - 1 : 0);
            }
            this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CELLS_ORDERED, {
                back: back,
                cells: cells
            }));
        });
    }
};


/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 


/**
 * Extends {@link EventSource} to implement a graph overlay, represented by an icon and a tooltip.
 *
 * Overlays can handle and fire {@link InternalEvent.CLICK} events and are added to the graph using {@link AbstractGraph.addCellOverlay}, and removed using
 * {@link AbstractGraph.removeCellOverlay}, or {@link AbstractGraph.removeCellOverlays} to remove all overlays.
 * The {@link AbstractGraph.getCellOverlays} function returns the array of overlays for a given cell in a graph.
 * If multiple overlays exist for the same cell, then {@link getBounds} should be overridden in at least one of the overlays.
 *
 * Overlays appear on top of all cells in a special layer.
 * If this is not desirable, then the image must be rendered as part of the shape or label of the cell instead.
 *
 * For cell overlays to be printed, use {@link PrintPreview.printOverlays}.
 *
 * ### Example
 *
 * The following adds a new overlay for a given vertex and selects the cell if the overlay is clicked.
 *
 * ```javascript
 * const overlay = new CellOverlay(img, html);
 * graph.addCellOverlay(vertex, overlay);
 * overlay.addListener(InternalEvent.CLICK, (sender, evt) => {
 *   const cell = evt.getProperty('cell');
 *   graph.setSelectionCell(cell);
 * });
 * ```
 *
 * ### Events
 *
 * **{@link InternalEvent.CLICK}**
 *
 * Fires when the user clicks on the overlay.
 * In the {@link EventObject} parameter of the listener function:
 * - the `event` property contains the corresponding {@link MouseEvent}
 * - the `cell` property contains the {@link Cell}.
 *
 * For touch devices this is fired if the element receives a touchend event.
 */ class $8593e1ea2c3f81b5$var$CellOverlay extends (0, $17f25eceeba97548$export$2e2bcd8739ae039) {
    /**
     * Constructs a new overlay using the given image and tooltip.
     *
     * @param image {@link ImageBox} that represents the icon to be displayed.
     * @param tooltip Optional string that specifies the tooltip.
     * @param align Optional horizontal alignment for the overlay. Possible values are 'left', 'center' and 'right' (default).
     * @param verticalAlign Vertical alignment for the overlay. Possible values are 'top', 'middle' and 'bottom' (default).
     * @param offset Optional offset for positioning the overlay relative to its alignment. Scaled according to the current graph scale. Default is `new Point()`.
     * @param cursor Optional CSS cursor for the overlay. Default is `'help'`.
     */ constructor(image, tooltip = null, align = 'right', verticalAlign = 'bottom', offset = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(), cursor = 'help'){
        super();
        /**
         * Holds the horizontal alignment for the overlay.
         *
         * For edges, the overlay always appears in the center of the edge.
         * @default 'right'
         */ this.align = 'right';
        /**
         * Holds the vertical alignment for the overlay.
         *
         * For edges, the overlay always appears in the center of the edge.
         * @default 'bottom'
         */ this.verticalAlign = 'bottom';
        /**
         * Holds the offset as an {@link Point}. The offset will be scaled according to the current scale.
         */ this.offset = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)();
        /**
         * Holds the cursor for the overlay.
         * @default 'help'.
         */ this.cursor = 'help';
        /**
         * Defines the overlapping for the overlay, that is, the proportional distance from the origin to the point defined by the alignment.
         * @default 0.5
         */ this.defaultOverlap = 0.5;
        this.image = image;
        this.tooltip = tooltip;
        this.align = align;
        this.verticalAlign = verticalAlign;
        this.offset = offset;
        this.cursor = cursor;
    }
    /**
     * Returns the bounds of the overlay for the given {@link CellState} as an {@link Rectangle}.
     * This should be overridden when using multiple overlays per cell so that the overlays do not overlap.
     *
     * The following example will place the overlay along an edge (where x=[-1..1] from the start to the end of the edge
     * and y is the orthogonal offset in px).
     *
     * ```javascript
     * const overlayBounds = overlay.getBounds;
     * overlay.getBounds = function(state) {
     *   const bounds = overlayBounds.call(this, state);
     *
     *   if (state.view.graph.getDataModel().isEdge(state.cell)) {
     *     const pt = state.view.getPoint(state, {x: 0, y: 0, relative: true});
     *
     *     bounds.x = pt.x - bounds.width / 2;
     *     bounds.y = pt.y - bounds.height / 2;
     *   }
     *
     *   return bounds;
     * };
     * ```
     *
     * @param state {@link CellState} that represents the current state of the associated cell.
     */ getBounds(state) {
        const isEdge = state.cell.isEdge();
        const s = state.view.scale;
        let pt = null;
        const image = this.image;
        const w = image.width;
        const h = image.height;
        if (isEdge) {
            const pts = state.absolutePoints;
            if (pts.length % 2 === 1) pt = pts[Math.floor(pts.length / 2)];
            else {
                const idx = pts.length / 2;
                const p0 = pts[idx - 1];
                const p1 = pts[idx];
                pt = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(p0.x + (p1.x - p0.x) / 2, p0.y + (p1.y - p0.y) / 2);
            }
        } else {
            pt = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)();
            switch(this.align){
                case 'left':
                    pt.x = state.x;
                    break;
                case 'center':
                    pt.x = state.x + state.width / 2;
                    break;
                case 'right':
                    pt.x = state.x + state.width;
                    break;
                default:
                    throw new Error();
            }
            switch(this.verticalAlign){
                case 'top':
                    pt.y = state.y;
                    break;
                case 'middle':
                    pt.y = state.y + state.height / 2;
                    break;
                case 'bottom':
                    pt.y = state.y + state.height;
                    break;
                default:
                    throw new Error();
            }
        }
        return new (0, $2997c239141ea844$export$2e2bcd8739ae039)(Math.round(pt.x - (w * this.defaultOverlap - this.offset.x) * s), Math.round(pt.y - (h * this.defaultOverlap - this.offset.y) * s), w * s, h * s);
    }
    /**
     * Returns the textual representation of the overlay to be used as the tooltip.
     *
     * This implementation returns {@link tooltip}.
     */ toString() {
        return this.tooltip;
    }
}
var $8593e1ea2c3f81b5$export$2e2bcd8739ae039 = $8593e1ea2c3f81b5$var$CellOverlay;




const $5339067944edd54d$export$a75d9540456969a2 = {
    addCellOverlay (cell, overlay) {
        cell.overlays.push(overlay);
        // Immediately update the cell display if the state exists
        const state = this.getView().getState(cell);
        if (state) this.getCellRenderer().redraw(state);
        this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).ADD_OVERLAY, {
            cell: cell,
            overlay: overlay
        }));
        return overlay;
    },
    getCellOverlays (cell) {
        return cell.overlays;
    },
    removeCellOverlay (cell, overlay = null) {
        if (!overlay) this.removeCellOverlays(cell);
        else {
            const index = cell.overlays.indexOf(overlay);
            if (index >= 0) {
                cell.overlays.splice(index, 1);
                // Immediately updates the cell display if the state exists
                const state = this.getView().getState(cell);
                if (state) this.getCellRenderer().redraw(state);
                this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).REMOVE_OVERLAY, {
                    cell: cell,
                    overlay: overlay
                }));
            } else overlay = null;
        }
        return overlay;
    },
    removeCellOverlays (cell) {
        const { overlays: overlays } = cell;
        cell.overlays = [];
        // Immediately updates the cell display if the state exists
        const state = this.getView().getState(cell);
        if (state) this.getCellRenderer().redraw(state);
        for(let i = 0; i < overlays.length; i += 1)this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).REMOVE_OVERLAY, 'cell', cell, 'overlay', overlays[i]));
        return overlays;
    },
    clearCellOverlays (cell = null) {
        cell = cell ?? this.getDataModel().getRoot();
        if (!cell) return;
        this.removeCellOverlays(cell);
        // Recursively removes all overlays from the children
        const childCount = cell.getChildCount();
        for(let i = 0; i < childCount; i += 1){
            const child = cell.getChildAt(i);
            this.clearCellOverlays(child); // recurse
        }
    },
    setCellWarning (cell, warning = null, img, isSelect = false) {
        img = img ?? this.getWarningImage();
        if (warning && warning.length > 0) {
            // Creates the overlay with the image and warning
            const overlay = new (0, $8593e1ea2c3f81b5$export$2e2bcd8739ae039)(img, `<font color=red>${warning}</font>`);
            // Adds a handler for single mouseclicks to select the cell
            if (isSelect) overlay.addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CLICK, (sender, evt)=>{
                if (this.isEnabled()) this.setSelectionCell(cell);
            });
            // Sets and returns the overlay in the graph
            return this.addCellOverlay(cell, overlay);
        }
        this.removeCellOverlays(cell);
        return null;
    }
};


/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 

/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 

var $h5l15 = parcelRequire("h5l15");


var $cBHcM = parcelRequire("cBHcM");

/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
var $h5l15 = parcelRequire("h5l15");




var $cBHcM = parcelRequire("cBHcM");

/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 

var $cBHcM = parcelRequire("cBHcM");
/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /**
 * Converts relative and absolute URLs to absolute URLs with protocol and domain.
 */ class $b4c1a99b9450c5e8$var$UrlConverter {
    constructor(){
        /**
         * Specifies if the converter is enabled. Default is true.
         */ this.enabled = true;
        /**
         * Specifies the base URL to be used as a prefix for relative URLs.
         */ this.baseUrl = null;
        /**
         * Specifies the base domain to be used as a prefix for absolute URLs.
         */ this.baseDomain = null;
    // Empty constructor
    }
    /**
     * Private helper function to update the base URL.
     */ updateBaseUrl() {
        this.baseDomain = `${location.protocol}//${location.host}`;
        this.baseUrl = this.baseDomain + location.pathname;
        const tmp = this.baseUrl.lastIndexOf('/');
        // Strips filename etc
        if (tmp > 0) this.baseUrl = this.baseUrl.substring(0, tmp + 1);
    }
    /**
     * Returns <enabled>.
     */ isEnabled() {
        return this.enabled;
    }
    /**
     * Sets <enabled>.
     */ setEnabled(value) {
        this.enabled = value;
    }
    /**
     * Returns <baseUrl>.
     */ getBaseUrl() {
        return this.baseUrl;
    }
    /**
     * Sets <baseUrl>.
     */ setBaseUrl(value) {
        this.baseUrl = value;
    }
    /**
     * Returns <baseDomain>.
     */ getBaseDomain() {
        return this.baseDomain;
    }
    /**
     * Sets <baseDomain>.
     */ setBaseDomain(value) {
        this.baseDomain = value;
    }
    /**
     * Returns true if the given URL is relative.
     */ isRelativeUrl(url) {
        return url && url.substring(0, 2) !== '//' && url.substring(0, 7) !== 'http://' && url.substring(0, 8) !== 'https://' && url.substring(0, 10) !== 'data:image' && url.substring(0, 7) !== 'file://';
    }
    /**
     * Converts the given URL to an absolute URL with protol and domain.
     * Relative URLs are first converted to absolute URLs.
     */ convert(url) {
        if (this.isEnabled() && this.isRelativeUrl(url)) {
            if (!this.getBaseUrl()) this.updateBaseUrl();
            if (url.charAt(0) === '/') url = this.getBaseDomain() + url;
            else url = this.getBaseUrl() + url;
        }
        return url;
    }
}
var $b4c1a99b9450c5e8$export$2e2bcd8739ae039 = $b4c1a99b9450c5e8$var$UrlConverter;





var $4vC7I = parcelRequire("4vC7I");
/**
 * Base class for all canvases.
 *
 * The following methods make up the public interface of the canvas 2D for all painting in mxGraph:
 *
 * - {@link save}, {@link restore}
 * - {@link scale}, {@link translate}, {@link rotate}
 * - {@link setAlpha}, {@link setFillAlpha}, {@link setStrokeAlpha}, {@link setFillColor}, {@link setGradient},
 *   {@link setStrokeColor}, {@link setStrokeWidth}, {@link setDashed}, {@link setDashPattern}, {@link setLineCap},
 *   {@link setLineJoin}, {@link setMiterLimit}
 * - {@link setFontColor}, {@link setFontBackgroundColor}, {@link setFontBorderColor}, {@link setFontSize},
 *   {@link setFontFamily}, {@link setFontStyle}
 * - {@link setShadow}, {@link setShadowColor}, {@link setShadowAlpha}, {@link setShadowOffset}
 * - {@link rect}, {@link roundrect}, {@link ellipse}, {@link image}, {@link text}
 * - {@link begin}, {@link moveTo}, {@link lineTo}, {@link quadTo}, {@link curveTo}
 * - {@link stroke}, {@link fill}, {@link fillAndStroke}
 *
 * {@link arcTo} is an additional method for drawing paths.
 * This is a synthetic method, meaning that it is turned into a sequence of curves by default.
 * Subclasses may add native support for arcs.
 *
 * All color values of {@link NONE} will be converted to null in the state.
 */ class $e210c5e34817cc0a$var$AbstractCanvas2D {
    constructor(){
        /**
         * Holds the current state.
         */ this.state = this.createState();
        /**
         * Stack of states.
         */ this.states = [];
        /**
         * Holds the current path as an array.
         */ this.path = [];
        /**
         * Switch for rotation of HTML. Default is false.
         */ this.rotateHtml = true;
        /**
         * Holds the last x coordinate.
         */ this.lastX = 0;
        /**
         * Holds the last y coordinate.
         */ this.lastY = 0;
        /**
         * Contains the string used for moving in paths. Default is 'M'.
         */ this.moveOp = 'M';
        /**
         * Contains the string used for moving in paths. Default is 'L'.
         */ this.lineOp = 'L';
        /**
         * Contains the string used for quadratic paths. Default is 'Q'.
         */ this.quadOp = 'Q';
        /**
         * Contains the string used for bezier curves. Default is 'C'.
         */ this.curveOp = 'C';
        /**
         * Holds the operator for closing curves. Default is 'Z'.
         */ this.closeOp = 'Z';
        /**
         * Boolean value that specifies if events should be handled. Default is false.
         */ this.pointerEvents = false;
        // from Polyline (maybe from other shapes also)
        this.pointerEventsValue = null;
        /**
         * Adds the given operation to the path.
         */ this.addOp = (op, ...args)=>{
            this.path.push(op);
            if (args.length > 1) {
                const s = this.state;
                for(let i = 1; i < args.length; i += 2){
                    this.lastX = args[i - 1];
                    this.lastY = args[i];
                    this.path.push(this.format((this.lastX + s.dx) * s.scale));
                    this.path.push(this.format((this.lastY + s.dy) * s.scale));
                }
            }
        };
        this.converter = this.createUrlConverter();
        this.reset();
    }
    /**
     * Create a new <UrlConverter> and returns it.
     */ createUrlConverter() {
        return new (0, $b4c1a99b9450c5e8$export$2e2bcd8739ae039)();
    }
    /**
     * Resets the state of this canvas.
     */ reset() {
        this.state = this.createState();
        this.states = [];
    }
    /**
     * Creates the state of the this canvas.
     */ createState() {
        return {
            dx: 0,
            dy: 0,
            scale: 1,
            alpha: 1,
            fillAlpha: 1,
            strokeAlpha: 1,
            fillColor: (0, $cBHcM.NONE),
            gradientFillAlpha: 1,
            gradientColor: (0, $cBHcM.NONE),
            gradientAlpha: 1,
            gradientDirection: 'east',
            strokeColor: (0, $cBHcM.NONE),
            strokeWidth: 1,
            dashed: false,
            dashPattern: '3 3',
            fixDash: false,
            lineCap: 'flat',
            lineJoin: 'miter',
            miterLimit: 10,
            fontColor: '#000000',
            fontBackgroundColor: (0, $cBHcM.NONE),
            fontBorderColor: (0, $cBHcM.NONE),
            fontSize: (0, $4vC7I.StyleDefaultsConfig).fontSize,
            fontFamily: (0, $4vC7I.StyleDefaultsConfig).fontFamily,
            fontStyle: 0,
            shadow: false,
            shadowColor: (0, $4vC7I.StyleDefaultsConfig).shadowColor,
            shadowAlpha: (0, $4vC7I.StyleDefaultsConfig).shadowOpacity,
            shadowDx: (0, $4vC7I.StyleDefaultsConfig).shadowOffsetX,
            shadowDy: (0, $4vC7I.StyleDefaultsConfig).shadowOffsetY,
            rotation: 0,
            rotationCx: 0,
            rotationCy: 0
        };
    }
    /**
     * Rounds all numbers to integers.
     */ format(value) {
        return Math.round(value);
    }
    /**
     * Rotates the given point and returns the result as an {@link Point}.
     */ rotatePoint(x, y, theta, cx, cy) {
        const rad = theta * (Math.PI / 180);
        return (0, $f7ff90b8964488a6$export$ad2a0af3fbffd7c1)(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y), Math.cos(rad), Math.sin(rad), new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(cx, cy));
    }
    /**
     * Saves the current state.
     */ save() {
        this.states.push(this.state);
        this.state = (0, $a200c5dda16aedca$export$9cd59f9826255e47)(this.state);
    }
    /**
     * Restores the current state.
     */ restore() {
        const state = this.states.pop();
        if (state) this.state = state;
    }
    /**
     * Sets the current link. Hook for subclassers.
     */ setLink(link) {
    // nop
    }
    /**
     * Scales the current state.
     */ scale(value) {
        this.state.scale *= value;
        if (this.state.strokeWidth !== null) this.state.strokeWidth *= value;
    }
    /**
     * Translates the current state.
     */ translate(dx, dy) {
        this.state.dx += dx;
        this.state.dy += dy;
    }
    /**
     * Rotates the current state.
     */ rotate(theta, flipH, flipV, cx, cy) {
    // nop
    }
    /**
     * Sets the current alpha.
     */ setAlpha(value) {
        this.state.alpha = value;
    }
    /**
     * Sets the current solid fill alpha.
     */ setFillAlpha(value) {
        this.state.fillAlpha = value;
    }
    /**
     * Sets the current stroke alpha.
     */ setStrokeAlpha(value) {
        this.state.strokeAlpha = value;
    }
    /**
     * Sets the current fill color.
     */ setFillColor(value) {
        this.state.fillColor = value ?? (0, $cBHcM.NONE);
        this.state.gradientColor = (0, $cBHcM.NONE);
    }
    /**
     * Sets the current gradient.
     */ setGradient(color1, color2, x, y, w, h, direction, alpha1 = 1, alpha2 = 1) {
        const s = this.state;
        s.fillColor = color1;
        s.gradientFillAlpha = alpha1;
        s.gradientColor = color2;
        s.gradientAlpha = alpha2;
        s.gradientDirection = direction;
    }
    /**
     * Sets the current stroke color.
     */ setStrokeColor(value) {
        this.state.strokeColor = value ?? (0, $cBHcM.NONE);
    }
    /**
     * Sets the current stroke width.
     */ setStrokeWidth(value) {
        this.state.strokeWidth = value;
    }
    /**
     * Enables or disables dashed lines.
     */ setDashed(value, fixDash = false) {
        this.state.dashed = value;
        this.state.fixDash = fixDash;
    }
    /**
     * Sets the current dash pattern.
     */ setDashPattern(value) {
        this.state.dashPattern = value;
    }
    /**
     * Sets the current line cap.
     */ setLineCap(value) {
        this.state.lineCap = value;
    }
    /**
     * Sets the current line join.
     */ setLineJoin(value) {
        this.state.lineJoin = value;
    }
    /**
     * Sets the current miter limit.
     */ setMiterLimit(value) {
        this.state.miterLimit = value;
    }
    /**
     * Sets the current font color.
     */ setFontColor(value) {
        this.state.fontColor = value ?? (0, $cBHcM.NONE);
    }
    /**
     * Sets the current font background color.
     */ setFontBackgroundColor(value) {
        this.state.fontBackgroundColor = value ?? (0, $cBHcM.NONE);
    }
    /**
     * Sets the current font border color.
     */ setFontBorderColor(value) {
        this.state.fontBorderColor = value ?? (0, $cBHcM.NONE);
    }
    /**
     * Sets the current font size.
     */ setFontSize(value) {
        this.state.fontSize = value;
    }
    /**
     * Sets the current font family.
     */ setFontFamily(value) {
        this.state.fontFamily = value;
    }
    /**
     * Sets the current font style.
     */ setFontStyle(value) {
        this.state.fontStyle = value;
    }
    /**
     * Enables or disables and configures the current shadow.
     */ setShadow(enabled) {
        this.state.shadow = enabled;
    }
    /**
     * Sets the current shadow color.
     *
     * @param value Hexadecimal representation of the color or `none`.
     */ setShadowColor(value) {
        this.state.shadowColor = value ?? (0, $cBHcM.NONE);
    }
    /**
     * Sets the current shadow alpha.
     *
     * @param value Number that represents the new alpha. Possible values are between 1 (opaque) and 0 (transparent).
     */ setShadowAlpha(value) {
        this.state.shadowAlpha = value;
    }
    /**
     * Sets the current shadow offset.
     *
     * @param dx Number that represents the horizontal offset of the shadow.
     * @param dy Number that represents the vertical offset of the shadow.
     */ setShadowOffset(dx, dy) {
        this.state.shadowDx = dx;
        this.state.shadowDy = dy;
    }
    /**
     * Starts a new path.
     */ begin() {
        this.lastX = 0;
        this.lastY = 0;
        this.path = [];
    }
    /**
     *  Moves the current path the given coordinates.
     */ moveTo(x, y) {
        this.addOp(this.moveOp, x, y);
    }
    /**
     * Draws a line to the given coordinates. Uses moveTo with the op argument.
     */ lineTo(x, y) {
        this.addOp(this.lineOp, x, y);
    }
    /**
     * Adds a quadratic curve to the current path.
     */ quadTo(x1, y1, x2, y2) {
        this.addOp(this.quadOp, x1, y1, x2, y2);
    }
    /**
     * Adds a bezier curve to the current path.
     */ curveTo(x1, y1, x2, y2, x3, y3) {
        this.addOp(this.curveOp, x1, y1, x2, y2, x3, y3);
    }
    /**
     * Adds the given arc to the current path. This is a synthetic operation that
     * is broken down into curves.
     * @param rx: The x distance between the current position
     *            and the center of the ellipse around which to arc
     * @param ry: The y distance between the current position
     *            and the center of the ellipse around which to arc
     * @param x: The x position of the end point of the arc
     * @param y: The y position of the end point of the arc
     */ arcTo(rx, ry, angle, largeArcFlag, sweepFlag, x, y) {
        const curves = (0, $f7ff90b8964488a6$export$a434bae21ada3b6b)(this.lastX, this.lastY, rx, ry, angle, largeArcFlag, sweepFlag, x, y);
        if (curves != null) for(let i = 0; i < curves.length; i += 6)this.curveTo(curves[i], curves[i + 1], curves[i + 2], curves[i + 3], curves[i + 4], curves[i + 5]);
    }
    /**
     * Closes the current path.
     */ close(x1, y1, x2, y2, x3, y3) {
        this.addOp(this.closeOp);
    }
}
var $e210c5e34817cc0a$export$2e2bcd8739ae039 = $e210c5e34817cc0a$var$AbstractCanvas2D;


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
var $cBHcM = parcelRequire("cBHcM");



var $h5l15 = parcelRequire("h5l15");
const $f26d63937b34ab64$export$734053adc8964b61 = ()=>{
    return document.implementation.createDocument('', '', null);
};
const $f26d63937b34ab64$export$60ca78d2e670be93 = (xmlString)=>{
    return new DOMParser().parseFromString(xmlString, 'text/xml');
};
const $f26d63937b34ab64$export$4084de0f62de36b0 = (node, linefeed = '&#xa;')=>{
    const xmlSerializer = new XMLSerializer();
    let xml = xmlSerializer.serializeToString(node);
    // Replaces linefeed with HTML Entities.
    xml = xml.replace(/\n/g, linefeed);
    return xml;
};
const $f26d63937b34ab64$export$3540a4f59b307278 = (node, tab = '  ', indent = '', newline = '\n', ns = null)=>{
    const result = [];
    if (node != null) {
        if (node.namespaceURI != null && node.namespaceURI !== ns) {
            ns = node.namespaceURI;
            if (node.getAttribute('xmlns') == null) node.setAttribute('xmlns', node.namespaceURI);
        }
        switch(node.nodeType){
            case (0, $cBHcM.NODE_TYPE).DOCUMENT:
                result.push($f26d63937b34ab64$export$3540a4f59b307278(node.documentElement, tab, indent, newline, ns));
                break;
            case (0, $cBHcM.NODE_TYPE).DOCUMENT_FRAGMENT:
                {
                    let tmp = node.firstChild;
                    if (tmp != null) while(tmp != null){
                        result.push($f26d63937b34ab64$export$3540a4f59b307278(tmp, tab, indent, newline, ns));
                        tmp = tmp.nextSibling;
                    }
                    break;
                }
            case (0, $cBHcM.NODE_TYPE).COMMENT:
                {
                    const value = (0, $b1d29c834e82fef5$export$132e79e4118a78e0)(node);
                    if (value.length > 0) result.push(`${indent}<!--${value}-->${newline}`);
                    break;
                }
            case (0, $cBHcM.NODE_TYPE).TEXT:
                {
                    const value = (0, $6bb3a85a9cf63e97$export$87c2784dc9fc4ab)((0, $b1d29c834e82fef5$export$132e79e4118a78e0)(node));
                    if (value && value.length > 0) result.push(indent + (0, $6bb3a85a9cf63e97$export$324699496a105db8)(value, false) + newline);
                    break;
                }
            case (0, $cBHcM.NODE_TYPE).CDATA:
                {
                    const value = (0, $b1d29c834e82fef5$export$132e79e4118a78e0)(node);
                    if (value.length > 0) result.push(`${indent}<![CDATA[${value}]]${newline}`);
                    break;
                }
            default:
                {
                    result.push(`${indent}<${node.nodeName}`);
                    // Creates the string with the node attributes
                    // and converts all HTML entities in the values
                    const attrs = node.attributes;
                    if (attrs != null) for(let i = 0; i < attrs.length; i += 1){
                        const val = (0, $6bb3a85a9cf63e97$export$324699496a105db8)(attrs[i].value);
                        result.push(` ${attrs[i].nodeName}="${val}"`);
                    }
                    // Recursively creates the XML string for each child
                    // node and appends it here with an indentation
                    let tmp = node.firstChild;
                    if (tmp != null) {
                        result.push(`>${newline}`);
                        while(tmp != null){
                            result.push($f26d63937b34ab64$export$3540a4f59b307278(tmp, tab, indent + tab, newline, ns));
                            tmp = tmp.nextSibling;
                        }
                        result.push(`${indent}</${node.nodeName}>${newline}`);
                    } else result.push(` />${newline}`);
                }
        }
    }
    return result.join('');
};
const $f26d63937b34ab64$export$5b92d7a8b5d33ee2 = (node, attr, value)=>{
    if ((0, $h5l15.isElement)(node)) {
        const tmp = node.getAttribute(attr);
        if (tmp && tmp === value) return node;
    }
    node = node.firstChild;
    while(node){
        const result = $f26d63937b34ab64$export$5b92d7a8b5d33ee2(node, attr, value);
        if (result) return result;
        node = node.nextSibling;
    }
    return null;
};





var $4vC7I = parcelRequire("4vC7I");
// Activates workaround for gradient ID resolution if base tag is used.
const $f0b9bd90b7bd8dd2$var$useAbsoluteIds = typeof DOMParser === 'function' && !(0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_CHROMEAPP && !(0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_EDGE && document.getElementsByTagName('base').length > 0;
/**
 * Extends {@link AbstractCanvas2D} to implement a canvas for SVG.
 * This canvas writes all calls as SVG output to the given SVG root node.
 *
 * ```javascript
 * const svgDoc = xmlUtils.createXmlDocument();
 * const root = svgDoc.createElementNS ?
 * 		svgDoc.createElementNS(constants.NS_SVG, 'svg') : svgDoc.createElement('svg');
 *
 * if (!svgDoc.createElementNS) {
 *   root.setAttribute('xmlns', constants.NS_SVG);
 *   root.setAttribute('xmlns:xlink', constants.NS_XLINK);
 * } else {
 *   root.setAttributeNS('http://www.w3.org/2000/xmlns/', 'xmlns:xlink', constants.NS_XLINK);
 * }
 *
 * const bounds = graph.getGraphBounds();
 * root.setAttribute('width', (bounds.x + bounds.width + 4) + 'px');
 * root.setAttribute('height', (bounds.y + bounds.height + 4) + 'px');
 * root.setAttribute('version', '1.1');
 *
 * svgDoc.appendChild(root);
 *
 * const svgCanvas = new mxSvgCanvas2D(root);
 * ```
 *
 *
 * To disable anti-aliasing in the output, use the following code.
 * ```javascript
 * graph.view.canvas.ownerSVGElement.setAttribute('shape-rendering', 'crispEdges');
 * ```
 * Or set the respective attribute in the SVG element directly.
 */ class $f0b9bd90b7bd8dd2$var$SvgCanvas2D extends (0, $e210c5e34817cc0a$export$2e2bcd8739ae039) {
    constructor(root, styleEnabled){
        super();
        this.defs = null;
        this.styleEnabled = true;
        /**
         * Holds the current DOM node.
         */ this.node = null;
        /**
         * Specifies if plain text output should match the vertical HTML alignment.
         * @default true.
         */ this.matchHtmlAlignment = true;
        /**
         * Specifies if text output should be enabled.
         * @default true
         */ this.textEnabled = true;
        /**
         * Specifies if use of foreignObject for HTML markup is allowed.
         * @default true
         */ this.foEnabled = true;
        /**
         * Specifies the fallback text for unsupported foreignObjects in exported documents.
         * If this is set to `null` then no fallback text is added to the exported document.
         * @default [Object]
         */ this.foAltText = '[Object]';
        /**
         * Offset to be used for foreignObjects.
         * @default 0
         */ this.foOffset = 0;
        /**
         * Offset to be used for text elements.
         * @default 0
         */ this.textOffset = 0;
        /**
         * Offset to be used for image elements.
         * @default 0
         */ this.imageOffset = 0;
        /**
         * Adds transparent paths for strokes.
         * @default 0
         */ this.strokeTolerance = 0;
        /**
         * Minimum stroke width for output.
         * @default 1
         */ this.minStrokeWidth = 1;
        /**
         * Local counter for references in SVG export.
         * @default 0
         */ this.refCount = 0;
        /**
         * Correction factor for {@link LINE_HEIGHT} in HTML output.
         * @default 1
         */ this.lineHeightCorrection = 1;
        /**
         * Default value for active pointer events.
         * @default all
         */ this.pointerEventsValue = 'all';
        /**
         * Padding to be added for text that is not wrapped to account for differences in font metrics on different platforms in pixels.
         * @default 10.
         */ this.fontMetricsPadding = 10;
        /**
         * Specifies if offsetWidth and offsetHeight should be cached. This is used to speed up repaint of text in {@link updateText}.
         * @default true
         */ this.cacheOffsetSize = true;
        this.originalRoot = null;
        /**
         * Reference to the container for the SVG content.
         */ this.root = root;
        /**
         * Local cache of gradients for quick lookups.
         */ this.gradients = {};
        /**
         * Reference to the defs section of the SVG document. Only for export.
         */ this.defs = null;
        /**
         * Stores the value of styleEnabled passed to the constructor.
         */ this.styleEnabled = styleEnabled != null ? styleEnabled : false;
        let svg = null;
        // Adds optional defs section for export
        if (root.ownerDocument !== document) {
            let node = root;
            // Finds owner SVG element in XML DOM
            while(node && node.nodeName !== 'svg')node = node.parentElement;
            svg = node;
        }
        if (svg) {
            // Tries to get existing defs section
            const tmp = svg.getElementsByTagName('defs');
            if (tmp.length > 0) this.defs = svg.getElementsByTagName('defs')[0];
            // Adds defs section if none exists
            if (!this.defs) {
                this.defs = this.createElement('defs');
                if (svg.firstChild != null) svg.insertBefore(this.defs, svg.firstChild);
                else svg.appendChild(this.defs);
            }
            // Adds stylesheet
            if (this.styleEnabled) this.defs.appendChild(this.createStyle());
        }
    }
    /**
     * Rounds all numbers to 2 decimal points.
     */ format(value) {
        return Number.parseFloat(value.toFixed(2));
    }
    /**
     * Returns the URL of the page without the hash part. This needs to use href to
     * include any search part with no params (ie question mark alone). This is a
     * workaround for the fact that window.location.search is empty if there is
     * no search string behind the question mark.
     */ getBaseUrl() {
        let { href: href } = window.location;
        const hash = href.lastIndexOf('#');
        if (hash > 0) href = href.substring(0, hash);
        return href;
    }
    /**
     * Returns any offsets for rendering pixels.
     */ reset() {
        super.reset();
        this.gradients = {};
    }
    end() {
        return;
    }
    /**
     * Creates the optional style section.
     */ createStyle() {
        const style = this.createElement('style');
        style.setAttribute('type', 'text/css');
        (0, $b1d29c834e82fef5$export$68d8715fc104d294)(style, `svg{font-family:${(0, $4vC7I.StyleDefaultsConfig).fontFamily};font-size:${(0, $4vC7I.StyleDefaultsConfig).fontSize};fill:none;stroke-miterlimit:10}`);
        return style;
    }
    /**
     * Private helper function to create SVG elements
     */ createElement(tagName, namespace) {
        return this.root?.ownerDocument.createElementNS(namespace || (0, $cBHcM.NS_SVG), tagName);
    }
    /**
     * Returns the alternate text string for the given foreignObject.
     */ getAlternateText(fo, x, y, w, h, str, align, valign, wrap, format, overflow, clip, rotation) {
        return !(0, $h5l15.isNullish)(str) ? this.foAltText : null;
    }
    /**
     * Returns the alternate content for the given foreignObject.
     */ createAlternateContent(fo, x, y, w, h, str, align, valign, wrap, format, overflow, clip, rotation) {
        const text = this.getAlternateText(fo, x, y, w, h, str, align, valign, wrap, format, overflow, clip, rotation);
        const s = this.state;
        if (!(0, $h5l15.isNullish)(text) && s.fontSize > 0) {
            const dy = valign === 'top' ? 1 : valign === 'bottom' ? 0 : 0.3;
            const anchor = align === 'right' ? 'end' : align === 'left' ? 'start' : 'middle';
            const alt = this.createElement('text');
            alt.setAttribute('x', String(Math.round(x + s.dx)));
            alt.setAttribute('y', String(Math.round(y + s.dy + dy * s.fontSize)));
            alt.setAttribute('fill', s.fontColor || 'black');
            alt.setAttribute('font-family', s.fontFamily);
            alt.setAttribute('font-size', `${Math.round(s.fontSize)}px`);
            // Text-anchor start is default in SVG
            anchor !== 'start' && alt.setAttribute('text-anchor', anchor);
            const fontStyle = s.fontStyle;
            (0, $h5l15.matchBinaryMask)(fontStyle, (0, $cBHcM.FONT_STYLE_MASK).BOLD) && alt.setAttribute('font-weight', 'bold');
            (0, $h5l15.matchBinaryMask)(fontStyle, (0, $cBHcM.FONT_STYLE_MASK).ITALIC) && alt.setAttribute('font-style', 'italic');
            const txtDecor = [];
            (0, $h5l15.matchBinaryMask)(fontStyle, (0, $cBHcM.FONT_STYLE_MASK).UNDERLINE) && txtDecor.push('underline');
            (0, $h5l15.matchBinaryMask)(fontStyle, (0, $cBHcM.FONT_STYLE_MASK).STRIKETHROUGH) && txtDecor.push('line-through');
            txtDecor.length > 0 && alt.setAttribute('text-decoration', txtDecor.join(' '));
            (0, $b1d29c834e82fef5$export$68d8715fc104d294)(alt, text);
            return alt;
        }
        return null;
    }
    /**
     * Private helper function to create SVG elements
     */ createGradientId(start, end, alpha1, alpha2, direction) {
        // Removes illegal characters from gradient ID
        if (start.charAt(0) === '#') start = start.substring(1);
        if (end.charAt(0) === '#') end = end.substring(1);
        // Workaround for gradient IDs not working in Safari 5 / Chrome 6
        // if they contain uppercase characters
        start = `${start.toLowerCase()}-${alpha1}`;
        end = `${end.toLowerCase()}-${alpha2}`;
        // Wrong gradient directions possible?
        let dir = null;
        if (direction == null || direction === 'south') dir = 's';
        else if (direction === 'east') dir = 'e';
        else {
            const tmp = start;
            start = end;
            end = tmp;
            if (direction === 'north') dir = 's';
            else if (direction === 'west') dir = 'e';
        }
        return `mx-gradient-${start}-${end}-${dir}`;
    }
    /**
     * Private helper function to create SVG elements
     */ getSvgGradient(start, end, alpha1, alpha2, direction) {
        const id = this.createGradientId(start, end, alpha1, alpha2, direction);
        let gradient = this.gradients[id];
        if (!gradient) {
            const svg = this.root.ownerSVGElement;
            let counter = 0;
            let tmpId = `${id}-${counter}`;
            if (svg) {
                gradient = svg.ownerDocument.getElementById(tmpId);
                while(gradient && gradient.ownerSVGElement !== svg){
                    tmpId = `${id}-${counter++}`;
                    gradient = svg.ownerDocument.getElementById(tmpId);
                }
            } else // Uses shorter IDs for export
            tmpId = `id${++this.refCount}`;
            if (!gradient) {
                gradient = this.createSvgGradient(start, end, alpha1, alpha2, direction);
                gradient.setAttribute('id', tmpId);
                if (this.defs) this.defs.appendChild(gradient);
                else if (svg) svg.appendChild(gradient);
            }
            this.gradients[id] = gradient;
        }
        return gradient.getAttribute('id');
    }
    /**
     * Creates the given SVG gradient.
     */ createSvgGradient(start, end, alpha1, alpha2, direction) {
        const gradient = this.createElement('linearGradient');
        gradient.setAttribute('x1', '0%');
        gradient.setAttribute('y1', '0%');
        gradient.setAttribute('x2', '0%');
        gradient.setAttribute('y2', '0%');
        if (direction == null || direction === 'south') gradient.setAttribute('y2', '100%');
        else switch(direction){
            case 'east':
                gradient.setAttribute('x2', '100%');
                break;
            case 'north':
                gradient.setAttribute('y1', '100%');
                break;
            case 'west':
                gradient.setAttribute('x1', '100%');
                break;
        }
        let op = alpha1 < 1 ? `;stop-opacity:${alpha1}` : '';
        let stop = this.createElement('stop');
        stop.setAttribute('offset', '0%');
        stop.setAttribute('style', `stop-color:${start}${op}`);
        gradient.appendChild(stop);
        op = alpha2 < 1 ? `;stop-opacity:${alpha2}` : '';
        stop = this.createElement('stop');
        stop.setAttribute('offset', '100%');
        stop.setAttribute('style', `stop-color:${end}${op}`);
        gradient.appendChild(stop);
        return gradient;
    }
    /**
     * Private helper function to create SVG elements
     */ addNode(filled, stroked) {
        const { node: node } = this;
        const s = this.state;
        if (node) {
            if (node.nodeName === 'path') {
                // Checks if the path is not empty
                if (this.path && this.path.length > 0) node.setAttribute('d', this.path.join(' '));
                else return;
            }
            if (filled && s.fillColor !== (0, $cBHcM.NONE)) this.updateFill();
            else if (!this.styleEnabled) {
                // Workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=814952
                if (node.nodeName === 'ellipse' && (0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_FF) node.setAttribute('fill', 'transparent');
                else node.setAttribute('fill', (0, $cBHcM.NONE));
                // Sets the actual filled state for stroke tolerance
                filled = false;
            }
            if (stroked && s.strokeColor !== (0, $cBHcM.NONE)) this.updateStroke();
            else if (!this.styleEnabled) node.setAttribute('stroke', (0, $cBHcM.NONE));
            if (s.transform && s.transform.length > 0) node.setAttribute('transform', s.transform);
            if (s.shadow) this.root.appendChild(this.createShadow(node));
            // Adds stroke tolerance
            if (this.strokeTolerance > 0 && !filled) this.root.appendChild(this.createTolerance(node));
            // Adds pointer events
            if (this.pointerEvents) node.setAttribute('pointer-events', this.pointerEventsValue);
            else if (!this.pointerEvents && !this.originalRoot) node.setAttribute('pointer-events', (0, $cBHcM.NONE));
            // Removes invisible nodes from output if they don't handle events
            if (node.nodeName !== 'rect' && node.nodeName !== 'path' && node.nodeName !== 'ellipse' || node.getAttribute('fill') !== (0, $cBHcM.NONE) && node.getAttribute('fill') !== 'transparent' || node.getAttribute('stroke') !== (0, $cBHcM.NONE) || node.getAttribute('pointer-events') !== (0, $cBHcM.NONE)) // LATER: Update existing DOM for performance
            this.root.appendChild(node);
            this.node = null;
        }
    }
    /**
     * Transfers the stroke attributes from <state> to <node>.
     */ updateFill() {
        const s = this.state;
        if (s.alpha < 1 || s.fillAlpha < 1) this.node.setAttribute('fill-opacity', String(s.alpha * s.fillAlpha));
        if (s.fillColor !== (0, $cBHcM.NONE)) {
            if (s.gradientColor !== (0, $cBHcM.NONE)) {
                const id = this.getSvgGradient(s.fillColor, s.gradientColor, s.gradientFillAlpha, s.gradientAlpha, s.gradientDirection);
                if (this.root?.ownerDocument === document && $f0b9bd90b7bd8dd2$var$useAbsoluteIds) {
                    // Workaround for no fill with base tag in page (escape brackets)
                    const base = this.getBaseUrl().replace(/([()])/g, '\\$1');
                    this.node.setAttribute('fill', `url(${base}#${id})`);
                } else this.node.setAttribute('fill', `url(#${id})`);
            } else this.node.setAttribute('fill', s.fillColor.toLowerCase());
        }
    }
    /**
     * Returns the current stroke width (>= 1), ie. max(1, this.format(this.state.strokeWidth * this.state.scale)).
     */ getCurrentStrokeWidth() {
        return Math.max(this.minStrokeWidth, Math.max(0.01, this.format(this.state.strokeWidth * this.state.scale)));
    }
    /**
     * Transfers the stroke attributes from {@link AbstractCanvas2D.state} to {@link node}.
     */ updateStroke() {
        const s = this.state;
        if (s.strokeColor && s.strokeColor !== (0, $cBHcM.NONE)) this.node.setAttribute('stroke', s.strokeColor.toLowerCase());
        if (s.alpha < 1 || s.strokeAlpha < 1) this.node.setAttribute('stroke-opacity', String(s.alpha * s.strokeAlpha));
        const sw = this.getCurrentStrokeWidth();
        if (sw !== 1) this.node.setAttribute('stroke-width', String(sw));
        if (this.node.nodeName === 'path') this.updateStrokeAttributes();
        if (s.dashed) this.node.setAttribute('stroke-dasharray', this.createDashPattern((s.fixDash ? 1 : s.strokeWidth) * s.scale));
    }
    /**
     * Transfers the stroke attributes from {@link AbstractCanvas2D.state} to {@link node}.
     */ updateStrokeAttributes() {
        const s = this.state;
        // Linejoin miter is default in SVG
        if (s.lineJoin && s.lineJoin !== 'miter') this.node.setAttribute('stroke-linejoin', s.lineJoin);
        if (s.lineCap) {
            // flat is called butt in SVG
            let value = s.lineCap;
            if (value === 'flat') value = 'butt';
            // Linecap butt is default in SVG
            if (value !== 'butt') this.node.setAttribute('stroke-linecap', value);
        }
        // Miterlimit 10 is default in our document
        if (s.miterLimit != null && (!this.styleEnabled || s.miterLimit !== 10)) this.node.setAttribute('stroke-miterlimit', String(s.miterLimit));
    }
    /**
     * Creates the SVG dash pattern for the given state.
     */ createDashPattern(scale) {
        const pat = [];
        if (typeof this.state.dashPattern === 'string') {
            const dash = this.state.dashPattern.split(' ');
            if (dash.length > 0) for(let i = 0; i < dash.length; i += 1)pat[i] = Number(dash[i]) * scale;
        }
        return pat.join(' ');
    }
    /**
     * Creates a hit detection tolerance shape for the given node.
     */ createTolerance(node) {
        const tol = node.cloneNode(true);
        const sw = Number.parseFloat(tol.getAttribute('stroke-width') || '1') + this.strokeTolerance;
        tol.setAttribute('pointer-events', 'stroke');
        tol.setAttribute('visibility', 'hidden');
        tol.removeAttribute('stroke-dasharray');
        tol.setAttribute('stroke-width', String(sw));
        tol.setAttribute('fill', 'none');
        tol.setAttribute('stroke', 'white');
        return tol;
    }
    /**
     * Creates a shadow for the given node.
     */ createShadow(node) {
        const shadow = node.cloneNode(true);
        const s = this.state;
        // Firefox uses transparent for no fill in ellipses
        if (shadow.getAttribute('fill') !== 'none' && (!(0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_FF || shadow.getAttribute('fill') !== 'transparent')) shadow.setAttribute('fill', s.shadowColor);
        if (shadow.getAttribute('stroke') !== 'none' && s.shadowColor && s.shadowColor !== (0, $cBHcM.NONE)) shadow.setAttribute('stroke', s.shadowColor);
        shadow.setAttribute('transform', `translate(${this.format(s.shadowDx * s.scale)},${this.format(s.shadowDy * s.scale)})${s.transform || ''}`);
        shadow.setAttribute('opacity', String(s.shadowAlpha));
        return shadow;
    }
    /**
     * Experimental implementation for hyperlinks.
     */ setLink(link) {
        if (!link) this.root = this.originalRoot;
        else {
            this.originalRoot = this.root;
            const node = this.createElement('a');
            // Workaround for implicit namespace handling in HTML5 export, IE adds NS1 namespace so use code below
            // in all IE versions except quirks mode. KNOWN: Adds xlink namespace to each image tag in output.
            if (node.setAttributeNS == null || this.root.ownerDocument !== document) node.setAttribute('xlink:href', link);
            else node.setAttributeNS((0, $cBHcM.NS_XLINK), 'xlink:href', link);
            this.root.appendChild(node);
            this.root = node;
        }
    }
    /**
     * Sets the rotation of the canvas. Note that rotation cannot be concatenated.
     */ rotate(theta, flipH, flipV, cx, cy) {
        if (theta !== 0 || flipH || flipV) {
            const s = this.state;
            cx += s.dx;
            cy += s.dy;
            cx *= s.scale;
            cy *= s.scale;
            s.transform = s.transform || '';
            // This implementation uses custom scale/translate and built-in rotation
            // Rotation state is part of the AffineTransform in state.transform
            if (flipH && flipV) theta += 180;
            else if (flipH !== flipV) {
                const tx = flipH ? cx : 0;
                const sx = flipH ? -1 : 1;
                const ty = flipV ? cy : 0;
                const sy = flipV ? -1 : 1;
                s.transform += `translate(${this.format(tx)},${this.format(ty)})` + `scale(${this.format(sx)},${this.format(sy)})` + `translate(${this.format(-tx)},${this.format(-ty)})`;
            }
            if (flipH ? !flipV : flipV) theta *= -1;
            if (theta !== 0) s.transform += `rotate(${this.format(theta)},${this.format(cx)},${this.format(cy)})`;
            s.rotation += theta;
            s.rotationCx = cx;
            s.rotationCy = cy;
        }
    }
    /**
     * Begins a new path.
     */ begin() {
        super.begin();
        this.node = this.createElement('path');
    }
    /**
     * Private helper function to create SVG elements
     */ rect(x, y, w, h) {
        const s = this.state;
        const n = this.createElement('rect');
        n.setAttribute('x', String(this.format((x + s.dx) * s.scale)));
        n.setAttribute('y', String(this.format((y + s.dy) * s.scale)));
        n.setAttribute('width', String(this.format(w * s.scale)));
        n.setAttribute('height', String(this.format(h * s.scale)));
        this.node = n;
    }
    /**
     * Private helper function to create SVG elements
     */ roundrect(x, y, w, h, dx, dy) {
        this.rect(x, y, w, h);
        if (dx > 0) this.node.setAttribute('rx', String(this.format(dx * this.state.scale)));
        if (dy > 0) this.node.setAttribute('ry', String(this.format(dy * this.state.scale)));
    }
    /**
     * Private helper function to create SVG elements
     */ ellipse(x, y, w, h) {
        const s = this.state;
        const n = this.createElement('ellipse');
        // No rounding for consistent output with 1.x
        n.setAttribute('cx', String(this.format((x + w / 2 + s.dx) * s.scale)));
        n.setAttribute('cy', String(this.format((y + h / 2 + s.dy) * s.scale)));
        n.setAttribute('rx', String(w / 2 * s.scale));
        n.setAttribute('ry', String(h / 2 * s.scale));
        this.node = n;
    }
    /**
     * Private helper function to create SVG elements
     */ image(x, y, w, h, src, aspect = true, flipH = false, flipV = false) {
        src = this.converter.convert(src);
        const s = this.state;
        x += s.dx;
        y += s.dy;
        const node = this.createElement('image');
        node.setAttribute('x', String(this.format(x * s.scale) + this.imageOffset));
        node.setAttribute('y', String(this.format(y * s.scale) + this.imageOffset));
        node.setAttribute('width', String(this.format(w * s.scale)));
        node.setAttribute('height', String(this.format(h * s.scale)));
        // Workaround for missing namespace support
        if (!node.setAttributeNS) node.setAttribute('xlink:href', src);
        else node.setAttributeNS((0, $cBHcM.NS_XLINK), 'xlink:href', src);
        if (!aspect) node.setAttribute('preserveAspectRatio', 'none');
        if (s.alpha < 1 || s.fillAlpha < 1) node.setAttribute('opacity', String(s.alpha * s.fillAlpha));
        let tr = this.state.transform || '';
        if (flipH || flipV) {
            let sx = 1;
            let sy = 1;
            let dx = 0;
            let dy = 0;
            if (flipH) {
                sx = -1;
                dx = -w - 2 * x;
            }
            if (flipV) {
                sy = -1;
                dy = -h - 2 * y;
            }
            // Adds image transformation to existing transform
            tr += `scale(${sx},${sy})translate(${dx * s.scale},${dy * s.scale})`;
        }
        if (tr.length > 0) node.setAttribute('transform', tr);
        if (!this.pointerEvents) node.setAttribute('pointer-events', 'none');
        this.root.appendChild(node);
    }
    /**
     * Converts the given HTML string to XHTML.
     */ convertHtml(val) {
        const doc = new DOMParser().parseFromString(val, 'text/html');
        // the jsdoc of DOMParser.parseFromString says the returned value is never null, but keep the check (it comes from mxGraph) for now until we get more feedback on this
        if (doc) {
            val = new XMLSerializer().serializeToString(doc.body);
            // Extracts body content from DOM
            if (val.substring(0, 5) === '<body') val = val.substring(val.indexOf('>', 5) + 1);
            if (val.substring(val.length - 7, val.length) === '</body>') val = val.substring(0, val.length - 7);
        }
        return val;
    }
    /**
     * Private helper function to create SVG elements
     * Note: signature changed in mxgraph 4.1.0
     */ createDiv(str) {
        let val = str;
        if (!(0, $b1d29c834e82fef5$export$8ee0fc9ee280b4ee)(val)) val = `<div><div>${this.convertHtml(val)}</div></div>`;
        if (document.createElementNS) {
            const div = document.createElementNS('http://www.w3.org/1999/xhtml', 'div');
            if ((0, $b1d29c834e82fef5$export$8ee0fc9ee280b4ee)(val)) {
                const div2 = document.createElement('div');
                const div3 = div2.cloneNode(false);
                // Creates a copy for export
                if (this.root.ownerDocument !== document) div2.appendChild(val.cloneNode(true));
                else div2.appendChild(val);
                div3.appendChild(div2);
                div.appendChild(div3);
            } else div.innerHTML = val;
            return div;
        }
        if ((0, $b1d29c834e82fef5$export$8ee0fc9ee280b4ee)(val)) val = `<div><div>${(0, $f26d63937b34ab64$export$4084de0f62de36b0)(val)}</div></div>`;
        val = `<div xmlns="http://www.w3.org/1999/xhtml">${val}</div>`;
        // NOTE: FF 3.6 crashes if content CSS contains "height:100%"
        return (0, $f26d63937b34ab64$export$60ca78d2e670be93)(val).documentElement;
    }
    /**
     * Updates existing DOM nodes for text rendering. LATER: Merge common parts with text function below.
     */ updateText(x, y, w, h, align, valign, wrap, overflow, clip, rotation, node) {
        if (node && node.firstChild && node.firstChild.firstChild) this.updateTextNodes(x, y, w, h, align, valign, wrap, overflow, clip, rotation, node.firstChild);
    }
    /**
     * Creates a foreignObject for the given string and adds it to the given root.
     */ addForeignObject(x, y, w, h, str, align, valign, wrap, format, overflow, clip, rotation, dir, div, root) {
        const group = this.createElement('g');
        const fo = this.createElement('foreignObject');
        // Workarounds for print clipping and static position in Safari
        fo.setAttribute('style', 'overflow: visible; text-align: left;');
        fo.setAttribute('pointer-events', 'none');
        fo.appendChild(div);
        group.appendChild(fo);
        this.updateTextNodes(x, y, w, h, align, valign, wrap, overflow, clip, rotation, group);
        // Alternate content if foreignObject not supported
        if (this.root?.ownerDocument !== document) {
            const alt = this.createAlternateContent(fo, x, y, w, h, str, align, valign, wrap, format, overflow, clip, rotation);
            if (alt != null) {
                fo.setAttribute('requiredFeatures', 'http://www.w3.org/TR/SVG11/feature#Extensibility');
                const sw = this.createElement('switch');
                sw.appendChild(fo);
                sw.appendChild(alt);
                group.appendChild(sw);
            }
        }
        root.appendChild(group);
    }
    /**
     * Updates existing DOM nodes for text rendering.
     */ updateTextNodes(x, y, w, h, align, valign, wrap, overflow, clip, rotation, g) {
        const s = this.state.scale;
        $f0b9bd90b7bd8dd2$var$SvgCanvas2D.createCss(w + 2, h, align, valign, wrap, overflow, clip, this.state.fontBackgroundColor != null ? this.state.fontBackgroundColor : null, this.state.fontBorderColor != null ? this.state.fontBorderColor : null, `display: flex; align-items: unsafe ${valign === 'top' ? 'flex-start' : valign === 'bottom' ? 'flex-end' : 'center'}; ` + `justify-content: unsafe ${align === 'left' ? 'flex-start' : align === 'right' ? 'flex-end' : 'center'}; `, this.getTextCss(), s, (dx, dy, flex, item, block)=>{
            x += this.state.dx;
            y += this.state.dy;
            const fo = g.firstChild;
            const div = fo.firstChild;
            const box = div.firstChild;
            const text = box.firstChild;
            const r = (this.rotateHtml ? this.state.rotation : 0) + (rotation != null ? rotation : 0);
            let t = (this.foOffset !== 0 ? `translate(${this.foOffset} ${this.foOffset})` : '') + (s !== 1 ? `scale(${s})` : '');
            text.setAttribute('style', block);
            box.setAttribute('style', item);
            // Workaround for clipping in Webkit with scrolling and zoom
            fo.setAttribute('width', `${Math.ceil(1 / Math.min(1, s) * 100)}%`);
            fo.setAttribute('height', `${Math.ceil(1 / Math.min(1, s) * 100)}%`);
            const yp = Math.round(y + dy);
            // Allows for negative values which are causing problems with
            // transformed content where the top edge of the foreignObject
            // limits the text box being moved further up in the diagram.
            // KNOWN: Possible clipping problems with zoom and scrolling
            // but this is normally not used with scrollbars as the
            // coordinates are always positive with scrollbars.
            // Margin-top is ignored in Safari and no negative values allowed
            // for padding.
            if (yp < 0) fo.setAttribute('y', String(yp));
            else {
                fo.removeAttribute('y');
                flex += `padding-top: ${yp}px; `;
            }
            div.setAttribute('style', `${flex}margin-left: ${Math.round(x + dx)}px;`);
            t += r !== 0 ? `rotate(${r} ${x} ${y})` : '';
            // Output allows for reflow but Safari cannot use absolute position,
            // transforms or opacity. https://bugs.webkit.org/show_bug.cgi?id=23113
            if (t !== '') g.setAttribute('transform', t);
            else g.removeAttribute('transform');
            if (this.state.alpha !== 1) g.setAttribute('opacity', String(this.state.alpha));
            else g.removeAttribute('opacity');
        });
    }
    /**
     * Private helper function to create SVG elements
     */ getTextCss() {
        const s = this.state;
        const lh = (0, $cBHcM.ABSOLUTE_LINE_HEIGHT) ? `${s.fontSize * (0, $cBHcM.LINE_HEIGHT)}px` : (0, $cBHcM.LINE_HEIGHT) * this.lineHeightCorrection;
        let css = `display: inline-block; font-size: ${s.fontSize}px; ` + `font-family: ${s.fontFamily}; color: ${s.fontColor}; line-height: ${lh}; pointer-events: ${this.pointerEvents ? this.pointerEventsValue : 'none'}; `;
        const fontStyle = s.fontStyle;
        (0, $h5l15.matchBinaryMask)(fontStyle, (0, $cBHcM.FONT_STYLE_MASK).BOLD) && (css += 'font-weight: bold; ');
        (0, $h5l15.matchBinaryMask)(fontStyle, (0, $cBHcM.FONT_STYLE_MASK).ITALIC) && (css += 'font-style: italic; ');
        const txtDecor = [];
        (0, $h5l15.matchBinaryMask)(fontStyle, (0, $cBHcM.FONT_STYLE_MASK).UNDERLINE) && txtDecor.push('underline');
        (0, $h5l15.matchBinaryMask)(fontStyle, (0, $cBHcM.FONT_STYLE_MASK).STRIKETHROUGH) && txtDecor.push('line-through');
        txtDecor.length > 0 && (css += `text-decoration: ${txtDecor.join(' ')}; `);
        return css;
    }
    /**
     * Paints the given text.
     *
     * Possible values for format are empty string for plain text and HTML for HTML markup.
     *
     * Note that HTML markup is only supported if `foreignObject` is supported and {@link foEnabled} is `true`.
     */ text(x, y, w, h, str, align, valign, wrap, format, overflow, clip, rotation = 0, dir) {
        if (this.textEnabled && str != null) {
            rotation = rotation != null ? rotation : 0;
            if (this.foEnabled && format === 'html') {
                const div = this.createDiv(str);
                // Ignores invalid XHTML labels
                if (div != null) {
                    if (dir != null) div.setAttribute('dir', dir);
                    this.addForeignObject(x, y, w, h, str, align, valign, wrap, format, overflow, clip, rotation, dir, div, this.root);
                }
            } else this.plainText(x + this.state.dx, y + this.state.dy, w, h, str, align, valign, wrap, overflow, clip, rotation, dir);
        }
    }
    /**
     * Creates a clip for the given coordinates.
     */ createClip(x, y, w, h) {
        x = Math.round(x);
        y = Math.round(y);
        w = Math.round(w);
        h = Math.round(h);
        const id = `mx-clip-${x}-${y}-${w}-${h}`;
        let counter = 0;
        let tmp = `${id}-${counter}`;
        // Resolves ID conflicts
        while(document.getElementById(tmp) != null)tmp = `${id}-${++counter}`;
        const clip = this.createElement('clipPath');
        clip.setAttribute('id', tmp);
        const rect = this.createElement('rect');
        rect.setAttribute('x', String(x));
        rect.setAttribute('y', String(y));
        rect.setAttribute('width', String(w));
        rect.setAttribute('height', String(h));
        clip.appendChild(rect);
        return clip;
    }
    /**
     * Paints the given text. Possible values for format are empty string for
     * plain text and html for HTML markup.
     */ plainText(x, y, w, h, str, align, valign, wrap, overflow, clip, rotation = 0, dir) {
        const s = this.state;
        const size = s.fontSize;
        const node = this.createElement('g');
        let tr = s.transform || '';
        this.updateFont(node);
        // Ignores pointer events
        if (!this.pointerEvents && this.originalRoot == null) node.setAttribute('pointer-events', 'none');
        // Non-rotated text
        if (rotation !== 0) tr += `rotate(${rotation},${this.format(x * s.scale)},${this.format(y * s.scale)})`;
        if (dir != null) node.setAttribute('direction', dir);
        if (clip && w > 0 && h > 0) {
            let cx = x;
            let cy = y;
            if (align === 'center') cx -= w / 2;
            else if (align === 'right') cx -= w;
            if (overflow !== 'fill') {
                if (valign === 'middle') cy -= h / 2;
                else if (valign === 'bottom') cy -= h;
            }
            // LATER: Remove spacing from clip rectangle
            const c = this.createClip(cx * s.scale - 2, cy * s.scale - 2, w * s.scale + 4, h * s.scale + 4);
            if (this.defs != null) this.defs.appendChild(c);
            else // Makes sure clip is removed with referencing node
            this.root.appendChild(c);
            if (!(0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_CHROMEAPP && !(0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_EDGE && this.root.ownerDocument === document) {
                // Workaround for potential base tag
                const base = this.getBaseUrl().replace(/([()])/g, '\\$1');
                node.setAttribute('clip-path', `url(${base}#${c.getAttribute('id')})`);
            } else node.setAttribute('clip-path', `url(#${c.getAttribute('id')})`);
        }
        // Default is left
        const anchor = align === 'right' ? 'end' : align === 'center' ? 'middle' : 'start';
        // Text-anchor start is default in SVG
        if (anchor !== 'start') node.setAttribute('text-anchor', anchor);
        if (!this.styleEnabled || size !== (0, $4vC7I.StyleDefaultsConfig).fontSize) node.setAttribute('font-size', `${size * s.scale}px`);
        if (tr.length > 0) node.setAttribute('transform', tr);
        if (s.alpha < 1) node.setAttribute('opacity', String(s.alpha));
        const lines = str.split('\n');
        const lh = Math.round(size * (0, $cBHcM.LINE_HEIGHT));
        const textHeight = size + (lines.length - 1) * lh;
        let cy = y + size - 1;
        if (valign === 'middle') {
            if (overflow === 'fill') cy -= h / 2;
            else {
                const dy = (this.matchHtmlAlignment && clip && h > 0 ? Math.min(textHeight, h) : textHeight) / 2;
                cy -= dy;
            }
        } else if (valign === 'bottom') {
            if (overflow === 'fill') cy -= h;
            else {
                const dy = this.matchHtmlAlignment && clip && h > 0 ? Math.min(textHeight, h) : textHeight;
                cy -= dy + 1;
            }
        }
        for(let i = 0; i < lines.length; i += 1){
            const line = (0, $6bb3a85a9cf63e97$export$87c2784dc9fc4ab)(lines[i]);
            // Workaround for bounding box of empty lines and spaces
            if (line) {
                const text = this.createElement('text');
                // LATER: Match horizontal HTML alignment
                text.setAttribute('x', String(this.format(x * s.scale) + this.textOffset));
                text.setAttribute('y', String(this.format(cy * s.scale) + this.textOffset));
                (0, $b1d29c834e82fef5$export$68d8715fc104d294)(text, line);
                node.appendChild(text);
            }
            cy += lh;
        }
        this.root.appendChild(node);
        this.addTextBackground(node, str, x, y, w, overflow === 'fill' ? h : textHeight, align, valign, overflow);
    }
    /**
     * Updates the text properties for the given node. (NOTE: For this to work in
     * IE, the given node must be a text or tspan element.)
     */ updateFont(node) {
        const s = this.state;
        if (s.fontColor && s.fontColor !== (0, $cBHcM.NONE)) node.setAttribute('fill', s.fontColor);
        if (!this.styleEnabled || s.fontFamily !== (0, $4vC7I.StyleDefaultsConfig).fontFamily) node.setAttribute('font-family', s.fontFamily);
        const fontStyle = s.fontStyle;
        (0, $h5l15.matchBinaryMask)(fontStyle, (0, $cBHcM.FONT_STYLE_MASK).BOLD) && node.setAttribute('font-weight', 'bold');
        (0, $h5l15.matchBinaryMask)(fontStyle, (0, $cBHcM.FONT_STYLE_MASK).ITALIC) && node.setAttribute('font-style', 'italic');
        const txtDecor = [];
        (0, $h5l15.matchBinaryMask)(fontStyle, (0, $cBHcM.FONT_STYLE_MASK).UNDERLINE) && txtDecor.push('underline');
        (0, $h5l15.matchBinaryMask)(fontStyle, (0, $cBHcM.FONT_STYLE_MASK).STRIKETHROUGH) && txtDecor.push('line-through');
        txtDecor.length > 0 && node.setAttribute('text-decoration', txtDecor.join(' '));
    }
    /**
     * Background color and border
     */ addTextBackground(node, str, x, y, w, h, align, valign, overflow) {
        const s = this.state;
        if (s.fontBackgroundColor != null || s.fontBorderColor != null) {
            let bbox = null;
            if (overflow === 'fill' || overflow === 'width') {
                if (align === 'center') x -= w / 2;
                else if (align === 'right') x -= w;
                if (valign === 'middle') y -= h / 2;
                else if (valign === 'bottom') y -= h;
                bbox = new (0, $2997c239141ea844$export$2e2bcd8739ae039)((x + 1) * s.scale, y * s.scale, (w - 2) * s.scale, (h + 2) * s.scale);
            // @ts-ignore check for getBBox
            } else if (node.getBBox != null && this.root.ownerDocument === document) // Uses getBBox only if inside document for correct size
            try {
                // @ts-ignore getBBox exists
                bbox = node.getBBox();
                bbox = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(bbox.x, bbox.y + 1, bbox.width, bbox.height + 0);
            } catch (e) {
            // Ignores NS_ERROR_FAILURE in FF if container display is none.
            }
            if (bbox == null || bbox.width === 0 || bbox.height === 0) {
                // Computes size if not in document or no getBBox available
                const div = document.createElement('div');
                // Wrapping and clipping can be ignored here
                div.style.lineHeight = (0, $cBHcM.ABSOLUTE_LINE_HEIGHT) ? `${s.fontSize * (0, $cBHcM.LINE_HEIGHT)}px` : String((0, $cBHcM.LINE_HEIGHT));
                div.style.fontSize = `${s.fontSize}px`;
                div.style.fontFamily = s.fontFamily;
                div.style.whiteSpace = 'nowrap';
                div.style.position = 'absolute';
                div.style.visibility = 'hidden';
                div.style.display = 'inline-block';
                (0, $h5l15.matchBinaryMask)(s.fontStyle, (0, $cBHcM.FONT_STYLE_MASK).BOLD) && (div.style.fontWeight = 'bold');
                (0, $h5l15.matchBinaryMask)(s.fontStyle, (0, $cBHcM.FONT_STYLE_MASK).ITALIC) && (div.style.fontStyle = 'italic');
                str = (0, $6bb3a85a9cf63e97$export$324699496a105db8)(str, false);
                div.innerHTML = str.replace(/\n/g, '<br/>');
                document.body.appendChild(div);
                const w = div.offsetWidth;
                const h = div.offsetHeight;
                document.body.removeChild(div);
                if (align === 'center') x -= w / 2;
                else if (align === 'right') x -= w;
                if (valign === 'middle') y -= h / 2;
                else if (valign === 'bottom') y -= h;
                bbox = new (0, $2997c239141ea844$export$2e2bcd8739ae039)((x + 1) * s.scale, (y + 2) * s.scale, w * s.scale, (h + 1) * s.scale);
            }
            if (bbox != null) {
                const n = this.createElement('rect');
                n.setAttribute('fill', s.fontBackgroundColor || 'none');
                n.setAttribute('stroke', s.fontBorderColor || 'none');
                n.setAttribute('x', String(Math.floor(bbox.x - 1)));
                n.setAttribute('y', String(Math.floor(bbox.y - 1)));
                n.setAttribute('width', String(Math.ceil(bbox.width + 2)));
                n.setAttribute('height', String(Math.ceil(bbox.height)));
                const sw = s.fontBorderColor ? Math.max(1, this.format(s.scale)) : 0;
                n.setAttribute('stroke-width', String(sw));
                // Workaround for crisp rendering - only required if not exporting
                if (this.root?.ownerDocument === document && (0, $f7ff90b8964488a6$export$842a2cf37af977e1)(sw, 2) === 1) n.setAttribute('transform', 'translate(0.5, 0.5)');
                node.insertBefore(n, node.firstChild);
            }
        }
    }
    /**
     * Paints the outline of the current path.
     */ stroke() {
        this.addNode(false, true);
    }
    /**
     * Fills the current path.
     */ fill() {
        this.addNode(true, false);
    }
    /**
     * Fills and paints the outline of the current path.
     */ fillAndStroke() {
        this.addNode(true, true);
    }
}
/**
 * Updates existing DOM nodes for text rendering.
 */ $f0b9bd90b7bd8dd2$var$SvgCanvas2D.createCss = (w, h, align, valign, wrap, overflow, clip, bg, border, flex, block, scale, callback)=>{
    let item = `box-sizing: border-box; font-size: 0; text-align: ${align === 'left' ? 'left' : align === 'right' ? 'right' : 'center'}; `;
    const pt = (0, $b55d6ca3b42398e2$export$29d173e672cfdc1f)(align, valign);
    let ofl = 'overflow: hidden; ';
    let fw = 'width: 1px; ';
    let fh = 'height: 1px; ';
    let dx = pt.x * w;
    let dy = pt.y * h;
    if (clip) {
        fw = `width: ${Math.round(w)}px; `;
        item += `max-height: ${Math.round(h)}px; `;
        dy = 0;
    } else if (overflow === 'fill') {
        fw = `width: ${Math.round(w)}px; `;
        fh = `height: ${Math.round(h)}px; `;
        block += 'width: 100%; height: 100%; ';
        item += fw + fh;
    } else if (overflow === 'width') {
        fw = `width: ${Math.round(w)}px; `;
        block += 'width: 100%; ';
        item += fw;
        dy = 0;
        if (h > 0) item += `max-height: ${Math.round(h)}px; `;
    } else {
        ofl = '';
        dy = 0;
    }
    let bgc = '';
    if (bg) bgc += `background-color: ${bg}; `;
    if (border) bgc += `border: 1px solid ${border}; `;
    if (ofl == '' || clip) block += bgc;
    else item += bgc;
    if (wrap && w > 0) {
        block += `white-space: normal; word-wrap: ${0, $cBHcM.WORD_WRAP}; `;
        fw = `width: ${Math.round(w)}px; `;
        if (ofl !== '' && overflow !== 'fill') dy = 0;
    } else {
        block += 'white-space: nowrap; ';
        if (ofl === '') dx = 0;
    }
    callback(dx, dy, flex + fw + fh, item + ofl, block, ofl);
};
var $f0b9bd90b7bd8dd2$export$2e2bcd8739ae039 = $f0b9bd90b7bd8dd2$var$SvgCanvas2D;





var $4vC7I = parcelRequire("4vC7I");
/**
 * Base class for all shapes.
 * A shape in maxGraph is a separate implementation for SVG, VML and HTML.
 * Which implementation to use is controlled by the dialect property which
 * is assigned from within the {@link CellRenderer} when the shape is created.
 * The dialect must be assigned for a shape, and it does normally depend on
 * the browser and the configuration of the graph (see maxGraph rendering hint).
 *
 * For each supported shape in SVG and VML, a corresponding shape exists in
 * maxGraph, namely for text, image, rectangle, rhombus, ellipse and polyline.
 * The other shapes are a combination of these shapes (e.g. label and swimlane)
 * or they consist of one or more (filled) path objects (e.g. actor and cylinder).
 * The HTML implementation is optional but may be required for a HTML-only view
 * of the graph.
 *
 * ### Custom Shapes
 *
 * A custom shape is a class extending one of the exported shape classes, registered in {@link ShapeRegistry} under a
 * name, then referenced by that name as the `shape` property of a cell style.
 *
 * Choose the base class according to what is painted:
 * - {@link Shape} itself for a vertex made of a single filled and stroked path: override
 *   `paintVertexShape(c, x, y, w, h)` and call `c.translate(x, y)`, `c.begin()`, the path drawing operations, then
 *   `c.fillAndStroke()`.
 * - {@link AbstractPathShape} for the same single path vertex, without that boilerplate: override
 *   `redrawPath(c, x, y, w, h)` with the drawing operations only.
 * - {@link CylinderShape} for a filled area plus a stroke only overlay path: override
 *   `redrawPath(c, x, y, w, h, isForeground)`.
 * - {@link RectangleShape} (override `paintBackground` or `paintForeground`) or {@link EllipseShape} (override
 *   `paintVertexShape`) to decorate an existing shape.
 * - For edges, {@link ConnectorShape}, {@link PolylineShape}, {@link ArrowShape} or {@link ArrowConnectorShape}:
 *   override `paintEdgeShape(c, pts)`.
 *
 * **The constructor must take no argument.** {@link CellRenderer.createShape} instantiates the registered class with
 * `new shapeConstructor()`, for vertices and edges alike, so the legacy `(bounds, fill, stroke, strokeWidth)`
 * parameters still declared by several built-in shapes are never passed on that path. The renderer populates the
 * instance afterwards: {@link Shape.apply} sets {@link Shape.state}, {@link Shape.style} and the fields derived from
 * the style, then {@link CellRenderer.redrawShape} sets {@link Shape.bounds} for a vertex, {@link Shape.points} for an
 * edge, and {@link Shape.scale}.
 *
 * Consequently, the cell style is only available at paint time, through {@link Shape.style}, which is
 * `CellStateStyle | null` and must be guarded.
 *
 * ```typescript
 * class CustomShape extends Shape {
 *   override paintVertexShape(
 *     c: AbstractCanvas2D,
 *     x: number,
 *     y: number,
 *     w: number,
 *     h: number
 *   ): void {
 *     const notch = this.style?.arcSize ?? 10;
 *     c.translate(x, y);
 *     c.begin();
 *     c.moveTo(0, 0);
 *     c.lineTo(w - notch, 0);
 *     c.lineTo(w, notch);
 *     c.lineTo(w, h);
 *     c.lineTo(0, h);
 *     c.close();
 *     c.fillAndStroke();
 *   }
 * }
 *
 * ShapeRegistry.add('customShape', CustomShape);
 *
 * graph.insertVertex({ value: 'custom', position: [10, 10], size: [100, 60], style: { shape: 'customShape' } });
 * ```
 *
 * See the Extend maxGraph page of the documentation for a complete walkthrough.
 *
 * @category Shape
 */ class $d0e43aed19391bda$var$Shape {
    constructor(stencil = null){
        /**
         * Switch to preserve image aspect.
         * @default false
         */ this.preserveImageAspect = false;
        this.overlay = null;
        this.indicator = null;
        this.indicatorShape = null;
        /** @see CellHighlight */ this.opacity = 100;
        this.isDashed = false;
        this.fill = (0, $cBHcM.NONE);
        this.gradient = (0, $cBHcM.NONE);
        this.gradientDirection = 'east';
        this.fillOpacity = 100;
        this.strokeOpacity = 100;
        this.stroke = (0, $cBHcM.NONE);
        this.strokeWidth = 1;
        this.spacing = 0;
        this.startSize = 1;
        this.endSize = 1;
        this.startArrow = (0, $cBHcM.NONE);
        this.endArrow = (0, $cBHcM.NONE);
        this.direction = 'east';
        this.flipH = false;
        this.flipV = false;
        this.isShadow = false;
        this.isRounded = false;
        this.rotation = 0;
        this.cursor = '';
        this.verticalTextRotation = 0;
        this.oldGradients = {};
        this.glass = false;
        /**
         * Holds the dialect in which the shape is to be painted.
         */ this.dialect = null;
        /**
         * Holds the scale in which the shape is being painted.
         */ this.scale = 1;
        /**
         * Rendering hint for configuring the canvas.
         */ this.antiAlias = true;
        /**
         * Minimum stroke width for SVG output.
         */ this.minSvgStrokeWidth = 1;
        /**
         * Holds the {@link Rectangle} that specifies the bounds of this shape.
         */ this.bounds = null;
        /**
         * Holds the array of <Point> that specify the points of this shape.
         */ this.points = [];
        /**
         * Optional reference to the corresponding <CellState>.
         */ this.state = null;
        /**
         * Optional reference to the style of the corresponding <CellState>.
         */ this.style = null;
        /**
         * Contains the bounding box of the shape, that is, the smallest rectangle
         * that includes all pixels of the shape.
         */ this.boundingBox = null;
        /**
         * Holds the {@link StencilShape} that defines the shape.
         */ this.stencil = null;
        /**
         * Event-tolerance for SVG strokes (in px).
         * This is only passed to the canvas in {@link createSvgCanvas} if {@link pointerEvents} is `true`.
         * @default 8
         */ this.svgStrokeTolerance = 8;
        /**
         * Specifies if pointer events should be handled. Default is true.
         */ this.pointerEvents = true;
        this.originalPointerEvents = null;
        /**
         * Specifies if pointer events should be handled. Default is true.
         */ this.svgPointerEvents = 'all';
        /**
         * Specifies if pointer events outside of shape should be handled. Default
         * is false.
         */ this.shapePointerEvents = false;
        /**
         * Specifies if pointer events outside of stencils should be handled. Default
         * is false. Set this to true for backwards compatibility with the 1.x branch.
         */ this.stencilPointerEvents = false;
        /**
         * Specifies if the shape should be drawn as an outline. This disables all
         * fill colors and can be used to disable other drawing states that should
         * not be painted for outlines. Default is false. This should be set before
         * calling <apply>.
         */ this.outline = false;
        /**
         * Specifies if the shape is visible. Default is true.
         */ this.visible = true;
        /**
         * Allows to use the SVG bounding box in SVG. Default is false for performance
         * reasons.
         */ this.useSvgBoundingBox = true;
        this.image = null;
        this.imageSrc = null;
        this.indicatorColor = (0, $cBHcM.NONE);
        this.indicatorStrokeColor = (0, $cBHcM.NONE);
        this.indicatorGradientColor = (0, $cBHcM.NONE);
        this.indicatorDirection = 'east';
        this.indicatorImageSrc = null;
        // `stencil` is not null when instantiated directly,
        // but can be null when instantiated through a child class.
        if (stencil) this.stencil = stencil;
        // moved from init()
        this.node = this.create();
    }
    /**
     * Initializes the shape by adding it into the given container if the node of the shape doesn't already have a parent.
     *
     * @param container DOM node that will contain the shape.
     */ init(container) {
        if (!this.node.parentNode) container.appendChild(this.node);
    }
    /**
     * Sets the styles to their default values.
     */ initStyles() {
        this.strokeWidth = 1;
        this.rotation = 0;
        this.opacity = 100;
        this.fillOpacity = 100;
        this.strokeOpacity = 100;
        this.flipH = false;
        this.flipV = false;
    }
    /**
     * Returns true if HTML is allowed for this shape. This implementation always returns `false`.
     */ isHtmlAllowed() {
        return false;
    }
    /**
     * Returns 0, or 0.5 if {@link strokeWidth} % 2 == 1.
     */ getSvgScreenOffset() {
        const sw = this.stencil && this.stencil.strokeWidthValue !== 'inherit' ? Number(this.stencil.strokeWidthValue) : this.strokeWidth ?? 0;
        return (0, $f7ff90b8964488a6$export$842a2cf37af977e1)(Math.max(1, Math.round(sw * this.scale)), 2) === 1 ? 0.5 : 0;
    }
    /**
     * Creates and returns the DOM node for the shape.
     * This implementation assumes that `maxGraph` produces SVG elements.
     */ create() {
        return document.createElementNS((0, $cBHcM.NS_SVG), 'g');
    }
    redraw() {
        this.updateBoundsFromPoints();
        if (this.visible && this.checkBounds()) {
            this.node.style.visibility = 'visible';
            this.clear();
            this.redrawShape();
            this.updateBoundingBox();
        } else {
            this.node.style.visibility = 'hidden';
            this.boundingBox = null;
        }
    }
    /**
     * Removes all child nodes and resets all CSS.
     */ clear() {
        while(this.node.lastChild)this.node.removeChild(this.node.lastChild);
    }
    /**
     * Updates the bounds based on the points.
     */ updateBoundsFromPoints() {
        const pts = this.points;
        if (pts.length > 0 && pts[0]) {
            this.bounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(Math.round(pts[0].x), Math.round(pts[0].y), 1, 1);
            for (const pt of pts)if (pt) this.bounds.add(new (0, $2997c239141ea844$export$2e2bcd8739ae039)(Math.round(pt.x), Math.round(pt.y), 1, 1));
        }
    }
    /**
     * Returns the {@link Rectangle} for the label bounds of this shape, based on the
     * given scaled and translated bounds of the shape. This method should not
     * change the rectangle in-place. This implementation returns the given rect.
     */ getLabelBounds(rect) {
        const d = this.style?.direction ?? 'east';
        let bounds = rect.clone();
        // Normalizes argument for getLabelMargins hook
        if (d !== 'south' && d !== 'north' && this.state && this.state.text && this.state.text.isPaintBoundsInverted()) {
            bounds = bounds.clone();
            [bounds.width, bounds.height] = [
                bounds.height,
                bounds.width
            ];
        }
        let labelMargins = this.getLabelMargins(bounds);
        if (labelMargins) {
            labelMargins = labelMargins.clone();
            let flipH = this.style?.flipH ?? false;
            let flipV = this.style?.flipV ?? false;
            // Handles special case for vertical labels
            if (this.state && this.state.text && this.state.text.isPaintBoundsInverted()) {
                const tmp = labelMargins.x;
                labelMargins.x = labelMargins.height;
                labelMargins.height = labelMargins.width;
                labelMargins.width = labelMargins.y;
                labelMargins.y = tmp;
                [flipH, flipV] = [
                    flipV,
                    flipH
                ];
            }
            return (0, $f7ff90b8964488a6$export$3b8a4d2abb6b1293)(rect, labelMargins, this.style, flipH, flipV);
        }
        return rect;
    }
    /**
     * Returns the scaled top, left, bottom and right margin to be used for
     * computing the label bounds as an {@link Rectangle}, where the bottom and right
     * margin are defined in the width and height of the rectangle, respectively.
     */ getLabelMargins(rect) {
        return null;
    }
    /**
     * Returns true if the bounds are not null and all of its variables are numeric.
     */ checkBounds() {
        return !Number.isNaN(this.scale) && Number.isFinite(this.scale) && this.scale > 0 && this.bounds && !Number.isNaN(this.bounds.x) && !Number.isNaN(this.bounds.y) && !Number.isNaN(this.bounds.width) && !Number.isNaN(this.bounds.height) && this.bounds.width > 0 && this.bounds.height > 0;
    }
    /**
     * Updates the SVG or VML shape.
     */ redrawShape() {
        const canvas = this.createCanvas();
        if (canvas) {
            // Specifies if events should be handled
            canvas.pointerEvents = this.pointerEvents;
            this.beforePaint(canvas);
            this.paint(canvas);
            this.afterPaint(canvas);
            if (this.node !== canvas.root && canvas.root) // Forces parsing in IE8 standards mode - slow! avoid
            this.node.insertAdjacentHTML('beforeend', canvas.root.outerHTML);
            this.destroyCanvas(canvas);
        }
    }
    /**
     * Creates a new canvas for drawing this shape. May return null.
     */ createCanvas() {
        const canvas = this.createSvgCanvas();
        if (canvas && this.outline) {
            canvas.setStrokeWidth(this.strokeWidth);
            canvas.setStrokeColor(this.stroke);
            if (this.isDashed) canvas.setDashed(this.isDashed);
            canvas.setStrokeWidth = ()=>{
                return;
            };
            canvas.setStrokeColor = ()=>{
                return;
            };
            canvas.setFillColor = ()=>{
                return;
            };
            canvas.setGradient = ()=>{
                return;
            };
            canvas.setDashed = ()=>{
                return;
            };
            canvas.text = ()=>{
                return;
            };
        }
        return canvas;
    }
    /**
     * Creates and returns an {@link SvgCanvas2D} for rendering this shape.
     */ createSvgCanvas() {
        if (!this.node) return null;
        const canvas = new (0, $f0b9bd90b7bd8dd2$export$2e2bcd8739ae039)(this.node, false);
        canvas.strokeTolerance = this.pointerEvents ? this.svgStrokeTolerance : 0;
        canvas.pointerEventsValue = this.svgPointerEvents;
        const off = this.getSvgScreenOffset();
        if (off !== 0) this.node.setAttribute('transform', `translate(${off},${off})`);
        else this.node.removeAttribute('transform');
        canvas.minStrokeWidth = this.minSvgStrokeWidth;
        if (!this.antiAlias) // Rounds all numbers in the SVG output to integers
        canvas.format = (value)=>{
            return Math.round(value);
        };
        return canvas;
    }
    /**
     * Destroys the given canvas which was used for drawing. This implementation
     * increments the reference counts on all shared gradients used in the canvas.
     */ destroyCanvas(canvas) {
        // Manages reference counts
        if (canvas instanceof (0, $f0b9bd90b7bd8dd2$export$2e2bcd8739ae039)) {
            // Increments ref counts
            for(const key in canvas.gradients){
                const gradient = canvas.gradients[key];
                if (gradient) gradient.mxRefCount = (gradient.mxRefCount || 0) + 1;
            }
            this.releaseSvgGradients(this.oldGradients);
            this.oldGradients = canvas.gradients;
        }
    }
    /**
     * Invoked before paint is called.
     */ beforePaint(c) {
        return;
    }
    /**
     * Invokes after paint was called.
     */ afterPaint(c) {
        return;
    }
    /**
     * Generic rendering code.
     */ paint(c) {
        let strokeDrawn = false;
        if (c && this.outline) {
            const { stroke: stroke } = c;
            c.stroke = (...args)=>{
                strokeDrawn = true;
                stroke.apply(c, args);
            };
            const { fillAndStroke: fillAndStroke } = c;
            c.fillAndStroke = (...args)=>{
                strokeDrawn = true;
                fillAndStroke.apply(c, args);
            };
        }
        // Scale is passed-through to canvas
        const s = this.scale;
        const bounds = this.bounds;
        if (bounds) {
            let x = bounds.x / s;
            let y = bounds.y / s;
            let w = bounds.width / s;
            let h = bounds.height / s;
            if (this.isPaintBoundsInverted()) {
                const t = (w - h) / 2;
                x += t;
                y -= t;
                const tmp = w;
                w = h;
                h = tmp;
            }
            this.updateTransform(c, x, y, w, h);
            this.configureCanvas(c, x, y, w, h);
            // Adds background rectangle to capture events
            let bg = null;
            if (!this.stencil && this.points.length === 0 && this.shapePointerEvents || this.stencil && this.stencilPointerEvents) {
                const bb = this.createBoundingBox();
                if (bb && this.node) {
                    bg = this.createTransparentSvgRectangle(bb.x, bb.y, bb.width, bb.height);
                    this.node.appendChild(bg);
                }
            }
            if (this.stencil) this.stencil.drawShape(c, this, x, y, w, h);
            else {
                // Stencils have separate strokewidth
                c.setStrokeWidth(this.strokeWidth);
                if (this.points.length > 0) {
                    // Paints edge shape
                    const pts = [];
                    for(let i = 0; i < this.points.length; i += 1){
                        const p = this.points[i];
                        if (p) pts.push(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(p.x / s, p.y / s));
                    }
                    this.paintEdgeShape(c, pts);
                } else // Paints vertex shape
                this.paintVertexShape(c, x, y, w, h);
            }
            if (bg && c.state && !(0, $h5l15.isNullish)(c.state.transform)) bg.setAttribute('transform', c.state.transform);
            // Draws highlight rectangle if no stroke was used
            if (c && this.outline && !strokeDrawn) {
                c.rect(x, y, w, h);
                c.stroke();
            }
        }
    }
    /**
     * Sets the state of the canvas for drawing the shape.
     */ configureCanvas(c, x, y, w, h) {
        let dash = null;
        if (this.style && this.style.dashPattern != null) dash = this.style.dashPattern;
        c.setAlpha(this.opacity / 100);
        c.setFillAlpha(this.fillOpacity / 100);
        c.setStrokeAlpha(this.strokeOpacity / 100);
        // Sets alpha, colors and gradients
        if (this.isShadow) c.setShadow(this.isShadow);
        // Dash pattern
        if (this.isDashed) c.setDashed(this.isDashed, this.style?.fixDash ?? false);
        if (dash) c.setDashPattern(dash);
        if (this.fill !== (0, $cBHcM.NONE) && this.gradient !== (0, $cBHcM.NONE)) {
            const b = this.getGradientBounds(c, x, y, w, h);
            c.setGradient(this.fill, this.gradient, b.x, b.y, b.width, b.height, this.gradientDirection);
        } else c.setFillColor(this.fill);
        c.setStrokeColor(this.stroke);
    }
    /**
     * Returns the bounding box for the gradient box for this shape.
     */ getGradientBounds(c, x, y, w, h) {
        return new (0, $2997c239141ea844$export$2e2bcd8739ae039)(x, y, w, h);
    }
    /**
     * Sets the scale and rotation on the given canvas.
     */ updateTransform(c, x, y, w, h) {
        // NOTE: Currently, scale is implemented in state and canvas. This will
        // move to canvas in a later version, so that the states are unscaled
        // and untranslated and do not need an update after zooming or panning.
        c.scale(this.scale);
        c.rotate(this.getShapeRotation(), this.flipH, this.flipV, x + w / 2, y + h / 2);
    }
    /**
     * Paints the vertex shape.
     */ paintVertexShape(c, x, y, w, h) {
        this.paintBackground(c, x, y, w, h);
        if (!this.outline || !this.style || !(this.style.backgroundOutline ?? false)) {
            c.setShadow(false);
            this.paintForeground(c, x, y, w, h);
        }
    }
    /**
     * Hook for subclassers. This implementation is empty.
     */ paintBackground(c, x, y, w, h) {
        return;
    }
    /**
     * Hook for subclassers. This implementation is empty.
     */ paintForeground(c, x, y, w, h) {
        return;
    }
    /**
     * Hook for subclassers. This implementation is empty.
     */ paintEdgeShape(c, pts) {
        return;
    }
    /**
     * Base arc size for the shape, taken from the style.
     * @since 0.21.0
     */ getBaseArcSize() {
        return (this.style?.arcSize ?? (0, $4vC7I.StyleDefaultsConfig).lineArcSize) / 2;
    }
    /**
     * Returns the arc size for the given dimension.
     */ getArcSize(w, h) {
        if (this.style?.absoluteArcSize) return Math.min(this.getBaseArcSize(), Math.min(h, w) / 2);
        const roundingFactor = (this.style?.arcSize ?? (0, $4vC7I.StyleDefaultsConfig).roundingFactor * 100) / 100;
        return Math.min(w, h) * roundingFactor;
    }
    /**
     * Paints the glass gradient effect.
     */ paintGlassEffect(c, x, y, w, h, arc) {
        const sw = Math.ceil((this.strokeWidth ?? 0) / 2);
        const size = 0.4;
        c.setGradient('#ffffff', '#ffffff', x, y, w, h * 0.6, 'south', 0.9, 0.1);
        c.begin();
        arc += 2 * sw;
        if (this.isRounded) {
            c.moveTo(x - sw + arc, y - sw);
            c.quadTo(x - sw, y - sw, x - sw, y - sw + arc);
            c.lineTo(x - sw, y + h * size);
            c.quadTo(x + w * 0.5, y + h * 0.7, x + w + sw, y + h * size);
            c.lineTo(x + w + sw, y - sw + arc);
            c.quadTo(x + w + sw, y - sw, x + w + sw - arc, y - sw);
        } else {
            c.moveTo(x - sw, y - sw);
            c.lineTo(x - sw, y + h * size);
            c.quadTo(x + w * 0.5, y + h * 0.7, x + w + sw, y + h * size);
            c.lineTo(x + w + sw, y - sw);
        }
        c.close();
        c.fill();
    }
    /**
     * Paints the given points with rounded corners.
     */ addPoints(c, pts, rounded = false, arcSize, close = false, exclude = [], initialMove = true) {
        if (pts.length > 0) {
            const pe = pts[pts.length - 1];
            // Adds virtual waypoint in the center between start and end point
            if (close && rounded) {
                pts = pts.slice();
                const p0 = pts[0];
                const wp = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(pe.x + (p0.x - pe.x) / 2, pe.y + (p0.y - pe.y) / 2);
                pts.splice(0, 0, wp);
            }
            let pt = pts[0];
            let i = 1;
            // Draws the line segments
            if (initialMove) c.moveTo(pt.x, pt.y);
            else c.lineTo(pt.x, pt.y);
            while(i < (close ? pts.length : pts.length - 1)){
                let tmp = pts[(0, $f7ff90b8964488a6$export$842a2cf37af977e1)(i, pts.length)];
                let dx = pt.x - tmp.x;
                let dy = pt.y - tmp.y;
                if (rounded && (dx !== 0 || dy !== 0) && !exclude.includes(i - 1)) {
                    // Draws a line from the last point to the current
                    // point with a spacing of size off the current point
                    // into direction of the last point
                    let dist = Math.sqrt(dx * dx + dy * dy);
                    const nx1 = dx * Math.min(arcSize, dist / 2) / dist;
                    const ny1 = dy * Math.min(arcSize, dist / 2) / dist;
                    const x1 = tmp.x + nx1;
                    const y1 = tmp.y + ny1;
                    c.lineTo(x1, y1);
                    // Draws a curve from the last point to the current
                    // point with a spacing of size off the current point
                    // into direction of the next point
                    let next = pts[(0, $f7ff90b8964488a6$export$842a2cf37af977e1)(i + 1, pts.length)];
                    // Uses next non-overlapping point
                    while(i < pts.length - 2 && Math.round(next.x - tmp.x) === 0 && Math.round(next.y - tmp.y) === 0){
                        next = pts[(0, $f7ff90b8964488a6$export$842a2cf37af977e1)(i + 2, pts.length)];
                        i++;
                    }
                    dx = next.x - tmp.x;
                    dy = next.y - tmp.y;
                    dist = Math.max(1, Math.sqrt(dx * dx + dy * dy));
                    const nx2 = dx * Math.min(arcSize, dist / 2) / dist;
                    const ny2 = dy * Math.min(arcSize, dist / 2) / dist;
                    const x2 = tmp.x + nx2;
                    const y2 = tmp.y + ny2;
                    c.quadTo(tmp.x, tmp.y, x2, y2);
                    tmp = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x2, y2);
                } else c.lineTo(tmp.x, tmp.y);
                pt = tmp;
                i += 1;
            }
            if (close) c.close();
            else c.lineTo(pe.x, pe.y);
        }
    }
    /**
     * Resets all styles.
     */ resetStyles() {
        this.initStyles();
        this.spacing = 0;
        this.fill = (0, $cBHcM.NONE);
        this.gradient = (0, $cBHcM.NONE);
        this.gradientDirection = 'east';
        this.stroke = (0, $cBHcM.NONE);
        this.startSize = 1;
        this.endSize = 1;
        this.startArrow = (0, $cBHcM.NONE);
        this.endArrow = (0, $cBHcM.NONE);
        this.direction = 'east';
        this.isShadow = false;
        this.isDashed = false;
        this.isRounded = false;
        this.glass = false;
    }
    /**
     * Applies the style of the given <CellState> to the shape. This
     * implementation assigns the following styles to local fields:
     *
     * - <'fillColor'> => fill
     * - <'gradientColor'> => gradient
     * - <'gradientDirection'> => gradientDirection
     * - <'opacity'> => opacity
     * - {@link Constants#STYLE_FILL_OPACITY} => fillOpacity
     * - {@link Constants#STYLE_STROKE_OPACITY} => strokeOpacity
     * - <'strokeColor'> => stroke
     * - <'strokeWidth'> => strokewidth
     * - <'shadow'> => isShadow
     * - <'dashed'> => isDashed
     * - <'spacing'> => spacing
     * - <'startSize'> => startSize
     * - <'endSize'> => endSize
     * - <'rounded'> => isRounded
     * - <'startArrow'> => startArrow
     * - <'endArrow'> => endArrow
     * - <'rotation'> => rotation
     * - <'direction'> => direction
     * - <'glass'> => glass
     *
     * This keeps a reference to the <style>. If you need to keep a reference to
     * the cell, you can override this method and store a local reference to
     * state.cell or the <CellState> itself. If <outline> should be true, make
     * sure to set it before calling this method.
     *
     * @param state <CellState> of the corresponding cell.
     */ apply(state) {
        this.state = state;
        this.style = state.style;
        if (this.style) {
            this.fill = this.style.fillColor ?? this.fill;
            this.gradient = this.style.gradientColor ?? this.gradient;
            this.gradientDirection = this.style.gradientDirection ?? this.gradientDirection;
            this.opacity = this.style.opacity ?? this.opacity;
            this.fillOpacity = this.style.fillOpacity ?? this.fillOpacity;
            this.strokeOpacity = this.style.strokeOpacity ?? this.strokeOpacity;
            this.stroke = this.style.strokeColor ?? this.stroke;
            this.strokeWidth = this.style.strokeWidth ?? this.strokeWidth;
            this.spacing = this.style.spacing ?? this.spacing;
            this.startSize = this.style.startSize ?? this.startSize;
            this.endSize = this.style.endSize ?? this.endSize;
            this.startArrow = this.style.startArrow ?? this.startArrow;
            this.endArrow = this.style.endArrow ?? this.endArrow;
            this.rotation = this.style.rotation ?? this.rotation;
            this.direction = this.style.direction ?? this.direction;
            this.flipH = !!this.style.flipH;
            this.flipV = !!this.style.flipV;
            if (this.direction === 'north' || this.direction === 'south') {
                const tmp = this.flipH;
                this.flipH = this.flipV;
                this.flipV = tmp;
            }
            this.isShadow = this.style.shadow ?? this.isShadow;
            this.isDashed = this.style.dashed ?? this.isDashed;
            this.isRounded = this.style.rounded ?? this.isRounded;
            this.glass = this.style.glass ?? this.glass;
        }
    }
    /**
     * Sets the cursor on the given shape.
     *
     * @param cursor The cursor to be used.
     */ setCursor(cursor) {
        this.cursor = cursor;
        this.node.style.cursor = cursor;
    }
    /**
     * Returns the current cursor.
     */ getCursor() {
        return this.cursor;
    }
    /**
     * Hook for subclassers. This implementation returns `false`.
     */ isRoundable(c, x, y, w, h) {
        return false;
    }
    /**
     * Updates the {@link boundingBox} for this shape using {@link createBoundingBox} and
     * {@link augmentBoundingBox} and stores the result in {@link boundingBox}.
     */ updateBoundingBox() {
        // Tries to get bounding box from SVG subsystem
        // LATER: Use getBoundingClientRect for fallback in VML
        if (this.useSvgBoundingBox && this.node.ownerSVGElement) try {
            const b = this.node.getBBox();
            if (b.width > 0 && b.height > 0) {
                this.boundingBox = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(b.x, b.y, b.width, b.height);
                // Adds strokeWidth
                this.boundingBox.grow((this.strokeWidth ?? 0) * this.scale / 2);
                return;
            }
        } catch (e) {
        // fallback to code below
        }
        if (this.bounds) {
            let bbox = this.createBoundingBox();
            if (bbox) {
                this.augmentBoundingBox(bbox);
                const rot = this.getShapeRotation();
                if (rot !== 0) bbox = (0, $f7ff90b8964488a6$export$895c5e634403eaa7)(bbox, rot);
            }
            this.boundingBox = bbox;
        }
    }
    /**
     * Returns a new rectangle that represents the bounding box of the bare shape
     * with no shadows or strokewidths.
     */ createBoundingBox() {
        if (!this.bounds) return null;
        const bb = this.bounds.clone();
        if (this.stencil && (this.direction === 'north' || this.direction === 'south') || this.isPaintBoundsInverted()) bb.rotate90();
        return bb;
    }
    /**
     * Augments the bounding box with the strokewidth and shadow offsets.
     */ augmentBoundingBox(bbox) {
        if (this.isShadow) {
            bbox.width += Math.ceil((0, $4vC7I.StyleDefaultsConfig).shadowOffsetX * this.scale);
            bbox.height += Math.ceil((0, $4vC7I.StyleDefaultsConfig).shadowOffsetX * this.scale);
        }
        // Adds strokeWidth
        bbox.grow((this.strokeWidth ?? 0) * this.scale / 2);
    }
    /**
     * Returns true if the bounds should be inverted.
     */ isPaintBoundsInverted() {
        // Stencil implements inversion via aspect
        return !this.stencil && (this.direction === 'north' || this.direction === 'south');
    }
    /**
     * Returns the rotation from the style.
     */ getRotation() {
        return this.rotation ?? 0;
    }
    /**
     * Returns the rotation for the text label.
     */ getTextRotation() {
        let rot = this.getRotation();
        if (!(this.style?.horizontal ?? true)) rot += this.verticalTextRotation || -90; // WARNING WARNING!!!! ===============================================================================================
        return rot;
    }
    /**
     * Returns the actual rotation of the shape.
     */ getShapeRotation() {
        let rot = this.getRotation();
        switch(this.direction){
            case 'north':
                rot += 270;
                break;
            case 'west':
                rot += 180;
                break;
            case 'south':
                rot += 90;
                break;
        }
        return rot;
    }
    /**
     * Adds a transparent rectangle that catches all events.
     */ createTransparentSvgRectangle(x, y, w, h) {
        const rect = document.createElementNS((0, $cBHcM.NS_SVG), 'rect');
        rect.setAttribute('x', String(x));
        rect.setAttribute('y', String(y));
        rect.setAttribute('width', String(w));
        rect.setAttribute('height', String(h));
        rect.setAttribute('fill', (0, $cBHcM.NONE));
        rect.setAttribute('stroke', (0, $cBHcM.NONE));
        rect.setAttribute('pointer-events', 'all');
        return rect;
    }
    redrawHtmlShape() {
        return;
    }
    /**
     * Sets a transparent background CSS style to catch all events.
     *
     * Paints the line shape.
     */ setTransparentBackgroundImage(node) {
        node.style.backgroundImage = `url('${(0, $d47e32a58f71e01d$export$2e2bcd8739ae039).imageBasePath}/transparent.gif')`;
    }
    /**
     * Paints the line shape.
     */ releaseSvgGradients(grads) {
        for(const key in grads){
            const gradient = grads[key];
            if (gradient) {
                gradient.mxRefCount = (gradient.mxRefCount || 0) - 1;
                if (gradient.mxRefCount === 0 && gradient.parentNode) gradient.parentNode.removeChild(gradient);
            }
        }
    }
    /**
     * Destroys the shape by removing it from the DOM and releasing the DOM
     * node associated with the shape using {@link Event#release}.
     */ destroy() {
        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).release(this.node);
        if (this.node.parentNode) this.node.parentNode.removeChild(this.node);
        this.node.innerHTML = '';
        // Decrements refCount and removes unused
        this.releaseSvgGradients(this.oldGradients);
        this.oldGradients = {};
    }
}
var $d0e43aed19391bda$export$2e2bcd8739ae039 = $d0e43aed19391bda$var$Shape;


/**
 * Extends {@link Shape} to implement a polyline (a line with multiple points).
 *
 * The shape is used to represent edges, not vertices.
 *
 * This shape is **NOT** registered in {@link ShapeRegistry} when using {@link Graph} or calling {@link registerDefaultShapes}.
 *
 * @category Edge Shapes
 */ class $4b136726e3ad0ef6$var$PolylineShape extends (0, $d0e43aed19391bda$export$2e2bcd8739ae039) {
    /**
     * Constructs a new polyline shape.
     *
     * @param points Array of <{@link Point} that define the points. This is stored in {@link Shape.points}.
     * @param stroke String that defines the stroke color. Default is 'black'. This is stored in {@link Shape.stroke}.
     * @param strokeWidth Optional integer that defines the stroke width. Default is 1. This is stored in {@link Shape.strokeWidth}.
     */ constructor(points, stroke, strokeWidth = 1){
        super();
        this.points = points;
        this.stroke = stroke;
        this.strokeWidth = strokeWidth;
    }
    /**
     * Returns 0.
     */ getRotation() {
        return 0;
    }
    /**
     * Returns 0.
     */ getShapeRotation() {
        return 0;
    }
    /**
     * Returns false.
     */ isPaintBoundsInverted() {
        return false;
    }
    /**
     * Paints the line shape.
     */ paintEdgeShape(c, pts) {
        const prev = c.pointerEventsValue;
        c.pointerEventsValue = 'stroke';
        if (!this.style?.curved) this.paintLine(c, pts, this.isRounded);
        else this.paintCurvedLine(c, pts);
        c.pointerEventsValue = prev;
    }
    /**
     * Paints the line shape.
     */ paintLine(c, pts, rounded) {
        c.begin();
        this.addPoints(c, pts, rounded, this.getBaseArcSize(), false);
        c.stroke();
    }
    /**
     * Paints the line shape.
     */ paintCurvedLine(c, pts) {
        c.begin();
        const pt = pts[0];
        const n = pts.length;
        c.moveTo(pt.x, pt.y);
        for(let i = 1; i < n - 2; i += 1){
            const p0 = pts[i];
            const p1 = pts[i + 1];
            const ix = (p0.x + p1.x) / 2;
            const iy = (p0.y + p1.y) / 2;
            c.quadTo(p0.x, p0.y, ix, iy);
        }
        const p0 = pts[n - 2];
        const p1 = pts[n - 1];
        c.quadTo(p0.x, p0.y, p1.x, p1.y);
        c.stroke();
    }
}
var $4b136726e3ad0ef6$export$2e2bcd8739ae039 = $4b136726e3ad0ef6$var$PolylineShape;


const $cc7c563de8857d49$export$4c950d614ff6b903 = {
    horizontalPageBreaks: null,
    verticalPageBreaks: null,
    updatePageBreaks (visible, _width, _height) {
        const { scale: scale, translate: tr } = this.getView();
        const fmt = this.getPageFormat();
        const ps = scale * this.getPageScale();
        const bounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(0, 0, fmt.width * ps, fmt.height * ps);
        const gb = (0, $2997c239141ea844$export$2e2bcd8739ae039).fromRectangle(this.getGraphBounds());
        gb.width = Math.max(1, gb.width);
        gb.height = Math.max(1, gb.height);
        bounds.x = Math.floor((gb.x - tr.x * scale) / bounds.width) * bounds.width + tr.x * scale;
        bounds.y = Math.floor((gb.y - tr.y * scale) / bounds.height) * bounds.height + tr.y * scale;
        gb.width = Math.ceil((gb.width + (gb.x - bounds.x)) / bounds.width) * bounds.width;
        gb.height = Math.ceil((gb.height + (gb.y - bounds.y)) / bounds.height) * bounds.height;
        // Does not show page breaks if the scale is too small
        visible = visible && Math.min(bounds.width, bounds.height) > this.getMinPageBreakDist();
        const horizontalCount = visible ? Math.ceil(gb.height / bounds.height) + 1 : 0;
        const verticalCount = visible ? Math.ceil(gb.width / bounds.width) + 1 : 0;
        const right = (verticalCount - 1) * bounds.width;
        const bottom = (horizontalCount - 1) * bounds.height;
        if (this.horizontalPageBreaks == null && horizontalCount > 0) this.horizontalPageBreaks = [];
        if (this.verticalPageBreaks == null && verticalCount > 0) this.verticalPageBreaks = [];
        const drawPageBreaks = (breaks)=>{
            if (!breaks) return;
            const count = breaks === this.horizontalPageBreaks ? horizontalCount : verticalCount;
            for(let i = 0; i <= count; i += 1){
                const pts = breaks === this.horizontalPageBreaks ? [
                    new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(Math.round(bounds.x), Math.round(bounds.y + i * bounds.height)),
                    new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(Math.round(bounds.x + right), Math.round(bounds.y + i * bounds.height))
                ] : [
                    new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(Math.round(bounds.x + i * bounds.width), Math.round(bounds.y)),
                    new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(Math.round(bounds.x + i * bounds.width), Math.round(bounds.y + bottom))
                ];
                if (breaks[i] != null) {
                    breaks[i].points = pts;
                    breaks[i].redraw();
                } else {
                    const pageBreak = new (0, $4b136726e3ad0ef6$export$2e2bcd8739ae039)(pts, this.getPageBreakColor());
                    pageBreak.dialect = this.getDialect();
                    pageBreak.pointerEvents = false;
                    pageBreak.isDashed = this.isPageBreakDashed();
                    pageBreak.init(this.getView().backgroundPane);
                    pageBreak.redraw();
                    breaks[i] = pageBreak;
                }
            }
            for(let i = count; i < breaks.length; i += 1)breaks[i].destroy();
            breaks.splice(count, breaks.length - count);
        };
        drawPageBreaks(this.horizontalPageBreaks);
        drawPageBreaks(this.verticalPageBreaks);
    }
};


/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 




const $84a4958bf2b15fa8$export$a2e7e4f95025d9b3 = {
    shiftPreview1: null,
    shiftPreview2: null,
    useScrollbarsForPanning: true,
    isUseScrollbarsForPanning () {
        return this.useScrollbarsForPanning;
    },
    timerAutoScroll: false,
    isTimerAutoScroll () {
        return this.timerAutoScroll;
    },
    allowAutoPanning: false,
    isAllowAutoPanning () {
        return this.allowAutoPanning;
    },
    panDx: 0,
    getPanDx () {
        return this.panDx;
    },
    setPanDx (dx) {
        this.panDx = dx;
    },
    panDy: 0,
    getPanDy () {
        return this.panDy;
    },
    setPanDy (dy) {
        this.panDy = dy;
    },
    panGraph (dx, dy) {
        const container = this.getContainer();
        if (this.useScrollbarsForPanning && (0, $b55d6ca3b42398e2$export$988b38dbf6859d61)(container)) {
            container.scrollLeft = -dx;
            container.scrollTop = -dy;
        } else {
            const canvas = this.getView().getCanvas();
            // Puts everything inside the container in a DIV so that it
            // can be moved without changing the state of the container
            if (dx === 0 && dy === 0) {
                canvas.removeAttribute('transform');
                if (this.shiftPreview1) {
                    let child = this.shiftPreview1.firstChild;
                    while(child){
                        const next = child.nextSibling;
                        container.appendChild(child);
                        child = next;
                    }
                    if (this.shiftPreview1.parentNode) this.shiftPreview1.parentNode.removeChild(this.shiftPreview1);
                    this.shiftPreview1 = null;
                    container.appendChild(canvas.parentNode);
                    const shiftPreview2 = this.shiftPreview2;
                    child = shiftPreview2.firstChild;
                    while(child){
                        const next = child.nextSibling;
                        container.appendChild(child);
                        child = next;
                    }
                    if (shiftPreview2.parentNode) shiftPreview2.parentNode.removeChild(shiftPreview2);
                    this.shiftPreview2 = null;
                }
            } else {
                canvas.setAttribute('transform', `translate(${dx},${dy})`);
                if (!this.shiftPreview1) {
                    // Needs two divs for stuff before and after the SVG element
                    this.shiftPreview1 = document.createElement('div');
                    this.shiftPreview1.style.position = 'absolute';
                    this.shiftPreview1.style.overflow = 'visible';
                    this.shiftPreview2 = document.createElement('div');
                    this.shiftPreview2.style.position = 'absolute';
                    this.shiftPreview2.style.overflow = 'visible';
                    let current = this.shiftPreview1;
                    let child = container.firstChild;
                    while(child){
                        const next = child.nextSibling;
                        // SVG element is moved via transform attribute
                        // @ts-ignore
                        if (child !== canvas.parentNode) current.appendChild(child);
                        else current = this.shiftPreview2;
                        child = next;
                    }
                    // Inserts elements only if not empty
                    if (this.shiftPreview1.firstChild) container.insertBefore(this.shiftPreview1, canvas.parentNode);
                    if (this.shiftPreview2.firstChild) container.appendChild(this.shiftPreview2);
                }
                this.shiftPreview1.style.left = `${dx}px`;
                this.shiftPreview1.style.top = `${dy}px`;
                if (this.shiftPreview2) {
                    this.shiftPreview2.style.left = `${dx}px`;
                    this.shiftPreview2.style.top = `${dy}px`;
                }
            }
            this.panDx = dx;
            this.panDy = dy;
            this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).PAN));
        }
    },
    scrollCellToVisible (cell, center = false) {
        const x = -this.getView().translate.x;
        const y = -this.getView().translate.y;
        const state = this.getView().getState(cell);
        if (state) {
            const bounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(x + state.x, y + state.y, state.width, state.height);
            if (center && this.getContainer()) {
                const w = this.getContainer().clientWidth;
                const h = this.getContainer().clientHeight;
                bounds.x = bounds.getCenterX() - w / 2;
                bounds.width = w;
                bounds.y = bounds.getCenterY() - h / 2;
                bounds.height = h;
            }
            const tr = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(this.getView().translate.x, this.getView().translate.y);
            if (this.scrollRectToVisible(bounds)) {
                // Triggers an update via the view's event source
                const tr2 = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(this.getView().translate.x, this.getView().translate.y);
                this.getView().translate.x = tr.x;
                this.getView().translate.y = tr.y;
                this.getView().setTranslate(tr2.x, tr2.y);
            }
        }
    },
    scrollRectToVisible (rect) {
        let isChanged = false;
        const container = this.getContainer();
        const w = container.offsetWidth;
        const h = container.offsetHeight;
        const widthLimit = Math.min(w, rect.width);
        const heightLimit = Math.min(h, rect.height);
        if ((0, $b55d6ca3b42398e2$export$988b38dbf6859d61)(container)) {
            rect.x += this.getView().translate.x;
            rect.y += this.getView().translate.y;
            let dx = container.scrollLeft - rect.x;
            const ddx = Math.max(dx - container.scrollLeft, 0);
            if (dx > 0) container.scrollLeft -= dx + 2;
            else {
                dx = rect.x + widthLimit - container.scrollLeft - container.clientWidth;
                if (dx > 0) container.scrollLeft += dx + 2;
            }
            let dy = container.scrollTop - rect.y;
            const ddy = Math.max(0, dy - container.scrollTop);
            if (dy > 0) container.scrollTop -= dy + 2;
            else {
                dy = rect.y + heightLimit - container.scrollTop - container.clientHeight;
                if (dy > 0) container.scrollTop += dy + 2;
            }
            if (!this.useScrollbarsForPanning && (ddx != 0 || ddy != 0)) this.getView().setTranslate(ddx, ddy);
        } else {
            const x = -this.getView().translate.x;
            const y = -this.getView().translate.y;
            const s = this.getView().scale;
            if (rect.x + widthLimit > x + w) {
                this.getView().translate.x -= (rect.x + widthLimit - w - x) / s;
                isChanged = true;
            }
            if (rect.y + heightLimit > y + h) {
                this.getView().translate.y -= (rect.y + heightLimit - h - y) / s;
                isChanged = true;
            }
            if (rect.x < x) {
                this.getView().translate.x += (x - rect.x) / s;
                isChanged = true;
            }
            if (rect.y < y) {
                this.getView().translate.y += (y - rect.y) / s;
                isChanged = true;
            }
            if (isChanged) {
                this.getView().refresh();
                const selectionCellsHandler = this.getPlugin('SelectionCellsHandler');
                // Repaints selection marker (ticket 18)
                if (selectionCellsHandler) selectionCellsHandler.refresh();
            }
        }
        return isChanged;
    },
    setPanning (enabled) {
        const panningHandler = this.getPlugin('PanningHandler');
        panningHandler && (panningHandler.panningEnabled = enabled);
    }
};


/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ const $8634ffd5b74882cb$export$e09e2e7c7ba3b830 = {
    portsEnabled: true,
    isPort (cell) {
        return false;
    },
    getTerminalForPort (cell, _source = false) {
        return cell.getParent();
    },
    isPortsEnabled () {
        return this.portsEnabled;
    },
    setPortsEnabled (value) {
        this.portsEnabled = value;
    }
};


/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 


const $83521e847399c002$export$748254dc0d2dca9 = {
    // Always non-null at runtime: initialized in {@link AbstractGraph.initializeCollaborators}
    // via {@link setSelectionModel}, which shadows the `null` set on the prototype by the mixin.
    selectionModel: null,
    getSelectionModel () {
        return this.selectionModel;
    },
    setSelectionModel (selectionModel) {
        this.selectionModel = selectionModel;
    },
    /*****************************************************************************
     * Selection
     *****************************************************************************/ isCellSelected (cell) {
        return this.selectionModel.isSelected(cell);
    },
    isSelectionEmpty () {
        return this.selectionModel.isEmpty();
    },
    clearSelection () {
        this.selectionModel.clear();
    },
    getSelectionCount () {
        return this.selectionModel.cells.length;
    },
    getSelectionCell () {
        return this.selectionModel.cells[0];
    },
    getSelectionCells () {
        return this.selectionModel.cells.slice();
    },
    setSelectionCell (cell) {
        this.selectionModel.setCell(cell);
    },
    setSelectionCells (cells) {
        this.selectionModel.setCells(cells);
    },
    addSelectionCell (cell) {
        this.selectionModel.addCell(cell);
    },
    addSelectionCells (cells) {
        this.selectionModel.addCells(cells);
    },
    removeSelectionCell (cell) {
        this.selectionModel.removeCell(cell);
    },
    removeSelectionCells (cells) {
        this.selectionModel.removeCells(cells);
    },
    selectRegion (rect, evt) {
        const cells = this.getCells(rect.x, rect.y, rect.width, rect.height);
        this.selectCellsForEvent(cells, evt);
        return cells;
    },
    selectNextCell () {
        this.selectCell(true);
    },
    selectPreviousCell () {
        this.selectCell();
    },
    selectParentCell () {
        this.selectCell(false, true);
    },
    selectChildCell () {
        this.selectCell(false, false, true);
    },
    selectCell (isNext = false, isParent = false, isChild = false) {
        const cell = this.selectionModel.cells.length > 0 ? this.selectionModel.cells[0] : null;
        if (this.selectionModel.cells.length > 1) this.selectionModel.clear();
        const parent = cell ? cell.getParent() : this.getDefaultParent();
        const childCount = parent.getChildCount();
        if (!cell && childCount > 0) {
            const child = parent.getChildAt(0);
            this.setSelectionCell(child);
        } else if (parent && (!cell || isParent) && this.getView().getState(parent) && parent.getGeometry()) {
            if (this.getCurrentRoot() !== parent) this.setSelectionCell(parent);
        } else if (cell && isChild) {
            const tmp = cell.getChildCount();
            if (tmp > 0) {
                const child = cell.getChildAt(0);
                this.setSelectionCell(child);
            }
        } else if (childCount > 0) {
            let i = parent.getIndex(cell);
            if (isNext) {
                i++;
                const child = parent.getChildAt(i % childCount);
                this.setSelectionCell(child);
            } else {
                i--;
                const index = i < 0 ? childCount - 1 : i;
                const child = parent.getChildAt(index);
                this.setSelectionCell(child);
            }
        }
    },
    selectAll (parent, descendants = false) {
        parent = parent ?? this.getDefaultParent();
        const cells = descendants ? parent.filterDescendants((cell)=>{
            return cell !== parent && !!this.getView().getState(cell);
        }) : parent.getChildren();
        this.setSelectionCells(cells);
    },
    selectVertices (parent, selectGroups = false) {
        this.selectCells(true, false, parent, selectGroups);
    },
    selectEdges (parent) {
        this.selectCells(false, true, parent);
    },
    selectCells (vertices = false, edges = false, parent, selectGroups = false) {
        parent = parent ?? this.getDefaultParent();
        const filter = (cell)=>{
            const p = cell.getParent();
            return !!this.getView().getState(cell) && ((selectGroups || cell.getChildCount() === 0) && cell.isVertex() && vertices && p && !p.isEdge() || cell.isEdge() && edges);
        };
        const cells = parent.filterDescendants(filter);
        this.setSelectionCells(cells);
    },
    selectCellForEvent (cell, evt) {
        const isSelected = this.isCellSelected(cell);
        if (this.isToggleEvent(evt)) {
            if (isSelected) this.removeSelectionCell(cell);
            else this.addSelectionCell(cell);
        } else if (!isSelected || this.getSelectionCount() !== 1) this.setSelectionCell(cell);
    },
    selectCellsForEvent (cells, evt) {
        if (this.isToggleEvent(evt)) this.addSelectionCells(cells);
        else this.setSelectionCells(cells);
    },
    isSiblingSelected (cell) {
        const parent = cell.getParent();
        const childCount = parent.getChildCount();
        for(let i = 0; i < childCount; i += 1){
            const child = parent.getChildAt(i);
            if (cell !== child && this.isCellSelected(child)) return true;
        }
        return false;
    },
    /*****************************************************************************
     * Selection state
     *****************************************************************************/ getSelectionCellsForChanges (changes, ignoreFn = null) {
        const coveredElements = new Map();
        const cells = [];
        const addCell = (cell)=>{
            if (!coveredElements.has(cell) && this.getDataModel().contains(cell)) {
                if (cell.isEdge() || cell.isVertex()) {
                    coveredElements.set(cell, true);
                    cells.push(cell);
                } else {
                    const childCount = cell.getChildCount();
                    for(let i = 0; i < childCount; i += 1)addCell(cell.getChildAt(i));
                }
            }
        };
        for(let i = 0; i < changes.length; i += 1){
            const change = changes[i];
            if (change.constructor !== (0, $eb24dd3dae295813$export$2e2bcd8739ae039) && (!ignoreFn || !ignoreFn(change))) {
                let cell = null;
                if (change instanceof (0, $12157cc2312b9a0d$export$2e2bcd8739ae039)) cell = change.child;
                else if (change.cell && change.cell instanceof (0, $0e256159624f4593$export$2e2bcd8739ae039)) cell = change.cell;
                if (cell) addCell(cell);
            }
        }
        return cells;
    },
    updateSelection () {
        const cells = this.getSelectionCells();
        const removed = [];
        for (const cell of cells)if (!this.getDataModel().contains(cell) || !cell.isVisible()) removed.push(cell);
        else {
            let par = cell.getParent();
            while(par && par !== this.getView().currentRoot){
                if (par.isCollapsed() || !par.isVisible()) {
                    removed.push(cell);
                    break;
                }
                par = par.getParent();
            }
        }
        this.removeSelectionCells(removed);
    }
};


/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ // @ts-expect-error The properties of PartialGraph are defined elsewhere.
const $a13d581094df3b45$export$6de44a9c5599d543 = {
    snapTolerance: 0,
    getSnapTolerance () {
        return this.snapTolerance;
    },
    gridSize: 10,
    gridEnabled: true,
    snap (value) {
        if (this.gridEnabled) value = Math.round(value / this.gridSize) * this.gridSize;
        return value;
    },
    snapDelta (delta, bounds, ignoreGrid = false, ignoreHorizontal = false, ignoreVertical = false) {
        const t = this.getView().translate;
        const s = this.getView().scale;
        if (!ignoreGrid && this.gridEnabled) {
            const tol = this.gridSize * s * 0.5;
            if (!ignoreHorizontal) {
                const tx = bounds.x - (this.snap(bounds.x / s - t.x) + t.x) * s;
                if (Math.abs(delta.x - tx) < tol) delta.x = 0;
                else delta.x = this.snap(delta.x / s) * s - tx;
            }
            if (!ignoreVertical) {
                const ty = bounds.y - (this.snap(bounds.y / s - t.y) + t.y) * s;
                if (Math.abs(delta.y - ty) < tol) delta.y = 0;
                else delta.y = this.snap(delta.y / s) * s - ty;
            }
        } else {
            const tol = 0.5 * s;
            if (!ignoreHorizontal) {
                const tx = bounds.x - (Math.round(bounds.x / s - t.x) + t.x) * s;
                if (Math.abs(delta.x - tx) < tol) delta.x = 0;
                else delta.x = Math.round(delta.x / s) * s - tx;
            }
            if (!ignoreVertical) {
                const ty = bounds.y - (Math.round(bounds.y / s - t.y) + t.y) * s;
                if (Math.abs(delta.y - ty) < tol) delta.y = 0;
                else delta.y = Math.round(delta.y / s) * s - ty;
            }
        }
        return delta;
    },
    isGridEnabled () {
        return this.gridEnabled;
    },
    setGridEnabled (value) {
        this.gridEnabled = value;
    },
    getGridSize () {
        return this.gridSize;
    },
    setGridSize (value) {
        this.gridSize = value;
    }
};


/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 




var $4vC7I = parcelRequire("4vC7I");
const $a967ac45f86f7386$export$a8feb72689307917 = {
    swimlaneSelectionEnabled: true,
    swimlaneNesting: true,
    swimlaneIndicatorColorAttribute: 'fillColor',
    getSwimlane (cell = null) {
        while(cell && !this.isSwimlane(cell))cell = cell.getParent();
        return cell;
    },
    getSwimlaneAt (x, y, parent) {
        if (!parent) {
            parent = this.getCurrentRoot();
            if (!parent) parent = this.getDataModel().getRoot();
        }
        if (parent) {
            const childCount = parent.getChildCount();
            for(let i = 0; i < childCount; i += 1){
                const child = parent.getChildAt(i);
                if (child) {
                    const result = this.getSwimlaneAt(x, y, child);
                    if (result != null) return result;
                    if (child.isVisible() && this.isSwimlane(child)) {
                        const state = this.getView().getState(child);
                        if (state && this.intersects(state, x, y)) return child;
                    }
                }
            }
        }
        return null;
    },
    hitsSwimlaneContent (swimlane, x, y) {
        const state = this.getView().getState(swimlane);
        const size = this.getStartSize(swimlane);
        if (state) {
            const scale = this.getView().getScale();
            x -= state.x;
            y -= state.y;
            if (size.width > 0 && x > 0 && x > size.width * scale) return true;
            if (size.height > 0 && y > 0 && y > size.height * scale) return true;
        }
        return false;
    },
    getStartSize (swimlane, ignoreState = false) {
        const result = new (0, $2997c239141ea844$export$2e2bcd8739ae039)();
        const style = this.getCurrentCellStyle(swimlane, ignoreState);
        const size = style.startSize ?? (0, $4vC7I.StyleDefaultsConfig).startSize;
        if (style.horizontal ?? true) result.height = size;
        else result.width = size;
        return result;
    },
    getSwimlaneDirection (style) {
        const dir = style.direction ?? 'east';
        const flipH = style.flipH;
        const flipV = style.flipV;
        const h = style.horizontal ?? true;
        let n = h ? 0 : 3;
        switch(dir){
            case 'north':
                n--;
                break;
            case 'west':
                n += 2;
                break;
            case 'south':
                n += 1;
                break;
        }
        const _mod = (0, $f7ff90b8964488a6$export$842a2cf37af977e1)(n, 2);
        if (flipH && _mod === 1) n += 2;
        if (flipV && _mod === 0) n += 2;
        return [
            'north',
            'east',
            'south',
            'west'
        ][(0, $f7ff90b8964488a6$export$842a2cf37af977e1)(n, 4)];
    },
    getActualStartSize (swimlane, ignoreState = false) {
        const result = new (0, $2997c239141ea844$export$2e2bcd8739ae039)();
        if (this.isSwimlane(swimlane, ignoreState)) {
            const style = this.getCurrentCellStyle(swimlane, ignoreState);
            const size = style.startSize ?? (0, $4vC7I.StyleDefaultsConfig).startSize;
            const dir = this.getSwimlaneDirection(style);
            switch(dir){
                case 'north':
                    result.y = size;
                    break;
                case 'west':
                    result.x = size;
                    break;
                case 'south':
                    result.height = size;
                    break;
                default:
                    result.width = size;
            }
        }
        return result;
    },
    isSwimlane (cell, ignoreState = false) {
        if (cell && cell.getParent() !== this.getDataModel().getRoot() && !cell.isEdge()) return this.getCurrentCellStyle(cell, ignoreState).shape === 'swimlane';
        return false;
    },
    isValidDropTarget (cell, cells, evt) {
        return cell && (this.isSplitEnabled() && this.isSplitTarget(cell, cells, evt) || !cell.isEdge() && (this.isSwimlane(cell) || cell.getChildCount() > 0 && !cell.isCollapsed()));
    },
    getDropTarget (cells, evt, cell = null, clone = false) {
        if (!this.isSwimlaneNesting()) for(let i = 0; i < cells.length; i += 1){
            if (this.isSwimlane(cells[i])) return null;
        }
        const pt = (0, $b55d6ca3b42398e2$export$864dc177f7f5bda1)(this.getContainer(), (0, $f192e93a2fd1153c$export$87583e2c100c6a4f)(evt), (0, $f192e93a2fd1153c$export$195fc3609401443f)(evt));
        pt.x -= this.getPanDx();
        pt.y -= this.getPanDy();
        const swimlane = this.getSwimlaneAt(pt.x, pt.y);
        if (!cell) cell = swimlane;
        else if (swimlane) {
            // Checks if the cell is an ancestor of the swimlane
            // under the mouse and uses the swimlane in that case
            let tmp = swimlane.getParent();
            while(tmp && this.isSwimlane(tmp) && tmp !== cell)tmp = tmp.getParent();
            if (tmp === cell) cell = swimlane;
        }
        while(cell && !this.isValidDropTarget(cell, cells, evt) && !this.getDataModel().isLayer(cell))cell = cell.getParent();
        // Checks if parent is dropped into child if not cloning
        let parentCell = cell;
        if (!clone) while(parentCell && !cells.includes(parentCell))parentCell = parentCell.getParent();
        return !this.getDataModel().isLayer(cell) && !parentCell ? cell : null;
    },
    isSwimlaneNesting () {
        return this.swimlaneNesting;
    },
    setSwimlaneNesting (value) {
        this.swimlaneNesting = value;
    },
    isSwimlaneSelectionEnabled () {
        return this.swimlaneSelectionEnabled;
    },
    setSwimlaneSelectionEnabled (value) {
        this.swimlaneSelectionEnabled = value;
    }
};


/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ // @ts-expect-error The properties of PartialGraph are defined elsewhere.
const $a3fb24498245ffcd$export$4c6b7191f1a8d68f = {
    isTerminalPointMovable (cell, source) {
        return true;
    },
    getOpposites (edges, terminal = null, includeSources = true, includeTargets = true) {
        const terminals = [];
        // Fast lookup to avoid duplicates in terminals array
        const coveredEntries = new Map();
        for(let i = 0; i < edges.length; i += 1){
            const state = this.getView().getState(edges[i]);
            const source = state ? state.getVisibleTerminal(true) : this.getView().getVisibleTerminal(edges[i], true);
            const target = state ? state.getVisibleTerminal(false) : this.getView().getVisibleTerminal(edges[i], false);
            // Checks if the terminal is the source of the edge and if the target should be stored in the result
            if (source === terminal && target && target !== terminal && includeTargets) {
                if (!coveredEntries.has(target)) {
                    coveredEntries.set(target, true);
                    terminals.push(target);
                }
            } else if (target === terminal && source && source !== terminal && includeSources) {
                if (!coveredEntries.has(source)) {
                    coveredEntries.set(source, true);
                    terminals.push(source);
                }
            }
        }
        return terminals;
    }
};


/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 


var $h5l15 = parcelRequire("h5l15");
const $3871cf2271a88856$export$af6259491f2fb49f = {
    validationAlert (message) {
        alert(message);
    },
    isEdgeValid (edge, source, target) {
        return !this.getEdgeValidationError(edge, source, target);
    },
    getEdgeValidationError (edge = null, source = null, target = null) {
        if (edge && !this.isAllowDanglingEdges() && (!source || !target)) return '';
        if (edge && !edge.getTerminal(true) && !edge.getTerminal(false)) return null;
        // Checks if we're dealing with a loop
        if (!this.isAllowLoops() && source === target && source) return '';
        // Checks if the connection is generally allowed
        if (!this.isValidConnection(source, target)) return '';
        if (source && target) {
            let error = '';
            // Checks if the cells are already connected
            // and adds an error message if required
            if (!this.isMultigraph()) {
                const tmp = this.getDataModel().getEdgesBetween(source, target, true);
                // Checks if the source and target are not connected by another edge
                if (tmp.length > 1 || tmp.length === 1 && tmp[0] !== edge) error += `${(0, $78efedcb0f6c688d$export$d73ee8ef04f5226a)(this.getAlreadyConnectedResource()) || this.getAlreadyConnectedResource()}\n`;
            }
            // Gets the number of outgoing edges from the source
            // and the number of incoming edges from the target
            // without counting the edge being currently changed.
            const sourceOut = source.getDirectedEdgeCount(true, edge);
            const targetIn = target.getDirectedEdgeCount(false, edge);
            // Checks the change against each multiplicity rule
            for (const multiplicity of this.multiplicities){
                const err = multiplicity.check(this, edge, source, target, sourceOut, targetIn);
                if (!(0, $h5l15.isNullish)(err)) error += err;
            }
            // Validates the source and target terminals independently
            const err = this.validateEdge(edge, source, target);
            if (!(0, $h5l15.isNullish)(err)) error += err;
            return error.length > 0 ? error : null;
        }
        return this.isAllowDanglingEdges() ? null : '';
    },
    validateEdge (edge = null, source = null, target = null) {
        return null;
    },
    validateGraph (cell = null, context) {
        cell = cell ?? this.getDataModel().getRoot();
        if (!cell) return 'The root does not exist!';
        context = context ?? {};
        let isValid = true;
        const childCount = cell.getChildCount();
        for(let i = 0; i < childCount; i += 1){
            const tmp = cell.getChildAt(i);
            let ctx = context;
            if (this.isValidRoot(tmp)) ctx = {};
            const warn = this.validateGraph(tmp, ctx);
            if (warn) this.setCellWarning(tmp, warn.replace(/\n/g, '<br>'));
            else this.setCellWarning(tmp, null);
            isValid = isValid && warn == null;
        }
        let warning = '';
        // Adds error for invalid children if collapsed (children invisible)
        if (cell && cell.isCollapsed() && !isValid) warning += `${(0, $78efedcb0f6c688d$export$d73ee8ef04f5226a)(this.getContainsValidationErrorsResource()) || this.getContainsValidationErrorsResource()}\n`;
        // Checks edges and cells using the defined multiplicities
        if (cell && cell.isEdge()) warning += this.getEdgeValidationError(cell, cell.getTerminal(true), cell.getTerminal(false)) || '';
        else warning += this.getCellValidationError(cell) || '';
        // Checks custom validation rules
        const err = this.validateCell(cell, context);
        if (!(0, $h5l15.isNullish)(err)) warning += err;
        // Updates the display with the warning icons
        // before any potential alerts are displayed.
        // LATER: Move this into addCellOverlay. Redraw
        // should check if overlay was added or removed.
        if (cell.getParent() == null) this.getView().validate();
        return warning.length > 0 || !isValid ? warning : null;
    },
    getCellValidationError (cell) {
        const outCount = cell.getDirectedEdgeCount(true);
        const inCount = cell.getDirectedEdgeCount(false);
        const value = cell.getValue();
        let error = '';
        for(let i = 0; i < this.multiplicities.length; i += 1){
            const rule = this.multiplicities[i];
            if (rule.source && (0, $b1d29c834e82fef5$export$8ee0fc9ee280b4ee)(value, rule.type, rule.attr, rule.value) && (outCount > rule.max || outCount < rule.min)) error += `${rule.countError}\n`;
            else if (!rule.source && (0, $b1d29c834e82fef5$export$8ee0fc9ee280b4ee)(value, rule.type, rule.attr, rule.value) && (inCount > rule.max || inCount < rule.min)) error += `${rule.countError}\n`;
        }
        return error.length > 0 ? error : null;
    },
    validateCell (cell, context) {
        return null;
    }
};


/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 

const $44dd52a4de88f311$export$9067d9443efadc22 = {
    vertexLabelsMovable: false,
    allowNegativeCoordinates: true,
    isAllowNegativeCoordinates () {
        return this.allowNegativeCoordinates;
    },
    setAllowNegativeCoordinates (value) {
        this.allowNegativeCoordinates = value;
    },
    insertVertex (...args) {
        let parent;
        let id;
        let value;
        let x;
        let y;
        let width;
        let height;
        let style;
        let relative;
        let geometryClass;
        if (args.length === 1 && typeof args[0] === 'object') {
            const params = args[0];
            parent = params.parent;
            id = params.id;
            value = params.value;
            x = 'x' in params ? params.x : params.position?.[0];
            y = 'y' in params ? params.y : params.position?.[1];
            width = 'width' in params ? params.width : params.size?.[0];
            height = 'height' in params ? params.height : params.size?.[1];
            style = params.style;
            relative = params.relative;
            geometryClass = params.geometryClass;
        } else // Otherwise treat as arguments
        [parent, id, value, x, y, width, height, style, relative, geometryClass] = args;
        const vertex = this.createVertex(parent, id, value, x, y, width, height, style, relative, geometryClass);
        return this.addCell(vertex, parent);
    },
    createVertex (_parent, id, value, x, y, width, height, style, relative = false, geometryClass = (0, $6713282b00eec691$export$2e2bcd8739ae039)) {
        // Creates the geometry for the vertex
        const geometry = new geometryClass(x, y, width, height);
        geometry.relative = relative;
        // Creates the vertex
        const vertex = new (0, $0e256159624f4593$export$2e2bcd8739ae039)(value, geometry, style);
        vertex.setId(id); // this is not an issue to set undefined here. If so, the id will be auto-generated when adding the cell to the model
        vertex.setVertex(true);
        vertex.setConnectable(true);
        return vertex;
    },
    getChildVertices (parent) {
        return this.getChildCells(parent, true, false);
    },
    isVertexLabelsMovable () {
        return this.vertexLabelsMovable;
    },
    setVertexLabelsMovable (value) {
        this.vertexLabelsMovable = value;
    }
};


/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 

const $fcb68ea8132762ac$export$b5afc1b757e1a65d = {
    zoomFactor: 1.2,
    keepSelectionVisibleOnZoom: false,
    centerZoom: true,
    zoomIn () {
        this.zoom(this.zoomFactor);
    },
    zoomOut () {
        this.zoom(1 / this.zoomFactor);
    },
    zoomActual () {
        if (this.getView().scale === 1) this.getView().setTranslate(0, 0);
        else {
            this.getView().translate.x = 0;
            this.getView().translate.y = 0;
            this.getView().setScale(1);
        }
    },
    zoomTo (scale, center = false) {
        this.zoom(scale / this.getView().scale, center);
    },
    zoom (factor, center) {
        center = center ?? this.centerZoom;
        const scale = Math.round(this.getView().scale * factor * 100) / 100;
        const state = this.getView().getState(this.getSelectionCell());
        const container = this.getContainer();
        factor = scale / this.getView().scale;
        if (this.keepSelectionVisibleOnZoom && state != null) {
            const rect = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(state.x * factor, state.y * factor, state.width * factor, state.height * factor);
            // Refreshes the display only once if a scroll is carried out
            this.getView().scale = scale;
            if (!this.scrollRectToVisible(rect)) {
                this.getView().revalidate();
                // Forces an event to be fired but does not revalidate again
                this.getView().setScale(scale);
            }
        } else {
            const _hasScrollbars = (0, $b55d6ca3b42398e2$export$988b38dbf6859d61)(this.getContainer());
            if (center && !_hasScrollbars) {
                let dx = container.offsetWidth;
                let dy = container.offsetHeight;
                if (factor > 1) {
                    const f = (factor - 1) / (scale * 2);
                    dx *= -f;
                    dy *= -f;
                } else {
                    const f = (1 / factor - 1) / (this.getView().scale * 2);
                    dx *= f;
                    dy *= f;
                }
                this.getView().scaleAndTranslate(scale, this.getView().translate.x + dx, this.getView().translate.y + dy);
            } else {
                // Allows for changes of translate and scrollbars during setscale
                const tx = this.getView().translate.x;
                const ty = this.getView().translate.y;
                const sl = container.scrollLeft;
                const st = container.scrollTop;
                this.getView().setScale(scale);
                if (_hasScrollbars) {
                    let dx = 0;
                    let dy = 0;
                    if (center) {
                        dx = container.offsetWidth * (factor - 1) / 2;
                        dy = container.offsetHeight * (factor - 1) / 2;
                    }
                    container.scrollLeft = (this.getView().translate.x - tx) * this.getView().scale + Math.round(sl * factor + dx);
                    container.scrollTop = (this.getView().translate.y - ty) * this.getView().scale + Math.round(st * factor + dy);
                }
            }
        }
    },
    zoomToRect (rect) {
        const container = this.getContainer();
        const scaleX = container.clientWidth / rect.width;
        const scaleY = container.clientHeight / rect.height;
        const aspectFactor = scaleX / scaleY;
        // Remove any overlap of the rect outside the client area
        rect.x = Math.max(0, rect.x);
        rect.y = Math.max(0, rect.y);
        let rectRight = Math.min(container.scrollWidth, rect.x + rect.width);
        let rectBottom = Math.min(container.scrollHeight, rect.y + rect.height);
        rect.width = rectRight - rect.x;
        rect.height = rectBottom - rect.y;
        // The selection area has to be increased to the same aspect
        // ratio as the container, centred around the centre point of the
        // original rect passed in.
        if (aspectFactor < 1.0) {
            // Height needs increasing
            const newHeight = rect.height / aspectFactor;
            const deltaHeightBuffer = (newHeight - rect.height) / 2.0;
            rect.height = newHeight;
            // Assign up to half the buffer to the upper part of the rect, not crossing 0
            // put the rest on the bottom
            const upperBuffer = Math.min(rect.y, deltaHeightBuffer);
            rect.y -= upperBuffer;
            // Check if the bottom has extended too far
            rectBottom = Math.min(container.scrollHeight, rect.y + rect.height);
            rect.height = rectBottom - rect.y;
        } else {
            // Width needs increasing
            const newWidth = rect.width * aspectFactor;
            const deltaWidthBuffer = (newWidth - rect.width) / 2.0;
            rect.width = newWidth;
            // Assign up to half the buffer to the upper part of the rect, not crossing 0
            // put the rest on the bottom
            const leftBuffer = Math.min(rect.x, deltaWidthBuffer);
            rect.x -= leftBuffer;
            // Check if the right hand side has extended too far
            rectRight = Math.min(container.scrollWidth, rect.x + rect.width);
            rect.width = rectRight - rect.x;
        }
        const scale = container.clientWidth / rect.width;
        const newScale = this.getView().scale * scale;
        if (!(0, $b55d6ca3b42398e2$export$988b38dbf6859d61)(this.getContainer())) this.getView().scaleAndTranslate(newScale, this.getView().translate.x - rect.x / this.getView().scale, this.getView().translate.y - rect.y / this.getView().scale);
        else {
            this.getView().setScale(newScale);
            container.scrollLeft = Math.round(rect.x * scale);
            container.scrollTop = Math.round(rect.y * scale);
        }
    }
};


const $8cff855c18425434$export$80043f1805ddadcd = (target)=>{
    const mixIntoGraph = (0, $h5l15.mixInto)(target);
    // Apply the mixins in alphabetic order to ease maintenance.
    // The order should have no influence of the resulting Graph prototype.
    for (const mixin of [
        (0, $dd22e0d3739891de$export$14c400dc30c508e6),
        (0, $6aea47dc5754b787$export$3af94bf8f5a305d1),
        (0, $54830583bb43eee7$export$a8c1e24dcf7fcdb6),
        (0, $4209aee23314ac42$export$a39ff26707082afe),
        (0, $955dbf39e1d6c312$export$ab76d606b2038e62),
        (0, $29df245d7351981d$export$9dbbfd00a094a9ae),
        (0, $befecb7e189e687e$export$b883829f60f9e1f8),
        (0, $387ae64630512a7b$export$1935de4be750391c),
        (0, $2ec6cb622eeb3713$export$cbcd29e611f64d3f),
        (0, $a89fae7908329d67$export$e1d4ed99a3ebf40c),
        (0, $cc7c563de8857d49$export$4c950d614ff6b903),
        (0, $5339067944edd54d$export$a75d9540456969a2),
        (0, $84a4958bf2b15fa8$export$a2e7e4f95025d9b3),
        (0, $8634ffd5b74882cb$export$e09e2e7c7ba3b830),
        (0, $83521e847399c002$export$748254dc0d2dca9),
        (0, $a13d581094df3b45$export$6de44a9c5599d543),
        (0, $a967ac45f86f7386$export$a8feb72689307917),
        (0, $a3fb24498245ffcd$export$4c6b7191f1a8d68f),
        (0, $3871cf2271a88856$export$af6259491f2fb49f),
        (0, $44dd52a4de88f311$export$9067d9443efadc22),
        (0, $fcb68ea8132762ac$export$b5afc1b757e1a65d)
    ])mixIntoGraph(mixin);
};



var $h5l15 = parcelRequire("h5l15");

class $04d8eeb08050dccc$export$ad0a8adca2a96dfe extends (0, $17f25eceeba97548$export$2e2bcd8739ae039) {
    // ===================================================================================================================
    // Group: Main graph constructor and functions
    // ===================================================================================================================
    /**
     * Convenient hook method that can be used to register global styles and shapes using the related global registries.
     *
     * While registration can also be done outside of this class (as it applies globally),
     * implementing it here makes the registration process transparent to the caller of this class.
     *
     * Subclasses can override this method to register custom defaults.
     */ registerDefaults() {
    // do nothing, it's the purpose of this class not to load defaults.
    }
    constructor(options){
        super();
        this.destroyed = false;
        this.graphModelChangeListener = null;
        this.paintBackground = null;
        this.isConstrainedMoving = false;
        // ===================================================================================================================
        // Group: Variables that should be in the mixins but requiring per-instance initialization
        // The mixin application currently causes shared state for complex types (object/array),
        // so these are defined here to ensure a fresh instance per Graph.
        // See https://github.com/maxGraph/maxGraph/pull/751 and https://github.com/maxGraph/maxGraph/pull/879
        //
        // Every property of this group is covered by a per-instance test in
        // __tests__/view/no-global-state-for-mixin-properties.ts, run against each concrete graph implementation. Add a case
        // there when adding a property here, otherwise moving it to a mixin later silently shares it across all Graph
        // instances, with no error to signal it.
        // ===================================================================================================================
        /**
         * Specifies the alternate edge style to be used if the main control point on an edge is being double-clicked.
         * @default {}
         */ this.alternateEdgeStyle = {};
        this.cells = [];
        /**
         * Holds the mouse event listeners. See {@link fireMouseEvent}.
         */ this.mouseListeners = [];
        /**
         * An array of {@link Multiplicity} describing the allowed connections in a graph.
         */ this.multiplicities = [];
        /** Folding options. */ this.options = {
            foldingEnabled: true,
            collapsedImage: new (0, $6af2797f00fe3156$export$2e2bcd8739ae039)(`${(0, $d47e32a58f71e01d$export$2e2bcd8739ae039).imageBasePath}/collapsed.gif`, 9, 9),
            expandedImage: new (0, $6af2797f00fe3156$export$2e2bcd8739ae039)(`${(0, $d47e32a58f71e01d$export$2e2bcd8739ae039).imageBasePath}/expanded.gif`, 9, 9),
            collapseToPreferredSize: true
        };
        /**
         * Specifies the page format for the background page.
         * This is used as the default in {@link PrintPreview} and for painting the background page
         * if {@link pageVisible} is `true` and the page breaks if {@link pageBreaksVisible} is `true`.
         * @default {@link PAGE_FORMAT_A4_PORTRAIT}
         */ this.pageFormat = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(...(0, $cBHcM.PAGE_FORMAT_A4_PORTRAIT));
        /**
         * Specifies the {@link Image} for the image to be used to display a warning
         * overlay. See {@link setCellWarning}. Default value is Client.imageBasePath +
         * '/warning'.  The extension for the image depends on the platform. It is
         * '.png' on the Mac and '.gif' on all other platforms.
         */ this.warningImage = new (0, $6af2797f00fe3156$export$2e2bcd8739ae039)(`${(0, $d47e32a58f71e01d$export$2e2bcd8739ae039).imageBasePath}/warning${(0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_MAC ? '.png' : '.gif'}`, 16, 16);
        this.plugins = new Map();
        /**
         * RenderHint as it was passed to the constructor.
         */ this.renderHint = null;
        /**
         * Dialect to be used for drawing the graph.
         */ this.dialect = 'svg';
        /**
         * Value returned by {@link getOverlap} if {@link isAllowOverlapParent} returns
         * `true` for the given cell. {@link getOverlap} is used in {@link constrainChild} if
         * {@link isConstrainChild} returns `true`. The value specifies the
         * portion of the child which is allowed to overlap the parent.
         */ this.defaultOverlap = 0.5;
        /**
         * Specifies the default parent to be used to insert new cells.
         * This is used in {@link getDefaultParent}.
         * @default null
         */ this.defaultParent = null;
        /**
         * Specifies the {@link Image} to be returned by {@link getBackgroundImage}.
         * @default null
         *
         * @example
         * ```javascript
         * var img = new mxImage('http://www.example.com/maps/examplemap.jpg', 1024, 768);
         * graph.setBackgroundImage(img);
         * graph.view.validate();
         * ```
         */ this.backgroundImage = null;
        /**
         * Specifies if the background page should be visible.
         * Not yet implemented.
         * @default false
         */ this.pageVisible = false;
        /**
         * Specifies if a dashed line should be drawn between multiple pages.
         * If you change this value while a graph is being displayed then you
         * should call {@link sizeDidChange} to force an update of the display.
         * @default false
         */ this.pageBreaksVisible = false;
        /**
         * Specifies the color for page breaks.
         * @default gray
         */ this.pageBreakColor = 'gray';
        /**
         * Specifies the page breaks should be dashed.
         * @default true
         */ this.pageBreakDashed = true;
        /**
         * Specifies the minimum distance in pixels for page breaks to be visible.
         * @default 20
         */ this.minPageBreakDist = 20;
        /**
         * Specifies if the graph size should be rounded to the next page number in
         * {@link sizeDidChange}. This is only used if the graph container has scrollbars.
         * @default false
         */ this.preferPageSize = false;
        /**
         * Specifies the scale of the background page.
         * Not yet implemented.
         * @default 1.5
         */ this.pageScale = 1.5;
        /**
         * Specifies the return value for {@link isEnabled}.
         * @default true
         */ this.enabled = true;
        /**
         * Specifies the return value for {@link canExportCell}.
         * @default true
         */ this.exportEnabled = true;
        /**
         * Specifies the return value for {@link canImportCell}.
         * @default true
         */ this.importEnabled = true;
        /**
         * Specifies if the graph should automatically scroll regardless of the
         * scrollbars. This will scroll the container using positive values for
         * scroll positions (ie usually only rightwards and downwards). To avoid
         * possible conflicts with panning, set {@link translateToScrollPosition} to `true`.
         */ this.ignoreScrollbars = false;
        /**
         * Specifies if the graph should automatically convert the current scroll
         * position to a translate in the graph view when a mouseUp event is received.
         * This can be used to avoid conflicts when using {@link autoScroll} and
         * {@link ignoreScrollbars} with no scrollbars in the container.
         */ this.translateToScrollPosition = false;
        /**
         * {@link Rectangle} that specifies the area in which all cells in the diagram
         * should be placed. Uses in {@link getMaximumGraphBounds}. Use a width or height of
         * `0` if you only want to give a upper, left corner.
         */ this.maximumGraphBounds = null;
        /**
         * {@link Rectangle} that specifies the minimum size of the graph. This is ignored
         * if the graph container has no scrollbars.
         * @default null
         */ this.minimumGraphSize = null;
        /**
         * {@link Rectangle} that specifies the minimum size of the {@link container} if
         * {@link resizeContainer} is `true`.
         */ this.minimumContainerSize = null;
        /**
         * {@link Rectangle} that specifies the maximum size of the container if
         * {@link resizeContainer} is `true`.
         */ this.maximumContainerSize = null;
        /**
         * Specifies if the container should be resized to the graph size when
         * the graph size has changed.
         * @default false
         */ this.resizeContainer = false;
        /**
         * Border to be added to the bottom and right side when the container is
         * being resized after the graph has been changed.
         * @default 0
         */ this.border = 0;
        /**
         * Specifies if edges should appear in the foreground regardless of their order
         * in the model. If {@link keepEdgesInForeground} and {@link keepEdgesInBackground} are
         * both `true` then the normal order is applied.
         * @default false
         */ this.keepEdgesInForeground = false;
        /**
         * Specifies if edges should appear in the background regardless of their order
         * in the model. If {@link keepEdgesInForeground} and {@link keepEdgesInBackground} are
         * both `true` then the normal order is applied.
         * @default false
         */ this.keepEdgesInBackground = false;
        /**
         * Specifies the return value for {@link isRecursiveResize}.
         * @default false (for backwards compatibility)
         */ this.recursiveResize = false;
        /**
         * Specifies if the scale and translate should be reset if the root changes in
         * the model.
         * @default true
         */ this.resetViewOnRootChange = true;
        /**
         * Specifies if loops (aka self-references) are allowed.
         * @default false
         */ this.allowLoops = false;
        /**
         * {@link EdgeStyle} to be used for loops.
         *
         * This is a fallback for loops if the {@link CellStateStyle.loopStyle} is `undefined`.
         * @default {@link EdgeStyle.Loop}
         */ this.defaultLoopStyle = (0, $dea342649dfec9b9$exports).Loop;
        /**
         * Specifies if multiple edges in the same direction between the same pair of
         * vertices are allowed.
         * @default true
         */ this.multigraph = true;
        /**
         * Specifies the resource key for the error message to be displayed in
         * non-multigraphs when two vertices are already connected. If the resource
         * for this key does not exist then the value is used as the error message.
         * @default 'alreadyConnected'
         */ this.alreadyConnectedResource = (0, $78efedcb0f6c688d$export$ee28232f9313fcdf)() ? 'alreadyConnected' : '';
        /**
         * Specifies the resource key for the warning message to be displayed when
         * a collapsed cell contains validation errors. If the resource for this
         * key does not exist then the value is used as the warning message.
         * @default 'containsValidationErrors'
         */ this.containsValidationErrorsResource = (0, $78efedcb0f6c688d$export$ee28232f9313fcdf)() ? 'containsValidationErrors' : '';
        this.getContainer = ()=>this.container;
        this.getPlugin = (id)=>this.plugins.get(id);
        this.getCellRenderer = ()=>this.cellRenderer;
        this.getDialect = ()=>this.dialect;
        this.isPageVisible = ()=>this.pageVisible;
        this.isPageBreaksVisible = ()=>this.pageBreaksVisible;
        this.getPageBreakColor = ()=>this.pageBreakColor;
        this.isPageBreakDashed = ()=>this.pageBreakDashed;
        this.getMinPageBreakDist = ()=>this.minPageBreakDist;
        this.isPreferPageSize = ()=>this.preferPageSize;
        this.getPageFormat = ()=>this.pageFormat;
        this.getPageScale = ()=>this.pageScale;
        this.isExportEnabled = ()=>this.exportEnabled;
        this.isImportEnabled = ()=>this.importEnabled;
        this.isIgnoreScrollbars = ()=>this.ignoreScrollbars;
        this.isTranslateToScrollPosition = ()=>this.translateToScrollPosition;
        this.getMinimumGraphSize = ()=>this.minimumGraphSize;
        this.setMinimumGraphSize = (size)=>this.minimumGraphSize = size;
        this.getMinimumContainerSize = ()=>this.minimumContainerSize;
        this.setMinimumContainerSize = (size)=>this.minimumContainerSize = size;
        this.getAlreadyConnectedResource = ()=>this.alreadyConnectedResource;
        this.getContainsValidationErrorsResource = ()=>this.containsValidationErrorsResource;
        this.registerDefaults();
        this.container = options?.container ?? document.createElement('div');
        // collaborators
        this.initializeCollaborators(options);
        // Adds a graph model listener to update the view
        this.graphModelChangeListener = (_sender, evt)=>{
            this.graphModelChanged(evt.getProperty('edit').changes);
        };
        this.getDataModel().addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CHANGE, this.graphModelChangeListener);
        // Initializes the container using the view
        this.view.init();
        // Updates the size of the container for the current graph
        this.sizeDidChange();
        // Initializes plugins
        options?.plugins?.forEach((p)=>this.plugins.set(p.pluginId, new p(this)));
        this.view.revalidate();
    }
    getWarningImage() {
        return this.warningImage;
    }
    setTooltips(enabled) {
        const tooltipHandler = this.getPlugin('TooltipHandler');
        tooltipHandler?.setEnabled(enabled);
    }
    /**
     * Updates the model in a transaction.
     *
     * @param fn the update to be performed in the transaction.
     *
     * @see {@link GraphDataModel.batchUpdate}
     */ batchUpdate(fn) {
        this.getDataModel().batchUpdate(fn);
    }
    /**
     * Returns the {@link GraphDataModel} that contains the cells.
     */ getDataModel() {
        return this.model;
    }
    /**
     * Returns the {@link GraphView} that contains the {@link CellState}s.
     */ getView() {
        return this.view;
    }
    /**
     * Returns the {@link Stylesheet} that defines the style.
     */ getStylesheet() {
        return this.stylesheet;
    }
    /**
     * Sets the {@link Stylesheet} that defines the style.
     */ setStylesheet(stylesheet) {
        this.stylesheet = stylesheet;
    }
    /**
     * Called when the graph model changes. Invokes {@link processChange} on each
     * item of the given array to update the view accordingly.
     *
     * @param changes Array that contains the individual changes.
     */ graphModelChanged(changes) {
        for (const change of changes)this.processChange(change);
        this.updateSelection();
        this.view.validate();
        this.sizeDidChange();
    }
    /**
     * Processes the given change and invalidates the respective cached data
     * in {@link GraphView}. This fires a {@link root} event if the root has changed in the
     * model.
     *
     * @param {(RootChange|ChildChange|TerminalChange|GeometryChange|ValueChange|StyleChange)} change - Object that represents the change on the model.
     */ processChange(change) {
        // Resets the view settings, removes all cells and clears
        // the selection if the root changes.
        if (change instanceof (0, $eb24dd3dae295813$export$2e2bcd8739ae039)) {
            this.clearSelection();
            this.setDefaultParent(null);
            if (change.previous) this.removeStateForCell(change.previous);
            if (this.resetViewOnRootChange) {
                this.view.scale = 1;
                this.view.translate.x = 0;
                this.view.translate.y = 0;
            }
            this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).ROOT));
        } else if (change instanceof (0, $12157cc2312b9a0d$export$2e2bcd8739ae039)) {
            const newParent = change.child.getParent();
            this.view.invalidate(change.child, true, true);
            if (!newParent || !this.getDataModel().contains(newParent) || newParent.isCollapsed()) {
                this.view.invalidate(change.child, true, true);
                this.removeStateForCell(change.child);
                // Handles special case of current root of view being removed
                if (this.view.currentRoot == change.child) this.home();
            }
            if (newParent != change.previous) {
                // Refreshes the collapse/expand icons on the parents
                if (newParent != null) this.view.invalidate(newParent, false, false);
                if (change.previous != null) this.view.invalidate(change.previous, false, false);
            }
        } else if (change instanceof (0, $530d9ffa074b4f5b$export$2e2bcd8739ae039) || change instanceof (0, $f343bbd443ab0083$export$2e2bcd8739ae039)) // Checks if the geometry has changed to avoid unnecessary revalidation
        {
            if (change instanceof (0, $530d9ffa074b4f5b$export$2e2bcd8739ae039) || change.previous == null && change.geometry != null || change.previous != null && !change.previous.equals(change.geometry)) this.view.invalidate(change.cell);
        } else if (change instanceof (0, $eca1687eb224877d$export$2e2bcd8739ae039)) this.view.invalidate(change.cell, false, false);
        else if (change instanceof (0, $97bd40c34c614402$export$2e2bcd8739ae039)) {
            this.view.invalidate(change.cell, true, true);
            const state = this.view.getState(change.cell);
            if (state != null) state.invalidStyle = true;
        } else if (change.cell != null && change.cell instanceof (0, $0e256159624f4593$export$2e2bcd8739ae039)) this.removeStateForCell(change.cell);
    }
    /**
     * Scrolls the graph to the given point, extending the graph container if
     * specified.
     */ scrollPointToVisible(x, y, extend = false, border = 20) {
        const panningHandler = this.getPlugin('PanningHandler');
        if (!this.isTimerAutoScroll() && (this.ignoreScrollbars || (0, $b55d6ca3b42398e2$export$988b38dbf6859d61)(this.container))) {
            const c = this.container;
            if (x >= c.scrollLeft && y >= c.scrollTop && x <= c.scrollLeft + c.clientWidth && y <= c.scrollTop + c.clientHeight) {
                let dx = c.scrollLeft + c.clientWidth - x;
                if (dx < border) {
                    const old = c.scrollLeft;
                    c.scrollLeft += border - dx;
                    // Automatically extends the canvas size to the bottom, right
                    // if the event is outside of the canvas and the edge of the
                    // canvas has been reached. Notes: Needs fix for IE.
                    if (extend && old === c.scrollLeft) {
                        // @ts-ignore
                        const root = this.view.getDrawPane().ownerSVGElement;
                        const width = c.scrollWidth + border - dx;
                        // Updates the clipping region. This is an expensive
                        // operation that should not be executed too often.
                        // @ts-ignore
                        root.style.width = `${width}px`;
                        c.scrollLeft += border - dx;
                    }
                } else {
                    dx = x - c.scrollLeft;
                    if (dx < border) c.scrollLeft -= border - dx;
                }
                let dy = c.scrollTop + c.clientHeight - y;
                if (dy < border) {
                    const old = c.scrollTop;
                    c.scrollTop += border - dy;
                    if (old == c.scrollTop && extend) {
                        // @ts-ignore
                        const root = this.view.getDrawPane().ownerSVGElement;
                        const height = c.scrollHeight + border - dy;
                        // Updates the clipping region. This is an expensive
                        // operation that should not be executed too often.
                        // @ts-ignore
                        root.style.height = `${height}px`;
                        c.scrollTop += border - dy;
                    }
                } else {
                    dy = y - c.scrollTop;
                    if (dy < border) c.scrollTop -= border - dy;
                }
            }
        } else if (this.isAllowAutoPanning() && panningHandler && !panningHandler.isActive()) panningHandler.getPanningManager().panTo(x + this.getPanDx(), y + this.getPanDy());
    }
    /**
     * Returns the size of the border and padding on all four sides of the
     * container. The left, top, right and bottom borders are stored in the x, y,
     * width and height of the returned {@link Rectangle}, respectively.
     */ getBorderSizes() {
        const css = (0, $b55d6ca3b42398e2$export$6e10775a92bc4d41)(this.container);
        return new (0, $2997c239141ea844$export$2e2bcd8739ae039)((0, $b55d6ca3b42398e2$export$7f55d6cdd504ed6)(css.paddingLeft) + (css.borderLeftStyle != 'none' ? (0, $b55d6ca3b42398e2$export$7f55d6cdd504ed6)(css.borderLeftWidth) : 0), (0, $b55d6ca3b42398e2$export$7f55d6cdd504ed6)(css.paddingTop) + (css.borderTopStyle != 'none' ? (0, $b55d6ca3b42398e2$export$7f55d6cdd504ed6)(css.borderTopWidth) : 0), (0, $b55d6ca3b42398e2$export$7f55d6cdd504ed6)(css.paddingRight) + (css.borderRightStyle != 'none' ? (0, $b55d6ca3b42398e2$export$7f55d6cdd504ed6)(css.borderRightWidth) : 0), (0, $b55d6ca3b42398e2$export$7f55d6cdd504ed6)(css.paddingBottom) + (css.borderBottomStyle != 'none' ? (0, $b55d6ca3b42398e2$export$7f55d6cdd504ed6)(css.borderBottomWidth) : 0));
    }
    /**
     * Returns the preferred size of the background page if {@link preferPageSize} is true.
     */ getPreferredPageSize(bounds, width, height) {
        const tr = this.view.translate;
        const fmt = this.pageFormat;
        const ps = this.pageScale;
        const page = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(0, 0, Math.ceil(fmt.width * ps), Math.ceil(fmt.height * ps));
        const hCount = this.pageBreaksVisible ? Math.ceil(width / page.width) : 1;
        const vCount = this.pageBreaksVisible ? Math.ceil(height / page.height) : 1;
        return new (0, $2997c239141ea844$export$2e2bcd8739ae039)(0, 0, hCount * page.width + 2 + tr.x, vCount * page.height + 2 + tr.y);
    }
    /**
     * Resizes the container for the given graph width and height.
     */ doResizeContainer(width, height) {
        if (this.maximumContainerSize != null) {
            width = Math.min(this.maximumContainerSize.width, width);
            height = Math.min(this.maximumContainerSize.height, height);
        }
        const container = this.container;
        container.style.width = `${Math.ceil(width)}px`;
        container.style.height = `${Math.ceil(height)}px`;
    }
    /*****************************************************************************
     * Group: Drill down
     *****************************************************************************/ /**
     * Returns the current root of the displayed cell hierarchy. This is a
     * shortcut to {@link GraphView.currentRoot} in {@link GraphView}.
     */ getCurrentRoot() {
        return this.view.currentRoot;
    }
    /**
     * Returns the translation to be used if the given cell is the root cell as
     * an {@link Point}. This implementation returns null.
     *
     * To keep the children at their absolute position while stepping into groups,
     * this function can be overridden as follows.
     *
     * @example
     * ```javascript
     * var offset = new mxPoint(0, 0);
     *
     * while (cell != null)
     * {
     *   var geo = this.model.getGeometry(cell);
     *
     *   if (geo != null)
     *   {
     *     offset.x -= geo.x;
     *     offset.y -= geo.y;
     *   }
     *
     *   cell = this.model.getParent(cell);
     * }
     *
     * return offset;
     * ```
     *
     * @param cell {@link Cell} that represents the root.
     */ getTranslateForRoot(cell) {
        return null;
    }
    /**
     * Returns the offset to be used for the cells inside the given cell. The
     * root and layer cells may be identified using {@link GraphDataModel.isRoot} and
     * {@link GraphDataModel.isLayer}. For all other current roots, the
     * {@link GraphView.currentRoot} field points to the respective cell, so that
     * the following holds: cell == this.view.currentRoot. This implementation
     * returns null.
     *
     * @param cell {@link Cell} whose offset should be returned.
     */ getChildOffsetForCell(cell) {
        return null;
    }
    /**
     * Uses the root of the model as the root of the displayed cell hierarchy
     * and selects the previous root.
     */ home() {
        const current = this.getCurrentRoot();
        if (current != null) {
            this.view.setCurrentRoot(null);
            const state = this.view.getState(current);
            if (state != null) this.setSelectionCell(current);
        }
    }
    /**
     * Returns true if the given cell is a valid root for the cell display
     * hierarchy. This implementation returns true for all non-null values.
     *
     * @param cell {@link Cell} which should be checked as a possible root.
     */ isValidRoot(cell) {
        return !!cell;
    }
    /*****************************************************************************
     * Group: Graph display
     *****************************************************************************/ /**
     * Returns the bounds of the visible graph. Shortcut to
     * {@link GraphView.getGraphBounds}. See also: {@link getBoundingBoxFromGeometry}.
     */ getGraphBounds() {
        return this.view.getGraphBounds();
    }
    /**
     * Returns the bounds inside which the diagram should be kept as an
     * {@link Rectangle}.
     */ getMaximumGraphBounds() {
        return this.maximumGraphBounds;
    }
    /**
     * Clears all cell states or the states for the hierarchy starting at the
     * given cell and validates the graph. This fires a refresh event as the
     * last step.
     *
     * @param cell Optional {@link Cell} for which the cell states should be cleared.
     */ refresh(cell = null) {
        if (cell) this.view.clear(cell, false);
        else this.view.clear(undefined, true);
        this.view.validate();
        this.sizeDidChange();
        this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).REFRESH));
    }
    /**
     * Centers the graph in the container.
     *
     * @param horizontal Optional boolean that specifies if the graph should be centered
     * horizontally. Default is `true`.
     * @param vertical Optional boolean that specifies if the graph should be centered
     * vertically. Default is `true`.
     * @param cx Optional float that specifies the horizontal center. Default is `0.5`.
     * @param cy Optional float that specifies the vertical center. Default is `0.5`.
     */ center(horizontal = true, vertical = true, cx = 0.5, cy = 0.5) {
        const container = this.container;
        const _hasScrollbars = (0, $b55d6ca3b42398e2$export$988b38dbf6859d61)(this.container);
        const padding = 2 * this.getBorder();
        const cw = container.clientWidth - padding;
        const ch = container.clientHeight - padding;
        const bounds = this.getGraphBounds();
        const t = this.view.translate;
        const s = this.view.scale;
        let dx = horizontal ? cw - bounds.width : 0;
        let dy = vertical ? ch - bounds.height : 0;
        if (!_hasScrollbars) this.view.setTranslate(horizontal ? Math.floor(t.x - bounds.x / s + dx * cx / s) : t.x, vertical ? Math.floor(t.y - bounds.y / s + dy * cy / s) : t.y);
        else {
            bounds.x -= t.x;
            bounds.y -= t.y;
            const sw = container.scrollWidth;
            const sh = container.scrollHeight;
            if (sw > cw) dx = 0;
            if (sh > ch) dy = 0;
            this.view.setTranslate(Math.floor(dx / 2 - bounds.x), Math.floor(dy / 2 - bounds.y));
            container.scrollLeft = (sw - cw) / 2;
            container.scrollTop = (sh - ch) / 2;
        }
    }
    /**
     * Returns `true` if perimeter points should be computed such that the resulting edge has only horizontal or vertical segments.
     *
     * This method relies on the registered elements in {@link EdgeStyleRegistry} to know if the {@link CellStateStyle.edgeStyle} of the {@link CellState} is orthogonal.
     * If the {@link EdgeStyle} is not registered, it is considered as NOT orthogonal.
     *
     * @param edge {@link CellState} that represents the edge.
     */ isOrthogonal(edge) {
        const orthogonal = edge.style.orthogonal;
        if (!(0, $h5l15.isNullish)(orthogonal)) return orthogonal;
        // fallback when the orthogonal style is not defined
        const edgeStyle = this.view.getEdgeStyle(edge);
        return (0, $130af394a0fcdee4$export$28d1530539966ca9).isOrthogonal(edgeStyle);
    }
    /*****************************************************************************
     * Group: Graph appearance
     *****************************************************************************/ /**
     * Returns the {@link backgroundImage} as an {@link Image}.
     */ getBackgroundImage() {
        return this.backgroundImage;
    }
    /**
     * Sets the new {@link backgroundImage}.
     *
     * @param image New {@link Image} to be used for the background.
     */ setBackgroundImage(image) {
        this.backgroundImage = image;
    }
    /**
     * Returns the textual representation for the given cell.
     *
     * This implementation returns the node name or string-representation of the user object.
     *
     *
     * The following returns the label attribute from the cells user object if it is an XML node.
     *
     * @example
     * ```javascript
     * graph.convertValueToString = function(cell)
     * {
     * 	return cell.getAttribute('label');
     * }
     * ```
     *
     * See also: {@link cellLabelChanged}.
     *
     * @param cell {@link Cell} whose textual representation should be returned.
     */ convertValueToString(cell) {
        const value = cell.getValue();
        if (value != null) {
            if ((0, $b1d29c834e82fef5$export$8ee0fc9ee280b4ee)(value)) return value.nodeName;
            if (typeof value.toString === 'function') return value.toString();
        }
        return '';
    }
    /**
     * Returns the string to be used as the link for the given cell.
     *
     * This implementation returns null.
     *
     * @param cell {@link Cell} whose link should be returned.
     */ getLinkForCell(cell) {
        return null;
    }
    /**
     * Returns the value of {@link border}.
     */ getBorder() {
        return this.border;
    }
    /**
     * Sets the value of {@link border}.
     *
     * @param value Positive integer that represents the border to be used.
     */ setBorder(value) {
        this.border = value;
    }
    /*****************************************************************************
     * Group: Graph behaviour
     *****************************************************************************/ /**
     * Returns {@link resizeContainer}.
     */ isResizeContainer() {
        return this.resizeContainer;
    }
    /**
     * Sets {@link resizeContainer}.
     *
     * @param value Boolean indicating if the container should be resized.
     */ setResizeContainer(value) {
        this.resizeContainer = value;
    }
    /**
     * Returns true if the graph is {@link enabled}.
     */ isEnabled() {
        return this.enabled;
    }
    /**
     * Specifies if the graph should allow any interactions. This
     * implementation updates {@link enabled}.
     *
     * @param value Boolean indicating if the graph should be enabled.
     */ setEnabled(value) {
        this.enabled = value;
    }
    /**
     * Returns {@link multigraph} as a boolean.
     */ isMultigraph() {
        return this.multigraph;
    }
    /**
     * Specifies if the graph should allow multiple connections between the
     * same pair of vertices.
     *
     * @param value Boolean indicating if the graph allows multiple connections
     * between the same pair of vertices.
     */ setMultigraph(value) {
        this.multigraph = value;
    }
    /**
     * Returns {@link allowLoops} as a boolean.
     */ isAllowLoops() {
        return this.allowLoops;
    }
    /**
     * Specifies if loops are allowed.
     *
     * @param value Boolean indicating if loops are allowed.
     */ setAllowLoops(value) {
        this.allowLoops = value;
    }
    /**
     * Returns {@link recursiveResize}.
     *
     * @param state {@link CellState} that is being resized.
     */ isRecursiveResize(state = null) {
        return this.recursiveResize;
    }
    /**
     * Sets {@link recursiveResize}.
     *
     * @param value New boolean value for {@link recursiveResize}.
     */ setRecursiveResize(value) {
        this.recursiveResize = value;
    }
    /**
     * Returns a decimal number representing the amount of the width and height
     * of the given cell that is allowed to overlap its parent. A value of 0
     * means all children must stay inside the parent, 1 means the child is
     * allowed to be placed outside of the parent such that it touches one of
     * the parents sides. If {@link isAllowOverlapParent} returns false for the given
     * cell, then this method returns 0.
     *
     * @param cell {@link Cell} for which the overlap ratio should be returned.
     */ getOverlap(cell) {
        return this.isAllowOverlapParent(cell) ? this.defaultOverlap : 0;
    }
    /**
     * Returns true if the given cell is allowed to be placed outside the
     * parents area.
     *
     * @param cell {@link Cell} that represents the child to be checked.
     */ isAllowOverlapParent(cell) {
        return false;
    }
    /*****************************************************************************
     * Group: Cell retrieval
     *****************************************************************************/ /**
     * Returns {@link defaultParent} or {@link GraphView.currentRoot} or the first child
     * of {@link GraphDataModel.root} if both are null. The value returned by
     * this function should be used as the parent for new cells (aka default
     * layer).
     */ getDefaultParent() {
        let parent = this.getCurrentRoot();
        if (!parent) {
            parent = this.defaultParent;
            if (!parent) {
                const root = this.getDataModel().getRoot();
                parent = root.getChildAt(0);
            }
        }
        return parent;
    }
    /**
     * Sets the {@link defaultParent} to the given cell. Set this to null to return
     * the first child of the root in getDefaultParent.
     */ setDefaultParent(cell) {
        this.defaultParent = cell;
    }
    /**
     * Destroys the graph and all its resources.
     * After calling this method, the Graph should not be used anymore.
     *
     * For example, call this method when unmounting/disposing a component using the Graph to avoid memory leaks.
     */ destroy() {
        if (!this.destroyed) {
            this.destroyed = true;
            this.plugins.forEach((p)=>p.onDestroy());
            this.view.destroy();
            if (this.model && this.graphModelChangeListener) {
                this.getDataModel().removeListener(this.graphModelChangeListener);
                this.graphModelChangeListener = null;
            }
            // @ts-expect-error Can be null when destroyed.
            this.container = null;
            super.destroy();
        }
    }
}
// Applying the mixins at module scope is a deliberate side effect: their members are copied onto the AbstractGraph
// prototype, which has to happen before any graph is instantiated. Running it here guarantees that every importer of
// AbstractGraph, Graph or BaseGraph gets a complete class, whatever the import order.
// It does not prevent the unused modules of the package from being dropped, but it does pull every mixin into the
// bundle as soon as a graph class is imported: their members all land on the same prototype, so a bundler cannot tell
// which of them the application actually calls. Converting the mixins to plugins, which are opt-in, is tracked by
// https://github.com/maxGraph/maxGraph/issues/762.
(0, $8cff855c18425434$export$80043f1805ddadcd)($04d8eeb08050dccc$export$ad0a8adca2a96dfe);


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2018, JGraph Ltd
Copyright (c) 2006-2018, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 

/**
 * Implements a composite undoable edit. Here is an example for a custom change
 * which gets executed via the model:
 *
 * ```javascript
 * function CustomChange(model, name)
 * {
 *   this.model = model;
 *   this.name = name;
 *   this.previous = name;
 * };
 *
 * execute = ()=>
 * {
 *   let tmp = this.model.name;
 *   this.model.name = this.previous;
 *   this.previous = tmp;
 * };
 *
 * let name = prompt('Enter name');
 * graph.model.execute(new CustomChange(graph.model, name));
 * ```
 *
 * Event: mxEvent.EXECUTED
 *
 * Fires between START_EDIT and END_EDIT after an atomic change was executed.
 * The <code>change</code> property contains the change that was executed.
 *
 * Event: mxEvent.START_EDIT
 *
 * Fires before a set of changes will be executed in <undo> or <redo>.
 * This event contains no properties.
 *
 * Event: mxEvent.END_EDIT
 *
 * Fires after a set of changes was executed in <undo> or <redo>.
 * This event contains no properties.
 *
 * Constructor: mxUndoableEdit
 *
 * Constructs a new undoable edit for the given source.
 */ class $49cf4bffc87379a1$var$UndoableEdit {
    constructor(source, significant = true){
        /**
         * Array that contains the changes that make up this edit. The changes are
         * expected to either have an undo and redo function, or an execute
         * function. Default is an empty array.
         */ this.changes = [];
        /**
         * Specifies if the undoable change is significant.
         * Default is true.
         */ this.significant = true;
        /**
         * Specifies if this edit has been undone. Default is false.
         */ this.undone = false;
        /**
         * Specifies if this edit has been redone. Default is false.
         */ this.redone = false;
        this.source = source;
        this.changes = [];
        this.significant = significant;
    }
    /**
     * Returns true if the this edit contains no changes.
     */ isEmpty() {
        return this.changes.length === 0;
    }
    /**
     * Returns <significant>.
     */ isSignificant() {
        return this.significant;
    }
    /**
     * Adds the specified change to this edit. The change is an object that is
     * expected to either have an undo and redo, or an execute function.
     */ add(change) {
        this.changes.push(change);
    }
    /**
     * Hook to notify any listeners of the changes after an <undo> or <redo>
     * has been carried out. This implementation is empty.
     */ notify() {
        return;
    }
    /**
     * Hook to free resources after the edit has been removed from the command
     * history. This implementation is empty.
     */ die() {
        return;
    }
    /**
     * Undoes all changes in this edit.
     */ undo() {
        if (!this.undone) {
            this.source.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).START_EDIT));
            const count = this.changes.length;
            for(let i = count - 1; i >= 0; i--){
                const change = this.changes[i];
                if (change.execute) change.execute();
                else if (change.undo) change.undo();
                // New global executed event
                this.source.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).EXECUTED, {
                    change: change
                }));
            }
            this.undone = true;
            this.redone = false;
            this.source.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).END_EDIT));
        }
        this.notify();
    }
    /**
     * Redoes all changes in this edit.
     */ redo() {
        if (!this.redone) {
            this.source.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).START_EDIT));
            const count = this.changes.length;
            for(let i = 0; i < count; i += 1){
                const change = this.changes[i];
                if (change.execute != null) change.execute();
                else if (change.redo != null) change.redo();
                // New global executed event
                this.source.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).EXECUTED, {
                    change: change
                }));
            }
            this.undone = false;
            this.redone = true;
            this.source.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).END_EDIT));
        }
        this.notify();
    }
}
var $49cf4bffc87379a1$export$2e2bcd8739ae039 = $49cf4bffc87379a1$var$UndoableEdit;








/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /**
 * Action to change a cell's collapsed state in a model.
 *
 * @category Change
 */ class $f8c85b3eb197571a$var$CollapseChange {
    constructor(model, cell, collapsed){
        this.model = model;
        this.cell = cell;
        this.collapsed = collapsed;
        this.previous = collapsed;
    }
    /**
     * Changes the collapsed state of {@link cell} to {@link previous} using {@link GraphDataModel.collapsedStateForCellChanged}.
     */ execute() {
        this.collapsed = this.previous;
        this.previous = this.model.collapsedStateForCellChanged(this.cell, this.previous);
    }
}
var $f8c85b3eb197571a$export$2e2bcd8739ae039 = $f8c85b3eb197571a$var$CollapseChange;







/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /**
 * Action to change a cell's visible state in a model.
 *
 * @category Change
 */ class $0b8ba01678457185$var$VisibleChange {
    constructor(model, cell, visible){
        this.model = model;
        this.cell = cell;
        this.visible = visible;
        this.previous = visible;
    }
    /**
     * Changes the visible state of {@link cell} to {@link previous} using {@link GraphDataModel.visibleStateForCellChanged}.
     */ execute() {
        this.visible = this.previous;
        this.previous = this.model.visibleStateForCellChanged(this.cell, this.previous);
    }
}
var $0b8ba01678457185$export$2e2bcd8739ae039 = $0b8ba01678457185$var$VisibleChange;


class $73c88ebf085ac84f$export$c4b0e0aa83f5028b extends (0, $17f25eceeba97548$export$2e2bcd8739ae039) {
    constructor(root = null){
        super();
        /**
         * Holds the root cell, which in turn contains the cells that represent the
         * layers of the diagram as child cells. That is, the actual elements of the
         * diagram are supposed to live in the third generation of cells and below.
         */ this.root = null;
        /**
         * Maps from Ids to cells.
         */ this.cells = {};
        /**
         * Specifies if edges should automatically be moved into the nearest common ancestor of their terminals.
         * @default true
         */ this.maintainEdgeParent = true;
        /**
         * Specifies if relative edge parents should be ignored for finding the nearest common ancestors of an edge's terminals.
         * @default true
         */ this.ignoreRelativeEdgeParent = true;
        /**
         * Specifies if the model should automatically create Ids for new cells.
         * @default true.
         */ this.createIds = true;
        /**
         * Defines the prefix of new Ids. Default is an empty string.
         * @default ''
         */ this.prefix = '';
        /**
         * Defines the postfix of new Ids.
         * @default ''
         */ this.postfix = '';
        /**
         * Specifies the next Id to be created. Initial value is 0.
         */ this.nextId = 0;
        /**
         * Holds the changes for the current transaction. If the transaction is
         * closed then a new object is created for this variable using
         * {@link createUndoableEdit}.
         */ this.currentEdit = null;
        /**
         * Counter for the depth of nested transactions. Each call to {@link beginUpdate}
         * will increment this number and each call to {@link endUpdate} will decrement
         * it. When the counter reaches 0, the transaction is closed and the
         * respective events are fired. Initial value is 0.
         */ this.updateLevel = 0;
        /**
         * True if the program flow is currently inside endUpdate.
         */ this.endingUpdate = false;
        this.currentEdit = this.createUndoableEdit();
        if (root != null) this.setRoot(root);
        else this.clear();
    }
    /**
     * Sets a new root using {@link createRoot}.
     */ clear() {
        this.setRoot(this.createRoot());
    }
    /**
     * Returns {@link createIds}.
     */ isCreateIds() {
        return this.createIds;
    }
    /**
     * Sets {@link createIds}.
     */ setCreateIds(value) {
        this.createIds = value;
    }
    /**
     * Creates a new root cell with a default layer (child 0).
     */ createRoot() {
        const cell = new (0, $0e256159624f4593$export$2e2bcd8739ae039)();
        cell.insert(new (0, $0e256159624f4593$export$2e2bcd8739ae039)());
        return cell;
    }
    /**
     * Returns the {@link Cell} for the specified Id or null if no cell can be
     * found for the given Id.
     *
     * @param {string} id  A string representing the Id of the cell.
     */ getCell(id) {
        return this.cells ? this.cells[id] : null;
    }
    filterCells(cells, filter) {
        return cells.filter(filter);
    }
    getRoot(cell = null) {
        return cell ? cell.getRoot() : this.root;
    }
    /**
     * Sets the {@link root} of the model using {@link RootChange} and adds the change to
     * the current transaction. This resets all datastructures in the model and
     * is the preferred way of clearing an existing model. Returns the new
     * root.
     *
     * Example:
     *
     * ```javascript
     * const root = new Cell();
     * root.insert(new Cell());
     * model.setRoot(root);
     * ```
     *
     * @param {Cell} root  that specifies the new root.
     */ setRoot(root) {
        this.execute(new (0, $eb24dd3dae295813$export$2e2bcd8739ae039)(this, root));
        return root;
    }
    /**
     * Inner callback to change the root of the model and update the internal
     * datastructures, such as {@link cells} and {@link nextId}. Returns the previous root.
     *
     * @param {Cell} root  that specifies the new root.
     */ rootChanged(root) {
        const oldRoot = this.root;
        this.root = root;
        // Resets counters and datastructures
        this.nextId = 0;
        this.cells = null;
        this.cellAdded(root);
        return oldRoot;
    }
    /**
     * Returns true if the given cell is the root of the model and a non-null
     * value.
     *
     * @param {Cell} cell  that represents the possible root.
     */ isRoot(cell = null) {
        return cell != null && this.root === cell;
    }
    /**
     * Returns true if {@link isRoot} returns true for the parent of the given cell.
     *
     * @param cell  that represents the possible layer.
     */ isLayer(cell) {
        return cell ? this.isRoot(cell.getParent()) : false;
    }
    /**
     * Returns true if the model contains the given {@link Cell}.
     *
     * @param {Cell} cell  that specifies the cell.
     */ contains(cell) {
        return this.root.isAncestor(cell);
    }
    /**
     * Adds the specified child to the parent at the given index using
     * {@link ChildChange} and adds the change to the current transaction. If no
     * index is specified then the child is appended to the parent's array of
     * children. Returns the inserted child.
     *
     * @param {Cell} parent  that specifies the parent to contain the child.
     * @param {Cell} child  that specifies the child to be inserted.
     * @param index  Optional integer that specifies the index of the child.
     */ add(parent, child, index = null) {
        if (child !== parent && parent != null && child != null) {
            // Appends the child if no index was specified
            if (index == null) index = parent.getChildCount();
            const parentChanged = parent !== child.getParent();
            this.execute(new (0, $12157cc2312b9a0d$export$2e2bcd8739ae039)(this, parent, child, index));
            // Maintains the edges parents by moving the edges
            // into the nearest common ancestor of its terminals
            if (this.maintainEdgeParent && parentChanged) this.updateEdgeParents(child);
        }
        return child;
    }
    /**
     * Inner callback to update {@link cells} when a cell has been added. This
     * implementation resolves collisions by creating new Ids. To change the
     * ID of a cell after it was inserted into the model, use the following
     * code:
     *
     * (code
     * delete model.cells[cell.getId()];
     * cell.setId(newId);
     * model.cells[cell.getId()] = cell;
     * ```
     *
     * If the change of the ID should be part of the command history, then the
     * cell should be removed from the model and a clone with the new ID should
     * be reinserted into the model instead.
     *
     * @param {Cell} cell  that specifies the cell that has been added.
     */ cellAdded(cell) {
        if (cell != null) {
            // Creates an Id for the cell if not Id exists
            if (cell.getId() == null && this.createIds) cell.setId(this.createId(cell));
            if (cell.getId() != null) {
                let collision = this.getCell(cell.getId());
                if (collision !== cell) {
                    // Creates new Id for the cell
                    // as long as there is a collision
                    while(collision != null){
                        cell.setId(this.createId(cell));
                        collision = this.getCell(cell.getId());
                    }
                    // Lazily creates the cells map
                    if (this.cells == null) this.cells = {};
                    this.cells[cell.getId()] = cell;
                }
            }
            // Makes sure IDs of deleted cells are not reused
            if ((0, $f7ff90b8964488a6$export$e90fb89750dba83f)(String(cell.getId()))) this.nextId = Math.max(this.nextId, Number.parseInt(cell.getId()));
            // Recursively processes child cells
            for (const child of cell.getChildren())this.cellAdded(child);
        }
    }
    /**
     * Hook method to create an Id for the specified cell. This implementation
     * concatenates {@link prefix}, id and {@link postfix} to create the Id and increments
     * {@link nextId}. The cell is ignored by this implementation, but can be used in
     * overridden methods to prefix the Ids with eg. the cell type.
     *
     * @param {Cell} cell  to create the Id for.
     */ createId(cell) {
        const id = this.nextId;
        this.nextId++;
        return this.prefix + id + this.postfix;
    }
    /**
     * Updates the parent for all edges that are connected to cell or one of
     * its descendants using {@link updateEdgeParent}.
     */ updateEdgeParents(cell, root = this.getRoot(cell)) {
        // Updates edges on children first
        const childCount = cell.getChildCount();
        for(let i = 0; i < childCount; i += 1){
            const child = cell.getChildAt(i);
            this.updateEdgeParents(child, root);
        }
        // Updates the parents of all connected edges
        const edgeCount = cell.getEdgeCount();
        const edges = [];
        for(let i = 0; i < edgeCount; i += 1)edges.push(cell.getEdgeAt(i));
        for(let i = 0; i < edges.length; i += 1){
            const edge = edges[i];
            // Updates edge parent if edge and child have
            // a common root node (does not need to be the
            // model root node)
            if (root.isAncestor(edge)) this.updateEdgeParent(edge, root);
        }
    }
    /**
     * Inner callback to update the parent of the specified {@link Cell} to the
     * nearest-common-ancestor of its two terminals.
     *
     * @param {Cell} edge  that specifies the edge.
     * @param {Cell} root  that represents the current root of the model.
     */ updateEdgeParent(edge, root) {
        let source = edge.getTerminal(true);
        let target = edge.getTerminal(false);
        let cell = null;
        // Uses the first non-relative descendants of the source terminal
        while(source != null && !source.isEdge() && source.geometry != null && source.geometry.relative)source = source.getParent();
        // Uses the first non-relative descendants of the target terminal
        while(target != null && this.ignoreRelativeEdgeParent && !target.isEdge() && target.geometry != null && target.geometry.relative)target = target.getParent();
        if (root.isAncestor(source) && root.isAncestor(target)) {
            if (source === target) cell = source ? source.getParent() : null;
            else if (source) cell = source.getNearestCommonAncestor(target);
            if (cell != null && (cell.getParent() !== this.root || cell.isAncestor(edge)) && edge && edge.getParent() !== cell) {
                let geo = edge.getGeometry();
                if (geo != null) {
                    const origin1 = edge.getParent().getOrigin();
                    const origin2 = cell.getOrigin();
                    const dx = origin2.x - origin1.x;
                    const dy = origin2.y - origin1.y;
                    geo = geo.clone();
                    geo.translate(-dx, -dy);
                    this.setGeometry(edge, geo);
                }
                this.add(cell, edge, cell.getChildCount());
            }
        }
    }
    /**
     * Removes the specified cell from the model using {@link ChildChange} and adds
     * the change to the current transaction. This operation will remove the
     * cell and all of its children from the model. Returns the removed cell.
     *
     * @param {Cell} cell  that should be removed.
     */ remove(cell) {
        if (cell === this.root) this.setRoot(null);
        else if (cell.getParent() != null) this.execute(new (0, $12157cc2312b9a0d$export$2e2bcd8739ae039)(this, null, cell));
        return cell;
    }
    /**
     * Inner callback to update {@link cells} when a cell has been removed.
     *
     * @param {Cell} cell  that specifies the cell that has been removed.
     */ cellRemoved(cell) {
        if (cell != null && this.cells != null) {
            // Recursively processes child cells
            const childCount = cell.getChildCount();
            for(let i = childCount - 1; i >= 0; i--)this.cellRemoved(cell.getChildAt(i));
            // Removes the map entry for the cell
            if (this.cells != null && cell.getId() != null) // @ts-ignore
            delete this.cells[cell.getId()];
        }
    }
    /**
     * Inner callback to update the parent of a cell using {@link Cell#insert}
     * on the parent and return the previous parent.
     *
     * @param {Cell} cell  to update the parent for.
     * @param {Cell} parent  that specifies the new parent of the cell.
     * @param index  Optional integer that defines the index of the child
     * in the parent's child array.
     */ parentForCellChanged(cell, parent, index) {
        const previous = cell.getParent();
        if (parent != null) {
            if (parent !== previous || previous.getIndex(cell) !== index) parent.insert(cell, index);
        } else if (previous != null) {
            const oldIndex = previous.getIndex(cell);
            previous.remove(oldIndex);
        }
        // Adds or removes the cell from the model
        const par = parent ? this.contains(parent) : null;
        const pre = this.contains(previous);
        if (par && !pre) this.cellAdded(cell);
        else if (pre && !par) this.cellRemoved(cell);
        return previous;
    }
    /**
     * Sets the source or target terminal of the given {@link Cell} using
     * {@link TerminalChange} and adds the change to the current transaction.
     * This implementation updates the parent of the edge using {@link updateEdgeParent}
     * if required.
     *
     * @param {Cell} edge  that specifies the edge.
     * @param {Cell} terminal  that specifies the new terminal.
     * @param isSource  Boolean indicating if the terminal is the new source or
     * target terminal of the edge.
     */ setTerminal(edge, terminal, isSource) {
        const terminalChanged = terminal !== edge.getTerminal(isSource);
        this.execute(new (0, $530d9ffa074b4f5b$export$2e2bcd8739ae039)(this, edge, terminal, isSource));
        if (this.maintainEdgeParent && terminalChanged) this.updateEdgeParent(edge, this.getRoot());
        return terminal;
    }
    /**
     * Sets the source and target {@link Cell} of the given {@link Cell} in a single
     * transaction using {@link setTerminal} for each end of the edge.
     *
     * @param {Cell} edge  that specifies the edge.
     * @param {Cell} source  that specifies the new source terminal.
     * @param {Cell} target  that specifies the new target terminal.
     */ setTerminals(edge, source, target) {
        this.beginUpdate();
        try {
            this.setTerminal(edge, source, true);
            this.setTerminal(edge, target, false);
        } finally{
            this.endUpdate();
        }
    }
    /**
     * Inner helper function to update the terminal of the edge using
     * {@link Cell#insertEdge} and return the previous terminal.
     *
     * @param {Cell} edge  that specifies the edge to be updated.
     * @param {Cell} terminal  that specifies the new terminal.
     * @param isSource  Boolean indicating if the terminal is the new source or
     * target terminal of the edge.
     */ terminalForCellChanged(edge, terminal, isSource = false) {
        const previous = edge.getTerminal(isSource);
        if (terminal != null) terminal.insertEdge(edge, isSource);
        else if (previous != null) previous.removeEdge(edge, isSource);
        return previous;
    }
    /**
     * Returns all edges between the given source and target pair. If directed
     * is true, then only edges from the source to the target are returned,
     * otherwise, all edges between the two cells are returned.
     *
     * @param {Cell} source  that defines the source terminal of the edge to be
     * returned.
     * @param {Cell} target  that defines the target terminal of the edge to be
     * returned.
     * @param directed  Optional boolean that specifies if the direction of the
     * edge should be taken into account. Default is false.
     */ getEdgesBetween(source, target, directed = false) {
        const tmp1 = source.getEdgeCount();
        const tmp2 = target.getEdgeCount();
        // Assumes the source has less connected edges
        let terminal = source;
        let edgeCount = tmp1;
        // Uses the smaller array of connected edges
        // for searching the edge
        if (tmp2 < tmp1) {
            edgeCount = tmp2;
            terminal = target;
        }
        const result = [];
        // Checks if the edge is connected to the correct
        // cell and returns the first match
        for(let i = 0; i < edgeCount; i += 1){
            const edge = terminal.getEdgeAt(i);
            const src = edge.getTerminal(true);
            const trg = edge.getTerminal(false);
            const directedMatch = src === source && trg === target;
            const oppositeMatch = trg === source && src === target;
            if (directedMatch || !directed && oppositeMatch) result.push(edge);
        }
        return result;
    }
    /**
     * Sets the user object of then given {@link Cell} using {@link ValueChange}
     * and adds the change to the current transaction.
     *
     * @param {Cell} cell  whose user object should be changed.
     * @param value  Object that defines the new user object.
     */ setValue(cell, value) {
        this.execute(new (0, $eca1687eb224877d$export$2e2bcd8739ae039)(this, cell, value));
        return value;
    }
    /**
     * Inner callback to update the user object of the given {@link Cell}
     * using {@link Cell#valueChanged} and return the previous value,
     * that is, the return value of {@link Cell#valueChanged}.
     *
     * To change a specific attribute in an XML node, the following code can be
     * used.
     *
     * ```javascript
     * graph.getDataModel().valueForCellChanged(cell, value)
     * {
     *   var previous = cell.value.getAttribute('label');
     *   cell.value.setAttribute('label', value);
     *
     *   return previous;
     * };
     * ```
     */ valueForCellChanged(cell, value) {
        return cell.valueChanged(value);
    }
    /**
     * Sets the {@link Geometry} of the given {@link Cell}. The actual update
     * of the cell is carried out in {@link geometryForCellChanged}. The
     * {@link GeometryChange} action is used to encapsulate the change.
     *
     * @param {Cell} cell  whose geometry should be changed.
     * @param {Geometry} geometry  that defines the new geometry.
     */ setGeometry(cell, geometry) {
        if (geometry !== cell.getGeometry()) this.execute(new (0, $f343bbd443ab0083$export$2e2bcd8739ae039)(this, cell, geometry));
        return geometry;
    }
    /**
     * Inner callback to update the {@link Geometry} of the given {@link Cell} using
     * {@link Cell#setGeometry} and return the previous {@link Geometry}.
     */ geometryForCellChanged(cell, geometry) {
        const previous = cell.getGeometry();
        cell.setGeometry(geometry);
        return previous;
    }
    /**
     * Sets the style of the given {@link Cell} using {@link StyleChange} and adds the change to the current transaction.
     *
     * **IMPORTANT**: Do not pass {@link Cell.getStyle} as value of the `style` parameter. Otherwise, no style change is performed, so the view won't be updated.
     * Always get a clone of the style of the cell with {@link Cell.getClonedStyle}, then update it and pass the updated style to this method.
     *
     * @param cell  whose style should be changed.
     * @param style the new cell style to set.
     */ setStyle(cell, style) {
        // To investigate in the future: it may be more convenient to do a deep comparison to prevent unnecessary changes
        // If the passed style is the same as the current style without being the same instance, we don't need to do anything
        // With the current implementation, a style change is executed when the styles are deep equal.
        if (style !== cell.getStyle()) this.execute(new (0, $97bd40c34c614402$export$2e2bcd8739ae039)(this, cell, style));
    }
    /**
     * Inner callback to update the style of the given {@link Cell}  using {@link Cell#setStyle} and return the previous style.
     *
     * **IMPORTANT**: to fully work, this method should not receive `cell.getStyle` as value of the `style` parameter. See {@link setStyle} for more information.
     *
     * @param cell  whose style should be changed.
     * @param style the new cell style to set.
     */ styleForCellChanged(cell, style) {
        const previous = cell.getStyle();
        cell.setStyle(style);
        return previous;
    }
    /**
     * Sets the collapsed state of the given {@link Cell} using {@link CollapseChange}
     * and adds the change to the current transaction.
     *
     * @param {Cell} cell  whose collapsed state should be changed.
     * @param collapsed  Boolean that specifies the new collpased state.
     */ setCollapsed(cell, collapsed) {
        if (collapsed !== cell.isCollapsed()) this.execute(new (0, $f8c85b3eb197571a$export$2e2bcd8739ae039)(this, cell, collapsed));
        return collapsed;
    }
    /**
     * Inner callback to update the collapsed state of the
     * given {@link Cell} using {@link Cell#setCollapsed} and return
     * the previous collapsed state.
     *
     * @param {Cell} cell  that specifies the cell to be updated.
     * @param collapsed  Boolean that specifies the new collapsed state.
     */ collapsedStateForCellChanged(cell, collapsed) {
        const previous = cell.isCollapsed();
        cell.setCollapsed(collapsed);
        return previous;
    }
    /**
     * Sets the visible state of the given {@link Cell} using {@link VisibleChange} and
     * adds the change to the current transaction.
     *
     * @param {Cell} cell  whose visible state should be changed.
     * @param visible  Boolean that specifies the new visible state.
     */ setVisible(cell, visible) {
        if (visible !== cell.isVisible()) this.execute(new (0, $0b8ba01678457185$export$2e2bcd8739ae039)(this, cell, visible));
        return visible;
    }
    /**
     * Inner callback to update the visible state of the
     * given {@link Cell} using {@link Cell#setCollapsed} and return
     * the previous visible state.
     *
     * @param {Cell} cell  that specifies the cell to be updated.
     * @param visible  Boolean that specifies the new visible state.
     */ visibleStateForCellChanged(cell, visible) {
        const previous = cell.isVisible();
        cell.setVisible(visible);
        return previous;
    }
    /**
     * Executes the given edit and fires events if required. The edit object
     * requires an execute function which is invoked. The edit is added to the
     * {@link currentEdit} between {@link beginUpdate} and {@link endUpdate} calls, so that
     * events will be fired if this execute is an individual transaction, that
     * is, if no previous {@link beginUpdate} calls have been made without calling
     * {@link endUpdate}. This implementation fires an {@link execute} event before
     * executing the given change.
     *
     * @param change  Object that described the change.
     */ execute(change) {
        change.execute();
        this.beginUpdate();
        this.currentEdit.add(change);
        this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).EXECUTE, {
            change: change
        }));
        // New global executed event
        this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).EXECUTED, {
            change: change
        }));
        this.endUpdate();
    }
    /**
     * Updates the model in a transaction.
     * This is a shortcut to the usage of {@link beginUpdate} and the {@link endUpdate} methods.
     *
     * ```javascript
     * const model = graph.getDataModel();
     * const parent = graph.getDefaultParent();
     * const index = model.getChildCount(parent);
     * model.batchUpdate(() => {
     *   model.add(parent, v1, index);
     *   model.add(parent, v2, index+1);
     * });
     * ```
     *
     * @param fn the update to be performed in the transaction.
     */ batchUpdate(fn) {
        this.beginUpdate();
        try {
            fn();
        } finally{
            this.endUpdate();
        }
    }
    /**
     * Increments the {@link updateLevel} by one. The event notification
     * is queued until {@link updateLevel} reaches 0 by use of
     * {@link endUpdate}.
     *
     * All changes on {@link GraphDataModel} are transactional,
     * that is, they are executed in a single undoable change
     * on the model (without transaction isolation).
     * Therefore, if you want to combine any
     * number of changes into a single undoable change,
     * you should group any two or more API calls that
     * modify the graph model between {@link beginUpdate}
     * and {@link endUpdate} calls as shown here:
     *
     * ```javascript
     * const model = graph.getDataModel();
     * const parent = graph.getDefaultParent();
     * const index = model.getChildCount(parent);
     * model.beginUpdate();
     * try
     * {
     *   model.add(parent, v1, index);
     *   model.add(parent, v2, index+1);
     * }
     * finally
     * {
     *   model.endUpdate();
     * }
     * ```
     *
     * Of course there is a shortcut for appending a
     * sequence of cells into the default parent:
     *
     * ```javascript
     * graph.addCells([v1, v2]).
     * ```
     */ beginUpdate() {
        this.updateLevel += 1;
        this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).BEGIN_UPDATE));
        if (this.updateLevel === 1) this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).START_EDIT));
    }
    /**
     * Decrements the {@link updateLevel} by one and fires an {@link undo}
     * event if the {@link updateLevel} reaches 0. This function
     * indirectly fires a {@link change} event by invoking the notify
     * function on the {@link currentEdit} und then creates a new
     * {@link currentEdit} using {@link createUndoableEdit}.
     *
     * The {@link undo} event is fired only once per edit, whereas
     * the {@link change} event is fired whenever the notify
     * function is invoked, that is, on undo and redo of
     * the edit.
     */ endUpdate() {
        this.updateLevel -= 1;
        if (this.updateLevel === 0) this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).END_EDIT));
        if (!this.endingUpdate) {
            this.endingUpdate = this.updateLevel === 0;
            this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).END_UPDATE, {
                edit: this.currentEdit
            }));
            try {
                if (this.endingUpdate && !this.currentEdit.isEmpty()) {
                    this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).BEFORE_UNDO, {
                        edit: this.currentEdit
                    }));
                    const tmp = this.currentEdit;
                    this.currentEdit = this.createUndoableEdit();
                    tmp.notify();
                    this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).UNDO, {
                        edit: tmp
                    }));
                }
            } finally{
                this.endingUpdate = false;
            }
        }
    }
    /**
     * Creates a new {@link UndoableEdit} that implements the
     * notify function to fire a {@link change} and {@link notify} event
     * through the {@link UndoableEdit}'s source.
     *
     * @param significant  Optional boolean that specifies if the edit to be created is
     * significant. Default is true.
     */ createUndoableEdit(significant = true) {
        const edit = new (0, $49cf4bffc87379a1$export$2e2bcd8739ae039)(this, significant);
        edit.notify = ()=>{
            // LATER: Remove changes property (deprecated)
            edit.source.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CHANGE, {
                edit: edit,
                changes: edit.changes
            }));
            edit.source.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).NOTIFY, {
                edit: edit,
                changes: edit.changes
            }));
        };
        return edit;
    }
    /**
     * Merges the children of the given cell into the given target cell inside
     * this model. All cells are cloned unless there is a corresponding cell in
     * the model with the same id, in which case the source cell is ignored and
     * all edges are connected to the corresponding cell in this model. Edges
     * are considered to have no identity and are always cloned unless the
     * cloneAllEdges flag is set to false, in which case edges with the same
     * id in the target model are reconnected to reflect the terminals of the
     * source edges.
     */ mergeChildren(from, to, cloneAllEdges = true) {
        this.beginUpdate();
        try {
            const mapping = {};
            this.mergeChildrenImpl(from, to, cloneAllEdges, mapping);
            // Post-processes all edges in the mapping and
            // reconnects the terminals to the corresponding
            // cells in the target model
            for(const key in mapping){
                const cell = mapping[key];
                let terminal = cell.getTerminal(true);
                if (terminal != null) {
                    terminal = mapping[(0, $368e61f06e799719$export$2e2bcd8739ae039).create(terminal)];
                    this.setTerminal(cell, terminal, true);
                }
                terminal = cell.getTerminal(false);
                if (terminal != null) {
                    terminal = mapping[(0, $368e61f06e799719$export$2e2bcd8739ae039).create(terminal)];
                    this.setTerminal(cell, terminal, false);
                }
            }
        } finally{
            this.endUpdate();
        }
    }
    /**
     * Clones the children of the source cell into the given target cell in
     * this model and adds an entry to the mapping that maps from the source
     * cell to the target cell with the same id or the clone of the source cell
     * that was inserted into this model.
     */ mergeChildrenImpl(from, to, cloneAllEdges, mapping = {}) {
        this.beginUpdate();
        try {
            const childCount = from.getChildCount();
            for(let i = 0; i < childCount; i += 1){
                const cell = from.getChildAt(i);
                if (typeof cell.getId === 'function') {
                    const id = cell.getId();
                    let target = id != null && (!cell.isEdge() || !cloneAllEdges) ? this.getCell(id) : null;
                    // Clones and adds the child if no cell exists for the id
                    if (target == null) {
                        const clone = cell.clone();
                        clone.setId(id);
                        // Sets the terminals from the original cell to the clone
                        // because the lookup uses strings not cells in JS
                        clone.setTerminal(cell.getTerminal(true), true);
                        clone.setTerminal(cell.getTerminal(false), false);
                        // Do *NOT* use model.add as this will move the edge away
                        // from the parent in updateEdgeParent if maintainEdgeParent
                        // is enabled in the target model
                        target = to.insert(clone);
                        this.cellAdded(target);
                    }
                    // Stores the mapping for later reconnecting edges
                    mapping[(0, $368e61f06e799719$export$2e2bcd8739ae039).create(cell)] = target;
                    // Recurses
                    this.mergeChildrenImpl(cell, target, cloneAllEdges, mapping);
                }
            }
        } finally{
            this.endUpdate();
        }
    }
}
var $73c88ebf085ac84f$export$2e2bcd8739ae039 = $73c88ebf085ac84f$export$c4b0e0aa83f5028b;


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2017, JGraph Ltd
Copyright (c) 2006-2017, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
var $cBHcM = parcelRequire("cBHcM");

/**
 * Extends {@link Shape} to implement a rectangle shape.
 *
 * This shape is registered under `rectangle` in {@link ShapeRegistry} when using {@link Graph} or calling {@link registerDefaultShapes}.
 *
 * @category Vertex Shapes
 */ class $14ee9ba473f8b778$var$RectangleShape extends (0, $d0e43aed19391bda$export$2e2bcd8739ae039) {
    constructor(bounds, fill, stroke, strokeWidth = 1){
        super();
        this.bounds = bounds;
        this.fill = fill;
        this.stroke = stroke;
        this.strokeWidth = strokeWidth;
    }
    /**
     * Returns true for non-rounded, non-rotated shapes with no glass gradient.
     */ isHtmlAllowed() {
        let events = true;
        if (this.style && this.style.pointerEvents != null) events = this.style.pointerEvents;
        return !this.isRounded && !this.glass && this.rotation === 0 && (events || this.fill !== (0, $cBHcM.NONE));
    }
    /**
     * Generic background painting implementation.
     */ paintBackground(c, x, y, w, h) {
        let events = true;
        if (this.style && this.style.pointerEvents != null) events = this.style.pointerEvents;
        if (events || this.fill !== (0, $cBHcM.NONE) || this.stroke !== (0, $cBHcM.NONE)) {
            if (!events && this.fill === (0, $cBHcM.NONE)) c.pointerEvents = false;
            if (this.isRounded) {
                const r = this.getArcSize(w, h);
                c.roundrect(x, y, w, h, r, r);
            } else c.rect(x, y, w, h);
            c.fillAndStroke();
        }
    }
    /**
     * Adds roundable support.
     */ isRoundable(c, x, y, w, h) {
        return true;
    }
    /**
     * Generic background painting implementation.
     */ paintForeground(c, x, y, w, h) {
        if (this.glass && !this.outline && this.fill !== (0, $cBHcM.NONE)) this.paintGlassEffect(c, x, y, w, h, this.getArcSize(w + this.strokeWidth, h + this.strokeWidth));
    }
}
var $14ee9ba473f8b778$export$2e2bcd8739ae039 = $14ee9ba473f8b778$var$RectangleShape;


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
var $cBHcM = parcelRequire("cBHcM");

/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
class $22f248acd8a7d0ef$var$EdgeMarkerRegistryImpl extends (0, $f195b8ee628b1fc3$export$1ae599b19ef421f5) {
    createMarker(canvas, shape, type, pe, unitX, unitY, size, source, sw, filled) {
        const markerFunction = this.get(type);
        return markerFunction ? markerFunction(canvas, shape, type, pe, unitX, unitY, size, source, sw, filled) : null;
    }
}
const $22f248acd8a7d0ef$export$fda6e3c4c112260a = new $22f248acd8a7d0ef$var$EdgeMarkerRegistryImpl();



var $4vC7I = parcelRequire("4vC7I");
/**
 * Extends {@link PolylineShape} to implement a connector shape including a polyline (a line with multiple points)
 * that allows for arrow heads on either side.
 *
 * The shape is used to represent edges, not vertices.
 *
 * This shape is registered under `connector` in {@link ShapeRegistry} when using {@link Graph} or calling {@link registerDefaultShapes}.
 *
 * @category Edge Shapes
 */ class $d431b1f35c865adf$var$ConnectorShape extends (0, $4b136726e3ad0ef6$export$2e2bcd8739ae039) {
    constructor(points, stroke, strokewidth){
        super(points, stroke, strokewidth);
    }
    /**
     * Updates the {@link boundingBox} for this shape using {@link createBoundingBox}
     * and {@link augmentBoundingBox} and stores the result in {@link boundingBox}.
     */ updateBoundingBox() {
        this.useSvgBoundingBox = this.style?.curved ?? false;
        super.updateBoundingBox();
    }
    /**
     * Paints the line shape.
     */ paintEdgeShape(c, pts) {
        // The indirection via functions for markers is needed in
        // order to apply the offsets before painting the line and
        // paint the markers after painting the line.
        const sourceMarker = this.createMarker(c, pts, true);
        const targetMarker = this.createMarker(c, pts, false);
        super.paintEdgeShape(c, pts);
        // Disables shadows, dashed styles
        c.setShadow(false);
        c.setDashed(false);
        if (sourceMarker) {
            const strokeColor = this.style?.startStrokeColor ?? this.stroke;
            c.setStrokeColor(strokeColor);
            c.setFillColor(this.style?.startFillColor ?? strokeColor);
            sourceMarker();
        }
        if (targetMarker) {
            const strokeColor = this.style?.endStrokeColor ?? this.stroke;
            c.setStrokeColor(strokeColor);
            c.setFillColor(this.style?.endFillColor ?? strokeColor);
            targetMarker();
        }
    }
    /**
     * Prepares the marker by adding offsets in pts and returning a function to paint the marker.
     */ createMarker(c, pts, source) {
        if (!this.style) return null;
        let result = null;
        const n = pts.length;
        const type = (source ? this.style.startArrow : this.style.endArrow) || (0, $cBHcM.NONE);
        let p0 = source ? pts[1] : pts[n - 2];
        const pe = source ? pts[0] : pts[n - 1];
        if (type !== (0, $cBHcM.NONE) && p0 !== null && pe !== null) {
            let count = 1;
            // Uses next non-overlapping point
            while(count < n - 1 && Math.round(p0.x - pe.x) === 0 && Math.round(p0.y - pe.y) === 0){
                p0 = source ? pts[1 + count] : pts[n - 2 - count];
                count++;
            }
            // Computes the norm and the inverse norm
            const dx = pe.x - p0.x;
            const dy = pe.y - p0.y;
            const dist = Math.max(1, Math.sqrt(dx * dx + dy * dy));
            const unitX = dx / dist;
            const unitY = dy / dist;
            const size = (source ? this.style.startSize : this.style.endSize) ?? (0, $4vC7I.StyleDefaultsConfig).markerSize;
            // Allow for stroke width in the end point used and the
            // orthogonal vectors describing the direction of the marker
            const filled = (source ? this.style.startFill : this.style.endFill) ?? true;
            result = (0, $22f248acd8a7d0ef$export$fda6e3c4c112260a).createMarker(c, this, type, pe, unitX, unitY, size, source, this.strokeWidth, filled);
        }
        return result;
    }
    /**
     * Augments the bounding box with the strokewidth and shadow offsets.
     */ augmentBoundingBox(bbox) {
        super.augmentBoundingBox(bbox);
        if (!this.style) return;
        // Adds marker sizes
        let size = 0;
        if ((this.style.startArrow ?? (0, $cBHcM.NONE)) !== (0, $cBHcM.NONE)) size = (this.style.startSize ?? (0, $4vC7I.StyleDefaultsConfig).markerSize) + 1;
        if ((this.style.endArrow ?? (0, $cBHcM.NONE)) !== (0, $cBHcM.NONE)) size = Math.max(size, this.style.endSize ?? (0, $4vC7I.StyleDefaultsConfig).markerSize) + 1;
        bbox.grow(size * this.scale);
    }
}
var $d431b1f35c865adf$export$2e2bcd8739ae039 = $d431b1f35c865adf$var$ConnectorShape;


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 

var $cBHcM = parcelRequire("cBHcM");
/**
 * Extends {@link RectangleShape} to implement an image shape.
 *
 * This shape is registered under `image` in {@link ShapeRegistry} when using {@link Graph} or calling {@link registerDefaultShapes}.
 *
 * @category Vertex Shapes
 */ class $48f65d6d4849e478$var$ImageShape extends (0, $14ee9ba473f8b778$export$2e2bcd8739ae039) {
    constructor(bounds, imageSrc, fill = '#FFFFFF', stroke = '#000000', strokeWidth = 1){
        super(bounds, fill, stroke, strokeWidth);
        this.imageSrc = imageSrc;
        this.shadow = false;
        this.preserveImageAspect = true;
    }
    /**
     * Disables offset in IE9 for crisper image output.
     */ getSvgScreenOffset() {
        return 0;
    }
    /**
     * Overrides to replace the fill and stroke colors with the respective values from {@link imageBackground} and {@link imageBorder}.
     *
     * Applies the style of the given {@link CellState} to the shape. This implementation assigns the following styles to local fields:
     *
     * - {@link imageBackground} => fill
     * - {@link imageBorder} => stroke
     *
     * @param {CellState} state   {@link CellState} of the corresponding cell.
     */ apply(state) {
        super.apply(state);
        this.fill = (0, $cBHcM.NONE);
        this.stroke = (0, $cBHcM.NONE);
        this.gradient = (0, $cBHcM.NONE);
        if (this.style && this.style.imageAspect != null) this.preserveImageAspect = this.style.imageAspect;
    }
    isHtmlAllowed() {
        return !this.preserveImageAspect;
    }
    /**
     * Disables inherited roundable support.
     */ isRoundable(c, x, y, w, h) {
        return false;
    }
    /**
     * Generic background painting implementation.
     */ paintVertexShape(c, x, y, w, h) {
        if (this.imageSrc) {
            const fill = this.style?.imageBackground ?? (0, $cBHcM.NONE);
            const stroke = this.style?.imageBorder ?? (0, $cBHcM.NONE);
            if (fill !== (0, $cBHcM.NONE)) {
                // Stroke rendering required for shadow
                c.setFillColor(fill);
                c.setStrokeColor(stroke);
                c.rect(x, y, w, h);
                c.fillAndStroke();
            }
            // FlipH/V are implicit via mxShape.updateTransform
            c.image(x, y, w, h, this.imageSrc, this.preserveImageAspect, false, false);
            if (stroke !== (0, $cBHcM.NONE)) {
                c.setShadow(false);
                c.setStrokeColor(stroke);
                c.rect(x, y, w, h);
                c.stroke();
            }
        } else this.paintBackground(c, x, y, w, h);
    }
}
var $48f65d6d4849e478$export$2e2bcd8739ae039 = $48f65d6d4849e478$var$ImageShape;


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 

var $cBHcM = parcelRequire("cBHcM");









var $h5l15 = parcelRequire("h5l15");

var $4vC7I = parcelRequire("4vC7I");
/**
 * Extends {@link Shape} to implement a text shape.
 *
 * This shape is **NOT** registered in {@link ShapeRegistry} when using {@link Graph} or calling {@link registerDefaultShapes}.
 * It is the label shape: it is created by {@link CellRenderer.createLabel} and stored in {@link CellState.text}, next to
 * the shape of the cell itself. It is not usable as a value of the `shape` style, because shapes coming from
 * {@link ShapeRegistry} are constructed without any argument whereas this one requires a value and bounds, and because
 * {@link getTextRotation} would then recurse endlessly on its own state.
 *
 * ### Rotation of vertical labels
 *
 * The rotation applied to a vertical label (a cell whose `horizontal` style is `false`) does not come from this shape.
 * {@link getTextRotation} delegates to the shape of the cell, {@link CellState.shape}, so the
 * {@link verticalTextRotation} declared here is never read while the label belongs to a cell state. To change vertical
 * text from "bottom to top" (the -90 degrees default) to "top to bottom", set {@link Shape.verticalTextRotation} on the
 * shape of the cell. No global configuration object covers it, so the change goes through a {@link CellRenderer}
 * subclass:
 *
 * ```typescript
 * import { CellRenderer, Graph } from '@maxgraph/core';
 * import type { CellState, Shape } from '@maxgraph/core';
 *
 * class TopToBottomCellRenderer extends CellRenderer {
 *   override createShape(state: CellState): Shape {
 *     const shape = super.createShape(state);
 *     shape.verticalTextRotation = 90;
 *     return shape;
 *   }
 * }
 *
 * class TopToBottomGraph extends Graph {
 *   override createCellRenderer(): CellRenderer {
 *     return new TopToBottomCellRenderer();
 *   }
 * }
 * ```
 *
 * {@link BaseGraph} takes the renderer as a collaborator instead of a factory method:
 * `new BaseGraph({ container, cellRenderer: new TopToBottomCellRenderer() })`.
 *
 * Beware that `0` does not mean "no extra rotation": {@link Shape.getTextRotation} computes
 * `this.verticalTextRotation || -90`, so a value of `0` falls back to -90 degrees.
 *
 * @category Vertex Shapes
 */ class $ac9b5e111f18d948$var$TextShape extends (0, $d0e43aed19391bda$export$2e2bcd8739ae039) {
    constructor(value, bounds, align = 'center', valign = 'middle', color = 'black', family = (0, $4vC7I.StyleDefaultsConfig).fontFamily, size = (0, $4vC7I.StyleDefaultsConfig).fontSize, fontStyle = (0, $cBHcM.DEFAULT_FONTSTYLE), spacing = 2, spacingTop = 0, spacingRight = 0, spacingBottom = 0, spacingLeft = 0, horizontal = true, background = (0, $cBHcM.NONE), border = (0, $cBHcM.NONE), wrap = false, clipped = false, overflow = 'visible', labelPadding = 0, textDirection = (0, $cBHcM.DEFAULT_TEXT_DIRECTION)){
        super();
        this.margin = null;
        this.unrotatedBoundingBox = null;
        this.flipH = false;
        this.flipV = false;
        /**
         * Specifies the spacing to be added to the top spacing. Default is 0. Use the
         * value 5 here to get the same label positions as in mxGraph 1.x.
         */ this.baseSpacingTop = 0;
        /**
         * Specifies the spacing to be added to the bottom spacing. Default is 0. Use the
         * value 1 here to get the same label positions as in mxGraph 1.x.
         */ this.baseSpacingBottom = 0;
        /**
         * Specifies the spacing to be added to the left spacing. Default is 0.
         */ this.baseSpacingLeft = 0;
        /**
         * Specifies the spacing to be added to the right spacing. Default is 0.
         */ this.baseSpacingRight = 0;
        /**
         * Specifies if linefeeds in HTML labels should be replaced with BR tags.
         * Default is true.
         */ this.replaceLinefeeds = true;
        /**
         * Rotation for vertical text. Default is -90 (bottom to top).
         *
         * This value is **not** used to rotate the label of a cell: {@link getTextRotation} delegates to
         * {@link CellState.shape}, so the value that applies is the {@link Shape.verticalTextRotation} of the shape of the
         * cell. See the documentation of this class for the way to change it.
         */ this.verticalTextRotation = -90;
        /**
         * Specifies if the string size should be measured in <updateBoundingBox> if
         * the label is clipped and the label position is center and middle. If this is
         * true, then the bounding box will be set to <bounds>. Default is true.
         * <ignoreStringSize> has precedence over this switch.
         */ this.ignoreClippedStringSize = true;
        /**
         * Specifies if the actual string size should be measured. If disabled the
         * boundingBox will not ignore the actual size of the string, otherwise
         * <bounds> will be used instead. Default is false.
         */ this.ignoreStringSize = false;
        /**
         * Contains the last rendered text value. Used for caching.
         */ this.lastValue = null;
        /**
         * Specifies if caching for HTML labels should be enabled. Default is true.
         */ this.cacheEnabled = true;
        this.value = value;
        this.bounds = bounds;
        this.color = color ?? 'black';
        this.align = align ?? 'center';
        this.valign = valign ?? 'middle';
        this.family = family ?? (0, $4vC7I.StyleDefaultsConfig).fontFamily;
        this.size = size ?? (0, $4vC7I.StyleDefaultsConfig).fontSize;
        this.fontStyle = fontStyle ?? (0, $cBHcM.DEFAULT_FONTSTYLE);
        this.spacing = spacing ?? 2;
        this.spacingTop = this.spacing + (spacingTop ?? 0);
        this.spacingRight = this.spacing + (spacingRight ?? 0);
        this.spacingBottom = this.spacing + (spacingBottom ?? 0);
        this.spacingLeft = this.spacing + (spacingLeft ?? 0);
        this.horizontal = horizontal ?? true;
        this.background = background;
        this.border = border;
        this.wrap = wrap ?? false;
        this.clipped = clipped ?? false;
        this.overflow = overflow ?? 'visible';
        this.labelPadding = labelPadding ?? 0;
        this.textDirection = textDirection;
        this.rotation = 0;
        this.updateMargin();
    }
    /**
     * Disables offset in IE9 for crisper image output.
     */ getSvgScreenOffset() {
        return 0;
    }
    /**
     * Returns true if the bounds are not null and all of its variables are numeric.
     */ checkBounds() {
        return !Number.isNaN(this.scale) && Number.isFinite(this.scale) && this.scale > 0 && this.bounds && !Number.isNaN(this.bounds.x) && !Number.isNaN(this.bounds.y) && !Number.isNaN(this.bounds.width) && !Number.isNaN(this.bounds.height);
    }
    /**
     * Generic rendering code.
     */ paint(c, update = false) {
        // Scale is passed-through to canvas
        const s = this.scale;
        const x = this.bounds.x / s;
        const y = this.bounds.y / s;
        const w = this.bounds.width / s;
        const h = this.bounds.height / s;
        this.updateTransform(c, x, y, w, h);
        this.configureCanvas(c, x, y, w, h);
        if (update) c.updateText(x, y, w, h, this.align, this.valign, this.wrap, this.overflow, this.clipped, this.getTextRotation(), this.node);
        else {
            // Checks if text contains HTML markup
            const realHtml = (0, $b1d29c834e82fef5$export$8ee0fc9ee280b4ee)(this.value) || this.dialect === 'strictHtml';
            // Always renders labels as HTML in VML
            const fmt = realHtml ? 'html' : '';
            let val = this.value;
            if (!realHtml && fmt === 'html') val = (0, $6bb3a85a9cf63e97$export$324699496a105db8)(val, false);
            if (fmt === 'html' && !(0, $b1d29c834e82fef5$export$8ee0fc9ee280b4ee)(this.value)) val = (0, $6bb3a85a9cf63e97$export$c480f75734bc04c9)(val, '<div><br></div>');
            // Handles trailing newlines to make sure they are visible in rendering output
            val = !(0, $b1d29c834e82fef5$export$8ee0fc9ee280b4ee)(this.value) && this.replaceLinefeeds && fmt === 'html' ? val.replace(/\n/g, '<br/>') : val;
            let dir = this.textDirection;
            if (dir === 'auto' && !realHtml) dir = this.getAutoDirection();
            if (dir !== 'ltr' && dir !== 'rtl') dir = '';
            c.text(x, y, w, h, val, this.align, this.valign, this.wrap, fmt, this.overflow, this.clipped, this.getTextRotation(), dir);
        }
    }
    /**
     * Renders the text using the given DOM nodes.
     */ redraw() {
        if (this.visible && this.checkBounds() && this.cacheEnabled && this.lastValue === this.value && ((0, $b1d29c834e82fef5$export$8ee0fc9ee280b4ee)(this.value) || this.dialect === 'strictHtml')) {
            if (this.node.nodeName === 'DIV') {
                this.redrawHtmlShape();
                this.updateBoundingBox();
            } else {
                const canvas = this.createCanvas();
                if (canvas) {
                    // Specifies if events should be handled
                    canvas.pointerEvents = this.pointerEvents;
                    this.paint(canvas, true);
                    this.destroyCanvas(canvas);
                    this.updateBoundingBox();
                }
            }
        } else {
            super.redraw();
            if ((0, $b1d29c834e82fef5$export$8ee0fc9ee280b4ee)(this.value) || this.dialect === 'strictHtml') this.lastValue = this.value;
            else this.lastValue = null;
        }
    }
    /**
     * Resets all styles.
     */ resetStyles() {
        super.resetStyles();
        this.color = 'black';
        this.align = 'center';
        this.valign = 'middle';
        this.family = (0, $4vC7I.StyleDefaultsConfig).fontFamily;
        this.size = (0, $4vC7I.StyleDefaultsConfig).fontSize;
        this.fontStyle = (0, $cBHcM.DEFAULT_FONTSTYLE);
        this.spacing = 2;
        this.spacingTop = 2;
        this.spacingRight = 2;
        this.spacingBottom = 2;
        this.spacingLeft = 2;
        this.horizontal = true;
        this.background = (0, $cBHcM.NONE);
        this.border = (0, $cBHcM.NONE);
        this.textDirection = (0, $cBHcM.DEFAULT_TEXT_DIRECTION);
        this.margin = null;
    }
    /**
     * Extends mxShape to update the text styles.
     *
     * @param state <CellState> of the corresponding cell.
     */ apply(state) {
        const old = this.spacing;
        super.apply(state);
        if (this.style) {
            this.fontStyle = this.style.fontStyle ?? this.fontStyle;
            this.family = this.style.fontFamily ?? this.family;
            this.size = this.style.fontSize ?? this.size;
            this.color = this.style.fontColor ?? this.color;
            this.align = this.style.align ?? this.align;
            this.valign = this.style.verticalAlign ?? this.valign;
            this.spacing = this.style.spacing ?? this.spacing;
            this.spacingTop = (this.style.spacingTop ?? this.spacingTop - old) + this.spacing;
            this.spacingRight = (this.style.spacingRight ?? this.spacingRight - old) + this.spacing;
            this.spacingBottom = (this.style.spacingBottom ?? this.spacingBottom - old) + this.spacing;
            this.spacingLeft = (this.style.spacingLeft ?? this.spacingLeft - old) + this.spacing;
            this.horizontal = this.style.horizontal ?? this.horizontal;
            this.background = this.style.labelBackgroundColor ?? this.background;
            this.border = this.style.labelBorderColor ?? this.border;
            this.textDirection = this.style.textDirection ?? (0, $cBHcM.DEFAULT_TEXT_DIRECTION);
            this.opacity = this.style.textOpacity ?? 100;
            this.updateMargin();
        }
        this.flipV = false;
        this.flipH = false;
    }
    /**
     * Used to determine the automatic text direction.
     *
     * Returns 'ltr' or 'rtl' depending on the contents of {@link value}.
     *
     * This is not invoked for HTML, wrapped content or if {@link value} is a DOM node.
     */ getAutoDirection() {
        // Looks for strong (directional) characters
        const tmp = /[A-Za-z\u05d0-\u065f\u066a-\u06ef\u06fa-\u07ff\ufb1d-\ufdff\ufe70-\ufefc]/.exec(String(this.value));
        // Returns the direction defined by the character
        return tmp && tmp.length > 0 && tmp[0] > 'z' ? 'rtl' : 'ltr';
    }
    /**
     * Returns the node that contains the rendered input.
     */ getContentNode() {
        let result = this.node;
        if (result) {
            // Rendered with no foreignObject
            if (!result.ownerSVGElement) // @ts-ignore
            result = this.node.firstChild.firstChild;
            else // Innermost DIV that contains the actual content
            // @ts-ignore
            result = result.firstChild.firstChild.firstChild.firstChild.firstChild;
        }
        return result;
    }
    /**
     * Updates the <boundingBox> for this shape using the given node and position.
     */ updateBoundingBox() {
        let { node: node } = this;
        this.boundingBox = this.bounds.clone();
        const rot = this.getTextRotation();
        const h = this.style?.labelPosition ?? 'center';
        const v = this.style?.verticalLabelPosition ?? 'middle';
        if (!this.ignoreStringSize && node && this.overflow !== 'fill' && (!this.clipped || !this.ignoreClippedStringSize || h !== 'center' || v !== 'middle')) {
            let ow = null;
            let oh = null;
            if (node.firstChild && node.firstChild.firstChild && node.firstChild.firstChild.nodeName === 'foreignObject') {
                // Uses second inner DIV for font metrics
                // @ts-ignore
                node = node.firstChild.firstChild.firstChild.firstChild;
                // @ts-ignore
                oh = node.offsetHeight * this.scale;
                if (this.overflow === 'width') ow = this.boundingBox.width;
                else // @ts-ignore
                ow = node.offsetWidth * this.scale;
            } else try {
                const b = node.getBBox();
                // Workaround for bounding box of empty string
                if (typeof this.value === 'string' && (0, $6bb3a85a9cf63e97$export$87c2784dc9fc4ab)(this.value)?.length === 0) this.boundingBox = null;
                else if (b.width === 0 && b.height === 0) this.boundingBox = null;
                else this.boundingBox = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(b.x, b.y, b.width, b.height);
                return;
            } catch (e) {
            // Ignores NS_ERROR_FAILURE in FF if container display is none.
            }
            if (ow && oh) this.boundingBox = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(this.bounds.x, this.bounds.y, ow, oh);
        }
        if (this.boundingBox) {
            const margin = this.margin;
            if (rot !== 0) {
                // Accounts for pre-rotated x and y
                const bbox = (0, $f7ff90b8964488a6$export$895c5e634403eaa7)(new (0, $2997c239141ea844$export$2e2bcd8739ae039)(margin.x * this.boundingBox.width, margin.y * this.boundingBox.height, this.boundingBox.width, this.boundingBox.height), rot, new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(0, 0));
                this.unrotatedBoundingBox = (0, $2997c239141ea844$export$2e2bcd8739ae039).fromRectangle(this.boundingBox);
                this.unrotatedBoundingBox.x += margin.x * this.unrotatedBoundingBox.width;
                this.unrotatedBoundingBox.y += margin.y * this.unrotatedBoundingBox.height;
                this.boundingBox.x += bbox.x;
                this.boundingBox.y += bbox.y;
                this.boundingBox.width = bbox.width;
                this.boundingBox.height = bbox.height;
            } else {
                this.boundingBox.x += margin.x * this.boundingBox.width;
                this.boundingBox.y += margin.y * this.boundingBox.height;
                this.unrotatedBoundingBox = null;
            }
        }
    }
    /**
     * Returns 0 to avoid using rotation in the canvas via updateTransform.
     */ getShapeRotation() {
        return 0;
    }
    /**
     * Returns the rotation for the text label of the corresponding shape.
     */ getTextRotation() {
        return this.state && this.state.shape ? this.state.shape.getTextRotation() : 0;
    }
    /**
     * Inverts the bounds if {@link Shape#isBoundsInverted} returns true or if the
     * horizontal style is false.
     */ isPaintBoundsInverted() {
        return !this.horizontal && !!this.state && this.state.cell.isVertex();
    }
    /**
     * Sets the state of the canvas for drawing the shape.
     */ configureCanvas(c, x, y, w, h) {
        super.configureCanvas(c, x, y, w, h);
        c.setFontColor(this.color);
        c.setFontBackgroundColor(this.background);
        c.setFontBorderColor(this.border);
        c.setFontFamily(this.family);
        c.setFontSize(this.size);
        c.setFontStyle(this.fontStyle);
    }
    /**
     * Private helper function to create SVG elements
     */ getHtmlValue() {
        let val = this.value;
        if (this.dialect !== 'strictHtml') val = (0, $6bb3a85a9cf63e97$export$324699496a105db8)(val, false);
        // Handles trailing newlines to make sure they are visible in rendering output
        val = (0, $6bb3a85a9cf63e97$export$c480f75734bc04c9)(val, '<div><br></div>');
        val = this.replaceLinefeeds ? val.replace(/\n/g, '<br/>') : val;
        return val;
    }
    /**
     * Private helper function to create SVG elements
     */ getTextCss() {
        const lh = (0, $cBHcM.ABSOLUTE_LINE_HEIGHT) ? `${this.size * (0, $cBHcM.LINE_HEIGHT)}px` : (0, $cBHcM.LINE_HEIGHT);
        let css = `display: inline-block; font-size: ${this.size}px; ` + `font-family: ${this.family}; color: ${this.color}; line-height: ${lh}; pointer-events: ${this.pointerEvents ? 'all' : 'none'}; `;
        (0, $h5l15.matchBinaryMask)(this.fontStyle, (0, $cBHcM.FONT_STYLE_MASK).BOLD) && (css += 'font-weight: bold; ');
        (0, $h5l15.matchBinaryMask)(this.fontStyle, (0, $cBHcM.FONT_STYLE_MASK).ITALIC) && (css += 'font-style: italic; ');
        const txtDecor = [];
        (0, $h5l15.matchBinaryMask)(this.fontStyle, (0, $cBHcM.FONT_STYLE_MASK).UNDERLINE) && txtDecor.push('underline');
        (0, $h5l15.matchBinaryMask)(this.fontStyle, (0, $cBHcM.FONT_STYLE_MASK).STRIKETHROUGH) && txtDecor.push('line-through');
        txtDecor.length > 0 && (css += `text-decoration: ${txtDecor.join(' ')}; `);
        return css;
    }
    /**
     * Updates the HTML node(s) to reflect the latest bounds and scale.
     */ redrawHtmlShape() {
        const w = Math.max(0, Math.round(this.bounds.width / this.scale));
        const h = Math.max(0, Math.round(this.bounds.height / this.scale));
        const flex = `position: absolute; left: ${Math.round(this.bounds.x)}px; ` + `top: ${Math.round(this.bounds.y)}px; pointer-events: none; `;
        const block = this.getTextCss();
        const margin = this.margin;
        const node = this.node;
        (0, $f0b9bd90b7bd8dd2$export$2e2bcd8739ae039).createCss(w + 2, h, this.align, this.valign, this.wrap, this.overflow, this.clipped, this.background !== (0, $cBHcM.NONE) ? (0, $6bb3a85a9cf63e97$export$324699496a105db8)(this.background, true) : null, this.border !== (0, $cBHcM.NONE) ? (0, $6bb3a85a9cf63e97$export$324699496a105db8)(this.border, true) : null, flex, block, this.scale, (dx, dy, flex, item, block, ofl)=>{
            const r = this.getTextRotation();
            let tr = (this.scale !== 1 ? `scale(${this.scale}) ` : '') + (r !== 0 ? `rotate(${r}deg) ` : '') + (margin.x !== 0 || margin.y !== 0 ? `translate(${margin.x * 100}%,${margin.y * 100}%)` : '');
            if (tr !== '') tr = `transform-origin: 0 0; transform: ${tr}; `;
            if (ofl === '') {
                flex += item;
                item = `display:inline-block; min-width: 100%; ${tr}`;
            } else {
                item += tr;
                if ((0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_SF) item += '-webkit-clip-path: content-box;';
            }
            if (this.opacity < 100) block += `opacity: ${this.opacity / 100}; `;
            node.setAttribute('style', flex);
            const html = (0, $b1d29c834e82fef5$export$8ee0fc9ee280b4ee)(this.value) ? this.value.outerHTML : this.getHtmlValue();
            if (!node.firstChild) node.innerHTML = `<div><div>${html}</div></div>`;
            // @ts-ignore
            node.firstChild.firstChild.setAttribute('style', block);
            // @ts-ignore
            node.firstChild.setAttribute('style', item);
        });
    }
    /**
     * Sets the inner HTML of the given element to the <value>.
     */ updateInnerHtml(elt) {
        if ((0, $b1d29c834e82fef5$export$8ee0fc9ee280b4ee)(this.value)) elt.innerHTML = this.value.outerHTML;
        else {
            let val = this.value;
            if (this.dialect !== 'strictHtml') // LATER: Can be cached in updateValue
            val = (0, $6bb3a85a9cf63e97$export$324699496a105db8)(val, false);
            // Handles trailing newlines to make sure they are visible in rendering output
            val = (0, $6bb3a85a9cf63e97$export$c480f75734bc04c9)(val, '<div>&nbsp;</div>');
            val = this.replaceLinefeeds ? val.replace(/\n/g, '<br/>') : val;
            val = `<div style="display:inline-block;_display:inline;">${val}</div>`;
            elt.innerHTML = val;
        }
    }
    /**
     * Updates the HTML node(s) to reflect the latest bounds and scale.
     */ updateValue() {
        const node = this.node;
        if ((0, $b1d29c834e82fef5$export$8ee0fc9ee280b4ee)(this.value)) {
            node.innerHTML = '';
            node.appendChild(this.value);
        } else {
            let val = this.value;
            if (this.dialect !== 'strictHtml') val = (0, $6bb3a85a9cf63e97$export$324699496a105db8)(val, false);
            // Handles trailing newlines to make sure they are visible in rendering output
            val = (0, $6bb3a85a9cf63e97$export$c480f75734bc04c9)(val, '<div><br></div>');
            val = this.replaceLinefeeds ? val.replace(/\n/g, '<br/>') : val;
            const bg = this.background !== (0, $cBHcM.NONE) ? this.background : null;
            const bd = this.border !== (0, $cBHcM.NONE) ? this.border : null;
            if (this.overflow === 'fill' || this.overflow === 'width') {
                if (bg) node.style.backgroundColor = bg;
                if (bd) node.style.border = `1px solid ${bd}`;
            } else {
                let css = '';
                if (bg) css += `background-color:${(0, $6bb3a85a9cf63e97$export$324699496a105db8)(bg, true)};`;
                if (bd) css += `border:1px solid ${(0, $6bb3a85a9cf63e97$export$324699496a105db8)(bd, true)};`;
                // Wrapper DIV for background, zoom needed for inline in quirks
                // and to measure wrapped font sizes in all browsers
                // FIXME: Background size in quirks mode for wrapped text
                const lh = (0, $cBHcM.ABSOLUTE_LINE_HEIGHT) ? `${this.size * (0, $cBHcM.LINE_HEIGHT)}px` : (0, $cBHcM.LINE_HEIGHT);
                val = `<div style="zoom:1;${css}display:inline-block;_display:inline;text-decoration:inherit;` + `padding-bottom:1px;padding-right:1px;line-height:${lh}">${val}</div>`;
            }
            node.innerHTML = val;
            // Sets text direction
            const divs = node.getElementsByTagName('div');
            if (divs.length > 0) {
                let dir = this.textDirection;
                if (dir === 'auto' && this.dialect !== 'strictHtml') dir = this.getAutoDirection();
                if (dir === 'ltr' || dir === 'rtl') divs[divs.length - 1].setAttribute('dir', dir);
                else divs[divs.length - 1].removeAttribute('dir');
            }
        }
    }
    /**
     * Updates the HTML node(s) to reflect the latest bounds and scale.
     */ updateFont(node) {
        const { style: style } = node;
        // @ts-ignore
        style.lineHeight = (0, $cBHcM.ABSOLUTE_LINE_HEIGHT) ? `${this.size * (0, $cBHcM.LINE_HEIGHT)}px` : (0, $cBHcM.LINE_HEIGHT);
        style.fontSize = `${this.size}px`;
        style.fontFamily = this.family;
        style.verticalAlign = 'top';
        style.color = this.color;
        (0, $h5l15.matchBinaryMask)(this.fontStyle, (0, $cBHcM.FONT_STYLE_MASK).BOLD) ? style.fontWeight = 'bold' : style.fontWeight = '';
        (0, $h5l15.matchBinaryMask)(this.fontStyle, (0, $cBHcM.FONT_STYLE_MASK).ITALIC) ? style.fontStyle = 'italic' : style.fontStyle = '';
        const txtDecor = [];
        (0, $h5l15.matchBinaryMask)(this.fontStyle, (0, $cBHcM.FONT_STYLE_MASK).UNDERLINE) && txtDecor.push('underline');
        (0, $h5l15.matchBinaryMask)(this.fontStyle, (0, $cBHcM.FONT_STYLE_MASK).STRIKETHROUGH) && txtDecor.push('line-through');
        txtDecor.length > 0 && (style.textDecoration = txtDecor.join(' '));
        if (this.align === 'center') style.textAlign = 'center';
        else if (this.align === 'right') style.textAlign = 'right';
        else style.textAlign = 'left';
    }
    /**
     * Updates the HTML node(s) to reflect the latest bounds and scale.
     */ updateSize(node, enableWrap = false) {
        const w = Math.max(0, Math.round(this.bounds.width / this.scale));
        const h = Math.max(0, Math.round(this.bounds.height / this.scale));
        const { style: style } = node;
        // NOTE: Do not use maxWidth here because wrapping will
        // go wrong if the cell is outside of the viewable area
        if (this.clipped) {
            style.overflow = 'hidden';
            style.maxHeight = `${h}px`;
            style.maxWidth = `${w}px`;
        } else if (this.overflow === 'fill') {
            style.width = `${w + 1}px`;
            style.height = `${h + 1}px`;
            style.overflow = 'hidden';
        } else if (this.overflow === 'width') {
            style.width = `${w + 1}px`;
            style.maxHeight = `${h + 1}px`;
            style.overflow = 'hidden';
        }
        if (this.wrap && w > 0) {
            style.wordWrap = (0, $cBHcM.WORD_WRAP);
            style.whiteSpace = 'normal';
            style.width = `${w}px`;
            if (enableWrap && this.overflow !== 'fill' && this.overflow !== 'width') {
                let sizeDiv = node;
                if (sizeDiv.firstChild != null && sizeDiv.firstChild.nodeName === 'DIV') {
                    // @ts-ignore
                    sizeDiv = sizeDiv.firstChild;
                    if (node.style.wordWrap === 'break-word') sizeDiv.style.width = '100%';
                }
                let tmp = sizeDiv.offsetWidth;
                // Workaround for text measuring in hidden containers
                if (tmp === 0) {
                    const prev = node.parentNode;
                    node.style.visibility = 'hidden';
                    document.body.appendChild(node);
                    tmp = sizeDiv.offsetWidth;
                    node.style.visibility = '';
                    prev.appendChild(node);
                }
                tmp += 3;
                if (this.clipped) tmp = Math.min(tmp, w);
                style.width = `${tmp}px`;
            }
        } else style.whiteSpace = 'nowrap';
    }
    /**
     * Returns the spacing as an {@link Point}.
     */ updateMargin() {
        this.margin = (0, $b55d6ca3b42398e2$export$29d173e672cfdc1f)(this.align, this.valign);
    }
    /**
     * Returns the spacing as an {@link Point}.
     */ getSpacing() {
        let dx = 0;
        let dy = 0;
        if (this.align === 'center') dx = (this.spacingLeft - this.spacingRight) / 2;
        else if (this.align === 'right') dx = -this.spacingRight - this.baseSpacingRight;
        else dx = this.spacingLeft + this.baseSpacingLeft;
        if (this.valign === 'middle') dy = (this.spacingTop - this.spacingBottom) / 2;
        else if (this.valign === 'bottom') dy = -this.spacingBottom - this.baseSpacingBottom;
        else dy = this.spacingTop + this.baseSpacingTop;
        return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(dx, dy);
    }
}
var $ac9b5e111f18d948$export$2e2bcd8739ae039 = $ac9b5e111f18d948$var$TextShape;



var $cBHcM = parcelRequire("cBHcM");




/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
const $7589a668edfb0759$export$c15282e4d9d6e44e = new (0, $f195b8ee628b1fc3$export$1ae599b19ef421f5)();


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
const $3e06012548141a59$export$70eac3d2a559b8c8 = new (0, $f195b8ee628b1fc3$export$1ae599b19ef421f5)();











var $4vC7I = parcelRequire("4vC7I");
const $71fcd07ecf4780df$var$placeholderStyleValues = [
    'inherit',
    'swimlane',
    'indicated'
];
const $71fcd07ecf4780df$var$placeholderStyleProperties = [
    'fillColor',
    'strokeColor',
    'gradientColor',
    'fontColor'
];
/**
 * Renders {@link Cell}s into a document object model.
 *
 * In general, the `CellRenderer` is in charge of creating, redrawing and destroying the shape and label associated with a cell state,
 * as well as some other graphical objects, namely controls and overlays.
 *
 * The shape hierarchy in the display (i.e. the hierarchy in which the DOM nodes appear in the document) does not reflect the cell hierarchy.
 * The shapes are a (flat) sequence of shapes and labels inside the draw pane of the {@link GraphView}, with some exceptions,
 * namely the HTML labels being placed directly inside the graph container for certain browsers.
 */ class $71fcd07ecf4780df$var$CellRenderer {
    constructor(){
        /**
         * Defines the default shape for edges.
         * @default {@link ConnectorShape}
         */ this.defaultEdgeShape = (0, $d431b1f35c865adf$export$2e2bcd8739ae039);
        /**
         * Defines the default shape for vertices.
         * @default {@link RectangleShape}.
         */ this.defaultVertexShape = (0, $14ee9ba473f8b778$export$2e2bcd8739ae039);
        /**
         * Defines the default shape for labels.
         * @default {@link TextShape}.
         */ this.defaultTextShape = (0, $ac9b5e111f18d948$export$2e2bcd8739ae039);
        /**
         * Specifies if the folding icon should ignore the horizontal orientation of a swimlane.
         * @default true.
         */ this.legacyControlPosition = true;
        /**
         * Specifies if spacing and label position should be ignored if overflow is fill or width.
         * @default true for backwards compatibility.
         */ this.legacySpacing = true;
        /**
         * Antialiasing option for new shapes.
         * @default true.
         */ this.antiAlias = true;
        /**
         * Minimum stroke width for SVG output.
         */ this.minSvgStrokeWidth = 1;
        /**
         * Specifies if the enabled state of the graph should be ignored in the control
         * click handler (to allow folding in disabled graphs).
         * @default false.
         */ this.forceControlClickHandler = false;
    }
    /**
     * Initializes the shape in the given state by calling its init method with
     * the correct container after configuring it using {@link configureShape}.
     *
     * @param state {@link CellState} for which the shape should be initialized.
     */ initializeShape(state) {
        if (state.shape) {
            state.shape.dialect = state.view.graph.dialect;
            this.configureShape(state);
            state.shape.init(state.view.getDrawPane());
        }
    }
    /**
     * Creates and returns the shape for the given cell state.
     *
     * @param state {@link CellState} for which the shape should be created.
     */ createShape(state) {
        // Checks if there is a stencil for the name and creates a shape instance for the stencil if one exists
        const stencil = (0, $3e06012548141a59$export$70eac3d2a559b8c8).get(state.style.shape);
        if (stencil) return new (0, $d0e43aed19391bda$export$2e2bcd8739ae039)(stencil);
        const shapeConstructor = this.getShapeConstructor(state);
        return new shapeConstructor();
    }
    /**
     * Creates the indicator shape for the given cell state.
     *
     * @param state {@link CellState} for which the indicator shape should be created.
     */ createIndicatorShape(state) {
        if (state.shape) state.shape.indicatorShape = this.getShape(state.getIndicatorShape());
    }
    /**
     * Returns the shape for the given name from {@link ShapeRegistry}.
     */ getShape(name) {
        return (0, $7589a668edfb0759$export$c15282e4d9d6e44e).get(name);
    }
    /**
     * Returns the constructor to be used for creating the shape.
     */ getShapeConstructor(state) {
        let ctor = this.getShape(state.style.shape);
        if (!ctor) ctor = state.cell.isEdge() ? this.defaultEdgeShape : this.defaultVertexShape;
        return ctor;
    }
    /**
     * Configures the shape for the given cell state.
     *
     * @param state {@link CellState} for which the shape should be configured.
     */ configureShape(state) {
        const shape = state.shape;
        if (shape) {
            shape.apply(state);
            shape.imageSrc = state.getImageSrc() || null;
            shape.indicatorColor = state.getIndicatorColor() || (0, $cBHcM.NONE);
            shape.indicatorStrokeColor = state.style.indicatorStrokeColor || (0, $cBHcM.NONE);
            shape.indicatorGradientColor = state.getIndicatorGradientColor() || (0, $cBHcM.NONE);
            if (state.style.indicatorDirection) shape.indicatorDirection = state.style.indicatorDirection;
            shape.indicatorImageSrc = state.getIndicatorImageSrc() || null;
            this.postConfigureShape(state);
        }
    }
    /**
     * Replaces any reserved words used for attributes, eg. inherit,
     * indicated or swimlane for colors in the shape for the given state.
     * This implementation resolves these keywords on the fill, stroke
     * and gradient color keys.
     */ postConfigureShape(state) {
        if (state.shape) {
            this.resolveColor(state, 'indicatorGradientColor', 'gradientColor');
            this.resolveColor(state, 'indicatorColor', 'fillColor');
            this.resolveColor(state, 'gradient', 'gradientColor');
            this.resolveColor(state, 'stroke', 'strokeColor');
            this.resolveColor(state, 'fill', 'fillColor');
        }
    }
    /**
     * Check if style properties supporting placeholders requires resolution.
     */ checkPlaceholderStyles(state) {
        // LATER: Check if the color has actually changed
        for (const property of $71fcd07ecf4780df$var$placeholderStyleProperties){
            if ($71fcd07ecf4780df$var$placeholderStyleValues.includes(state.style[property])) return true;
        }
        return false;
    }
    /**
     * Resolves special keywords 'inherit', 'indicated' and 'swimlane' and sets
     * the respective color on the shape.
     */ resolveColor(state, field, key) {
        const shape = key === 'fontColor' ? state.text : state.shape;
        if (shape) {
            const graph = state.view.graph;
            // @ts-ignore
            const value = shape[field];
            let referenced = null;
            if (value === 'inherit') referenced = state.cell.getParent();
            else if (value === 'swimlane') {
                // @ts-ignore
                shape[field] = key === 'strokeColor' || key === 'fontColor' ? '#000000' : '#ffffff';
                if (state.cell.getTerminal(false)) referenced = state.cell.getTerminal(false);
                else referenced = state.cell;
                referenced = graph.getSwimlane(referenced);
                key = graph.swimlaneIndicatorColorAttribute;
            } else if (value === 'indicated' && state.shape) // @ts-ignore
            shape[field] = state.shape.indicatorColor;
            else if (key !== 'fillColor' && value === 'fillColor' && state.shape) // @ts-ignore
            shape[field] = state.style.fillColor;
            else if (key !== 'strokeColor' && value === 'strokeColor' && state.shape) // @ts-ignore
            shape[field] = state.style.strokeColor;
            if (referenced) {
                const rstate = graph.getView().getState(referenced);
                // @ts-ignore
                shape[field] = null;
                if (rstate) {
                    const rshape = key === 'fontColor' ? rstate.text : rstate.shape;
                    if (rshape && field !== 'indicatorColor') // @ts-ignore
                    shape[field] = rshape[field];
                    else // @ts-ignore
                    shape[field] = rstate.style[key];
                }
            }
        }
    }
    /**
     * Returns the value to be used for the label.
     *
     * @param state {@link CellState} for which the label should be created.
     */ getLabelValue(state) {
        const graph = state.view.graph;
        return graph.getLabel(state.cell);
    }
    /**
     * Creates the label for the given cell state.
     *
     * @param state {@link CellState} for which the label should be created.
     * @param value the label value.
     */ createLabel(state, value) {
        const graph = state.view.graph;
        if ((state.style.fontSize || 0) > 0 || state.style.fontSize == null) {
            // Avoids using DOM node for empty labels
            const isForceHtml = graph.isHtmlLabel(state.cell) || (0, $b1d29c834e82fef5$export$8ee0fc9ee280b4ee)(value);
            state.text = new this.defaultTextShape(value, new (0, $2997c239141ea844$export$2e2bcd8739ae039)(), state.style.align ?? 'center', state.getVerticalAlign(), state.style.fontColor, state.style.fontFamily, state.style.fontSize, state.style.fontStyle, state.style.spacing, state.style.spacingTop, state.style.spacingRight, state.style.spacingBottom, state.style.spacingLeft, state.style.horizontal, state.style.labelBackgroundColor, state.style.labelBorderColor, graph.isWrapping(state.cell) && graph.isHtmlLabel(state.cell), graph.isLabelClipped(state.cell), state.style.overflow, state.style.labelPadding, state.style.textDirection ?? (0, $cBHcM.DEFAULT_TEXT_DIRECTION));
            state.text.opacity = state.style.textOpacity ?? 100;
            state.text.dialect = isForceHtml ? 'strictHtml' : graph.dialect;
            state.text.style = state.style;
            state.text.state = state;
            this.initializeLabel(state, state.text);
            // Workaround for touch devices routing all events for a mouse gesture
            // (down, move, up) via the initial DOM node. IE additionally redirects
            // the event via the initial DOM node but the event source is the node
            // under the mouse, so we need to check if this is the case and force
            // getCellAt for the subsequent mouseMoves and the final mouseUp.
            let forceGetCell = false;
            const getState = (evt)=>{
                let result = state;
                if ((0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_TOUCH || forceGetCell) {
                    const x = (0, $f192e93a2fd1153c$export$87583e2c100c6a4f)(evt);
                    const y = (0, $f192e93a2fd1153c$export$195fc3609401443f)(evt);
                    // Dispatches the drop event to the graph which
                    // consumes and executes the source function
                    const pt = (0, $b55d6ca3b42398e2$export$864dc177f7f5bda1)(graph.container, x, y);
                    result = graph.view.getState(graph.getCellAt(pt.x, pt.y));
                }
                return result;
            };
            // TODO: Add handling for special touch device gestures
            (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addGestureListeners(state.text.node, (evt)=>{
                if (this.isLabelEvent(state, evt)) {
                    graph.fireMouseEvent((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_DOWN, new (0, $2051fd5f8fd06bc7$export$2e2bcd8739ae039)(evt, state));
                    const source = (0, $f192e93a2fd1153c$export$dd2b6e807fb37ba3)(evt);
                    forceGetCell = // @ts-ignore nodeName should exist.
                    graph.dialect !== 'svg' && source.nodeName === 'IMG';
                }
            }, (evt)=>{
                if (this.isLabelEvent(state, evt)) graph.fireMouseEvent((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_MOVE, new (0, $2051fd5f8fd06bc7$export$2e2bcd8739ae039)(evt, getState(evt)));
            }, (evt)=>{
                if (this.isLabelEvent(state, evt)) {
                    graph.fireMouseEvent((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_UP, new (0, $2051fd5f8fd06bc7$export$2e2bcd8739ae039)(evt, getState(evt)));
                    forceGetCell = false;
                }
            });
            // Uses double click timeout in mxGraph for quirks mode
            if (graph.isNativeDblClickEnabled()) (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addListener(state.text.node, 'dblclick', (evt)=>{
                if (this.isLabelEvent(state, evt)) {
                    graph.dblClick(evt, state.cell);
                    (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).consume(evt);
                }
            });
        }
    }
    /**
     * Initializes the label with a suitable container.
     *
     * @param state {@link CellState} whose label should be initialized.
     * @param shape {@link Shape} that represents the label.
     */ initializeLabel(state, shape) {
        if ((0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_SVG && (0, $d47e32a58f71e01d$export$2e2bcd8739ae039).NO_FO && shape.dialect !== 'svg') {
            const graph = state.view.graph;
            shape.init(graph.container);
        } else shape.init(state.view.getDrawPane());
    }
    /**
     * Creates the actual shape for showing the overlay for the given cell state.
     *
     * @param state {@link CellState} for which the overlay should be created.
     */ createCellOverlays(state) {
        const graph = state.view.graph;
        const cellOverlays = graph.getCellOverlays(state.cell);
        const createdOverlays = new Map();
        for (const cellOverlay of cellOverlays){
            const shape = state.overlays.get(cellOverlay);
            state.overlays.delete(cellOverlay);
            if (shape) {
                createdOverlays.set(cellOverlay, shape);
                continue;
            }
            const overlayShape = this.createOverlayShape(state, cellOverlay);
            overlayShape.dialect = graph.dialect;
            overlayShape.overlay = cellOverlay;
            this.initializeOverlay(state, overlayShape);
            this.installCellOverlayListeners(state, cellOverlay, overlayShape);
            this.configureOverlayShape(state, cellOverlay, overlayShape);
            createdOverlays.set(cellOverlay, overlayShape);
        }
        // Removes unused
        state.overlays.forEach((shape)=>{
            shape.destroy();
        });
        state.overlays = createdOverlays;
    }
    /**
     * Create the Shape of the overlay.
     *
     * @param _state {@link CellState} for which the overlay shape should be created.
     * @param cellOverlay {@link CellOverlay} used to create the Shape of the overlay.
     * @since 0.16.0
     */ createOverlayShape(_state, cellOverlay) {
        const overlayShape = new (0, $48f65d6d4849e478$export$2e2bcd8739ae039)(new (0, $2997c239141ea844$export$2e2bcd8739ae039)(), cellOverlay.image.src);
        overlayShape.preserveImageAspect = false;
        return overlayShape;
    }
    /**
     * Initializes the given overlay.
     *
     * @param state {@link CellState}  for which the overlay should be created.
     * @param overlay {@link Shape} that represents the overlay.
     */ initializeOverlay(state, overlay) {
        overlay.init(state.view.getOverlayPane());
    }
    /**
     * Installs the listeners for the given {@link CellState} , {@link CellOverlay} and {@link Shape} that represents the overlay.
     */ installCellOverlayListeners(state, overlay, shape) {
        const graph = state.view.graph;
        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addListener(shape.node, 'click', (evt)=>{
            if (graph.isEditing()) graph.stopEditing(!graph.isInvokesStopCellEditing());
            overlay.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CLICK, {
                event: evt,
                cell: state.cell
            }));
        });
        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addGestureListeners(shape.node, (evt)=>{
            (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).consume(evt);
        }, (evt)=>{
            graph.fireMouseEvent((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_MOVE, new (0, $2051fd5f8fd06bc7$export$2e2bcd8739ae039)(evt, state));
        });
        if ((0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_TOUCH) (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addListener(shape.node, 'touchend', (evt)=>{
            overlay.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CLICK, {
                event: evt,
                cell: state.cell
            }));
        });
    }
    /**
     * Configure the Shape of the overlay. Generally, it is used to configure the DOM node of the Shape
     *
     * The default implementation set the cursor in the DOM node of the Shape based on the {@link CellOverlay.cursor}.
     *
     * @param _state {@link CellState} for which the overlay shape should be created.
     * @param cellOverlay {@link CellOverlay} used to create the Shape of the overlay.
     * @param overlayShape the {@link Shape} of the overlay.
     * @since 0.16.0
     */ configureOverlayShape(_state, cellOverlay, overlayShape) {
        if (cellOverlay.cursor) overlayShape.node.style.cursor = cellOverlay.cursor;
    }
    /**
     * Creates the control for the given cell state.
     *
     * @param state {@link CellState}  for which the control should be created.
     */ createControl(state) {
        const graph = state.view.graph;
        const image = graph.getFoldingImage(state);
        if (graph.isFoldingEnabled() && image) {
            if (!state.control) {
                const b = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(0, 0, image.width, image.height);
                state.control = new (0, $48f65d6d4849e478$export$2e2bcd8739ae039)(b, image.src);
                state.control.preserveImageAspect = false;
                state.control.dialect = graph.dialect;
                this.initControl(state, state.control, true, this.createControlClickHandler(state));
            }
        } else if (state.control) {
            state.control.destroy();
            state.control = null;
        }
    }
    /**
     * Hook for creating the click handler for the folding icon.
     *
     * @param state {@link CellState}  whose control click handler should be returned.
     */ createControlClickHandler(state) {
        const graph = state.view.graph;
        return (evt)=>{
            if (this.forceControlClickHandler || graph.isEnabled()) {
                const collapse = !state.cell.isCollapsed();
                graph.foldCells(collapse, false, [
                    state.cell
                ], false, evt);
                (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).consume(evt);
            }
        };
    }
    /**
     * Initializes the given control and returns the corresponding DOM node.
     *
     * @param state {@link CellState} for which the control should be initialized.
     * @param control {@link Shape} to be initialized.
     * @param handleEvents Boolean indicating if mousedown and mousemove should fire events via the graph.
     * @param clickHandler Optional function to implement clicks on the control.
     */ initControl(state, control, handleEvents, clickHandler) {
        const graph = state.view.graph;
        // In the special case where the label is in HTML and the display is SVG the image
        // should go into the graph container directly in order to be clickable. Otherwise
        // it is obscured by the HTML label that overlaps the cell.
        const isForceHtml = graph.isHtmlLabel(state.cell) && (0, $d47e32a58f71e01d$export$2e2bcd8739ae039).NO_FO && graph.dialect === 'svg';
        if (isForceHtml) {
            control.dialect = 'preferHtml';
            control.init(graph.container);
            control.node.style.zIndex = String(1);
        } else control.init(state.view.getOverlayPane());
        const node = control.node;
        // Workaround for missing click event on iOS is to check tolerance below
        if (clickHandler && !(0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_IOS) {
            if (graph.isEnabled()) node.style.cursor = 'pointer';
            (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addListener(node, 'click', clickHandler);
        }
        if (handleEvents) {
            let first = null;
            (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addGestureListeners(node, (evt)=>{
                first = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)((0, $f192e93a2fd1153c$export$87583e2c100c6a4f)(evt), (0, $f192e93a2fd1153c$export$195fc3609401443f)(evt));
                graph.fireMouseEvent((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_DOWN, new (0, $2051fd5f8fd06bc7$export$2e2bcd8739ae039)(evt, state));
                (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).consume(evt);
            }, (evt)=>{
                graph.fireMouseEvent((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_MOVE, new (0, $2051fd5f8fd06bc7$export$2e2bcd8739ae039)(evt, state));
            }, (evt)=>{
                graph.fireMouseEvent((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_UP, new (0, $2051fd5f8fd06bc7$export$2e2bcd8739ae039)(evt, state));
                (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).consume(evt);
            });
            // Uses capture phase for event interception to stop bubble phase
            if (clickHandler && (0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_IOS) node.addEventListener('touchend', (evt)=>{
                if (first) {
                    const tol = graph.getEventTolerance();
                    if (Math.abs(first.x - (0, $f192e93a2fd1153c$export$87583e2c100c6a4f)(evt)) < tol && Math.abs(first.y - (0, $f192e93a2fd1153c$export$195fc3609401443f)(evt)) < tol) {
                        clickHandler.call(clickHandler, evt);
                        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).consume(evt);
                    }
                }
            }, true);
        }
        return node;
    }
    /**
     * Returns `true` if the event is for the shape of the given state.
     *
     * This implementation always returns `true`.
     *
     * @param state {@link CellState}  whose shape fired the event.
     * @param evt Mouse event which was fired.
     */ isShapeEvent(state, evt) {
        return true;
    }
    /**
     * Returns `true` if the event is for the label of the given state.
     *
     * This implementation always returns `true`.
     *
     * @param state {@link CellState}  whose label fired the event.
     * @param evt Mouse event which was fired.
     */ isLabelEvent(state, evt) {
        return true;
    }
    /**
     * Installs the event listeners for the given cell state.
     *
     * @param state {@link CellState}  for which the event listeners should be isntalled.
     */ installListeners(state) {
        const graph = state.view.graph;
        // Workaround for touch devices routing all events for a mouse
        // gesture (down, move, up) via the initial DOM node. Same for
        // HTML images in all IE versions (VML images are working).
        const getState = (evt)=>{
            let result = state;
            const source = (0, $f192e93a2fd1153c$export$dd2b6e807fb37ba3)(evt);
            if (source && graph.dialect !== 'svg' && // @ts-ignore nodeName should exist
            source.nodeName === 'IMG' || (0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_TOUCH) {
                const x = (0, $f192e93a2fd1153c$export$87583e2c100c6a4f)(evt);
                const y = (0, $f192e93a2fd1153c$export$195fc3609401443f)(evt);
                // Dispatches the drop event to the graph which
                // consumes and executes the source function
                const pt = (0, $b55d6ca3b42398e2$export$864dc177f7f5bda1)(graph.container, x, y);
                const cell = graph.getCellAt(pt.x, pt.y);
                result = cell ? graph.view.getState(cell) : null;
            }
            return result;
        };
        if (state.shape) {
            (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addGestureListeners(state.shape.node, (evt)=>{
                if (this.isShapeEvent(state, evt)) graph.fireMouseEvent((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_DOWN, new (0, $2051fd5f8fd06bc7$export$2e2bcd8739ae039)(evt, state));
            }, (evt)=>{
                if (this.isShapeEvent(state, evt)) graph.fireMouseEvent((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_MOVE, new (0, $2051fd5f8fd06bc7$export$2e2bcd8739ae039)(evt, getState(evt)));
            }, (evt)=>{
                if (this.isShapeEvent(state, evt)) graph.fireMouseEvent((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_UP, new (0, $2051fd5f8fd06bc7$export$2e2bcd8739ae039)(evt, getState(evt)));
            });
            // Uses double click timeout in mxGraph for quirks mode
            if (graph.isNativeDblClickEnabled()) (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addListener(state.shape.node, 'dblclick', (evt)=>{
                if (this.isShapeEvent(state, evt)) {
                    graph.dblClick(evt, state.cell);
                    (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).consume(evt);
                }
            });
        }
    }
    /**
     * Redraws the label for the given cell state.
     *
     * @param state {@link CellState}  whose label should be redrawn.
     */ redrawLabel(state, forced) {
        const graph = state.view.graph;
        const value = this.getLabelValue(state);
        const wrapping = graph.isWrapping(state.cell);
        const clipping = graph.isLabelClipped(state.cell);
        const isForceHtml = graph.isHtmlLabel(state.cell) || value && (0, $b1d29c834e82fef5$export$8ee0fc9ee280b4ee)(value);
        const dialect = isForceHtml ? 'strictHtml' : graph.dialect;
        const overflow = state.style.overflow ?? 'visible';
        if (state.text && (state.text.wrap !== wrapping || state.text.clipped !== clipping || state.text.overflow !== overflow || state.text.dialect !== dialect)) {
            state.text.destroy();
            state.text = null;
        }
        if (state.text == null && value != null && ((0, $b1d29c834e82fef5$export$8ee0fc9ee280b4ee)(value) || value.length > 0)) this.createLabel(state, value);
        else if (state.text != null && (value == null || value.length == 0)) {
            state.text.destroy();
            state.text = null;
        }
        if (state.text != null) {
            // Forced is true if the style has changed, so to get the updated
            // result in getLabelBounds we apply the new style to the shape
            if (forced) {
                // Checks if a full repaint is needed
                if (state.text.lastValue != null && this.isTextShapeInvalid(state, state.text)) // Forces a full repaint
                state.text.lastValue = null;
                state.text.resetStyles();
                state.text.apply(state);
                // Special case where value is obtained via hook in graph
                state.text.valign = state.getVerticalAlign();
            }
            const bounds = this.getLabelBounds(state);
            const nextScale = this.getTextScale(state);
            this.resolveColor(state, 'color', 'fontColor');
            if (forced || state.text.value !== value || state.text.wrap !== wrapping || state.text.overflow !== overflow || state.text.clipped !== clipping || state.text.scale !== nextScale || state.text.dialect !== dialect || state.text.bounds == null || !state.text.bounds.equals(bounds)) {
                state.text.dialect = dialect;
                state.text.value = value;
                state.text.bounds = bounds;
                state.text.scale = nextScale;
                state.text.wrap = wrapping;
                state.text.clipped = clipping;
                state.text.overflow = overflow;
                // Preserves visible state
                // @ts-ignore
                const vis = state.text.node.style.visibility;
                this.redrawLabelShape(state.text);
                // @ts-ignore
                state.text.node.style.visibility = vis;
            }
        }
    }
    /**
     * Returns true if the style for the text shape has changed.
     *
     * @param state {@link CellState}  whose label should be checked.
     * @param shape {@link Text} shape to be checked.
     */ isTextShapeInvalid(state, shape) {
        function check(property, styleName, defaultValue) {
            let result = false;
            // Workaround for spacing added to directional spacing
            if (styleName === 'spacingTop' || styleName === 'spacingRight' || styleName === 'spacingBottom' || styleName === 'spacingLeft') result = // @ts-ignore
            Number.parseFloat(String(shape[property])) - Number.parseFloat(String(shape.spacing)) !== (state.style[styleName] || defaultValue);
            else // @ts-ignore
            result = shape[property] !== (state.style[styleName] || defaultValue);
            return result;
        }
        return check('fontStyle', 'fontStyle', (0, $cBHcM.DEFAULT_FONTSTYLE)) || check('family', 'fontFamily', (0, $4vC7I.StyleDefaultsConfig).fontFamily) || check('size', 'fontSize', (0, $4vC7I.StyleDefaultsConfig).fontSize) || check('color', 'fontColor', 'black') || check('align', 'align', '') || check('valign', 'verticalAlign', '') || check('spacing', 'spacing', 2) || check('spacingTop', 'spacingTop', 0) || check('spacingRight', 'spacingRight', 0) || check('spacingBottom', 'spacingBottom', 0) || check('spacingLeft', 'spacingLeft', 0) || check('horizontal', 'horizontal', true) || check('background', 'labelBackgroundColor', null) || check('border', 'labelBorderColor', null) || check('opacity', 'textOpacity', 100) || check('textDirection', 'textDirection', (0, $cBHcM.DEFAULT_TEXT_DIRECTION));
    }
    /**
     * Called to invoked redraw on the given text shape.
     *
     * @param shape {@link Text} shape to be redrawn.
     */ redrawLabelShape(shape) {
        shape.redraw();
    }
    /**
     * Returns the scaling used for the label of the given state
     *
     * @param state {@link CellState}  whose label scale should be returned.
     */ getTextScale(state) {
        return state.view.scale;
    }
    /**
     * Returns the bounds to be used to draw the label of the given state.
     *
     * @param state {@link CellState}  whose label bounds should be returned.
     */ getLabelBounds(state) {
        const { scale: scale } = state.view;
        const isEdge = state.cell.isEdge();
        let bounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(state.absoluteOffset.x, state.absoluteOffset.y);
        if (isEdge) {
            // @ts-ignore
            const spacing = state.text.getSpacing();
            bounds.x += spacing.x * scale;
            bounds.y += spacing.y * scale;
            const geo = state.cell.getGeometry();
            if (geo != null) {
                bounds.width = Math.max(0, geo.width * scale);
                bounds.height = Math.max(0, geo.height * scale);
            }
        } else {
            // Inverts label position
            // @ts-ignore
            if (state.text.isPaintBoundsInverted()) {
                const tmp = bounds.x;
                bounds.x = bounds.y;
                bounds.y = tmp;
            }
            bounds.x += state.x;
            bounds.y += state.y;
            // Minimum of 1 fixes alignment bug in HTML labels
            bounds.width = Math.max(1, state.width);
            bounds.height = Math.max(1, state.height);
        }
        // @ts-ignore
        if (state.text.isPaintBoundsInverted()) {
            // Rotates around center of state
            const t = (state.width - state.height) / 2;
            bounds.x += t;
            bounds.y -= t;
            const tmp = bounds.width;
            bounds.width = bounds.height;
            bounds.height = tmp;
        }
        // Shape can modify its label bounds
        if (state.shape != null) {
            const hpos = state.style.labelPosition ?? 'center';
            const vpos = state.style.verticalLabelPosition ?? 'middle';
            if (hpos === 'center' && vpos === 'middle') bounds = state.shape.getLabelBounds(bounds);
        }
        // Label width style overrides actual label width
        const lw = state.style.labelWidth ?? null;
        if (lw != null) bounds.width = lw * scale;
        if (!isEdge) this.rotateLabelBounds(state, bounds);
        return bounds;
    }
    /**
     * Adds the shape rotation to the given label bounds and
     * applies the alignment and offsets.
     *
     * @param state {@link CellState}  whose label bounds should be rotated.
     * @param bounds {@link Rectangle} the rectangle to be rotated.
     */ rotateLabelBounds(state, bounds) {
        const textShape = state.text;
        bounds.y -= textShape.margin.y * bounds.height;
        bounds.x -= textShape.margin.x * bounds.width;
        if (!this.legacySpacing || state.style.overflow !== 'fill' && state.style.overflow !== 'width') {
            const s = state.view.scale;
            const spacing = textShape.getSpacing();
            bounds.x += spacing.x * s;
            bounds.y += spacing.y * s;
            const hpos = state.style.labelPosition ?? 'center';
            const vpos = state.style.verticalLabelPosition ?? 'middle';
            const lw = state.style.labelWidth ?? null;
            bounds.width = Math.max(0, bounds.width - (hpos === 'center' && lw == null ? textShape.spacingLeft * s + textShape.spacingRight * s : 0));
            bounds.height = Math.max(0, bounds.height - (vpos === 'middle' ? textShape.spacingTop * s + textShape.spacingBottom * s : 0));
        }
        // @ts-ignore
        const theta = textShape.getTextRotation();
        // Only needed if rotated around another center
        if (theta !== 0 && state != null && // @ts-ignore
        state.cell.isVertex()) {
            const cx = state.getCenterX();
            const cy = state.getCenterY();
            if (bounds.x !== cx || bounds.y !== cy) {
                const rad = theta * (Math.PI / 180);
                const pt = (0, $f7ff90b8964488a6$export$ad2a0af3fbffd7c1)(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(bounds.x, bounds.y), Math.cos(rad), Math.sin(rad), new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(cx, cy));
                bounds.x = pt.x;
                bounds.y = pt.y;
            }
        }
    }
    /**
     * Redraws the overlays for the given cell state.
     *
     * @param state {@link CellState}  whose overlays should be redrawn.
     */ redrawCellOverlays(state, forced = false) {
        this.createCellOverlays(state);
        if (state.overlays) {
            const rot = (0, $f7ff90b8964488a6$export$842a2cf37af977e1)(state.style.rotation ?? 0, 90);
            const rad = (0, $f7ff90b8964488a6$export$cba01ba138429a1d)(rot);
            const cos = Math.cos(rad);
            const sin = Math.sin(rad);
            state.overlays.forEach((shape)=>{
                const bounds = shape.overlay?.getBounds(state) ?? null;
                if (bounds && !state.cell.isEdge() && state.shape && rot !== 0) {
                    let cx = bounds.getCenterX();
                    let cy = bounds.getCenterY();
                    const point = (0, $f7ff90b8964488a6$export$ad2a0af3fbffd7c1)(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(cx, cy), cos, sin, new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(state.getCenterX(), state.getCenterY()));
                    cx = point.x;
                    cy = point.y;
                    bounds.x = Math.round(cx - bounds.width / 2);
                    bounds.y = Math.round(cy - bounds.height / 2);
                }
                if (forced || shape.bounds == null || shape.scale !== state.view.scale || !shape.bounds.equals(bounds)) {
                    shape.bounds = bounds;
                    shape.scale = state.view.scale;
                    shape.redraw();
                }
            });
        }
    }
    /**
     * Redraws the control for the given cell state.
     *
     * @param state {@link CellState}  whose control should be redrawn.
     */ redrawControl(state, forced = false) {
        const image = state.view.graph.getFoldingImage(state);
        if (state.control != null && image != null) {
            const bounds = this.getControlBounds(state, image.width, image.height);
            const r = this.legacyControlPosition ? state.style.rotation ?? 0 : state.shape.getTextRotation();
            const s = state.view.scale;
            if (forced || state.control.scale !== s || !state.control.bounds.equals(bounds) || state.control.rotation !== r) {
                state.control.rotation = r;
                state.control.bounds = bounds;
                state.control.scale = s;
                state.control.redraw();
            }
        }
    }
    /**
     * Returns the bounds to be used to draw the control (folding icon) of the given state.
     */ getControlBounds(state, w, h) {
        if (state.control != null) {
            const s = state.view.scale;
            let cx = state.getCenterX();
            let cy = state.getCenterY();
            if (!state.cell.isEdge()) {
                cx = state.x + w * s;
                cy = state.y + h * s;
                if (state.shape != null) {
                    // TODO: Factor out common code
                    let rot = state.shape.getShapeRotation();
                    if (this.legacyControlPosition) rot = state.style.rotation ?? 0;
                    else if (state.shape.isPaintBoundsInverted()) {
                        const t = (state.width - state.height) / 2;
                        cx += t;
                        cy -= t;
                    }
                    if (rot !== 0) {
                        const rad = (0, $f7ff90b8964488a6$export$cba01ba138429a1d)(rot);
                        const cos = Math.cos(rad);
                        const sin = Math.sin(rad);
                        const point = (0, $f7ff90b8964488a6$export$ad2a0af3fbffd7c1)(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(cx, cy), cos, sin, new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(state.getCenterX(), state.getCenterY()));
                        cx = point.x;
                        cy = point.y;
                    }
                }
            }
            return state.cell.isEdge() ? new (0, $2997c239141ea844$export$2e2bcd8739ae039)(Math.round(cx - w / 2 * s), Math.round(cy - h / 2 * s), Math.round(w * s), Math.round(h * s)) : new (0, $2997c239141ea844$export$2e2bcd8739ae039)(Math.round(cx - w / 2 * s), Math.round(cy - h / 2 * s), Math.round(w * s), Math.round(h * s));
        }
        return null;
    }
    /**
     * Inserts the given {@link CellState} after the given nodes in the DOM.
     *
     * @param state {@link CellState} to be inserted.
     * @param node Node in {@link GraphView.drawPane} after which the shapes should be inserted.
     * @param htmlNode Node in the graph container after which the shapes should be inserted that
     * will not go into the {@link GraphView.drawPane} (e.g. HTML labels without foreignObjects).
     */ insertStateAfter(state, node, htmlNode) {
        const graph = state.view.graph;
        const shapes = this.getShapesForState(state);
        for(let i = 0; i < shapes.length; i += 1)// @ts-ignore
        if (shapes[i] != null && shapes[i].node != null) {
            const html = // @ts-ignore
            shapes[i].node.parentNode !== state.view.getDrawPane() && // @ts-ignore
            shapes[i].node.parentNode !== state.view.getOverlayPane();
            const temp = html ? htmlNode : node;
            // @ts-ignore
            if (temp != null && temp.nextSibling !== shapes[i].node) {
                if (temp.nextSibling == null) // @ts-ignore
                temp.parentNode.appendChild(shapes[i].node);
                else // @ts-ignore
                temp.parentNode.insertBefore(shapes[i].node, temp.nextSibling);
            } else if (temp == null) {
                // Special case: First HTML node should be first sibling after canvas
                // @ts-ignore
                const shapeNode = shapes[i].node;
                if (shapeNode.parentNode === graph.container) {
                    let { canvas: canvas } = state.view;
                    while(canvas != null && canvas.parentNode !== graph.container)// @ts-ignore
                    canvas = canvas.parentNode;
                    if (canvas != null && canvas.nextSibling != null) {
                        if (canvas.nextSibling !== shapeNode) // @ts-ignore
                        shapeNode.parentNode.insertBefore(shapeNode, canvas.nextSibling);
                    } else // @ts-ignore
                    shapeNode.parentNode.appendChild(shapeNode);
                } else if (shapeNode.parentNode != null && shapeNode.parentNode.firstChild != null && shapeNode.parentNode.firstChild != shapeNode) // Inserts the node as the first child of the parent to implement the order
                shapeNode.parentNode.insertBefore(shapeNode, shapeNode.parentNode.firstChild);
            }
            if (html) // @ts-ignore
            htmlNode = shapes[i].node;
            else // @ts-ignore
            node = shapes[i].node;
        }
        return [
            node,
            htmlNode
        ];
    }
    /**
     * Returns the {@link Shape}s for the given cell state in the order in which they should appear in the DOM.
     *
     * @param state {@link CellState}  whose shapes should be returned.
     */ getShapesForState(state) {
        return [
            state.shape,
            state.text,
            state.control
        ];
    }
    /**
     * Updates the bounds or points and scale of the shapes for the given cell
     * state. This is called in mxGraphView.validatePoints as the last step of
     * updating all cells.
     *
     * @param state {@link CellState}  for which the shapes should be updated.
     * @param force Optional boolean that specifies if the cell should be reconfiured
     * and redrawn without any additional checks.
     * @param rendering Optional boolean that specifies if the cell should actually
     * be drawn into the DOM. If this is false then redraw and/or reconfigure
     * will not be called on the shape.
     */ redraw(state, force = false, rendering = true) {
        const shapeChanged = this.redrawShape(state, force, rendering);
        if (state.shape != null && rendering) {
            this.redrawLabel(state, shapeChanged);
            this.redrawCellOverlays(state, shapeChanged);
            this.redrawControl(state, shapeChanged);
        }
    }
    /**
     * Redraws the shape for the given cell state.
     *
     * @param state {@link CellState}  whose label should be redrawn.
     */ redrawShape(state, force = false, rendering = true) {
        let shapeChanged = false;
        const graph = state.view.graph;
        // Forces creation of new shape if shape style has changed
        if (state.shape != null && state.shape.style != null && state.style != null && state.shape.style.shape !== state.style.shape) {
            state.shape.destroy();
            state.shape = null;
        }
        const selectionCellsHandler = graph.getPlugin('SelectionCellsHandler');
        if (state.shape == null && graph.container != null && state.cell !== state.view.currentRoot && (state.cell.isVertex() || state.cell.isEdge())) {
            state.shape = this.createShape(state);
            if (state.shape != null) {
                state.shape.minSvgStrokeWidth = this.minSvgStrokeWidth;
                state.shape.antiAlias = this.antiAlias;
                this.createIndicatorShape(state);
                this.initializeShape(state);
                this.createCellOverlays(state);
                this.installListeners(state);
                // Forces a refresh of the handler if one exists
                selectionCellsHandler?.updateHandler(state);
            }
        } else if (!force && state.shape != null && (!(0, $7798e91745d24e26$export$ddfc9eb811782af)(state.shape.style, state.style) || this.checkPlaceholderStyles(state))) {
            state.shape.resetStyles();
            this.configureShape(state);
            // LATER: Ignore update for realtime to fix reset of current gesture
            selectionCellsHandler?.updateHandler(state);
            force = true;
        }
        // Updates indicator shape
        if (state.shape != null && state.shape.indicatorShape != this.getShape(state.getIndicatorShape())) {
            if (state.shape.indicator != null) {
                state.shape.indicator.destroy();
                state.shape.indicator = null;
            }
            this.createIndicatorShape(state);
            if (state.shape.indicatorShape != null) {
                state.shape.indicator = new state.shape.indicatorShape();
                state.shape.indicator.dialect = state.shape.dialect;
                state.shape.indicator.init(state.node);
                force = true;
            }
        }
        if (state.shape) {
            // Handles changes of the collapse icon
            this.createControl(state);
            // Redraws the cell if required, ignores changes to bounds if points are
            // defined as the bounds are updated for the given points inside the shape
            if (force || this.isShapeInvalid(state, state.shape)) {
                if (state.absolutePoints.length > 0) {
                    state.shape.points = state.absolutePoints.slice();
                    state.shape.bounds = null;
                } else {
                    state.shape.points = [];
                    state.shape.bounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(state.x, state.y, state.width, state.height);
                }
                state.shape.scale = state.view.scale;
                if (rendering == null || rendering) this.doRedrawShape(state);
                else state.shape.updateBoundingBox();
                shapeChanged = true;
            }
        }
        return shapeChanged;
    }
    /**
     * Invokes redraw on the shape of the given state.
     */ doRedrawShape(state) {
        state.shape?.redraw();
    }
    /**
     * Returns true if the given shape must be repainted.
     */ isShapeInvalid(state, shape) {
        return shape.bounds == null || shape.scale !== state.view.scale || state.absolutePoints.length === 0 && !shape.bounds.equals(state) || state.absolutePoints.length > 0 && !(0, $7798e91745d24e26$export$762de7b100cb21fe)(shape.points, state.absolutePoints);
    }
    /**
     * Destroys the shapes associated with the given cell state.
     *
     * @param state {@link CellState}  for which the shapes should be destroyed.
     */ destroy(state) {
        if (state.shape) {
            if (state.text) {
                state.text.destroy();
                state.text = null;
            }
            state.overlays.forEach((shape)=>{
                shape.destroy();
            });
            state.overlays = new Map();
            if (state.control) {
                state.control.destroy();
                state.control = null;
            }
            state.shape.destroy();
            state.shape = null;
        }
    }
}
var $71fcd07ecf4780df$export$2e2bcd8739ae039 = $71fcd07ecf4780df$var$CellRenderer;


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
var $cBHcM = parcelRequire("cBHcM");
class $94c0379da76b3d8f$export$cd02bf5de16fbd7c {
    constructor(){
        this.styles = new Map();
        this.putDefaultVertexStyle(this.createDefaultVertexStyle());
        this.putDefaultEdgeStyle(this.createDefaultEdgeStyle());
    }
    /**
     * Creates and returns the default vertex style.
     */ createDefaultVertexStyle() {
        return {
            shape: 'rectangle',
            perimeter: 'rectanglePerimeter',
            verticalAlign: 'middle',
            align: 'center',
            fillColor: '#C3D9FF',
            strokeColor: '#6482B9',
            fontColor: '#774400'
        };
    }
    /**
     * Creates and returns the default edge style.
     */ createDefaultEdgeStyle() {
        return {
            shape: 'connector',
            endArrow: 'classic',
            verticalAlign: 'middle',
            align: 'center',
            strokeColor: '#6482B9',
            fontColor: '#446299'
        };
    }
    /**
     * Sets the default style for vertices using `defaultVertex` as the style name.
     * @param style The style to be stored.
     */ putDefaultVertexStyle(style) {
        this.putCellStyle('defaultVertex', style);
    }
    /**
     * Sets the default style for edges using `defaultEdge` as the style name.
     * @param style The style to be stored.
     */ putDefaultEdgeStyle(style) {
        this.putCellStyle('defaultEdge', style);
    }
    /**
     * Returns the default style for vertices.
     */ getDefaultVertexStyle() {
        return this.styles.get('defaultVertex');
    }
    /**
     * Returns the default style for edges.
     */ getDefaultEdgeStyle() {
        return this.styles.get('defaultEdge');
    }
    /**
     * Stores the given {@link CellStateStyle} under the given name in {@link styles}.
     *
     * ### Example
     *
     * The following example adds a new style called `rounded` into an existing stylesheet:
     *
     * ```javascript
     * const style = {} as CellStateStyle;
     * style.shape = 'rectangle';
     * style.perimeter = 'rectanglePerimeter';
     * style.rounded = true;
     * graph.getStylesheet().putCellStyle('rounded', style);
     * ```
     *
     * ### Description
     *
     * Note that not all properties will be interpreted by all shapes. For example, the 'line' shape ignores the fill color.
     * The final call to this method associates the style with a name in the stylesheet.
     *
     * The style is used in a cell with the following code:
     * ```javascript
     * // model is an instance of GraphDataModel
     * // style is an instance of CellStyle
     * model.setStyle(cell, { baseStyleNames: ['rounded'] });
     * ```
     *
     * @param name Name for the style to be stored.
     * @param style The instance of the style to be stored.
     */ putCellStyle(name, style) {
        this.styles.set(name, style);
    }
    /**
     * Returns a {@link CellStateStyle} computed by merging the default style, styles referenced in the specified `baseStyleNames`
     * and the properties of the `cellStyle` parameter.
     *
     * The properties are merged by taking the properties from various styles in the following order:
     *   - default style (if {@link CellStyle.ignoreDefaultStyle} is not set to `true`, otherwise it is ignored)
     *   - registered styles referenced in `baseStyleNames`, in the order of the array
     *   - `cellStyle` parameter
     *
     * To fully unset a style property i.e. the property is not set even if a value is set in the default style or in the referenced styles,
     * set the `cellStyle` property to `none`. For example. `cellStyle.fillColor = 'none'`
     *
     * @param cellStyle An object that represents the style.
     * @param defaultStyle Default style used as reference to compute the returned style.
     */ getCellStyle(cellStyle, defaultStyle) {
        let style = cellStyle.ignoreDefaultStyle ? {} : {
            ...defaultStyle
        };
        if (cellStyle.baseStyleNames) // creates style with the given baseStyleNames. (merges from left to right)
        style = cellStyle.baseStyleNames.reduce((acc, styleName)=>{
            return {
                ...acc,
                ...this.styles.get(styleName)
            };
        }, style);
        // Merges cellStyle into style
        for (const key of Object.keys(cellStyle))// @ts-ignore
        if (cellStyle[key] !== undefined) // @ts-ignore
        cellStyle[key] == (0, $cBHcM.NONE) ? delete style[key] : style[key] = cellStyle[key];
        // Remove the specific CellStyle properties that may have been copied from the cellStyle parameter to match the method signature
        'baseStyleNames' in style && delete style.baseStyleNames;
        'ignoreDefaultStyle' in style && delete style.ignoreDefaultStyle;
        return style;
    }
}


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 

/**
 * Action to add and remove cells to/from the selection of a {@link GraphSelectionModel}.
 *
 * @category Change
 */ class $cebbd4d2e9a95460$var$SelectionChange {
    constructor(graph, added = [], removed = []){
        this.graph = graph;
        this.added = added.slice();
        this.removed = removed.slice();
    }
    /**
     * Applies the change to the selection model: calls {@link GraphSelectionModel.cellRemoved} for each cell
     * in {@link removed}, then {@link GraphSelectionModel.cellAdded} for each cell in {@link added}. Swaps
     * {@link added} and {@link removed} so a subsequent call undoes the change, then fires
     * {@link InternalEvent.CHANGE} on the selection model.
     *
     * **WARN**: because of the swap, the `added` and `removed` properties of the fired event refer to the
     * post-swap arrays — the event's `added` contains the cells just removed from the selection, and
     * vice-versa. This naming is preserved for historical reasons.
     */ execute() {
        const selectionModel = this.graph.getSelectionModel();
        for (const removed of this.removed)selectionModel.cellRemoved(removed);
        for (const added of this.added)selectionModel.cellAdded(added);
        [this.added, this.removed] = [
            this.removed,
            this.added
        ];
        selectionModel.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CHANGE, {
            added: this.added,
            removed: this.removed
        }));
    }
}
var $cebbd4d2e9a95460$export$2e2bcd8739ae039 = $cebbd4d2e9a95460$var$SelectionChange;






/**
 * Implements the selection model for a graph.
 *
 * Here is a listener that handles all removed selection cells.
 *
 * ```javascript
 * graph.getSelectionModel().addListener(InternalEvent.CHANGE, function(sender, evt) {
 *   const cells = evt.getProperty('added');
 *   for (const cell of cells) {
 *     // Handle cell...
 *   }
 * });
 * ```
 *
 * ### Events
 *
 * **{@link InternalEvent.UNDO}**
 *
 * Fires after the selection was changed in {@link changeSelection}. The
 * `edit` property contains the {@link UndoableEdit} which contains the
 * {@link SelectionChange}.
 *
 * **{@link InternalEvent.CHANGE}**
 *
 * Fires after the selection changes by executing an {@link SelectionChange}.
 *
 * **WARN**: the event's `added` and `removed` properties contain arrays of cells that have been added to or
 * removed from the selection, respectively. The names are inverted due to historic reasons.
 *
 * See the {@link SelectionChange} class for more details.
 *
 */ class $e6719d4fe4c26799$var$GraphSelectionModel extends (0, $17f25eceeba97548$export$2e2bcd8739ae039) {
    /**
     * Constructs a new graph selection model for the given {@link AbstractGraph}.
     * @param graph Reference to the enclosing {@link AbstractGraph}.
     */ constructor(graph){
        super();
        /**
         * Specifies the resource key for the status message after a long operation.
         * If the resource for this key does not exist, then the value is used as
         * the status message.
         * @default 'done'
         */ this.doneResource = (0, $78efedcb0f6c688d$export$ee28232f9313fcdf)() ? 'done' : '';
        /**
         * Specifies the resource key for the status message while the selection is
         * being updated. If the resource for this key does not exist, then the
         * value is used as the status message.
         * @default 'updatingSelection'
         */ this.updatingSelectionResource = (0, $78efedcb0f6c688d$export$ee28232f9313fcdf)() ? 'updatingSelection' : '';
        /**
         * Specifies if only one selected item at a time is allowed.
         * @default false.
         */ this.singleSelection = false;
        this.graph = graph;
        this.cells = [];
    }
    /**
     * Returns {@link singleSelection} as a boolean.
     */ isSingleSelection() {
        return this.singleSelection;
    }
    /**
     * Sets the {@link singleSelection} flag.
     *
     * @param singleSelection the new value for {@link singleSelection}.
     */ setSingleSelection(singleSelection) {
        this.singleSelection = singleSelection;
    }
    /**
     * Returns true if the given {@link Cell} is selected.
     */ isSelected(cell) {
        return this.cells.includes(cell);
    }
    /**
     * Returns true if no cells are currently selected.
     */ isEmpty() {
        return this.cells.length === 0;
    }
    /**
     * Clears the selection and fires a {@link InternalEvent.CHANGE} event if the selection was not empty.
     */ clear() {
        this.changeSelection(null, this.cells);
    }
    /**
     * Selects the specified {@link Cell} using {@link setCells}.
     *
     * @param cell {@link Cell} to be selected.
     */ setCell(cell) {
        this.setCells(cell ? [
            cell
        ] : []);
    }
    /**
     * Selects the given array of {@link Cell} and fires a {@link InternalEvent.CHANGE} event.
     *
     * @param cells Array of {@link Cell} to be selected.
     */ setCells(cells) {
        if (this.singleSelection) {
            const firstSelectable = this.getFirstSelectableCell(cells);
            this.changeSelection(firstSelectable ? [
                firstSelectable
            ] : [], this.cells);
            return;
        }
        const selectable = cells.filter((cell)=>this.graph.isCellSelectable(cell));
        this.changeSelection(selectable, this.cells);
    }
    /**
     * Returns the first selectable cell in the given array of cells.
     *
     * @returns the first cell for which {@link AbstractGraph.isCellSelectable} returns `true`, or `null` if no
     * such cell exists (including when `cells` is empty).
     */ getFirstSelectableCell(cells) {
        return cells.find((cell)=>this.graph.isCellSelectable(cell)) ?? null;
    }
    /**
     * Adds the given {@link Cell} to the selection and fires a {@link InternalEvent.CHANGE} event.
     *
     * @param cell {@link Cell} to add to the selection.
     */ addCell(cell) {
        this.addCells([
            cell
        ]);
    }
    /**
     * Adds the given array of {@link Cell} to the selection and fires a {@link InternalEvent.CHANGE} event.
     *
     * @param cells Array of {@link Cell} to add to the selection.
     */ addCells(cells) {
        if (this.singleSelection) {
            const firstSelectable = this.getFirstSelectableCell(cells);
            const toAdd = firstSelectable && !this.isSelected(firstSelectable) ? [
                firstSelectable
            ] : [];
            this.changeSelection(toAdd, this.cells);
            return;
        }
        const toAdd = cells.filter((cell)=>!this.isSelected(cell) && this.graph.isCellSelectable(cell));
        this.changeSelection(toAdd, null);
    }
    /**
     * Removes the specified {@link Cell} from the selection and fires a {@link InternalEvent.CHANGE} event
     * for the remaining cells.
     *
     * @param cell {@link Cell} to remove from the selection.
     */ removeCell(cell) {
        this.removeCells([
            cell
        ]);
    }
    /**
     * Removes the specified {@link Cell} from the selection and fires a {@link InternalEvent.CHANGE} event
     * for the remaining cells.
     *
     * @param cells {@link Cell}s to remove from the selection.
     */ removeCells(cells) {
        const toRemove = cells.filter((cell)=>this.isSelected(cell));
        this.changeSelection(null, toRemove);
    }
    /**
     * Adds/removes the specified arrays of {@link Cell} to/from the selection.
     *
     * @param added Array of {@link Cell} to add to the selection.
     * @param removed Array of {@link Cell} to remove from the selection.
     */ changeSelection(added = null, removed = null) {
        const toAdd = (added ?? []).filter((cell)=>cell != null);
        const toRemove = (removed ?? []).filter((cell)=>cell != null);
        if (toAdd.length > 0 || toRemove.length > 0) {
            const change = new (0, $cebbd4d2e9a95460$export$2e2bcd8739ae039)(this.graph, toAdd, toRemove);
            change.execute();
            const edit = new (0, $49cf4bffc87379a1$export$2e2bcd8739ae039)(this.graph, false);
            edit.add(change);
            this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).UNDO, {
                edit: edit
            }));
        }
    }
    /**
     * Inner callback to add the specified {@link Cell} to the selection. No event
     * is fired in this implementation.
     *
     * @param cell {@link Cell} to add to the selection.
     */ cellAdded(cell) {
        if (!this.isSelected(cell)) this.cells.push(cell);
    }
    /**
     * Inner callback to remove the specified {@link Cell} from the selection. No
     * event is fired in this implementation.
     *
     * @param cell {@link Cell} to remove from the selection.
     */ cellRemoved(cell) {
        const index = this.cells.indexOf(cell);
        if (index >= 0) this.cells.splice(index, 1);
    }
}
var $e6719d4fe4c26799$export$2e2bcd8739ae039 = $e6719d4fe4c26799$var$GraphSelectionModel;


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 





var $cBHcM = parcelRequire("cBHcM");








/*
Copyright 2021-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 


/**
 * Action to change the current root in a view.
 *
 * @category Change
 */ class $d38739a8c86b74f7$var$CurrentRootChange {
    constructor(view, root){
        this.view = view;
        this.root = root;
        this.previous = root;
        this.isUp = root === null;
        if (!this.isUp) {
            let tmp = this.view.currentRoot;
            while(tmp){
                if (tmp === root) {
                    this.isUp = true;
                    break;
                }
                tmp = tmp.getParent();
            }
        }
    }
    /**
     * Changes the current root of the view.
     */ execute() {
        const tmp = this.view.currentRoot;
        this.view.currentRoot = this.previous;
        this.previous = tmp;
        const translate = this.view.graph.getTranslateForRoot(this.view.currentRoot);
        if (translate) this.view.translate = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(-translate.x, -translate.y);
        if (this.isUp) {
            this.view.clear(this.view.currentRoot, true, true);
            this.view.validate(null);
        } else this.view.refresh();
        const name = this.isUp ? (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).UP : (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).DOWN;
        this.view.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)(name, {
            root: this.view.currentRoot,
            previous: this.previous
        }));
        this.isUp = !this.isUp;
    }
}
var $d38739a8c86b74f7$export$2e2bcd8739ae039 = $d38739a8c86b74f7$var$CurrentRootChange;





/*
Copyright 2025-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
const $f6ffa40f48aaef80$export$e92e39e3fc5b4647 = new (0, $f195b8ee628b1fc3$export$1ae599b19ef421f5)();



var $h5l15 = parcelRequire("h5l15");

class $667abfee930cface$export$6a7fe3ef90e8d566 extends (0, $17f25eceeba97548$export$2e2bcd8739ae039) {
    constructor(graph){
        super();
        // TODO: Document me!
        this.backgroundImage = null;
        this.backgroundPageShape = null;
        this.EMPTY_POINT = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)();
        /**
         * Specifies the resource key for the status message after a long operation.
         * If the resource for this key does not exist then the value is used as
         * the status message.
         * @default 'done'
         */ this.doneResource = (0, $78efedcb0f6c688d$export$ee28232f9313fcdf)() ? 'done' : '';
        /**
         * Specifies the resource key for the status message while the document is
         * being updated. If the resource for this key does not exist then the
         * value is used as the status message.
         * @default 'updatingSelection'
         */ this.updatingDocumentResource = (0, $78efedcb0f6c688d$export$ee28232f9313fcdf)() ? 'updatingDocument' : '';
        /**
         * Specifies if string values in cell styles should be evaluated using {@link eval}.
         *
         * This will only be used if the string values can't be mapped to objects using {@link EdgeStyleRegistry} or  {@link PerimeterRegistry} when resolving {@link CellStateStyle.edgeStyle} and {@link CellStateStyle.perimeter} respectively.
         *
         * **WARNING**: Enabling this switch carries a possible security risk.
         *
         * @default false
         */ this.allowEval = false;
        /**
         * Specifies if a gesture should be captured when it goes outside of the
         * graph container. Default is true.
         */ this.captureDocumentGesture = true;
        /**
         * Specifies if shapes should be created, updated and destroyed using the
         * methods of {@link cellRenderer} in {@link graph}. Default is true.
         */ this.rendering = true;
        /**
         * {@link Cell} that acts as the root of the displayed cell hierarchy.
         */ this.currentRoot = null;
        this.graphBounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)();
        this.scale = 1;
        /**
         * {@link Point} that specifies the current translation. Default is a new
         * empty {@link Point}.
         */ this.translate = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)();
        this.states = new Map();
        /**
         * Specifies if the style should be updated in each validation step. If this
         * is false then the style is only updated if the state is created or if the
         * style of the cell was changed. Default is false.
         */ this.updateStyle = false;
        /**
         * During validation, this contains the last DOM node that was processed.
         */ this.lastNode = null;
        /**
         * During validation, this contains the last HTML DOM node that was processed.
         */ this.lastHtmlNode = null;
        /**
         * During validation, this contains the last edge's DOM node that was processed.
         */ this.lastForegroundNode = null;
        /**
         * During validation, this contains the last edge HTML DOM node that was processed.
         */ this.lastForegroundHtmlNode = null;
        this.endHandler = null;
        this.moveHandler = null;
        this.graph = graph;
    }
    /**
     * Returns {@link graphBounds}.
     */ getGraphBounds() {
        return this.graphBounds;
    }
    /**
     * Sets {@link graphBounds}.
     */ setGraphBounds(value) {
        this.graphBounds = value;
    }
    /**
     * Returns the {@link scale}.
     */ getScale() {
        return this.scale;
    }
    /**
     * Sets the scale and fires a {@link scale} event before calling {@link revalidate} followed
     * by {@link AbstractGraph.sizeDidChange}.
     *
     * @param value Decimal value that specifies the new scale (1 is 100%).
     */ setScale(value) {
        const previousScale = this.scale;
        if (previousScale !== value) {
            this.scale = value;
            if (this.isEventsEnabled()) this.viewStateChanged();
        }
        this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).SCALE, {
            scale: value,
            previousScale: previousScale
        }));
    }
    /**
     * Returns the {@link translate}.
     */ getTranslate() {
        return this.translate;
    }
    isRendering() {
        return this.rendering;
    }
    setRendering(value) {
        this.rendering = value;
    }
    /**
     * Sets the translation and fires a {@link translate} event before calling
     * {@link revalidate} followed by {@link AbstractGraph.sizeDidChange}. The translation is the
     * negative of the origin.
     *
     * @param dx X-coordinate of the translation.
     * @param dy Y-coordinate of the translation.
     */ setTranslate(dx, dy) {
        const previousTranslate = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(this.translate.x, this.translate.y);
        if (this.translate.x !== dx || this.translate.y !== dy) {
            this.translate.x = dx;
            this.translate.y = dy;
            if (this.isEventsEnabled()) this.viewStateChanged();
        }
        this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).TRANSLATE, {
            translate: this.translate,
            previousTranslate: previousTranslate
        }));
    }
    /**
     * Returns {@link allowEval}.
     */ isAllowEval() {
        return this.allowEval;
    }
    /**
     * Sets {@link allowEval}.
     */ setAllowEval(value) {
        this.allowEval = value;
    }
    /**
     * Returns {@link states}.
     */ getStates() {
        return this.states;
    }
    /**
     * Sets {@link states}.
     */ setStates(value) {
        this.states = value;
    }
    /**
     * Returns the DOM node that contains the background-, draw-, overlay- and decorator- panes.
     */ getCanvas() {
        return this.canvas;
    }
    /**
     * Returns the DOM node that represents the background layer.
     */ getBackgroundPane() {
        return this.backgroundPane;
    }
    /**
     * Returns the DOM node that represents the main drawing layer.
     */ getDrawPane() {
        return this.drawPane;
    }
    /**
     * Returns the DOM node that represents the layer above the drawing layer.
     */ getOverlayPane() {
        return this.overlayPane;
    }
    /**
     * Returns the DOM node that represents the topmost drawing layer.
     */ getDecoratorPane() {
        return this.decoratorPane;
    }
    /**
     * Returns the union of all {@link CellState}s for the given array of {@link Cell}.
     *
     * @param cells Array of {@link Cell} whose bounds should be returned.
     */ getBounds(cells) {
        let result = null;
        if (cells.length > 0) {
            for(let i = 0; i < cells.length; i += 1)if (cells[i].isVertex() || cells[i].isEdge()) {
                const state = this.getState(cells[i]);
                if (state) {
                    if (!result) result = (0, $2997c239141ea844$export$2e2bcd8739ae039).fromRectangle(state);
                    else result.add(state);
                }
            }
        }
        return result;
    }
    /**
     * Sets and returns the current root and fires an {@link undo} event before
     * calling {@link AbstractGraph.sizeDidChange}.
     *
     * @param root {@link Cell} that specifies the root of the displayed cell hierarchy.
     */ setCurrentRoot(root) {
        if (this.currentRoot !== root) {
            const change = new (0, $d38739a8c86b74f7$export$2e2bcd8739ae039)(this, root);
            change.execute();
            const edit = new (0, $49cf4bffc87379a1$export$2e2bcd8739ae039)(this, true);
            edit.add(change);
            this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).UNDO, {
                edit: edit
            }));
            this.graph.sizeDidChange();
            this.currentRoot = root;
        }
        return root;
    }
    /**
     * Sets the scale and translation and fires a {@link scale} and {@link translate} event
     * before calling {@link revalidate} followed by {@link AbstractGraph.sizeDidChange}.
     *
     * @param scale Decimal value that specifies the new scale (1 is 100%).
     * @param dx X-coordinate of the translation.
     * @param dy Y-coordinate of the translation.
     */ scaleAndTranslate(scale, dx, dy) {
        const previousScale = this.scale;
        const previousTranslate = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(this.translate.x, this.translate.y);
        if (this.scale !== scale || this.translate.x !== dx || this.translate.y !== dy) {
            this.scale = scale;
            this.translate.x = dx;
            this.translate.y = dy;
            if (this.isEventsEnabled()) this.viewStateChanged();
        }
        this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).SCALE_AND_TRANSLATE, {
            scale: scale,
            previousScale: previousScale,
            translate: this.translate,
            previousTranslate: previousTranslate
        }));
    }
    /**
     * Invoked after {@link scale} and/or {@link translate} has changed.
     */ viewStateChanged() {
        this.revalidate();
        this.graph.sizeDidChange();
    }
    /**
     * Clears the view if {@link currentRoot} is not null and revalidates.
     */ refresh() {
        if (this.currentRoot) this.clear();
        this.revalidate();
    }
    /**
     * Revalidates the complete view with all cell states.
     */ revalidate() {
        this.invalidate();
        this.validate();
    }
    /**
     * Removes the state of the given cell and all descendants if the given cell is not the current root.
     *
     * @param cell Optional {@link Cell} for which the state should be removed. Default is the root of the model.
     * @param force Optional boolean indicating if the current root should be ignored for recursion. Default is `false`.
     * @param recurse Optional boolean indicating if the descendants should be cleared as well. Default is `true`.
     */ clear(cell, force = false, recurse = true) {
        if (!cell) cell = this.graph.getDataModel().getRoot();
        if (cell) {
            this.removeState(cell);
            if (recurse && (force || cell !== this.currentRoot)) {
                const childCount = cell.getChildCount();
                for(let i = 0; i < childCount; i += 1)this.clear(cell.getChildAt(i), force);
            } else this.invalidate(cell);
        }
    }
    /**
     * Invalidates the state of the given cell, all its descendants and
     * connected edges.
     *
     * @param cell Optional {@link Cell} to be invalidated. Default is the root of the
     * model.
     */ invalidate(cell = null, recurse = true, includeEdges = true) {
        const model = this.graph.getDataModel();
        cell = cell ?? model.getRoot();
        if (cell) {
            const state = this.getState(cell);
            if (state) state.invalid = true;
            // Avoids infinite loops for invalid graphs
            if (!cell.invalidating) {
                cell.invalidating = true;
                // Recursively invalidates all descendants
                if (recurse) {
                    const childCount = cell.getChildCount();
                    for(let i = 0; i < childCount; i += 1){
                        const child = cell.getChildAt(i);
                        this.invalidate(child, recurse, includeEdges);
                    }
                }
                // Propagates invalidation to all connected edges
                if (includeEdges) {
                    const edgeCount = cell.getEdgeCount();
                    for(let i = 0; i < edgeCount; i += 1)this.invalidate(cell.getEdgeAt(i), recurse, includeEdges);
                }
                cell.invalidating = false;
            }
        }
    }
    /**
     * Calls {@link validateCell} and {@link validateCellState} and updates the {@link graphBounds}
     * using {@link getBoundingBox}. Finally, the background is validated using
     * {@link validateBackground}.
     *
     * @param cell Optional {@link Cell} to be used as the root of the validation.
     * Default is {@link currentRoot} or the root of the model.
     */ validate(cell = null) {
        const t0 = (0, $h5l15.log)().enter('GraphView.validate');
        this.resetValidationState();
        const c = cell || (this.currentRoot ?? this.graph.getDataModel().getRoot());
        if (c) {
            const graphBounds = this.getBoundingBox(this.validateCellState(c ? this.validateCell(c) : null));
            this.setGraphBounds(graphBounds ?? this.getEmptyBounds());
            this.validateBackground();
            this.resetValidationState();
        }
        (0, $h5l15.log)().leave('GraphView.validate', t0);
    }
    /**
     * Returns the bounds for an empty graph. This returns a rectangle at
     * {@link translate} with the size of 0 x 0.
     */ getEmptyBounds() {
        return new (0, $2997c239141ea844$export$2e2bcd8739ae039)(this.translate.x * this.scale, this.translate.y * this.scale);
    }
    /**
     * Returns the bounding box of the shape and the label for the given
     * {@link CellState} and its children if recurse is true.
     *
     * @param state {@link CellState} whose bounding box should be returned.
     * @param recurse Optional boolean indicating if the children should be included.
     * Default is true.
     */ getBoundingBox(state = null, recurse = true) {
        let bbox = null;
        if (state) {
            if (state.shape && state.shape.boundingBox) bbox = state.shape.boundingBox.clone();
            // Adds label bounding box to graph bounds
            if (state.text && state.text.boundingBox) {
                if (bbox) bbox.add(state.text.boundingBox);
                else bbox = state.text.boundingBox.clone();
            }
            if (recurse) {
                const childCount = state.cell.getChildCount();
                for(let i = 0; i < childCount; i += 1){
                    const bounds = this.getBoundingBox(this.getState(state.cell.getChildAt(i)));
                    if (bounds) {
                        if (!bbox) bbox = bounds;
                        else bbox.add(bounds);
                    }
                }
            }
        }
        return bbox;
    }
    /**
     * Creates and returns the shape used as the background page.
     *
     * @param bounds {@link Rectangle} that represents the bounds of the shape.
     */ createBackgroundPageShape(bounds) {
        return new (0, $14ee9ba473f8b778$export$2e2bcd8739ae039)(bounds, 'white', 'black');
    }
    /**
     * Calls {@link validateBackgroundImage} and {@link validateBackgroundPage}.
     */ validateBackground() {
        this.validateBackgroundImage();
        this.validateBackgroundPage();
    }
    /**
     * Validates the background image.
     */ validateBackgroundImage() {
        const bg = this.graph.getBackgroundImage();
        if (bg) {
            if (!this.backgroundImage || this.backgroundImage.imageSrc !== bg.src) {
                if (this.backgroundImage) this.backgroundImage.destroy();
                const bounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(0, 0, 1, 1);
                this.backgroundImage = new (0, $48f65d6d4849e478$export$2e2bcd8739ae039)(bounds, bg.src);
                this.backgroundImage.dialect = this.graph.dialect;
                this.backgroundImage.init(this.backgroundPane);
                this.backgroundImage.redraw();
            }
            this.redrawBackgroundImage(this.backgroundImage, bg);
        } else if (this.backgroundImage) {
            this.backgroundImage.destroy();
            this.backgroundImage = null;
        }
    }
    /**
     * Validates the background page.
     */ validateBackgroundPage() {
        const graph = this.graph;
        if (graph.pageVisible) {
            const bounds = this.getBackgroundPageBounds();
            if (this.backgroundPageShape == null) {
                this.backgroundPageShape = this.createBackgroundPageShape(bounds);
                this.backgroundPageShape.scale = this.scale;
                this.backgroundPageShape.isShadow = true;
                this.backgroundPageShape.dialect = this.graph.dialect;
                this.backgroundPageShape.init(this.backgroundPane);
                this.backgroundPageShape.redraw();
                if (this.backgroundPageShape.node) {
                    // Adds listener for double click handling on background
                    if (graph.isNativeDblClickEnabled()) (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addListener(this.backgroundPageShape.node, 'dblclick', (evt)=>{
                        graph.dblClick(evt);
                    });
                    // Adds basic listeners for graph event dispatching outside the
                    // container and finishing the handling of a single gesture
                    (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addGestureListeners(this.backgroundPageShape.node, (evt)=>{
                        graph.fireMouseEvent((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_DOWN, new (0, $2051fd5f8fd06bc7$export$2e2bcd8739ae039)(evt));
                    }, (evt)=>{
                        const tooltipHandler = graph.getPlugin('TooltipHandler');
                        // Hides the tooltip if mouse is outside container
                        if (tooltipHandler && tooltipHandler.isHideOnHover()) tooltipHandler.hide();
                        if (graph.isMouseDown && !(0, $f192e93a2fd1153c$export$f6e93dab47d340de)(evt)) graph.fireMouseEvent((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_MOVE, new (0, $2051fd5f8fd06bc7$export$2e2bcd8739ae039)(evt));
                    }, (evt)=>{
                        graph.fireMouseEvent((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_UP, new (0, $2051fd5f8fd06bc7$export$2e2bcd8739ae039)(evt));
                    });
                }
            } else {
                this.backgroundPageShape.scale = this.scale;
                this.backgroundPageShape.bounds = bounds;
                this.backgroundPageShape.redraw();
            }
        } else if (this.backgroundPageShape) {
            this.backgroundPageShape.destroy();
            this.backgroundPageShape = null;
        }
    }
    /**
     * Returns the bounds for the background page.
     */ getBackgroundPageBounds() {
        const fmt = this.graph.pageFormat;
        const ps = this.scale * this.graph.pageScale;
        return new (0, $2997c239141ea844$export$2e2bcd8739ae039)(this.scale * this.translate.x, this.scale * this.translate.y, fmt.width * ps, fmt.height * ps);
    }
    /**
     * Updates the bounds and redraws the background image.
     *
     * Example:
     *
     * If the background image should not be scaled, this can be replaced with
     * the following.
     *
     * @example
     * ```javascript
     * redrawBackground(backgroundImage, bg)
     * {
     *   backgroundImage.bounds.x = this.translate.x;
     *   backgroundImage.bounds.y = this.translate.y;
     *   backgroundImage.bounds.width = bg.width;
     *   backgroundImage.bounds.height = bg.height;
     *
     *   backgroundImage.redraw();
     * };
     * ```
     *
     * @param backgroundImage {@link ImageShape} that represents the background image.
     * @param bg {@link Image} that specifies the image and its dimensions.
     */ redrawBackgroundImage(backgroundImage, bg) {
        backgroundImage.scale = this.scale;
        if (backgroundImage.bounds) {
            const bounds = backgroundImage.bounds;
            bounds.x = this.scale * this.translate.x;
            bounds.y = this.scale * this.translate.y;
            bounds.width = this.scale * bg.width;
            bounds.height = this.scale * bg.height;
        }
        backgroundImage.redraw();
    }
    /**
     * Recursively creates the cell state for the given cell if visible is true and
     * the given cell is visible. If the cell is not visible but the state exists
     * then it is removed using {@link removeState}.
     *
     * @param cell {@link Cell} whose {@link CellState} should be created.
     * @param visible Optional boolean indicating if the cell should be visible. Default
     * is true.
     */ validateCell(cell, visible = true) {
        visible = visible && cell.isVisible();
        const state = this.getState(cell, visible);
        if (state && !visible) this.removeState(cell);
        else {
            const childCount = cell.getChildCount();
            for(let i = 0; i < childCount; i += 1)this.validateCell(cell.getChildAt(i), visible && (!cell.isCollapsed() || cell === this.currentRoot));
        }
        return cell;
    }
    /**
     * Validates and repaints the {@link CellState} for the given {@link Cell}.
     *
     * @param cell {@link Cell} whose {@link CellState} should be validated.
     * @param recurse Optional boolean indicating if the children of the cell should be
     * validated. Default is true.
     */ validateCellState(cell, recurse = true) {
        let state = null;
        if (cell) {
            state = this.getState(cell);
            if (state) {
                if (state.invalid) {
                    state.invalid = false;
                    if (!state.style || state.invalidStyle) {
                        state.style = this.graph.getCellStyle(state.cell);
                        state.invalidStyle = false;
                    }
                    if (cell !== this.currentRoot) this.validateCellState(cell.getParent(), false);
                    state.setVisibleTerminalState(this.validateCellState(this.getVisibleTerminal(cell, true), false), true);
                    state.setVisibleTerminalState(this.validateCellState(this.getVisibleTerminal(cell, false), false), false);
                    this.updateCellState(state);
                    // Repaint happens immediately after the cell is validated
                    if (cell !== this.currentRoot && !state.invalid) {
                        this.graph.cellRenderer.redraw(state, false, this.isRendering());
                        // Handles changes to vertex paint bounds after update of rendering shape
                        state.updateCachedBounds();
                    }
                }
                if (recurse && !state.invalid) {
                    // Updates order in DOM if recursively traversing
                    if (state.shape) this.stateValidated(state);
                    const childCount = cell.getChildCount();
                    for(let i = 0; i < childCount; i += 1)this.validateCellState(cell.getChildAt(i));
                }
            }
        }
        return state;
    }
    /**
     * Updates the given {@link CellState}.
     *
     * @param state {@link CellState} to be updated.
     */ updateCellState(state) {
        const absoluteOffset = state.absoluteOffset;
        const origin = state.origin;
        absoluteOffset.x = 0;
        absoluteOffset.y = 0;
        origin.x = 0;
        origin.y = 0;
        state.length = 0;
        if (state.cell !== this.currentRoot) {
            const parent = state.cell.getParent();
            const pState = parent ? this.getState(parent) : null;
            if (pState && pState.cell !== this.currentRoot) {
                origin.x += pState.origin.x;
                origin.y += pState.origin.y;
            }
            let offset = this.graph.getChildOffsetForCell(state.cell);
            if (offset) {
                origin.x += offset.x;
                origin.y += offset.y;
            }
            const geo = state.cell.getGeometry();
            if (geo) {
                if (!state.cell.isEdge()) {
                    offset = geo.offset ? geo.offset : this.EMPTY_POINT;
                    if (geo.relative && pState) {
                        if (pState.cell.isEdge()) {
                            const point = this.getPoint(pState, geo);
                            if (point) {
                                origin.x += point.x / this.scale - pState.origin.x - this.translate.x;
                                origin.y += point.y / this.scale - pState.origin.y - this.translate.y;
                            }
                        } else {
                            origin.x += geo.x * pState.unscaledWidth + offset.x;
                            origin.y += geo.y * pState.unscaledHeight + offset.y;
                        }
                    } else {
                        absoluteOffset.x = this.scale * offset.x;
                        absoluteOffset.y = this.scale * offset.y;
                        origin.x += geo.x;
                        origin.y += geo.y;
                    }
                }
                state.x = this.scale * (this.translate.x + origin.x);
                state.y = this.scale * (this.translate.y + origin.y);
                state.width = this.scale * geo.width;
                state.unscaledWidth = geo.width;
                state.height = this.scale * geo.height;
                state.unscaledHeight = geo.height;
                if (state.cell.isVertex()) this.updateVertexState(state, geo);
                if (state.cell.isEdge()) this.updateEdgeState(state, geo);
            }
        }
        state.updateCachedBounds();
    }
    /**
     * Validates the given cell state.
     */ updateVertexState(state, geo) {
        const parent = state.cell.getParent();
        const pState = parent ? this.getState(parent) : null;
        if (geo.relative && pState && !pState.cell.isEdge()) {
            const alpha = (0, $f7ff90b8964488a6$export$cba01ba138429a1d)(pState.style.rotation ?? 0);
            if (alpha !== 0) {
                const cos = Math.cos(alpha);
                const sin = Math.sin(alpha);
                const ct = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(state.getCenterX(), state.getCenterY());
                const cx = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(pState.getCenterX(), pState.getCenterY());
                const pt = (0, $f7ff90b8964488a6$export$ad2a0af3fbffd7c1)(ct, cos, sin, cx);
                state.x = pt.x - state.width / 2;
                state.y = pt.y - state.height / 2;
            }
        }
        this.updateVertexLabelOffset(state);
    }
    /**
     * Validates the given cell state.
     */ updateEdgeState(state, geo) {
        const source = state.getVisibleTerminalState(true);
        const target = state.getVisibleTerminalState(false);
        // This will remove edges with no terminals and no terminal points
        // as such edges are invalid and produce NPEs in the edge styles.
        // Also removes connected edges that have no visible terminals.
        if (state.cell.getTerminal(true) && !source || !source && !geo.getTerminalPoint(true) || state.cell.getTerminal(false) && !target || !target && !geo.getTerminalPoint(false)) this.clear(state.cell, true);
        else {
            this.updateFixedTerminalPoints(state, source, target);
            this.updatePoints(state, geo.points, source, target);
            this.updateFloatingTerminalPoints(state, source, target);
            const pts = state.absolutePoints;
            if (state.cell !== this.currentRoot && (pts == null || pts.length < 2 || pts[0] == null || pts[pts.length - 1] == null)) // This will remove edges with invalid points from the list of states in the view.
            // Happens if the one of the terminals and the corresponding terminal point is null.
            this.clear(state.cell, true);
            else {
                this.updateEdgeBounds(state);
                this.updateEdgeLabelOffset(state);
            }
        }
    }
    /**
     * Updates the absoluteOffset of the given vertex cell state. This takes
     * into account the label position styles.
     *
     * @param state {@link CellState} whose absolute offset should be updated.
     */ updateVertexLabelOffset(state) {
        const h = state.style.labelPosition ?? 'center';
        switch(h){
            case 'left':
                {
                    let lw = state.style.labelWidth ?? null;
                    if (lw != null) lw *= this.scale;
                    else lw = state.width;
                    // @ts-ignore
                    state.absoluteOffset.x -= lw;
                    break;
                }
            case 'right':
                // @ts-ignore
                state.absoluteOffset.x += state.width;
                break;
            case 'center':
                {
                    const lw = state.style.labelWidth ?? null;
                    if (lw != null) {
                        // Aligns text block with given width inside the vertex width
                        const align = state.style.align ?? 'center';
                        let dx = 0;
                        if (align === 'center') dx = 0.5;
                        else if (align === 'right') dx = 1;
                        if (dx !== 0) // @ts-ignore
                        state.absoluteOffset.x -= (lw * this.scale - state.width) * dx;
                    }
                    break;
                }
        }
        const v = state.style.verticalLabelPosition ?? 'middle';
        if (v === 'top') // @ts-ignore
        state.absoluteOffset.y -= state.height;
        else if (v === 'bottom') // @ts-ignore
        state.absoluteOffset.y += state.height;
    }
    /**
     * Resets the current validation state.
     */ resetValidationState() {
        this.lastNode = null;
        this.lastHtmlNode = null;
        this.lastForegroundNode = null;
        this.lastForegroundHtmlNode = null;
    }
    /**
     * Invoked when a state has been processed in {@link validatePoints}. This is used
     * to update the order of the DOM nodes of the shape.
     *
     * @param state {@link CellState} that represents the cell state.
     */ stateValidated(state) {
        const graph = this.graph;
        const fg = state.cell.isEdge() && graph.keepEdgesInForeground || state.cell.isVertex() && graph.keepEdgesInBackground;
        const htmlNode = fg ? this.lastForegroundHtmlNode || this.lastHtmlNode : this.lastHtmlNode;
        const node = fg ? this.lastForegroundNode || this.lastNode : this.lastNode;
        const result = graph.cellRenderer.insertStateAfter(state, node, htmlNode);
        if (fg) {
            this.lastForegroundHtmlNode = result[1];
            this.lastForegroundNode = result[0];
        } else {
            this.lastHtmlNode = result[1];
            this.lastNode = result[0];
        }
    }
    /**
     * Sets the initial absolute terminal points in the given state before the edge
     * style is computed.
     *
     * @param edge {@link CellState} whose initial terminal points should be updated.
     * @param source {@link CellState} which represents the source terminal.
     * @param target {@link CellState} which represents the target terminal.
     */ updateFixedTerminalPoints(edge, source, target) {
        this.updateFixedTerminalPoint(edge, source, true, this.graph.getConnectionConstraint(edge, source, true));
        this.updateFixedTerminalPoint(edge, target, false, this.graph.getConnectionConstraint(edge, target, false));
    }
    /**
     * Sets the fixed source or target terminal point on the given edge.
     *
     * @param edge {@link CellState} whose terminal point should be updated.
     * @param terminal {@link CellState} which represents the actual terminal.
     * @param source Boolean that specifies if the terminal is the source.
     * @param constraint {@link ConnectionConstraint} that specifies the connection.
     */ updateFixedTerminalPoint(edge, terminal, source, constraint) {
        edge.setAbsoluteTerminalPoint(this.getFixedTerminalPoint(edge, terminal, source, constraint), source);
    }
    /**
     * Returns the fixed source or target terminal point for the given edge.
     *
     * @param edge {@link CellState} whose terminal point should be returned.
     * @param terminal {@link CellState} which represents the actual terminal.
     * @param source Boolean that specifies if the terminal is the source.
     * @param constraint {@link ConnectionConstraint} that specifies the connection.
     */ getFixedTerminalPoint(edge, terminal, source, constraint) {
        let pt = null;
        if (constraint && terminal) pt = this.graph.getConnectionPoint(terminal, constraint, false); // FIXME Rounding introduced bugs when calculating label positions -> , this.graph.isOrthogonal(edge));
        if (!pt && !terminal) {
            const s = this.scale;
            const tr = this.translate;
            const orig = edge.origin;
            const geo = edge.cell.getGeometry();
            pt = geo.getTerminalPoint(source);
            if (pt) pt = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(s * (tr.x + pt.x + orig.x), s * (tr.y + pt.y + orig.y));
        }
        return pt;
    }
    /**
     * Updates the bounds of the given cell state to reflect the bounds of the stencil
     * if it has a fixed aspect and returns the previous bounds as an {@link Rectangle} if
     * the bounds have been modified or null otherwise.
     *
     * @param state {@link CellState} whose bounds should be updated.
     */ updateBoundsFromStencil(state) {
        let previous = null;
        if (state && state.shape && state.shape.stencil && state.shape.stencil.aspect === 'fixed') {
            previous = (0, $2997c239141ea844$export$2e2bcd8739ae039).fromRectangle(state);
            const asp = state.shape.stencil.computeAspect(null, state.x, state.y, state.width, state.height);
            state.setRect(asp.x, asp.y, state.shape.stencil.w0 * asp.width, state.shape.stencil.h0 * asp.height);
        }
        return previous;
    }
    /**
     * Updates the absolute points in the given state using the specified array
     * of {@link Point} as the relative points.
     *
     * @param edge {@link CellState} whose absolute points should be updated.
     * @param points Array of {@link Point} that constitute the relative points.
     * @param source {@link CellState} that represents the source terminal.
     * @param target {@link CellState} that represents the target terminal.
     */ updatePoints(edge, points, source, target) {
        const pts = [];
        pts.push(edge.absolutePoints[0]);
        const edgeStyle = this.getEdgeStyle(edge, points, source, target);
        if (edgeStyle && source) {
            // target can be null
            const src = this.getTerminalPort(edge, source, true);
            const trg = target ? this.getTerminalPort(edge, target, false) : null;
            // Uses the stencil bounds for routing and restores after routing
            const srcBounds = this.updateBoundsFromStencil(src);
            const trgBounds = this.updateBoundsFromStencil(trg);
            edgeStyle(edge, src, trg, points, pts);
            // Restores previous bounds
            if (src && srcBounds) src.setRect(srcBounds.x, srcBounds.y, srcBounds.width, srcBounds.height);
            if (trg && trgBounds) trg.setRect(trgBounds.x, trgBounds.y, trgBounds.width, trgBounds.height);
        } else if (points) {
            for(let i = 0; i < points.length; i += 1)if (points[i]) {
                const pt = (0, $a200c5dda16aedca$export$9cd59f9826255e47)(points[i]);
                pts.push(this.transformControlPoint(edge, pt));
            }
        }
        const tmp = edge.absolutePoints;
        pts.push(tmp[tmp.length - 1]);
        edge.absolutePoints = pts;
    }
    /**
     * Transforms the given control point to an absolute point.
     */ transformControlPoint(state, pt, ignoreScale = false) {
        if (state && pt) {
            const orig = state.origin;
            const scale = ignoreScale ? 1 : this.scale;
            return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(scale * (pt.x + this.translate.x + orig.x), scale * (pt.y + this.translate.y + orig.y));
        }
        return null;
    }
    /**
     * Returns `true` if the given edge should be routed with {@link AbstractGraph.defaultLoopStyle}
     * or the {@link CellStateStyle.orthogonalLoop} defined for the given edge.
     * This implementation returns `true` if the given edge is a loop and does not
     */ isLoopStyleEnabled(edge, points = [], source = null, target = null) {
        const sc = this.graph.getConnectionConstraint(edge, source, true);
        const tc = this.graph.getConnectionConstraint(edge, target, false);
        if ((points == null || points.length < 2) && !((edge.style.orthogonalLoop ?? false) || (sc == null || sc.point == null) && (tc == null || tc.point == null))) return source != null && source === target;
        return false;
    }
    /**
     * Returns the edge style function to be used to render the given edge state.
     */ getEdgeStyle(edge, points = [], source = null, target = null) {
        let edgeStyle = this.isLoopStyleEnabled(edge, points, source, target) ? edge.style.loopStyle ?? this.graph.defaultLoopStyle : !(edge.style.noEdgeStyle ?? false) ? edge.style.edgeStyle : null;
        // Converts string values to objects
        if (typeof edgeStyle === 'string') {
            let tmp = (0, $130af394a0fcdee4$export$28d1530539966ca9).get(edgeStyle);
            if (!tmp && this.isAllowEval()) tmp = (0, $h5l15.doEval)(edgeStyle);
            edgeStyle = tmp;
        }
        if (typeof edgeStyle === 'function') return edgeStyle;
        return null;
    }
    /**
     * Updates the terminal points in the given state after the edge style was
     * computed for the edge.
     *
     * @param state {@link CellState} whose terminal points should be updated.
     * @param source {@link CellState} that represents the source terminal.
     * @param target {@link CellState} that represents the target terminal.
     */ updateFloatingTerminalPoints(state, source, target) {
        const pts = state.absolutePoints;
        const p0 = pts[0];
        const pe = pts[pts.length - 1];
        if (!pe && target) this.updateFloatingTerminalPoint(state, target, source, false);
        if (!p0 && source) this.updateFloatingTerminalPoint(state, source, target, true);
    }
    /**
     * Updates the absolute terminal point in the given state for the given
     * start and end state, where start is the source if source is true.
     *
     * @param edge {@link CellState} whose terminal point should be updated.
     * @param start {@link CellState} for the terminal on "this" side of the edge.
     * @param end {@link CellState} for the terminal on the other side of the edge.
     * @param source Boolean indicating if start is the source terminal state.
     */ updateFloatingTerminalPoint(edge, start, end, source) {
        edge.setAbsoluteTerminalPoint(this.getFloatingTerminalPoint(edge, start, end, source), source);
    }
    /**
     * Returns the floating terminal point for the given edge, start and end
     * state, where start is the source if source is true.
     *
     * @param edge {@link CellState} whose terminal point should be returned.
     * @param start {@link CellState} for the terminal on "this" side of the edge.
     * @param end {@link CellState} for the terminal on the other side of the edge.
     * @param source Boolean indicating if start is the source terminal state.
     */ getFloatingTerminalPoint(edge, start, end, source) {
        start = this.getTerminalPort(edge, start, source);
        let next = this.getNextPoint(edge, end, source);
        const orth = this.graph.isOrthogonal(edge);
        const alpha = (0, $f7ff90b8964488a6$export$cba01ba138429a1d)(start.style.rotation ?? 0);
        const center = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(start.getCenterX(), start.getCenterY());
        if (alpha !== 0) {
            const cos = Math.cos(-alpha);
            const sin = Math.sin(-alpha);
            next = (0, $f7ff90b8964488a6$export$ad2a0af3fbffd7c1)(next, cos, sin, center);
        }
        let border = edge.style.perimeterSpacing ?? 0;
        border += edge.style[source ? 'sourcePerimeterSpacing' : 'targetPerimeterSpacing'] ?? 0;
        let pt = this.getPerimeterPoint(start, next, alpha === 0 && orth, border);
        if (pt && alpha !== 0) {
            const cos = Math.cos(alpha);
            const sin = Math.sin(alpha);
            pt = (0, $f7ff90b8964488a6$export$ad2a0af3fbffd7c1)(pt, cos, sin, center);
        }
        return pt;
    }
    /**
     * Returns an {@link CellState} that represents the source or target terminal or
     * port for the given edge.
     *
     * @param state {@link CellState} that represents the state of the edge.
     * @param terminal {@link CellState} that represents the terminal.
     * @param source Boolean indicating if the given terminal is the source terminal.
     */ getTerminalPort(state, terminal, source = false) {
        const key = source ? 'sourcePort' : 'targetPort';
        const id = state.style[key];
        if (id) {
            const cell = this.graph.getDataModel().getCell(id);
            if (cell) {
                const tmp = this.getState(cell, false);
                // Only uses ports where a cell state exists
                if (tmp) terminal = tmp;
            }
        }
        return terminal;
    }
    /**
     * Returns an {@link Point} that defines the location of the intersection point between
     * the perimeter and the line between the center of the shape and the given point.
     *
     * @param terminal {@link CellState} for the source or target terminal.
     * @param next {@link Point} that lies outside the given terminal.
     * @param orthogonal Boolean that specifies if the orthogonal projection onto
     * the perimeter should be returned. If this is false then the intersection
     * of the perimeter and the line between the next and the center point is
     * returned.
     * @param border Optional border between the perimeter and the shape.
     */ getPerimeterPoint(terminal, next, orthogonal, border = 0) {
        let point = null;
        if (terminal != null) {
            const perimeter = this.getPerimeterFunction(terminal);
            if (perimeter != null && next != null) {
                const bounds = this.getPerimeterBounds(terminal, border);
                if (bounds.width > 0 || bounds.height > 0) {
                    point = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(next.x, next.y);
                    let flipH = false;
                    let flipV = false;
                    if (terminal.cell.isVertex()) {
                        flipH = !!terminal.style.flipH;
                        flipV = !!terminal.style.flipV;
                        if (flipH) point.x = 2 * bounds.getCenterX() - point.x;
                        if (flipV) point.y = 2 * bounds.getCenterY() - point.y;
                    }
                    point = perimeter(bounds, terminal, point, orthogonal);
                    if (point != null) {
                        if (flipH) point.x = 2 * bounds.getCenterX() - point.x;
                        if (flipV) point.y = 2 * bounds.getCenterY() - point.y;
                    }
                }
            }
            if (point == null) point = this.getPoint(terminal);
        }
        return point;
    }
    /**
     * Returns the x-coordinate of the center point for automatic routing.
     */ getRoutingCenterX(state) {
        const f = state.style ? state.style.routingCenterX ?? 0 : 0;
        return state.getCenterX() + f * state.width;
    }
    /**
     * Returns the y-coordinate of the center point for automatic routing.
     */ getRoutingCenterY(state) {
        const f = state.style ? state.style.routingCenterY ?? 0 : 0;
        return state.getCenterY() + f * state.height;
    }
    /**
     * Returns the perimeter bounds for the given terminal, edge pair as an
     * {@link Rectangle}.
     *
     * If you have a model where each terminal has a relative child that should
     * act as the graphical endpoint for a connection from/to the terminal, then
     * this method can be replaced as follows:
     *
     * @example
     * ```javascript
     * var oldGetPerimeterBounds = getPerimeterBounds;
     * getPerimeterBounds(terminal, edge, isSource)
     * {
     *   var model = this.graph.getDataModel();
     *   var childCount = model.getChildCount(terminal.cell);
     *
     *   if (childCount > 0)
     *   {
     *     var child = model.getChildAt(terminal.cell, 0);
     *     var geo = model.getGeometry(child);
     *
     *     if (geo != null &&
     *         geo.relative)
     *     {
     *       var state = this.getState(child);
     *
     *       if (state != null)
     *       {
     *         terminal = state;
     *       }
     *     }
     *   }
     *
     *   return oldGetPerimeterBounds.apply(this, arguments);
     * };
     * ```
     *
     * @param terminal CellState that represents the terminal.
     * @param border Number that adds a border between the shape and the perimeter.
     */ getPerimeterBounds(terminal, border = 0) {
        border += terminal.style.perimeterSpacing ?? 0;
        return terminal.getPerimeterBounds(border * this.scale);
    }
    /**
     * Returns the perimeter function for the given state.
     */ getPerimeterFunction(state) {
        let perimeter = state.style.perimeter;
        // Converts string values to objects
        if (typeof perimeter === 'string') {
            let tmp = (0, $f6ffa40f48aaef80$export$e92e39e3fc5b4647).get(perimeter);
            if (tmp == null && this.isAllowEval()) tmp = (0, $h5l15.doEval)(perimeter);
            perimeter = tmp;
        }
        if (typeof perimeter === 'function') return perimeter;
        return null;
    }
    /**
     * Returns the nearest point in the list of absolute points or the center
     * of the opposite terminal.
     *
     * @param edge {@link CellState} that represents the edge.
     * @param opposite {@link CellState} that represents the opposite terminal.
     * @param source Boolean indicating if the next point for the source or target
     * should be returned.
     */ getNextPoint(edge, opposite, source = false) {
        const pts = edge.absolutePoints;
        let point = null;
        if (pts.length >= 2) {
            const count = pts.length;
            point = pts[source ? Math.min(1, count - 1) : Math.max(0, count - 2)];
        }
        if (!point && opposite) point = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(opposite.getCenterX(), opposite.getCenterY());
        return point; // shouldn't return null, but really?
    }
    /**
     * Returns the nearest ancestor terminal that is visible. The edge appears
     * to be connected to this terminal on the display. The result of this method
     * is cached in {@link CellState.getVisibleTerminalState}.
     *
     * @param edge {@link Cell} whose visible terminal should be returned.
     * @param source Boolean that specifies if the source or target terminal
     * should be returned.
     */ getVisibleTerminal(edge, source) {
        const model = this.graph.getDataModel();
        let result = edge.getTerminal(source);
        let best = result;
        while(result && result !== this.currentRoot){
            if (best && !best.isVisible() || result.isCollapsed()) best = result;
            result = result.getParent();
        }
        // Checks if the result is valid for the current view state
        if (best && (!model.contains(best) || best.getParent() === model.getRoot() || best === this.currentRoot)) best = null;
        return best;
    }
    /**
     * Updates the given state using the bounding box of the absolute points.
     * Also updates {@link CellState.terminalDistance}, {@link CellState.length} and
     * {@link CellState.segments}.
     *
     * @param state {@link CellState} whose bounds should be updated.
     */ updateEdgeBounds(state) {
        const points = state.absolutePoints;
        const p0 = points[0];
        const pe = points[points.length - 1];
        if (p0 && pe && (p0.x !== pe.x || p0.y !== pe.y)) {
            const dx = pe.x - p0.x;
            const dy = pe.y - p0.y;
            state.terminalDistance = Math.sqrt(dx * dx + dy * dy);
        } else state.terminalDistance = 0;
        let length = 0;
        const segments = [];
        let pt = p0;
        if (pt) {
            let minX = pt.x;
            let minY = pt.y;
            let maxX = minX;
            let maxY = minY;
            for(let i = 1; i < points.length; i += 1){
                const tmp = points[i];
                if (tmp) {
                    const dx = pt.x - tmp.x;
                    const dy = pt.y - tmp.y;
                    const segment = Math.sqrt(dx * dx + dy * dy);
                    segments.push(segment);
                    length += segment;
                    pt = tmp;
                    minX = Math.min(pt.x, minX);
                    minY = Math.min(pt.y, minY);
                    maxX = Math.max(pt.x, maxX);
                    maxY = Math.max(pt.y, maxY);
                }
            }
            state.length = length;
            state.segments = segments;
            const markerSize = 1; // TODO: include marker size
            state.x = minX;
            state.y = minY;
            state.width = Math.max(markerSize, maxX - minX);
            state.height = Math.max(markerSize, maxY - minY);
        }
    }
    /**
     * Returns the absolute point on the edge for the given relative
     * {@link Geometry} as an {@link Point}. The edge is represented by the given
     * {@link CellState}.
     *
     * @param state {@link CellState} that represents the state of the parent edge.
     * @param geometry {@link Geometry} that represents the relative location.
     */ getPoint(state, geometry = null) {
        let x = state.getCenterX();
        let y = state.getCenterY();
        if (state.segments != null && (geometry == null || geometry.relative)) {
            const gx = geometry != null ? geometry.x / 2 : 0;
            const pointCount = state.absolutePoints.length;
            const dist = Math.round((gx + 0.5) * state.length);
            let segment = state.segments[0];
            let length = 0;
            let index = 1;
            while(dist >= Math.round(length + segment) && index < pointCount - 1){
                length += segment;
                segment = state.segments[index++];
            }
            const factor = segment === 0 ? 0 : (dist - length) / segment;
            const p0 = state.absolutePoints[index - 1];
            const pe = state.absolutePoints[index];
            if (p0 != null && pe != null) {
                let gy = 0;
                let offsetX = 0;
                let offsetY = 0;
                if (geometry != null) {
                    gy = geometry.y;
                    const { offset: offset } = geometry;
                    if (offset != null) {
                        offsetX = offset.x;
                        offsetY = offset.y;
                    }
                }
                const dx = pe.x - p0.x;
                const dy = pe.y - p0.y;
                const nx = segment === 0 ? 0 : dy / segment;
                const ny = segment === 0 ? 0 : dx / segment;
                x = p0.x + dx * factor + (nx * gy + offsetX) * this.scale;
                y = p0.y + dy * factor - (ny * gy - offsetY) * this.scale;
            }
        } else if (geometry != null) {
            const { offset: offset } = geometry;
            if (offset != null) {
                x += offset.x;
                y += offset.y;
            }
        }
        return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y);
    }
    /**
     * Gets the relative point that describes the given, absolute label
     * position for the given edge state.
     *
     * @param edgeState {@link CellState} that represents the state of the parent edge.
     * @param x Specifies the x-coordinate of the absolute label location.
     * @param y Specifies the y-coordinate of the absolute label location.
     */ getRelativePoint(edgeState, x, y) {
        const geometry = edgeState.cell.getGeometry();
        if (geometry) {
            const absolutePoints = edgeState.absolutePoints;
            const pointCount = absolutePoints.length;
            if (geometry.relative && pointCount > 1) {
                const totalLength = edgeState.length;
                const { segments: segments } = edgeState;
                // Works out which line segment the point of the label is closest to
                let p0 = absolutePoints[0];
                let pe = absolutePoints[1];
                let minDist = (0, $f7ff90b8964488a6$export$545acef63fa0c8)(p0.x, p0.y, pe.x, pe.y, x, y);
                let length = 0;
                let index = 0;
                let tmp = 0;
                for(let i = 2; i < pointCount; i += 1){
                    p0 = pe;
                    pe = absolutePoints[i];
                    const dist = (0, $f7ff90b8964488a6$export$545acef63fa0c8)(p0.x, p0.y, pe.x, pe.y, x, y);
                    tmp += segments[i - 2];
                    if (dist <= minDist) {
                        minDist = dist;
                        index = i - 1;
                        length = tmp;
                    }
                }
                const seg = segments[index];
                p0 = absolutePoints[index];
                pe = absolutePoints[index + 1];
                const x2 = p0.x;
                const y2 = p0.y;
                const x1 = pe.x;
                const y1 = pe.y;
                let px = x;
                let py = y;
                const xSegment = x2 - x1;
                const ySegment = y2 - y1;
                px -= x1;
                py -= y1;
                let projlenSq = 0;
                px = xSegment - px;
                py = ySegment - py;
                const dotprod = px * xSegment + py * ySegment;
                if (dotprod <= 0.0) projlenSq = 0;
                else projlenSq = dotprod * dotprod / (xSegment * xSegment + ySegment * ySegment);
                let projlen = Math.sqrt(projlenSq);
                if (projlen > seg) projlen = seg;
                let yDistance = Math.sqrt((0, $f7ff90b8964488a6$export$545acef63fa0c8)(p0.x, p0.y, pe.x, pe.y, x, y));
                const direction = (0, $f7ff90b8964488a6$export$353ccb813a4d7574)(p0.x, p0.y, pe.x, pe.y, x, y);
                if (direction === -1) yDistance = -yDistance;
                // Constructs the relative point for the label
                return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)((totalLength / 2 - length - projlen) / totalLength * -2, yDistance / this.scale);
            }
        }
        return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)();
    }
    /**
     * Updates {@link CellState.absoluteOffset} for the given state. The absolute
     * offset is normally used for the position of the edge label. It is
     * calculated from the geometry as an absolute offset from the center
     * between the two endpoints if the geometry is absolute, or as the
     * relative distance between the center along the line and the absolute
     * orthogonal distance if the geometry is relative.
     *
     * @param state {@link CellState} whose absolute offset should be updated.
     */ updateEdgeLabelOffset(state) {
        const points = state.absolutePoints;
        const absoluteOffset = state.absoluteOffset;
        absoluteOffset.x = state.getCenterX();
        absoluteOffset.y = state.getCenterY();
        if (points.length > 0 && state.segments) {
            const geometry = state.cell.getGeometry();
            if (geometry) {
                if (geometry.relative) {
                    const offset = this.getPoint(state, geometry);
                    state.absoluteOffset = offset;
                } else {
                    const p0 = points[0];
                    const pe = points[points.length - 1];
                    if (p0 && pe) {
                        const dx = pe.x - p0.x;
                        const dy = pe.y - p0.y;
                        let x0 = 0;
                        let y0 = 0;
                        const off = geometry.offset;
                        if (off) {
                            x0 = off.x;
                            y0 = off.y;
                        }
                        const x = p0.x + dx / 2 + x0 * this.scale;
                        const y = p0.y + dy / 2 + y0 * this.scale;
                        absoluteOffset.x = x;
                        absoluteOffset.y = y;
                    }
                }
            }
        }
    }
    /**
     * Returns the {@link CellState} for the given cell. If create is true, then
     * the state is created if it does not yet exist.
     *
     * @param cell {@link Cell} for which the {@link CellState} should be returned.
     * @param create Optional boolean indicating if a new state should be created if it does not yet exist. Default is false.
     */ getState(cell, create = false) {
        let state = this.states.get(cell) ?? null;
        if (create && (!state || this.updateStyle) && cell.isVisible()) {
            if (!state) {
                state = this.createState(cell);
                this.states.set(cell, state);
            } else state.style = this.graph.getCellStyle(cell);
        }
        return state;
    }
    /**
     * Returns the {@link CellState}s for the given array of {@link Cell}.
     *
     * The array contains all states that are not null, that is, the returned array may have fewer elements than the given array.
     *
     * If no argument is given, then this returns the {@link CellState} of {@link states}.
     */ getCellStates(cells = null) {
        if (!cells) return Array.from(this.states.values());
        const result = [];
        for (const cell of cells){
            const state = this.getState(cell);
            if (state) result.push(state);
        }
        return result;
    }
    /**
     * Removes and returns the {@link CellState} for the given cell.
     *
     * @param cell {@link Cell} for which the {@link CellState} should be removed.
     */ removeState(cell) {
        const state = this.states.get(cell) ?? null;
        this.states.delete(cell);
        if (state) {
            this.graph.cellRenderer.destroy(state);
            state.invalid = true;
            state.destroy();
        }
        return state;
    }
    /**
     * Creates and returns an {@link CellState} for the given cell and initializes
     * it using {@link cellRenderer.initialize}.
     *
     * @param cell {@link Cell} for which a new {@link CellState} should be created.
     */ createState(cell) {
        return new (0, $a9ad68c2c04d1a53$export$2e2bcd8739ae039)(this, cell, this.graph.getCellStyle(cell));
    }
    /**
     * Returns true if the event origin is one of the drawing panes or
     * containers of the view.
     */ isContainerEvent(evt) {
        const source = (0, $f192e93a2fd1153c$export$dd2b6e807fb37ba3)(evt);
        return source && (source === this.graph.container || // @ts-ignore parentNode may exist
        source.parentNode === this.backgroundPane || // @ts-ignore parentNode may exist
        source.parentNode && source.parentNode.parentNode === this.backgroundPane || source === this.canvas.parentNode || source === this.canvas || source === this.backgroundPane || source === this.drawPane || source === this.overlayPane || source === this.decoratorPane);
    }
    isScrollEvent(evt) {
        const graph = this.graph;
        const offset = (0, $b55d6ca3b42398e2$export$622cea445a1c5b7d)(graph.container);
        const eventClientPosition = evt instanceof MouseEvent ? [
            evt.clientX,
            evt.clientY
        ] : [
            evt.touches[0].clientX,
            evt.touches[0].clientY
        ];
        const pt = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(eventClientPosition[0] - offset.x, eventClientPosition[1] - offset.y);
        const container = graph.container;
        const outWidth = container.offsetWidth;
        const inWidth = container.clientWidth;
        if (outWidth > inWidth && pt.x > inWidth + 2 && pt.x <= outWidth) return true;
        const outHeight = container.offsetHeight;
        const inHeight = container.clientHeight;
        return outHeight > inHeight && pt.y > inHeight + 2 && pt.y <= outHeight;
    }
    /**
     * Initializes the graph event dispatch loop for the specified container
     * and invokes {@link create} to create the required DOM nodes for the display.
     */ init() {
        this.installListeners();
        this.createSvg();
    }
    /**
     * Installs the required listeners in the container.
     */ installListeners() {
        const graph = this.graph;
        const { container: container } = graph;
        // Support for touch device gestures (eg. pinch to zoom)
        // Double-tap handling is implemented in mxGraph.fireMouseEvent
        if ((0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_TOUCH) {
            (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addListener(container, 'gesturestart', (evt)=>{
                graph.fireGestureEvent(evt);
                (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).consume(evt);
            });
            (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addListener(container, 'gesturechange', (evt)=>{
                graph.fireGestureEvent(evt);
                (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).consume(evt);
            });
            (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addListener(container, 'gestureend', (evt)=>{
                graph.fireGestureEvent(evt);
                (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).consume(evt);
            });
        }
        // Fires event only for one pointer per gesture
        let pointerId = null;
        // Adds basic listeners for graph event dispatching
        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addGestureListeners(container, (evt)=>{
            // Condition to avoid scrollbar events starting a rubberband selection
            if (this.isContainerEvent(evt) && (!(0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_GC && !(0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_SF || !this.isScrollEvent(evt))) {
                graph.fireMouseEvent((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_DOWN, new (0, $2051fd5f8fd06bc7$export$2e2bcd8739ae039)(evt));
                // @ts-ignore
                pointerId = evt.pointerId;
            }
        }, (evt)=>{
            if (this.isContainerEvent(evt) && // @ts-ignore
            (pointerId === null || evt.pointerId === pointerId)) graph.fireMouseEvent((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_MOVE, new (0, $2051fd5f8fd06bc7$export$2e2bcd8739ae039)(evt));
        }, (evt)=>{
            if (this.isContainerEvent(evt)) graph.fireMouseEvent((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_UP, new (0, $2051fd5f8fd06bc7$export$2e2bcd8739ae039)(evt));
            pointerId = null;
        });
        // Adds listener for double click handling on background, this does always
        // use native event handler, we assume that the DOM of the background
        // does not change during the double click
        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addListener(container, 'dblclick', (evt)=>{
            if (this.isContainerEvent(evt)) graph.dblClick(evt);
        });
        // Workaround for touch events which started on some DOM node
        // on top of the container, in which case the cells under the
        // mouse for the move and up events are not detected.
        const getState = (evt)=>{
            let state = null;
            // Workaround for touch events which started on some DOM node
            // on top of the container, in which case the cells under the
            // mouse for the move and up events are not detected.
            if ((0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_TOUCH) {
                const x = (0, $f192e93a2fd1153c$export$87583e2c100c6a4f)(evt);
                const y = (0, $f192e93a2fd1153c$export$195fc3609401443f)(evt);
                // Dispatches the drop event to the graph which
                // consumes and executes the source function
                const pt = (0, $b55d6ca3b42398e2$export$864dc177f7f5bda1)(container, x, y);
                const cell = graph.getCellAt(pt.x, pt.y);
                if (cell) state = graph.view.getState(cell);
            }
            return state;
        };
        // Adds basic listeners for graph event dispatching outside the container and finishing the handling of a single gesture
        // Implemented via graph event dispatch loop to avoid duplicate events in Firefox and Chrome
        graph.addMouseListener({
            mouseDown: ()=>{
                const popupMenuHandler = graph.getPlugin('PopupMenuHandler');
                popupMenuHandler?.hideMenu();
            },
            mouseMove: ()=>{
            // do nothing
            },
            mouseUp: ()=>{
            // do nothing
            }
        });
        this.moveHandler = (evt)=>{
            const tooltipHandler = graph.getPlugin('TooltipHandler');
            // Hides the tooltip if mouse is outside container
            if (tooltipHandler && tooltipHandler.isHideOnHover()) tooltipHandler.hide();
            if (this.captureDocumentGesture && graph.isMouseDown && graph.container != null && !this.isContainerEvent(evt) && graph.container.style.display !== 'none' && graph.container.style.visibility !== 'hidden' && !(0, $f192e93a2fd1153c$export$f6e93dab47d340de)(evt)) graph.fireMouseEvent((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_MOVE, new (0, $2051fd5f8fd06bc7$export$2e2bcd8739ae039)(evt, getState(evt)));
        };
        this.endHandler = (evt)=>{
            if (this.captureDocumentGesture && graph.isMouseDown && graph.container != null && !this.isContainerEvent(evt) && graph.container.style.display !== 'none' && graph.container.style.visibility !== 'hidden') graph.fireMouseEvent((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_UP, new (0, $2051fd5f8fd06bc7$export$2e2bcd8739ae039)(evt));
        };
        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addGestureListeners(document, null, this.moveHandler, this.endHandler);
    }
    /**
     * Creates and returns the DOM nodes for the SVG display.
     */ createSvg() {
        const { container: container } = this.graph;
        const canvas = this.canvas = document.createElementNS((0, $cBHcM.NS_SVG), 'g');
        // For background image
        this.backgroundPane = document.createElementNS((0, $cBHcM.NS_SVG), 'g');
        canvas.appendChild(this.backgroundPane);
        // Adds two layers (background is early feature)
        this.drawPane = document.createElementNS((0, $cBHcM.NS_SVG), 'g');
        canvas.appendChild(this.drawPane);
        this.overlayPane = document.createElementNS((0, $cBHcM.NS_SVG), 'g');
        canvas.appendChild(this.overlayPane);
        this.decoratorPane = document.createElementNS((0, $cBHcM.NS_SVG), 'g');
        canvas.appendChild(this.decoratorPane);
        const root = document.createElementNS((0, $cBHcM.NS_SVG), 'svg');
        root.style.left = '0px';
        root.style.top = '0px';
        root.style.width = '100%';
        root.style.height = '100%';
        // NOTE: In standards mode, the SVG must have block layout
        // in order for the container DIV to not show scrollbars.
        root.style.display = 'block';
        root.appendChild(this.canvas);
        if (container != null) {
            container.appendChild(root);
            this.updateContainerStyle(container);
        }
    }
    /**
     * Creates the DOM nodes for the HTML display.
     */ createHtml() {
        const container = this.graph.container;
        if (container != null) {
            this.canvas = this.createHtmlPane('100%', '100%');
            this.canvas.style.overflow = 'hidden';
            // Uses minimal size for inner DIVs on Canvas. This is required
            // for correct event processing in IE. If we have an overlapping
            // DIV then the events on the cells are only fired for labels.
            this.backgroundPane = this.createHtmlPane('1px', '1px');
            this.drawPane = this.createHtmlPane('1px', '1px');
            this.overlayPane = this.createHtmlPane('1px', '1px');
            this.decoratorPane = this.createHtmlPane('1px', '1px');
            this.canvas.appendChild(this.backgroundPane);
            this.canvas.appendChild(this.drawPane);
            this.canvas.appendChild(this.overlayPane);
            this.canvas.appendChild(this.decoratorPane);
            container.appendChild(this.canvas);
            this.updateContainerStyle(container);
        }
    }
    /**
     * Updates the size of the HTML canvas.
     */ updateHtmlCanvasSize(width, height) {
        if (this.graph.container != null) {
            const ow = this.graph.container.offsetWidth;
            const oh = this.graph.container.offsetHeight;
            if (ow < width) this.canvas.style.width = width + 'px';
            else this.canvas.style.width = '100%';
            if (oh < height) this.canvas.style.height = height + 'px';
            else this.canvas.style.height = '100%';
        }
    }
    /**
     * Creates and returns a drawing pane in HTML (DIV).
     */ createHtmlPane(width, height) {
        const pane = document.createElement('DIV');
        if (width != null && height != null) {
            pane.style.position = 'absolute';
            pane.style.left = '0px';
            pane.style.top = '0px';
            pane.style.width = width;
            pane.style.height = height;
        } else pane.style.position = 'relative';
        return pane;
    }
    /**
     * Updates the style of the container after installing the SVG DOM elements.
     */ updateContainerStyle(container) {
        // Workaround for offset of container
        const style = (0, $b55d6ca3b42398e2$export$6e10775a92bc4d41)(container);
        if (style != null && style.position == 'static') container.style.position = 'relative';
        // Disables built-in pan and zoom in IE10 and later
        if ((0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_POINTER) container.style.touchAction = 'none';
    }
    /**
     * Destroys the view and all its resources.
     */ destroy() {
        let root = null;
        if (this.canvas && this.canvas instanceof SVGElement) root = this.canvas.ownerSVGElement;
        if (!root) root = this.canvas;
        if (root && root.parentNode) {
            this.clear(this.currentRoot, true);
            (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).removeGestureListeners(document, null, this.moveHandler, this.endHandler);
            (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).release(this.graph.container);
            root.parentNode.removeChild(root);
            this.moveHandler = null;
            this.endHandler = null;
            // @ts-expect-error Can be null when destroyed.
            this.canvas = null;
            // @ts-expect-error Can be null when destroyed.
            this.backgroundPane = null;
            // @ts-expect-error Can be null when destroyed.
            this.drawPane = null;
            // @ts-expect-error Can be null when destroyed.
            this.overlayPane = null;
            // @ts-expect-error Can be null when destroyed.
            this.decoratorPane = null;
            super.destroy();
        }
    }
}
var $667abfee930cface$export$2e2bcd8739ae039 = $667abfee930cface$export$6a7fe3ef90e8d566;


class $beb1c49bb5001815$export$44cb372311309cb9 extends (0, $04d8eeb08050dccc$export$ad0a8adca2a96dfe) {
    initializeCollaborators(options) {
        this.cellRenderer = options?.cellRenderer ?? new (0, $71fcd07ecf4780df$export$2e2bcd8739ae039)();
        this.model = options?.model ?? new (0, $73c88ebf085ac84f$export$2e2bcd8739ae039)();
        this.setSelectionModel(options?.selectionModel?.(this) ?? new (0, $e6719d4fe4c26799$export$2e2bcd8739ae039)(this));
        this.setStylesheet(options?.stylesheet ?? new (0, $94c0379da76b3d8f$export$cd02bf5de16fbd7c)());
        this.view = options?.view?.(this) ?? new (0, $667abfee930cface$export$2e2bcd8739ae039)(this);
    }
}

/*
Copyright 2024-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 




var $cBHcM = parcelRequire("cBHcM");





var $h5l15 = parcelRequire("h5l15");

var $4vC7I = parcelRequire("4vC7I");
/**
 * In-place editor for the graph.
 *
 * To control this editor, use:
 * - {@link AbstractGraph.invokesStopCellEditing}
 * - {@link AbstractGraph.enterStopsCellEditing}
 * - {@link AbstractGraph.escapeEnabled}
 *
 * If {@link AbstractGraph.enterStopsCellEditing} is `true` then ctrl-enter or shift-enter can be used to create a linefeed.
 *
 * The F2 (accept change) and escape keys (undo change) can always be used to stop editing.
 *
 * To customize the location of the textbox in the graph, override {@link getEditorBounds} as follows:
 *
 * ```javascript
 * graph.cellEditor.getEditorBounds = (state) => {
 *   const result = super.getEditorBounds(state);
 *
 *   if (this.graph.getDataModel().isEdge(state.cell)) {
 *     result.x = state.getCenterX() - result.width / 2;
 *     result.y = state.getCenterY() - result.height / 2;
 *   }
 *
 *   return result;
 * };
 * ```
 *
 * Note that this hook is only called if {@link autoSize} is `false`.
 * If {@link autoSize} is `true`, then {@link Shape.getLabelBounds} is used to compute the current bounds of the textbox.
 *
 * The textarea uses the `mxCellEditor` CSS class. You can modify this class in your custom CSS.

 * Example:
 *
 * To only allow numeric input in the in-place editor, use the following code.
 *
 * ```javascript
 * const text = graph.cellEditor.textarea;
 *
 * InternalEvent.addListener(text, 'keydown', function (evt) {
 *   if (!(evt.keyCode >= 48 && evt.keyCode <= 57) &&
 *       !(evt.keyCode >= 96 && evt.keyCode <= 105)) {
 *     InternalEvent.consume(evt);
 *   }
 * });
 * ```
 *
 * ### Placeholder
 *
 * To implement a placeholder for cells without a label, use the {@link emptyLabelText} variable.
 *
 *
 * ### Resize the textarea
 *
 * Resize of the textarea is disabled by default.
 * If you want to enable this feature extend {@link init} and set `this.textarea.style.resize = ''`.
 *
 *
 * ### Editing on key press
 *
 * To start editing on a key press event, the container of the graph
 * should have focus or a focusable parent should be used to add the
 * key press handler as follows.
 *
 * ```javascript
 * InternalEvent.addListener(graph.container, 'keypress', (evt) => {
 *   if (!graph.isEditing() && !graph.isSelectionEmpty() && evt.which !== 0
 *       && !eventUtils.isAltDown(evt)
 *       && !eventUtils.isControlDown(evt)
 *       && !eventUtils.isMetaDown(evt)) {
 *     graph.startEditing();
 *
 *     if (Client.IS_FF) {
 *       graph.cellEditor.textarea.value = String.fromCharCode(evt.which);
 *     }
 *   }
 * });
 * ```
 *
 * To allow focus for a DIV, and hence to receive key press events, some browsers require it to have a valid tabindex attribute.
 * In this case the following code may be used to keep the container focused.
 *
 * ```javascript
 * const graphFireMouseEvent = graph.fireMouseEvent;
 * graph.fireMouseEvent = (evtName, me, sender) => {
 *   if (evtName == mxEvent.MOUSE_DOWN) {
 *     this.container.focus();
 *   }
 *
 *   graphFireMouseEvent.apply(this, [evtName, me, sender]);
 * };
 * ```
 *
 * @category Plugin
 */ class $3e6c1027d91142d4$var$CellEditorHandler {
    constructor(graph){
        this.clearOnChange = false;
        this.bounds = null;
        this.resizeThread = null;
        this.textDirection = null;
        /**
         * Holds the DIV that is used for text editing. Note that this may be null before the first
         * edit. Instantiated in <init>.
         */ this.textarea = null;
        /**
         * Reference to the <Cell> that is currently being edited.
         */ this.editingCell = null;
        /**
         * Reference to the event that was used to start editing.
         */ this.trigger = null;
        /**
         * Specifies if the label has been modified.
         */ this.modified = false;
        /**
         * Specifies if the textarea should be resized while the text is being edited.
         * Default is true.
         */ this.autoSize = true;
        /**
         * Specifies if the text should be selected when editing starts. Default is
         * true.
         */ this.selectText = true;
        /**
         * Text to be displayed for empty labels. Default is '' or '<br>' in Firefox as
         * a workaround for the missing cursor bug for empty content editable. This can
         * be set to eg. "[Type Here]" to easier visualize editing of empty labels. The
         * value is only displayed before the first keystroke and is never used as the
         * actual editing value.
         */ this.emptyLabelText = (0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_FF ? '<br>' : '';
        /**
         * If true, pressing the escape key will stop editing and not accept the new
         * value. Change this to false to accept the new value on escape, and cancel
         * editing on Shift+Escape instead. Default is true.
         */ this.escapeCancelsEditing = true;
        /**
         * Reference to the label DOM node that has been hidden.
         */ this.textNode = null;
        /**
         * Specifies the zIndex for the textarea. Default is 5.
         */ this.zIndex = 5;
        /**
         * Defines the minimum width and height to be used in <resize>. Default is 0x20px.
         */ this.minResize = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(0, 20);
        /**
         * Correction factor for word wrapping width. Default is 2 in quirks, 0 in IE
         * 11 and 1 in all other browsers and modes.
         */ // wordWrapPadding: 2 | 1 | 0;
        this.wordWrapPadding = 0;
        /**
         * If <focusLost> should be called if <textarea> loses the focus. Default is false.
         */ this.blurEnabled = false;
        /**
         * Holds the initial editing value to check if the current value was modified.
         */ this.initialValue = null;
        /**
         * Holds the current temporary horizontal alignment for the cell style. If this
         * is modified then the current text alignment is changed and the cell style is
         * updated when the value is applied.
         */ this.align = null;
        this.graph = graph;
        // Stops editing after zoom changes
        this.zoomHandler = ()=>{
            if (this.graph.isEditing()) this.resize();
        };
        // Handling of deleted cells while editing
        this.changeHandler = (_sender)=>{
            if (this.editingCell && !this.graph.getView().getState(this.editingCell, false)) this.stopEditing(true);
        };
        this.graph.getView().addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).SCALE, this.zoomHandler);
        this.graph.getView().addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).SCALE_AND_TRANSLATE, this.zoomHandler);
        this.graph.getDataModel().addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CHANGE, this.changeHandler);
    }
    /**
     * Creates the {@link textarea} and installs the event listeners. The key handler
     * updates the {@link modified} state.
     */ init() {
        this.textarea = document.createElement('div');
        this.textarea.className = 'mxCellEditor mxPlainTextEditor';
        this.textarea.contentEditable = String(true);
        // Workaround for selection outside DIV if height is 0
        if ((0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_GC) this.textarea.style.minHeight = '1em';
        this.textarea.style.position = 'absolute';
        this.installListeners(this.textarea);
    }
    /**
     * Called in <stopEditing> if cancel is false to invoke {@link AbstractGraph.labelChanged}.
     */ applyValue(state, value) {
        this.graph.labelChanged(state.cell, value, this.trigger);
    }
    /**
     * Sets the temporary horizontal alignment for the current editing session.
     */ setAlign(align) {
        if (this.textarea) this.textarea.style.textAlign = align;
        this.align = align;
        this.resize();
    }
    /**
     * Gets the initial editing value for the given cell.
     */ getInitialValue(state, trigger) {
        let result = (0, $6bb3a85a9cf63e97$export$324699496a105db8)(this.graph.getEditingValue(state.cell, trigger), false);
        result = (0, $6bb3a85a9cf63e97$export$c480f75734bc04c9)(result, '<div><br></div>');
        return result.replace(/\n/g, '<br>');
    }
    /**
     * Returns the current editing value.
     */ getCurrentValue(state) {
        if (!this.textarea) return null;
        return (0, $b1d29c834e82fef5$export$bd6c631d45dacdd2)(Array.from(this.textarea.childNodes));
    }
    /**
     * Returns true if <escapeCancelsEditing> is true and shift, control and meta
     * are not pressed.
     */ // isCancelEditingKeyEvent(evt: Event): boolean;
    isCancelEditingKeyEvent(evt) {
        return this.escapeCancelsEditing || (0, $f192e93a2fd1153c$export$1d7fd696f3493e74)(evt) || (0, $f192e93a2fd1153c$export$aec581d3997aa3aa)(evt) || (0, $f192e93a2fd1153c$export$77ae9bb78030b9bf)(evt);
    }
    /**
     * Installs listeners for focus, change and standard key event handling.
     */ // installListeners(elt: Element): void;
    installListeners(elt) {
        // Applies value if text is dragged
        // LATER: Gesture mouse events ignored for starting move
        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addListener(elt, 'dragstart', (evt)=>{
            this.graph.stopEditing(false);
            (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).consume(evt);
        });
        // Applies value if focus is lost
        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addListener(elt, 'blur', (evt)=>{
            if (this.blurEnabled) this.focusLost();
        });
        // Updates modified state and handles placeholder text
        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addListener(elt, 'keydown', (evt)=>{
            if (!(0, $f192e93a2fd1153c$export$f6e93dab47d340de)(evt)) {
                if (this.isStopEditingEvent(evt)) {
                    this.graph.stopEditing(false);
                    (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).consume(evt);
                } else if (evt.keyCode === 27 /* Escape */ ) {
                    this.graph.stopEditing(this.isCancelEditingKeyEvent(evt));
                    (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).consume(evt);
                }
            }
        });
        // Keypress only fires if printable key was pressed and handles removing the empty placeholder
        const keypressHandler = (evt)=>{
            if (this.editingCell != null) // Clears the initial empty label on the first keystroke
            // and workaround for FF which fires keypress for delete and backspace
            {
                if (this.clearOnChange && elt.innerHTML === this.getEmptyLabelText() && (!(0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_FF || evt.keyCode !== 8 /* Backspace */  && evt.keyCode !== 46)) {
                    this.clearOnChange = false;
                    elt.innerHTML = '';
                }
            }
        };
        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addListener(elt, 'keypress', keypressHandler);
        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addListener(elt, 'paste', keypressHandler);
        // Handler for updating the empty label text value after a change
        const keyupHandler = (evt)=>{
            if (this.editingCell != null) {
                // Uses an optional text value for sempty labels which is cleared
                // when the first keystroke appears. This makes it easier to see
                // that a label is being edited even if the label is empty.
                // In Safari and FF, an empty text is represented by <BR> which isn't enough to force a valid size
                const textarea = this.textarea;
                if (textarea.innerHTML.length === 0 || textarea.innerHTML === '<br>') {
                    textarea.innerHTML = this.getEmptyLabelText();
                    this.clearOnChange = textarea.innerHTML.length > 0;
                } else this.clearOnChange = false;
            }
        };
        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addListener(elt, 'input', keyupHandler);
        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addListener(elt, 'cut', keyupHandler);
        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addListener(elt, 'paste', keyupHandler);
        // Adds automatic resizing of the textbox while typing using input, keyup and/or DOM change events
        const evtName = 'input';
        const resizeHandler = (evt)=>{
            if (this.editingCell != null && this.autoSize && !(0, $f192e93a2fd1153c$export$f6e93dab47d340de)(evt)) {
                // Asynchronous is needed for keydown and shows better results for input events overall
                // (ie non-blocking and cases where the offsetWidth/-Height was wrong at this time)
                if (this.resizeThread != null) window.clearTimeout(this.resizeThread);
                this.resizeThread = window.setTimeout(()=>{
                    this.resizeThread = null;
                    this.resize();
                }, 0);
            }
        };
        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addListener(elt, evtName, resizeHandler);
        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addListener(window, 'resize', resizeHandler);
        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addListener(elt, 'cut', resizeHandler);
        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addListener(elt, 'paste', resizeHandler);
    }
    /**
     * Returns true if the given keydown event should stop cell editing. This
     * returns true if F2 is pressed of if {@link AbstractGraph.enterStopsCellEditing} is true
     * and enter is pressed without control or shift.
     */ isStopEditingEvent(evt) {
        return evt.keyCode === 113 /* F2 */  || this.graph.isEnterStopsCellEditing() && evt.keyCode === 13 /* Enter */  && !(0, $f192e93a2fd1153c$export$aec581d3997aa3aa)(evt) && !(0, $f192e93a2fd1153c$export$1d7fd696f3493e74)(evt);
    }
    /**
     * Returns true if this editor is the source for the given native event.
     */ isEventSource(evt) {
        return (0, $f192e93a2fd1153c$export$dd2b6e807fb37ba3)(evt) === this.textarea;
    }
    /**
     * Returns {@link odified}.
     */ resize() {
        const state = this.editingCell ? this.graph.getView().getState(this.editingCell) : null;
        if (!state) this.stopEditing(true);
        else if (this.textarea != null) {
            const isEdge = state.cell.isEdge();
            const { scale: scale } = this.graph.getView();
            let m = null;
            if (!this.autoSize || state.style.overflow === 'fill') {
                // Specifies the bounds of the editor box
                this.bounds = this.getEditorBounds(state);
                this.textarea.style.width = `${Math.round(this.bounds.width / scale)}px`;
                this.textarea.style.height = `${Math.round(this.bounds.height / scale)}px`;
                // FIXME: Offset when scaled
                this.textarea.style.left = `${Math.max(0, Math.round(this.bounds.x + 1))}px`;
                this.textarea.style.top = `${Math.max(0, Math.round(this.bounds.y + 1))}px`;
                // Installs native word wrapping and avoids word wrap for empty label placeholder
                if (this.graph.isWrapping(state.cell) && (this.bounds.width >= 2 || this.bounds.height >= 2) && this.textarea.innerHTML !== this.getEmptyLabelText()) {
                    this.textarea.style.wordWrap = (0, $cBHcM.WORD_WRAP);
                    this.textarea.style.whiteSpace = 'normal';
                    if (state.style.overflow !== 'fill') this.textarea.style.width = `${Math.round(this.bounds.width / scale) + this.wordWrapPadding}px`;
                } else {
                    this.textarea.style.whiteSpace = 'nowrap';
                    if (state.style.overflow !== 'fill') this.textarea.style.width = '';
                }
            } else {
                const lw = state.style.labelWidth ?? null;
                m = state.text != null && this.align == null ? state.text.margin : null;
                if (m == null) m = (0, $b55d6ca3b42398e2$export$29d173e672cfdc1f)(this.align ?? state.style.align ?? 'center', state.style.verticalAlign ?? 'middle');
                if (isEdge) {
                    this.bounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(state.absoluteOffset.x, state.absoluteOffset.y, 0, 0);
                    if (lw != null) {
                        const tmp = (lw + 2) * scale;
                        this.bounds.width = tmp;
                        this.bounds.x += m.x * tmp;
                    }
                } else {
                    let bounds = (0, $2997c239141ea844$export$2e2bcd8739ae039).fromRectangle(state);
                    let hpos = state.style.labelPosition ?? 'center';
                    let vpos = state.style.verticalLabelPosition ?? 'middle';
                    bounds = state.shape != null && hpos === 'center' && vpos === 'middle' ? state.shape.getLabelBounds(bounds) : bounds;
                    if (lw != null) bounds.width = lw * scale;
                    if (!state.view.graph.cellRenderer.legacySpacing || state.style.overflow !== 'width') {
                        // @ts-ignore
                        const dummy = new (0, $ac9b5e111f18d948$export$2e2bcd8739ae039)(); // FIXME!!!! ===================================================================================================
                        const spacing = (state.style.spacing ?? 2) * scale;
                        const spacingTop = ((state.style.spacingTop ?? 0) + dummy.baseSpacingTop) * scale + spacing;
                        const spacingRight = ((state.style.spacingRight ?? 0) + dummy.baseSpacingRight) * scale + spacing;
                        const spacingBottom = ((state.style.spacingBottom ?? 0) + dummy.baseSpacingBottom) * scale + spacing;
                        const spacingLeft = ((state.style.spacingLeft ?? 0) + dummy.baseSpacingLeft) * scale + spacing;
                        hpos = state.style.labelPosition != null ? state.style.labelPosition : 'center';
                        vpos = state.style.verticalLabelPosition != null ? state.style.verticalLabelPosition : 'middle';
                        bounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(bounds.x + spacingLeft, bounds.y + spacingTop, bounds.width - (hpos === 'center' && lw == null ? spacingLeft + spacingRight : 0), bounds.height - (vpos === 'middle' ? spacingTop + spacingBottom : 0));
                    }
                    this.bounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(bounds.x + state.absoluteOffset.x, bounds.y + state.absoluteOffset.y, bounds.width, bounds.height);
                }
                // Needed for word wrap inside text blocks with oversize lines to match the final result where
                // the width of the longest line is used as the reference for text alignment in the cell
                // TODO: Fix word wrapping preview for edge labels in helloworld.html
                if (this.graph.isWrapping(state.cell) && (this.bounds.width >= 2 || this.bounds.height >= 2) && this.textarea.innerHTML !== this.getEmptyLabelText()) {
                    this.textarea.style.wordWrap = (0, $cBHcM.WORD_WRAP);
                    this.textarea.style.whiteSpace = 'normal';
                    // Forces automatic reflow if text is removed from an oversize label and normal word wrap
                    const tmp = Math.round(this.bounds.width / scale) + this.wordWrapPadding;
                    if (this.textarea.style.position !== 'relative') {
                        this.textarea.style.width = `${tmp}px`;
                        if (this.textarea.scrollWidth > tmp) this.textarea.style.width = `${this.textarea.scrollWidth}px`;
                    } else this.textarea.style.maxWidth = `${tmp}px`;
                } else {
                    // KNOWN: Trailing cursor in IE9 quirks mode is not visible
                    this.textarea.style.whiteSpace = 'nowrap';
                    this.textarea.style.width = '';
                }
                const ow = this.textarea.scrollWidth;
                const oh = this.textarea.scrollHeight;
                // TODO: Update CSS width and height if smaller than minResize or remove minResize
                // if (this.minResize != null)
                // {
                //  ow = Math.max(ow, this.minResize.width);
                //  oh = Math.max(oh, this.minResize.height);
                // }
                // LATER: Keep in visible area, add fine tuning for pixel precision
                this.textarea.style.left = `${Math.max(0, Math.round(this.bounds.x - m.x * (this.bounds.width - 2)) + 1)}px`;
                this.textarea.style.top = `${Math.max(0, Math.round(this.bounds.y - m.y * (this.bounds.height - 4) + (m.y === -1 ? 3 : 0)) + 1)}px`;
            }
            (0, $b55d6ca3b42398e2$export$5cd002036665463c)(this.textarea.style, 'transformOrigin', '0px 0px');
            (0, $b55d6ca3b42398e2$export$5cd002036665463c)(this.textarea.style, 'transform', `scale(${scale},${scale})${m == null ? '' : ` translate(${m.x * 100}%,${m.y * 100}%)`}`);
        }
    }
    /**
     * Called if the textarea has lost focus.
     */ focusLost() {
        this.stopEditing(!this.graph.isInvokesStopCellEditing());
    }
    /**
     * Returns the background color for the in-place editor. This implementation
     * always returns NONE.
     */ getBackgroundColor(state) {
        return 0, $cBHcM.NONE;
    }
    /**
     * Starts the editor for the given cell.
     *
     * @param cell <Cell> to start editing.
     * @param trigger Optional mouse event that triggered the editor.
     */ startEditing(cell, trigger = null) {
        this.stopEditing(true);
        this.align = null;
        // Creates new textarea instance
        if (this.textarea == null) this.init();
        const tooltipHandler = this.graph.getPlugin('TooltipHandler');
        tooltipHandler?.hideTooltip();
        const state = this.graph.getView().getState(cell);
        if (state) {
            // Configures the style of the in-place editor
            // Notice that the logic here is duplicated with styleUtils.getSizeForString
            const stateStyle = state.style;
            const size = stateStyle.fontSize ?? (0, $4vC7I.StyleDefaultsConfig).fontSize;
            const family = stateStyle.fontFamily ?? (0, $4vC7I.StyleDefaultsConfig).fontFamily;
            const color = stateStyle.fontColor ?? 'black';
            const align = stateStyle.align ?? 'left';
            const fontStyle = stateStyle.fontStyle ?? 0;
            const bold = (0, $h5l15.matchBinaryMask)(fontStyle, (0, $cBHcM.FONT_STYLE_MASK).BOLD);
            const italic = (0, $h5l15.matchBinaryMask)(fontStyle, (0, $cBHcM.FONT_STYLE_MASK).ITALIC);
            const txtDecor = [];
            (0, $h5l15.matchBinaryMask)(fontStyle, (0, $cBHcM.FONT_STYLE_MASK).UNDERLINE) && txtDecor.push('underline');
            (0, $h5l15.matchBinaryMask)(fontStyle, (0, $cBHcM.FONT_STYLE_MASK).STRIKETHROUGH) && txtDecor.push('line-through');
            const textarea = this.textarea; // code above ensure it is always set
            const textareaStyle = textarea.style;
            textareaStyle.lineHeight = (0, $cBHcM.ABSOLUTE_LINE_HEIGHT) ? `${Math.round(size * (0, $cBHcM.LINE_HEIGHT))}px` : String((0, $cBHcM.LINE_HEIGHT));
            textareaStyle.backgroundColor = this.getBackgroundColor(state) || 'transparent';
            textareaStyle.textDecoration = txtDecor.join(' ');
            textareaStyle.fontWeight = bold ? 'bold' : 'normal';
            textareaStyle.fontStyle = italic ? 'italic' : '';
            textareaStyle.fontSize = `${Math.round(size)}px`;
            textareaStyle.zIndex = String(this.zIndex);
            textareaStyle.fontFamily = family;
            textareaStyle.textAlign = align;
            textareaStyle.outline = 'none';
            textareaStyle.color = color;
            let dir = this.textDirection = stateStyle.textDirection ?? (0, $cBHcM.DEFAULT_TEXT_DIRECTION);
            const stateText = state.text;
            if (dir === 'auto') {
                if (stateText !== null && stateText.dialect !== 'strictHtml' && !(0, $b1d29c834e82fef5$export$8ee0fc9ee280b4ee)(stateText.value)) dir = stateText.getAutoDirection();
            }
            if (dir === 'ltr' || dir === 'rtl') textarea.setAttribute('dir', dir);
            else textarea.removeAttribute('dir');
            // Sets the initial editing value
            textarea.innerHTML = this.getInitialValue(state, trigger) || '';
            this.initialValue = textarea.innerHTML;
            // Uses an optional text value for empty labels which is cleared
            // when the first keystroke appears. This makes it easier to see
            // that a label is being edited even if the label is empty.
            if (textarea.innerHTML.length === 0 || textarea.innerHTML === '<br>') {
                textarea.innerHTML = this.getEmptyLabelText();
                this.clearOnChange = true;
            } else this.clearOnChange = textarea.innerHTML === this.getEmptyLabelText();
            // @ts-ignore
            this.graph.container.appendChild(textarea);
            // Update this after firing all potential events that could update the cleanOnChange flag
            this.editingCell = cell;
            this.trigger = trigger;
            this.textNode = null;
            if (stateText !== null && this.isHideLabel(state)) {
                this.textNode = stateText.node;
                this.textNode.style.visibility = 'hidden';
            }
            // Workaround for initial offsetHeight not ready for heading in markup
            if (this.autoSize && (state.cell.isEdge() || stateStyle.overflow !== 'fill')) window.setTimeout(()=>{
                this.resize();
            }, 0);
            this.resize();
            // Workaround for NS_ERROR_FAILURE in FF
            try {
                // Prefers blinking cursor over no selected text if empty
                textarea.focus();
                if (this.isSelectText() && textarea.innerHTML.length > 0 && (textarea.innerHTML !== this.getEmptyLabelText() || !this.clearOnChange)) document.execCommand('selectAll', false);
            } catch (e) {
            // ignore
            }
        }
    }
    /**
     * Returns <selectText>.
     */ isSelectText() {
        return this.selectText;
    }
    /**
     * Stops the editor and applies the value if cancel is false.
     */ stopEditing(cancel = false) {
        if (this.editingCell) {
            if (this.textNode) {
                this.textNode.style.visibility = 'visible';
                this.textNode = null;
            }
            const state = !cancel ? this.graph.view.getState(this.editingCell) : null;
            const textarea = this.textarea;
            const initial = this.initialValue;
            this.initialValue = null;
            this.editingCell = null;
            this.bounds = null;
            textarea.blur();
            (0, $b1d29c834e82fef5$export$a3d02541b0ebf605)();
            if (textarea.parentNode) textarea.parentNode.removeChild(textarea);
            if (this.clearOnChange && textarea.innerHTML === this.getEmptyLabelText()) {
                textarea.innerHTML = '';
                this.clearOnChange = false;
            }
            if (state && (textarea.innerHTML !== initial || this.align !== null)) {
                this.prepareTextarea();
                const value = this.getCurrentValue(state);
                this.graph.batchUpdate(()=>{
                    if (value !== null) this.applyValue(state, value);
                    if (this.align !== null) this.graph.setCellStyles('align', this.align, [
                        state.cell
                    ]);
                });
            }
            this.trigger = null;
            // Forces new instance on next edit for undo history reset
            if (this.textarea) (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).release(this.textarea);
            this.textarea = null;
            this.align = null;
        }
    }
    /**
     * Prepares the textarea for getting its value in <stopEditing>.
     * This implementation removes the extra trailing linefeed in Firefox.
     */ prepareTextarea() {
        const textarea = this.textarea;
        if (textarea.lastChild && textarea.lastChild.nodeName === 'BR') textarea.removeChild(textarea.lastChild);
    }
    /**
     * Returns true if the label should be hidden while the cell is being
     * edited.
     */ isHideLabel(state = null) {
        return true;
    }
    /**
     * Returns the minimum width and height for editing the given state.
     */ getMinimumSize(state) {
        const { scale: scale } = this.graph.getView();
        const textarea = this.textarea;
        return new (0, $2997c239141ea844$export$2e2bcd8739ae039)(0, 0, state.text === null ? 30 : state.text.size * scale + 20, textarea.style.textAlign === 'left' ? 120 : 40);
    }
    /**
     * Returns the {@link Rectangle} that defines the bounds of the editor.
     */ getEditorBounds(state) {
        const isEdge = state.cell.isEdge();
        const { scale: scale } = this.graph.getView();
        const minSize = this.getMinimumSize(state);
        const minWidth = minSize.width;
        const minHeight = minSize.height;
        let result = null;
        if (!isEdge && state.view.graph.cellRenderer.legacySpacing && state.style.overflow === 'fill') result = state.shape.getLabelBounds((0, $2997c239141ea844$export$2e2bcd8739ae039).fromRectangle(state));
        else {
            // @ts-ignore
            const dummy = new (0, $ac9b5e111f18d948$export$2e2bcd8739ae039)(); // FIXME!!!! ===================================================================================================
            const spacing = (state.style.spacing ?? 0) * scale;
            const spacingTop = ((state.style.spacingTop ?? 0) + dummy.baseSpacingTop) * scale + spacing;
            const spacingRight = ((state.style.spacingRight ?? 0) + dummy.baseSpacingRight) * scale + spacing;
            const spacingBottom = ((state.style.spacingBottom ?? 0) + dummy.baseSpacingBottom) * scale + spacing;
            const spacingLeft = ((state.style.spacingLeft ?? 0) + dummy.baseSpacingLeft) * scale + spacing;
            result = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(state.x, state.y, Math.max(minWidth, state.width - spacingLeft - spacingRight), Math.max(minHeight, state.height - spacingTop - spacingBottom));
            const hpos = state.style.labelPosition != null ? state.style.labelPosition : 'center';
            const vpos = state.style.verticalLabelPosition != null ? state.style.verticalLabelPosition : 'middle';
            result = state.shape != null && hpos === 'center' && vpos === 'middle' ? state.shape.getLabelBounds(result) : result;
            if (isEdge) {
                result.x = state.absoluteOffset.x;
                result.y = state.absoluteOffset.y;
                if (state.text != null && state.text.boundingBox != null) {
                    // Workaround for label containing just spaces in which case
                    // the bounding box location contains negative numbers
                    if (state.text.boundingBox.x > 0) result.x = state.text.boundingBox.x;
                    if (state.text.boundingBox.y > 0) result.y = state.text.boundingBox.y;
                }
            } else if (state.text != null && state.text.boundingBox != null) {
                result.x = Math.min(result.x, state.text.boundingBox.x);
                result.y = Math.min(result.y, state.text.boundingBox.y);
            }
            result.x += spacingLeft;
            result.y += spacingTop;
            if (state.text != null && state.text.boundingBox != null) {
                if (!isEdge) {
                    result.width = Math.max(result.width, state.text.boundingBox.width);
                    result.height = Math.max(result.height, state.text.boundingBox.height);
                } else {
                    result.width = Math.max(minWidth, state.text.boundingBox.width);
                    result.height = Math.max(minHeight, state.text.boundingBox.height);
                }
            }
            // Applies the horizontal and vertical label positions
            if (state.cell.isVertex()) {
                const horizontal = state.style.labelPosition ?? 'center';
                if (horizontal === 'left') result.x -= state.width;
                else if (horizontal === 'right') result.x += state.width;
                const vertical = state.style.verticalLabelPosition != null ? state.style.verticalLabelPosition : 'middle';
                if (vertical === 'top') result.y -= state.height;
                else if (vertical === 'bottom') result.y += state.height;
            }
        }
        return new (0, $2997c239141ea844$export$2e2bcd8739ae039)(Math.round(result.x), Math.round(result.y), Math.round(result.width), Math.round(result.height));
    }
    /**
     * Returns the initial label value to be used of the label of the given
     * cell is empty. This label is displayed and cleared on the first keystroke.
     * This implementation returns <emptyLabelText>.
     *
     * @param cell <Cell> for which a text for an empty editing box should be
     * returned.
     */ getEmptyLabelText(cell = null) {
        return this.emptyLabelText ?? '';
    }
    /**
     * Returns the cell that is currently being edited or null if no cell is
     * being edited.
     */ getEditingCell() {
        return this.editingCell;
    }
    /**
     * Destroys the editor and removes all associated resources.
     */ onDestroy() {
        if (this.textarea) {
            (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).release(this.textarea);
            if (this.textarea.parentNode) this.textarea.parentNode.removeChild(this.textarea);
            this.textarea = null;
        }
        this.graph.getDataModel().removeListener(this.changeHandler);
        this.graph.getView().removeListener(this.zoomHandler);
    }
}
$3e6c1027d91142d4$var$CellEditorHandler.pluginId = 'CellEditorHandler';
var $3e6c1027d91142d4$export$2e2bcd8739ae039 = $3e6c1027d91142d4$var$CellEditorHandler;


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 


var $cBHcM = parcelRequire("cBHcM");




/**
 * Plugin that displays tooltips.
 * It is generally enabled using {@link AbstractGraph.setTooltips}.
 *
 * {@link getTooltip} is used to get the tooltip for a cell or handle.
 *
 * **IMPORTANT**: Provides additional tooltip information on edges when the {@link SelectionCellsHandler} (cell selection) plugin is available. See {@link getTooltip} for more details.
 *
 * @category Plugin
 */ class $7f5b7d97e04b4503$var$TooltipHandler {
    /**
     * Creates the tooltip element and appends it to the document body.
     *
     */ init() {
        if (document.body) {
            this.div = document.createElement('div');
            this.div.className = 'mxTooltip';
            this.div.style.visibility = 'hidden';
            document.body.appendChild(this.div);
            (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addGestureListeners(this.div, (evt)=>{
                const source = (0, $f192e93a2fd1153c$export$dd2b6e807fb37ba3)(evt);
                // @ts-ignore nodeName may exist
                if (source && source.nodeName !== 'A') this.hideTooltip();
            });
            // Hides tooltips and resets tooltip timer if mouse leaves container
            (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addListener(this.graph.getContainer(), 'mouseleave', (evt)=>{
                if (this.div !== evt.relatedTarget) this.hide();
            });
        }
    }
    /**
     * Constructs an event handler that displays tooltips.
     *
     * @param graph Reference to the enclosing {@link AbstractGraph}.
     */ constructor(graph){
        /**
         * Specifies the zIndex for the tooltip and its shadow.
         * @default 10005
         */ this.zIndex = 10005;
        /**
         * Delay to show the tooltip in milliseconds.
         * @default 500
         */ this.delay = 500;
        /**
         * Specifies if touch and pen events should be ignored.
         * @default true
         */ this.ignoreTouchEvents = true;
        /**
         * Specifies if the tooltip should be hidden if the mouse is moved over the current cell.
         * @default false
         */ this.hideOnHover = false;
        /**
         * `true` if this handler was destroyed using {@link onDestroy}.
         */ this.destroyed = false;
        this.lastX = 0;
        this.lastY = 0;
        this.state = null;
        this.stateSource = false;
        this.thread = null;
        /**
         * Specifies if events are handled.
         * @default false
         */ this.enabled = false;
        this.graph = graph;
        this.graph.addMouseListener(this);
    }
    /**
     * Returns `true` if events are handled.
     *
     * This implementation returns {@link enabled}.
     */ isEnabled() {
        return this.enabled;
    }
    /**
     * Enables or disables event handling.
     *
     * This implementation updates {@link enabled}.
     */ setEnabled(enabled) {
        this.enabled = enabled;
    }
    /**
     * Returns {@link hideOnHover}.
     */ isHideOnHover() {
        return this.hideOnHover;
    }
    /**
     * Sets {@link hideOnHover}.
     */ setHideOnHover(value) {
        this.hideOnHover = value;
    }
    /**
     * Returns the {@link CellState}. to be used for showing a tooltip for this event.
     */ getStateForEvent(me) {
        return me.getState();
    }
    mouseDown(_sender, me) {
        this.reset(me, false);
        this.hideTooltip();
    }
    mouseMove(_sender, me) {
        if (me.getX() !== this.lastX || me.getY() !== this.lastY) {
            this.reset(me, true);
            const state = this.getStateForEvent(me);
            if (this.isHideOnHover() || state !== this.state || me.getSource() !== this.node && (!this.stateSource || state != null && this.stateSource === (me.isSource(state.shape) || !me.isSource(state.text)))) this.hideTooltip();
        }
        this.lastX = me.getX();
        this.lastY = me.getY();
    }
    /**
     * Handles the event by resetting the tooltip timer or hiding the existing tooltip.
     */ mouseUp(_sender, me) {
        this.reset(me, true);
        this.hideTooltip();
    }
    /**
     * Resets the timer.
     */ resetTimer() {
        if (this.thread) {
            window.clearTimeout(this.thread);
            this.thread = null;
        }
    }
    /**
     * Resets and/or restarts the timer to trigger the display of the tooltip.
     */ reset(me, restart, state = null) {
        if (!this.ignoreTouchEvents || (0, $f192e93a2fd1153c$export$764db16956f554f8)(me.getEvent())) {
            this.resetTimer();
            state = state ?? this.getStateForEvent(me);
            if (restart && this.isEnabled() && state && (!this.div || this.div.style.visibility == 'hidden')) {
                const node = me.getSource();
                const x = me.getX();
                const y = me.getY();
                const stateSource = me.isSource(state.shape) || me.isSource(state.text);
                const popupMenuHandler = this.graph.getPlugin('PopupMenuHandler');
                this.thread = window.setTimeout(()=>{
                    if (state && node && !this.graph.isEditing() && !popupMenuHandler?.isMenuShowing() && !this.graph.isMouseDown) {
                        // Uses information from inside event cause using the event at
                        // this (delayed) point in time is not possible in IE as it no
                        // longer contains the required information (member not found)
                        const tip = this.getTooltip(state, node, x, y);
                        this.show(tip, x, y);
                        this.state = state;
                        this.node = node;
                        this.stateSource = stateSource;
                    }
                }, this.delay);
            }
        }
    }
    /**
     * Hides the tooltip and resets the timer.
     */ hide() {
        this.resetTimer();
        this.hideTooltip();
    }
    /**
     * Hides the tooltip.
     */ hideTooltip() {
        if (this.div) {
            this.div.style.visibility = 'hidden';
            this.div.innerHTML = '';
        }
    }
    /**
     * Shows the tooltip for the specified cell and optional index at the
     * specified location (with a vertical offset of 10 pixels).
     */ show(tip, x, y) {
        if (!this.destroyed && tip && tip !== '') {
            const origin = (0, $b55d6ca3b42398e2$export$744922fd1f3b32b)();
            if (!this.div) this.init();
            this.div.style.zIndex = String(this.zIndex);
            this.div.style.left = `${x + origin.x}px`;
            this.div.style.top = `${y + (0, $cBHcM.TOOLTIP_VERTICAL_OFFSET) + origin.y}px`;
            if (!(0, $b1d29c834e82fef5$export$8ee0fc9ee280b4ee)(tip)) this.div.innerHTML = tip.replace(/\n/g, '<br>');
            else {
                this.div.innerHTML = '';
                this.div.appendChild(tip);
            }
            this.div.style.visibility = '';
            (0, $b55d6ca3b42398e2$export$1e044b7877db048c)(this.div);
        }
    }
    /**
     * Destroys the handler and all its resources and DOM nodes.
     */ onDestroy() {
        if (!this.destroyed) {
            this.resetTimer();
            this.graph.removeMouseListener(this);
            if (this.div) (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).release(this.div);
            if (this.div?.parentNode) this.div.parentNode.removeChild(this.div);
            this.destroyed = true;
            this.div = null;
        }
    }
    /**
     * Returns the string or DOM node that represents the tooltip for the given state, node and coordinate pair.
     *
     * This implementation checks if the given node is a folding icon or overlay and returns the respective tooltip.
     * - If this does not result in a tooltip, the handler for the cell is retrieved from {@link SelectionCellsHandler} and the optional `getTooltipForNode` method is called.
     * - If no special tooltip exists here then {@link getTooltipForCell} is used with the cell in the given state as the argument to return a tooltip for the given state.
     *
     * @param state {@link CellState} whose tooltip should be returned.
     * @param node DOM node that is currently under the mouse.
     * @param x X-coordinate of the mouse.
     * @param y Y-coordinate of the mouse.
     *
     * @since 0.23.0
     */ getTooltip(state, node, x, y) {
        let tip = null;
        // Checks if the mouse is over the folding icon
        if (state.control && (node === state.control.node || node.parentNode === state.control.node)) {
            tip = this.graph.getCollapseExpandResource();
            tip = (0, $6bb3a85a9cf63e97$export$324699496a105db8)((0, $78efedcb0f6c688d$export$d73ee8ef04f5226a)(tip) || tip, true).replace(/\\n/g, '<br>');
        }
        if (!tip && state.overlays) state.overlays.forEach((shape)=>{
            // LATER: Exit loop if tip is not null
            if (!tip && (node === shape.node || node.parentNode === shape.node)) tip = shape.overlay ? shape.overlay.toString() ?? null : null;
        });
        if (!tip) {
            const selectionCellsHandler = this.graph.getPlugin('SelectionCellsHandler');
            const handler = selectionCellsHandler?.getHandler(state.cell);
            if (handler && // this method exists at least in EdgeSegmentHandler and ElbowEdgeHandler
            'getTooltipForNode' in handler && typeof handler.getTooltipForNode === 'function') tip = handler.getTooltipForNode(node);
        }
        if (!tip) tip = this.getTooltipForCell(state.cell);
        return tip;
    }
    /**
     * Returns the string or DOM node to be used as the tooltip for the given cell.
     * This implementation uses the {@link Cell.getTooltip} function if it exists, or else it returns {@link convertValueToString} for the cell.
     *
     * To replace all tooltips with the string "Hello, World!", use the following code:
     *
     * ```typescript
     * const tooltipHandler = graph.getPlugin<TooltipHandler>('TooltipHandler')!;
     * tooltipHandler.getTooltipForCell = function(cell) {
     *   return 'Hello, World!';
     * }
     * ```
     *
     * @param cell {@link Cell} whose tooltip should be returned.
     *
     * @since 0.23.0
     */ getTooltipForCell(cell) {
        // Special case for cells that implement their own tooltip method
        // Kept for backward compatibility with mxGraph, currently Cell does not have it in the maxGraph core code and demo/examples
        if (cell && 'getTooltip' in cell && typeof cell.getTooltip === 'function') return cell.getTooltip();
        return this.graph.convertValueToString(cell);
    }
}
$7f5b7d97e04b4503$var$TooltipHandler.pluginId = 'TooltipHandler';
var $7f5b7d97e04b4503$export$2e2bcd8739ae039 = $7f5b7d97e04b4503$var$TooltipHandler;


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 



/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 

var $cBHcM = parcelRequire("cBHcM");
/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
var $cBHcM = parcelRequire("cBHcM");


/**
 * A helper class to highlight cells. Here is an example for a given cell.
 *
 * ```javascript
 * const highlight = new CellHighlight(graph, '#ff0000', 2);
 * highlight.highlight(graph.view.getState(cell));
 * ```
 */ class $9c1b6c331f040a7b$var$CellHighlight {
    constructor(graph, highlightColor, strokeWidth, dashed){
        this.strokeWidth = 0;
        this.dashed = false;
        this.opacity = 100;
        this.shape = null;
        /**
         * Specifies if the highlights should appear on top of everything else in the overlay pane.
         * @default false
         */ this.keepOnTop = false;
        /**
         * Reference to the {@link CellState}.
         * @default null
         */ this.state = null;
        /**
         * Specifies the spacing between the highlight for vertices and the vertex.
         * @default 2
         */ this.spacing = 2;
        this.graph = graph;
        this.highlightColor = highlightColor ?? (0, $cBHcM.DEFAULT_VALID_COLOR);
        this.strokeWidth = strokeWidth ?? (0, $cBHcM.HIGHLIGHT_STROKEWIDTH);
        this.dashed = dashed ?? false;
        this.opacity = (0, $cBHcM.HIGHLIGHT_OPACITY);
        // Updates the marker if the graph changes
        this.repaintHandler = ()=>{
            // Updates reference to state
            if (this.state) {
                const tmp = this.graph.view.getState(this.state.cell);
                if (!tmp) this.hide();
                else {
                    this.state = tmp;
                    this.repaint();
                }
            }
        };
        this.graph.getView().addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).SCALE, this.repaintHandler);
        this.graph.getView().addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).TRANSLATE, this.repaintHandler);
        this.graph.getView().addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).SCALE_AND_TRANSLATE, this.repaintHandler);
        this.graph.getDataModel().addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CHANGE, this.repaintHandler);
        // Hides the marker if the current root changes
        this.resetHandler = ()=>{
            this.hide();
        };
        this.graph.getView().addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).DOWN, this.resetHandler);
        this.graph.getView().addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).UP, this.resetHandler);
    }
    /**
     * Sets the color of the rectangle used to highlight drop targets.
     *
     * @param {string} color - String that represents the new highlight color.
     */ setHighlightColor(color) {
        this.highlightColor = color;
        if (this.shape) this.shape.stroke = color;
    }
    /**
     * Creates and returns the highlight shape for the given state.
     */ drawHighlight() {
        this.shape = this.createShape();
        this.repaint();
        if (this.shape) {
            const node = this.shape.node;
            if (!this.keepOnTop && node?.parentNode?.firstChild !== node && node.parentNode) node.parentNode.insertBefore(node, node.parentNode.firstChild);
        }
    }
    /**
     * Creates and returns the highlight shape for the given state.
     */ createShape() {
        if (!this.state) return null;
        const shape = this.graph.cellRenderer.createShape(this.state);
        shape.svgStrokeTolerance = this.graph.getEventTolerance();
        shape.points = this.state.absolutePoints;
        shape.apply(this.state);
        shape.stroke = this.highlightColor;
        shape.opacity = this.opacity;
        shape.isDashed = this.dashed;
        shape.isShadow = false;
        shape.dialect = 'svg';
        shape.init(this.graph.getView().getOverlayPane());
        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).redirectMouseEvents(shape.node, this.graph, this.state);
        if (this.graph.dialect !== 'svg') shape.pointerEvents = false;
        else shape.svgPointerEvents = 'stroke';
        return shape;
    }
    /**
     * Updates the highlight after a change of the model or view.
     */ getStrokeWidth(state = null) {
        return this.strokeWidth;
    }
    /**
     * Updates the highlight after a change of the model or view.
     */ repaint() {
        if (this.state && this.shape) {
            this.shape.scale = this.state.view.scale;
            if (this.state.cell.isEdge()) {
                this.shape.strokeWidth = this.getStrokeWidth();
                this.shape.points = this.state.absolutePoints;
                this.shape.outline = false;
            } else {
                this.shape.bounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(this.state.x - this.spacing, this.state.y - this.spacing, this.state.width + 2 * this.spacing, this.state.height + 2 * this.spacing);
                this.shape.rotation = this.state.style.rotation ?? 0;
                this.shape.strokeWidth = this.getStrokeWidth() / this.state.view.scale;
                this.shape.outline = true;
            }
            // Uses cursor from shape in highlight
            if (this.state.shape) this.shape.setCursor(this.state.shape.getCursor());
            this.shape.redraw();
        }
    }
    /**
     * Resets the state of the cell marker.
     */ hide() {
        this.highlight(null);
    }
    /**
     * Marks the {@link CellState} and fires a {@link InternalEvent.MARK} event.
     */ highlight(state = null) {
        if (this.state !== state) {
            if (this.shape) {
                this.shape.destroy();
                this.shape = null;
            }
            this.state = state;
            if (this.state) this.drawHighlight();
        }
    }
    /**
     * Returns true if this highlight is at the given position.
     */ isHighlightAt(x, y) {
        let hit = false;
        if (this.shape && document.elementFromPoint) {
            let elt = document.elementFromPoint(x, y);
            while(elt){
                if (elt === this.shape.node) {
                    hit = true;
                    break;
                }
                elt = elt.parentNode;
            }
        }
        return hit;
    }
    /**
     * Destroys the handler and all its resources and DOM nodes.
     */ destroy() {
        const graph = this.graph;
        graph.getView().removeListener(this.resetHandler);
        graph.getView().removeListener(this.repaintHandler);
        graph.getDataModel().removeListener(this.repaintHandler);
        if (this.shape) {
            this.shape.destroy();
            this.shape = null;
        }
    }
}
var $9c1b6c331f040a7b$export$2e2bcd8739ae039 = $9c1b6c331f040a7b$var$CellHighlight;





/**
 * A helper class to process mouse locations and highlight cells.
 *
 * To add a cell marker to an existing graph for highlighting all cells, the following code is used:
 *
 * ```javascript
 * const marker = new CellMarker(graph);
 * graph.addMouseListener({
 *   mouseDown: ()=> {},
 *   mouseMove: (sender, me) => {
 *     marker.process(me);
 *   },
 *   mouseUp: ()=> {}
 * });
 * ```
 *
 * ### Events
 * **{@link InternalEvent.MARK}**
 *
 * Fires after a cell has been marked or unmarked. The `state` property contains the marked {@link CellState} or `null` if no state is marked.
 */ class $41e693d31e181f17$var$CellMarker extends (0, $17f25eceeba97548$export$2e2bcd8739ae039) {
    /**
     * Constructs a new cell marker.
     *
     * @param graph Reference to the enclosing {@link AbstractGraph}.
     * @param validColor Optional marker color for valid states. Default is {@link DEFAULT_VALID_COLOR}.
     * @param invalidColor Optional marker color for invalid states. Default is {@link DEFAULT_INVALID_COLOR}.
     * @param hotspot Portion of the width and height where a state intersects a given coordinate pair. A value of 0 means always highlight. Default is {@link DEFAULT_HOTSPOT}.
     */ constructor(graph, validColor = (0, $cBHcM.DEFAULT_VALID_COLOR), invalidColor = (0, $cBHcM.DEFAULT_INVALID_COLOR), hotspot = (0, $cBHcM.DEFAULT_HOTSPOT)){
        super();
        /**
         * Specifies if the marker is enabled.
         * @default true
         */ this.enabled = true;
        /**
         * Specifies the portion of the width and height that should trigger a highlight.
         *
         * The area around the center of the cell to be marked is used as the hotspot. Possible values are between 0 and 1.
         * @default DEFAULT_HOTSPOT
         */ this.hotspot = (0, $cBHcM.DEFAULT_HOTSPOT);
        /**
         * Specifies if the hotspot is enabled.
         * @default false
         */ this.hotspotEnabled = false;
        /**
         * Holds the current marker color.
         */ this.currentColor = (0, $cBHcM.NONE);
        /**
         * Holds the marked {@link CellState} if it is valid.
         */ this.validState = null;
        /**
         * Holds the marked {@link CellState}.
         */ this.markedState = null;
        this.graph = graph;
        this.validColor = validColor;
        this.invalidColor = invalidColor;
        this.hotspot = hotspot;
        this.highlight = this.createCellHighlight(graph);
    }
    /**
     * Hook method to override the implementation of {@link highlight}.
     * @since 0.22.0
     */ createCellHighlight(graph) {
        return new (0, $9c1b6c331f040a7b$export$2e2bcd8739ae039)(graph);
    }
    /**
     * Enables or disables event handling.
     * This implementation updates {@link enabled}.
     *
     * @param enabled Boolean that specifies the new enabled state.
     */ setEnabled(enabled) {
        this.enabled = enabled;
    }
    /**
     * Returns true if events are handled.
     * This implementation returns {@link enabled}.
     */ isEnabled() {
        return this.enabled;
    }
    /**
     * Sets the {@link hotspot}.
     */ setHotspot(hotspot) {
        this.hotspot = hotspot;
    }
    /**
     * Returns the {@link hotspot}.
     */ getHotspot() {
        return this.hotspot;
    }
    /**
     * Specifies whether the hotspot should be used in <intersects>.
     */ setHotspotEnabled(enabled) {
        this.hotspotEnabled = enabled;
    }
    /**
     * Returns true if hotspot is used in <intersects>.
     */ isHotspotEnabled() {
        return this.hotspotEnabled;
    }
    /**
     * Returns true if {@link validState} is not `null`.
     */ hasValidState() {
        return !!this.validState;
    }
    /**
     * Returns the {@link validState}.
     */ getValidState() {
        return this.validState;
    }
    /**
     * Returns the {@link markedState}.
     */ getMarkedState() {
        return this.markedState;
    }
    /**
     * Resets the state of the cell marker.
     */ reset() {
        this.validState = null;
        if (this.markedState) {
            this.markedState = null;
            this.unmark();
        }
    }
    /**
     * Processes the given event and cell and marks the state returned by {@link getState} with the color returned by {@link getMarkerColor}.
     * If the markerColor is not `null`, then the state is stored in {@link markedState}.
     * If {@link isValidState} returns `true`, then the state is stored in {@link validState} regardless of the marker color.
     * The state is returned regardless of the marker color and valid state.
     */ process(me) {
        let state = null;
        if (this.isEnabled()) {
            state = this.getState(me);
            this.setCurrentState(state, me);
        }
        return state;
    }
    /**
     * Sets and marks the current valid state.
     */ setCurrentState(state, me, color) {
        const isValid = state ? this.isValidState(state) : false;
        color = color ?? this.getMarkerColor(me.getEvent(), state, isValid);
        if (isValid) this.validState = state;
        else this.validState = null;
        if (state !== this.markedState || color !== this.currentColor) {
            this.currentColor = color;
            if (state && this.currentColor !== (0, $cBHcM.NONE)) {
                this.markedState = state;
                this.mark();
            } else if (this.markedState) {
                this.markedState = null;
                this.unmark();
            }
        }
    }
    /**
     * Marks the given cell using the given color, or {@link validColor} if no color is specified.
     */ markCell(cell, color) {
        const state = this.graph.getView().getState(cell);
        if (state) {
            this.currentColor = color ?? this.validColor;
            this.markedState = state;
            this.mark();
        }
    }
    /**
     * Marks the {@link markedState} and fires a {@link InternalEvent.MARK} event.
     */ mark() {
        this.highlight.setHighlightColor(this.currentColor);
        this.highlight.highlight(this.markedState);
        this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MARK, 'state', this.markedState));
    }
    /**
     * Hides the marker and fires a {@link InternalEvent.MARK} event.
     */ unmark() {
        this.mark();
    }
    /**
     * Returns true if the given {@link CellState} is a valid state.
     * If this returns `true`, then the state is stored in {@link validState}.
     * The return value of this method is used as the argument for {@link getMarkerColor}.
     */ isValidState(state) {
        return true;
    }
    /**
     * Returns the {@link validColor} or {@link invalidColor} depending on the value of {@link isValid}.
     * The given {@link CellState} is ignored by this implementation.
     */ getMarkerColor(evt, state, isValid) {
        return isValid ? this.validColor : this.invalidColor;
    }
    /**
     * Uses {@link getCell}, {@link getStateToMark} and {@link intersects} to return the {@link CellState} for the given {@link MouseEvent}.
     */ getState(me) {
        const view = this.graph.getView();
        const cell = this.getCell(me);
        if (!cell) return null;
        const state = this.getStateToMark(view.getState(cell));
        return state && this.intersects(state, me) ? state : null;
    }
    /**
     * Returns the {@link Cell} for the given event and cell.
     * This implementation returns the given cell.
     */ getCell(me) {
        return me.getCell();
    }
    /**
     * Returns the {@link CellState} to be marked for the given {@link CellState} under the mouse.
     * This implementation returns the given state.
     */ getStateToMark(state) {
        return state;
    }
    /**
     * Returns `true` if the given coordinate pair intersects the given state.
     * This returns `true` if the {@link hotspot} is `0` or the coordinates are inside the hotspot for the given cell state.
     */ intersects(state, me) {
        const x = me.getGraphX();
        const y = me.getGraphY();
        if (this.hotspotEnabled) return (0, $f7ff90b8964488a6$export$72155a378789e697)(state, x, y, this.hotspot, (0, $cBHcM.MIN_HOTSPOT_SIZE), (0, $cBHcM.MAX_HOTSPOT_SIZE));
        return true;
    }
    /**
     * Destroys the handler and all its resources and DOM nodes.
     */ destroy() {
        this.highlight.destroy();
        super.destroy();
    }
}
var $41e693d31e181f17$export$2e2bcd8739ae039 = $41e693d31e181f17$var$CellMarker;




var $cBHcM = parcelRequire("cBHcM");


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
/**
 * Extends {@link Shape} to implement an ellipse shape.
 *
 * This shape is registered under `ellipse` in {@link ShapeRegistry} when using {@link Graph} or calling {@link registerDefaultShapes}.
 *
 * @category Vertex Shapes
 */ class $f3582df951663f77$var$EllipseShape extends (0, $d0e43aed19391bda$export$2e2bcd8739ae039) {
    constructor(bounds, fill, stroke, strokeWidth = 1){
        super();
        this.bounds = bounds;
        this.fill = fill;
        this.stroke = stroke;
        this.strokeWidth = strokeWidth;
    }
    /**
     * Paints the ellipse shape.
     */ paintVertexShape(c, x, y, w, h) {
        c.ellipse(x, y, w, h);
        c.fillAndStroke();
    }
}
var $f3582df951663f77$export$2e2bcd8739ae039 = $f3582df951663f77$var$EllipseShape;






/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 


var $cBHcM = parcelRequire("cBHcM");






/**
 * Handles constraints on connection targets. This class is in charge of
 * showing fixed points when the mouse is over a vertex and handles constraints
 * to establish new connections.
 *
 */ class $34290ae7320e7535$var$ConstraintHandler {
    constructor(graph){
        /**
         * {@link Image} to be used as the image for fixed connection points.
         */ this.pointImage = new (0, $6af2797f00fe3156$export$2e2bcd8739ae039)(`${(0, $d47e32a58f71e01d$export$2e2bcd8739ae039).imageBasePath}/point.gif`, 5, 5);
        this.currentFocus = null;
        this.currentFocusArea = null;
        this.focusIcons = [];
        this.constraints = null;
        this.currentConstraint = null;
        this.focusHighlight = null;
        this.focusPoints = [];
        this.currentPoint = null;
        /**
         * Specifies if events are handled. Default is true.
         */ this.enabled = true;
        /**
         * Specifies the color for the highlight. Default is {@link DEFAULT_VALID_COLOR}.
         */ this.highlightColor = (0, $cBHcM.DEFAULT_VALID_COLOR);
        this.mouseleaveHandler = null;
        this.graph = graph;
        // Adds a graph model listener to update the current focus on changes
        this.resetHandler = ()=>{
            if (this.currentFocus && !this.graph.view.getState(this.currentFocus.cell)) this.reset();
            else this.redraw();
        };
        this.graph.model.addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CHANGE, this.resetHandler);
        this.graph.view.addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).SCALE_AND_TRANSLATE, this.resetHandler);
        this.graph.view.addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).TRANSLATE, this.resetHandler);
        this.graph.view.addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).SCALE, this.resetHandler);
        this.graph.addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).ROOT, this.resetHandler);
    }
    /**
     * Returns true if events are handled. This implementation
     * returns {@link enabled}.
     */ isEnabled() {
        return this.enabled;
    }
    /**
     * Enables or disables event handling. This implementation
     * updates {@link enabled}.
     *
     * @param {boolean} enabled - Boolean that specifies the new enabled state.
     */ setEnabled(enabled) {
        this.enabled = enabled;
    }
    /**
     * Resets the state of this handler.
     */ reset() {
        for(let i = 0; i < this.focusIcons.length; i += 1)this.focusIcons[i].destroy();
        this.focusIcons = [];
        if (this.focusHighlight) {
            this.focusHighlight.destroy();
            this.focusHighlight = null;
        }
        this.currentConstraint = null;
        this.currentFocusArea = null;
        this.currentPoint = null;
        this.currentFocus = null;
        this.focusPoints = [];
    }
    /**
     * Returns the tolerance to be used for intersecting connection points. This
     * implementation returns {@link mxGraph.tolerance}.
     *
     * @param me {@link mxMouseEvent} whose tolerance should be returned.
     */ getTolerance(me) {
        return this.graph.getEventTolerance();
    }
    /**
     * Returns the tolerance to be used for intersecting connection points.
     */ getImageForConstraint(state, constraint, point) {
        return this.pointImage;
    }
    /**
     * Returns true if the given {@link mxMouseEvent} should be ignored in {@link update}. This
     * implementation always returns false.
     */ isEventIgnored(me, source = false) {
        return false;
    }
    /**
     * Returns true if the given state should be ignored. This always returns false.
     */ isStateIgnored(state, source = false) {
        return false;
    }
    /**
     * Destroys the {@link focusIcons} if they exist.
     */ destroyIcons() {
        for(let i = 0; i < this.focusIcons.length; i += 1)this.focusIcons[i].destroy();
        this.focusIcons = [];
        this.focusPoints = [];
    }
    /**
     * Destroys the {@link focusHighlight} if one exists.
     */ destroyFocusHighlight() {
        if (this.focusHighlight) {
            this.focusHighlight.destroy();
            this.focusHighlight = null;
        }
    }
    /**
     * Returns true if the current focused state should not be changed for the given event.
     * This returns true if shift and alt are pressed.
     */ isKeepFocusEvent(me) {
        return (0, $f192e93a2fd1153c$export$1d7fd696f3493e74)(me.getEvent());
    }
    /**
     * Returns the cell for the given event.
     */ getCellForEvent(me, point) {
        let cell = me.getCell();
        // Gets cell under actual point if different from event location
        if (!cell && point && (me.getGraphX() !== point.x || me.getGraphY() !== point.y)) cell = this.graph.getCellAt(point.x, point.y);
        // Uses connectable parent vertex if one exists
        if (cell && !cell.isConnectable()) {
            const parent = cell.getParent();
            if (parent && parent.isVertex() && parent.isConnectable()) cell = parent;
        }
        if (cell) return this.graph.isCellLocked(cell) ? null : cell;
        else return null;
    }
    /**
     * Updates the state of this handler based on the given {@link mxMouseEvent}.
     * Source is a boolean indicating if the cell is a source or target.
     */ update(me, source, existingEdge, point) {
        if (this.isEnabled() && !this.isEventIgnored(me)) {
            // Lazy installation of mouseleave handler
            if (!this.mouseleaveHandler && this.graph.container) {
                this.mouseleaveHandler = ()=>{
                    this.reset();
                };
                (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addListener(this.graph.container, 'mouseleave', this.resetHandler);
            }
            const tol = this.getTolerance(me);
            const x = point ? point.x : me.getGraphX();
            const y = point ? point.y : me.getGraphY();
            const grid = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(x - tol, y - tol, 2 * tol, 2 * tol);
            const mouse = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(me.getGraphX() - tol, me.getGraphY() - tol, 2 * tol, 2 * tol);
            const state = this.graph.view.getState(this.getCellForEvent(me, point));
            // Keeps focus icons visible while over vertex bounds and no other cell under mouse or shift is pressed
            if (!this.isKeepFocusEvent(me) && (!this.currentFocusArea || !this.currentFocus || state || !this.currentFocus.cell.isVertex() || !(0, $f7ff90b8964488a6$export$7b0a31e10bbff018)(this.currentFocusArea, mouse)) && state !== this.currentFocus) {
                this.currentFocusArea = null;
                this.currentFocus = null;
                this.setFocus(me, state, source);
            }
            this.currentConstraint = null;
            this.currentPoint = null;
            let minDistSq = null;
            let tmp;
            if (this.focusIcons.length > 0 && this.constraints && (!state || this.currentFocus === state)) {
                const cx = mouse.getCenterX();
                const cy = mouse.getCenterY();
                for(let i = 0; i < this.focusIcons.length; i += 1){
                    const dx = cx - this.focusIcons[i].bounds.getCenterX();
                    const dy = cy - this.focusIcons[i].bounds.getCenterY();
                    tmp = dx * dx + dy * dy;
                    if ((this.intersects(this.focusIcons[i], mouse, source, existingEdge) || point && this.intersects(this.focusIcons[i], grid, source, existingEdge)) && (minDistSq === null || tmp < minDistSq)) {
                        this.currentConstraint = this.constraints[i];
                        this.currentPoint = this.focusPoints[i];
                        minDistSq = tmp;
                        tmp = this.focusIcons[i].bounds.clone();
                        tmp.grow((0, $cBHcM.HIGHLIGHT_SIZE) + 1);
                        tmp.width -= 1;
                        tmp.height -= 1;
                        if (!this.focusHighlight) {
                            const hl = this.createHighlightShape();
                            hl.dialect = 'svg';
                            hl.pointerEvents = false;
                            hl.init(this.graph.getView().getOverlayPane());
                            this.focusHighlight = hl;
                            const getState = ()=>{
                                return this.currentFocus ? this.currentFocus : state;
                            };
                            (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).redirectMouseEvents(hl.node, this.graph, getState);
                        }
                        this.focusHighlight.bounds = tmp;
                        this.focusHighlight.redraw();
                    }
                }
            }
            if (!this.currentConstraint) this.destroyFocusHighlight();
        } else {
            this.currentConstraint = null;
            this.currentFocus = null;
            this.currentPoint = null;
        }
    }
    /**
     * Transfers the focus to the given state as a source or target terminal. If
     * the handler is not enabled then the outline is painted, but the constraints
     * are ignored.
     */ redraw() {
        if (this.currentFocus && this.constraints && this.focusIcons.length > 0) {
            const state = this.graph.view.getState(this.currentFocus.cell);
            this.currentFocus = state;
            this.currentFocusArea = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(state.x, state.y, state.width, state.height);
            for(let i = 0; i < this.constraints.length; i += 1){
                const cp = this.graph.getConnectionPoint(state, this.constraints[i]);
                const img = this.getImageForConstraint(state, this.constraints[i], cp);
                const bounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(Math.round(cp.x - img.width / 2), Math.round(cp.y - img.height / 2), img.width, img.height);
                this.focusIcons[i].bounds = bounds;
                this.focusIcons[i].redraw();
                this.currentFocusArea.add(this.focusIcons[i].bounds);
                this.focusPoints[i] = cp;
            }
        }
    }
    /**
     * Transfers the focus to the given state as a source or target terminal. If
     * the handler is not enabled then the outline is painted, but the constraints
     * are ignored.
     */ setFocus(me, state, source) {
        this.constraints = state && !this.isStateIgnored(state, source) && state.cell.isConnectable() ? this.isEnabled() ? this.graph.getAllConnectionConstraints(state, source) ?? [] : [] : null;
        // Only uses cells which have constraints
        if (this.constraints && state) {
            this.currentFocus = state;
            this.currentFocusArea = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(state.x, state.y, state.width, state.height);
            for(let i = 0; i < this.focusIcons.length; i += 1)this.focusIcons[i].destroy();
            this.focusIcons = [];
            this.focusPoints = [];
            for(let i = 0; i < this.constraints.length; i += 1){
                const cp = this.graph.getConnectionPoint(state, this.constraints[i]);
                const img = this.getImageForConstraint(state, this.constraints[i], cp);
                const { src: src } = img;
                const bounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(Math.round(cp.x - img.width / 2), Math.round(cp.y - img.height / 2), img.width, img.height);
                const icon = new (0, $48f65d6d4849e478$export$2e2bcd8739ae039)(bounds, src);
                icon.dialect = this.graph.dialect !== 'svg' ? 'mixedHtml' : 'svg';
                icon.preserveImageAspect = false;
                icon.init(this.graph.getView().getDecoratorPane());
                // Move the icon behind all other overlays
                if (icon.node.previousSibling) icon.node.parentNode?.insertBefore(icon.node, icon.node.parentNode.firstChild);
                const getState = ()=>{
                    return this.currentFocus ? this.currentFocus : state;
                };
                icon.redraw();
                (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).redirectMouseEvents(icon.node, this.graph, getState);
                this.currentFocusArea.add(icon.bounds);
                this.focusIcons.push(icon);
                this.focusPoints.push(cp);
            }
            this.currentFocusArea.grow(this.getTolerance(me));
        } else {
            this.destroyIcons();
            this.destroyFocusHighlight();
        }
    }
    /**
     * Create the shape used to paint the highlight.
     *
     * Returns true if the given icon intersects the given point.
     */ createHighlightShape() {
        const hl = new (0, $14ee9ba473f8b778$export$2e2bcd8739ae039)(new (0, $2997c239141ea844$export$2e2bcd8739ae039)(), this.highlightColor, this.highlightColor, (0, $cBHcM.HIGHLIGHT_STROKEWIDTH));
        hl.opacity = (0, $cBHcM.HIGHLIGHT_OPACITY);
        return hl;
    }
    /**
     * Returns `true` if the given icon intersects the given rectangle.
     */ intersects(icon, rectangle, source, existingEdge) {
        return (0, $f7ff90b8964488a6$export$7b0a31e10bbff018)(icon.bounds, rectangle);
    }
    /**
     * Destroy this handler.
     */ onDestroy() {
        this.reset();
        this.graph.model.removeListener(this.resetHandler);
        this.graph.view.removeListener(this.resetHandler);
        this.graph.removeListener(this.resetHandler);
        if (this.mouseleaveHandler && this.graph.container) {
            (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).removeListener(this.graph.container, 'mouseleave', this.mouseleaveHandler);
            this.mouseleaveHandler = null;
        }
    }
}
var $34290ae7320e7535$export$2e2bcd8739ae039 = $34290ae7320e7535$var$ConstraintHandler;







/*
Copyright 2024-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
var $cBHcM = parcelRequire("cBHcM");

var $iy79G = parcelRequire("iy79G");
const $f17931ed28a53cd3$export$3c0f4b700203d869 = {
    addBendOnShiftClickEnabled: false,
    connectFillColor: (0, $cBHcM.CONNECT_HANDLE_FILLCOLOR),
    cursorBend: 'crosshair',
    cursorMovable: 'move',
    cursorTerminal: 'pointer',
    cursorVirtualBend: 'crosshair',
    handleShape: 'square',
    removeBendOnShiftClickEnabled: false,
    selectionColor: (0, $cBHcM.EDGE_SELECTION_COLOR),
    selectionDashed: (0, $cBHcM.EDGE_SELECTION_DASHED),
    selectionStrokeWidth: (0, $cBHcM.EDGE_SELECTION_STROKEWIDTH),
    virtualBendOpacity: 20,
    virtualBendsEnabled: false
};
const $f17931ed28a53cd3$var$defaultEdgeHandlerConfig = {
    ...$f17931ed28a53cd3$export$3c0f4b700203d869
};
const $f17931ed28a53cd3$export$6c79335f7ec8b822 = ()=>{
    (0, $iy79G.shallowCopy)($f17931ed28a53cd3$var$defaultEdgeHandlerConfig, $f17931ed28a53cd3$export$3c0f4b700203d869);
};
const $f17931ed28a53cd3$export$f4c61547d94bf143 = {
    /**
     * Defines the default color to be used for the handle fill color. Use `none` for no color.
     * @default {@link HANDLE_FILLCOLOR}
     */ fillColor: (0, $cBHcM.HANDLE_FILLCOLOR),
    /**
     * Defines the cursor to be used for the label handle.
     * @default 'default'
     * @since 0.20.0
     */ labelCursor: 'default',
    /**
     * Defines the color to be used for the label handle fill color. Use `none` for no color.
     * @default {@link LABEL_HANDLE_FILLCOLOR}
     */ labelFillColor: (0, $cBHcM.LABEL_HANDLE_FILLCOLOR),
    /**
     * Defines the default size for label handles.
     * @default {@link LABEL_HANDLE_SIZE}
     */ labelSize: (0, $cBHcM.LABEL_HANDLE_SIZE),
    /**
     * Defines the default size for handles.
     * @default {@link HANDLE_SIZE}
     */ size: (0, $cBHcM.HANDLE_SIZE),
    /**
     * Defines the default color to be used for the handle stroke color. Use `none` for no color.
     * @default {@link HANDLE_STROKECOLOR}
     */ strokeColor: (0, $cBHcM.HANDLE_STROKECOLOR)
};
const $f17931ed28a53cd3$var$defaultHandleConfig = {
    ...$f17931ed28a53cd3$export$f4c61547d94bf143
};
const $f17931ed28a53cd3$export$c6f2bb763883dccf = ()=>{
    (0, $iy79G.shallowCopy)($f17931ed28a53cd3$var$defaultHandleConfig, $f17931ed28a53cd3$export$f4c61547d94bf143);
};
const $f17931ed28a53cd3$export$1b394cdb5b3999f1 = {
    /**
     * Defines the cursor for a movable vertex.
     * @since 0.20.0
     */ cursorMovable: 'move',
    /**
     * Enable rotation handle
     * @default false
     */ rotationEnabled: false,
    /**
     * Defines the default color to be used for the selection border of vertices. Use `none` for no color.
     * @default {@link VERTEX_SELECTION_COLOR}
     * @since 0.14.0
     */ selectionColor: (0, $cBHcM.VERTEX_SELECTION_COLOR),
    /**
     * Defines the default stroke width to be used for vertex selections.
     * @default {@link VERTEX_SELECTION_STROKEWIDTH}
     * @since 0.14.0
     */ selectionStrokeWidth: (0, $cBHcM.VERTEX_SELECTION_STROKEWIDTH),
    /**
     * Defines the default dashed state to be used for the vertex selection border.
     * @default {@link VERTEX_SELECTION_DASHED}
     * @since 0.14.0
     */ selectionDashed: (0, $cBHcM.VERTEX_SELECTION_DASHED)
};
const $f17931ed28a53cd3$var$defaultVertexHandlerConfig = {
    ...$f17931ed28a53cd3$export$1b394cdb5b3999f1
};
const $f17931ed28a53cd3$export$629890816bf16bd4 = ()=>{
    (0, $iy79G.shallowCopy)($f17931ed28a53cd3$var$defaultVertexHandlerConfig, $f17931ed28a53cd3$export$1b394cdb5b3999f1);
};


/**
 * Graph event handler that reconnects edges, modifies control points and the edge label location.
 * It displays a handle on each waypoint of the edge, and one on each terminal to reconnect it.
 *
 * Uses {@link CellMarker} for finding and highlighting new source and target vertices.
 *
 * **Instantiation**
 *
 * This is the handler of the `'default'` {@link EdgeStyleHandlerKind}. {@link SelectionCellsHandler} creates it for
 * each selected edge whose `EdgeStyle` is registered under that kind in {@link EdgeStyleRegistry}, which covers the
 * built-in `entityRelationEdgeStyle`, the edges without `EdgeStyle`, and any kind having no registered factory.
 *
 * To have maxGraph create a custom implementation instead, register a factory on the plugin:
 * ```typescript
 * selectionCellsHandler.setEdgeHandlerFactory('default', (state) => new MyEdgeHandler(state));
 * ```
 *
 * **Configuration**
 *
 * Some elements of this handler and its subclasses can be configured globally using {@link EdgeHandlerConfig} and
 * {@link HandleConfig}.
 */ class $d02037fd5fbb23ea$var$EdgeHandler {
    constructor(state){
        /**
         * Holds the current validation error while a connection is being changed.
         */ this.error = null;
        /**
         * Holds the {@link Shape}s that represent the points.
         */ this.bends = [];
        /**
         * Specifies if cloning by control-drag is enabled.
         * @default true
         */ this.cloneEnabled = true;
        /**
         * Specifies if removing bends by double click is enabled.
         * @default false
         */ this.dblClickRemoveEnabled = false;
        /**
         * Specifies if removing bends by dropping them on other bends is enabled.
         * @default false
         */ this.mergeRemoveEnabled = false;
        /**
         * Specifies if removing bends by creating straight segments should be enabled.
         * If enabled, this can be overridden by holding down the alt key while moving.
         * @default false
         */ this.straightRemoveEnabled = false;
        /**
         * Specifies if the parent should be highlighted if a child cell is selected.
         * @default false
         */ this.parentHighlightEnabled = false;
        /**
         * Specifies if bends should be added to the graph container.
         * This is updated in {@link constructor} based on whether the edge or one of its terminals has an HTML label in the container.
         */ this.preferHtml = false;
        /**
         * Specifies if the bounds of handles should be used for hit-detection in IE.
         * @default true
         */ this.allowHandleBoundsCheck = true;
        /**
         * Specifies if waypoints should snap to the routing centers of terminals.
         * @default false
         */ this.snapToTerminals = false;
        /**
         * Optional {@link Image} to be used as handles.
         * @default null
         */ this.handleImage = null;
        this.labelHandleImage = null;
        /**
         * Optional tolerance for hit-detection in {@link getHandleForEvent}.
         * @default 0
         */ this.tolerance = 0;
        /**
         * Specifies if connections to the outline of a highlighted target should be
         * enabled. This will allow to place the connection point along the outline of
         * the highlighted target.
         * @default false
         */ this.outlineConnect = false;
        /**
         * Specifies if the label handle should be moved if it intersects with another
         * handle. Uses {@link checkLabelHandle} for checking and moving.
         * @default false
         */ this.manageLabelHandle = false;
        this.currentPoint = null;
        this.parentHighlight = null;
        this.index = null;
        this.isSource = false;
        this.isTarget = false;
        this.isLabel = false;
        this.points = [];
        this.snapPoint = null;
        this.abspoints = [];
        this.startX = 0;
        this.startY = 0;
        this.outline = true;
        this.active = true;
        // `state.shape` must exists.
        this.state = state;
        this.graph = this.state.view.graph;
        this.marker = this.createMarker();
        this.constraintHandler = this.createConstraintHandler();
        // Clones the original points from the cell
        // and makes sure at least one point exists
        this.points = [];
        // Uses the absolute points of the state
        // for the initial configuration and preview
        this.abspoints = this.getSelectionPoints(this.state);
        this.shape = this.createSelectionShape(this.abspoints);
        this.shape.dialect = this.graph.dialect !== 'svg' ? 'mixedHtml' : 'svg';
        this.shape.init(this.graph.getView().getOverlayPane());
        this.shape.pointerEvents = false;
        this.shape.setCursor((0, $f17931ed28a53cd3$export$3c0f4b700203d869).cursorMovable);
        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).redirectMouseEvents(this.shape.node, this.graph, this.state);
        // Updates preferHtml
        this.preferHtml = this.state.text != null && this.state.text.node.parentNode === this.graph.container;
        if (!this.preferHtml) {
            // Checks source terminal
            const sourceState = this.state.getVisibleTerminalState(true);
            if (sourceState != null) this.preferHtml = sourceState.text != null && sourceState.text.node.parentNode === this.graph.container;
            if (!this.preferHtml) {
                // Checks target terminal
                const targetState = this.state.getVisibleTerminalState(false);
                if (targetState != null) this.preferHtml = targetState.text != null && targetState.text.node.parentNode === this.graph.container;
            }
        }
        const selectionHandler = this.graph.getPlugin('SelectionHandler');
        // Creates bends for the non-routed absolute points
        // or bends that don't correspond to points
        if (selectionHandler && (this.graph.getSelectionCount() < selectionHandler.maxCells || selectionHandler.maxCells <= 0)) {
            this.bends = this.createBends();
            if (this.isVirtualBendsEnabled()) this.virtualBends = this.createVirtualBends();
        }
        // Adds a rectangular handle for the label position
        this.label = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(this.state.absoluteOffset.x, this.state.absoluteOffset.y);
        this.labelShape = this.createLabelHandleShape();
        this.initBend(this.labelShape);
        this.labelShape.setCursor((0, $f17931ed28a53cd3$export$f4c61547d94bf143).labelCursor);
        this.customHandles = this.createCustomHandles();
        this.updateParentHighlight();
        this.redraw();
        // Handles escape keystrokes
        this.escapeHandler = (_sender, _evt)=>{
            const dirty = this.index != null;
            this.reset();
            if (dirty) this.graph.cellRenderer.redraw(this.state, false, state.view.isRendering());
        };
        this.state.view.graph.addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).ESCAPE, this.escapeHandler);
    }
    /**
     * Hook for subclasses to change the implementation of {@link ConstraintHandler} used here.
     * @since 0.21.0
     */ createConstraintHandler() {
        return new (0, $34290ae7320e7535$export$2e2bcd8739ae039)(this.graph);
    }
    /**
     * Returns true if the parent highlight should be visible. This implementation
     * always returns true.
     */ isParentHighlightVisible() {
        const parent = this.state.cell.getParent();
        return parent ? !this.graph.isCellSelected(parent) : null;
    }
    /**
     * Updates the highlight of the parent if {@link parentHighlightEnabled} is true.
     */ updateParentHighlight() {
        if (!this.isDestroyed()) {
            const visible = this.isParentHighlightVisible();
            const parent = this.state.cell.getParent();
            const pstate = parent ? this.graph.view.getState(parent) : null;
            if (this.parentHighlight) {
                if (parent && parent.isVertex() && visible) {
                    const b = this.parentHighlight.bounds;
                    if (pstate && b && (b.x !== pstate.x || b.y !== pstate.y || b.width !== pstate.width || b.height !== pstate.height)) {
                        this.parentHighlight.bounds = (0, $2997c239141ea844$export$2e2bcd8739ae039).fromRectangle(pstate);
                        this.parentHighlight.redraw();
                    }
                } else {
                    if (pstate && pstate.parentHighlight === this.parentHighlight) pstate.parentHighlight = null;
                    this.parentHighlight.destroy();
                    this.parentHighlight = null;
                }
            } else if (this.parentHighlightEnabled && visible) {
                if (parent && parent.isVertex() && pstate && !pstate.parentHighlight) {
                    this.parentHighlight = this.createParentHighlightShape(pstate);
                    // VML dialect required here for event transparency in IE
                    this.parentHighlight.dialect = 'svg';
                    this.parentHighlight.pointerEvents = false;
                    if (pstate.style.rotation) this.parentHighlight.rotation = pstate.style.rotation;
                    this.parentHighlight.init(this.graph.getView().getOverlayPane());
                    this.parentHighlight.redraw();
                    // Shows highlight once per parent
                    pstate.parentHighlight = this.parentHighlight;
                }
            }
        }
    }
    /**
     * Returns an array of custom handles. This implementation returns an empty array.
     */ createCustomHandles() {
        return [];
    }
    /**
     * Returns true if virtual bends should be added. This returns true if
     * {@link virtualBendsEnabled} is true and the current style allows and
     * renders custom waypoints.
     */ isVirtualBendsEnabled(evt) {
        return (0, $f17931ed28a53cd3$export$3c0f4b700203d869).virtualBendsEnabled && (this.state.style.edgeStyle == null || this.state.style.edgeStyle === (0, $cBHcM.NONE) || this.state.style.noEdgeStyle) && this.state.style.shape !== 'arrow';
    }
    /**
     * Returns true if the given cell allows new connections to be created. This implementation
     * always returns true.
     */ isCellEnabled(cell) {
        return true;
    }
    /**
     * Returns true if the given event is a trigger to add a new Point. This
     * implementation returns true if shift is pressed.
     */ isAddPointEvent(evt) {
        return (0, $f192e93a2fd1153c$export$1d7fd696f3493e74)(evt);
    }
    /**
     * Returns true if the given event is a trigger to remove a point. This
     * implementation returns true if shift is pressed.
     */ isRemovePointEvent(evt) {
        return (0, $f192e93a2fd1153c$export$1d7fd696f3493e74)(evt);
    }
    /**
     * Returns the list of points that defines the selection stroke.
     */ getSelectionPoints(state) {
        return state.absolutePoints;
    }
    /**
     * Creates the shape used to draw the selection border.
     */ createParentHighlightShape(bounds) {
        const shape = new (0, $14ee9ba473f8b778$export$2e2bcd8739ae039)((0, $2997c239141ea844$export$2e2bcd8739ae039).fromRectangle(bounds), (0, $cBHcM.NONE), this.getSelectionColor());
        shape.strokeWidth = this.getSelectionStrokeWidth();
        shape.isDashed = this.isSelectionDashed();
        return shape;
    }
    /**
     * Creates the shape used to draw the selection border.
     */ createSelectionShape(points) {
        const c = this.state.shape.constructor;
        const shape = new c();
        shape.outline = true;
        shape.apply(this.state);
        shape.isDashed = this.isSelectionDashed();
        shape.stroke = this.getSelectionColor();
        shape.isShadow = false;
        return shape;
    }
    /**
     * Returns {@link EdgeHandlerConfig.selectionColor}.
     */ getSelectionColor() {
        return (0, $f17931ed28a53cd3$export$3c0f4b700203d869).selectionColor;
    }
    /**
     * Returns {@link EdgeHandlerConfig.selectionStrokeWidth}.
     */ getSelectionStrokeWidth() {
        return (0, $f17931ed28a53cd3$export$3c0f4b700203d869).selectionStrokeWidth;
    }
    /**
     * Returns {@link EdgeHandlerConfig.selectionDashed}.
     */ isSelectionDashed() {
        return (0, $f17931ed28a53cd3$export$3c0f4b700203d869).selectionDashed;
    }
    /**
     * Returns true if the given cell is connectable. This is a hook to
     * disable floating connections. This implementation returns true.
     */ isConnectableCell(cell) {
        return true;
    }
    /**
     * Creates and returns the {@link CellMarker} used in {@link marker}.
     */ getCellAt(x, y) {
        return !this.outlineConnect ? this.graph.getCellAt(x, y) : null;
    }
    /**
     * Creates and returns the {@link CellMarker} used in {@link marker}.
     */ createMarker() {
        return new $d02037fd5fbb23ea$var$EdgeHandlerCellMarker(this.graph, this);
    }
    /**
     * Returns the error message or an empty string if the connection for the
     * given source, target pair is not valid. Otherwise, it returns null. This
     * implementation uses {@link AbstractGraph.getEdgeValidationError}.
     *
     * @param source {@link Cell} that represents the source terminal.
     * @param target {@link Cell} that represents the target terminal.
     */ validateConnection(source, target) {
        return this.graph.getEdgeValidationError(this.state.cell, source, target);
    }
    /**
     * Creates and returns the bends used for modifying the edge. This is
     * typically an array of {@link RectangleShape}.
     */ createBends() {
        const { cell: cell } = this.state;
        const bends = [];
        for(let i = 0; i < this.abspoints.length; i += 1)if (this.isHandleVisible(i)) {
            const source = i === 0;
            const target = i === this.abspoints.length - 1;
            const terminal = source || target;
            if (terminal || this.graph.isCellBendable(cell)) ((index)=>{
                const bend = this.createHandleShape(index);
                this.initBend(bend, ()=>{
                    if (this.dblClickRemoveEnabled) this.removePoint(this.state, index);
                });
                if (this.isHandleEnabled(i)) bend.setCursor(terminal ? (0, $f17931ed28a53cd3$export$3c0f4b700203d869).cursorTerminal : (0, $f17931ed28a53cd3$export$3c0f4b700203d869).cursorBend);
                bends.push(bend);
                if (!terminal) {
                    this.points.push(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(0, 0));
                    bend.node.style.visibility = 'hidden';
                }
            })(i);
        }
        return bends;
    }
    /**
     * Creates and returns the bends used for modifying the edge. This is
     * typically an array of {@link RectangleShape}.
     */ createVirtualBends() {
        const { cell: cell } = this.state;
        const last = this.abspoints[0];
        const bends = [];
        if (this.graph.isCellBendable(cell)) for(let i = 1; i < this.abspoints.length; i += 1)((bend)=>{
            this.initBend(bend);
            bend.setCursor((0, $f17931ed28a53cd3$export$3c0f4b700203d869).cursorVirtualBend);
            bends.push(bend);
        })(this.createHandleShape());
        return bends;
    }
    /**
     * Creates the shape used to display the given bend.
     */ isHandleEnabled(index) {
        return true;
    }
    /**
     * Returns true if the handle at the given index is visible.
     */ isHandleVisible(index) {
        const source = this.state.getVisibleTerminalState(true);
        const target = this.state.getVisibleTerminalState(false);
        const geo = this.state.cell.getGeometry();
        const edgeStyle = geo ? this.graph.view.getEdgeStyle(this.state, geo.points || undefined, source, target) : null;
        return (0, $130af394a0fcdee4$export$28d1530539966ca9).allowsIntermediateHandles(edgeStyle) || index === 0 || index === this.abspoints.length - 1;
    }
    /**
     * Creates the shape used to display the given bend.
     * Note that the index
     * - may be `null` for special cases, such as when called from {@link ElbowEdgeHandler.createVirtualBend}.
     * - is `null` for virtual handles.
     *
     * Only images and rectangles should be returned if support for HTML labels with not foreign objects is required.
     */ createHandleShape(_index) {
        if (this.handleImage) {
            const shape = new (0, $48f65d6d4849e478$export$2e2bcd8739ae039)(new (0, $2997c239141ea844$export$2e2bcd8739ae039)(0, 0, this.handleImage.width, this.handleImage.height), this.handleImage.src);
            // Allows HTML rendering of the images
            shape.preserveImageAspect = false;
            return shape;
        }
        let s = (0, $f17931ed28a53cd3$export$f4c61547d94bf143).size;
        if (this.preferHtml) s -= 1;
        const shapeConstructor = (0, $f17931ed28a53cd3$export$3c0f4b700203d869).handleShape === 'circle' ? (0, $f3582df951663f77$export$2e2bcd8739ae039) : (0, $14ee9ba473f8b778$export$2e2bcd8739ae039);
        return new shapeConstructor(new (0, $2997c239141ea844$export$2e2bcd8739ae039)(0, 0, s, s), (0, $f17931ed28a53cd3$export$f4c61547d94bf143).fillColor, (0, $f17931ed28a53cd3$export$f4c61547d94bf143).strokeColor);
    }
    /**
     * Creates the shape used to display the label handle.
     */ createLabelHandleShape() {
        if (this.labelHandleImage) {
            const shape = new (0, $48f65d6d4849e478$export$2e2bcd8739ae039)(new (0, $2997c239141ea844$export$2e2bcd8739ae039)(0, 0, this.labelHandleImage.width, this.labelHandleImage.height), this.labelHandleImage.src);
            // Allows HTML rendering of the images
            shape.preserveImageAspect = false;
            return shape;
        }
        const s = (0, $f17931ed28a53cd3$export$f4c61547d94bf143).labelSize;
        return new (0, $14ee9ba473f8b778$export$2e2bcd8739ae039)(new (0, $2997c239141ea844$export$2e2bcd8739ae039)(0, 0, s, s), (0, $f17931ed28a53cd3$export$f4c61547d94bf143).labelFillColor, (0, $f17931ed28a53cd3$export$f4c61547d94bf143).strokeColor);
    }
    /**
     * Helper method to initialize the given bend.
     *
     * @param bend {@link Shape} that represents the bend to be initialized.
     * @param dblClick Optional function to be called on double click.
     */ initBend(bend, dblClick) {
        if (this.preferHtml) {
            bend.dialect = 'strictHtml';
            bend.init(this.graph.container);
        } else {
            bend.dialect = this.graph.dialect !== 'svg' ? 'mixedHtml' : 'svg';
            bend.init(this.graph.getView().getOverlayPane());
        }
        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).redirectMouseEvents(bend.node, this.graph, this.state, null, null, null, dblClick);
        if ((0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_TOUCH) bend.node.setAttribute('pointer-events', 'none');
    }
    /**
     * Returns the index of the handle for the given event.
     */ getHandleForEvent(me) {
        let result = null;
        // Connection highlight may consume events before they reach sizer handle
        const tol = !(0, $f192e93a2fd1153c$export$764db16956f554f8)(me.getEvent()) ? this.tolerance : 1;
        const hit = this.allowHandleBoundsCheck && tol > 0 ? new (0, $2997c239141ea844$export$2e2bcd8739ae039)(me.getGraphX() - tol, me.getGraphY() - tol, 2 * tol, 2 * tol) : null;
        let minDistSq = Number.POSITIVE_INFINITY;
        function checkShape(shape) {
            if (shape && shape.bounds && shape.node && shape.node.style.display !== 'none' && shape.node.style.visibility !== 'hidden' && (me.isSource(shape) || hit && (0, $f7ff90b8964488a6$export$7b0a31e10bbff018)(shape.bounds, hit))) {
                const dx = me.getGraphX() - shape.bounds.getCenterX();
                const dy = me.getGraphY() - shape.bounds.getCenterY();
                const tmp = dx * dx + dy * dy;
                if (tmp <= minDistSq) {
                    minDistSq = tmp;
                    return true;
                }
            }
            return false;
        }
        if (this.isCustomHandleEvent(me) && this.customHandles) // Inverse loop order to match display order
        for(let i = this.customHandles.length - 1; i >= 0; i--){
            if (checkShape(this.customHandles[i].shape)) // LATER: Return reference to active shape
            return (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CUSTOM_HANDLE - i;
        }
        if (me.isSource(this.state.text) || checkShape(this.labelShape)) result = (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).LABEL_HANDLE;
        for(let i = 0; i < this.bends.length; i += 1)if (checkShape(this.bends[i])) result = i;
        if (this.virtualBends && this.isAddVirtualBendEvent(me)) {
            for(let i = 0; i < this.virtualBends.length; i += 1)if (checkShape(this.virtualBends[i])) result = (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).VIRTUAL_HANDLE - i;
        }
        return result;
    }
    /**
     * Returns true if the given event allows virtual bends to be added. This
     * implementation returns true.
     */ isAddVirtualBendEvent(me) {
        return true;
    }
    /**
     * Returns true if the given event allows custom handles to be changed. This
     * implementation returns true.
     */ isCustomHandleEvent(me) {
        return true;
    }
    /**
     * Handles the event by checking if a special element of the handler
     * was clicked, in which case the index parameter is non-null. The
     * indices may be one of {@link InternalEvent.LABEL_HANDLE} or the number of the respective
     * control point. The source and target points are used for reconnecting
     * the edge.
     */ mouseDown(_sender, me) {
        const handle = this.getHandleForEvent(me);
        if (handle !== null && this.bends[handle]) {
            const b = this.bends[handle].bounds;
            if (b) this.snapPoint = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(b.getCenterX(), b.getCenterY());
        }
        if ((0, $f17931ed28a53cd3$export$3c0f4b700203d869).addBendOnShiftClickEnabled && handle === null && this.isAddPointEvent(me.getEvent())) {
            this.addPoint(this.state, me.getEvent());
            me.consume();
        } else if (handle !== null && !me.isConsumed() && this.graph.isEnabled()) {
            const cell = me.getCell();
            if ((0, $f17931ed28a53cd3$export$3c0f4b700203d869).removeBendOnShiftClickEnabled && this.isRemovePointEvent(me.getEvent())) this.removePoint(this.state, handle);
            else if (handle !== (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).LABEL_HANDLE || cell && this.graph.isLabelMovable(cell)) {
                if (this.virtualBends && handle <= (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).VIRTUAL_HANDLE) (0, $b55d6ca3b42398e2$export$2646c6b151d2e8)(this.virtualBends[(0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).VIRTUAL_HANDLE - handle].node, 100);
                this.start(me.getX(), me.getY(), handle);
            }
            me.consume();
        }
    }
    /**
     * Starts the handling of the mouse gesture.
     */ start(x, y, index) {
        this.startX = x;
        this.startY = y;
        this.isSource = this.bends.length === 0 ? false : index === 0;
        this.isTarget = this.bends.length === 0 ? false : index === this.bends.length - 1;
        this.isLabel = index === (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).LABEL_HANDLE;
        if (this.isSource || this.isTarget) {
            const { cell: cell } = this.state;
            const terminal = cell.getTerminal(this.isSource);
            if (terminal == null && this.graph.isTerminalPointMovable(cell, this.isSource) || terminal != null && this.graph.isCellDisconnectable(cell, terminal, this.isSource)) this.index = index;
        } else this.index = index;
        // Hides other custom handles
        if (this.index !== null && this.index <= (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CUSTOM_HANDLE && this.index > (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).VIRTUAL_HANDLE) {
            if (this.customHandles != null) {
                for(let i = 0; i < this.customHandles.length; i += 1)if (i !== (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CUSTOM_HANDLE - this.index) this.customHandles[i].setVisible(false);
            }
        }
    }
    /**
     * Returns a clone of the current preview state for the given point and terminal.
     */ clonePreviewState(point, terminal) {
        return this.state.clone();
    }
    /**
     * Returns the tolerance for the guides. Default value is
     * gridSize * scale / 2.
     */ getSnapToTerminalTolerance() {
        return this.graph.getGridSize() * this.graph.getView().scale / 2;
    }
    /**
     * Hook for subclassers do show details while the handler is active.
     */ updateHint(me, point) {
        return;
    }
    /**
     * Hooks for subclassers to hide details when the handler gets inactive.
     */ removeHint() {
        return;
    }
    /**
     * Hook for rounding the unscaled width or height. This uses Math.round.
     */ roundLength(length) {
        return Math.round(length);
    }
    /**
     * Returns true if {@link snapToTerminals} is true and if alt is not pressed.
     */ isSnapToTerminalsEvent(me) {
        return this.snapToTerminals && !(0, $f192e93a2fd1153c$export$bdc3218ff6eba0d8)(me.getEvent());
    }
    /**
     * Returns the point for the given event.
     */ getPointForEvent(me) {
        const view = this.graph.getView();
        const { scale: scale } = view;
        const point = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(this.roundLength(me.getGraphX() / scale) * scale, this.roundLength(me.getGraphY() / scale) * scale);
        const tt = this.getSnapToTerminalTolerance();
        let overrideX = false;
        let overrideY = false;
        if (tt > 0 && this.isSnapToTerminalsEvent(me)) {
            const snapToPoint = (pt)=>{
                if (pt) {
                    const { x: x } = pt;
                    if (Math.abs(point.x - x) < tt) {
                        point.x = x;
                        overrideX = true;
                    }
                    const { y: y } = pt;
                    if (Math.abs(point.y - y) < tt) {
                        point.y = y;
                        overrideY = true;
                    }
                }
            };
            // Temporary function
            const snapToTerminal = (terminal)=>{
                if (terminal) snapToPoint(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(view.getRoutingCenterX(terminal), view.getRoutingCenterY(terminal)));
            };
            snapToTerminal(this.state.getVisibleTerminalState(true));
            snapToTerminal(this.state.getVisibleTerminalState(false));
            for(let i = 0; i < this.state.absolutePoints.length; i += 1)snapToPoint(this.state.absolutePoints[i]);
        }
        if (this.graph.isGridEnabledEvent(me.getEvent())) {
            const tr = view.translate;
            if (!overrideX) point.x = (this.graph.snap(point.x / scale - tr.x) + tr.x) * scale;
            if (!overrideY) point.y = (this.graph.snap(point.y / scale - tr.y) + tr.y) * scale;
        }
        return point;
    }
    /**
     * Updates the given preview state taking into account the state of the constraint handler.
     */ getPreviewTerminalState(me) {
        this.constraintHandler.update(me, this.isSource, true, me.isSource(this.marker.highlight.shape) ? null : this.currentPoint);
        if (this.constraintHandler.currentFocus && this.constraintHandler.currentConstraint) {
            // Handles special case where grid is large and connection point is at actual point in which
            // case the outline is not followed as long as we're < gridSize / 2 away from that point
            if (this.marker.highlight && this.marker.highlight.shape && this.marker.highlight.state && this.marker.highlight.state.cell === this.constraintHandler.currentFocus.cell) // Direct repaint needed if cell already highlighted
            {
                if (this.marker.highlight.shape.stroke !== 'transparent') {
                    this.marker.highlight.shape.stroke = 'transparent';
                    this.marker.highlight.repaint();
                }
            } else this.marker.markCell(this.constraintHandler.currentFocus.cell, 'transparent');
            const other = this.graph.view.getTerminalPort(this.state, this.graph.view.getState(this.state.cell.getTerminal(!this.isSource)), !this.isSource);
            const otherCell = other ? other.cell : null;
            const source = this.isSource ? this.constraintHandler.currentFocus.cell : otherCell;
            const target = this.isSource ? otherCell : this.constraintHandler.currentFocus.cell;
            // Updates the error message of the handler
            this.error = this.validateConnection(source, target);
            let result = null;
            if (this.error === null) result = this.constraintHandler.currentFocus;
            if (this.error !== null || result && !this.isCellEnabled(result.cell)) this.constraintHandler.reset();
            return result;
        }
        if (!this.graph.isIgnoreTerminalEvent(me.getEvent())) {
            this.marker.process(me);
            const state = this.marker.getValidState();
            if (state && !this.isCellEnabled(state.cell)) {
                this.constraintHandler.reset();
                this.marker.reset();
            }
            return this.marker.getValidState();
        }
        this.marker.reset();
        return null;
    }
    /**
     * Updates the given preview state taking into account the state of the constraint handler.
     *
     * @param pt {@link Point} that contains the current pointer position.
     * @param me Optional {@link MouseEvent} that contains the current event.
     */ getPreviewPoints(pt, me) {
        const geometry = this.state.cell.getGeometry();
        if (!geometry) return null;
        let points = (geometry.points || []).slice();
        const point = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(pt.x, pt.y);
        let result = null;
        if (!this.isSource && !this.isTarget && this.index !== null) {
            this.convertPoint(point, false);
            // Adds point from virtual bend
            if (this.index <= (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).VIRTUAL_HANDLE) points.splice((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).VIRTUAL_HANDLE - this.index, 0, point);
            // Removes point if dragged on terminal point
            if (!this.isSource && !this.isTarget) {
                for(let i = 0; i < this.bends.length; i += 1)if (i !== this.index) {
                    const bend = this.bends[i];
                    if (bend && (0, $f7ff90b8964488a6$export$2344b14b097df817)(bend.bounds, pt.x, pt.y)) {
                        if (this.index <= (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).VIRTUAL_HANDLE) points.splice((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).VIRTUAL_HANDLE - this.index, 1);
                        else points.splice(this.index - 1, 1);
                        result = points;
                    }
                }
                // Removes point if user tries to straighten a segment
                if (!result && this.straightRemoveEnabled && (!me || !(0, $f192e93a2fd1153c$export$bdc3218ff6eba0d8)(me.getEvent()))) {
                    const tol = this.graph.getEventTolerance() * this.graph.getEventTolerance();
                    const abs = this.state.absolutePoints.slice();
                    abs[this.index] = pt;
                    // Handes special case where removing waypoint affects tolerance (flickering)
                    const src = this.state.getVisibleTerminalState(true);
                    if (src != null) {
                        const c = this.graph.getConnectionConstraint(this.state, src, true);
                        // Checks if point is not fixed
                        if (c == null || this.graph.getConnectionPoint(src, c) == null) abs[0] = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(src.view.getRoutingCenterX(src), src.view.getRoutingCenterY(src));
                    }
                    const trg = this.state.getVisibleTerminalState(false);
                    if (trg != null) {
                        const c = this.graph.getConnectionConstraint(this.state, trg, false);
                        // Checks if point is not fixed
                        if (c == null || this.graph.getConnectionPoint(trg, c) == null) abs[abs.length - 1] = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(trg.view.getRoutingCenterX(trg), trg.view.getRoutingCenterY(trg));
                    }
                    const checkRemove = (idx, tmp)=>{
                        if (idx > 0 && idx < abs.length - 1 && (0, $f7ff90b8964488a6$export$545acef63fa0c8)(abs[idx - 1].x, abs[idx - 1].y, abs[idx + 1].x, abs[idx + 1].y, tmp.x, tmp.y) < tol) {
                            points.splice(idx - 1, 1);
                            result = points;
                        }
                    };
                    // LATER: Check if other points can be removed if a segment is made straight
                    checkRemove(this.index, pt);
                }
            }
            // Updates existing point
            if (result == null && this.index > (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).VIRTUAL_HANDLE) points[this.index - 1] = point;
        } else if (this.graph.isResetEdgesOnConnect()) points = [];
        return result != null ? result : points;
    }
    /**
     * Returns true if {@link outlineConnect} is true and the source of the event is the outline shape
     * or shift is pressed.
     */ isOutlineConnectEvent(me) {
        if (!this.currentPoint) return false;
        const offset = (0, $b55d6ca3b42398e2$export$622cea445a1c5b7d)(this.graph.container);
        const evt = me.getEvent();
        const clientX = (0, $f192e93a2fd1153c$export$87583e2c100c6a4f)(evt);
        const clientY = (0, $f192e93a2fd1153c$export$195fc3609401443f)(evt);
        const doc = document.documentElement;
        const left = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
        const top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
        const gridX = this.currentPoint.x - this.graph.container.scrollLeft + offset.x - left;
        const gridY = this.currentPoint.y - this.graph.container.scrollTop + offset.y - top;
        return this.outlineConnect && !(0, $f192e93a2fd1153c$export$1d7fd696f3493e74)(me.getEvent()) && (me.isSource(this.marker.highlight.shape) || (0, $f192e93a2fd1153c$export$bdc3218ff6eba0d8)(me.getEvent()) && me.getState() != null || this.marker.highlight.isHighlightAt(clientX, clientY) || (gridX !== clientX || gridY !== clientY) && me.getState() == null && this.marker.highlight.isHighlightAt(gridX, gridY));
    }
    /**
     * Updates the given preview state taking into account the state of the constraint handler.
     */ updatePreviewState(edgeState, point, terminalState, me, outline = false) {
        // Computes the points for the edge style and terminals
        const sourceState = this.isSource ? terminalState : this.state.getVisibleTerminalState(true);
        const targetState = this.isTarget ? terminalState : this.state.getVisibleTerminalState(false);
        let sourceConstraint = this.graph.getConnectionConstraint(edgeState, sourceState, true);
        let targetConstraint = this.graph.getConnectionConstraint(edgeState, targetState, false);
        let constraint = this.constraintHandler.currentConstraint;
        if (constraint == null && outline) {
            if (terminalState != null) {
                // Handles special case where mouse is on outline away from actual end point
                // in which case the grid is ignored and mouse point is used instead
                if (me.isSource(this.marker.highlight.shape)) point = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(me.getGraphX(), me.getGraphY());
                constraint = this.graph.getOutlineConstraint(point, terminalState, me);
                this.constraintHandler.setFocus(me, terminalState, this.isSource);
                this.constraintHandler.currentConstraint = constraint;
                this.constraintHandler.currentPoint = point;
            } else constraint = new (0, $cb4bce61eb363699$export$2e2bcd8739ae039)(null);
        }
        if (this.outlineConnect && this.marker.highlight != null && this.marker.highlight.shape != null) {
            const s = this.graph.view.scale;
            if (this.constraintHandler.currentConstraint != null && this.constraintHandler.currentFocus != null) {
                this.marker.highlight.shape.stroke = outline ? (0, $cBHcM.OUTLINE_HIGHLIGHT_COLOR) : 'transparent';
                this.marker.highlight.shape.strokeWidth = (0, $cBHcM.OUTLINE_HIGHLIGHT_STROKEWIDTH) / s / s;
                this.marker.highlight.repaint();
            } else if (this.marker.hasValidState()) {
                const cell = me.getCell();
                this.marker.highlight.shape.stroke = cell && cell.isConnectable() && this.marker.getValidState() !== me.getState() ? 'transparent' : (0, $cBHcM.DEFAULT_VALID_COLOR);
                this.marker.highlight.shape.strokeWidth = (0, $cBHcM.HIGHLIGHT_STROKEWIDTH) / s / s;
                this.marker.highlight.repaint();
            }
        }
        if (this.isSource) sourceConstraint = constraint;
        else if (this.isTarget) targetConstraint = constraint;
        if (this.isSource || this.isTarget) {
            if (constraint != null && constraint.point != null) {
                edgeState.style[this.isSource ? 'exitX' : 'entryX'] = constraint.point.x;
                edgeState.style[this.isSource ? 'exitY' : 'entryY'] = constraint.point.y;
            } else {
                delete edgeState.style[this.isSource ? 'exitX' : 'entryX'];
                delete edgeState.style[this.isSource ? 'exitY' : 'entryY'];
            }
        }
        edgeState.setVisibleTerminalState(sourceState, true);
        edgeState.setVisibleTerminalState(targetState, false);
        if (!this.isSource || sourceState != null) edgeState.view.updateFixedTerminalPoint(edgeState, sourceState, true, sourceConstraint);
        if (!this.isTarget || targetState != null) edgeState.view.updateFixedTerminalPoint(edgeState, targetState, false, targetConstraint);
        if ((this.isSource || this.isTarget) && terminalState == null) {
            edgeState.setAbsoluteTerminalPoint(point, this.isSource);
            if (this.marker.getMarkedState() == null) this.error = this.graph.isAllowDanglingEdges() ? null : '';
        }
        edgeState.view.updatePoints(edgeState, this.points, sourceState, targetState);
        edgeState.view.updateFloatingTerminalPoints(edgeState, sourceState, targetState);
    }
    /**
     * Handles the event by updating the preview.
     */ mouseMove(_sender, me) {
        if (this.index != null && this.marker != null) {
            this.currentPoint = this.getPointForEvent(me);
            this.error = null;
            // Uses the current point from the constraint handler if available
            if (!this.graph.isIgnoreTerminalEvent(me.getEvent()) && (0, $f192e93a2fd1153c$export$1d7fd696f3493e74)(me.getEvent()) && this.snapPoint != null) {
                if (Math.abs(this.snapPoint.x - this.currentPoint.x) < Math.abs(this.snapPoint.y - this.currentPoint.y)) this.currentPoint.x = this.snapPoint.x;
                else this.currentPoint.y = this.snapPoint.y;
            }
            if (this.index <= (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CUSTOM_HANDLE && this.index > (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).VIRTUAL_HANDLE) {
                if (this.customHandles != null) {
                    this.customHandles[(0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CUSTOM_HANDLE - this.index].processEvent(me);
                    this.customHandles[(0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CUSTOM_HANDLE - this.index].positionChanged();
                    if (this.shape != null && this.shape.node != null) this.shape.node.style.display = 'none';
                }
            } else if (this.isLabel && this.label) {
                this.label.x = this.currentPoint.x;
                this.label.y = this.currentPoint.y;
            } else {
                this.points = this.getPreviewPoints(this.currentPoint, me);
                let terminalState = this.isSource || this.isTarget ? this.getPreviewTerminalState(me) : null;
                if (this.constraintHandler.currentConstraint != null && this.constraintHandler.currentFocus != null && this.constraintHandler.currentPoint != null) this.currentPoint = this.constraintHandler.currentPoint.clone();
                else if (this.outlineConnect) {
                    // Need to check outline before cloning terminal state
                    const outline = this.isSource || this.isTarget ? this.isOutlineConnectEvent(me) : false;
                    if (outline) terminalState = this.marker.highlight.state;
                    else if (terminalState != null && terminalState !== me.getState() && me.getCell()?.isConnectable() && this.marker.highlight.shape != null) {
                        this.marker.highlight.shape.stroke = 'transparent';
                        this.marker.highlight.repaint();
                        terminalState = null;
                    }
                }
                if (terminalState != null && !this.isCellEnabled(terminalState.cell)) {
                    terminalState = null;
                    this.marker.reset();
                }
                if (this.currentPoint) {
                    const clone = this.clonePreviewState(this.currentPoint, terminalState != null ? terminalState.cell : null);
                    this.updatePreviewState(clone, this.currentPoint, terminalState, me, this.outline);
                    // Sets the color of the preview to valid or invalid, updates the
                    // points of the preview and redraws
                    const color = this.error == null ? this.marker.validColor : this.marker.invalidColor;
                    this.setPreviewColor(color);
                    this.abspoints = clone.absolutePoints;
                    this.active = true;
                    this.updateHint(me, this.currentPoint);
                }
            }
            // This should go before calling isOutlineConnectEvent above. As a workaround
            // we add an offset of gridSize to the hint to avoid problem with hit detection
            // in highlight.isHighlightAt (which uses comonentFromPoint)
            this.drawPreview();
            (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).consume(me.getEvent());
            me.consume();
        }
    }
    /**
     * Handles the event to applying the previewed changes on the edge by
     * using {@link moveLabel}, {@link connect} or {@link changePoints}.
     */ mouseUp(_sender, me) {
        // Workaround for wrong event source in Webkit
        if (this.index != null && this.marker != null) {
            if (this.shape != null && this.shape.node != null) this.shape.node.style.display = '';
            let edge = this.state.cell;
            const { index: index } = this;
            this.index = null;
            // Ignores event if mouse has not been moved
            if (me.getX() !== this.startX || me.getY() !== this.startY) {
                const clone = !this.graph.isIgnoreTerminalEvent(me.getEvent()) && this.graph.isCloneEvent(me.getEvent()) && this.cloneEnabled && this.graph.isCellsCloneable();
                // Displays the reason for not carriying out the change
                // if there is an error message with non-zero length
                if (this.error != null) {
                    if (this.error.length > 0) this.graph.validationAlert(this.error);
                } else if (index <= (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CUSTOM_HANDLE && index > (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).VIRTUAL_HANDLE) {
                    if (this.customHandles != null) {
                        const model = this.graph.getDataModel();
                        model.beginUpdate();
                        try {
                            this.customHandles[(0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CUSTOM_HANDLE - index].execute(me);
                            if (this.shape != null && this.shape.node != null) {
                                this.shape.apply(this.state);
                                this.shape.redraw();
                            }
                        } finally{
                            model.endUpdate();
                        }
                    }
                } else if (this.isLabel && this.label) this.moveLabel(this.state, this.label.x, this.label.y);
                else if (this.isSource || this.isTarget) {
                    let terminal = null;
                    if (this.constraintHandler.currentConstraint != null && this.constraintHandler.currentFocus != null) terminal = this.constraintHandler.currentFocus.cell;
                    if (!terminal && this.marker.hasValidState() && this.marker.highlight != null && this.marker.highlight.shape != null && this.marker.highlight.shape.stroke !== 'transparent' && this.marker.highlight.shape.stroke !== 'white') terminal = this.marker.validState.cell;
                    if (terminal) {
                        const model = this.graph.getDataModel();
                        const parent = edge.getParent();
                        model.beginUpdate();
                        try {
                            // Clones and adds the cell
                            if (clone) {
                                let geo = edge.getGeometry();
                                const cloned = this.graph.cloneCell(edge);
                                model.add(parent, cloned, parent.getChildCount());
                                if (geo != null) {
                                    geo = geo.clone();
                                    model.setGeometry(cloned, geo);
                                }
                                const other = edge.getTerminal(!this.isSource);
                                this.graph.connectCell(cloned, other, !this.isSource);
                                edge = cloned;
                            }
                            edge = this.connect(edge, terminal, this.isSource, clone, me);
                        } finally{
                            model.endUpdate();
                        }
                    } else if (this.graph.isAllowDanglingEdges()) {
                        const pt = this.abspoints[this.isSource ? 0 : this.abspoints.length - 1];
                        pt.x = this.roundLength(pt.x / this.graph.view.scale - this.graph.view.translate.x);
                        pt.y = this.roundLength(pt.y / this.graph.view.scale - this.graph.view.translate.y);
                        const parent = edge.getParent();
                        const pstate = parent ? this.graph.getView().getState(parent) : null;
                        if (pstate != null) {
                            pt.x -= pstate.origin.x;
                            pt.y -= pstate.origin.y;
                        }
                        pt.x -= this.graph.getPanDx() / this.graph.view.scale;
                        pt.y -= this.graph.getPanDy() / this.graph.view.scale;
                        // Destroys and recreates this handler
                        edge = this.changeTerminalPoint(edge, pt, this.isSource, clone);
                    }
                } else if (this.active) edge = this.changePoints(edge, this.points, clone);
                else {
                    this.graph.getView().invalidate(this.state.cell);
                    this.graph.getView().validate(this.state.cell);
                }
            } else if (this.graph.isToggleEvent(me.getEvent())) this.graph.selectCellForEvent(this.state.cell, me.getEvent());
            // Resets the preview color the state of the handler if this
            // handler has not been recreated
            if (this.marker != null) {
                this.reset();
                // Updates the selection if the edge has been cloned
                if (edge !== this.state.cell) this.graph.setSelectionCell(edge);
            }
            me.consume();
        }
    }
    /**
     * Resets the state of this handler.
     */ reset() {
        if (this.active) this.refresh();
        this.error = null;
        this.index = null;
        this.points = [];
        this.snapPoint = null;
        this.isLabel = false;
        this.isSource = false;
        this.isTarget = false;
        this.active = false;
        if (this.marker) this.marker.reset();
        this.constraintHandler.reset();
        if (this.customHandles) for(let i = 0; i < this.customHandles.length; i += 1)this.customHandles[i].reset();
        this.setPreviewColor((0, $f17931ed28a53cd3$export$3c0f4b700203d869).selectionColor);
        this.removeHint();
        this.redraw();
    }
    /**
     * Sets the color of the preview to the given value.
     */ setPreviewColor(color) {
        this.shape.stroke = color;
    }
    /**
     * Converts the given point in-place from screen to unscaled, untranslated
     * graph coordinates and applies the grid. Returns the given, modified
     * point instance.
     *
     * @param point {@link Point} to be converted.
     * @param gridEnabled Boolean that specifies if the grid should be applied.
     */ convertPoint(point, gridEnabled) {
        const scale = this.graph.getView().getScale();
        const tr = this.graph.getView().getTranslate();
        if (gridEnabled) {
            point.x = this.graph.snap(point.x);
            point.y = this.graph.snap(point.y);
        }
        point.x = Math.round(point.x / scale - tr.x);
        point.y = Math.round(point.y / scale - tr.y);
        const parent = this.state.cell.getParent();
        const pstate = parent ? this.graph.getView().getState(parent) : parent;
        if (pstate) {
            point.x -= pstate.origin.x;
            point.y -= pstate.origin.y;
        }
        return point;
    }
    /**
     * Changes the coordinates for the label of the given edge.
     *
     * @param edge {@link Cell} that represents the edge.
     * @param x Integer that specifies the x-coordinate of the new location.
     * @param y Integer that specifies the y-coordinate of the new location.
     */ moveLabel(edgeState, x, y) {
        const model = this.graph.getDataModel();
        let geometry = edgeState.cell.getGeometry();
        if (geometry != null) {
            const { scale: scale } = this.graph.getView();
            geometry = geometry.clone();
            if (geometry.relative) {
                // Resets the relative location stored inside the geometry
                let pt = this.graph.getView().getRelativePoint(edgeState, x, y);
                geometry.x = Math.round(pt.x * 10000) / 10000;
                geometry.y = Math.round(pt.y);
                // Resets the offset inside the geometry to find the offset
                // from the resulting point
                geometry.offset = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(0, 0);
                pt = this.graph.view.getPoint(edgeState, geometry);
                geometry.offset = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(Math.round((x - pt.x) / scale), Math.round((y - pt.y) / scale));
            } else {
                const points = edgeState.absolutePoints;
                const p0 = points[0];
                const pe = points[points.length - 1];
                if (p0 != null && pe != null) {
                    const cx = p0.x + (pe.x - p0.x) / 2;
                    const cy = p0.y + (pe.y - p0.y) / 2;
                    geometry.offset = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(Math.round((x - cx) / scale), Math.round((y - cy) / scale));
                    geometry.x = 0;
                    geometry.y = 0;
                }
            }
            model.setGeometry(edgeState.cell, geometry);
        }
    }
    /**
     * Changes the terminal or terminal point of the given edge in the graph model.
     *
     * @param edge {@link Cell} that represents the edge to be reconnected.
     * @param terminal {@link Cell} that represents the new terminal.
     * @param isSource Boolean indicating if the new terminal is the source or target terminal.
     * @param _isClone Boolean indicating if the new connection should be a clone of the old edge.
     * @param _me {@link MouseEvent} that contains the mouse up event.
     */ connect(edge, terminal, isSource, _isClone, _me) {
        const parent = edge.getParent();
        this.graph.batchUpdate(()=>{
            let constraint = this.constraintHandler.currentConstraint;
            if (constraint == null) constraint = new (0, $cb4bce61eb363699$export$2e2bcd8739ae039)(null);
            this.graph.connectCell(edge, terminal, isSource, constraint);
        });
        return edge;
    }
    /**
     * Changes the terminal point of the given edge.
     */ changeTerminalPoint(edge, point, isSource, clone) {
        const model = this.graph.getDataModel();
        model.batchUpdate(()=>{
            if (clone) {
                const parent = edge.getParent();
                const terminal = edge.getTerminal(!isSource);
                edge = this.graph.cloneCell(edge);
                model.add(parent, edge, parent.getChildCount());
                model.setTerminal(edge, terminal, !isSource);
            }
            let geo = edge.getGeometry();
            if (geo != null) {
                geo = geo.clone();
                geo.setTerminalPoint(point, isSource);
                model.setGeometry(edge, geo);
                this.graph.connectCell(edge, null, isSource, new (0, $cb4bce61eb363699$export$2e2bcd8739ae039)(null));
            }
        });
        return edge;
    }
    /**
     * Changes the control points of the given edge in the graph model.
     */ changePoints(edge, points, clone) {
        const model = this.graph.getDataModel();
        model.batchUpdate(()=>{
            if (clone) {
                const parent = edge.getParent();
                const source = edge.getTerminal(true);
                const target = edge.getTerminal(false);
                edge = this.graph.cloneCell(edge);
                model.add(parent, edge, parent.getChildCount());
                model.setTerminal(edge, source, true);
                model.setTerminal(edge, target, false);
            }
            let geo = edge.getGeometry();
            if (geo != null) {
                geo = geo.clone();
                geo.points = points;
                model.setGeometry(edge, geo);
            }
        });
        return edge;
    }
    /**
     * Adds a control point for the given state and event.
     */ addPoint(state, evt) {
        const pt = (0, $b55d6ca3b42398e2$export$864dc177f7f5bda1)(this.graph.container, (0, $f192e93a2fd1153c$export$87583e2c100c6a4f)(evt), (0, $f192e93a2fd1153c$export$195fc3609401443f)(evt));
        const gridEnabled = this.graph.isGridEnabledEvent(evt);
        this.convertPoint(pt, gridEnabled);
        this.addPointAt(state, pt.x, pt.y);
        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).consume(evt);
    }
    /**
     * Adds a control point at the given point.
     */ addPointAt(state, x, y) {
        let geo = state.cell.getGeometry();
        const pt = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y);
        if (geo != null) {
            geo = geo.clone();
            const t = this.graph.view.translate;
            const s = this.graph.view.scale;
            let offset = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(t.x * s, t.y * s);
            const parent = this.state.cell.getParent();
            if (parent && parent.isVertex()) {
                const pState = this.graph.view.getState(parent);
                if (pState) offset = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(pState.x, pState.y);
            }
            const index = (0, $f7ff90b8964488a6$export$d6d91d741b272ab)(state, pt.x * s + offset.x, pt.y * s + offset.y);
            if (geo.points == null) geo.points = [
                pt
            ];
            else geo.points.splice(index, 0, pt);
            this.graph.getDataModel().setGeometry(state.cell, geo);
            this.refresh();
            this.redraw();
        }
    }
    /**
     * Removes the control point at the given index from the given state.
     */ removePoint(state, index) {
        if (index > 0 && index < this.abspoints.length - 1) {
            let geo = this.state.cell.getGeometry();
            if (geo != null && geo.points != null) {
                geo = geo.clone();
                (geo.points || []).splice(index - 1, 1);
                this.graph.getDataModel().setGeometry(state.cell, geo);
                this.refresh();
                this.redraw();
            }
        }
    }
    /**
     * Returns the fillcolor for the handle at the given index.
     */ getHandleFillColor(index) {
        const isSource = index === 0;
        const { cell: cell } = this.state;
        const terminal = cell.getTerminal(isSource);
        let color = (0, $f17931ed28a53cd3$export$f4c61547d94bf143).fillColor;
        if (terminal != null && !this.graph.isCellDisconnectable(cell, terminal, isSource) || terminal == null && !this.graph.isTerminalPointMovable(cell, isSource)) color = (0, $cBHcM.LOCKED_HANDLE_FILLCOLOR);
        else if (terminal != null && this.graph.isCellDisconnectable(cell, terminal, isSource)) color = (0, $f17931ed28a53cd3$export$3c0f4b700203d869).connectFillColor;
        return color;
    }
    /**
     * Redraws the preview, and the bends- and label control points.
     */ redraw(ignoreHandles) {
        this.abspoints = this.state.absolutePoints.slice();
        const g = this.state.cell.getGeometry();
        if (g) {
            const pts = g.points;
            if (this.bends != null && this.bends.length > 0) {
                if (pts != null) {
                    if (this.points == null) this.points = [];
                    for(let i = 1; i < this.bends.length - 1; i += 1)if (this.bends[i] != null && this.abspoints[i] != null) this.points[i - 1] = pts[i - 1];
                }
            }
        }
        this.drawPreview();
        if (!ignoreHandles) this.redrawHandles();
    }
    /**
     * Redraws the handles.
     */ redrawHandles() {
        const { cell: cell } = this.state;
        // Updates the handle for the label position
        let b = this.labelShape.bounds;
        this.label = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(this.state.absoluteOffset.x, this.state.absoluteOffset.y);
        this.labelShape.bounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(Math.round(this.label.x - b.width / 2), Math.round(this.label.y - b.height / 2), b.width, b.height);
        // Shows or hides the label handle depending on the label
        const lab = this.graph.getLabel(cell);
        this.labelShape.visible = lab != null && lab.length > 0 && this.graph.isLabelMovable(cell);
        if (this.bends != null && this.bends.length > 0) {
            const n = this.abspoints.length - 1;
            const p0 = this.abspoints[0];
            const x0 = p0.x;
            const y0 = p0.y;
            b = this.bends[0].bounds;
            this.bends[0].bounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(Math.floor(x0 - b.width / 2), Math.floor(y0 - b.height / 2), b.width, b.height);
            this.bends[0].fill = this.getHandleFillColor(0);
            this.bends[0].redraw();
            if (this.manageLabelHandle) this.checkLabelHandle(this.bends[0].bounds);
            const pe = this.abspoints[n];
            const xn = pe.x;
            const yn = pe.y;
            const bn = this.bends.length - 1;
            b = this.bends[bn].bounds;
            this.bends[bn].bounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(Math.floor(xn - b.width / 2), Math.floor(yn - b.height / 2), b.width, b.height);
            this.bends[bn].fill = this.getHandleFillColor(bn);
            this.bends[bn].redraw();
            if (this.manageLabelHandle) this.checkLabelHandle(this.bends[bn].bounds);
            this.redrawInnerBends(p0, pe);
        }
        if (this.virtualBends && this.virtualBends.length > 0) {
            let last = this.abspoints[0];
            for(let i = 0; i < this.virtualBends.length; i += 1)if (this.virtualBends[i] != null && this.abspoints[i + 1] != null) {
                const pt = this.abspoints[i + 1];
                const b = this.virtualBends[i];
                const x = last.x + (pt.x - last.x) / 2;
                const y = last.y + (pt.y - last.y) / 2;
                if (b.bounds) {
                    b.bounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(Math.floor(x - b.bounds.width / 2), Math.floor(y - b.bounds.height / 2), b.bounds.width, b.bounds.height);
                    b.redraw();
                }
                (0, $b55d6ca3b42398e2$export$2646c6b151d2e8)(b.node, (0, $f17931ed28a53cd3$export$3c0f4b700203d869).virtualBendOpacity);
                last = pt;
                if (this.manageLabelHandle) this.checkLabelHandle(b.bounds);
            }
        }
        this.labelShape.redraw();
        if (this.customHandles) for(let i = 0; i < this.customHandles.length; i += 1){
            const shape = this.customHandles[i].shape;
            if (shape) {
                const temp = shape.node.style.display;
                this.customHandles[i].redraw();
                shape.node.style.display = temp;
                // Hides custom handles during text editing
                shape.node.style.visibility = this.isCustomHandleVisible(this.customHandles[i]) ? '' : 'hidden';
            }
        }
    }
    /**
     * Returns true if the given custom handle is visible.
     */ isCustomHandleVisible(handle) {
        return !this.graph.isEditing() && this.state.view.graph.getSelectionCount() === 1;
    }
    /**
     * Shortcut to {@link hideSizers}.
     */ setHandlesVisible(visible) {
        for(let i = 0; i < this.bends.length; i += 1)this.bends[i].node.style.display = visible ? '' : 'none';
        if (this.virtualBends) for(let i = 0; i < this.virtualBends.length; i += 1)this.virtualBends[i].node.style.display = visible ? '' : 'none';
        this.labelShape.node.style.display = visible ? '' : 'none';
        if (this.customHandles) for(let i = 0; i < this.customHandles.length; i += 1)this.customHandles[i].setVisible(visible);
    }
    /**
     * Updates and redraws the inner bends.
     *
     * @param p0 {@link Point} that represents the location of the first point.
     * @param pe {@link Point} that represents the location of the last point.
     */ redrawInnerBends(p0, pe) {
        for(let i = 1; i < this.bends.length - 1; i += 1)if (this.bends[i] != null) {
            if (this.abspoints[i] != null) {
                const { x: x } = this.abspoints[i];
                const { y: y } = this.abspoints[i];
                const b = this.bends[i].bounds;
                this.bends[i].node.style.visibility = 'visible';
                this.bends[i].bounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(Math.round(x - b.width / 2), Math.round(y - b.height / 2), b.width, b.height);
                if (this.manageLabelHandle) this.checkLabelHandle(this.bends[i].bounds);
                else if (this.handleImage == null && this.labelShape.visible && (0, $f7ff90b8964488a6$export$7b0a31e10bbff018)(this.bends[i].bounds, this.labelShape.bounds)) {
                    const w = (0, $f17931ed28a53cd3$export$f4c61547d94bf143).size + 3;
                    const h = w;
                    this.bends[i].bounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(Math.round(x - w / 2), Math.round(y - h / 2), w, h);
                }
                this.bends[i].redraw();
            } else this.bends[i].destroy();
        }
    }
    /**
     * Checks if the label handle intersects the given bounds and moves it if it
     * intersects.
     */ checkLabelHandle(b) {
        const b2 = this.labelShape.bounds;
        if ((0, $f7ff90b8964488a6$export$7b0a31e10bbff018)(b, b2)) {
            if (b.getCenterY() < b2.getCenterY()) b2.y = b.y + b.height;
            else b2.y = b.y - b2.height;
        }
    }
    /**
     * Redraws the preview.
     */ drawPreview() {
        try {
            if (this.isLabel) {
                const b = this.labelShape.bounds;
                const bounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(Math.round(this.label.x - b.width / 2), Math.round(this.label.y - b.height / 2), b.width, b.height);
                if (!b.equals(bounds)) {
                    this.labelShape.bounds = bounds;
                    this.labelShape.redraw();
                }
            }
            if (this.shape != null && !(0, $7798e91745d24e26$export$762de7b100cb21fe)(this.shape.points, this.abspoints)) {
                this.shape.apply(this.state);
                this.shape.points = this.abspoints.slice();
                this.shape.scale = this.state.view.scale;
                this.shape.isDashed = this.isSelectionDashed();
                this.shape.stroke = this.getSelectionColor();
                this.shape.strokeWidth = this.getSelectionStrokeWidth() / this.shape.scale / this.shape.scale;
                this.shape.isShadow = false;
                this.shape.redraw();
            }
            this.updateParentHighlight();
        } catch (e) {
        // ignore
        }
    }
    /**
     * Refreshes the bends of this handler.
     */ refresh() {
        if (this.state != null) {
            this.abspoints = this.getSelectionPoints(this.state);
            this.points = [];
            this.destroyBends(this.bends);
            this.bends = this.createBends();
            if (this.virtualBends) {
                this.destroyBends(this.virtualBends);
                this.virtualBends = this.createVirtualBends();
            }
            if (this.customHandles) {
                this.destroyBends(this.customHandles);
                this.customHandles = this.createCustomHandles();
            }
            // Puts label node on top of bends
            if (this.labelShape != null && this.labelShape.node != null && this.labelShape.node.parentNode != null) this.labelShape.node.parentNode.appendChild(this.labelShape.node);
        }
    }
    /**
     * Returns true if {@link destroy} was called.
     */ isDestroyed() {
        return this.shape == null;
    }
    /**
     * Destroys all elements in {@link bends}.
     */ destroyBends(bends) {
        if (bends != null) {
            for(let i = 0; i < bends.length; i += 1)if (bends[i] != null) bends[i].destroy();
        }
    }
    /**
     * Destroys the handler and all its resources and DOM nodes. This does
     * normally not need to be called as handlers are destroyed automatically
     * when the corresponding cell is deselected.
     */ onDestroy() {
        this.state.view.graph.removeListener(this.escapeHandler);
        this.marker.destroy();
        // @ts-expect-error Can be null when destroyed.
        this.marker = null;
        this.shape.destroy();
        // @ts-expect-error Can be null when destroyed.
        this.shape = null;
        if (this.parentHighlight) {
            const parent = this.state.cell.getParent();
            const pstate = parent ? this.graph.view.getState(parent) : null;
            if (pstate && pstate.parentHighlight === this.parentHighlight) pstate.parentHighlight = null;
            this.parentHighlight.destroy();
            this.parentHighlight = null;
        }
        this.labelShape.destroy();
        // @ts-expect-error Can be null when destroyed.
        this.labelShape = null;
        this.constraintHandler.onDestroy();
        // @ts-expect-error Can be null when destroyed.
        this.constraintHandler = null;
        if (this.virtualBends) {
            this.destroyBends(this.virtualBends);
            this.virtualBends = [];
        }
        if (this.customHandles) {
            this.destroyBends(this.customHandles);
            this.customHandles = [];
        }
        this.destroyBends(this.bends);
        this.bends = [];
        this.removeHint();
    }
}
class $d02037fd5fbb23ea$var$EdgeHandlerCellMarker extends (0, $41e693d31e181f17$export$2e2bcd8739ae039) {
    constructor(graph, edgeHandler, validColor = (0, $cBHcM.DEFAULT_VALID_COLOR), invalidColor = (0, $cBHcM.DEFAULT_INVALID_COLOR), hotspot = (0, $cBHcM.DEFAULT_HOTSPOT)){
        super(graph, validColor, invalidColor, hotspot);
        // Only returns edges if they are connectable and never returns
        // the edge that is currently being modified
        this.getCell = (me)=>{
            let cell = super.getCell(me);
            // Checks for cell at preview point (with grid)
            if ((cell === this.edgeHandler.state.cell || !cell) && this.edgeHandler.currentPoint) cell = this.edgeHandler.graph.getCellAt(this.edgeHandler.currentPoint.x, this.edgeHandler.currentPoint.y);
            // Uses connectable parent vertex if one exists
            if (cell && !cell.isConnectable()) {
                const parent = cell.getParent();
                if (parent && parent.isVertex() && parent.isConnectable()) cell = parent;
            }
            if (cell) {
                if (this.graph.isSwimlane(cell) && this.edgeHandler.currentPoint && this.graph.hitsSwimlaneContent(cell, this.edgeHandler.currentPoint.x, this.edgeHandler.currentPoint.y) || !this.edgeHandler.isConnectableCell(cell) || cell === this.edgeHandler.state.cell || cell && !this.edgeHandler.graph.connectableEdges && cell.isEdge() || this.edgeHandler.state.cell.isAncestor(cell)) cell = null;
            }
            if (cell && !cell.isConnectable()) cell = null;
            return cell;
        };
        // Sets the highlight color according to validateConnection
        this.isValidState = (state)=>{
            const cell = this.edgeHandler.state.cell.getTerminal(!this.edgeHandler.isSource);
            const cellState = this.edgeHandler.graph.view.getState(cell);
            const other = this.edgeHandler.graph.view.getTerminalPort(state, cellState, !this.edgeHandler.isSource);
            const otherCell = other ? other.cell : null;
            const source = this.edgeHandler.isSource ? state.cell : otherCell;
            const target = this.edgeHandler.isSource ? otherCell : state.cell;
            // Updates the error message of the handler
            this.edgeHandler.error = this.edgeHandler.validateConnection(source, target);
            return !this.edgeHandler.error;
        };
        this.edgeHandler = edgeHandler;
    }
}
var $d02037fd5fbb23ea$export$2e2bcd8739ae039 = $d02037fd5fbb23ea$var$EdgeHandler;


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 

var $cBHcM = parcelRequire("cBHcM");










var $h5l15 = parcelRequire("h5l15");
/**
 * Event handler for resizing cells.
 * It displays a selection border around the vertex, a resize handle on each corner and side, an optional rotation
 * handle, and the label handle when the label is movable.
 *
 * **Instantiation**
 *
 * {@link SelectionCellsHandler} creates it for each selected vertex.
 *
 * To have maxGraph create a custom implementation instead, register a factory on the plugin:
 * ```typescript
 * selectionCellsHandler.setVertexHandlerFactory((state) => new MyVertexHandler(state));
 * ```
 *
 * **Configuration**
 *
 * Some elements of this handler and its subclasses can be configured globally using {@link VertexHandlerConfig} and
 * {@link HandleConfig}.
 */ class $b94bb9bb182e316f$var$VertexHandler {
    /**
     * Specifies if a rotation handle should be visible.
     *
     * This implementation returns {@link VertexHandlerConfig.rotationEnabled}.
     * @since 0.12.0
     */ isRotationEnabled() {
        return (0, $f17931ed28a53cd3$export$1b394cdb5b3999f1).rotationEnabled;
    }
    /**
     * Constructs an event handler that allows to resize vertices and groups.
     *
     * @param state {@link CellState} of the cell to be resized.
     */ constructor(state){
        this.sizers = [];
        /**
         * Specifies if only one sizer handle at the bottom, right corner should be used.
         * @default false
         */ this.singleSizer = false;
        /**
         * Holds the index of the current handle.
         */ this.index = null;
        /**
         * Specifies if the bounds of handles should be used for hit-detection in IE or if {@link tolerance} > 0.
         * @default true
         */ this.allowHandleBoundsCheck = true;
        /**
         * Optional {@link Image} to be used as handles.
         * @default null
         */ this.handleImage = null;
        /**
         * If handles are currently visible.
         * @default true
         */ this.handlesVisible = true;
        /**
         * Optional tolerance for hit-detection in {@link getHandleForEvent}.
         * @default 0
         */ this.tolerance = 0;
        /**
         * Specifies if the parent should be highlighted if a child cell is selected.
         * @default false
         */ this.parentHighlightEnabled = false;
        /**
         * Specifies if rotation steps should be "rasterized" depending on the distance to the handle.
         * @default true
         */ this.rotationRaster = true;
        /**
         * Specifies the cursor for the rotation handle.
         * @default 'crosshair'.
         */ this.rotationCursor = 'crosshair';
        /**
         * Specifies if resize should change the cell in-place. This is an experimental
         * feature for non-touch devices.
         * @default false
         */ this.livePreview = false;
        /**
         * Specifies if the live preview should be moved to the front.
         * @default false
         */ this.movePreviewToFront = false;
        /**
         * Specifies if sizers should be hidden and spaced if the vertex is small.
         * @default false
         */ this.manageSizers = false;
        /**
         * Specifies if the size of groups should be constrained by the children.
         * @default false
         */ this.constrainGroupByChildren = false;
        /**
         * Vertical spacing for rotation icon.
         * @default -16
         */ this.rotationHandleVSpacing = -16;
        /**
         * The horizontal offset for the handles. This is updated in {@link redrawHandles}
         * if {@link manageSizers} is `true` and the sizers are offset horizontally.
         */ this.horizontalOffset = 0;
        /**
         * The horizontal offset for the handles. This is updated in <redrawHandles>
         * if {@link manageSizers} is true and the sizers are offset vertically.
         */ this.verticalOffset = 0;
        this.minBounds = null;
        this.x0 = 0;
        this.y0 = 0;
        this.customHandles = [];
        this.inTolerance = false;
        this.startX = 0;
        this.startY = 0;
        this.rotationShape = null;
        this.currentAlpha = null;
        this.startAngle = 0;
        this.startDist = 0;
        this.ghostPreview = null;
        this.livePreviewActive = false;
        this.childOffsetX = 0;
        this.childOffsetY = 0;
        this.parentState = null;
        this.parentHighlight = null;
        this.unscaledBounds = null;
        this.preview = null;
        this.labelShape = null;
        this.edgeHandlers = [];
        this.EMPTY_POINT = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)();
        this.state = state;
        this.graph = this.state.view.graph;
        this.selectionBounds = this.getSelectionBounds(this.state);
        this.bounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(this.selectionBounds.x, this.selectionBounds.y, this.selectionBounds.width, this.selectionBounds.height);
        this.selectionBorder = this.createSelectionShape(this.bounds);
        // VML dialect required here for event transparency in IE
        this.selectionBorder.dialect = 'svg';
        this.selectionBorder.pointerEvents = false;
        this.selectionBorder.rotation = this.state.style.rotation ?? 0;
        this.selectionBorder.init(this.graph.getView().getOverlayPane());
        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).redirectMouseEvents(this.selectionBorder.node, this.graph, this.state);
        if (this.graph.isCellMovable(this.state.cell)) this.selectionBorder.setCursor((0, $f17931ed28a53cd3$export$1b394cdb5b3999f1).cursorMovable);
        const selectionHandler = this.getSelectionHandler();
        // Adds the sizer handles
        if (selectionHandler && (selectionHandler.maxCells <= 0 || this.graph.getSelectionCount() < selectionHandler.maxCells)) {
            const resizable = this.graph.isCellResizable(this.state.cell);
            this.sizers = [];
            if (resizable || this.graph.isLabelMovable(this.state.cell) && this.state.width >= 2 && this.state.height >= 2) {
                let i = 0;
                if (resizable) {
                    if (!this.singleSizer) {
                        this.sizers.push(this.createSizer('nw-resize', i++));
                        this.sizers.push(this.createSizer('n-resize', i++));
                        this.sizers.push(this.createSizer('ne-resize', i++));
                        this.sizers.push(this.createSizer('w-resize', i++));
                        this.sizers.push(this.createSizer('e-resize', i++));
                        this.sizers.push(this.createSizer('sw-resize', i++));
                        this.sizers.push(this.createSizer('s-resize', i++));
                    }
                    this.sizers.push(this.createSizer('se-resize', i++));
                }
                const geo = this.state.cell.getGeometry();
                if (geo != null && !geo.relative && !this.graph.isSwimlane(this.state.cell) && this.graph.isLabelMovable(this.state.cell)) {
                    // Marks this as the label handle for getHandleForEvent
                    this.labelShape = this.createSizer((0, $f17931ed28a53cd3$export$f4c61547d94bf143).labelCursor, (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).LABEL_HANDLE, (0, $f17931ed28a53cd3$export$f4c61547d94bf143).labelSize, (0, $f17931ed28a53cd3$export$f4c61547d94bf143).labelFillColor);
                    this.sizers.push(this.labelShape);
                }
            } else if (this.graph.isCellMovable(this.state.cell) && !this.graph.isCellResizable(this.state.cell) && this.state.width < 2 && this.state.height < 2) {
                this.labelShape = this.createSizer((0, $f17931ed28a53cd3$export$1b394cdb5b3999f1).cursorMovable, (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).LABEL_HANDLE, undefined, (0, $f17931ed28a53cd3$export$f4c61547d94bf143).labelFillColor);
                this.sizers.push(this.labelShape);
            }
        }
        // Adds the rotation handler
        if (this.isRotationHandleVisible()) {
            this.rotationShape = this.createSizer(this.rotationCursor, (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).ROTATION_HANDLE, (0, $f17931ed28a53cd3$export$f4c61547d94bf143).size + 3, (0, $f17931ed28a53cd3$export$f4c61547d94bf143).fillColor);
            this.sizers.push(this.rotationShape);
        }
        this.customHandles = this.createCustomHandles();
        this.redraw();
        if (this.constrainGroupByChildren) this.updateMinBounds();
        // Handles escape keystrokes
        this.escapeHandler = (_sender, _evt)=>{
            if (this.livePreview && this.index != null) {
                // Redraws the live preview
                this.state.view.graph.cellRenderer.redraw(this.state, true);
                // Redraws connected edges
                this.state.view.invalidate(this.state.cell);
                this.state.invalid = false;
                this.state.view.validate();
            }
            this.reset();
        };
        this.state.view.graph.addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).ESCAPE, this.escapeHandler);
    }
    getSelectionHandler() {
        return this.graph.getPlugin('SelectionHandler');
    }
    /**
     * Returns `true` if the rotation handle should be showing.
     */ isRotationHandleVisible() {
        const selectionHandler = this.getSelectionHandler();
        const selectionHandlerCheck = selectionHandler ? selectionHandler.maxCells <= 0 || this.graph.getSelectionCount() < selectionHandler.maxCells : true;
        return this.graph.isEnabled() && this.isRotationEnabled() && this.graph.isCellRotatable(this.state.cell) && selectionHandlerCheck;
    }
    /**
     * Returns `true` if the aspect ratio if the cell should be maintained.
     */ isConstrainedEvent(me) {
        return (0, $f192e93a2fd1153c$export$1d7fd696f3493e74)(me.getEvent()) || this.state.style.aspect === 'fixed';
    }
    /**
     * Returns `true` if the center of the vertex should be maintained during the resize.
     */ isCenteredEvent(state, me) {
        return false;
    }
    /**
     * Returns an array of custom handles.
     *
     * This implementation returns an empty array.
     */ createCustomHandles() {
        return [];
    }
    /**
     * Initializes the shapes required for this vertex handler.
     */ updateMinBounds() {
        const children = this.graph.getChildCells(this.state.cell);
        if (children.length > 0) {
            this.minBounds = this.graph.view.getBounds(children);
            if (this.minBounds) {
                const s = this.state.view.scale;
                const t = this.state.view.translate;
                this.minBounds.x -= this.state.x;
                this.minBounds.y -= this.state.y;
                this.minBounds.x /= s;
                this.minBounds.y /= s;
                this.minBounds.width /= s;
                this.minBounds.height /= s;
                this.x0 = this.state.x / s - t.x;
                this.y0 = this.state.y / s - t.y;
            }
        }
    }
    /**
     * Returns the Rectangle that defines the bounds of the selection border.
     */ getSelectionBounds(state) {
        return new (0, $2997c239141ea844$export$2e2bcd8739ae039)(Math.round(state.x), Math.round(state.y), Math.round(state.width), Math.round(state.height));
    }
    /**
     * Creates the shape used to draw the selection border.
     */ createParentHighlightShape(bounds) {
        return this.createSelectionShape(bounds);
    }
    /**
     * Creates the shape used to draw the selection border.
     */ createSelectionShape(bounds) {
        const shape = new (0, $14ee9ba473f8b778$export$2e2bcd8739ae039)((0, $2997c239141ea844$export$2e2bcd8739ae039).fromRectangle(bounds), (0, $cBHcM.NONE), this.getSelectionColor());
        shape.strokeWidth = this.getSelectionStrokeWidth();
        shape.isDashed = this.isSelectionDashed();
        return shape;
    }
    /**
     * Returns {@link VertexHandlerConfig.selectionColor}.
     */ getSelectionColor() {
        return (0, $f17931ed28a53cd3$export$1b394cdb5b3999f1).selectionColor;
    }
    /**
     * Returns {@link VertexHandlerConfig.selectionStrokeWidth}.
     */ getSelectionStrokeWidth() {
        return (0, $f17931ed28a53cd3$export$1b394cdb5b3999f1).selectionStrokeWidth;
    }
    /**
     * Returns {@link VertexHandlerConfig.selectionDashed}.
     */ isSelectionDashed() {
        return (0, $f17931ed28a53cd3$export$1b394cdb5b3999f1).selectionDashed;
    }
    /**
     * Creates a sizer handle for the specified cursor and index and returns
     * the new {@link RectangleShape} that represents the handle.
     */ createSizer(cursor, index, size = (0, $f17931ed28a53cd3$export$f4c61547d94bf143).size, fillColor = (0, $f17931ed28a53cd3$export$f4c61547d94bf143).fillColor) {
        const bounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(0, 0, size, size);
        const sizer = this.createSizerShape(bounds, index, fillColor);
        if (sizer.bounds && sizer.isHtmlAllowed() && this.state.text && this.state.text.node.parentNode === this.graph.container) {
            sizer.bounds.height -= 1;
            sizer.bounds.width -= 1;
            sizer.dialect = 'strictHtml';
            sizer.init(this.graph.container);
        } else {
            sizer.dialect = this.graph.dialect !== 'svg' ? 'mixedHtml' : 'svg';
            sizer.init(this.graph.getView().getOverlayPane());
        }
        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).redirectMouseEvents(sizer.node, this.graph, this.state);
        if (this.graph.isEnabled()) sizer.setCursor(cursor);
        if (!this.isSizerVisible(index)) sizer.visible = false;
        return sizer;
    }
    /**
     * Returns `true` if the sizer for the given index is visible.
     *
     * This implementation returns `true` for all given indices.
     */ isSizerVisible(_index) {
        return true;
    }
    /**
     * Creates the shape used for the sizer handle for the specified bounds an
     * index. Only images and rectangles should be returned if support for HTML
     * labels with not foreign objects is required.
     */ createSizerShape(bounds, index, fillColor = (0, $f17931ed28a53cd3$export$f4c61547d94bf143).fillColor) {
        if (this.handleImage) {
            bounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(bounds.x, bounds.y, this.handleImage.width, this.handleImage.height);
            const shape = new (0, $48f65d6d4849e478$export$2e2bcd8739ae039)(bounds, this.handleImage.src);
            // Allows HTML rendering of the images
            shape.preserveImageAspect = false;
            return shape;
        }
        const strokeColor = (0, $f17931ed28a53cd3$export$f4c61547d94bf143).strokeColor;
        if (index === (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).ROTATION_HANDLE) return new (0, $f3582df951663f77$export$2e2bcd8739ae039)(bounds, fillColor, strokeColor);
        return new (0, $14ee9ba473f8b778$export$2e2bcd8739ae039)(bounds, fillColor, strokeColor);
    }
    /**
     * Helper method to create an {@link Rectangle} around the given center point
     * with a width and height of 2*s or 6, if no s is given.
     */ moveSizerTo(shape, x, y) {
        if (shape && shape.bounds) {
            shape.bounds.x = Math.floor(x - shape.bounds.width / 2);
            shape.bounds.y = Math.floor(y - shape.bounds.height / 2);
            // Fixes visible inactive handles in VML
            if (shape.node && shape.node.style.display !== 'none') shape.redraw();
        }
    }
    /**
     * Returns the index of the handle for the given event. This returns the index
     * of the sizer from where the event originated or {@link InternalEvent.LABEL_HANDLE}.
     */ getHandleForEvent(me) {
        // Connection highlight may consume events before they reach sizer handle
        const tol = !(0, $f192e93a2fd1153c$export$764db16956f554f8)(me.getEvent()) ? this.tolerance : 1;
        const hit = this.allowHandleBoundsCheck && tol > 0 ? new (0, $2997c239141ea844$export$2e2bcd8739ae039)(me.getGraphX() - tol, me.getGraphY() - tol, 2 * tol, 2 * tol) : null;
        const checkShape = (shape)=>{
            const st = shape && shape.constructor !== (0, $48f65d6d4849e478$export$2e2bcd8739ae039) && this.allowHandleBoundsCheck ? shape.strokeWidth + shape.svgStrokeTolerance : null;
            const real = st ? new (0, $2997c239141ea844$export$2e2bcd8739ae039)(me.getGraphX() - Math.floor(st / 2), me.getGraphY() - Math.floor(st / 2), st, st) : hit;
            return shape && shape.bounds && (me.isSource(shape) || real && (0, $f7ff90b8964488a6$export$7b0a31e10bbff018)(shape.bounds, real) && shape.node.style.display !== 'none' && shape.node.style.visibility !== 'hidden');
        };
        if (checkShape(this.rotationShape)) return (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).ROTATION_HANDLE;
        if (checkShape(this.labelShape)) return (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).LABEL_HANDLE;
        for(let i = 0; i < this.sizers.length; i += 1){
            if (checkShape(this.sizers[i])) return i;
        }
        if (this.customHandles != null && this.isCustomHandleEvent(me)) // Inverse loop order to match display order
        for(let i = this.customHandles.length - 1; i >= 0; i--){
            if (checkShape(this.customHandles[i].shape)) // LATER: Return reference to active shape
            return (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CUSTOM_HANDLE - i;
        }
        return null;
    }
    /**
     * Returns `true` if the given event allows custom handles to be changed.
     *
     * This implementation returns `true`.
     */ isCustomHandleEvent(me) {
        return true;
    }
    /**
     * Handles the event if a handle has been clicked. By consuming the
     * event all subsequent events of the gesture are redirected to this
     * handler.
     */ mouseDown(_sender, me) {
        if (!me.isConsumed() && this.graph.isEnabled()) {
            const handle = this.getHandleForEvent(me);
            if (!(0, $h5l15.isNullish)(handle)) {
                this.start(me.getGraphX(), me.getGraphY(), handle);
                me.consume();
            }
        }
    }
    /**
     * Called if {@link livePreview} is enabled to check if a border should be painted.
     *
     * This implementation returns `true` if the shape is transparent.
     */ isLivePreviewBorder() {
        return this.state.shape && this.state.shape.fill === (0, $cBHcM.NONE) && this.state.shape.stroke === (0, $cBHcM.NONE);
    }
    /**
     * Starts the handling of the mouse gesture.
     */ start(x, y, index) {
        this.livePreviewActive = this.livePreview && this.state.cell.getChildCount() === 0;
        this.inTolerance = true;
        this.childOffsetX = 0;
        this.childOffsetY = 0;
        this.index = index;
        this.startX = x;
        this.startY = y;
        if (this.index <= (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CUSTOM_HANDLE && this.isGhostPreview()) this.ghostPreview = this.createGhostPreview();
        else {
            // Saves reference to parent state
            const parent = this.state.cell.getParent();
            if (this.state.view.currentRoot !== parent && parent && (parent.isVertex() || parent.isEdge())) this.parentState = this.state.view.graph.view.getState(parent);
            // Creates a preview that can be on top of any HTML label
            this.selectionBorder.node.style.display = index === (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).ROTATION_HANDLE ? 'inline' : 'none';
            // Creates the border that represents the new bounds
            if (!this.livePreviewActive || this.isLivePreviewBorder()) {
                this.preview = this.createSelectionShape(this.bounds);
                if (!((0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_SVG && (this.state.style.rotation ?? 0) != 0) && this.state.text != null && this.state.text.node.parentNode === this.graph.container) {
                    this.preview.dialect = 'strictHtml';
                    this.preview.init(this.graph.container);
                } else {
                    this.preview.dialect = 'svg';
                    this.preview.init(this.graph.view.getOverlayPane());
                }
            }
            if (index === (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).ROTATION_HANDLE) {
                // With the rotation handle in a corner, need the angle and distance.
                // The handle position derives from the bounds, whose coordinates getSelectionBounds rounds, and the centre is
                // taken from those same bounds on purpose, so that the angle is exactly 0 for the default handle and dragging
                // commits the bearing the pointer sits at rather than the angular travel of the handle. rotateVertex and
                // redrawHandles keep measuring from the unrounded centre of the state, at most half a pixel away on each axis.
                const pos = this.getRotationHandlePosition();
                const dx = pos.x - this.bounds.getCenterX();
                const dy = pos.y - this.bounds.getCenterY();
                // `Math.atan(dy / dx) + 90` only holds for a handle painted right of the centre: on the left it returns a
                // bearing 180 degrees off. atan2 covers the four quadrants, and still returns 0 for the default handle.
                this.startAngle = Math.atan2(dx, -dy) * 180 / Math.PI;
                this.startDist = Math.sqrt(dx * dx + dy * dy);
            }
            // Prepares the handles for live preview
            if (this.livePreviewActive) {
                this.hideSizers();
                if (index === (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).ROTATION_HANDLE && this.rotationShape) this.rotationShape.node.style.display = '';
                else if (index === (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).LABEL_HANDLE && this.labelShape) this.labelShape.node.style.display = '';
                else if (this.sizers[index]) this.sizers[index].node.style.display = '';
                else if (index <= (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CUSTOM_HANDLE) this.customHandles[(0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CUSTOM_HANDLE - index].setVisible(true);
                // Gets the array of connected edge handlers for redrawing
                const edges = this.state.cell.getEdges();
                this.edgeHandlers = [];
                const selectionCellsHandler = this.graph.getPlugin('SelectionCellsHandler');
                for(let i = 0; i < edges.length; i += 1){
                    const handler = selectionCellsHandler?.getHandler(edges[i]);
                    if (handler) this.edgeHandlers.push(handler);
                }
            }
        }
    }
    /**
     * Starts the handling of the mouse gesture.
     */ createGhostPreview() {
        const shape = this.graph.cellRenderer.createShape(this.state);
        shape.init(this.graph.view.getOverlayPane());
        shape.scale = this.state.view.scale;
        shape.bounds = this.bounds;
        shape.outline = true;
        return shape;
    }
    /**
     * Shortcut to {@link hideSizers}.
     */ setHandlesVisible(visible) {
        this.handlesVisible = visible;
        for(let i = 0; i < this.sizers.length; i += 1)this.sizers[i].node.style.display = visible ? '' : 'none';
        for(let i = 0; i < this.customHandles.length; i += 1)this.customHandles[i].setVisible(visible);
    }
    /**
     * Hides all sizers except.
     *
     * Starts the handling of the mouse gesture.
     */ hideSizers() {
        this.setHandlesVisible(false);
    }
    /**
     * Checks if the coordinates for the given event are within the
     * {@link AbstractGraph.tolerance}. If the event is a mouse event then the tolerance is
     * ignored.
     */ checkTolerance(me) {
        if (this.inTolerance && this.startX !== null && this.startY !== null) {
            if ((0, $f192e93a2fd1153c$export$764db16956f554f8)(me.getEvent()) || Math.abs(me.getGraphX() - this.startX) > this.graph.getEventTolerance() || Math.abs(me.getGraphY() - this.startY) > this.graph.getEventTolerance()) this.inTolerance = false;
        }
    }
    /**
     * Hook for subclasses do show details while the handler is active.
     */ updateHint(me) {
        return;
    }
    /**
     * Hooks for subclasses to hide details when the handler gets inactive.
     */ removeHint() {
        return;
    }
    /**
     * Hook for rounding the angle. This uses {@link Math.round}.
     */ roundAngle(angle) {
        return Math.round(angle * 10) / 10;
    }
    /**
     * Hook for rounding the unscaled width or height. This uses {@link Math.round}.
     */ roundLength(length) {
        return Math.round(length * 100) / 100;
    }
    /**
     * Handles the event by updating the preview.
     */ mouseMove(_sender, me) {
        if (!me.isConsumed() && this.index != null) {
            // Checks tolerance for ignoring single clicks
            this.checkTolerance(me);
            if (!this.inTolerance) {
                if (this.index <= (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CUSTOM_HANDLE) {
                    if (this.customHandles != null) {
                        this.customHandles[(0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CUSTOM_HANDLE - this.index].processEvent(me);
                        this.customHandles[(0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CUSTOM_HANDLE - this.index].active = true;
                        if (this.ghostPreview != null) {
                            this.ghostPreview.apply(this.state);
                            this.ghostPreview.strokeWidth = this.getSelectionStrokeWidth() / this.ghostPreview.scale / this.ghostPreview.scale;
                            this.ghostPreview.isDashed = this.isSelectionDashed();
                            this.ghostPreview.stroke = this.getSelectionColor();
                            this.ghostPreview.redraw();
                            if (this.selectionBounds != null) this.selectionBorder.node.style.display = 'none';
                        } else {
                            if (this.movePreviewToFront) this.moveToFront();
                            this.customHandles[(0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CUSTOM_HANDLE - this.index].positionChanged();
                        }
                    }
                } else if (this.index === (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).LABEL_HANDLE) this.moveLabel(me);
                else {
                    if (this.index === (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).ROTATION_HANDLE) this.rotateVertex(me);
                    else this.resizeVertex(me);
                    this.updateHint(me);
                }
            }
            me.consume();
        } else if (!this.graph.isMouseDown && !(0, $h5l15.isNullish)(this.getHandleForEvent(me))) me.consume(false);
    }
    /**
     * Returns `true` if a ghost preview should be used for custom handles.
     */ isGhostPreview() {
        return this.state.cell.getChildCount() > 0;
    }
    /**
     * Moves the vertex.
     */ moveLabel(me) {
        const point = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(me.getGraphX(), me.getGraphY());
        const tr = this.graph.view.translate;
        const { scale: scale } = this.graph.view;
        if (this.graph.isGridEnabledEvent(me.getEvent())) {
            point.x = (this.graph.snap(point.x / scale - tr.x) + tr.x) * scale;
            point.y = (this.graph.snap(point.y / scale - tr.y) + tr.y) * scale;
        }
        const index = this.rotationShape ? this.sizers.length - 2 : this.sizers.length - 1;
        this.moveSizerTo(this.sizers[index], point.x, point.y);
    }
    /**
     * Rotates the vertex.
     */ rotateVertex(me) {
        const point = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(me.getGraphX(), me.getGraphY());
        let dx = this.state.x + this.state.width / 2 - point.x;
        let dy = this.state.y + this.state.height / 2 - point.y;
        this.currentAlpha = dx !== 0 ? Math.atan(dy / dx) * 180 / Math.PI + 90 : dy < 0 ? 180 : 0;
        if (dx > 0) this.currentAlpha -= 180;
        this.currentAlpha -= this.startAngle;
        // Rotation raster
        if (this.rotationRaster && this.graph.isGridEnabledEvent(me.getEvent())) {
            let raster;
            dx = point.x - this.state.getCenterX();
            dy = point.y - this.state.getCenterY();
            const dist = Math.sqrt(dx * dx + dy * dy);
            if (dist - this.startDist < 2) raster = 15;
            else if (dist - this.startDist < 25) raster = 5;
            else raster = 1;
            this.currentAlpha = Math.round(this.currentAlpha / raster) * raster;
        } else this.currentAlpha = this.roundAngle(this.currentAlpha);
        this.selectionBorder.rotation = this.currentAlpha;
        this.selectionBorder.redraw();
        if (this.livePreviewActive) this.redrawHandles();
    }
    /**
     * Resizes the vertex.
     */ resizeVertex(me) {
        const ct = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(this.state.getCenterX(), this.state.getCenterY());
        const alpha = (0, $f7ff90b8964488a6$export$cba01ba138429a1d)(this.state.style.rotation ?? 0);
        const point = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(me.getGraphX(), me.getGraphY());
        const tr = this.graph.view.translate;
        const { scale: scale } = this.graph.view;
        let cos = Math.cos(-alpha);
        let sin = Math.sin(-alpha);
        let dx = point.x - this.startX;
        let dy = point.y - this.startY;
        // Rotates vector for mouse gesture
        const tx = cos * dx - sin * dy;
        const ty = sin * dx + cos * dy;
        dx = tx;
        dy = ty;
        const geo = this.state.cell.getGeometry();
        if (geo && this.index !== null) this.unscaledBounds = this.union(geo, dx / scale, dy / scale, this.index, this.graph.isGridEnabledEvent(me.getEvent()), 1, new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(0, 0), this.isConstrainedEvent(me), this.isCenteredEvent(this.state, me));
        // Keeps vertex within maximum graph or parent bounds
        if (geo && !geo.relative) {
            let max = this.graph.getMaximumGraphBounds();
            // Handles child cells
            if (max != null && this.parentState != null) {
                max = (0, $2997c239141ea844$export$2e2bcd8739ae039).fromRectangle(max);
                max.x -= (this.parentState.x - tr.x * scale) / scale;
                max.y -= (this.parentState.y - tr.y * scale) / scale;
            }
            if (this.graph.isConstrainChild(this.state.cell)) {
                let tmp = this.graph.getCellContainmentArea(this.state.cell);
                if (tmp != null) {
                    const overlap = this.graph.getOverlap(this.state.cell);
                    if (overlap > 0) {
                        tmp = (0, $2997c239141ea844$export$2e2bcd8739ae039).fromRectangle(tmp);
                        tmp.x -= tmp.width * overlap;
                        tmp.y -= tmp.height * overlap;
                        tmp.width += 2 * tmp.width * overlap;
                        tmp.height += 2 * tmp.height * overlap;
                    }
                    if (!max) max = tmp;
                    else {
                        max = (0, $2997c239141ea844$export$2e2bcd8739ae039).fromRectangle(max);
                        max.intersect(tmp);
                    }
                }
            }
            if (max && this.unscaledBounds) {
                if (this.unscaledBounds.x < max.x) {
                    this.unscaledBounds.width -= max.x - this.unscaledBounds.x;
                    this.unscaledBounds.x = max.x;
                }
                if (this.unscaledBounds.y < max.y) {
                    this.unscaledBounds.height -= max.y - this.unscaledBounds.y;
                    this.unscaledBounds.y = max.y;
                }
                if (this.unscaledBounds.x + this.unscaledBounds.width > max.x + max.width) this.unscaledBounds.width -= this.unscaledBounds.x + this.unscaledBounds.width - max.x - max.width;
                if (this.unscaledBounds.y + this.unscaledBounds.height > max.y + max.height) this.unscaledBounds.height -= this.unscaledBounds.y + this.unscaledBounds.height - max.y - max.height;
            }
        }
        if (this.unscaledBounds) {
            const old = this.bounds;
            this.bounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)((this.parentState ? this.parentState.x : tr.x * scale) + this.unscaledBounds.x * scale, (this.parentState ? this.parentState.y : tr.y * scale) + this.unscaledBounds.y * scale, this.unscaledBounds.width * scale, this.unscaledBounds.height * scale);
            if (geo && geo.relative && this.parentState) {
                this.bounds.x += this.state.x - this.parentState.x;
                this.bounds.y += this.state.y - this.parentState.y;
            }
            cos = Math.cos(alpha);
            sin = Math.sin(alpha);
            const c2 = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(this.bounds.getCenterX(), this.bounds.getCenterY());
            dx = c2.x - ct.x;
            dy = c2.y - ct.y;
            const dx2 = cos * dx - sin * dy;
            const dy2 = sin * dx + cos * dy;
            const dx3 = dx2 - dx;
            const dy3 = dy2 - dy;
            const dx4 = this.bounds.x - this.state.x;
            const dy4 = this.bounds.y - this.state.y;
            const dx5 = cos * dx4 - sin * dy4;
            const dy5 = sin * dx4 + cos * dy4;
            this.bounds.x += dx3;
            this.bounds.y += dy3;
            // Rounds unscaled bounds to int
            this.unscaledBounds.x = this.roundLength(this.unscaledBounds.x + dx3 / scale);
            this.unscaledBounds.y = this.roundLength(this.unscaledBounds.y + dy3 / scale);
            this.unscaledBounds.width = this.roundLength(this.unscaledBounds.width);
            this.unscaledBounds.height = this.roundLength(this.unscaledBounds.height);
            // Shifts the children according to parent offset
            if (!this.state.cell.isCollapsed() && (dx3 !== 0 || dy3 !== 0)) {
                this.childOffsetX = this.state.x - this.bounds.x + dx5;
                this.childOffsetY = this.state.y - this.bounds.y + dy5;
            } else {
                this.childOffsetX = 0;
                this.childOffsetY = 0;
            }
            if (!old.equals(this.bounds)) {
                if (this.livePreviewActive) this.updateLivePreview(me);
                if (this.preview != null) this.drawPreview();
                else this.updateParentHighlight();
            }
        }
    }
    /**
     * Repaints the live preview.
     */ updateLivePreview(me) {
        // TODO: Apply child offset to children in live preview
        const { scale: scale } = this.graph.view;
        const tr = this.graph.view.translate;
        // Saves current state
        const tempState = this.state.clone();
        // Temporarily changes size and origin
        this.state.x = this.bounds.x;
        this.state.y = this.bounds.y;
        this.state.origin = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(this.state.x / scale - tr.x, this.state.y / scale - tr.y);
        this.state.width = this.bounds.width;
        this.state.height = this.bounds.height;
        // Redraws cell and handles
        let off = this.state.absoluteOffset;
        off = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(off.x, off.y);
        // Required to store and reset absolute offset for updating label position
        this.state.absoluteOffset.x = 0;
        this.state.absoluteOffset.y = 0;
        const geo = this.state.cell.getGeometry();
        if (geo != null) {
            const offset = geo.offset || this.EMPTY_POINT;
            if (offset != null && !geo.relative) {
                this.state.absoluteOffset.x = this.state.view.scale * offset.x;
                this.state.absoluteOffset.y = this.state.view.scale * offset.y;
            }
            this.state.view.updateVertexLabelOffset(this.state);
        }
        // Draws the live preview
        this.state.view.graph.cellRenderer.redraw(this.state, true);
        // Redraws connected edges TODO: Include child edges
        this.state.view.invalidate(this.state.cell);
        this.state.invalid = false;
        this.state.view.validate();
        this.redrawHandles();
        // Moves live preview to front
        if (this.movePreviewToFront) this.moveToFront();
        // Hides folding icon
        if (this.state.control != null && this.state.control.node != null) this.state.control.node.style.visibility = 'hidden';
        // Restores current state
        this.state.setState(tempState);
    }
    /**
     * Handles the event by applying the changes to the geometry.
     */ moveToFront() {
        if (this.state.text && this.state.text.node && this.state.text.node.nextSibling || this.state.shape && this.state.shape.node && this.state.shape.node.nextSibling && (!this.state.text || this.state.shape.node.nextSibling !== this.state.text.node)) {
            if (this.state.shape && this.state.shape.node && this.state.shape.node.parentNode) this.state.shape.node.parentNode.appendChild(this.state.shape.node);
            if (this.state.text && this.state.text.node && this.state.text.node.parentNode) this.state.text.node.parentNode.appendChild(this.state.text.node);
        }
    }
    /**
     * Handles the event by applying the changes to the geometry.
     */ mouseUp(_sender, me) {
        if (this.index != null && this.state != null) {
            const point = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(me.getGraphX(), me.getGraphY());
            const { index: index } = this;
            this.index = null;
            if (this.ghostPreview == null) {
                // Required to restore order in case of no change
                this.state.view.invalidate(this.state.cell, false, false);
                this.state.view.validate();
            }
            this.graph.batchUpdate(()=>{
                if (index <= (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CUSTOM_HANDLE) {
                    if (this.customHandles != null) {
                        // Creates style before changing cell state
                        const style = this.state.view.graph.getCellStyle(this.state.cell);
                        this.customHandles[(0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CUSTOM_HANDLE - index].active = false;
                        this.customHandles[(0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CUSTOM_HANDLE - index].execute(me);
                        // Sets style and apply on shape to force repaint and
                        // check if execute has removed custom handles
                        if (this.customHandles != null && this.customHandles[(0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CUSTOM_HANDLE - index] != null) {
                            this.state.style = style;
                            this.customHandles[(0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CUSTOM_HANDLE - index].positionChanged();
                        }
                    }
                } else if (index === (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).ROTATION_HANDLE) {
                    if (this.currentAlpha != null) {
                        const delta = this.currentAlpha - (this.state.style.rotation ?? 0);
                        if (delta !== 0) this.rotateCell(this.state.cell, delta);
                    } else this.rotateClick();
                } else {
                    const gridEnabled = this.graph.isGridEnabledEvent(me.getEvent());
                    const alpha = (0, $f7ff90b8964488a6$export$cba01ba138429a1d)(this.state.style.rotation ?? 0);
                    const cos = Math.cos(-alpha);
                    const sin = Math.sin(-alpha);
                    let dx = point.x - this.startX;
                    let dy = point.y - this.startY;
                    // Rotates vector for mouse gesture
                    const tx = cos * dx - sin * dy;
                    const ty = sin * dx + cos * dy;
                    dx = tx;
                    dy = ty;
                    const s = this.graph.view.scale;
                    const recurse = this.isRecursiveResize(this.state, me);
                    this.resizeCell(this.state.cell, this.roundLength(dx / s), this.roundLength(dy / s), index, gridEnabled, this.isConstrainedEvent(me), recurse);
                }
            });
            me.consume();
            this.reset();
            this.redrawHandles();
        }
    }
    /**
     * Returns the `recursiveResize` status of the given state.
     * @param state the given {@link CellState}. This implementation takes the value of this state.
     * @param me the mouse event.
     */ isRecursiveResize(state, me) {
        return this.graph.isRecursiveResize(this.state);
    }
    /**
     * Hook for subclasses to implement a single click on the rotation handle.
     * This code is executed as part of the model transaction.
     *
     * This implementation is empty.
     */ rotateClick() {
        return;
    }
    /**
     * Rotates the given cell and its children by the given angle in degrees.
     *
     * @param cell {@link Cell} to be rotated.
     * @param angle Angle in degrees.
     * @param parent if set, consider the parent in the rotation computation.
     */ rotateCell(cell, angle, parent) {
        if (angle !== 0) {
            const model = this.graph.getDataModel();
            if (cell.isVertex() || cell.isEdge()) {
                if (!cell.isEdge()) {
                    const style = this.graph.getCurrentCellStyle(cell);
                    const total = (style.rotation ?? 0) + angle;
                    this.graph.setCellStyles('rotation', total, [
                        cell
                    ]);
                }
                let geo = cell.getGeometry();
                if (geo && parent) {
                    const pgeo = parent.getGeometry();
                    if (pgeo != null && !parent.isEdge()) {
                        geo = geo.clone();
                        geo.rotate(angle, new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(pgeo.width / 2, pgeo.height / 2));
                        model.setGeometry(cell, geo);
                    }
                    if (cell.isVertex() && !geo.relative || cell.isEdge()) {
                        // Recursive rotation
                        const childCount = cell.getChildCount();
                        for(let i = 0; i < childCount; i += 1)this.rotateCell(cell.getChildAt(i), angle, cell);
                    }
                }
            }
        }
    }
    /**
     * Resets the state of this handler.
     */ reset() {
        if (this.index !== null && this.sizers[this.index].node.style.display === 'none') this.sizers[this.index].node.style.display = '';
        this.index = null;
        this.currentAlpha = null;
        // TODO: Reset and redraw cell states for live preview
        if (this.preview) {
            this.preview.destroy();
            this.preview = null;
        }
        if (this.ghostPreview) {
            this.ghostPreview.destroy();
            this.ghostPreview = null;
        }
        if (this.livePreviewActive) {
            for(let i = 0; i < this.sizers.length; i += 1)this.sizers[i].node.style.display = '';
            // Shows folding icon
            if (this.state.control && this.state.control.node) this.state.control.node.style.visibility = '';
        }
        for(let i = 0; i < this.customHandles.length; i += 1)if (this.customHandles[i].active) {
            this.customHandles[i].active = false;
            this.customHandles[i].reset();
        } else this.customHandles[i].setVisible(true);
        // Checks if handler has been destroyed
        this.selectionBorder.node.style.display = 'inline';
        this.selectionBounds = this.getSelectionBounds(this.state);
        this.bounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(this.selectionBounds.x, this.selectionBounds.y, this.selectionBounds.width, this.selectionBounds.height);
        this.drawPreview();
        this.removeHint();
        this.redrawHandles();
        this.edgeHandlers = [];
        this.handlesVisible = true;
        this.unscaledBounds = null;
    }
    /**
     * Uses the given vector to change the bounds of the given cell
     * in the graph using {@link AbstractGraph.resizeCell}.
     */ resizeCell(cell, dx, dy, index, gridEnabled, constrained, recurse) {
        let geo = cell.getGeometry();
        if (geo) {
            if (index === (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).LABEL_HANDLE && this.labelShape && this.labelShape.bounds) {
                const alpha = -(0, $f7ff90b8964488a6$export$cba01ba138429a1d)(this.state.style.rotation ?? 0);
                const cos = Math.cos(alpha);
                const sin = Math.sin(alpha);
                const { scale: scale } = this.graph.view;
                const pt = (0, $f7ff90b8964488a6$export$ad2a0af3fbffd7c1)(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(Math.round((this.labelShape.bounds.getCenterX() - this.startX) / scale), Math.round((this.labelShape.bounds.getCenterY() - this.startY) / scale)), cos, sin);
                geo = geo.clone();
                if (geo.offset == null) geo.offset = pt;
                else {
                    geo.offset.x += pt.x;
                    geo.offset.y += pt.y;
                }
                this.graph.model.setGeometry(cell, geo);
            } else if (this.unscaledBounds) {
                const { scale: scale } = this.graph.view;
                if (this.childOffsetX !== 0 || this.childOffsetY !== 0) this.moveChildren(cell, Math.round(this.childOffsetX / scale), Math.round(this.childOffsetY / scale));
                this.graph.resizeCell(cell, this.unscaledBounds, recurse);
            }
        }
    }
    /**
     * Moves the children of the given cell by the given vector.
     */ moveChildren(cell, dx, dy) {
        const model = this.graph.getDataModel();
        const childCount = cell.getChildCount();
        for(let i = 0; i < childCount; i += 1){
            const child = cell.getChildAt(i);
            let geo = child.getGeometry();
            if (geo != null) {
                geo = geo.clone();
                geo.translate(dx, dy);
                model.setGeometry(child, geo);
            }
        }
    }
    /**
     * Returns the union of the given bounds and location for the specified
     * handle index.
     *
     * To override this to limit the size of vertex via a minWidth/-Height style,
     * the following code can be used.
     *
     * ```javascript
     * const vertexHandlerUnion = union;
     * vertexHandler.union = (bounds, dx, dy, index, gridEnabled, scale, tr, constrained) => {
     *   const result = vertexHandlerUnion.apply(this, arguments);
     *
     *   result.width = Math.max(result.width, this.state.style.minWidth ?? 0));
     *   result.height = Math.max(result.height, this.state.style.minHeight ?? 0));
     *
     *   return result;
     * };
     * ```
     *
     * The minWidth/-Height style can then be used as follows:
     *
     * ```javascript
     * graph.insertVertex({
     *   parent,
     *   value: 'Hello,',
     *   position: [20, 20],
     *   size: [80, 30],
     *   style: {
     *     minWidth: 100,
     *     minHeight: 100,
     *   },
     * });
     * ```
     *
     * To override this to update the height for a wrapped text if the width of a vertex is
     * changed, the following can be used.
     *
     * ```javascript
     * const vertexHandlerUnion = union;
     * vertexHandler.union = (bounds, dx, dy, index, gridEnabled, scale, tr, constrained) => {
     *   const result = vertexHandlerUnion.apply(this, arguments);
     *   const s = this.state;
     *
     *   if (this.graph.isHtmlLabel(s.cell)
     *        && (index == 3 || index == 4)
     *        && s.text != null && s.style.whiteSpace == 'wrap') {
     *     const label = this.graph.getLabel(s.cell);
     *     const fontSize = s.style.fontSize ?? StyleDefaultsConfig.fontSize;
     *     const ww = result.width / s.view.scale - s.text.spacingRight - s.text.spacingLeft
     *
     *     result.height = styleUtils.getSizeForString(label, fontSize, s.style.fontFamily, ww).height;
     *   }
     *
     *   return result;
     * };
     * ```
     */ union(bounds, dx, dy, index, gridEnabled, scale, tr, constrained, centered) {
        gridEnabled = gridEnabled && this.graph.isGridEnabled();
        if (this.singleSizer) {
            let x = bounds.x + bounds.width + dx;
            let y = bounds.y + bounds.height + dy;
            if (gridEnabled) {
                x = this.graph.snap(x / scale) * scale;
                y = this.graph.snap(y / scale) * scale;
            }
            const rect = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(bounds.x, bounds.y, 0, 0);
            rect.add(new (0, $2997c239141ea844$export$2e2bcd8739ae039)(x, y, 0, 0));
            return rect;
        }
        const w0 = bounds.width;
        const h0 = bounds.height;
        let left = bounds.x - tr.x * scale;
        let right = left + w0;
        let top = bounds.y - tr.y * scale;
        let bottom = top + h0;
        const cx = left + w0 / 2;
        const cy = top + h0 / 2;
        if (index > 4 /* Bottom Row */ ) {
            bottom += dy;
            if (gridEnabled) bottom = this.graph.snap(bottom / scale) * scale;
            else bottom = Math.round(bottom / scale) * scale;
        } else if (index < 3 /* Top Row */ ) {
            top += dy;
            if (gridEnabled) top = this.graph.snap(top / scale) * scale;
            else top = Math.round(top / scale) * scale;
        }
        if (index === 0 || index === 3 || index === 5 /* Left */ ) {
            left += dx;
            if (gridEnabled) left = this.graph.snap(left / scale) * scale;
            else left = Math.round(left / scale) * scale;
        } else if (index === 2 || index === 4 || index === 7 /* Right */ ) {
            right += dx;
            if (gridEnabled) right = this.graph.snap(right / scale) * scale;
            else right = Math.round(right / scale) * scale;
        }
        let width = right - left;
        let height = bottom - top;
        if (constrained) {
            const geo = this.state.cell.getGeometry();
            if (geo != null) {
                const aspect = geo.width / geo.height;
                if (index === 1 || index === 2 || index === 7 || index === 6) width = height * aspect;
                else height = width / aspect;
                if (index === 0) {
                    left = right - width;
                    top = bottom - height;
                }
            }
        }
        if (centered) {
            width += width - w0;
            height += height - h0;
            const cdx = cx - (left + width / 2);
            const cdy = cy - (top + height / 2);
            left += cdx;
            top += cdy;
            right += cdx;
            bottom += cdy;
        }
        // Flips over left side
        if (width < 0) {
            left += width;
            width = Math.abs(width);
        }
        // Flips over top side
        if (height < 0) {
            top += height;
            height = Math.abs(height);
        }
        const result = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(left + tr.x * scale, top + tr.y * scale, width, height);
        if (this.minBounds != null) {
            result.width = Math.max(result.width, this.minBounds.x * scale + this.minBounds.width * scale + Math.max(0, this.x0 * scale - result.x));
            result.height = Math.max(result.height, this.minBounds.y * scale + this.minBounds.height * scale + Math.max(0, this.y0 * scale - result.y));
        }
        return result;
    }
    /**
     * Redraws the handles and the preview.
     */ redraw(ignoreHandles) {
        this.selectionBounds = this.getSelectionBounds(this.state);
        this.bounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(this.selectionBounds.x, this.selectionBounds.y, this.selectionBounds.width, this.selectionBounds.height);
        this.drawPreview();
        if (!ignoreHandles) this.redrawHandles();
    }
    /**
     * Returns the padding to be used for drawing handles for the current <bounds>.
     */ getHandlePadding() {
        // KNOWN: Tolerance depends on event type (eg. 0 for mouse events)
        const result = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(0, 0);
        let tol = this.tolerance;
        if (this.sizers.length > 0 && this.sizers[0].bounds && (this.bounds.width < 2 * this.sizers[0].bounds.width + 2 * tol || this.bounds.height < 2 * this.sizers[0].bounds.height + 2 * tol)) {
            tol /= 2;
            result.x = this.sizers[0].bounds.width + tol;
            result.y = this.sizers[0].bounds.height + tol;
        }
        return result;
    }
    /**
     * Returns the bounds used to paint the resize handles.
     */ getSizerBounds() {
        return this.bounds;
    }
    /**
     * Redraws the handles. To hide certain handles the following code can be used.
     *
     * ```javascript
     * redrawHandles()
     * {
     *   mxVertexHandlerRedrawHandles.apply(this, arguments);
     *
     *   if (this.sizers != null && this.sizers.length > 7)
     *   {
     *     this.sizers[1].node.style.display = 'none';
     *     this.sizers[6].node.style.display = 'none';
     *   }
     * };
     * ```
     */ redrawHandles() {
        let s = this.getSizerBounds();
        const tol = this.tolerance;
        this.horizontalOffset = 0;
        this.verticalOffset = 0;
        for(let i = 0; i < this.customHandles.length; i += 1){
            const shape = this.customHandles[i].shape;
            if (shape) {
                const temp = shape.node.style.display;
                this.customHandles[i].redraw();
                shape.node.style.display = temp;
                // Hides custom handles during text editing
                shape.node.style.visibility = this.handlesVisible && this.isCustomHandleVisible(this.customHandles[i]) ? '' : 'hidden';
            }
        }
        if (this.sizers.length > 0 && this.sizers[0]) {
            if (this.index === null && this.manageSizers && this.sizers.length >= 8) {
                // KNOWN: Tolerance depends on event type (eg. 0 for mouse events)
                const padding = this.getHandlePadding();
                this.horizontalOffset = padding.x;
                this.verticalOffset = padding.y;
                if (this.horizontalOffset !== 0 || this.verticalOffset !== 0) {
                    s = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(s.x, s.y, s.width, s.height);
                    s.x -= this.horizontalOffset / 2;
                    s.width += this.horizontalOffset;
                    s.y -= this.verticalOffset / 2;
                    s.height += this.verticalOffset;
                }
                if (this.sizers.length >= 8) {
                    if (this.sizers[0].bounds && (s.width < 2 * this.sizers[0].bounds.width + 2 * tol || s.height < 2 * this.sizers[0].bounds.height + 2 * tol)) {
                        this.sizers[0].node.style.display = 'none';
                        this.sizers[2].node.style.display = 'none';
                        this.sizers[5].node.style.display = 'none';
                        this.sizers[7].node.style.display = 'none';
                    } else if (this.handlesVisible) {
                        this.sizers[0].node.style.display = '';
                        this.sizers[2].node.style.display = '';
                        this.sizers[5].node.style.display = '';
                        this.sizers[7].node.style.display = '';
                    }
                }
            }
            const r = s.x + s.width;
            const b = s.y + s.height;
            if (this.singleSizer) this.moveSizerTo(this.sizers[0], r, b);
            else {
                const cx = s.x + s.width / 2;
                const cy = s.y + s.height / 2;
                if (this.sizers.length >= 8) {
                    const crs = [
                        'nw-resize',
                        'n-resize',
                        'ne-resize',
                        'e-resize',
                        'se-resize',
                        's-resize',
                        'sw-resize',
                        'w-resize'
                    ];
                    const alpha = (0, $f7ff90b8964488a6$export$cba01ba138429a1d)(this.state.style.rotation ?? 0);
                    const cos = Math.cos(alpha);
                    const sin = Math.sin(alpha);
                    const da = Math.round(alpha * 4 / Math.PI);
                    const ct = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(s.getCenterX(), s.getCenterY());
                    let pt = (0, $f7ff90b8964488a6$export$ad2a0af3fbffd7c1)(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(s.x, s.y), cos, sin, ct);
                    this.moveSizerTo(this.sizers[0], pt.x, pt.y);
                    this.sizers[0].setCursor(crs[(0, $f7ff90b8964488a6$export$842a2cf37af977e1)(0 + da, crs.length)]);
                    pt.x = cx;
                    pt.y = s.y;
                    pt = (0, $f7ff90b8964488a6$export$ad2a0af3fbffd7c1)(pt, cos, sin, ct);
                    this.moveSizerTo(this.sizers[1], pt.x, pt.y);
                    this.sizers[1].setCursor(crs[(0, $f7ff90b8964488a6$export$842a2cf37af977e1)(1 + da, crs.length)]);
                    pt.x = r;
                    pt.y = s.y;
                    pt = (0, $f7ff90b8964488a6$export$ad2a0af3fbffd7c1)(pt, cos, sin, ct);
                    this.moveSizerTo(this.sizers[2], pt.x, pt.y);
                    this.sizers[2].setCursor(crs[(0, $f7ff90b8964488a6$export$842a2cf37af977e1)(2 + da, crs.length)]);
                    pt.x = s.x;
                    pt.y = cy;
                    pt = (0, $f7ff90b8964488a6$export$ad2a0af3fbffd7c1)(pt, cos, sin, ct);
                    this.moveSizerTo(this.sizers[3], pt.x, pt.y);
                    this.sizers[3].setCursor(crs[(0, $f7ff90b8964488a6$export$842a2cf37af977e1)(7 + da, crs.length)]);
                    pt.x = r;
                    pt.y = cy;
                    pt = (0, $f7ff90b8964488a6$export$ad2a0af3fbffd7c1)(pt, cos, sin, ct);
                    this.moveSizerTo(this.sizers[4], pt.x, pt.y);
                    this.sizers[4].setCursor(crs[(0, $f7ff90b8964488a6$export$842a2cf37af977e1)(3 + da, crs.length)]);
                    pt.x = s.x;
                    pt.y = b;
                    pt = (0, $f7ff90b8964488a6$export$ad2a0af3fbffd7c1)(pt, cos, sin, ct);
                    this.moveSizerTo(this.sizers[5], pt.x, pt.y);
                    this.sizers[5].setCursor(crs[(0, $f7ff90b8964488a6$export$842a2cf37af977e1)(6 + da, crs.length)]);
                    pt.x = cx;
                    pt.y = b;
                    pt = (0, $f7ff90b8964488a6$export$ad2a0af3fbffd7c1)(pt, cos, sin, ct);
                    this.moveSizerTo(this.sizers[6], pt.x, pt.y);
                    this.sizers[6].setCursor(crs[(0, $f7ff90b8964488a6$export$842a2cf37af977e1)(5 + da, crs.length)]);
                    pt.x = r;
                    pt.y = b;
                    pt = (0, $f7ff90b8964488a6$export$ad2a0af3fbffd7c1)(pt, cos, sin, ct);
                    this.moveSizerTo(this.sizers[7], pt.x, pt.y);
                    this.sizers[7].setCursor(crs[(0, $f7ff90b8964488a6$export$842a2cf37af977e1)(4 + da, crs.length)]);
                    pt.x = cx + this.state.absoluteOffset.x;
                    pt.y = cy + this.state.absoluteOffset.y;
                    pt = (0, $f7ff90b8964488a6$export$ad2a0af3fbffd7c1)(pt, cos, sin, ct);
                    this.moveSizerTo(this.sizers[8], pt.x, pt.y);
                } else if (this.state.width >= 2 && this.state.height >= 2) this.moveSizerTo(this.sizers[0], cx + this.state.absoluteOffset.x, cy + this.state.absoluteOffset.y);
                else this.moveSizerTo(this.sizers[0], this.state.x, this.state.y);
            }
        }
        if (this.rotationShape) {
            const alpha = (0, $f7ff90b8964488a6$export$cba01ba138429a1d)(this.currentAlpha ?? this.state.style.rotation ?? 0);
            const cos = Math.cos(alpha);
            const sin = Math.sin(alpha);
            const ct = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(this.state.getCenterX(), this.state.getCenterY());
            const pt = (0, $f7ff90b8964488a6$export$ad2a0af3fbffd7c1)(this.getRotationHandlePosition(), cos, sin, ct);
            if (this.rotationShape.node != null) {
                this.moveSizerTo(this.rotationShape, pt.x, pt.y);
                // Hides rotation handle during text editing
                this.rotationShape.node.style.visibility = this.state.view.graph.isEditing() || !this.handlesVisible ? 'hidden' : '';
            }
        }
        if (this.selectionBorder != null) this.selectionBorder.rotation = this.state.style.rotation ?? 0;
        if (this.edgeHandlers != null) for(let i = 0; i < this.edgeHandlers.length; i += 1)this.edgeHandlers[i].redraw();
    }
    /**
     * Returns true if the given custom handle is visible.
     */ isCustomHandleVisible(handle) {
        return !this.graph.isEditing() && this.state.view.graph.getSelectionCount() === 1;
    }
    /**
     * Returns an {@link Point} that defines the rotation handle position.
     */ getRotationHandlePosition() {
        return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(this.bounds.x + this.bounds.width / 2, this.bounds.y + this.rotationHandleVSpacing);
    }
    /**
     * Returns `true` if the parent highlight should be visible.
     *
     * This implementation always returns `true`.
     */ isParentHighlightVisible() {
        const parent = this.state.cell.getParent();
        return parent ? !this.graph.isCellSelected(parent) : false;
    }
    /**
     * Updates the highlight of the parent if {@link parentHighlightEnabled} is `true`.
     */ updateParentHighlight() {
        if (!this.isDestroyed()) {
            const visible = this.isParentHighlightVisible();
            const parent = this.state.cell.getParent();
            const pstate = parent ? this.graph.view.getState(parent) : null;
            if (this.parentHighlight) {
                if (parent && parent.isVertex() && visible) {
                    const b = this.parentHighlight.bounds;
                    if (pstate && b && (b.x !== pstate.x || b.y !== pstate.y || b.width !== pstate.width || b.height !== pstate.height)) {
                        this.parentHighlight.bounds = (0, $2997c239141ea844$export$2e2bcd8739ae039).fromRectangle(pstate);
                        this.parentHighlight.redraw();
                    }
                } else {
                    if (pstate != null && pstate.parentHighlight === this.parentHighlight) pstate.parentHighlight = null;
                    this.parentHighlight.destroy();
                    this.parentHighlight = null;
                }
            } else if (this.parentHighlightEnabled && visible) {
                if (parent && parent.isVertex() && pstate != null && pstate.parentHighlight == null) {
                    this.parentHighlight = this.createParentHighlightShape(pstate);
                    // VML dialect required here for event transparency in IE
                    this.parentHighlight.dialect = 'svg';
                    this.parentHighlight.pointerEvents = false;
                    this.parentHighlight.rotation = pstate.style.rotation ?? 0;
                    this.parentHighlight.init(this.graph.getView().getOverlayPane());
                    this.parentHighlight.redraw();
                    // Shows highlight once per parent
                    pstate.parentHighlight = this.parentHighlight;
                }
            }
        }
    }
    /**
     * Redraws the preview.
     */ drawPreview() {
        if (this.preview != null) {
            this.preview.bounds = this.bounds;
            if (this.preview.node.parentNode === this.graph.container) {
                this.preview.bounds.width = Math.max(0, this.preview.bounds.width - 1);
                this.preview.bounds.height = Math.max(0, this.preview.bounds.height - 1);
            }
            this.preview.rotation = this.state.style.rotation ?? 0;
            this.preview.redraw();
        }
        this.selectionBorder.bounds = this.getSelectionBorderBounds();
        this.selectionBorder.redraw();
        this.updateParentHighlight();
    }
    /**
     * Returns the bounds for the selection border.
     */ getSelectionBorderBounds() {
        return this.bounds;
    }
    /**
     * Returns `true` if this handler was destroyed or not initialized.
     */ isDestroyed() {
        return this.selectionBorder == null;
    }
    /**
     * Destroys the handler and all its resources and DOM nodes.
     */ onDestroy() {
        this.state.view.graph.removeListener(this.escapeHandler);
        this.escapeHandler = ()=>{
            return;
        };
        if (this.preview) {
            this.preview.destroy();
            this.preview = null;
        }
        if (this.parentHighlight) {
            const parent = this.state.cell.getParent();
            const pstate = parent ? this.graph.view.getState(parent) : null;
            if (pstate && pstate.parentHighlight === this.parentHighlight) pstate.parentHighlight = null;
            this.parentHighlight.destroy();
            this.parentHighlight = null;
        }
        if (this.ghostPreview) {
            this.ghostPreview.destroy();
            this.ghostPreview = null;
        }
        if (this.selectionBorder) this.selectionBorder.destroy();
        this.labelShape = null;
        this.removeHint();
        for(let i = 0; i < this.sizers.length; i += 1)this.sizers[i].destroy();
        this.sizers = [];
        for(let i = 0; i < this.customHandles.length; i += 1)this.customHandles[i].destroy();
        this.customHandles = [];
    }
}
var $b94bb9bb182e316f$export$2e2bcd8739ae039 = $b94bb9bb182e316f$var$VertexHandler;


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 







/**
 * Graph event handler that reconnects edges, modifies control points and the edge label location.
 * It extends {@link EdgeHandler} to display a single intermediate handle, which suits the elbow shaped routings
 * whose geometry is driven by one control point.
 *
 * Uses {@link CellMarker} for finding and highlighting new source and target vertices.
 *
 * **Instantiation**
 *
 * This is the handler of the `'elbow'` {@link EdgeStyleHandlerKind}. {@link SelectionCellsHandler} creates it for
 * each selected edge whose `EdgeStyle` is registered under that kind in {@link EdgeStyleRegistry}, which the built-in
 * `elbowEdgeStyle`, `loopEdgeStyle`, `sideToSideEdgeStyle` and `topToBottomEdgeStyle` are.
 *
 * To have maxGraph create a custom implementation instead, register a factory on the plugin:
 * ```typescript
 * selectionCellsHandler.setEdgeHandlerFactory('elbow', (state) => new MyElbowEdgeHandler(state));
 * ```
 *
 * **Configuration**
 *
 * Some elements of this handler and its subclasses can be configured globally using {@link EdgeHandlerConfig} and
 * {@link HandleConfig}.
 */ class $84dd256ead9f22dd$var$ElbowEdgeHandler extends (0, $d02037fd5fbb23ea$export$2e2bcd8739ae039) {
    constructor(state){
        super(state);
        /**
         * Specifies if a double click on the middle handle should call {@link AbstractGraph.flipEdge}.
         * @default true
         */ this.flipEnabled = true;
        /**
         * Specifies the resource key for the tooltip to be displayed on the single
         * control point for routed edges. If the resource for this key does not
         * exist then the value is used as the error message.
         * @default 'doubleClickOrientation'.
         */ this.doubleClickOrientationResource = (0, $78efedcb0f6c688d$export$ee28232f9313fcdf)() ? 'doubleClickOrientation' : '';
    }
    /**
     * Overrides {@link EdgeHandler.createBends} to create custom bends.
     */ createBends() {
        const bends = [];
        // Source
        let bend = this.createHandleShape(0);
        this.initBend(bend);
        bend.setCursor((0, $f17931ed28a53cd3$export$3c0f4b700203d869).cursorTerminal);
        bends.push(bend);
        // Virtual
        bends.push(this.createVirtualBend((evt)=>{
            if (!(0, $f192e93a2fd1153c$export$f6e93dab47d340de)(evt) && this.flipEnabled) {
                this.graph.flipEdge(this.state.cell);
                (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).consume(evt);
            }
        }));
        this.points.push(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(0, 0));
        // Target
        bend = this.createHandleShape(2);
        this.initBend(bend);
        bend.setCursor((0, $f17931ed28a53cd3$export$3c0f4b700203d869).cursorTerminal);
        bends.push(bend);
        return bends;
    }
    /**
     * Creates a virtual bend that supports double-clicking and calls {@link AbstractGraph.flipEdge}.
     */ createVirtualBend(dblClickHandler) {
        const bend = this.createHandleShape();
        this.initBend(bend, dblClickHandler);
        bend.setCursor(this.getCursorForBend());
        if (!this.graph.isCellBendable(this.state.cell)) bend.node.style.display = 'none';
        return bend;
    }
    /**
     * Returns the cursor to be used for the bend.
     */ getCursorForBend() {
        return this.state.style.edgeStyle === 'topToBottomEdgeStyle' || this.state.style.edgeStyle === 'elbowEdgeStyle' && this.state.style.elbow === 'vertical' ? 'row-resize' : 'col-resize';
    }
    /**
     * Returns the tooltip for the given node.
     */ getTooltipForNode(node) {
        let tip = null;
        if (this.bends != null && this.bends[1] != null && (node === this.bends[1].node || node.parentNode === this.bends[1].node)) {
            tip = this.doubleClickOrientationResource;
            tip = (0, $78efedcb0f6c688d$export$d73ee8ef04f5226a)(tip) || tip;
        }
        return tip;
    }
    /**
     * Converts the given point in-place from screen to unscaled, untranslated
     * graph coordinates and applies the grid.
     *
     * @param point {@link Point} to be converted.
     * @param gridEnabled Boolean that specifies if the grid should be applied.
     */ convertPoint(point, gridEnabled) {
        const scale = this.graph.getView().getScale();
        const tr = this.graph.getView().getTranslate();
        const { origin: origin } = this.state;
        if (gridEnabled) {
            point.x = this.graph.snap(point.x);
            point.y = this.graph.snap(point.y);
        }
        point.x = Math.round(point.x / scale - tr.x - origin.x);
        point.y = Math.round(point.y / scale - tr.y - origin.y);
        return point;
    }
    /**
     * Updates and redraws the inner bends.
     *
     * @param p0 {@link Point} that represents the location of the first point.
     * @param pe {@link Point} that represents the location of the last point.
     */ redrawInnerBends(p0, pe) {
        const g = this.state.cell.getGeometry();
        const pts = this.state.absolutePoints;
        let pt = null;
        // Keeps the virtual bend on the edge shape
        if (pts.length > 1) {
            p0 = pts[1];
            pe = pts[pts.length - 2];
        } else if (g.points != null && g.points.length > 0) pt = pts[0];
        if (pt == null) pt = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(p0.x + (pe.x - p0.x) / 2, p0.y + (pe.y - p0.y) / 2);
        else pt = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(this.graph.getView().scale * (pt.x + this.graph.getView().translate.x + this.state.origin.x), this.graph.getView().scale * (pt.y + this.graph.getView().translate.y + this.state.origin.y));
        // Makes handle slightly bigger if the yellow  label handle
        // exists and intersects this green handle
        const b = this.bends[1].bounds;
        let w = b.width;
        let h = b.height;
        let bounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(Math.round(pt.x - w / 2), Math.round(pt.y - h / 2), w, h);
        if (this.manageLabelHandle) this.checkLabelHandle(bounds);
        else if (this.handleImage == null && this.labelShape.visible && this.labelShape.bounds && (0, $f7ff90b8964488a6$export$7b0a31e10bbff018)(bounds, this.labelShape.bounds)) {
            w = (0, $f17931ed28a53cd3$export$f4c61547d94bf143).size + 3;
            h = w;
            bounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(Math.floor(pt.x - w / 2), Math.floor(pt.y - h / 2), w, h);
        }
        this.bends[1].bounds = bounds;
        this.bends[1].redraw();
        if (this.manageLabelHandle) this.checkLabelHandle(this.bends[1].bounds);
    }
}
var $84dd256ead9f22dd$export$2e2bcd8739ae039 = $84dd256ead9f22dd$var$ElbowEdgeHandler;


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 





/**
 * Graph event handler that reconnects edges, modifies control points and the edge label location.
 * It extends {@link ElbowEdgeHandler} to display a handle on each segment of the computed routing, so that the
 * segments of an orthogonal edge can be moved individually.
 *
 * Uses {@link CellMarker} for finding and highlighting new source and target vertices.
 *
 * **Instantiation**
 *
 * This is the handler of the `'segment'` {@link EdgeStyleHandlerKind}. {@link SelectionCellsHandler} creates it for
 * each selected edge whose `EdgeStyle` is registered under that kind in {@link EdgeStyleRegistry}, which the built-in
 * `manhattanEdgeStyle`, `orthogonalEdgeStyle` and `segmentEdgeStyle` are.
 *
 * To have maxGraph create a custom implementation instead, register a factory on the plugin:
 * ```typescript
 * selectionCellsHandler.setEdgeHandlerFactory('segment', (state) => new MyEdgeSegmentHandler(state));
 * ```
 *
 * **Configuration**
 *
 * Some elements of this handler and its subclasses can be configured globally using {@link EdgeHandlerConfig} and
 * {@link HandleConfig}.
 */ class $fcf0e51b59408fc7$var$EdgeSegmentHandler extends (0, $84dd256ead9f22dd$export$2e2bcd8739ae039) {
    constructor(state){
        super(state);
        this.points = [];
    }
    /**
     * Returns the current absolute points.
     */ getCurrentPoints() {
        let pts = this.state.absolutePoints;
        // Special case for straight edges where we add a virtual middle handle for moving the edge
        const tol = Math.max(1, this.graph.view.scale);
        if (pts.length === 2 && pts[0] && pts[1] || pts.length === 3 && pts[0] && pts[1] && pts[2] && (Math.abs(pts[0].x - pts[1].x) < tol && Math.abs(pts[1].x - pts[2].x) < tol || Math.abs(pts[0].y - pts[1].y) < tol && Math.abs(pts[1].y - pts[2].y) < tol)) {
            const cx = pts[0].x + (pts[pts.length - 1].x - pts[0].x) / 2;
            const cy = pts[0].y + (pts[pts.length - 1].y - pts[0].y) / 2;
            pts = [
                pts[0],
                new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(cx, cy),
                new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(cx, cy),
                pts[pts.length - 1]
            ];
        }
        return pts;
    }
    /**
     * Updates the given preview state taking into account the state of the constraint handler.
     */ getPreviewPoints(point) {
        if (this.isSource || this.isTarget) return super.getPreviewPoints(point);
        const pts = this.getCurrentPoints();
        let last = this.convertPoint(pts[0].clone(), false);
        point = this.convertPoint(point.clone(), false);
        let result = [];
        for(let i = 1; i < pts.length; i += 1){
            const pt = this.convertPoint(pts[i].clone(), false);
            if (i === this.index) {
                if (Math.round(last.x - pt.x) === 0) {
                    last.x = point.x;
                    pt.x = point.x;
                }
                if (Math.round(last.y - pt.y) === 0) {
                    last.y = point.y;
                    pt.y = point.y;
                }
            }
            if (i < pts.length - 1) result.push(pt);
            last = pt;
        }
        // Replaces single point that intersects with source or target
        if (result.length === 1) {
            const source = this.state.getVisibleTerminalState(true);
            const target = this.state.getVisibleTerminalState(false);
            const scale = this.state.view.getScale();
            const tr = this.state.view.getTranslate();
            const x = result[0].x * scale + tr.x;
            const y = result[0].y * scale + tr.y;
            if (source != null && (0, $f7ff90b8964488a6$export$2344b14b097df817)(source, x, y) || target != null && (0, $f7ff90b8964488a6$export$2344b14b097df817)(target, x, y)) result = [
                point,
                point
            ];
        }
        return result;
    }
    /**
     * Overridden to perform optimization of the edge style result.
     */ updatePreviewState(edge, point, terminalState, me) {
        super.updatePreviewState(edge, point, terminalState, me);
        // Checks and corrects preview by running edge style again
        if (!this.isSource && !this.isTarget) {
            point = this.convertPoint(point.clone(), false);
            const pts = edge.absolutePoints;
            let pt0 = pts[0];
            let pt1 = pts[1];
            let result = [];
            for(let i = 2; i < pts.length; i += 1){
                const pt2 = pts[i];
                // Merges adjacent segments only if more than 2 to allow for straight edges
                if ((Math.round(pt0.x - pt1.x) !== 0 || Math.round(pt1.x - pt2.x) !== 0) && (Math.round(pt0.y - pt1.y) !== 0 || Math.round(pt1.y - pt2.y) !== 0)) result.push(this.convertPoint(pt1.clone(), false));
                pt0 = pt1;
                pt1 = pt2;
            }
            const source = this.state.getVisibleTerminalState(true);
            const target = this.state.getVisibleTerminalState(false);
            const rpts = this.state.absolutePoints;
            const end = pts[pts.length - 1];
            // A straight line is represented by 3 handles
            if (result.length === 0 && pts[0] && end && (Math.round(pts[0].x - end.x) === 0 || Math.round(pts[0].y - end.y) === 0)) result = [
                point,
                point
            ];
            else if (pts.length === 5 && result.length === 2 && source != null && target != null && rpts != null && Math.round(rpts[0].x - rpts[rpts.length - 1].x) === 0) {
                const view = this.graph.getView();
                const scale = view.getScale();
                const tr = view.getTranslate();
                let y0 = view.getRoutingCenterY(source) / scale - tr.y;
                // Use fixed connection point y-coordinate if one exists
                const sc = this.graph.getConnectionConstraint(edge, source, true);
                if (sc != null) {
                    const pt = this.graph.getConnectionPoint(source, sc);
                    if (pt != null) {
                        this.convertPoint(pt, false);
                        y0 = pt.y;
                    }
                }
                let ye = view.getRoutingCenterY(target) / scale - tr.y;
                // Use fixed connection point y-coordinate if one exists
                const tc = this.graph.getConnectionConstraint(edge, target, false);
                if (tc) {
                    const pt = this.graph.getConnectionPoint(target, tc);
                    if (pt != null) {
                        this.convertPoint(pt, false);
                        ye = pt.y;
                    }
                }
                result = [
                    new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(point.x, y0),
                    new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(point.x, ye)
                ];
            }
            this.points = result;
            // LATER: Check if points and result are different
            edge.view.updateFixedTerminalPoints(edge, source, target);
            edge.view.updatePoints(edge, this.points, source, target);
            edge.view.updateFloatingTerminalPoints(edge, source, target);
        }
    }
    /**
     * Overriden to merge edge segments.
     */ connect(edge, terminal, isSource, isClone, me) {
        const model = this.graph.getDataModel();
        let geo = edge.getGeometry();
        let result = null;
        // Merges adjacent edge segments
        if (geo != null && geo.points != null && geo.points.length > 0) {
            const pts = this.abspoints;
            let pt0 = pts[0];
            let pt1 = pts[1];
            result = [];
            for(let i = 2; i < pts.length; i += 1){
                const pt2 = pts[i];
                // Merges adjacent segments only if more than 2 to allow for straight edges
                if (pt0 && pt1 && pt2 && (Math.round(pt0.x - pt1.x) !== 0 || Math.round(pt1.x - pt2.x) !== 0) && (Math.round(pt0.y - pt1.y) !== 0 || Math.round(pt1.y - pt2.y) !== 0)) result.push(this.convertPoint(pt1.clone(), false));
                pt0 = pt1;
                pt1 = pt2;
            }
        }
        this.graph.batchUpdate(()=>{
            if (result != null) {
                geo = edge.getGeometry();
                if (geo != null) {
                    geo = geo.clone();
                    geo.points = result;
                    model.setGeometry(edge, geo);
                }
            }
            edge = super.connect(edge, terminal, isSource, isClone, me);
        });
        return edge;
    }
    /**
     * Returns no tooltips.
     */ getTooltipForNode(node) {
        return null;
    }
    /**
     * Adds custom bends for the center of each segment.
     */ start(x, y, index) {
        super.start(x, y, index);
        if (this.bends != null && this.bends[index] != null && !this.isSource && !this.isTarget) (0, $b55d6ca3b42398e2$export$2646c6b151d2e8)(this.bends[index].node, 100);
    }
    /**
     * Adds custom bends for the center of each segment.
     */ createBends() {
        const bends = [];
        // Source
        let bend = this.createHandleShape(0);
        this.initBend(bend);
        bend.setCursor((0, $f17931ed28a53cd3$export$3c0f4b700203d869).cursorTerminal);
        bends.push(bend);
        const pts = this.getCurrentPoints();
        // Waypoints (segment handles)
        if (this.graph.isCellBendable(this.state.cell)) {
            if (this.points == null) this.points = [];
            for(let i = 0; i < pts.length - 1; i += 1){
                bend = this.createVirtualBend();
                bends.push(bend);
                let horizontal = Math.round(pts[i].x - pts[i + 1].x) === 0;
                // Special case where dy is 0 as well
                if (Math.round(pts[i].y - pts[i + 1].y) === 0 && i < pts.length - 2) horizontal = Math.round(pts[i].x - pts[i + 2].x) === 0;
                bend.setCursor(horizontal ? 'col-resize' : 'row-resize');
                this.points.push(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(0, 0));
            }
        }
        // Target
        bend = this.createHandleShape(pts.length);
        this.initBend(bend);
        bend.setCursor((0, $f17931ed28a53cd3$export$3c0f4b700203d869).cursorTerminal);
        bends.push(bend);
        return bends;
    }
    /**
     * Overridden to invoke <refresh> before the redraw.
     */ redraw() {
        this.refresh();
        super.redraw();
    }
    /**
     * Updates the position of the custom bends.
     */ redrawInnerBends(p0, pe) {
        if (this.graph.isCellBendable(this.state.cell)) {
            const pts = this.getCurrentPoints();
            if (pts != null && pts.length > 1) {
                let straight = false;
                // Puts handle in the center of straight edges
                if (pts.length === 4 && pts[0] && pts[1] && pts[2] && pts[3] && Math.round(pts[1].x - pts[2].x) === 0 && Math.round(pts[1].y - pts[2].y) === 0) {
                    straight = true;
                    if (Math.round(pts[0].y - pts[pts.length - 1].y) === 0) {
                        const cx = pts[0].x + (pts[pts.length - 1].x - pts[0].x) / 2;
                        pts[1] = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(cx, pts[1].y);
                        pts[2] = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(cx, pts[2].y);
                    } else {
                        const cy = pts[0].y + (pts[pts.length - 1].y - pts[0].y) / 2;
                        pts[1] = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(pts[1].x, cy);
                        pts[2] = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(pts[2].x, cy);
                    }
                }
                for(let i = 0; i < pts.length - 1; i += 1)if (this.bends[i + 1] != null) {
                    p0 = pts[i];
                    pe = pts[i + 1];
                    const pt = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(p0.x + (pe.x - p0.x) / 2, p0.y + (pe.y - p0.y) / 2);
                    const b = this.bends[i + 1].bounds;
                    this.bends[i + 1].bounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(Math.floor(pt.x - b.width / 2), Math.floor(pt.y - b.height / 2), b.width, b.height);
                    this.bends[i + 1].redraw();
                    if (this.manageLabelHandle) this.checkLabelHandle(this.bends[i + 1].bounds);
                }
                if (straight) {
                    (0, $b55d6ca3b42398e2$export$2646c6b151d2e8)(this.bends[1].node, (0, $f17931ed28a53cd3$export$3c0f4b700203d869).virtualBendOpacity);
                    (0, $b55d6ca3b42398e2$export$2646c6b151d2e8)(this.bends[3].node, (0, $f17931ed28a53cd3$export$3c0f4b700203d869).virtualBendOpacity);
                }
            }
        }
    }
}
var $fcf0e51b59408fc7$export$2e2bcd8739ae039 = $fcf0e51b59408fc7$var$EdgeSegmentHandler;




var $h5l15 = parcelRequire("h5l15");
/**
 * An event handler that manages cell handlers and invokes their mouse event processing functions.
 *
 * ### Events
 *
 * #### InternalEvent.ADD
 *
 * Fires if a cell has been added to the selection.
 * The `state` property contains the {@link CellState} that has been added.
 *
 * #### InternalEvent.REMOVE
 *
 * Fires if a cell has been remove from the selection.
 * The `state` property contains the {@link CellState} that has been removed.
 *
 * @category Plugin
 */ class $bfdc6dda29863ca3$var$SelectionCellsHandler extends (0, $17f25eceeba97548$export$2e2bcd8739ae039) {
    constructor(graph){
        super();
        this.vertexHandlerFactory = (state)=>{
            return new (0, $b94bb9bb182e316f$export$2e2bcd8739ae039)(state);
        };
        this.edgeHandlerFactories = new Map([
            [
                'default',
                (state)=>new (0, $d02037fd5fbb23ea$export$2e2bcd8739ae039)(state)
            ],
            [
                'elbow',
                (state)=>new (0, $84dd256ead9f22dd$export$2e2bcd8739ae039)(state)
            ],
            [
                'segment',
                (state)=>new (0, $fcf0e51b59408fc7$export$2e2bcd8739ae039)(state)
            ]
        ]);
        /**
         * Specifies if events are handled.
         * @default true
         */ this.enabled = true;
        /**
         * Defines the maximum number of handlers to paint individually.
         * @default 100
         */ this.maxHandlers = 100;
        this.graph = graph;
        this.handlers = new Map();
        this.graph.addMouseListener(this);
        this.refreshHandler = ()=>{
            if (this.isEnabled()) this.refresh();
        };
        this.graph.getSelectionModel().addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CHANGE, this.refreshHandler);
        this.graph.getDataModel().addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CHANGE, this.refreshHandler);
        this.graph.getView().addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).SCALE, this.refreshHandler);
        this.graph.getView().addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).TRANSLATE, this.refreshHandler);
        this.graph.getView().addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).SCALE_AND_TRANSLATE, this.refreshHandler);
        this.graph.getView().addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).DOWN, this.refreshHandler);
        this.graph.getView().addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).UP, this.refreshHandler);
    }
    /**
     * Returns {@link enabled}.
     */ isEnabled() {
        return this.enabled;
    }
    /**
     * Sets {@link enabled}.
     */ setEnabled(value) {
        this.enabled = value;
    }
    /**
     * Returns the handler for the given cell.
     */ getHandler(cell) {
        return this.handlers.get(cell);
    }
    /**
     * Returns true if the given cell has a handler.
     */ isHandled(cell) {
        return !!this.getHandler(cell);
    }
    /**
     * Resets all handlers.
     */ reset() {
        this.handlers.forEach((handler)=>{
            handler.reset.apply(handler);
        });
    }
    /**
     * Reloads or updates all handlers.
     */ getHandledSelectionCells() {
        return this.graph.getSelectionCells();
    }
    /**
     * Reloads or updates all handlers.
     */ refresh() {
        // Removes all existing handlers
        const oldHandlers = this.handlers;
        this.handlers = new Map();
        // Creates handles for all selection cells
        const tmp = (0, $b55d6ca3b42398e2$export$35c9ae3c728354cd)(this.getHandledSelectionCells(), false);
        // Destroys or updates old handlers
        for(let i = 0; i < tmp.length; i += 1){
            const state = this.graph.view.getState(tmp[i]);
            if (state) {
                let handler = oldHandlers.get(tmp[i]) ?? null;
                oldHandlers.delete(tmp[i]);
                if (handler) {
                    if (handler.state !== state) {
                        handler.onDestroy();
                        handler = null;
                    } else if (!this.isHandlerActive(handler)) {
                        // @ts-ignore refresh may exist
                        if (handler.refresh) handler.refresh();
                        handler.redraw();
                    }
                }
                if (handler) this.handlers.set(tmp[i], handler);
            }
        }
        // Destroys unused handlers
        oldHandlers.forEach((handler)=>{
            this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).REMOVE, {
                state: handler.state
            }));
            handler.onDestroy();
        });
        // Creates new handlers and updates parent highlight on existing handlers
        for(let i = 0; i < tmp.length; i += 1){
            const state = this.graph.view.getState(tmp[i]);
            if (state) {
                let handler = this.handlers.get(tmp[i]);
                if (!handler) {
                    handler = this.createHandler(state);
                    this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).ADD, {
                        state: state
                    }));
                    this.handlers.set(tmp[i], handler);
                } else handler.updateParentHighlight();
            }
        }
    }
    /**
     * Hooks to create a new handler for the given cell state.
     *
     * This implementation returns a new {@link EdgeHandler} if the corresponding cell is an edge,
     * otherwise it returns an {@link VertexHandler}.
     *
     * @param state {@link CellState} whose handler should be created.
     * @since 0.25.0
     */ createHandler(state) {
        if (state.cell.isEdge()) {
            const source = state.getVisibleTerminalState(true);
            const target = state.getVisibleTerminalState(false);
            const geo = state.cell.getGeometry();
            const edgeStyle = this.graph.view.getEdgeStyle(state, geo?.points ?? undefined, source, target);
            return this.createEdgeHandler(state, edgeStyle);
        }
        return this.vertexHandlerFactory(state);
    }
    /**
     * Hooks to create a new {@link EdgeHandler} for the given {@link CellState}.
     *
     * This method relies on the registered elements in {@link EdgeStyleRegistry} to know which {@link EdgeHandler} to create.
     * If the `EdgeStyle` is not registered, it will return the {@link EdgeHandler} registered under the 'default' handler kind.
     *
     * @param state {@link CellState} to create the handler for.
     * @param edgeStyle the {@link EdgeStyleFunction} that let choose the actual edge handler.
     * @since 0.25.0
     */ createEdgeHandler(state, edgeStyle) {
        const handlerKind = (0, $130af394a0fcdee4$export$28d1530539966ca9).getHandlerKind(edgeStyle);
        return this.edgeHandlerFactories.get(handlerKind)?.(state) ?? // there is always an entry for 'default'
        this.edgeHandlerFactories.get('default')(state);
    }
    /**
     * Sets the factory used by {@link createHandler} to instantiate the handler of a selected vertex.
     *
     * Use it to have maxGraph create a custom {@link VertexHandler} subclass, instead of subclassing this plugin:
     * ```typescript
     * const selectionCellsHandler = graph.getPlugin<SelectionCellsHandler>('SelectionCellsHandler')!;
     * selectionCellsHandler.setVertexHandlerFactory((state) => new MyVertexHandler(state));
     * ```
     *
     * It only affects handlers created after this call, so set it before the first selection occurs.
     *
     * @param factory creates the {@link VertexHandler} for the {@link CellState} it receives.
     * @since 0.25.0
     */ setVertexHandlerFactory(factory) {
        this.vertexHandlerFactory = factory;
    }
    /**
     * Sets the factory used by {@link createEdgeHandler} to instantiate the handler of a selected edge whose
     * `EdgeStyle` is registered under the given {@link EdgeStyleHandlerKind} in {@link EdgeStyleRegistry}.
     *
     * Use it to have maxGraph create a custom {@link EdgeHandler} subclass, instead of subclassing this plugin:
     * ```typescript
     * const selectionCellsHandler = graph.getPlugin<SelectionCellsHandler>('SelectionCellsHandler')!;
     * selectionCellsHandler.setEdgeHandlerFactory('elbow', (state) => new MyElbowEdgeHandler(state));
     * ```
     *
     * The three built-in kinds are `'default'`, `'elbow'` and `'segment'`. Custom kinds are supported: register the
     * `EdgeStyle` with `EdgeStyleRegistry.add(name, edgeStyle, { handlerKind: 'my-kind' })`, then declare the matching
     * factory here. Edge styles whose kind has no factory fall back to the `'default'` one.
     *
     * The factory only affects handlers created after this call.
     *
     * @param handlerKind the {@link EdgeStyleHandlerKind} the factory applies to.
     * @param factory creates the {@link EdgeHandler} for the {@link CellState} it receives.
     * @since 0.25.0
     */ setEdgeHandlerFactory(handlerKind, factory) {
        this.edgeHandlerFactories.set(handlerKind, factory);
    }
    /**
     * Sets a single factory used by {@link createEdgeHandler} for **every** {@link EdgeStyleHandlerKind}, whatever the
     * `EdgeStyle` of the selected edge.
     *
     * Use it when the same {@link EdgeHandler} implementation fits all edges, instead of repeating
     * {@link setEdgeHandlerFactory} for each kind:
     * ```typescript
     * const selectionCellsHandler = graph.getPlugin<SelectionCellsHandler>('SelectionCellsHandler')!;
     * selectionCellsHandler.setEdgeHandlerFactoryForAllKinds((state) => new MyEdgeHandler(state));
     * ```
     *
     * This also covers the kinds registered in {@link EdgeStyleRegistry} *after* this call, as any kind without a
     * dedicated factory falls back to the `'default'` one.
     *
     * @param factory creates the {@link EdgeHandler} for the {@link CellState} it receives.
     * @since 0.25.0
     *
     * @remarks
     * This **discards all factories previously set with {@link setEdgeHandlerFactory}**, including those declared for
     * custom kinds. Call it before declaring any per-kind factory, not after.
     */ setEdgeHandlerFactoryForAllKinds(factory) {
        this.edgeHandlerFactories.clear();
        // 'default' is the fallback of createEdgeHandler, so it now serves every kind
        this.edgeHandlerFactories.set('default', factory);
    }
    /**
     * Returns true if the given handler is active and should not be redrawn.
     */ isHandlerActive(handler) {
        return !(0, $h5l15.isNullish)(handler.index);
    }
    /**
     * Updates the handler for the given shape if one exists.
     */ updateHandler(state) {
        const handler = this.handlers.get(state.cell);
        this.handlers.delete(state.cell);
        if (!handler) return;
        // Keeps the state of the gesture in progress, if any, to transfer it to the new handler
        const { index: index, startX: startX, startY: startY } = handler;
        handler.onDestroy();
        const newHandler = this.createHandler(state);
        this.handlers.set(state.cell, newHandler);
        if (!(0, $h5l15.isNullish)(index)) newHandler.start(startX, startY, index);
    }
    /**
     * Redirects the given event to the handlers.
     */ mouseDown(sender, me) {
        if (this.graph.isEnabled() && this.isEnabled()) this.handlers.forEach((handler)=>{
            handler.mouseDown(sender, me);
        });
    }
    /**
     * Redirects the given event to the handlers.
     */ mouseMove(sender, me) {
        if (this.graph.isEnabled() && this.isEnabled()) this.handlers.forEach((handler)=>{
            handler.mouseMove(sender, me);
        });
    }
    /**
     * Redirects the given event to the handlers.
     */ mouseUp(sender, me) {
        if (this.graph.isEnabled() && this.isEnabled()) this.handlers.forEach((handler)=>{
            handler.mouseUp(sender, me);
        });
    }
    /**
     * Destroys the handler and all its resources and DOM nodes.
     */ onDestroy() {
        this.graph.removeMouseListener(this);
        this.graph.getSelectionModel().removeListener(this.refreshHandler);
        this.graph.getDataModel().removeListener(this.refreshHandler);
        this.graph.getView().removeListener(this.refreshHandler);
        super.destroy();
    }
}
$bfdc6dda29863ca3$var$SelectionCellsHandler.pluginId = 'SelectionCellsHandler';
var $bfdc6dda29863ca3$export$2e2bcd8739ae039 = $bfdc6dda29863ca3$var$SelectionCellsHandler;


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 






/**
 * Basic popup menu.
 *
 * To add a vertical scrollbar to a given submenu, the following code can be used:
 *
 * ```javascript
 * const popupMenu = new MaxPopupMenu(...);
 * const popupMenuShowMenu = popupMenu.showMenu;
 * popupMenu.showMenu = function() {
 *   popupMenuShowMenu.apply(this, []);
 *
 *   this.div.style.overflowY = 'auto';
 *   this.div.style.overflowX = 'hidden';
 *   this.div.style.maxHeight = '160px';
 * };
 * ```
 *
 * ### Events
 *
 * **{@link InternalEvent.SHOW}**
 *
 * Fires after the menu has been shown in {@link popup}.
 *
 * @category GUI
 */ class $ef3b37081fe7185d$var$MaxPopupMenu extends (0, $17f25eceeba97548$export$2e2bcd8739ae039) {
    constructor(factoryMethod){
        super();
        this.activeRow = null;
        this.eventReceiver = null;
        /**
         * URL of the image to be used for the submenu icon.
         */ this.submenuImage = `${(0, $d47e32a58f71e01d$export$2e2bcd8739ae039).imageBasePath}/submenu.gif`;
        /**
         * Specifies the zIndex for the popupmenu and its shadow. Default is 1006.
         */ this.zIndex = 10006;
        /**
         * Specifies if popupmenus should be activated by clicking the left mouse
         * button. Default is false.
         */ this.useLeftButtonForPopup = false;
        /**
         * Specifies if events are handled. Default is true.
         */ this.enabled = true;
        /**
         * Contains the number of times <addItem> has been called for a new menu.
         */ this.itemCount = 0;
        /**
         * Specifies if submenus should be expanded on mouseover. Default is false.
         */ this.autoExpand = false;
        /**
         * Specifies if separators should only be added if a menu item follows them.
         * Default is false.
         */ this.smartSeparators = false;
        /**
         * Specifies if any labels should be visible. Default is true.
         */ this.labels = true;
        this.willAddSeparator = false;
        this.containsItems = false;
        if (factoryMethod) this.factoryMethod = factoryMethod;
        // Adds the inner table
        this.table = document.createElement('table');
        this.table.className = 'mxPopupMenu';
        this.tbody = document.createElement('tbody');
        this.table.appendChild(this.tbody);
        // Adds the outer div
        this.div = document.createElement('div');
        this.div.className = 'mxPopupMenu';
        this.div.style.display = 'inline';
        this.div.style.zIndex = String(this.zIndex);
        this.div.appendChild(this.table);
        // Disables the context menu on the outer div
        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).disableContextMenu(this.div);
    }
    /**
     * Returns true if events are handled. This implementation
     * returns <enabled>.
     */ isEnabled() {
        return this.enabled;
    }
    /**
     * Enables or disables event handling. This implementation
     * updates <enabled>.
     */ setEnabled(enabled) {
        this.enabled = enabled;
    }
    /**
     * Returns true if the given event is a popupmenu trigger for the optional
     * given cell.
     *
     * @param me {@link MouseEvent} that represents the mouse event.
     */ isPopupTrigger(me) {
        return me.isPopupTrigger() || this.useLeftButtonForPopup && (0, $f192e93a2fd1153c$export$94d43346060bc767)(me.getEvent());
    }
    /**
     * Adds the given item to the given parent item. If no parent item is specified then the item is added to the top-level menu.
     *
     * The return value may be used as the parent argument, i.e. as a submenu item.
     * The return value is the table row that represents the item.
     *
     * @param title String that represents the title of the menu item.
     * @param image Optional URL for the image icon.
     * @param funct Function associated that takes a `mouseup` or `touchend` event.
     * @param parent Optional item returned by {@link addItem}.
     * @param iconCls Optional string that represents the CSS class for the image icon. It is ignored if image is given.
     * @param enabled Optional boolean indicating if the item is enabled. Default is `true`.
     * @param active Optional boolean indicating if the menu should implement any event handling. Default is `true`.
     * @param noHover Optional boolean to disable hover state. Default is `false`.
     */ addItem(title, image, funct, parent = null, iconCls = null, enabled = true, active = true, noHover = false) {
        parent = parent ?? this;
        this.itemCount++;
        // Smart separators only added if element contains items
        if (parent.willAddSeparator) {
            if (parent.containsItems) this.addSeparator(parent, true);
            parent.willAddSeparator = false;
        }
        parent.containsItems = true;
        const tr = document.createElement('tr');
        tr.className = 'mxPopupMenuItem';
        const col1 = document.createElement('td');
        col1.className = 'mxPopupMenuIcon';
        // Adds the given image into the first column
        if (image) {
            const img = document.createElement('img');
            img.src = image;
            col1.appendChild(img);
        } else if (iconCls) {
            const div = document.createElement('div');
            div.className = iconCls;
            col1.appendChild(div);
        }
        tr.appendChild(col1);
        if (this.labels) {
            const col2 = document.createElement('td');
            col2.className = `mxPopupMenuItem${!enabled ? ' mxDisabled' : ''}`;
            (0, $b1d29c834e82fef5$export$68d8715fc104d294)(col2, title);
            col2.align = 'left';
            tr.appendChild(col2);
            const col3 = document.createElement('td');
            col3.className = `mxPopupMenuItem${!enabled ? ' mxDisabled' : ''}`;
            col3.style.paddingRight = '6px';
            col3.style.textAlign = 'right';
            tr.appendChild(col3);
            if (parent.div == null) this.createSubmenu(parent);
        }
        parent.tbody?.appendChild(tr);
        if (active && enabled) {
            (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addGestureListeners(tr, (evt)=>{
                this.eventReceiver = tr;
                if (parent && parent.activeRow != tr && parent.activeRow != parent) {
                    if (parent.activeRow && parent.activeRow.div.parentNode) this.hideSubmenu(parent);
                    if (tr.div) {
                        this.showSubmenu(parent, tr);
                        parent.activeRow = tr;
                    }
                }
                (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).consume(evt);
            }, (_evt)=>{
                if (parent && parent.activeRow != tr && parent.activeRow != parent) {
                    if (parent.activeRow && parent.activeRow.div.parentNode) this.hideSubmenu(parent);
                    if (this.autoExpand && tr.div) {
                        this.showSubmenu(parent, tr);
                        parent.activeRow = tr;
                    }
                }
                // Sets hover style because TR in IE doesn't have hover
                if (!noHover) tr.className = 'mxPopupMenuItemHover';
            }, (evt)=>{
                // EventReceiver avoids clicks on a submenu item
                // which has just been shown in the mousedown
                if (this.eventReceiver == tr) {
                    if (parent && parent.activeRow != tr) this.hideMenu();
                    funct?.(evt);
                }
                this.eventReceiver = null;
                (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).consume(evt);
            });
            // Resets hover style because TR in IE doesn't have hover
            if (!noHover) (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addListener(tr, 'mouseout', (_evt)=>{
                tr.className = 'mxPopupMenuItem';
            });
        }
        return tr;
    }
    /**
     * Adds a checkmark to the given menuitem.
     */ addCheckmark(item, img) {
        if (item.firstChild) {
            const td = item.firstChild.nextSibling;
            td.style.backgroundImage = `url('${img}')`;
            td.style.backgroundRepeat = 'no-repeat';
            td.style.backgroundPosition = '2px 50%';
        }
    }
    /**
     * Creates the nodes required to add submenu items inside the given parent
     * item. This is called in <addItem> if a parent item is used for the first
     * time. This adds various DOM nodes and a <submenuImage> to the parent.
     *
     * @param parent An item returned by <addItem>.
     */ createSubmenu(parent) {
        parent.table = document.createElement('table');
        parent.table.className = 'mxPopupMenu';
        parent.tbody = document.createElement('tbody');
        parent.table.appendChild(parent.tbody);
        parent.div = document.createElement('div');
        parent.div.className = 'mxPopupMenu';
        parent.div.style.position = 'absolute';
        parent.div.style.display = 'inline';
        parent.div.style.zIndex = String(this.zIndex);
        parent.div.appendChild(parent.table);
        const img = document.createElement('img');
        img.setAttribute('src', this.submenuImage);
        // Last column of the submenu item in the parent menu
        if (parent.firstChild?.nextSibling?.nextSibling) {
            const td = parent.firstChild.nextSibling.nextSibling;
            td.appendChild(img);
        }
    }
    /**
     * Shows the submenu inside the given parent row.
     */ showSubmenu(parent, row) {
        if (row.div) {
            row.div.style.left = `${parent.div.offsetLeft + row.offsetLeft + row.offsetWidth - 1}px`;
            row.div.style.top = `${parent.div.offsetTop + row.offsetTop}px`;
            document.body.appendChild(row.div);
            // Moves the submenu to the left side if there is no space
            const left = row.div.offsetLeft;
            const width = row.div.offsetWidth;
            const offset = (0, $b55d6ca3b42398e2$export$d801aa93dad401af)(document);
            const b = document.body;
            const d = document.documentElement;
            const right = offset.x + (b.clientWidth || d.clientWidth);
            if (left + width > right) row.div.style.left = `${Math.max(0, parent.div.offsetLeft - width - 6)}px`;
            (0, $b55d6ca3b42398e2$export$1e044b7877db048c)(row.div);
        }
    }
    /**
     * Adds a horizontal separator in the given parent item or the top-level menu
     * if no parent is specified.
     *
     * @param parent Optional item returned by <addItem>.
     * @param force Optional boolean to ignore <smartSeparators>. Default is false.
     */ addSeparator(parent = null, force = false) {
        // Defaults to this instance if no parent (submenu) specified, but
        // all the necessary DOM elements are present as in PopupMenuItem
        parent = parent || this;
        if (this.smartSeparators && !force) parent.willAddSeparator = true;
        else if (parent.tbody) {
            parent.willAddSeparator = false;
            const tr = document.createElement('tr');
            const col1 = document.createElement('td');
            col1.className = 'mxPopupMenuIcon';
            col1.style.padding = '0 0 0 0px';
            tr.appendChild(col1);
            const col2 = document.createElement('td');
            col2.style.padding = '0 0 0 0px';
            col2.setAttribute('colSpan', '2');
            const hr = document.createElement('hr');
            hr.setAttribute('size', '1');
            col2.appendChild(hr);
            tr.appendChild(col2);
            parent.tbody.appendChild(tr);
        }
    }
    /**
     * Shows the popup menu for the given event and cell.
     *
     * Example:
     *
     * ```javascript
     * graph.getPlugin('PanningHandler').popup(x, y, cell, evt)
     * {
     *   mxUtils.alert('Hello, World!');
     * }
     * ```
     */ popup(x, y, cell, evt) {
        if (this.div && this.tbody && this.factoryMethod) {
            this.div.style.left = `${x}px`;
            this.div.style.top = `${y}px`;
            // Removes all child nodes from the existing menu
            while(this.tbody.firstChild){
                (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).release(this.tbody.firstChild);
                this.tbody.removeChild(this.tbody.firstChild);
            }
            this.itemCount = 0;
            this.factoryMethod(this, cell, evt);
            if (this.itemCount > 0) {
                this.showMenu();
                this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).SHOW));
            }
        }
    }
    /**
     * Returns true if the menu is showing.
     */ isMenuShowing() {
        return this.div && this.div.parentNode == document.body;
    }
    /**
     * Shows the menu.
     */ showMenu() {
        // Fits the div inside the viewport
        document.body.appendChild(this.div);
        (0, $b55d6ca3b42398e2$export$1e044b7877db048c)(this.div);
    }
    /**
     * Removes the menu and all submenus.
     */ hideMenu() {
        if (this.div) {
            this.div.parentNode?.removeChild(this.div);
            this.hideSubmenu(this);
            this.containsItems = false;
            this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).HIDE));
        }
    }
    /**
     * Removes all submenus inside the given parent.
     *
     * @param parent An item returned by <addItem>.
     */ hideSubmenu(parent) {
        if (parent.activeRow) {
            this.hideSubmenu(parent.activeRow);
            parent.activeRow.div.parentNode?.removeChild(parent.activeRow.div);
            parent.activeRow = null;
        }
    }
    /**
     * Destroys the handler and all its resources and DOM nodes.
     */ destroy() {
        if (this.div) {
            (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).release(this.div);
            this.div.parentNode?.removeChild(this.div);
        }
        super.destroy();
    }
}
var $ef3b37081fe7185d$export$2e2bcd8739ae039 = $ef3b37081fe7185d$var$MaxPopupMenu;





/**
 * Event handler that creates popupmenus.
 *
 * Relates to {@link MaxPopupMenu}.
 *
 * @category Plugin
 */ class $0cfb38ee30b027b0$var$PopupMenuHandler extends (0, $ef3b37081fe7185d$export$2e2bcd8739ae039) {
    constructor(graph){
        super();
        this.inTolerance = false;
        this.popupTrigger = false;
        /**
         * Specifies if cells should be selected if a popupmenu is displayed for
         * them. Default is true.
         */ this.selectOnPopup = true;
        /**
         * Specifies if cells should be deselected if a popupmenu is displayed for
         * the diagram background. Default is true.
         */ this.clearSelectionOnBackground = true;
        /**
         * X-coordinate of the mouse down event.
         */ this.triggerX = null;
        /**
         * Y-coordinate of the mouse down event.
         */ this.triggerY = null;
        /**
         * Screen X-coordinate of the mouse down event.
         */ this.screenX = null;
        /**
         * Screen Y-coordinate of the mouse down event.
         */ this.screenY = null;
        this.graph = graph;
        this.graph.addMouseListener(this);
        // Does not show menu if any touch gestures take place after the trigger
        this.gestureHandler = (sender, eo)=>{
            this.inTolerance = false;
        };
        this.graph.addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).GESTURE, this.gestureHandler);
        this.init();
    }
    /**
     * Initializes the shapes required for this vertex handler.
     */ init() {
        // Hides the tooltip if the mouse is over the context menu
        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addGestureListeners(this.div, (evt)=>{
            const tooltipHandler = this.graph.getPlugin('TooltipHandler');
            tooltipHandler?.hide();
        });
    }
    /**
     * Hook for returning if a cell should be selected for a given {@link MouseEvent}.
     * This implementation returns <selectOnPopup>.
     */ isSelectOnPopup(me) {
        return this.selectOnPopup;
    }
    /**
     * Handles the event by initiating the panning. By consuming the event all
     * subsequent events of the gesture are redirected to this handler.
     */ mouseDown(_sender, me) {
        if (this.isEnabled() && !(0, $f192e93a2fd1153c$export$d06464d6b74eedc4)(me.getEvent())) {
            // Hides the popupmenu if it is being displayed
            this.hideMenu();
            this.triggerX = me.getGraphX();
            this.triggerY = me.getGraphY();
            this.screenX = (0, $f192e93a2fd1153c$export$5b0b05d206f62d48)(me.getEvent()).screenX;
            this.screenY = (0, $f192e93a2fd1153c$export$5b0b05d206f62d48)(me.getEvent()).screenY;
            this.popupTrigger = this.isPopupTrigger(me);
            this.inTolerance = true;
        }
    }
    /**
     * Handles the event by updating the panning on the graph.
     */ mouseMove(_sender, me) {
        // Popup trigger may change on mouseUp so ignore it
        if (this.inTolerance && this.screenX != null && this.screenY != null) {
            if (Math.abs((0, $f192e93a2fd1153c$export$5b0b05d206f62d48)(me.getEvent()).screenX - this.screenX) > this.graph.getEventTolerance() || Math.abs((0, $f192e93a2fd1153c$export$5b0b05d206f62d48)(me.getEvent()).screenY - this.screenY) > this.graph.getEventTolerance()) this.inTolerance = false;
        }
    }
    /**
     * Handles the event by setting the translation on the view or showing the popupmenu.
     */ mouseUp(_sender, me) {
        if (this.popupTrigger && this.inTolerance && this.triggerX != null && this.triggerY != null) {
            const cell = this.getCellForPopupEvent(me);
            // Selects the cell for which the context menu is being displayed
            if (this.graph.isEnabled() && this.isSelectOnPopup(me) && cell != null && !this.graph.isCellSelected(cell)) this.graph.setSelectionCell(cell);
            else if (this.clearSelectionOnBackground && cell == null) this.graph.clearSelection();
            // Hides the tooltip if there is one
            const tooltipHandler = this.graph.getPlugin('TooltipHandler');
            tooltipHandler?.hide();
            // Menu is shifted by 1 pixel so that the mouse up event
            // is routed via the underlying shape instead of the DIV
            const origin = (0, $b55d6ca3b42398e2$export$744922fd1f3b32b)();
            this.popup(me.getX() + origin.x + 1, me.getY() + origin.y + 1, cell, me.getEvent());
            me.consume();
        }
        this.popupTrigger = false;
        this.inTolerance = false;
    }
    /**
     * Hook to return the cell for the mouse up popup trigger handling.
     */ getCellForPopupEvent(me) {
        return me.getCell();
    }
    /**
     * Destroys the handler and all its resources and DOM nodes.
     */ onDestroy() {
        this.graph.removeMouseListener(this);
        this.graph.removeListener(this.gestureHandler);
        // Supercall
        super.destroy();
    }
}
$0cfb38ee30b027b0$var$PopupMenuHandler.pluginId = 'PopupMenuHandler';
var $0cfb38ee30b027b0$export$2e2bcd8739ae039 = $0cfb38ee30b027b0$var$PopupMenuHandler;


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2016, JGraph Ltd
Copyright (c) 2006-2016, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 





var $cBHcM = parcelRequire("cBHcM");











var $h5l15 = parcelRequire("h5l15");
/**
 * Graph event handler that creates new connections.
 * Uses {@link CellMarker} for finding and highlighting the source and target vertices and {@link factoryMethod} to create the edge instance.
 *
 * This handler is enabled using {@link AbstractGraph.setConnectable}.
 *
 * Example:
 *
 * ```javascript
 * new ConnectionHandler(graph, (source, target, style)=>
 * {
 *   edge = new Cell('', new Geometry());
 *   edge.setEdge(true);
 *   edge.setStyle(style);
 *   edge.geometry.relative = true;
 *   return edge;
 * });
 * ```
 *
 * Here is an alternative solution that just sets a specific user object for new edges by overriding {@link insertEdge}.
 *
 * ```javascript
 * originalConnectionHandlerInsertEdge = connectionHandler.insertEdge;
 * connectionHandler.insertEdge = (parent, id, value, source, target, style) => {
 *   value = 'Test';
 *   return originalConnectionHandlerInsertEdge.apply(this, arguments);
 * };
 * ```
 *
 * ### Using images to trigger connections
 *
 * This handler uses {@link CellMarker} to find the source and target cell for
 * the new connection and creates a new edge using {@link connect}. The new edge is
 * created using {@link createEdge} which in turn uses {@link factoryMethod} or creates a
 * new default edge.
 *
 * The handler uses a "highlight-paradigm" for indicating if a cell is being
 * used as a source or target terminal, as seen in other diagramming products.
 * In order to allow both, moving and connecting cells at the same time,
 * {@link DEFAULT_HOTSPOT} is used in the handler to determine the hotspot
 * of a cell, that is, the region of the cell which is used to trigger a new
 * connection. The constant is a value between 0 and 1 that specifies the
 * amount of the width and height around the center to be used for the hotspot
 * of a cell and its default value is 0.5. In addition,
 * {@link MIN_HOTSPOT_SIZE} defines the minimum number of pixels for the
 * width and height of the hotspot.
 *
 * This solution, while standards compliant, may be somewhat confusing because
 * there is no visual indicator for the hotspot and the highlight is seen to
 * switch on and off while the mouse is being moved in and out. Furthermore,
 * this paradigm does not allow to create different connections depending on
 * the highlighted hotspot as there is only one hotspot per cell, and it
 * normally does not allow cells to be moved and connected at the same time as
 * there is no clear indication of the connectable area of the cell.
 *
 * To come across these issues, the handle has an additional {@link createIcons} hook
 * with a default implementation that allows to create one icon to be used to
 * trigger new connections. If this icon is specified, then new connections can
 * only be created if the image is clicked while the cell is being highlighted.
 * The {@link createIcons} hook may be overridden to create more than one
 * {@link ImageShape} for creating new connections, but the default implementation
 * supports one image and is used as follows:
 *
 * In order to display the "connect image" whenever the mouse is over the cell, an DEFAULT_HOTSPOT of 1 should be used:
 *
 * ```javascript
 * mxConstants.DEFAULT_HOTSPOT = 1;
 * ```
 *
 * In order to avoid confusion with the highlighting, the highlight color should not be used with a connect image:
 *
 * ```javascript
 * mxConstants.HIGHLIGHT_COLOR = null;
 * ```
 *
 * To install the image, the connectImage field of the ConnectionHandler must be assigned a new {@link Image} instance:
 *
 * ```javascript
 * connectImage = new ImageBox('images/green-dot.gif', 14, 14);
 * ```
 *
 * This will use the green-dot.gif with a width and height of 14 pixels as the
 * image to trigger new connections. In createIcons the icon field of the
 * handler will be set in order to remember the icon that has been clicked for
 * creating the new connection. This field will be available under selectedIcon
 * in the connect method, which may be overridden to take the icon that
 * triggered the new connection into account. This is useful if more than one
 * icon may be used to create a connection.
 *
 * ### Events
 *
 * #### InternalEvent.START
 *
 * Fires when a new connection is being created by the user. The `state`
 * property contains the state of the source cell.
 *
 * #### InternalEvent.CONNECT
 *
 * Fires between begin- and endUpdate in {@link connect}. The `cell`
 * property contains the inserted edge, the `event` and `target`
 * properties contain the respective arguments that were passed to {@link connect} (where
 * target corresponds to the dropTarget argument). Finally, the `terminal`
 * property corresponds to the target argument in {@link connect} or the clone of the source
 * terminal if {@link createTarget} is enabled.
 *
 * Note that the target is the cell under the mouse where the mouse button was released.
 * Depending on the logic in the handler, this doesn't necessarily have to be the target
 * of the inserted edge. To print the source, target or any optional ports IDs that the
 * edge is connected to, the following code can be used. To get more details about the
 * actual connection point, {@link AbstractGraph.getConnectionConstraint} can be used. To resolve
 * the port IDs, use {@link GraphDataModel.getCell}.
 *
 * ```javascript
 * graph.getPlugin('ConnectionHandler')?.addListener(mxEvent.CONNECT, (sender, evt) => {
 *   const edge = evt.getProperty('cell');
 *   const source = graph.getDataModel().getTerminal(edge, true);
 *   const target = graph.getDataModel().getTerminal(edge, false);
 *
 *   const style = graph.getCellStyle(edge);
 *   const sourcePortId = style.sourcePort;
 *   const targetPortId = style.targetPort;
 *
 *   GlobalConfig.logger.show();
 *   GlobalConfig.logger.debug(`connect edge=${edge.id} source=${source.id} target=${target.id} sourcePort=${sourcePortId} targetPort=${targetPortId}`);
 * });
 * ```
 *
 * #### InternalEvent.RESET
 *
 * Fires when the {@link reset} method is invoked.
 *
 * @category Plugin
 */ class $28f9a5c5f46c401e$var$ConnectionHandler extends (0, $17f25eceeba97548$export$2e2bcd8739ae039) {
    /**
     * Constructs an event handler that connects vertices using the specified
     * factory method to create the new edges.
     *
     * @param graph Reference to the enclosing {@link AbstractGraph}.
     * @param factoryMethod Optional function to create the edge. The function takes
     * the source and target {@link Cell} as the first and second argument and an
     * optional cell style from the preview as the third argument. It returns
     * the {@link Cell} that represents the new edge.
     */ constructor(graph, factoryMethod = null){
        super();
        this.previous = null;
        this.iconState = null;
        this.icons = [];
        this.cell = null;
        this.currentPoint = null;
        this.sourceConstraint = null;
        this.shape = null;
        this.icon = null;
        this.originalPoint = null;
        this.currentState = null;
        this.selectedIcon = null;
        this.waypoints = [];
        /**
         * Function that is used for creating new edges. The function takes the
         * source and target {@link Cell} as the first and second argument and returns
         * a new {@link Cell} that represents the edge. This is used in {@link createEdge}.
         */ this.factoryMethod = null;
        /**
         * Specifies if icons should be displayed inside the graph container instead
         * of the overlay pane. This is used for HTML labels on vertices which hide
         * the connect icon. This has precedence over {@link moveIconBack} when set
         * to true.
         * @default `false`
         */ this.moveIconFront = false;
        /**
         * Specifies if icons should be moved to the back of the overlay pane. This can
         * be set to true if the icons of the connection handler conflict with other
         * handles, such as the vertex label move handle.
         * @default false
         */ this.moveIconBack = false;
        /**
         * {@link Image} that is used to trigger the creation of a new connection.
         * This is used in {@link createIcons}.
         * @default null
         */ this.connectImage = null;
        /**
         * Specifies if the connect icon should be centered on the target state while connections are being previewed.
         * @default false
         */ this.targetConnectImage = false;
        /**
         * Specifies if events are handled.
         * @default false
         */ this.enabled = false;
        /**
         * Specifies if new edges should be selected.
         * @default true
         */ this.select = true;
        /**
         * Specifies if {@link createTargetVertex} should be called if no target was under the
         * mouse for the new connection. Setting this to true means the connection
         * will be drawn as valid if no target is under the mouse, and
         * {@link createTargetVertex} will be called before the connection is created between
         * the source cell and the newly created vertex in {@link createTargetVertex}, which
         * can be overridden to create a new target.
         * @default false
         */ this.createTarget = false;
        /**
         * Holds the current validation error while connections are being created.
         * @default null
         */ this.error = null;
        /**
         * Specifies if single clicks should add waypoints on the new edge.
         * @default false
         */ this.waypointsEnabled = false;
        /**
         * Specifies if the connection handler should ignore the state of the mouse button when highlighting the source.
         *
         * When false, that is, the handler only highlights the source if no button is being pressed.
         *
         * @default false
         */ this.ignoreMouseDown = false;
        /**
         * Holds the {@link Point} where the mouseDown took place while the handler is active.
         */ this.first = null;
        /**
         * Holds the offset for connect icons during connection preview.
         * Default is mxPoint(0, {@link TOOLTIP_VERTICAL_OFFSET}).
         * Note that placing the icon under the mouse pointer with an
         * offset of (0,0) will affect hit detection.
         */ this.connectIconOffset = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(0, (0, $cBHcM.TOOLTIP_VERTICAL_OFFSET));
        /**
         * Optional {@link CellState} that represents the preview edge while the
         * handler is active. This is created in {@link createEdgeState}.
         */ this.edgeState = null;
        /**
         * Counts the number of mouseDown events since the start. The initial mouse
         * down event counts as 1.
         */ this.mouseDownCounter = 0;
        /**
         * Switch to enable moving the preview away from the mouse pointer. This is required in browsers
         * where the preview cannot be made transparent to events and if the built-in hit detection on
         * the HTML elements in the page should be used.
         * @default false
         */ this.movePreviewAway = false;
        /**
         * Specifies if connections to the outline of a highlighted target should be
         * enabled. This will allow to place the connection point along the outline of
         * the highlighted target.
         * @default false
         */ this.outlineConnect = false;
        /**
         * Specifies if the actual shape of the edge state should be used for the preview.
         * This is ignored if no edge state is created in {@link createEdgeState}.
         * @default false
         */ this.livePreview = false;
        /**
         * Specifies the cursor to be used while the handler is active.
         * @default null
         */ this.cursor = null;
        /**
         * Defines the cursor for a connectable state.
         * @default 'pointer'
         * @since 0.20.0
         */ this.cursorConnect = 'pointer';
        /**
         * Specifies if new edges should be inserted before the source vertex in the
         * cell hierarchy. Default is false for backwards compatibility.
         */ this.insertBeforeSource = false;
        this.graph = graph;
        this.factoryMethod = factoryMethod;
        this.graph.addMouseListener(this);
        this.marker = this.createMarker();
        this.constraintHandler = this.createConstraintHandler();
        // Redraws the icons if the graph changes
        this.changeHandler = (sender)=>{
            if (this.iconState) this.iconState = this.graph.getView().getState(this.iconState.cell);
            if (this.iconState) {
                this.redrawIcons(this.icons, this.iconState);
                this.constraintHandler.reset();
            } else if (this.previous && !this.graph.view.getState(this.previous.cell)) this.reset();
        };
        this.graph.getDataModel().addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CHANGE, this.changeHandler);
        this.graph.getView().addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).SCALE, this.changeHandler);
        this.graph.getView().addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).TRANSLATE, this.changeHandler);
        this.graph.getView().addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).SCALE_AND_TRANSLATE, this.changeHandler);
        // Removes the icon if we step into/up or start editing
        this.drillHandler = (sender)=>{
            this.reset();
        };
        this.graph.addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).START_EDITING, this.drillHandler);
        this.graph.getView().addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).DOWN, this.drillHandler);
        this.graph.getView().addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).UP, this.drillHandler);
        // Handles escape keystrokes
        this.escapeHandler = ()=>{
            this.reset();
        };
        this.graph.addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).ESCAPE, this.escapeHandler);
    }
    /**
     * Hook for subclasses to change the implementation of {@link ConstraintHandler} used here.
     * @since 0.21.0
     */ createConstraintHandler() {
        return new (0, $34290ae7320e7535$export$2e2bcd8739ae039)(this.graph);
    }
    /**
     * Returns true if events are handled. This implementation
     * returns <enabled>.
     */ isEnabled() {
        return this.enabled;
    }
    /**
     * Enables or disables event handling. This implementation
     * updates <enabled>.
     *
     * @param enabled Boolean that specifies the new enabled state.
     */ setEnabled(enabled) {
        this.enabled = enabled;
    }
    /**
     * Returns <insertBeforeSource> for non-loops and false for loops.
     *
     * @param edge {@link Cell} that represents the edge to be inserted.
     * @param source {@link Cell} that represents the source terminal.
     * @param target {@link Cell} that represents the target terminal.
     * @param evt Mousedown event of the connect gesture.
     * @param dropTarget {@link Cell} that represents the cell under the mouse when it was
     * released.
     */ isInsertBefore(edge, source, target, evt, dropTarget) {
        return this.insertBeforeSource && source !== target;
    }
    /**
     * Returns <createTarget>.
     *
     * @param evt Current active native pointer event.
     */ isCreateTarget(evt) {
        return this.createTarget;
    }
    /**
     * Sets <createTarget>.
     */ setCreateTarget(value) {
        this.createTarget = value;
    }
    /**
     * Creates the preview shape for new connections.
     */ createShape() {
        // Creates the edge preview
        const shape = this.livePreview && this.edgeState ? this.graph.cellRenderer.createShape(this.edgeState) : new (0, $4b136726e3ad0ef6$export$2e2bcd8739ae039)([], (0, $cBHcM.INVALID_COLOR));
        if (shape && shape.node) {
            shape.dialect = 'svg';
            shape.scale = this.graph.view.scale;
            shape.pointerEvents = false;
            shape.isDashed = true;
            shape.init(this.graph.getView().getOverlayPane());
            (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).redirectMouseEvents(shape.node, this.graph, null);
        }
        return shape;
    }
    /**
     * Returns true if the given cell is connectable. This is a hook to
     * disable floating connections. This implementation returns true.
     */ isConnectableCell(cell) {
        return true;
    }
    /**
     * Creates and returns the {@link CellMarker} used in {@link marker}.
     */ createMarker() {
        return new $28f9a5c5f46c401e$export$716ef16d97785d58(this.graph, this);
    }
    /**
     * Starts a new connection for the given state and coordinates.
     */ start(state, x, y, edgeState) {
        this.previous = state;
        this.first = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y);
        this.edgeState = edgeState ?? this.createEdgeState();
        // Marks the source state
        this.marker.currentColor = this.marker.validColor;
        this.marker.markedState = state;
        this.marker.mark();
        this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).START, {
            state: this.previous
        }));
    }
    /**
     * Returns true if the source terminal has been clicked and a new
     * connection is currently being previewed.
     */ isConnecting() {
        return !!this.first && !!this.shape;
    }
    /**
     * Returns {@link AbstractGraph.isValidSource} for the given source terminal.
     *
     * @param cell {@link Cell} that represents the source terminal.
     * @param me {@link MouseEvent} that is associated with this call.
     */ isValidSource(cell, me) {
        return this.graph.isValidSource(cell);
    }
    /**
     * Returns true. The call to {@link AbstractGraph.isValidTarget} is implicit by calling
     * {@link AbstractGraph.getEdgeValidationError} in <validateConnection>. This is an
     * additional hook for disabling certain targets in this specific handler.
     *
     * @param cell {@link Cell} that represents the target terminal.
     */ isValidTarget(cell) {
        return true;
    }
    /**
     * Returns the error message or an empty string if the connection for the
     * given source target pair is not valid. Otherwise it returns null. This
     * implementation uses {@link AbstractGraph.getEdgeValidationError}.
     *
     * @param source {@link Cell} that represents the source terminal.
     * @param target {@link Cell} that represents the target terminal.
     */ validateConnection(source, target) {
        if (!this.isValidTarget(target)) return '';
        return this.graph.getEdgeValidationError(null, source, target);
    }
    /**
     * Hook to return the {@link Image} used for the connection icon of the given
     * {@link CellState}. This implementation returns {@link connectImage}.
     *
     * @param state {@link CellState} whose connect image should be returned.
     */ getConnectImage(state) {
        return this.connectImage;
    }
    /**
     * Returns true if the state has a HTML label in the graph's container, otherwise
     * it returns {@link oveIconFront}.
     *
     * @param state <CellState> whose connect icons should be returned.
     */ isMoveIconToFrontForState(state) {
        if (state.text && state.text.node.parentNode === this.graph.container) return true;
        return this.moveIconFront;
    }
    /**
     * Creates the array {@link ImageShape}s that represent the connect icons for
     * the given {@link CellState}.
     *
     * @param state {@link CellState} whose connect icons should be returned.
     */ createIcons(state) {
        const image = this.getConnectImage(state);
        if (image) {
            this.iconState = state;
            const icons = [];
            // Cannot use HTML for the connect icons because the icon receives all
            // mouse move events in IE, must use VML and SVG instead even if the
            // connect-icon appears behind the selection border and the selection
            // border consumes the events before the icon gets a chance
            const bounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(0, 0, image.width, image.height);
            const icon = new (0, $48f65d6d4849e478$export$2e2bcd8739ae039)(bounds, image.src, undefined, undefined, 0);
            icon.preserveImageAspect = false;
            if (this.isMoveIconToFrontForState(state)) {
                icon.dialect = 'strictHtml';
                icon.init(this.graph.container);
            } else {
                icon.dialect = 'svg';
                icon.init(this.graph.getView().getOverlayPane());
                // Move the icon back in the overlay pane
                if (this.moveIconBack && icon.node.parentNode && icon.node.previousSibling) icon.node.parentNode.insertBefore(icon.node, icon.node.parentNode.firstChild);
            }
            icon.node.style.cursor = this.cursorConnect;
            // Events transparency
            const getState = ()=>{
                return this.currentState ?? state;
            };
            // Updates the local icon before firing the mouse down event.
            const mouseDown = (evt)=>{
                if (!(0, $f192e93a2fd1153c$export$f6e93dab47d340de)(evt)) {
                    this.icon = icon;
                    this.graph.fireMouseEvent((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_DOWN, new (0, $2051fd5f8fd06bc7$export$2e2bcd8739ae039)(evt, getState()));
                }
            };
            (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).redirectMouseEvents(icon.node, this.graph, getState, mouseDown);
            icons.push(icon);
            this.redrawIcons(icons, this.iconState);
            return icons;
        }
        return [];
    }
    /**
     * Redraws the given array of {@link ImageShape}s.
     *
     * @param icons Array of {@link ImageShape}s to be redrawn.
     * @param state {@link CellState} under the mouse.
     */ redrawIcons(icons, state) {
        if (icons[0] && icons[0].bounds) {
            const pos = this.getIconPosition(icons[0], state);
            icons[0].bounds.x = pos.x;
            icons[0].bounds.y = pos.y;
            icons[0].redraw();
        }
    }
    /**
     * Returns the center position of the given icon.
     *
     * @param icon The connect icon of {@link ImageShape} with the mouse.
     * @param state {@link CellState} under the mouse.
     */ getIconPosition(icon, state) {
        const { scale: scale } = this.graph.getView();
        let cx = state.getCenterX();
        let cy = state.getCenterY();
        if (this.graph.isSwimlane(state.cell)) {
            const size = this.graph.getStartSize(state.cell);
            cx = size.width !== 0 ? state.x + size.width * scale / 2 : cx;
            cy = size.height !== 0 ? state.y + size.height * scale / 2 : cy;
            const alpha = (0, $f7ff90b8964488a6$export$cba01ba138429a1d)(state.style.rotation ?? 0);
            if (alpha !== 0) {
                const cos = Math.cos(alpha);
                const sin = Math.sin(alpha);
                const ct = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(state.getCenterX(), state.getCenterY());
                const pt = (0, $f7ff90b8964488a6$export$ad2a0af3fbffd7c1)(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(cx, cy), cos, sin, ct);
                cx = pt.x;
                cy = pt.y;
            }
        }
        return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(cx - icon.bounds.width / 2, cy - icon.bounds.height / 2);
    }
    /**
     * Destroys the connect icons and resets the respective state.
     */ destroyIcons() {
        for(let i = 0; i < this.icons.length; i += 1)this.icons[i].destroy();
        this.icons = [];
        this.icon = null;
        this.selectedIcon = null;
        this.iconState = null;
    }
    /**
     * Returns true if the given mouse down event should start this handler.
     * This implementation returns true if the event does not force marquee
     * selection, and the currentConstraint and currentFocus of the
     * {@link constraintHandler} are not null, or {@link previous} and {@link error} are not null and
     * {@link icons} is null or {@link icons} and {@link icon} are not `null`.
     */ isStartEvent(me) {
        return this.constraintHandler.currentFocus !== null && this.constraintHandler.currentConstraint !== null || this.previous !== null && this.error === null && (this.icons.length === 0 || this.icon !== null);
    }
    /**
     * Handles the event by initiating a new connection.
     */ mouseDown(_sender, me) {
        this.mouseDownCounter += 1;
        if (this.isEnabled() && this.graph.isEnabled() && !me.isConsumed() && !this.isConnecting() && this.isStartEvent(me)) {
            if (this.constraintHandler.currentConstraint && this.constraintHandler.currentFocus && this.constraintHandler.currentPoint) {
                this.sourceConstraint = this.constraintHandler.currentConstraint;
                this.previous = this.constraintHandler.currentFocus;
                this.first = this.constraintHandler.currentPoint.clone();
            } else // Stores the location of the initial mousedown
            this.first = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(me.getGraphX(), me.getGraphY());
            this.edgeState = this.createEdgeState(me);
            this.mouseDownCounter = 1;
            if (this.waypointsEnabled && !this.shape) {
                this.waypoints = [];
                this.shape = this.createShape();
                if (this.edgeState) this.shape.apply(this.edgeState);
            }
            // Stores the starting point in the geometry of the preview
            if (!this.previous && this.edgeState && this.edgeState.cell.geometry) {
                const pt = this.graph.getPointForEvent(me.getEvent());
                this.edgeState.cell.geometry.setTerminalPoint(pt, true);
            }
            this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).START, {
                state: this.previous
            }));
            me.consume();
        }
        this.selectedIcon = this.icon;
        this.icon = null;
    }
    /**
     * Returns true if a tap on the given source state should immediately start
     * connecting. This implementation returns true if the state is not movable
     * in the graph.
     */ isImmediateConnectSource(state) {
        return !this.graph.isCellMovable(state.cell);
    }
    /**
     * Hook to return an <CellState> which may be used during the preview.
     * This implementation returns null.
     *
     * Use the following code to create a preview for an existing edge style:
     *
     * ```javascript
     * graph.getPlugin('ConnectionHandler').createEdgeState(me)
     * {
     *   var edge = graph.createEdge(null, null, null, null, null, 'edgeStyle=elbowEdgeStyle');
     *
     *   return new CellState(this.graph.view, edge, this.graph.getCellStyle(edge));
     * };
     * ```
     */ createEdgeState(me) {
        return null;
    }
    /**
     * Returns true if <outlineConnect> is true and the source of the event is the outline shape
     * or shift is pressed.
     */ isOutlineConnectEvent(me) {
        if (!this.currentPoint) return false;
        const offset = (0, $b55d6ca3b42398e2$export$622cea445a1c5b7d)(this.graph.container);
        const evt = me.getEvent();
        const clientX = (0, $f192e93a2fd1153c$export$87583e2c100c6a4f)(evt);
        const clientY = (0, $f192e93a2fd1153c$export$195fc3609401443f)(evt);
        const doc = document.documentElement;
        const left = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
        const top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
        const gridX = this.currentPoint.x - this.graph.container.scrollLeft + offset.x - left;
        const gridY = this.currentPoint.y - this.graph.container.scrollTop + offset.y - top;
        return this.outlineConnect && !(0, $f192e93a2fd1153c$export$1d7fd696f3493e74)(me.getEvent()) && (me.isSource(this.marker.highlight.shape) || (0, $f192e93a2fd1153c$export$bdc3218ff6eba0d8)(me.getEvent()) && me.getState() != null || this.marker.highlight.isHighlightAt(clientX, clientY) || (gridX !== clientX || gridY !== clientY) && me.getState() == null && this.marker.highlight.isHighlightAt(gridX, gridY));
    }
    /**
     * Updates the current state for a given mouse move event by using the {@link marker}.
     */ updateCurrentState(me, point) {
        this.constraintHandler.update(me, !this.first, false, !this.first || me.isSource(this.marker.highlight.shape) ? null : point);
        if (this.constraintHandler.currentFocus != null && this.constraintHandler.currentConstraint != null) {
            // Handles special case where grid is large and connection point is at actual point in which
            // case the outline is not followed as long as we're < gridSize / 2 away from that point
            if (this.marker.highlight && this.marker.highlight.state && this.marker.highlight.state.cell === this.constraintHandler.currentFocus.cell && this.marker.highlight.shape) // Direct repaint needed if cell already highlighted
            {
                if (this.marker.highlight.shape.stroke !== 'transparent') {
                    this.marker.highlight.shape.stroke = 'transparent';
                    this.marker.highlight.repaint();
                }
            } else this.marker.markCell(this.constraintHandler.currentFocus.cell, 'transparent');
            // Updates validation state
            if (this.previous) {
                this.error = this.validateConnection(this.previous.cell, this.constraintHandler.currentFocus.cell);
                if (!this.error) this.currentState = this.constraintHandler.currentFocus;
                if (this.error || this.currentState && !this.isCellEnabled(this.currentState.cell)) this.constraintHandler.reset();
            }
        } else {
            if (this.graph.isIgnoreTerminalEvent(me.getEvent())) {
                this.marker.reset();
                this.currentState = null;
            } else {
                this.marker.process(me);
                this.currentState = this.marker.getValidState();
            }
            if (this.currentState != null && !this.isCellEnabled(this.currentState.cell)) {
                this.constraintHandler.reset();
                this.marker.reset();
                this.currentState = null;
            }
            const outline = this.isOutlineConnectEvent(me);
            if (this.currentState != null && outline) {
                // Handles special case where mouse is on outline away from actual end point
                // in which case the grid is ignored and mouse point is used instead
                if (me.isSource(this.marker.highlight.shape)) point = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(me.getGraphX(), me.getGraphY());
                const constraint = this.graph.getOutlineConstraint(point, this.currentState, me);
                this.constraintHandler.setFocus(me, this.currentState, false);
                this.constraintHandler.currentConstraint = constraint;
                this.constraintHandler.currentPoint = point;
            }
            if (this.outlineConnect) {
                if (this.marker.highlight != null && this.marker.highlight.shape != null) {
                    const s = this.graph.view.scale;
                    if (this.constraintHandler.currentConstraint != null && this.constraintHandler.currentFocus != null) {
                        this.marker.highlight.shape.stroke = (0, $cBHcM.OUTLINE_HIGHLIGHT_COLOR);
                        this.marker.highlight.shape.strokeWidth = (0, $cBHcM.OUTLINE_HIGHLIGHT_STROKEWIDTH) / s / s;
                        this.marker.highlight.repaint();
                    } else if (this.marker.hasValidState()) {
                        const cell = me.getCell();
                        // Handles special case where actual end point of edge and current mouse point
                        // are not equal (due to grid snapping) and there is no hit on shape or highlight
                        // but ignores cases where parent is used for non-connectable child cells
                        if (cell && cell.isConnectable() && this.marker.getValidState() !== me.getState()) {
                            this.marker.highlight.shape.stroke = 'transparent';
                            this.currentState = null;
                        } else this.marker.highlight.shape.stroke = (0, $cBHcM.VALID_COLOR);
                        this.marker.highlight.shape.strokeWidth = (0, $cBHcM.HIGHLIGHT_STROKEWIDTH) / s / s;
                        this.marker.highlight.repaint();
                    }
                }
            }
        }
    }
    /**
     * Returns true if the given cell does not allow new connections to be created.
     */ isCellEnabled(cell) {
        return true;
    }
    /**
     * Converts the given point from screen coordinates to model coordinates.
     */ convertWaypoint(point) {
        const scale = this.graph.getView().getScale();
        const tr = this.graph.getView().getTranslate();
        point.x = point.x / scale - tr.x;
        point.y = point.y / scale - tr.y;
    }
    /**
     * Called to snap the given point to the current preview. This snaps to the
     * first point of the preview if alt is not pressed.
     */ snapToPreview(me, point) {
        if (!(0, $f192e93a2fd1153c$export$bdc3218ff6eba0d8)(me.getEvent()) && this.previous) {
            const tol = this.graph.getGridSize() * this.graph.view.scale / 2;
            const tmp = this.sourceConstraint && this.first ? this.first : new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(this.previous.getCenterX(), this.previous.getCenterY());
            if (Math.abs(tmp.x - me.getGraphX()) < tol) point.x = tmp.x;
            if (Math.abs(tmp.y - me.getGraphY()) < tol) point.y = tmp.y;
        }
    }
    /**
     * Handles the event by updating the preview edge or by highlighting
     * a possible source or target terminal.
     */ mouseMove(_sender, me) {
        if (!me.isConsumed() && (this.ignoreMouseDown || this.first || !this.graph.isMouseDown)) {
            // Handles special case when handler is disabled during highlight
            if (!this.isEnabled() && this.currentState) {
                this.destroyIcons();
                this.currentState = null;
            }
            const view = this.graph.getView();
            const { scale: scale } = view;
            const tr = view.translate;
            let point = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(me.getGraphX(), me.getGraphY());
            this.error = null;
            if (this.graph.isGridEnabledEvent(me.getEvent())) point = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)((this.graph.snap(point.x / scale - tr.x) + tr.x) * scale, (this.graph.snap(point.y / scale - tr.y) + tr.y) * scale);
            this.snapToPreview(me, point);
            this.currentPoint = point;
            if ((this.first || this.isEnabled() && this.graph.isEnabled()) && (this.shape || !this.first || Math.abs(me.getGraphX() - this.first.x) > this.graph.getEventTolerance() || Math.abs(me.getGraphY() - this.first.y) > this.graph.getEventTolerance())) this.updateCurrentState(me, point);
            if (this.first) {
                let constraint = null;
                let current = point;
                // Uses the current point from the constraint handler if available
                if (this.constraintHandler.currentConstraint && this.constraintHandler.currentFocus && this.constraintHandler.currentPoint) {
                    constraint = this.constraintHandler.currentConstraint;
                    current = this.constraintHandler.currentPoint.clone();
                } else if (this.previous && !this.graph.isIgnoreTerminalEvent(me.getEvent()) && (0, $f192e93a2fd1153c$export$1d7fd696f3493e74)(me.getEvent())) {
                    if (Math.abs(this.previous.getCenterX() - point.x) < Math.abs(this.previous.getCenterY() - point.y)) point.x = this.previous.getCenterX();
                    else point.y = this.previous.getCenterY();
                }
                let pt2 = this.first;
                // Moves the connect icon with the mouse
                if (this.selectedIcon && this.selectedIcon.bounds) {
                    const w = this.selectedIcon.bounds.width;
                    const h = this.selectedIcon.bounds.height;
                    if (this.currentState && this.targetConnectImage) {
                        const pos = this.getIconPosition(this.selectedIcon, this.currentState);
                        this.selectedIcon.bounds.x = pos.x;
                        this.selectedIcon.bounds.y = pos.y;
                    } else {
                        const bounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(me.getGraphX() + this.connectIconOffset.x, me.getGraphY() + this.connectIconOffset.y, w, h);
                        this.selectedIcon.bounds = bounds;
                    }
                    this.selectedIcon.redraw();
                }
                // Uses edge state to compute the terminal points
                if (this.edgeState) {
                    this.updateEdgeState(current, constraint);
                    current = this.edgeState.absolutePoints[this.edgeState.absolutePoints.length - 1];
                    pt2 = this.edgeState.absolutePoints[0];
                } else {
                    if (this.currentState) {
                        if (!this.constraintHandler.currentConstraint) {
                            const tmp = this.getTargetPerimeterPoint(this.currentState, me);
                            if (tmp != null) current = tmp;
                        }
                    }
                    // Computes the source perimeter point
                    if (!this.sourceConstraint && this.previous) {
                        const next = this.waypoints.length > 0 ? this.waypoints[0] : current;
                        const tmp = this.getSourcePerimeterPoint(this.previous, next, me);
                        if (tmp) pt2 = tmp;
                    }
                }
                // Makes sure the cell under the mousepointer can be detected
                // by moving the preview shape away from the mouse. This
                // makes sure the preview shape does not prevent the detection
                // of the cell under the mousepointer even for slow gestures.
                if (!this.currentState && this.movePreviewAway && current) {
                    let tmp = pt2;
                    if (this.edgeState && this.edgeState.absolutePoints.length >= 2) {
                        const tmp2 = this.edgeState.absolutePoints[this.edgeState.absolutePoints.length - 2];
                        if (tmp2) tmp = tmp2;
                    }
                    if (tmp) {
                        const dx = current.x - tmp.x;
                        const dy = current.y - tmp.y;
                        const len = Math.sqrt(dx * dx + dy * dy);
                        if (len === 0) return;
                        // Stores old point to reuse when creating edge
                        this.originalPoint = current.clone();
                        current.x -= dx * 4 / len;
                        current.y -= dy * 4 / len;
                    }
                } else this.originalPoint = null;
                // Creates the preview shape (lazy)
                if (!this.shape) {
                    const dx = Math.abs(me.getGraphX() - this.first.x);
                    const dy = Math.abs(me.getGraphY() - this.first.y);
                    if (dx > this.graph.getEventTolerance() || dy > this.graph.getEventTolerance()) {
                        this.shape = this.createShape();
                        if (this.edgeState) this.shape.apply(this.edgeState);
                        // Revalidates current connection
                        this.updateCurrentState(me, point);
                    }
                }
                // Updates the points in the preview edge
                if (this.shape) {
                    if (this.edgeState) this.shape.points = this.edgeState.absolutePoints;
                    else {
                        let pts = [
                            pt2
                        ];
                        if (this.waypoints.length > 0) pts = pts.concat(this.waypoints);
                        pts.push(current);
                        this.shape.points = pts;
                    }
                    this.drawPreview();
                }
                // Makes sure endpoint of edge is visible during connect
                if (this.cursor) this.graph.container.style.cursor = this.cursor;
                (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).consume(me.getEvent());
                me.consume();
            } else if (!this.isEnabled() || !this.graph.isEnabled()) this.constraintHandler.reset();
            else if (this.previous !== this.currentState && !this.edgeState) {
                this.destroyIcons();
                // Sets the cursor on the current shape
                if (this.currentState && !this.error && !this.constraintHandler.currentConstraint) {
                    this.icons = this.createIcons(this.currentState);
                    if (this.icons.length === 0) {
                        this.currentState.setCursor(this.cursorConnect);
                        me.consume();
                    }
                }
                this.previous = this.currentState;
            } else if (this.previous === this.currentState && this.currentState != null && this.icons.length === 0 && !this.graph.isMouseDown) // Makes sure that no cursors are changed
            me.consume();
            if (!this.graph.isMouseDown && this.currentState != null && this.icons != null) {
                let hitsIcon = false;
                const target = me.getSource();
                for(let i = 0; i < this.icons.length && !hitsIcon; i += 1)hitsIcon = target === this.icons[i].node || // @ts-ignore parentNode should exist.
                !!target && target.parentNode === this.icons[i].node;
                if (!hitsIcon) this.updateIcons(this.currentState, this.icons, me);
            }
        } else this.constraintHandler.reset();
    }
    /**
     * Updates {@link edgeState}.
     */ updateEdgeState(current, constraint) {
        if (!this.edgeState) return;
        // TODO: Use generic method for writing constraint to style
        if (this.sourceConstraint?.point) {
            this.edgeState.style.exitX = this.sourceConstraint.point.x;
            this.edgeState.style.exitY = this.sourceConstraint.point.y;
        }
        if (constraint?.point) {
            this.edgeState.style.entryX = constraint.point.x;
            this.edgeState.style.entryY = constraint.point.y;
        } else {
            delete this.edgeState.style.entryX;
            delete this.edgeState.style.entryY;
        }
        this.edgeState.absolutePoints = [
            null,
            this.currentState != null ? null : current
        ];
        if (this.sourceConstraint) this.graph.view.updateFixedTerminalPoint(this.edgeState, this.previous, true, this.sourceConstraint);
        if (this.currentState != null) {
            if (constraint == null) constraint = this.graph.getConnectionConstraint(this.edgeState, this.previous, false);
            this.edgeState.setAbsoluteTerminalPoint(null, false);
            this.graph.view.updateFixedTerminalPoint(this.edgeState, this.currentState, false, constraint);
        }
        // Scales and translates the waypoints to the model
        const realPoints = [];
        for(let i = 0; i < this.waypoints.length; i += 1){
            const pt = this.waypoints[i].clone();
            this.convertWaypoint(pt);
            realPoints[i] = pt;
        }
        this.graph.view.updatePoints(this.edgeState, realPoints, this.previous, this.currentState);
        this.graph.view.updateFloatingTerminalPoints(this.edgeState, this.previous, this.currentState);
    }
    /**
     * Returns the perimeter point for the given target state.
     *
     * @param state <CellState> that represents the target cell state.
     * @param _me {@link MouseEvent} that represents the mouse move.
     */ getTargetPerimeterPoint(state, _me) {
        let result = null;
        const { view: view } = state;
        const targetPerimeter = view.getPerimeterFunction(state);
        if (targetPerimeter && this.previous && this.edgeState) {
            const next = this.waypoints.length > 0 ? this.waypoints[this.waypoints.length - 1] : new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(this.previous.getCenterX(), this.previous.getCenterY());
            const tmp = targetPerimeter(view.getPerimeterBounds(state), this.edgeState, next, false);
            if (tmp) result = tmp;
        } else result = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(state.getCenterX(), state.getCenterY());
        return result;
    }
    /**
     * Hook to update the icon position(s) based on a mouseOver event. This is
     * an empty implementation.
     *
     * @param state <CellState> that represents the target cell state.
     * @param next {@link Point} that represents the next point along the previewed edge.
     * @param me {@link MouseEvent} that represents the mouse move.
     */ getSourcePerimeterPoint(state, next, me) {
        let result = null;
        const { view: view } = state;
        const sourcePerimeter = view.getPerimeterFunction(state);
        const c = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(state.getCenterX(), state.getCenterY());
        if (sourcePerimeter) {
            const theta = state.style.rotation ?? 0;
            const rad = -theta * (Math.PI / 180);
            if (theta !== 0) next = (0, $f7ff90b8964488a6$export$ad2a0af3fbffd7c1)(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(next.x, next.y), Math.cos(rad), Math.sin(rad), c);
            let tmp = sourcePerimeter(view.getPerimeterBounds(state), state, next, false);
            if (tmp) {
                if (theta !== 0) tmp = (0, $f7ff90b8964488a6$export$ad2a0af3fbffd7c1)(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(tmp.x, tmp.y), Math.cos(-rad), Math.sin(-rad), c);
                result = tmp;
            }
        } else result = c;
        return result;
    }
    /**
     * Hook to update the icon position(s) based on a mouseOver event.
     *
     * This is an empty implementation.
     *
     * @param state {@link CellState} under the mouse.
     * @param icons Array of currently displayed icons.
     * @param me {@link MouseEvent} that contains the mouse event.
     */ updateIcons(state, icons, me) {
    // empty
    }
    /**
     * Returns `true` if the given mouse up event should stop this handler.
     *
     * The connection will be created if {@link error} is `null`.
     * Note that this is only called if {@link waypointsEnabled} is `true`.
     *
     * This implementation returns `true` if there is a cell state in the given event.
     */ isStopEvent(me) {
        return !!me.getState();
    }
    /**
     * Adds the waypoint for the given event to {@link waypoints}.
     */ addWaypointForEvent(me) {
        if (!this.first) return;
        let point = (0, $b55d6ca3b42398e2$export$864dc177f7f5bda1)(this.graph.container, me.getX(), me.getY());
        const dx = Math.abs(point.x - this.first.x);
        const dy = Math.abs(point.y - this.first.y);
        const addPoint = this.waypoints.length > 0 || this.mouseDownCounter > 1 && (dx > this.graph.getEventTolerance() || dy > this.graph.getEventTolerance());
        if (addPoint) {
            const { scale: scale } = this.graph.view;
            point = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(this.graph.snap(me.getGraphX() / scale) * scale, this.graph.snap(me.getGraphY() / scale) * scale);
            this.waypoints.push(point);
        }
    }
    /**
     * Returns `true` if the connection for the given constraints is valid.
     *
     * This implementation returns `true` if the constraints are not pointing to the same fixed connection point.
     */ checkConstraints(c1, c2) {
        return !c1 || !c2 || !c1.point || !c2.point || !c1.point.equals(c2.point) || c1.dx !== c2.dx || c1.dy !== c2.dy || c1.perimeter !== c2.perimeter;
    }
    /**
     * Handles the event by inserting the new connection.
     */ mouseUp(_sender, me) {
        if (!me.isConsumed() && this.isConnecting()) {
            if (this.waypointsEnabled && !this.isStopEvent(me)) {
                this.addWaypointForEvent(me);
                me.consume();
                return;
            }
            const c1 = this.sourceConstraint;
            const c2 = this.constraintHandler.currentConstraint;
            const source = this.previous ? this.previous.cell : null;
            let target = null;
            if (this.constraintHandler.currentConstraint && this.constraintHandler.currentFocus) target = this.constraintHandler.currentFocus.cell;
            if (!target && this.currentState) target = this.currentState.cell;
            // Inserts the edge if no validation error exists and if constraints differ
            if (!this.error && (!source || !target || source !== target || this.checkConstraints(c1, c2))) this.connect(source, target, me.getEvent(), me.getCell());
            else {
                // Selects the source terminal for self-references
                if (this.previous != null && this.marker.validState != null && this.previous.cell === this.marker.validState.cell) this.graph.selectCellForEvent(this.marker.validState.cell, me.getEvent());
                // Displays the error message if it is not an empty string,
                // for empty error messages, the event is silently dropped
                if (this.error != null && this.error.length > 0) this.graph.validationAlert(this.error);
            }
            // Redraws the connect icons and resets the handler state
            this.destroyIcons();
            me.consume();
        }
        if (this.first != null) this.reset();
    }
    /**
     * Resets the state of this handler.
     */ reset() {
        if (this.shape != null) {
            this.shape.destroy();
            this.shape = null;
        }
        // Resets the cursor on the container
        if (this.cursor != null && this.graph.container != null) this.graph.container.style.cursor = '';
        this.destroyIcons();
        this.marker.reset();
        this.constraintHandler.reset();
        this.originalPoint = null;
        this.currentPoint = null;
        this.edgeState = null;
        this.previous = null;
        this.error = null;
        this.sourceConstraint = null;
        this.mouseDownCounter = 0;
        this.first = null;
        this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).RESET));
    }
    /**
     * Redraws the preview edge using the color and width returned by {@link getEdgeColor} and {@link getEdgeWidth}.
     */ drawPreview() {
        this.updatePreview(this.error === null);
        if (this.shape) this.shape.redraw();
    }
    /**
     * Returns the color used to draw the preview edge.
     * This returns green if there is no edge validation error and red otherwise.
     *
     * @param valid Boolean indicating if the color for a valid edge should be returned.
     */ updatePreview(valid) {
        if (this.shape) {
            this.shape.strokeWidth = this.getEdgeWidth(valid);
            this.shape.stroke = this.getEdgeColor(valid);
        }
    }
    /**
     * Returns the color used to draw the preview edge.
     *
     * This returns green if there is no edge validation error and red otherwise.
     *
     * @param valid Boolean indicating if the color for a valid edge should be returned.
     */ getEdgeColor(valid) {
        return valid ? (0, $cBHcM.VALID_COLOR) : (0, $cBHcM.INVALID_COLOR);
    }
    /**
     * Returns the width used to draw the preview edge.
     *
     * This returns `3` if there is no edge validation error and `1` otherwise.
     *
     * @param valid Boolean indicating if the width for a valid edge should be returned.
     */ getEdgeWidth(valid) {
        return valid ? 3 : 1;
    }
    /**
     * Connects the given source and target using a new edge.
     *
     * This implementation uses {@link createEdge} to create the edge.
     *
     * @param source {@link Cell} that represents the source terminal.
     * @param target {@link Cell} that represents the target terminal.
     * @param evt {@link MouseEvent} event of the connect gesture.
     * @param dropTarget {@link Cell} that represents the cell under the mouse when it was
     * released.
     */ connect(source, target, evt, dropTarget = null) {
        if (target || this.isCreateTarget(evt) || this.graph.isAllowDanglingEdges()) {
            // Uses the common parent of source and target or
            // the default parent to insert the edge
            const model = this.graph.getDataModel();
            let terminalInserted = false;
            let edge = null;
            model.beginUpdate();
            try {
                if (source && !target && !this.graph.isIgnoreTerminalEvent(evt) && this.isCreateTarget(evt)) {
                    target = this.createTargetVertex(evt, source);
                    if (target) {
                        dropTarget = this.graph.getDropTarget([
                            target
                        ], evt, dropTarget);
                        terminalInserted = true;
                        // Disables edges as drop targets if the target cell was created
                        // FIXME: Should not shift if vertex was aligned (same in Java)
                        if (dropTarget == null || !dropTarget.isEdge()) {
                            const pstate = dropTarget ? this.graph.getView().getState(dropTarget) : null;
                            if (pstate) {
                                const tmp = target.getGeometry();
                                if (tmp) {
                                    tmp.x -= pstate.origin.x;
                                    tmp.y -= pstate.origin.y;
                                }
                            }
                        } else dropTarget = this.graph.getDefaultParent();
                        this.graph.addCell(target, dropTarget);
                    }
                }
                let parent = this.graph.getDefaultParent();
                if (source && target && source.getParent() === target.getParent() && source.getParent()?.getParent() !== model.getRoot()) {
                    parent = source.getParent();
                    if (source.geometry && source.geometry.relative && target.geometry && target.geometry.relative) parent = parent.getParent();
                }
                // Uses the value of the preview edge state for inserting
                // the new edge into the graph
                let value = null;
                let style = {};
                if (this.edgeState?.cell) {
                    value = this.edgeState.cell.value;
                    style = this.edgeState.cell.style ?? {};
                }
                edge = this.insertEdge(parent, '', value, source, target, style);
                if (edge && source) {
                    // Updates the connection constraints
                    this.graph.setConnectionConstraint(edge, source, true, this.sourceConstraint);
                    this.graph.setConnectionConstraint(edge, target, false, this.constraintHandler.currentConstraint);
                    // Uses geometry of the preview edge state
                    if (this.edgeState?.cell?.geometry) model.setGeometry(edge, this.edgeState.cell.geometry);
                    parent = source.getParent();
                    // Inserts edge before source
                    if (this.isInsertBefore(edge, source, target, evt, dropTarget)) {
                        const index = null;
                        let tmp = source;
                        while(tmp && tmp.parent != null && tmp.geometry != null && tmp.geometry.relative && tmp.parent !== edge.parent)tmp = tmp.getParent();
                        if (tmp != null && tmp.parent != null && tmp.parent === edge.parent) model.add(parent, edge, tmp.parent.getIndex(tmp));
                    }
                    // Makes sure the edge has a non-null, relative geometry
                    let geo = edge.getGeometry();
                    if (geo == null) {
                        geo = new (0, $6713282b00eec691$export$2e2bcd8739ae039)();
                        geo.relative = true;
                        model.setGeometry(edge, geo);
                    }
                    // Uses scaled waypoints in geometry
                    if (this.waypoints.length > 0) {
                        const s = this.graph.view.scale;
                        const tr = this.graph.view.translate;
                        geo.points = [];
                        for(let i = 0; i < this.waypoints.length; i += 1){
                            const pt = this.waypoints[i];
                            geo.points.push(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(pt.x / s - tr.x, pt.y / s - tr.y));
                        }
                    }
                    if (!target && this.currentPoint) {
                        const t = this.graph.view.translate;
                        const s = this.graph.view.scale;
                        const pt = this.originalPoint != null ? new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(this.originalPoint.x / s - t.x, this.originalPoint.y / s - t.y) : new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(this.currentPoint.x / s - t.x, this.currentPoint.y / s - t.y);
                        pt.x -= this.graph.getPanDx() / this.graph.view.scale;
                        pt.y -= this.graph.getPanDy() / this.graph.view.scale;
                        geo.setTerminalPoint(pt, false);
                    }
                    this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CONNECT, 'cell', edge, 'terminal', target, 'event', evt, 'target', dropTarget, 'terminalInserted', terminalInserted));
                }
            } catch (e) {
                (0, $h5l15.log)().show();
                const errorMessage = `Error in ConnectionHandler: ${e instanceof Error ? e.message + '\n' + e.stack : 'unknown cause'}`;
                (0, $h5l15.log)().debug(errorMessage);
            } finally{
                model.endUpdate();
            }
            if (this.select) this.selectCells(edge, terminalInserted ? target : null);
        }
    }
    /**
     * Selects the given edge after adding a new connection. The target argument
     * contains the target vertex if one has been inserted.
     */ selectCells(edge, target) {
        this.graph.setSelectionCell(edge);
    }
    /**
     * Creates, inserts and returns the new edge for the given parameters. This
     * implementation does only use {@link createEdge} if {@link factoryMethod} is defined,
     * otherwise {@link AbstractGraph.insertEdge} will be used.
     */ insertEdge(parent, id, value, source, target, style) {
        if (!this.factoryMethod) return this.graph.insertEdge({
            parent: parent,
            id: id,
            value: value,
            source: source,
            target: target,
            style: style
        });
        let edge = this.createEdge(value, source, target, style);
        edge = this.graph.addEdge(edge, parent, source, target);
        return edge;
    }
    /**
     * Hook method for creating new vertices on the fly if no target was
     * under the mouse. This is only called if <createTarget> is true and
     * returns null.
     *
     * @param evt Mousedown event of the connect gesture.
     * @param source {@link Cell} that represents the source terminal.
     */ createTargetVertex(evt, source) {
        // Uses the first non-relative source
        let geo = source.getGeometry();
        while(geo && geo.relative){
            source = source.getParent();
            geo = source.getGeometry();
        }
        const clone = this.graph.cloneCell(source);
        geo = clone.getGeometry();
        if (geo && this.currentPoint) {
            const t = this.graph.view.translate;
            const s = this.graph.view.scale;
            const point = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(this.currentPoint.x / s - t.x, this.currentPoint.y / s - t.y);
            geo.x = Math.round(point.x - geo.width / 2 - this.graph.getPanDx() / s);
            geo.y = Math.round(point.y - geo.height / 2 - this.graph.getPanDy() / s);
            // Aligns with source if within certain tolerance
            const tol = this.getAlignmentTolerance();
            if (tol > 0) {
                const sourceState = this.graph.view.getState(source);
                if (sourceState != null) {
                    const x = sourceState.x / s - t.x;
                    const y = sourceState.y / s - t.y;
                    if (Math.abs(x - geo.x) <= tol) geo.x = Math.round(x);
                    if (Math.abs(y - geo.y) <= tol) geo.y = Math.round(y);
                }
            }
        }
        return clone;
    }
    /**
     * Returns the tolerance for aligning new targets to sources. This returns the grid size / 2.
     */ getAlignmentTolerance(evt) {
        return this.graph.isGridEnabled() ? this.graph.getGridSize() / 2 : this.graph.getSnapTolerance();
    }
    /**
     * Creates and returns a new edge using {@link factoryMethod} if one exists. If
     * no factory method is defined, then a new default edge is returned. The
     * source and target arguments are informal, the actual connection is
     * set up later by the caller of this function.
     *
     * @param value Value to be used for creating the edge.
     * @param source {@link Cell} that represents the source terminal.
     * @param target {@link Cell} that represents the target terminal.
     * @param style Optional style from the preview edge.
     */ createEdge(value, source, target, style = {}) {
        let edge = null;
        // Creates a new edge using the factoryMethod
        if (this.factoryMethod != null) edge = this.factoryMethod(source, target, style);
        if (edge == null) {
            edge = new (0, $0e256159624f4593$export$2e2bcd8739ae039)(value || '');
            edge.setEdge(true);
            edge.setStyle(style);
            const geo = new (0, $6713282b00eec691$export$2e2bcd8739ae039)();
            geo.relative = true;
            edge.setGeometry(geo);
        }
        return edge;
    }
    /**
     * Destroys the handler and all its resources and DOM nodes. This should be
     * called on all instances. It is called automatically for the built-in
     * instance created for each {@link AbstractGraph}.
     */ onDestroy() {
        this.graph.removeMouseListener(this);
        if (this.shape) {
            this.shape.destroy();
            this.shape = null;
        }
        if (this.marker) {
            this.marker.destroy();
            // @ts-expect-error this.marker is null when it is destroyed.
            this.marker = null;
        }
        if (this.constraintHandler) this.constraintHandler.onDestroy();
        if (this.changeHandler) {
            this.graph.getDataModel().removeListener(this.changeHandler);
            this.graph.getView().removeListener(this.changeHandler);
        }
        if (this.drillHandler) {
            this.graph.removeListener(this.drillHandler);
            this.graph.getView().removeListener(this.drillHandler);
        }
        if (this.escapeHandler) this.graph.removeListener(this.escapeHandler);
    }
}
$28f9a5c5f46c401e$var$ConnectionHandler.pluginId = 'ConnectionHandler';
var $28f9a5c5f46c401e$export$2e2bcd8739ae039 = $28f9a5c5f46c401e$var$ConnectionHandler;
class $28f9a5c5f46c401e$export$716ef16d97785d58 extends (0, $41e693d31e181f17$export$2e2bcd8739ae039) {
    constructor(graph, connectionHandler, validColor = (0, $cBHcM.VALID_COLOR), invalidColor = (0, $cBHcM.DEFAULT_INVALID_COLOR), hotspot = (0, $cBHcM.DEFAULT_HOTSPOT)){
        super(graph, validColor, invalidColor, hotspot);
        this.hotspotEnabled = true;
        this.connectionHandler = connectionHandler;
    }
    // Overrides to return cell at location only if valid (so that
    // there is no highlight for invalid cells)
    getCell(me) {
        let cell = super.getCell(me);
        this.connectionHandler.error = null;
        // Checks for cell at preview point (with grid)
        if (!cell && this.connectionHandler.currentPoint) cell = this.connectionHandler.graph.getCellAt(this.connectionHandler.currentPoint.x, this.connectionHandler.currentPoint.y);
        // Uses connectable parent vertex if one exists
        if (cell && !cell.isConnectable() && this.connectionHandler.cell) {
            const parent = this.connectionHandler.cell.getParent();
            if (parent && parent.isVertex() && parent.isConnectable()) cell = parent;
        }
        if (cell) {
            if (this.connectionHandler.graph.isSwimlane(cell) && this.connectionHandler.currentPoint != null && this.connectionHandler.graph.hitsSwimlaneContent(cell, this.connectionHandler.currentPoint.x, this.connectionHandler.currentPoint.y) || !this.connectionHandler.isConnectableCell(cell)) cell = null;
        }
        if (cell) {
            if (this.connectionHandler.isConnecting()) {
                if (this.connectionHandler.previous) {
                    this.connectionHandler.error = this.connectionHandler.validateConnection(this.connectionHandler.previous.cell, cell);
                    if (this.connectionHandler.error !== null && this.connectionHandler.error.length === 0) {
                        cell = null;
                        // Enables create target inside groups
                        if (this.connectionHandler.isCreateTarget(me.getEvent())) this.connectionHandler.error = null;
                    }
                }
            } else if (!this.connectionHandler.isValidSource(cell, me)) cell = null;
        } else if (this.connectionHandler.isConnecting() && !this.connectionHandler.isCreateTarget(me.getEvent()) && !this.connectionHandler.graph.isAllowDanglingEdges()) this.connectionHandler.error = '';
        return cell;
    }
    // Sets the highlight color according to validateConnection
    isValidState(state) {
        if (this.connectionHandler.isConnecting()) return !this.connectionHandler.error;
        return super.isValidState(state);
    }
    // Overrides to use marker color only in highlight mode or for
    // target selection
    getMarkerColor(evt, state, isValid) {
        return !this.connectionHandler.connectImage || this.connectionHandler.isConnecting() ? super.getMarkerColor(evt, state, isValid) : (0, $cBHcM.NONE);
    }
    // Overrides to use hotspot only for source selection otherwise
    // intersects always returns true when over a cell
    intersects(state, evt) {
        if (this.connectionHandler.connectImage || this.connectionHandler.isConnecting()) return true;
        return super.intersects(state, evt);
    }
}


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 




/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
var $cBHcM = parcelRequire("cBHcM");


/**
 * Implements the alignment of selection cells to other cells in the graph.
 *
 * Constructor: mxGuide
 *
 * Constructs a new guide object.
 */ class $cc94ee9a81ffc981$var$Guide {
    constructor(graph, states){
        /**
         * Contains the {@link CellState}s that are used for alignment.
         */ this.states = [];
        /**
         * Specifies if horizontal guides are enabled. Default is true.
         */ this.horizontal = true;
        /**
         * Specifies if vertical guides are enabled. Default is true.
         */ this.vertical = true;
        /**
         * Holds the {@link Shape} for the horizontal guide.
         */ this.guideX = null;
        /**
         * Holds the {@link Shape} for the vertical guide.
         */ this.guideY = null;
        /**
         * Specifies if rounded coordinates should be used. Default is false.
         */ this.rounded = false;
        /**
         * Default tolerance in px if grid is disabled. Default is 2.
         */ this.tolerance = 2;
        this.graph = graph;
        this.setStates(states);
    }
    /**
     * Sets the {@link CellState}s that should be used for alignment.
     */ setStates(states) {
        this.states = states;
    }
    /**
     * Returns true if the guide should be enabled for the given native event. This
     * implementation always returns true.
     */ isEnabledForEvent(evt) {
        return true;
    }
    /**
     * Returns the tolerance for the guides. Default value is gridSize / 2.
     */ getGuideTolerance(gridEnabled = false) {
        return gridEnabled && this.graph.isGridEnabled() ? this.graph.getGridSize() / 2 : this.tolerance;
    }
    /**
     * Returns the mxShape to be used for painting the respective guide. This
     * implementation returns a new, dashed and crisp {@link PolylineShape} using
     * {@link GUIDE_COLOR} and {@link GUIDE_STROKEWIDTH} as the format.
     *
     * @param horizontal Boolean that specifies which guide should be created.
     */ createGuideShape(horizontal = false) {
        // TODO: Should vertical guides be supported here?? ============================
        const guide = new (0, $4b136726e3ad0ef6$export$2e2bcd8739ae039)([], (0, $cBHcM.GUIDE_COLOR), (0, $cBHcM.GUIDE_STROKEWIDTH));
        guide.isDashed = true;
        return guide;
    }
    /**
     * Returns true if the given state should be ignored.
     * @param state
     */ isStateIgnored(state) {
        return false;
    }
    /**
     * Moves the <bounds> by the given {@link Point} and returnt the snapped point.
     */ move(bounds = null, delta, gridEnabled = false, clone = false) {
        if ((this.horizontal || this.vertical) && bounds) {
            const { scale: scale } = this.graph.getView();
            const tt = this.getGuideTolerance(gridEnabled) * scale;
            const b = bounds.clone();
            b.x += delta.x;
            b.y += delta.y;
            let overrideX = false;
            let stateX = null;
            let valueX = null;
            let overrideY = false;
            let stateY = null;
            let valueY = null;
            let ttX = tt;
            let ttY = tt;
            const left = b.x;
            const right = b.x + b.width;
            const center = b.getCenterX();
            const top = b.y;
            const bottom = b.y + b.height;
            const middle = b.getCenterY();
            // Snaps the left, center and right to the given x-coordinate
            const snapX = (x, state, centerAlign)=>{
                let override = false;
                if (centerAlign && Math.abs(x - center) < ttX) {
                    delta.x = x - bounds.getCenterX();
                    ttX = Math.abs(x - center);
                    override = true;
                } else if (!centerAlign) {
                    if (Math.abs(x - left) < ttX) {
                        delta.x = x - bounds.x;
                        ttX = Math.abs(x - left);
                        override = true;
                    } else if (Math.abs(x - right) < ttX) {
                        delta.x = x - bounds.x - bounds.width;
                        ttX = Math.abs(x - right);
                        override = true;
                    }
                }
                if (override) {
                    stateX = state;
                    valueX = x;
                    if (!this.guideX) {
                        this.guideX = this.createGuideShape(true);
                        // Makes sure to use SVG shapes in order to implement
                        // event-transparency on the background area of the rectangle since
                        // HTML shapes do not let mouseevents through even when transparent
                        this.guideX.dialect = 'svg';
                        this.guideX.pointerEvents = false;
                        this.guideX.init(this.graph.getView().getOverlayPane());
                    }
                }
                overrideX = overrideX || override;
            };
            // Snaps the top, middle or bottom to the given y-coordinate
            const snapY = (y, state, centerAlign)=>{
                let override = false;
                if (centerAlign && Math.abs(y - middle) < ttY) {
                    delta.y = y - bounds.getCenterY();
                    ttY = Math.abs(y - middle);
                    override = true;
                } else if (!centerAlign) {
                    if (Math.abs(y - top) < ttY) {
                        delta.y = y - bounds.y;
                        ttY = Math.abs(y - top);
                        override = true;
                    } else if (Math.abs(y - bottom) < ttY) {
                        delta.y = y - bounds.y - bounds.height;
                        ttY = Math.abs(y - bottom);
                        override = true;
                    }
                }
                if (override) {
                    stateY = state;
                    valueY = y;
                    if (!this.guideY) {
                        this.guideY = this.createGuideShape(false);
                        // Makes sure to use SVG shapes in order to implement
                        // event-transparency on the background area of the rectangle since
                        // HTML shapes do not let mouseevents through even when transparent
                        this.guideY.dialect = 'svg';
                        this.guideY.pointerEvents = false;
                        this.guideY.init(this.graph.getView().getOverlayPane());
                    }
                }
                overrideY = overrideY || override;
            };
            for(let i = 0; i < this.states.length; i += 1){
                const state = this.states[i];
                if (state && !this.isStateIgnored(state)) {
                    // Align x
                    if (this.horizontal) {
                        snapX(state.getCenterX(), state, true);
                        snapX(state.x, state, false);
                        snapX(state.x + state.width, state, false);
                        // Aligns left and right of shape to center of page
                        if (!state.cell) snapX(state.getCenterX(), state, false);
                    }
                    // Align y
                    if (this.vertical) {
                        snapY(state.getCenterY(), state, true);
                        snapY(state.y, state, false);
                        snapY(state.y + state.height, state, false);
                        // Aligns left and right of shape to center of page
                        if (!state.cell) snapY(state.getCenterY(), state, false);
                    }
                }
            }
            // Moves cells to the raster if not aligned
            this.graph.snapDelta(delta, bounds, !gridEnabled, overrideX, overrideY);
            delta = this.getDelta(bounds, stateX, delta.x, stateY, delta.y);
            // Redraws the guides
            const c = this.graph.container;
            if (!overrideX && this.guideX) this.guideX.node.style.visibility = 'hidden';
            else if (this.guideX) {
                let minY = null;
                let maxY = null;
                if (stateX) {
                    minY = Math.min(bounds.y + delta.y - this.graph.getPanDy(), stateX.y);
                    maxY = Math.max(bounds.y + bounds.height + delta.y - this.graph.getPanDy(), // @ts-ignore stateX! doesn't work for some reason...
                    stateX.y + stateX.height);
                }
                if (minY !== null && maxY !== null) this.guideX.points = [
                    new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(valueX, minY),
                    new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(valueX, maxY)
                ];
                else this.guideX.points = [
                    new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(valueX, -this.graph.getPanDy()),
                    new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(valueX, c.scrollHeight - 3 - this.graph.getPanDy())
                ];
                this.guideX.stroke = this.getGuideColor(stateX, true);
                this.guideX.node.style.visibility = 'visible';
                this.guideX.redraw();
            }
            if (!overrideY && this.guideY != null) this.guideY.node.style.visibility = 'hidden';
            else if (this.guideY != null) {
                let minX = null;
                let maxX = null;
                if (stateY != null && bounds != null) {
                    minX = Math.min(bounds.x + delta.x - this.graph.getPanDx(), stateY.x);
                    maxX = Math.max(bounds.x + bounds.width + delta.x - this.graph.getPanDx(), // @ts-ignore
                    stateY.x + stateY.width);
                }
                if (minX != null && maxX != null && valueY !== null) this.guideY.points = [
                    new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(minX, valueY),
                    new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(maxX, valueY)
                ];
                else if (valueY !== null) this.guideY.points = [
                    new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(-this.graph.getPanDx(), valueY),
                    new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(c.scrollWidth - 3 - this.graph.getPanDx(), valueY)
                ];
                this.guideY.stroke = this.getGuideColor(stateY, false);
                this.guideY.node.style.visibility = 'visible';
                this.guideY.redraw();
            }
        }
        return delta;
    }
    /**
     * Rounds to pixels for virtual states (eg. page guides)
     */ getDelta(bounds, stateX = null, dx, stateY = null, dy) {
        const s = this.graph.view.scale;
        if (this.rounded || stateX != null && stateX.cell == null) dx = Math.round((bounds.x + dx) / s) * s - bounds.x;
        if (this.rounded || stateY != null && stateY.cell == null) dy = Math.round((bounds.y + dy) / s) * s - bounds.y;
        return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(dx, dy);
    }
    /**
     * Hides all current guides.
     */ getGuideColor(state, horizontal) {
        return 0, $cBHcM.GUIDE_COLOR;
    }
    /**
     * Hides all current guides.
     */ hide() {
        this.setVisible(false);
    }
    /**
     * Shows or hides the current guides.
     */ setVisible(visible) {
        if (this.guideX) this.guideX.node.style.visibility = visible ? 'visible' : 'hidden';
        if (this.guideY) this.guideY.node.style.visibility = visible ? 'visible' : 'hidden';
    }
    /**
     * Destroys all resources that this object uses.
     */ destroy() {
        if (this.guideX) {
            this.guideX.destroy();
            this.guideX = null;
        }
        if (this.guideY) {
            this.guideY.destroy();
            this.guideY = null;
        }
    }
}
var $cc94ee9a81ffc981$export$2e2bcd8739ae039 = $cc94ee9a81ffc981$var$Guide;




var $cBHcM = parcelRequire("cBHcM");




/**
 * Graph event handler that handles selection.
 *
 * Individual cells are handled separately by {@link SelectionCellsHandler} using {@link VertexHandler} or one of the {@link EdgeHandler}s.
 * When the {@link SelectionCellsHandler} plugin is registered in the {@link AbstractGraph}, {@link SelectionHandler} interacts with this plugin to propagate global selection events to individual cells.
 *
 * To avoid the container to scroll a moved cell into view, set {@link scrollOnMove} to `false`.
 *
 * @category Plugin
 */ class $49bd4ce5d7a604a2$var$SelectionHandler {
    /**
     * Constructs an event handler that creates handles for the selection cells.
     *
     * @param graph Reference to the enclosing {@link AbstractGraph}.
     */ constructor(graph){
        this.refreshThread = null;
        /**
         * Defines the maximum number of cells to paint subhandles
         * for. Default is 50 for Firefox and 20 for IE. Set this
         * to 0 if you want an unlimited number of handles to be
         * displayed. This is only recommended if the number of
         * cells in the graph is limited to a small number, eg.
         * 500.
         */ this.maxCells = 50;
        /**
         * Specifies if events are handled. Default is true.
         */ this.enabled = true;
        /**
         * Specifies if drop targets under the mouse should be enabled. Default is
         * true.
         */ this.highlightEnabled = true;
        /**
         * Specifies if cloning by control-drag is enabled. Default is true.
         */ this.cloneEnabled = true;
        /**
         * Specifies if moving is enabled. Default is true.
         */ this.moveEnabled = true;
        /**
         * Specifies if other cells should be used for snapping the right, center or
         * left side of the current selection. Default is false.
         */ this.guidesEnabled = false;
        /**
         * Whether the handles of the selection are currently visible.
         */ this.handlesVisible = true;
        /**
         * Holds the {@link Guide} instance that is used for alignment.
         */ this.guide = null;
        /**
         * Stores the x-coordinate of the current mouse move.
         */ this.currentDx = 0;
        /**
         * Stores the y-coordinate of the current mouse move.
         */ this.currentDy = 0;
        /**
         * Specifies if a move cursor should be shown if the mouse is over a movable
         * cell. Default is true.
         */ this.updateCursor = true;
        /**
         * Specifies if selecting is enabled. Default is true.
         */ this.selectEnabled = true;
        /**
         * Specifies if cells may be moved out of their parents. Default is true.
         */ this.removeCellsFromParent = true;
        /**
         * If empty parents should be removed from the model after all child cells
         * have been moved out. Default is true.
         */ this.removeEmptyParents = false;
        /**
         * Specifies if drop events are interpreted as new connections if no other
         * drop action is defined. Default is false.
         */ this.connectOnDrop = false;
        /**
         * Specifies if the view should be scrolled so that a moved cell is visible.
         * @default true
         */ this.scrollOnMove = true;
        /**
         * Specifies the minimum number of pixels for the width and height of a
         * selection border. Default is 6.
         */ this.minimumSize = 6;
        /**
         * Specifies the color of the preview shape. Default is black.
         */ this.previewColor = 'black';
        /**
         * Specifies if the graph container should be used for preview. If this is used
         * then drop target detection relies entirely on {@link AbstractGraph.getCellAt} because
         * the HTML preview does not "let events through". Default is false.
         */ this.htmlPreview = false;
        /**
         * Reference to the {@link Shape} that represents the preview.
         */ this.shape = null;
        /**
         * Specifies if the grid should be scaled. Default is false.
         */ this.scaleGrid = false;
        /**
         * Specifies if the bounding box should allow for rotation. Default is true.
         */ this.rotationEnabled = true;
        /**
         * Maximum number of cells for which live preview should be used.  Default is 0 which means no live preview.
         */ this.maxLivePreview = 0;
        /**
         * Variable allowLivePreview
         *
         * If live preview is allowed on this system.  Default is true for systems with SVG support.
         */ this.allowLivePreview = (0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_SVG;
        this.cell = null;
        this.delayedSelection = false;
        this.first = null;
        this.cells = null;
        this.bounds = null;
        this.pBounds = null;
        this.allCells = new Map();
        this.cellWasClicked = false;
        this.cloning = false;
        this.cellCount = 0;
        this.target = null;
        this.suspended = false;
        this.livePreviewActive = false;
        this.livePreviewUsed = false;
        this.highlight = null;
        this.graph = graph;
        this.graph.addMouseListener(this);
        // Repaints the handler after autoscroll
        this.panHandler = ()=>{
            if (!this.suspended) {
                this.updatePreview();
                this.updateHint();
            }
        };
        this.graph.addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).PAN, this.panHandler);
        // Handles escape keystrokes
        this.escapeHandler = (sender, evt)=>{
            this.reset();
        };
        this.graph.addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).ESCAPE, this.escapeHandler);
        // Updates the preview box for remote changes
        this.refreshHandler = (sender, evt)=>{
            // Merges multiple pending calls
            if (this.refreshThread) window.clearTimeout(this.refreshThread);
            // Waits for the states and handlers to be updated
            this.refreshThread = window.setTimeout(()=>{
                this.refreshThread = null;
                if (this.first && !this.suspended && this.cells) {
                    // Updates preview with no translate to compute bounding box
                    const dx = this.currentDx;
                    const dy = this.currentDy;
                    this.currentDx = 0;
                    this.currentDy = 0;
                    this.updatePreview();
                    this.bounds = this.graph.getView().getBounds(this.cells);
                    this.pBounds = this.getPreviewBounds(this.cells);
                    if (this.pBounds == null && !this.livePreviewUsed) this.reset();
                    else {
                        // Restores translate and updates preview
                        this.currentDx = dx;
                        this.currentDy = dy;
                        this.updatePreview();
                        this.updateHint();
                        if (this.livePreviewUsed) {
                            // Forces update to ignore last visible state
                            this.setHandlesVisibleForCells(this.getSelectionCellsHandler()?.getHandledSelectionCells() ?? [], false, true);
                            this.updatePreview();
                        }
                    }
                }
            }, 0);
        };
        this.graph.getDataModel().addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).CHANGE, this.refreshHandler);
        this.graph.addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).REFRESH, this.refreshHandler);
        this.keyHandler = (e)=>{
            if (this.graph.container != null && this.graph.container.style.visibility !== 'hidden' && this.first != null && !this.suspended) {
                const clone = this.graph.isCloneEvent(e) && this.graph.isCellsCloneable() && this.isCloneEnabled();
                if (clone !== this.cloning) {
                    this.cloning = clone;
                    this.checkPreview();
                    this.updatePreview();
                }
            }
        };
        if (typeof document !== 'undefined') {
            (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addListener(document, 'keydown', this.keyHandler);
            (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addListener(document, 'keyup', this.keyHandler);
        }
    }
    /**
     * Returns <enabled>.
     */ isEnabled() {
        return this.enabled;
    }
    /**
     * Sets <enabled>.
     */ setEnabled(value) {
        this.enabled = value;
    }
    /**
     * Returns <cloneEnabled>.
     */ isCloneEnabled() {
        return this.cloneEnabled;
    }
    /**
     * Sets <cloneEnabled>.
     *
     * @param value Boolean that specifies the new clone enabled state.
     */ setCloneEnabled(value) {
        this.cloneEnabled = value;
    }
    /**
     * Returns {@link oveEnabled}.
     */ isMoveEnabled() {
        return this.moveEnabled;
    }
    /**
     * Sets {@link oveEnabled}.
     */ setMoveEnabled(value) {
        this.moveEnabled = value;
    }
    /**
     * Returns <selectEnabled>.
     */ isSelectEnabled() {
        return this.selectEnabled;
    }
    /**
     * Sets <selectEnabled>.
     */ setSelectEnabled(value) {
        this.selectEnabled = value;
    }
    /**
     * Returns <removeCellsFromParent>.
     */ isRemoveCellsFromParent() {
        return this.removeCellsFromParent;
    }
    /**
     * Sets <removeCellsFromParent>.
     */ setRemoveCellsFromParent(value) {
        this.removeCellsFromParent = value;
    }
    /**
     * Returns true if the given cell and parent should propagate
     * selection state to the parent.
     */ isPropagateSelectionCell(cell, immediate, me) {
        const parent = cell.getParent();
        if (immediate) {
            const geo = cell.isEdge() ? null : cell.getGeometry();
            return !this.graph.isSiblingSelected(cell) && geo && geo.relative || !this.graph.isSwimlane(parent);
        }
        return (!this.graph.isToggleEvent(me.getEvent()) || !this.graph.isSiblingSelected(cell) && !this.graph.isCellSelected(cell) && !this.graph.isSwimlane(parent) || this.graph.isCellSelected(parent)) && (this.graph.isToggleEvent(me.getEvent()) || !this.graph.isCellSelected(parent));
    }
    /**
     * Hook to return initial cell for the given event.
     */ getInitialCellForEvent(me) {
        let state = me.getState();
        if ((!this.graph.isToggleEvent(me.getEvent()) || !(0, $f192e93a2fd1153c$export$bdc3218ff6eba0d8)(me.getEvent())) && state && !this.graph.isCellSelected(state.cell)) {
            let parent = state.cell.getParent();
            let next = parent ? this.graph.view.getState(parent) : null;
            while(next && !this.graph.isCellSelected(next.cell) && (next.cell.isVertex() || next.cell.isEdge()) && this.isPropagateSelectionCell(state.cell, true, me)){
                state = next;
                parent = state.cell.getParent();
                next = parent ? this.graph.view.getState(parent) : null;
            }
        }
        return state ? state.cell : null;
    }
    /**
     * Hook to return true for delayed selections.
     */ isDelayedSelection(cell, me) {
        let c = cell;
        const selectionCellsHandler = this.getSelectionCellsHandler();
        if (!this.graph.isToggleEvent(me.getEvent()) || !(0, $f192e93a2fd1153c$export$bdc3218ff6eba0d8)(me.getEvent())) while(c){
            if (selectionCellsHandler?.isHandled(c)) {
                const cellEditorHandler = this.graph.getPlugin('CellEditorHandler');
                return cellEditorHandler?.getEditingCell() !== c;
            }
            c = c.getParent();
        }
        return this.graph.isToggleEvent(me.getEvent()) && !(0, $f192e93a2fd1153c$export$bdc3218ff6eba0d8)(me.getEvent());
    }
    /**
     * Implements the delayed selection for the given mouse event.
     */ selectDelayed(me) {
        const popupMenuHandler = this.graph.getPlugin('PopupMenuHandler');
        if (!popupMenuHandler || !popupMenuHandler.isPopupTrigger(me)) {
            let cell = me.getCell();
            if (cell === null) cell = this.cell;
            if (cell) this.selectCellForEvent(cell, me);
        }
    }
    /**
     * Selects the given cell for the given {@link MouseEvent}.
     */ selectCellForEvent(cell, me) {
        const state = this.graph.view.getState(cell);
        if (state) {
            if (me.isSource(state.control)) this.graph.selectCellForEvent(cell, me.getEvent());
            else {
                if (!this.graph.isToggleEvent(me.getEvent()) || !(0, $f192e93a2fd1153c$export$bdc3218ff6eba0d8)(me.getEvent())) {
                    let parent = cell.getParent();
                    while(parent && this.graph.view.getState(parent) && (parent.isVertex() || parent.isEdge()) && this.isPropagateSelectionCell(cell, false, me)){
                        cell = parent;
                        parent = cell.getParent();
                    }
                }
                this.graph.selectCellForEvent(cell, me.getEvent());
            }
        }
        return cell;
    }
    /**
     * Consumes the given mouse event.
     *
     * **NOTE**: This may be used to enable click events for links in labels on iOS as follows as consuming the initial
     * touchStart disables firing the subsequent click event on the link.
     *
     * ```js
     * consumeMouseEvent(evtName, me) {
     *   const source = eventUtils.getSource(me.getEvent());
     *
     *   if (!eventUtils.isTouchEvent(me.getEvent()) || source.nodeName != 'A') {
     *     me.consume();
     *   }
     * }
     * ```
     */ consumeMouseEvent(_evtName, me) {
        me.consume();
    }
    /**
     * Handles the event by selecting the given cell and creating a handle for it.
     * By consuming the event all subsequent events of the gesture are redirected to this handler.
     */ mouseDown(_sender, me) {
        if (!me.isConsumed() && this.isEnabled() && this.graph.isEnabled() && me.getState() && !(0, $f192e93a2fd1153c$export$d06464d6b74eedc4)(me.getEvent())) {
            const cell = this.getInitialCellForEvent(me);
            if (cell) {
                this.delayedSelection = this.isDelayedSelection(cell, me);
                this.cell = null;
                if (this.isSelectEnabled() && !this.delayedSelection) this.graph.selectCellForEvent(cell, me.getEvent());
                if (this.isMoveEnabled()) {
                    const geo = cell.getGeometry();
                    if (geo && this.graph.isCellMovable(cell) && (!cell.isEdge() || this.graph.getSelectionCount() > 1 || geo.points && geo.points.length > 0 || !cell.getTerminal(true) || !cell.getTerminal(false) || this.graph.isAllowDanglingEdges() || this.graph.isCloneEvent(me.getEvent()) && this.graph.isCellsCloneable())) this.start(cell, me.getX(), me.getY());
                    else if (this.delayedSelection) this.cell = cell;
                    this.cellWasClicked = true;
                    this.consumeMouseEvent((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_DOWN, me);
                }
            }
        }
    }
    /**
     * Creates an array of cell states which should be used as guides.
     */ getGuideStates() {
        const parent = this.graph.getDefaultParent();
        const filter = (cell)=>{
            const geo = cell.getGeometry();
            return !!this.graph.view.getState(cell) && cell.isVertex() && !!geo && !geo.relative;
        };
        return this.graph.view.getCellStates(parent.filterDescendants(filter));
    }
    /**
     * Returns the cells to be modified by this handler. This implementation
     * returns all selection cells that are movable, or the given initial cell if
     * the given cell is not selected and movable. This handles the case of moving
     * unselectable or unselected cells.
     *
     * @param initialCell <Cell> that triggered this handler.
     */ getCells(initialCell) {
        if (!this.delayedSelection && this.graph.isCellMovable(initialCell)) return [
            initialCell
        ];
        return this.graph.getMovableCells(this.graph.getSelectionCells());
    }
    /**
     * Returns the {@link Rectangle} used as the preview bounds for
     * moving the given cells.
     */ getPreviewBounds(cells) {
        const bounds = this.getBoundingBox(cells);
        if (bounds) {
            // Corrects width and height
            bounds.width = Math.max(0, bounds.width - 1);
            bounds.height = Math.max(0, bounds.height - 1);
            if (bounds.width < this.minimumSize) {
                const dx = this.minimumSize - bounds.width;
                bounds.x -= dx / 2;
                bounds.width = this.minimumSize;
            } else {
                bounds.x = Math.round(bounds.x);
                bounds.width = Math.ceil(bounds.width);
            }
            if (bounds.height < this.minimumSize) {
                const dy = this.minimumSize - bounds.height;
                bounds.y -= dy / 2;
                bounds.height = this.minimumSize;
            } else {
                bounds.y = Math.round(bounds.y);
                bounds.height = Math.ceil(bounds.height);
            }
        }
        return bounds;
    }
    /**
     * Returns the union of the {@link CellStates} for the given array of {@link Cells}.
     * For vertices, this method uses the bounding box of the corresponding shape
     * if one exists. The bounding box of the corresponding text label and all
     * controls and overlays are ignored. See also: {@link GraphView#getBounds} and
     * {@link AbstractGraph.getBoundingBox}.
     *
     * @param cells Array of {@link Cells} whose bounding box should be returned.
     */ getBoundingBox(cells) {
        let result = null;
        if (cells.length > 0) {
            for(let i = 0; i < cells.length; i += 1)if (cells[i].isVertex() || cells[i].isEdge()) {
                const state = this.graph.view.getState(cells[i]);
                if (state) {
                    let bbox = null;
                    if (cells[i].isVertex() && state.shape && state.shape.boundingBox) bbox = state.shape.boundingBox;
                    if (bbox) {
                        if (!result) result = (0, $2997c239141ea844$export$2e2bcd8739ae039).fromRectangle(bbox);
                        else result.add(bbox);
                    }
                }
            }
        }
        return result;
    }
    /**
     * Creates the shape used to draw the preview for the given bounds.
     */ createPreviewShape(bounds) {
        const shape = new (0, $14ee9ba473f8b778$export$2e2bcd8739ae039)(bounds, (0, $cBHcM.NONE), this.previewColor);
        shape.isDashed = true;
        if (this.htmlPreview) {
            shape.dialect = 'strictHtml';
            shape.init(this.graph.container);
        } else {
            // Makes sure to use either VML or SVG shapes in order to implement
            // event-transparency on the background area of the rectangle since
            // HTML shapes do not let mouseevents through even when transparent
            shape.dialect = 'svg';
            shape.init(this.graph.getView().getOverlayPane());
            shape.pointerEvents = false;
            // Workaround for artifacts on iOS
            if ((0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_IOS) shape.getSvgScreenOffset = ()=>{
                return 0;
            };
        }
        return shape;
    }
    createGuide() {
        return new (0, $cc94ee9a81ffc981$export$2e2bcd8739ae039)(this.graph, this.getGuideStates());
    }
    /**
     * Starts the handling of the mouse gesture.
     */ start(cell, x, y, cells) {
        this.cell = cell;
        this.first = (0, $b55d6ca3b42398e2$export$864dc177f7f5bda1)(this.graph.container, x, y);
        this.cells = cells ? cells : this.getCells(this.cell);
        this.bounds = this.graph.getView().getBounds(this.cells);
        this.pBounds = this.getPreviewBounds(this.cells);
        this.cloning = false;
        this.cellCount = 0;
        for(let i = 0; i < this.cells.length; i += 1)this.cellCount += this.addStates(this.cells[i], this.allCells);
        if (this.guidesEnabled) {
            this.guide = this.createGuide();
            const parent = cell.getParent();
            const ignore = parent.getChildCount() < 2;
            // Uses connected states as guides
            const connected = new Map();
            const opps = this.graph.getOpposites(this.graph.getEdges(this.cell), this.cell);
            for(let i = 0; i < opps.length; i += 1){
                const state = this.graph.view.getState(opps[i]);
                if (state && !connected.get(state)) connected.set(state, true);
            }
            this.guide.isStateIgnored = (state)=>{
                const p = state.cell.getParent();
                return !!state.cell && (!this.cloning && !!this.isCellMoving(state.cell) || state.cell !== (this.target || parent) && !ignore && !connected.get(state) && (!this.target || this.target.getChildCount() >= 2) && p !== (this.target || parent));
            };
        }
    }
    /**
     * Adds the states for the given cell recursively to the given Map.
     * @param cell
     * @param dict
     */ addStates(cell, dict) {
        const state = this.graph.view.getState(cell);
        let count = 0;
        if (state && !dict.get(cell)) {
            dict.set(cell, state);
            count++;
            const childCount = cell.getChildCount();
            for(let i = 0; i < childCount; i += 1)count += this.addStates(cell.getChildAt(i), dict);
        }
        return count;
    }
    /**
     * Returns true if the given cell is currently being moved.
     */ isCellMoving(cell) {
        return this.allCells.has(cell);
    }
    /**
     * Returns true if the guides should be used for the given {@link MouseEvent}.
     * This implementation returns {@link Guide#isEnabledForEvent}.
     */ useGuidesForEvent(me) {
        return this.guide ? this.guide.isEnabledForEvent(me.getEvent()) && !this.graph.isConstrainedEvent(me.getEvent()) : true;
    }
    /**
     * Snaps the given vector to the grid and returns the given mxPoint instance.
     */ snap(vector) {
        const scale = this.scaleGrid ? this.graph.view.scale : 1;
        vector.x = this.graph.snap(vector.x / scale) * scale;
        vector.y = this.graph.snap(vector.y / scale) * scale;
        return vector;
    }
    /**
     * Returns an {@link Point} that represents the vector for moving the cells
     * for the given {@link MouseEvent}.
     */ getDelta(me) {
        const point = (0, $b55d6ca3b42398e2$export$864dc177f7f5bda1)(this.graph.container, me.getX(), me.getY());
        if (!this.first) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)();
        return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(point.x - this.first.x - this.graph.getPanDx(), point.y - this.first.y - this.graph.getPanDy());
    }
    /**
     * Hook for subclassers do show details while the handler is active.
     */ updateHint(me) {
        return;
    }
    /**
     * Hooks for subclassers to hide details when the handler gets inactive.
     */ removeHint() {
        return;
    }
    /**
     * Hook for rounding the unscaled vector. This uses Math.round.
     */ roundLength(length) {
        return Math.round(length * 100) / 100;
    }
    /**
     * Returns true if the given cell is a valid drop target.
     */ isValidDropTarget(target, me) {
        return this.cell ? this.cell.getParent() !== target : false;
    }
    /**
     * Updates the preview if cloning state has changed.
     */ checkPreview() {
        if (this.livePreviewActive && this.cloning) {
            this.resetLivePreview();
            this.livePreviewActive = false;
        } else if (this.maxLivePreview >= this.cellCount && !this.livePreviewActive && this.allowLivePreview) {
            if (!this.cloning || !this.livePreviewActive) {
                this.livePreviewActive = true;
                this.livePreviewUsed = true;
            }
        } else if (!this.livePreviewUsed && !this.shape && this.bounds) this.shape = this.createPreviewShape(this.bounds);
    }
    /**
     * Handles the event by highlighting possible drop targets and updating the preview.
     */ mouseMove(_sender, me) {
        const { graph: graph } = this;
        if (!me.isConsumed() && graph.isMouseDown && this.cell && this.first && this.bounds && !this.suspended) {
            // Stops moving if a multi touch event is received
            if ((0, $f192e93a2fd1153c$export$d06464d6b74eedc4)(me.getEvent())) {
                this.reset();
                return;
            }
            let delta = this.getDelta(me);
            const tol = graph.getEventTolerance();
            if (this.shape || this.livePreviewActive || Math.abs(delta.x) > tol || Math.abs(delta.y) > tol) {
                // Highlight is used for highlighting drop targets
                if (!this.highlight) this.highlight = new (0, $9c1b6c331f040a7b$export$2e2bcd8739ae039)(this.graph, (0, $cBHcM.DROP_TARGET_COLOR), 3);
                const clone = graph.isCloneEvent(me.getEvent()) && graph.isCellsCloneable() && this.isCloneEnabled();
                const gridEnabled = graph.isGridEnabledEvent(me.getEvent());
                const cell = me.getCell();
                let hideGuide = true;
                let target = null;
                this.cloning = clone;
                if (graph.isDropEnabled() && this.highlightEnabled && this.cells) // Contains a call to getCellAt to find the cell under the mouse
                target = graph.getDropTarget(this.cells, me.getEvent(), cell, clone);
                let state = target ? graph.getView().getState(target) : null;
                let highlight = false;
                if (state && (clone || target && this.isValidDropTarget(target, me))) {
                    if (this.target !== target) {
                        this.target = target;
                        this.setHighlightColor((0, $cBHcM.DROP_TARGET_COLOR));
                    }
                    highlight = true;
                } else {
                    this.target = null;
                    if (this.connectOnDrop && cell && this.cells && this.cells.length === 1 && cell.isVertex() && cell.isConnectable()) {
                        state = graph.getView().getState(cell);
                        if (state) {
                            const error = graph.getEdgeValidationError(null, this.cell, cell);
                            const color = error === null ? (0, $cBHcM.VALID_COLOR) : (0, $cBHcM.INVALID_CONNECT_TARGET_COLOR);
                            this.setHighlightColor(color);
                            highlight = true;
                        }
                    }
                }
                if (state && highlight) this.highlight.highlight(state);
                else this.highlight.hide();
                if (this.guide && this.useGuidesForEvent(me)) {
                    delta = this.guide.move(this.bounds, delta, gridEnabled, clone);
                    hideGuide = false;
                } else delta = this.graph.snapDelta(delta, this.bounds, !gridEnabled, false, false);
                if (this.guide && hideGuide) this.guide.hide();
                // Constrained movement if shift key is pressed
                if (graph.isConstrainedEvent(me.getEvent())) {
                    if (Math.abs(delta.x) > Math.abs(delta.y)) delta.y = 0;
                    else delta.x = 0;
                }
                this.checkPreview();
                if (this.currentDx !== delta.x || this.currentDy !== delta.y) {
                    this.currentDx = delta.x;
                    this.currentDy = delta.y;
                    this.updatePreview();
                }
            }
            this.updateHint(me);
            this.consumeMouseEvent((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_MOVE, me);
            // Cancels the bubbling of events to the container so
            // that the droptarget is not reset due to an mouseMove
            // fired on the container with no associated state.
            (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).consume(me.getEvent());
        } else if ((this.isMoveEnabled() || this.isCloneEnabled()) && this.updateCursor && !me.isConsumed() && (me.getState() || me.sourceState) && !graph.isMouseDown) {
            let cursor = graph.getCursorForMouseEvent(me);
            const cell = me.getCell();
            if (!cursor && cell && graph.isEnabled() && graph.isCellMovable(cell)) {
                if (cell.isEdge()) cursor = (0, $f17931ed28a53cd3$export$3c0f4b700203d869).cursorMovable;
                else cursor = (0, $f17931ed28a53cd3$export$1b394cdb5b3999f1).cursorMovable;
            }
            // Sets the cursor on the original source state under the mouse
            // instead of the event source state which can be the parent
            if (cursor && me.sourceState) me.sourceState.setCursor(cursor);
        }
    }
    /**
     * Updates the bounds of the preview shape.
     */ updatePreview(remote = false) {
        if (this.livePreviewUsed && !remote) {
            if (this.cells) {
                this.setHandlesVisibleForCells(this.getSelectionCellsHandler()?.getHandledSelectionCells() ?? [], false);
                this.updateLivePreview(this.currentDx, this.currentDy);
            }
        } else this.updatePreviewShape();
    }
    /**
     * Updates the bounds of the preview shape.
     */ updatePreviewShape() {
        if (this.shape && this.pBounds) {
            this.shape.bounds = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(Math.round(this.pBounds.x + this.currentDx), Math.round(this.pBounds.y + this.currentDy), this.pBounds.width, this.pBounds.height);
            this.shape.redraw();
        }
    }
    /**
     * Updates the bounds of the preview shape.
     */ updateLivePreview(dx, dy) {
        if (!this.suspended) {
            const states = [];
            if (this.allCells) this.allCells.forEach((state)=>{
                const realState = state ? this.graph.view.getState(state.cell) : null;
                // Checks if cell was removed or replaced
                if (realState !== state && state) {
                    state.destroy();
                    if (realState) this.allCells.set(state.cell, realState);
                    else this.allCells.delete(state.cell);
                    state = realState;
                }
                if (state) {
                    // Saves current state
                    const tempState = state.clone();
                    states.push([
                        state,
                        tempState
                    ]);
                    // Makes transparent for events to detect drop targets
                    if (state.shape) {
                        if (state.shape.originalPointerEvents === null) state.shape.originalPointerEvents = state.shape.pointerEvents;
                        state.shape.pointerEvents = false;
                        if (state.text) {
                            if (state.text.originalPointerEvents === null) state.text.originalPointerEvents = state.text.pointerEvents;
                            state.text.pointerEvents = false;
                        }
                    }
                    // Temporarily changes position
                    if (state.cell.isVertex()) {
                        state.x += dx;
                        state.y += dy;
                        // Draws the live preview
                        if (!this.cloning) {
                            state.view.graph.cellRenderer.redraw(state, true);
                            // Forces redraw of connected edges after all states
                            // have been updated but avoids update of state
                            state.view.invalidate(state.cell);
                            state.invalid = false;
                            // Hides folding icon
                            if (state.control && state.control.node) state.control.node.style.visibility = 'hidden';
                        } else if (state.text) {
                            state.text.updateBoundingBox();
                            // Fixes preview box for edge labels
                            if (state.text.boundingBox) {
                                state.text.boundingBox.x += dx;
                                state.text.boundingBox.y += dy;
                            }
                            if (state.text.unrotatedBoundingBox) {
                                state.text.unrotatedBoundingBox.x += dx;
                                state.text.unrotatedBoundingBox.y += dy;
                            }
                        }
                    }
                }
            });
            // Resets the handler if everything was removed
            if (states.length === 0) this.reset();
            else {
                // Redraws connected edges
                const s = this.graph.view.scale;
                for(let i = 0; i < states.length; i += 1){
                    const state = states[i][0];
                    if (state.cell.isEdge()) {
                        const geometry = state.cell.getGeometry();
                        const points = [];
                        if (geometry && geometry.points) {
                            for(let j = 0; j < geometry.points.length; j++)if (geometry.points[j]) points.push(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(geometry.points[j].x + dx / s, geometry.points[j].y + dy / s));
                        }
                        let source = state.visibleSourceState;
                        let target = state.visibleTargetState;
                        const pts = states[i][1].absolutePoints;
                        if (source == null || !this.isCellMoving(source.cell)) {
                            const pt0 = pts[0];
                            if (pt0) {
                                state.setAbsoluteTerminalPoint(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(pt0.x + dx, pt0.y + dy), true);
                                source = null;
                            }
                        } else state.view.updateFixedTerminalPoint(state, source, true, this.graph.getConnectionConstraint(state, source, true));
                        if (target == null || !this.isCellMoving(target.cell)) {
                            const ptn = pts[pts.length - 1];
                            if (ptn) {
                                state.setAbsoluteTerminalPoint(new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(ptn.x + dx, ptn.y + dy), false);
                                target = null;
                            }
                        } else state.view.updateFixedTerminalPoint(state, target, false, this.graph.getConnectionConstraint(state, target, false));
                        state.view.updatePoints(state, points, source, target);
                        state.view.updateFloatingTerminalPoints(state, source, target);
                        state.view.updateEdgeLabelOffset(state);
                        state.invalid = false;
                        // Draws the live preview but avoids update of state
                        if (!this.cloning) state.view.graph.cellRenderer.redraw(state, true);
                    }
                }
                this.graph.view.validate();
                this.redrawHandles(states);
                this.resetPreviewStates(states);
            }
        }
    }
    /**
     * Redraws the preview shape for the given states array.
     */ redrawHandles(states) {
        const selectionCellsHandler = this.getSelectionCellsHandler();
        for(let i = 0; i < states.length; i += 1){
            const handler = selectionCellsHandler?.getHandler(states[i][0].cell);
            handler?.redraw(true);
        }
    }
    /**
     * Resets the given preview states array.
     */ resetPreviewStates(states) {
        for(let i = 0; i < states.length; i += 1)states[i][0].setState(states[i][1]);
    }
    /**
     * Suspends the livew preview.
     */ suspend() {
        if (!this.suspended) {
            if (this.livePreviewUsed) this.updateLivePreview(0, 0);
            if (this.shape) this.shape.node.style.visibility = 'hidden';
            if (this.guide) this.guide.setVisible(false);
            this.suspended = true;
        }
    }
    /**
     * Suspends the livew preview.
     */ resume() {
        if (this.suspended) {
            this.suspended = false;
            if (this.livePreviewUsed) this.livePreviewActive = true;
            if (this.shape) this.shape.node.style.visibility = 'visible';
            if (this.guide) this.guide.setVisible(true);
        }
    }
    /**
     * Resets the livew preview.
     */ resetLivePreview() {
        this.allCells.forEach((state)=>{
            // Restores event handling
            if (state.shape && state.shape.originalPointerEvents !== null) {
                state.shape.pointerEvents = state.shape.originalPointerEvents;
                state.shape.originalPointerEvents = null;
                // Forces repaint even if not moved to update pointer events
                state.shape.bounds = null;
                if (state.text && state.text.originalPointerEvents !== null) {
                    state.text.pointerEvents = state.text.originalPointerEvents;
                    state.text.originalPointerEvents = null;
                }
            }
            // Shows folding icon
            if (state.control && state.control.node && state.control.node.style.visibility === 'hidden') state.control.node.style.visibility = '';
            // Fixes preview box for edge labels
            if (!this.cloning) {
                if (state.text) state.text.updateBoundingBox();
            }
            // Forces repaint of connected edges
            state.view.invalidate(state.cell);
        });
        // Repaints all invalid states
        this.graph.view.validate();
    }
    /**
     * Sets whether the handles attached to the given cells are visible.
     *
     * @param cells Array of {@link Cell}s.
     * @param visible Boolean that specifies if the handles should be visible.
     * @param force Forces an update of the handler regardless of the last used value.
     */ setHandlesVisibleForCells(cells, visible, force = false) {
        if (force || this.handlesVisible !== visible) {
            this.handlesVisible = visible;
            const selectionCellsHandler = this.getSelectionCellsHandler();
            for(let i = 0; i < cells.length; i += 1){
                const handler = selectionCellsHandler?.getHandler(cells[i]);
                if (handler) {
                    handler.setHandlesVisible(visible);
                    if (visible) handler.redraw();
                }
            }
        }
    }
    /**
     * Sets the color of the rectangle used to highlight drop targets.
     *
     * @param color String that represents the new highlight color.
     */ setHighlightColor(color) {
        if (this.highlight) this.highlight.setHighlightColor(color);
    }
    /**
     * Handles the event by applying the changes to the selection cells.
     */ mouseUp(_sender, me) {
        if (!me.isConsumed()) {
            if (this.livePreviewUsed) this.resetLivePreview();
            if (this.cell && this.first && (this.shape || this.livePreviewUsed) && (0, $f7ff90b8964488a6$export$e90fb89750dba83f)(this.currentDx) && (0, $f7ff90b8964488a6$export$e90fb89750dba83f)(this.currentDy)) {
                const { graph: graph } = this;
                const cell = me.getCell();
                if (this.connectOnDrop && !this.target && cell && cell.isVertex() && cell.isConnectable() && graph.isEdgeValid(null, this.cell, cell)) {
                    const connectionHandler = graph.getPlugin('ConnectionHandler');
                    connectionHandler?.connect(this.cell, cell, me.getEvent());
                } else {
                    const clone = graph.isCloneEvent(me.getEvent()) && graph.isCellsCloneable() && this.isCloneEnabled();
                    const { scale: scale } = graph.getView();
                    const dx = this.roundLength(this.currentDx / scale);
                    const dy = this.roundLength(this.currentDy / scale);
                    const target = this.target;
                    if (target && graph.isSplitEnabled() && this.cells && graph.isSplitTarget(target, this.cells, me.getEvent())) graph.splitEdge(target, this.cells, null, dx, dy, me.getGraphX(), me.getGraphY());
                    else if (this.cells) this.moveCells(this.cells, dx, dy, clone, this.target, me.getEvent());
                }
            } else if (this.isSelectEnabled() && this.delayedSelection && this.cell != null) this.selectDelayed(me);
        }
        // Consumes the event if a cell was initially clicked
        if (this.cellWasClicked) this.consumeMouseEvent((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_UP, me);
        this.reset();
    }
    /**
     * Resets the state of this handler.
     */ reset() {
        if (this.livePreviewUsed) {
            this.resetLivePreview();
            this.setHandlesVisibleForCells(this.getSelectionCellsHandler()?.getHandledSelectionCells() ?? [], true);
        }
        this.destroyShapes();
        this.removeHint();
        this.delayedSelection = false;
        this.livePreviewActive = false;
        this.livePreviewUsed = false;
        this.cellWasClicked = false;
        this.suspended = false;
        this.currentDx = 0;
        this.currentDy = 0;
        this.cellCount = 0;
        this.cloning = false;
        this.allCells.clear();
        this.pBounds = null;
        this.target = null;
        this.first = null;
        this.cells = null;
        this.cell = null;
    }
    /**
     * Returns true if the given cells should be removed from the parent for the specified
     * mousereleased event.
     */ shouldRemoveCellsFromParent(parent, cells, evt) {
        if (parent.isVertex()) {
            const pState = this.graph.getView().getState(parent);
            if (pState) {
                let pt = (0, $b55d6ca3b42398e2$export$864dc177f7f5bda1)(this.graph.container, (0, $f192e93a2fd1153c$export$87583e2c100c6a4f)(evt), (0, $f192e93a2fd1153c$export$195fc3609401443f)(evt));
                const alpha = (0, $f7ff90b8964488a6$export$cba01ba138429a1d)(pState.style.rotation ?? 0);
                if (alpha !== 0) {
                    const cos = Math.cos(-alpha);
                    const sin = Math.sin(-alpha);
                    const cx = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(pState.getCenterX(), pState.getCenterY());
                    pt = (0, $f7ff90b8964488a6$export$ad2a0af3fbffd7c1)(pt, cos, sin, cx);
                }
                return !(0, $f7ff90b8964488a6$export$2344b14b097df817)(pState, pt.x, pt.y);
            }
        }
        return false;
    }
    /**
     * Moves the given cells by the specified amount.
     */ moveCells(cells, dx, dy, clone, target, evt) {
        if (!this.cell) return;
        if (clone) cells = this.graph.getCloneableCells(cells);
        // Removes cells from parent
        const parent = this.cell.getParent();
        if (!target && parent && this.isRemoveCellsFromParent() && this.shouldRemoveCellsFromParent(parent, cells, evt)) target = this.graph.getDefaultParent();
        // Cloning into locked cells is not allowed
        clone = !!clone && !this.graph.isCellLocked(target || this.graph.getDefaultParent());
        this.graph.batchUpdate(()=>{
            const parents = [];
            // Removes parent if all child cells are removed
            if (!clone && target && this.removeEmptyParents) {
                // Collects all non-selected parents
                const dict = new Map();
                for(let i = 0; i < cells.length; i += 1)dict.set(cells[i], true);
                // LATER: Recurse up the cell hierarchy
                for(let i = 0; i < cells.length; i += 1){
                    const par = cells[i].getParent();
                    if (par && !dict.get(par)) {
                        dict.set(par, true);
                        parents.push(par);
                    }
                }
            }
            // Passes all selected cells in order to correctly clone or move into
            // the target cell. The method checks for each cell if its movable.
            cells = this.graph.moveCells(cells, dx, dy, clone, target, evt);
            // Removes parent if all child cells are removed
            const temp = [];
            for(let i = 0; i < parents.length; i += 1)if (this.shouldRemoveParent(parents[i])) temp.push(parents[i]);
            this.graph.removeCells(temp, false);
        });
        // Selects the new cells if cells have been cloned
        if (clone) this.graph.setSelectionCells(cells);
        if (this.isSelectEnabled() && this.scrollOnMove) this.graph.scrollCellToVisible(cells[0]);
    }
    /**
     * Returns true if the given parent should be removed after removal of child cells.
     */ shouldRemoveParent(parent) {
        const state = this.graph.view.getState(parent);
        return state != null && (state.cell.isEdge() || state.cell.isVertex()) && this.graph.isCellDeletable(state.cell) && state.cell.getChildCount() === 0 && state.isTransparentState();
    }
    /**
     * Destroy the preview and highlight shapes.
     */ destroyShapes() {
        // Destroys the preview dashed rectangle
        if (this.shape) {
            this.shape.destroy();
            this.shape = null;
        }
        if (this.guide) {
            this.guide.destroy();
            this.guide = null;
        }
        // Destroys the drop target highlight
        if (this.highlight) {
            this.highlight.destroy();
            this.highlight = null;
        }
    }
    /**
     * Destroys the handler and all its resources and DOM nodes.
     */ onDestroy() {
        this.graph.removeMouseListener(this);
        this.graph.removeListener(this.panHandler);
        this.graph.removeListener(this.escapeHandler);
        this.graph.getDataModel().removeListener(this.refreshHandler);
        this.graph.removeListener(this.refreshHandler);
        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).removeListener(document, 'keydown', this.keyHandler);
        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).removeListener(document, 'keyup', this.keyHandler);
        this.destroyShapes();
        this.removeHint();
    }
    getSelectionCellsHandler() {
        return this.graph.getPlugin('SelectionCellsHandler');
    }
}
$49bd4ce5d7a604a2$var$SelectionHandler.pluginId = 'SelectionHandler';
var $49bd4ce5d7a604a2$export$2e2bcd8739ae039 = $49bd4ce5d7a604a2$var$SelectionHandler;


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 




/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 


/**
 * Implements a handler for panning.
 *
 * @category Navigation
 */ class $274c4f32a068a57e$var$PanningManager {
    constructor(graph){
        /**
         * Damper value for the panning. Default is 1/6.
         */ this.damper = 1 / 6;
        /**
         * Delay in milliseconds for the panning. Default is 10.
         */ this.delay = 10;
        /**
         * Specifies if mouse events outside the component should be handled. Default is true.
         */ this.handleMouseOut = true;
        /**
         * Border to handle automatic panning inside the component. Default is 0 (disabled).
         */ this.border = 0;
        this.thread = null;
        this.active = false;
        this.tdx = 0;
        this.tdy = 0;
        this.t0x = 0;
        this.t0y = 0;
        this.dx = 0;
        this.dy = 0;
        this.scrollbars = false;
        this.scrollLeft = 0;
        this.scrollTop = 0;
        this.thread = null;
        this.active = false;
        this.tdx = 0;
        this.tdy = 0;
        this.t0x = 0;
        this.t0y = 0;
        this.dx = 0;
        this.dy = 0;
        this.scrollbars = false;
        this.scrollLeft = 0;
        this.scrollTop = 0;
        this.mouseListener = {
            mouseDown: ()=>{
            // do nothing
            },
            mouseMove: ()=>{
            // do nothing
            },
            mouseUp: ()=>{
                if (this.active) this.stop();
            }
        };
        graph.addMouseListener(this.mouseListener);
        this.mouseUpListener = ()=>{
            if (this.active) this.stop();
        };
        // Stops scrolling on every mouseup anywhere in the document
        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addListener(document, 'mouseup', this.mouseUpListener);
        const createThread = ()=>{
            this.scrollbars = (0, $b55d6ca3b42398e2$export$988b38dbf6859d61)(graph.container);
            this.scrollLeft = graph.container.scrollLeft;
            this.scrollTop = graph.container.scrollTop;
            return window.setInterval(()=>{
                this.tdx -= this.dx;
                this.tdy -= this.dy;
                if (this.scrollbars) {
                    const left = -graph.container.scrollLeft - Math.ceil(this.dx);
                    const top = -graph.container.scrollTop - Math.ceil(this.dy);
                    graph.panGraph(left, top);
                    graph.setPanDx(this.scrollLeft - graph.container.scrollLeft);
                    graph.setPanDy(this.scrollTop - graph.container.scrollTop);
                    graph.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).PAN));
                // TODO: Implement graph.autoExtend
                } else graph.panGraph(this.getDx(), this.getDy());
            }, this.delay);
        };
        this.isActive = ()=>{
            return this.active;
        };
        this.getDx = ()=>{
            return Math.round(this.tdx);
        };
        this.getDy = ()=>{
            return Math.round(this.tdy);
        };
        this.start = ()=>{
            this.t0x = graph.view.translate.x;
            this.t0y = graph.view.translate.y;
            this.active = true;
        };
        this.panTo = (x, y, w = 0, h = 0)=>{
            if (!this.active) this.start();
            this.scrollLeft = graph.container.scrollLeft;
            this.scrollTop = graph.container.scrollTop;
            const c = graph.container;
            this.dx = x + w - c.scrollLeft - c.clientWidth;
            if (this.dx < 0 && Math.abs(this.dx) < this.border) this.dx = this.border + this.dx;
            else if (this.handleMouseOut) this.dx = Math.max(this.dx, 0);
            else this.dx = 0;
            if (this.dx == 0) {
                this.dx = x - c.scrollLeft;
                if (this.dx > 0 && this.dx < this.border) this.dx -= this.border;
                else if (this.handleMouseOut) this.dx = Math.min(0, this.dx);
                else this.dx = 0;
            }
            this.dy = y + h - c.scrollTop - c.clientHeight;
            if (this.dy < 0 && Math.abs(this.dy) < this.border) this.dy = this.border + this.dy;
            else if (this.handleMouseOut) this.dy = Math.max(this.dy, 0);
            else this.dy = 0;
            if (this.dy == 0) {
                this.dy = y - c.scrollTop;
                if (this.dy > 0 && this.dy < this.border) this.dy -= this.border;
                else if (this.handleMouseOut) this.dy = Math.min(0, this.dy);
                else this.dy = 0;
            }
            if (this.dx != 0 || this.dy != 0) {
                this.dx *= this.damper;
                this.dy *= this.damper;
                if (this.thread == null) this.thread = createThread();
            } else if (this.thread != null) {
                window.clearInterval(this.thread);
                this.thread = null;
            }
        };
        this.stop = ()=>{
            if (this.active) {
                this.active = false;
                if (this.thread != null) {
                    window.clearInterval(this.thread);
                    this.thread = null;
                }
                this.tdx = 0;
                this.tdy = 0;
                if (!this.scrollbars) {
                    const px = graph.getPanDx();
                    const py = graph.getPanDy();
                    if (px != 0 || py != 0) {
                        graph.panGraph(0, 0);
                        graph.view.setTranslate(this.t0x + px / graph.view.scale, this.t0y + py / graph.view.scale);
                    }
                } else {
                    graph.setPanDx(0);
                    graph.setPanDy(0);
                    graph.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).PAN));
                }
            }
        };
        this.destroy = ()=>{
            this.stop();
            graph.removeMouseListener(this.mouseListener);
            (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).removeListener(document, 'mouseup', this.mouseUpListener);
        };
    }
}
var $274c4f32a068a57e$export$2e2bcd8739ae039 = $274c4f32a068a57e$var$PanningManager;


/**
 * Event handler that pans and creates popupmenus.
 *
 * To use the left mouse button for panning without interfering with cell moving and resizing, use {@link useLeftButtonForPanning} and {@link ignoreCell}.
 *
 * For grid size steps while panning, use {@link useGrid}.
 *
 * When registered in the {@link AbstractGraph.constructor} plugins list, it can be enabled using {@link AbstractGraph.setPanning}.
 *
 * ### Events
 *
 * **{@link InternalEvent.PAN_START}**
 *
 * Fires when the panning handler changes its {@link active} state to `true`.
 *
 * In the {@link EventObject} parameter of the listener function, the `event` property contains the corresponding {@link MouseEvent}.
 *
 * **{@link InternalEvent.PAN}**
 *
 * Fires while handle is processing events.
 *
 * In the {@link EventObject} parameter of the listener function, the `event` property contains the corresponding {@link MouseEvent}.
 *
 * **{@link InternalEvent.PAN_END}**
 *
 * Fires when the panning handler changes its {@link active} state to `false`.
 *
 * In the {@link EventObject} parameter of the listener function, the `event` property contains the corresponding {@link MouseEvent}.
 *
 * @category Plugin
 * @category Navigation
 */ class $eceb7e6f9e281a77$var$PanningHandler extends (0, $17f25eceeba97548$export$2e2bcd8739ae039) {
    constructor(graph){
        super();
        this.getPanningManager = ()=>this.panningManager;
        /**
         * Specifies if panning should be active for the left mouse button.
         * Setting this to true may conflict with {@link RubberBandHandler}.
         *
         * @default false
         */ this.useLeftButtonForPanning = false;
        /**
         * Specifies if {@link Event.isPopupTrigger} should also be used for panning.
         * @default true
         */ this.usePopupTrigger = true;
        /**
         * Specifies if panning should be active even if there is a cell under the mouse pointer.
         * @default false
         */ this.ignoreCell = false;
        /**
         * Specifies if the panning should be previewed.
         * @default true
         */ this.previewEnabled = true;
        /**
         * Specifies if the panning steps should be aligned to the grid size.
         * @default false
         */ this.useGrid = false;
        /**
         * Specifies if panning should be enabled.
         * @default false
         */ this.panningEnabled = false;
        /**
         * Specifies if pinch gestures should be handled as zoom.
         * @default true
         */ this.pinchEnabled = true;
        this.initialScale = 0;
        /**
         * Specifies the maximum scale.
         * @default 8
         */ this.maxScale = 8;
        /**
         * Specifies the minimum scale.
         * @default 0.01
         */ this.minScale = 0.01;
        /**
         * Holds the current horizontal offset.
         */ this.dx = 0;
        /**
         * Holds the current vertical offset.
         */ this.dy = 0;
        /**
         * Holds the x-coordinate of the start point.
         */ this.startX = 0;
        /**
         * Holds the y-coordinate of the start point.
         */ this.startY = 0;
        this.dx0 = 0;
        this.dy0 = 0;
        this.panningTrigger = false;
        this.active = false;
        this.mouseDownEvent = null;
        this.graph = graph;
        this.graph.addMouseListener(this);
        // Handles force panning event
        this.forcePanningHandler = (_sender, eo)=>{
            const evtName = eo.getProperty('eventName');
            const me = eo.getProperty('event');
            if (evtName === (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_DOWN && this.isForcePanningEvent(me)) {
                this.start(me);
                this.active = true;
                this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).PAN_START, {
                    event: me
                }));
                me.consume();
            }
        };
        this.graph.addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).FIRE_MOUSE_EVENT, this.forcePanningHandler);
        // Handles pinch gestures
        this.gestureHandler = (_sender, eo)=>{
            if (this.isPinchEnabled()) {
                const evt = eo.getProperty('event');
                if (!(0, $f192e93a2fd1153c$export$f6e93dab47d340de)(evt) && evt.type === 'gesturestart') {
                    this.initialScale = this.graph.view.scale;
                    // Forces start of panning when pinch gesture starts
                    if (!this.active && this.mouseDownEvent) {
                        this.start(this.mouseDownEvent);
                        this.mouseDownEvent = null;
                    }
                } else if (evt.type === 'gestureend' && this.initialScale !== 0) this.initialScale = 0;
                if (this.initialScale !== 0) this.zoomGraph(evt);
            }
        };
        this.graph.addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).GESTURE, this.gestureHandler);
        this.mouseUpListener = ()=>{
            if (this.active) this.reset();
        };
        // Stops scrolling on every mouseup anywhere in the document
        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addListener(document, 'mouseup', this.mouseUpListener);
        this.panningManager = new (0, $274c4f32a068a57e$export$2e2bcd8739ae039)(graph);
    }
    /**
     * Returns true if the handler is currently active.
     */ isActive() {
        return this.active || this.initialScale !== null;
    }
    /**
     * Returns <panningEnabled>.
     */ isPanningEnabled() {
        return this.panningEnabled;
    }
    /**
     * Sets <panningEnabled>.
     */ setPanningEnabled(value) {
        this.panningEnabled = value;
    }
    /**
     * Returns <pinchEnabled>.
     */ isPinchEnabled() {
        return this.pinchEnabled;
    }
    /**
     * Sets <pinchEnabled>.
     */ setPinchEnabled(value) {
        this.pinchEnabled = value;
    }
    /**
     * Returns `true` if the given event is a panning trigger for the optional given cell.
     *
     * This returns true if control-shift is pressed or if {@link usePopupTrigger} is `true` and the event is a popup trigger.
     */ isPanningTrigger(me) {
        const evt = me.getEvent();
        return this.useLeftButtonForPanning && !me.getState() && (0, $f192e93a2fd1153c$export$94d43346060bc767)(evt) || (0, $f192e93a2fd1153c$export$aec581d3997aa3aa)(evt) && (0, $f192e93a2fd1153c$export$1d7fd696f3493e74)(evt) || this.usePopupTrigger && (0, $f192e93a2fd1153c$export$e9cb688973f06c96)(evt);
    }
    /**
     * Returns true if the given {@link MouseEvent} should start panning.
     *
     * This implementation always returns `true` if {@link ignoreCell} is `true` or for multi touch events.
     */ isForcePanningEvent(me) {
        return this.ignoreCell || (0, $f192e93a2fd1153c$export$d06464d6b74eedc4)(me.getEvent());
    }
    /**
     * Handles the event by initiating the panning. By consuming the event all
     * subsequent events of the gesture are redirected to this handler.
     */ mouseDown(_sender, me) {
        this.mouseDownEvent = me;
        if (!me.isConsumed() && this.isPanningEnabled() && !this.active && this.isPanningTrigger(me)) {
            this.start(me);
            this.consumePanningTrigger(me);
        }
    }
    /**
     * Starts panning at the given event.
     */ start(me) {
        this.dx0 = -this.graph.container.scrollLeft;
        this.dy0 = -this.graph.container.scrollTop;
        // Stores the location of the trigger event
        this.startX = me.getX();
        this.startY = me.getY();
        this.dx = 0;
        this.dy = 0;
        this.panningTrigger = true;
    }
    /**
     * Consumes the given {@link MouseEvent} if it was a panning trigger in
     * {@link ouseDown}. The default is to invoke {@link MouseEvent#consume}. Note that this
     * will block any further event processing. If you haven't disabled built-in
     * context menus and require immediate selection of the cell on mouseDown in
     * Safari and/or on the Mac, then use the following code:
     *
     * ```javascript
     * consumePanningTrigger(me)
     * {
     *   if (me.evt.preventDefault)
     *   {
     *     me.evt.preventDefault();
     *   }
     *
     *   // Stops event processing in IE
     *   me.evt.returnValue = false;
     *
     *   // Sets local consumed state
     *   if (!Client.IS_SF && !Client.IS_MAC)
     *   {
     *     me.consumed = true;
     *   }
     * };
     * ```
     */ consumePanningTrigger(me) {
        me.consume();
    }
    /**
     * Handles the event by updating the panning on the graph.
     */ mouseMove(_sender, me) {
        this.dx = me.getX() - this.startX;
        this.dy = me.getY() - this.startY;
        if (this.active) {
            if (this.previewEnabled) {
                // Applies the grid to the panning steps
                if (this.useGrid) {
                    this.dx = this.graph.snap(this.dx);
                    this.dy = this.graph.snap(this.dy);
                }
                this.graph.panGraph(this.dx + this.dx0, this.dy + this.dy0);
            }
            this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).PAN, {
                event: me
            }));
        } else if (this.panningTrigger) {
            const tmp = this.active;
            // Panning is activated only if the mouse is moved
            // beyond the graph tolerance
            this.active = Math.abs(this.dx) > this.graph.getSnapTolerance() || Math.abs(this.dy) > this.graph.getSnapTolerance();
            if (!tmp && this.active) this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).PAN_START, {
                event: me
            }));
        }
        if (this.active || this.panningTrigger) me.consume();
    }
    /**
     * Handles the event by setting the translation on the view or showing the
     * popupmenu.
     */ mouseUp(_sender, me) {
        if (this.active) {
            if (this.dx !== 0 && this.dy !== 0) {
                // Ignores if scrollbars have been used for panning
                if (!this.graph.isUseScrollbarsForPanning() || !(0, $b55d6ca3b42398e2$export$988b38dbf6859d61)(this.graph.container)) {
                    const { scale: scale } = this.graph.getView();
                    const t = this.graph.getView().translate;
                    this.graph.panGraph(0, 0);
                    this.panGraph(t.x + this.dx / scale, t.y + this.dy / scale);
                }
                me.consume();
            }
            this.fireEvent(new (0, $9f60d86b38132780$export$2e2bcd8739ae039)((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).PAN_END, {
                event: me
            }));
        }
        this.reset();
    }
    /**
     * Zooms the graph to the given value and consumed the event if needed.
     */ zoomGraph(evt) {
        // @ts-ignore evt may have scale property
        let value = Math.round(this.initialScale * evt.scale * 100) / 100;
        value = Math.max(this.minScale, value);
        value = Math.min(this.maxScale, value);
        if (this.graph.view.scale !== value) {
            this.graph.zoomTo(value);
            (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).consume(evt);
        }
    }
    /**
     * Handles the event by setting the translation on the view or showing the
     * popupmenu.
     */ reset() {
        this.panningTrigger = false;
        this.mouseDownEvent = null;
        this.active = false;
        this.dx = 0;
        this.dy = 0;
    }
    /**
     * Pans {@link graph} by the given amount.
     */ panGraph(dx, dy) {
        this.graph.getView().setTranslate(dx, dy);
    }
    /**
     * Destroys the handler and all its resources and DOM nodes.
     */ onDestroy() {
        this.graph.removeMouseListener(this);
        this.graph.removeListener(this.forcePanningHandler);
        this.graph.removeListener(this.gestureHandler);
        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).removeListener(document, 'mouseup', this.mouseUpListener);
        this.panningManager.destroy();
        super.destroy();
    }
}
$eceb7e6f9e281a77$var$PanningHandler.pluginId = 'PanningHandler';
var $eceb7e6f9e281a77$export$2e2bcd8739ae039 = $eceb7e6f9e281a77$var$PanningHandler;


/*
Copyright 2025-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
function $a9c2855cc762abb5$var$keep2digits(value) {
    return Number(value.toFixed(2));
}
class $a9c2855cc762abb5$export$2a91daefac92e795 {
    /**
     * Constructs the plugin that provides `fit` methods.
     *
     * @param graph Reference to the enclosing {@link AbstractGraph}.
     */ constructor(graph){
        this.graph = graph;
        /**
         * Specifies the minimum scale to be applied in {@link fit}. Set this to `null` to allow any value.
         * @default 0.1
         * @since 0.21.0
         */ this.minFitScale = 0.1;
        /**
         * Specifies the maximum scale to be applied in {@link fit} and  {@link fitCenter}. Set this to `null` to allow any value.
         * @default 8
         */ this.maxFitScale = 8;
    }
    /**
     * Scales the graph such that the complete diagram fits into {@link Graph.container} and returns the current scale in the view.
     * To fit an initial graph prior to rendering, set {@link GraphView.rendering} to `false` prior to changing the model
     * and execute the following after changing the model.
     *
     * ```javascript
     * graph.view.rendering = false;
     * // here, change the model
     * graph.getPlugin<FitPlugin>('fit')?.fit();
     * graph.view.rendering = true;
     * graph.refresh();
     * ```
     *
     * To fit and center the graph, use {@link fitCenter}.
     *
     * @param options Optional number that specifies the border.
     * @since 0.21.0
     */ fit(options = {}) {
        const { border: border = this.graph.getBorder(), keepOrigin: keepOrigin = false, margin: margin = 0, enabled: enabled = true, ignoreWidth: ignoreWidth = false, ignoreHeight: ignoreHeight = false, maxHeight: maxHeight = null } = options;
        const { backgroundImage: backgroundImage, container: container, view: view } = this.graph;
        if (!container) return view.scale;
        let bounds = view.getGraphBounds();
        if (!(bounds.width > 0 && bounds.height > 0)) return view.scale;
        // Adds spacing and border from css
        const cssBorder = this.graph.getBorderSizes();
        let w1 = container.offsetWidth - cssBorder.x - cssBorder.width - 1;
        let h1 = maxHeight ?? container.offsetHeight - cssBorder.y - cssBorder.height - 1;
        if (keepOrigin && bounds.x != null && bounds.y != null) {
            bounds = bounds.clone();
            bounds.width += bounds.x;
            bounds.height += bounds.y;
            bounds.x = 0;
            bounds.y = 0;
        }
        // LATER: Use unscaled bounding boxes to fix rounding errors
        const originalScale = view.scale;
        let w2 = bounds.width / originalScale;
        let h2 = bounds.height / originalScale;
        // Fits to the size of the background image if required
        if (backgroundImage) {
            w2 = Math.max(w2, backgroundImage.width - bounds.x / originalScale);
            h2 = Math.max(h2, backgroundImage.height - bounds.y / originalScale);
        }
        const b = (keepOrigin ? border : 2 * border) + margin + 1;
        w1 -= b;
        h1 -= b;
        let newScale = ignoreWidth ? h1 / h2 : ignoreHeight ? w1 / w2 : Math.min(w1 / w2, h1 / h2);
        const minScale = this.minFitScale ?? 0;
        const maxScale = this.maxFitScale ?? Infinity;
        newScale = Math.max(Math.min(newScale, maxScale), minScale);
        if (enabled) {
            if (!keepOrigin) {
                if (!(0, $b55d6ca3b42398e2$export$988b38dbf6859d61)(container)) {
                    const x0 = bounds.x != null ? Math.floor(view.translate.x - bounds.x / originalScale + border / newScale + margin / 2) : border;
                    const y0 = bounds.y != null ? Math.floor(view.translate.y - bounds.y / originalScale + border / newScale + margin / 2) : border;
                    view.scaleAndTranslate(newScale, x0, y0);
                } else {
                    view.setScale(newScale);
                    const newBounds = this.graph.getGraphBounds();
                    if (newBounds.x != null) container.scrollLeft = newBounds.x;
                    if (newBounds.y != null) container.scrollTop = newBounds.y;
                }
            } else if (view.scale != newScale) view.setScale(newScale);
        } else return newScale;
        return view.scale;
    }
    /**
     * Fit and center the graph within its container.
     *
     * @param options Optional options to customize the fit behavior.
     * @returns The current scale in the view.
     */ fitCenter(options) {
        // Inspired by the former examples provided in the Graph.fit JSDoc: https://github.com/maxGraph/maxGraph/blob/v0.16.0/packages/core/src/view/Graph.ts#L845-L861
        const margin = options?.margin ?? 2;
        const { container: container, view: view } = this.graph;
        const clientWidth = container.clientWidth - 2 * margin;
        const clientHeight = container.clientHeight - 2 * margin;
        const bounds = this.graph.getGraphBounds();
        const originalScale = view.scale;
        const width = bounds.width / originalScale;
        const height = bounds.height / originalScale;
        // Apply workarounds to avoid rounding impact if fitCenter is called multiple times
        // Use precise scale value when computing translation values, but round the applied scale
        // Translate using integer values as this is done in Graph.fit
        let newScale = Math.min(this.maxFitScale ?? Infinity, clientWidth / width, clientHeight / height);
        if (!Number.isFinite(newScale)) newScale = originalScale;
        const translateX = Math.floor(view.translate.x + (container.clientWidth - width * newScale) / (2 * newScale) - bounds.x / originalScale);
        const translateY = Math.floor(view.translate.y + (container.clientHeight - height * newScale) / (2 * newScale) - bounds.y / originalScale);
        newScale = $a9c2855cc762abb5$var$keep2digits(newScale);
        view.scaleAndTranslate(newScale, translateX, translateY);
        return newScale;
    }
    /** Do nothing here. */ onDestroy() {
    // no-op
    }
}
$a9c2855cc762abb5$export$2a91daefac92e795.pluginId = 'fit';


/*
Copyright 2026-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /**
 * A plugin that manages {@link ImageBundle} instances for the graph.
 *
 * Image bundles map keys to image URLs (or data URIs). The keys can then be referenced in any cell style
 * via {@link CellStateStyle.image}.
 *
 * {@link AbstractGraph.postProcessCellStyle} (defined in `CellsMixin`) delegates bundle key resolution to this
 * plugin: when registered, a `style.image` that matches a bundle key is replaced with the underlying
 * URL/data URI; when this plugin is NOT registered (for instance on a {@link BaseGraph} without explicit
 * opt-in), the bundle lookup is silently skipped and the raw `style.image` key is used as the image path.
 *
 * @since 0.24.0
 * @category Plugin
 */ class $38e1383eb9435d8b$export$e64b4c286f5153f0 {
    /**
     * Constructs the plugin that manages image bundles.
     *
     * @param graph Reference to the enclosing {@link AbstractGraph}. Accepted to conform with the
     *   {@link GraphPluginConstructor} contract; not retained because this plugin does not interact
     *   with the graph directly.
     */ constructor(graph){
        /**
         * The registered {@link ImageBundle} instances. Bundles are consulted in insertion order; the first match wins.
         * @default [] (empty array)
         */ this.imageBundles = [];
    }
    /**
     * Adds the specified {@link ImageBundle}.
     */ addImageBundle(bundle) {
        this.imageBundles.push(bundle);
    }
    /**
     * Removes all occurrences of the specified {@link ImageBundle}.
     */ removeImageBundle(bundle) {
        this.imageBundles = this.imageBundles.filter((b)=>b !== bundle);
    }
    /**
     * Searches all {@link imageBundles} for the specified key and returns the value for the first match or
     * `null` if the key is not found.
     */ getImageFromBundles(key) {
        if (key) for (const bundle of this.imageBundles){
            const image = bundle.getImage(key);
            if (image) return image;
        }
        return null;
    }
    /** Releases the registered bundles to help garbage collection. */ onDestroy() {
        this.imageBundles = [];
    }
}
$38e1383eb9435d8b$export$e64b4c286f5153f0.pluginId = 'image-bundle';


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2016, JGraph Ltd
Copyright (c) 2006-2016, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 







/**
 * Event handler that selects rectangular regions.
 *
 * **IMPORTANT**: This is not built-into `maxGraph` i.e. this plugin is not in the `maxGraph` default plugins, see {@link getDefaultPlugins}.
 *
 * To enable rubberband selection in a graph, use the following code.
 *
 * ```javascript
 * const plugins = [
 *   ...getDefaultPlugins(), // or any other plugins you want
 *   RubberBandHandler,
 * ];
 *
 * // Creates the graph with the custom plugins
 * const graph = new Graph(container, undefined, plugins);
 * ```
 *
 * **IMPORTANT**: the RubberBandHandler requires CSS styles in order to work properly.
 * See the CSS rules in the `css/common.css` file provided within the npm package. They relate to the `.mxRubberband` class.
 *
 * @category Plugin
 */ class $82736aee638f8ebe$var$RubberBandHandler {
    constructor(graph){
        this.first = null;
        this.destroyed = false;
        this.dragHandler = null;
        this.dropHandler = null;
        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
        /**
         * Specifies the default opacity to be used for the rubberband div.
         * Valid values are between `0` and `100`.
         * @default 20
         */ this.defaultOpacity = 20;
        /**
         * Specifies if events are handled.
         * @default true
         */ this.enabled = true;
        /**
         * Holds the DIV element which is currently visible.
         */ this.div = null;
        /**
         * Holds the DIV element which is used to display the rubberband.
         */ this.sharedDiv = null;
        /**
         * Holds the value of the x argument in the last call to {@link update}.
         */ this.currentX = 0;
        /**
         * Holds the value of the y argument in the last call to {@link update}.
         */ this.currentY = 0;
        /**
         * Optional fade out effect.
         * @default false
         */ this.fadeOut = false;
        this.graph = graph;
        this.graph.addMouseListener(this);
        // Handles force rubberband event
        this.forceRubberbandHandler = (sender, evt)=>{
            const evtName = evt.getProperty('eventName');
            const me = evt.getProperty('event');
            if (evtName === (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).MOUSE_DOWN && this.isForceRubberbandEvent(me)) {
                const offset = (0, $b55d6ca3b42398e2$export$622cea445a1c5b7d)(this.graph.container);
                const origin = (0, $b55d6ca3b42398e2$export$744922fd1f3b32b)(this.graph.container);
                origin.x -= offset.x;
                origin.y -= offset.y;
                this.start(me.getX() + origin.x, me.getY() + origin.y);
                me.consume(false);
            }
        };
        this.graph.addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).FIRE_MOUSE_EVENT, this.forceRubberbandHandler);
        // Repaints the marquee after autoscroll
        this.panHandler = ()=>{
            this.repaint();
        };
        this.graph.addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).PAN, this.panHandler);
        // Does not show menu if any touch gestures take place after the trigger
        this.gestureHandler = (sender, eo)=>{
            if (this.first) this.reset();
        };
        this.graph.addListener((0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).GESTURE, this.gestureHandler);
    }
    /**
     * Creates the rubberband selection shape.
     */ isEnabled() {
        return this.enabled;
    }
    /**
     * Enables or disables event handling. This implementation updates{@link enabled}.
     */ setEnabled(enabled) {
        this.enabled = enabled;
    }
    /**
     * Returns true if the given {@link MouseEvent} should start rubberband selection.
     * This implementation returns true if the alt key is pressed.
     */ isForceRubberbandEvent(me) {
        return (0, $f192e93a2fd1153c$export$bdc3218ff6eba0d8)(me.getEvent());
    }
    /**
     * Handles the event by initiating a rubberband selection.
     * By consuming the event all subsequent events of the gesture are redirected to this handler.
     */ mouseDown(_sender, me) {
        if (!me.isConsumed() && this.isEnabled() && this.graph.isEnabled() && !me.getState() && !(0, $f192e93a2fd1153c$export$d06464d6b74eedc4)(me.getEvent())) {
            const offset = (0, $b55d6ca3b42398e2$export$622cea445a1c5b7d)(this.graph.container);
            const origin = (0, $b55d6ca3b42398e2$export$744922fd1f3b32b)(this.graph.container);
            origin.x -= offset.x;
            origin.y -= offset.y;
            this.start(me.getX() + origin.x, me.getY() + origin.y);
            // Does not prevent the default for this event so that the
            // event processing chain is still executed even if we start
            // rubberbanding. This is required eg. in ExtJs to hide the
            // current context menu. In mouseMove we'll make sure we're
            // not selecting anything while we're rubberbanding.
            me.consume(false);
        }
    }
    /**
     * Creates the rubberband selection shape.
     */ start(x, y) {
        this.first = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y);
        const { container: container } = this.graph;
        function createMouseEvent(evt) {
            const me = new (0, $2051fd5f8fd06bc7$export$2e2bcd8739ae039)(evt);
            const pt = (0, $b55d6ca3b42398e2$export$864dc177f7f5bda1)(container, me.getX(), me.getY());
            me.graphX = pt.x;
            me.graphY = pt.y;
            return me;
        }
        this.dragHandler = (evt)=>{
            this.mouseMove(this.graph, createMouseEvent(evt));
        };
        this.dropHandler = (evt)=>{
            this.mouseUp(this.graph, createMouseEvent(evt));
        };
        // Workaround for rubberband stopping if the mouse leaves the container in Firefox
        if ((0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_FF) (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).addGestureListeners(document, null, this.dragHandler, this.dropHandler);
    }
    /**
     * Handles the event by updating the rubberband selection.
     */ mouseMove(_sender, me) {
        if (!me.isConsumed() && this.first) {
            const origin = (0, $b55d6ca3b42398e2$export$744922fd1f3b32b)(this.graph.container);
            const offset = (0, $b55d6ca3b42398e2$export$622cea445a1c5b7d)(this.graph.container);
            origin.x -= offset.x;
            origin.y -= offset.y;
            const x = me.getX() + origin.x;
            const y = me.getY() + origin.y;
            const dx = this.first.x - x;
            const dy = this.first.y - y;
            const tol = this.graph.getEventTolerance();
            if (this.div || Math.abs(dx) > tol || Math.abs(dy) > tol) {
                if (!this.div) this.div = this.createShape();
                // Clears selection while rubberbanding. This is required because
                // the event is not consumed in mouseDown.
                (0, $b1d29c834e82fef5$export$a3d02541b0ebf605)();
                this.update(x, y);
                me.consume();
            }
        }
    }
    /**
     * Creates the rubberband selection shape.
     */ createShape() {
        if (!this.sharedDiv) {
            this.sharedDiv = document.createElement('div');
            this.sharedDiv.className = 'mxRubberband';
            (0, $b55d6ca3b42398e2$export$2646c6b151d2e8)(this.sharedDiv, this.defaultOpacity);
        }
        this.graph.container.appendChild(this.sharedDiv);
        const result = this.sharedDiv;
        if ((0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_SVG && this.fadeOut) this.sharedDiv = null;
        return result;
    }
    /**
     * Returns true if this handler is active.
     */ isActive(sender, me) {
        return this.div && this.div.style.display !== 'none';
    }
    /**
     * Handles the event by selecting the region of the rubberband using {@link AbstractGraph.selectRegion}.
     */ mouseUp(_sender, me) {
        const active = this.isActive();
        this.reset();
        if (active) {
            this.execute(me.getEvent());
            me.consume();
        }
    }
    /**
     * Resets the state of this handler and selects the current region for the given event.
     */ execute(evt) {
        const rect = new (0, $2997c239141ea844$export$2e2bcd8739ae039)(this.x, this.y, this.width, this.height);
        this.graph.selectRegion(rect, evt);
    }
    /**
     * Resets the state of the rubberband selection.
     */ reset() {
        if (this.div) {
            if ((0, $d47e32a58f71e01d$export$2e2bcd8739ae039).IS_SVG && this.fadeOut) {
                const temp = this.div;
                (0, $b55d6ca3b42398e2$export$5cd002036665463c)(temp.style, 'transition', 'all 0.2s linear');
                temp.style.pointerEvents = 'none';
                temp.style.opacity = String(0);
                window.setTimeout(()=>{
                    if (temp.parentNode) temp.parentNode.removeChild(temp);
                }, 200);
            } else if (this.div.parentNode) this.div.parentNode.removeChild(this.div);
        }
        (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).removeGestureListeners(document, null, this.dragHandler, this.dropHandler);
        this.dragHandler = null;
        this.dropHandler = null;
        this.currentX = 0;
        this.currentY = 0;
        this.first = null;
        this.div = null;
    }
    /**
     * Sets <currentX> and <currentY> and calls {@link repaint}.
     */ update(x, y) {
        this.currentX = x;
        this.currentY = y;
        this.repaint();
    }
    /**
     * Computes the bounding box and updates the style of the `div`.
     */ repaint() {
        if (this.div && this.first) {
            const x = this.currentX - this.graph.getPanDx();
            const y = this.currentY - this.graph.getPanDy();
            this.x = Math.min(this.first.x, x);
            this.y = Math.min(this.first.y, y);
            this.width = Math.max(this.first.x, x) - this.x;
            this.height = Math.max(this.first.y, y) - this.y;
            const dx = 0;
            const dy = 0;
            this.div.style.left = `${this.x + dx}px`;
            this.div.style.top = `${this.y + dy}px`;
            this.div.style.width = `${Math.max(1, this.width)}px`;
            this.div.style.height = `${Math.max(1, this.height)}px`;
        }
    }
    /**
     * Destroys the handler and all its resources and DOM nodes.
     * This does normally not need to be called, it is called automatically when the window unloads.
     */ onDestroy() {
        if (!this.destroyed) {
            this.destroyed = true;
            this.graph.removeMouseListener(this);
            this.graph.removeListener(this.forceRubberbandHandler);
            this.graph.removeListener(this.panHandler);
            this.graph.removeListener(this.gestureHandler);
            this.reset();
            if (this.sharedDiv) this.sharedDiv = null;
        }
    }
}
$82736aee638f8ebe$var$RubberBandHandler.pluginId = 'RubberBandHandler';
var $82736aee638f8ebe$export$2e2bcd8739ae039 = $82736aee638f8ebe$var$RubberBandHandler;


const $75c7fc7da3bb5f3b$export$e5c8557874730c58 = ()=>[
        (0, $3e6c1027d91142d4$export$2e2bcd8739ae039),
        (0, $7f5b7d97e04b4503$export$2e2bcd8739ae039),
        (0, $bfdc6dda29863ca3$export$2e2bcd8739ae039),
        (0, $0cfb38ee30b027b0$export$2e2bcd8739ae039),
        (0, $28f9a5c5f46c401e$export$2e2bcd8739ae039),
        (0, $49bd4ce5d7a604a2$export$2e2bcd8739ae039),
        (0, $eceb7e6f9e281a77$export$2e2bcd8739ae039),
        (0, $a9c2855cc762abb5$export$2a91daefac92e795),
        (0, $38e1383eb9435d8b$export$e64b4c286f5153f0)
    ];

var $c11d809e274fa603$exports = {};

$parcel$export($c11d809e274fa603$exports, "createArrow", () => $c11d809e274fa603$export$8f7d98f7c012cca0);
$parcel$export($c11d809e274fa603$exports, "createOpenArrow", () => $c11d809e274fa603$export$b5f4cbd0b19a0c82);
$parcel$export($c11d809e274fa603$exports, "oval", () => $c11d809e274fa603$export$1ed76074fcc3565f);
$parcel$export($c11d809e274fa603$exports, "diamond", () => $c11d809e274fa603$export$bc2a8782c99449da);
/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ const $c11d809e274fa603$var$isClassicOrClassicThin = (type)=>type === 'classic' || type === 'classicThin';
const $c11d809e274fa603$var$isDiamond = (type)=>type === 'diamond';
const $c11d809e274fa603$export$8f7d98f7c012cca0 = (widthFactor)=>(canvas, _shape, type, pe, unitX, unitY, size, _source, sw, filled)=>{
        // The angle of the forward facing arrow sides against the x axis is
        // 26.565 degrees, 1/sin(26.565) = 2.236 / 2 = 1.118 ( / 2 allows for
        // only half the strokewidth is processed ).
        const endOffsetX = unitX * sw * 1.118;
        const endOffsetY = unitY * sw * 1.118;
        unitX *= size + sw;
        unitY *= size + sw;
        const pt = pe.clone();
        pt.x -= endOffsetX;
        pt.y -= endOffsetY;
        const f = !$c11d809e274fa603$var$isClassicOrClassicThin(type) ? 1 : 3 / 4;
        pe.x += -unitX * f - endOffsetX;
        pe.y += -unitY * f - endOffsetY;
        return ()=>{
            canvas.begin();
            canvas.moveTo(pt.x, pt.y);
            canvas.lineTo(pt.x - unitX - unitY / widthFactor, pt.y - unitY + unitX / widthFactor);
            if ($c11d809e274fa603$var$isClassicOrClassicThin(type)) canvas.lineTo(pt.x - unitX * 3 / 4, pt.y - unitY * 3 / 4);
            canvas.lineTo(pt.x + unitY / widthFactor - unitX, pt.y - unitY - unitX / widthFactor);
            canvas.close();
            if (filled) canvas.fillAndStroke();
            else canvas.stroke();
        };
    };
const $c11d809e274fa603$export$b5f4cbd0b19a0c82 = (widthFactor)=>(canvas, _shape, _type, pe, unitX, unitY, size, _source, sw, _filled)=>{
        // The angle of the forward facing arrow sides against the x axis is
        // 26.565 degrees, 1/sin(26.565) = 2.236 / 2 = 1.118 ( / 2 allows for
        // only half the strokewidth is processed ).
        const endOffsetX = unitX * sw * 1.118;
        const endOffsetY = unitY * sw * 1.118;
        unitX *= size + sw;
        unitY *= size + sw;
        const pt = pe.clone();
        pt.x -= endOffsetX;
        pt.y -= endOffsetY;
        pe.x += -endOffsetX * 2;
        pe.y += -endOffsetY * 2;
        return ()=>{
            canvas.begin();
            canvas.moveTo(pt.x - unitX - unitY / widthFactor, pt.y - unitY + unitX / widthFactor);
            canvas.lineTo(pt.x, pt.y);
            canvas.lineTo(pt.x + unitY / widthFactor - unitX, pt.y - unitY - unitX / widthFactor);
            canvas.stroke();
        };
    };
const $c11d809e274fa603$export$1ed76074fcc3565f = (canvas, _shape, _type, pe, unitX, unitY, size, _source, _sw, filled)=>{
    const a = size / 2;
    const pt = pe.clone();
    pe.x -= unitX * a;
    pe.y -= unitY * a;
    return ()=>{
        canvas.ellipse(pt.x - a, pt.y - a, size, size);
        if (filled) canvas.fillAndStroke();
        else canvas.stroke();
    };
};
const $c11d809e274fa603$export$bc2a8782c99449da = (canvas, _shape, type, pe, unitX, unitY, size, _source, sw, filled)=>{
    // The angle of the forward facing arrow sides against the x axis is
    // 45 degrees, 1/sin(45) = 1.4142 / 2 = 0.7071 ( / 2 allows for
    // only half the strokewidth is processed ). Or 0.9862 for thin diamond.
    // Note these values and the tk variable below are dependent, update
    // both together (saves trig hard coding it).
    const swFactor = $c11d809e274fa603$var$isDiamond(type) ? 0.7071 : 0.9862;
    const endOffsetX = unitX * sw * swFactor;
    const endOffsetY = unitY * sw * swFactor;
    unitX *= size + sw;
    unitY *= size + sw;
    const pt = pe.clone();
    pt.x -= endOffsetX;
    pt.y -= endOffsetY;
    pe.x += -unitX - endOffsetX;
    pe.y += -unitY - endOffsetY;
    // thickness factor for diamond
    const tk = $c11d809e274fa603$var$isDiamond(type) ? 2 : 3.4;
    return ()=>{
        canvas.begin();
        canvas.moveTo(pt.x, pt.y);
        canvas.lineTo(pt.x - unitX / 2 - unitY / tk, pt.y + unitX / tk - unitY / 2);
        canvas.lineTo(pt.x - unitX, pt.y - unitY);
        canvas.lineTo(pt.x - unitX / 2 + unitY / tk, pt.y - unitY / 2 - unitX / tk);
        canvas.close();
        if (filled) canvas.fillAndStroke();
        else canvas.stroke();
    };
};

var $2f44305691436bfe$exports = {};

$parcel$export($2f44305691436bfe$exports, "EllipsePerimeter", () => $a7be515184519328$export$aa40dd0844546f20);
$parcel$export($2f44305691436bfe$exports, "HexagonPerimeter", () => $749454134d177b45$export$645e2fce148f1b52);
$parcel$export($2f44305691436bfe$exports, "RectanglePerimeter", () => $0abae1ed12d3613d$export$85a76429f0159d08);
$parcel$export($2f44305691436bfe$exports, "RhombusPerimeter", () => $e43a7f3481965cd8$export$ce71346f9a7744f);
$parcel$export($2f44305691436bfe$exports, "TrianglePerimeter", () => $aea660b624fbdd2c$export$35ac075a76ca0ecb);
/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ /*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
const $a7be515184519328$export$aa40dd0844546f20 = (bounds, _vertex, next, orthogonal = false)=>{
    const { x: x } = bounds;
    const { y: y } = bounds;
    const a = bounds.width / 2;
    const b = bounds.height / 2;
    const cx = x + a;
    const cy = y + b;
    const px = next.x;
    const py = next.y;
    // Calculates straight line equation through
    // point and ellipse center y = d * x + h
    const dx = Number.parseInt(String(px - cx));
    const dy = Number.parseInt(String(py - cy));
    if (dx === 0 && dy !== 0) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(cx, cy + b * dy / Math.abs(dy));
    if (dx === 0 && dy === 0) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(px, py);
    if (orthogonal) {
        if (py >= y && py <= y + bounds.height) {
            const ty = py - cy;
            let tx = Math.sqrt(a * a * (1 - ty * ty / (b * b))) || 0;
            if (px <= x) tx = -tx;
            return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(cx + tx, py);
        }
        if (px >= x && px <= x + bounds.width) {
            const tx = px - cx;
            let ty = Math.sqrt(b * b * (1 - tx * tx / (a * a))) || 0;
            if (py <= y) ty = -ty;
            return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(px, cy + ty);
        }
    }
    // Calculates intersection
    const d = dy / dx;
    const h = cy - d * cx;
    const e = a * a * d * d + b * b;
    const f = -2 * cx * e;
    const g = a * a * d * d * cx * cx + b * b * cx * cx - a * a * b * b;
    const det = Math.sqrt(f * f - 4 * e * g);
    // Two solutions (perimeter points)
    const xout1 = (-f + det) / (2 * e);
    const xout2 = (-f - det) / (2 * e);
    const yout1 = d * xout1 + h;
    const yout2 = d * xout2 + h;
    const dist1 = Math.sqrt(Math.pow(xout1 - px, 2) + Math.pow(yout1 - py, 2));
    const dist2 = Math.sqrt(Math.pow(xout2 - px, 2) + Math.pow(yout2 - py, 2));
    // Correct solution
    let xout = 0;
    let yout = 0;
    if (dist1 < dist2) {
        xout = xout1;
        yout = yout1;
    } else {
        xout = xout2;
        yout = yout2;
    }
    return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(xout, yout);
};


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 

const $749454134d177b45$export$645e2fce148f1b52 = (bounds, vertex, next, orthogonal = false)=>{
    const { x: x } = bounds;
    const { y: y } = bounds;
    const w = bounds.width;
    const h = bounds.height;
    const cx = bounds.getCenterX();
    const cy = bounds.getCenterY();
    const px = next.x;
    const py = next.y;
    const dx = px - cx;
    const dy = py - cy;
    const alpha = -Math.atan2(dy, dx);
    const pi = Math.PI;
    const pi2 = Math.PI / 2;
    let result = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(cx, cy);
    const direction = vertex?.style?.direction ?? 'east';
    const vertical = direction === 'north' || direction === 'south';
    let a = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)();
    let b = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)();
    // Only consider corrects quadrants for the orthogonal case.
    if (px < x && py < y || px < x && py > y + h || px > x + w && py < y || px > x + w && py > y + h) orthogonal = false;
    if (orthogonal) {
        if (vertical) {
            // Special cases where intersects with hexagon corners
            if (px === cx) {
                if (py <= y) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(cx, y);
                if (py >= y + h) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(cx, y + h);
            } else if (px < x) {
                if (py === y + h / 4) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y + h / 4);
                if (py === y + 3 * h / 4) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y + 3 * h / 4);
            } else if (px > x + w) {
                if (py === y + h / 4) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w, y + h / 4);
                if (py === y + 3 * h / 4) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w, y + 3 * h / 4);
            } else if (px === x) {
                if (py < cy) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y + h / 4);
                if (py > cy) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y + 3 * h / 4);
            } else if (px === x + w) {
                if (py < cy) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w, y + h / 4);
                if (py > cy) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w, y + 3 * h / 4);
            }
            if (py === y) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(cx, y);
            if (py === y + h) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(cx, y + h);
            if (px < cx) {
                if (py > y + h / 4 && py < y + 3 * h / 4) {
                    a = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y);
                    b = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y + h);
                } else if (py < y + h / 4) {
                    a = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x - Math.floor(0.5 * w), y + Math.floor(0.5 * h));
                    b = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w, y - Math.floor(0.25 * h));
                } else if (py > y + 3 * h / 4) {
                    a = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x - Math.floor(0.5 * w), y + Math.floor(0.5 * h));
                    b = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w, y + Math.floor(1.25 * h));
                }
            } else if (px > cx) {
                if (py > y + h / 4 && py < y + 3 * h / 4) {
                    a = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w, y);
                    b = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w, y + h);
                } else if (py < y + h / 4) {
                    a = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y - Math.floor(0.25 * h));
                    b = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + Math.floor(1.5 * w), y + Math.floor(0.5 * h));
                } else if (py > y + 3 * h / 4) {
                    a = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + Math.floor(1.5 * w), y + Math.floor(0.5 * h));
                    b = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y + Math.floor(1.25 * h));
                }
            }
        } else {
            // Special cases where intersects with hexagon corners
            if (py === cy) {
                if (px <= x) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y + h / 2);
                if (px >= x + w) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w, y + h / 2);
            } else if (py < y) {
                if (px === x + w / 4) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w / 4, y);
                if (px === x + 3 * w / 4) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + 3 * w / 4, y);
            } else if (py > y + h) {
                if (px === x + w / 4) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w / 4, y + h);
                if (px === x + 3 * w / 4) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + 3 * w / 4, y + h);
            } else if (py === y) {
                if (px < cx) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w / 4, y);
                if (px > cx) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + 3 * w / 4, y);
            } else if (py === y + h) {
                if (px < cx) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w / 4, y + h);
                if (py > cy) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + 3 * w / 4, y + h);
            }
            if (px === x) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, cy);
            if (px === x + w) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w, cy);
            if (py < cy) {
                if (px > x + w / 4 && px < x + 3 * w / 4) {
                    a = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y);
                    b = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w, y);
                } else if (px < x + w / 4) {
                    a = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x - Math.floor(0.25 * w), y + h);
                    b = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + Math.floor(0.5 * w), y - Math.floor(0.5 * h));
                } else if (px > x + 3 * w / 4) {
                    a = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + Math.floor(0.5 * w), y - Math.floor(0.5 * h));
                    b = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + Math.floor(1.25 * w), y + h);
                }
            } else if (py > cy) {
                if (px > x + w / 4 && px < x + 3 * w / 4) {
                    a = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y + h);
                    b = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w, y + h);
                } else if (px < x + w / 4) {
                    a = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x - Math.floor(0.25 * w), y);
                    b = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + Math.floor(0.5 * w), y + Math.floor(1.5 * h));
                } else if (px > x + 3 * w / 4) {
                    a = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + Math.floor(0.5 * w), y + Math.floor(1.5 * h));
                    b = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + Math.floor(1.25 * w), y);
                }
            }
        }
        let tx = cx;
        let ty = cy;
        if (px >= x && px <= x + w) {
            tx = px;
            if (py < cy) ty = y + h;
            else ty = y;
        } else if (py >= y && py <= y + h) {
            ty = py;
            if (px < cx) tx = x + w;
            else tx = x;
        }
        result = (0, $f7ff90b8964488a6$export$bc86dfbf7795668c)(tx, ty, next.x, next.y, a.x, a.y, b.x, b.y);
    } else {
        if (vertical) {
            const beta = Math.atan2(h / 4, w / 2);
            // Special cases where intersects with hexagon corners
            if (alpha === beta) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w, y + Math.floor(0.25 * h));
            if (alpha === pi2) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + Math.floor(0.5 * w), y);
            if (alpha === pi - beta) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y + Math.floor(0.25 * h));
            if (alpha === -beta) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w, y + Math.floor(0.75 * h));
            if (alpha === -pi2) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + Math.floor(0.5 * w), y + h);
            if (alpha === -pi + beta) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y + Math.floor(0.75 * h));
            if (alpha < beta && alpha > -beta) {
                a = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w, y);
                b = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w, y + h);
            } else if (alpha > beta && alpha < pi2) {
                a = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y - Math.floor(0.25 * h));
                b = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + Math.floor(1.5 * w), y + Math.floor(0.5 * h));
            } else if (alpha > pi2 && alpha < pi - beta) {
                a = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x - Math.floor(0.5 * w), y + Math.floor(0.5 * h));
                b = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w, y - Math.floor(0.25 * h));
            } else if (alpha > pi - beta && alpha <= pi || alpha < -pi + beta && alpha >= -pi) {
                a = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y);
                b = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y + h);
            } else if (alpha < -beta && alpha > -pi2) {
                a = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + Math.floor(1.5 * w), y + Math.floor(0.5 * h));
                b = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y + Math.floor(1.25 * h));
            } else if (alpha < -pi2 && alpha > -pi + beta) {
                a = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x - Math.floor(0.5 * w), y + Math.floor(0.5 * h));
                b = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w, y + Math.floor(1.25 * h));
            }
        } else {
            const beta = Math.atan2(h / 2, w / 4);
            // Special cases where intersects with hexagon corners
            if (alpha === beta) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + Math.floor(0.75 * w), y);
            if (alpha === pi - beta) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + Math.floor(0.25 * w), y);
            if (alpha === pi || alpha === -pi) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y + Math.floor(0.5 * h));
            if (alpha === 0) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w, y + Math.floor(0.5 * h));
            if (alpha === -beta) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + Math.floor(0.75 * w), y + h);
            if (alpha === -pi + beta) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + Math.floor(0.25 * w), y + h);
            if (alpha > 0 && alpha < beta) {
                a = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + Math.floor(0.5 * w), y - Math.floor(0.5 * h));
                b = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + Math.floor(1.25 * w), y + h);
            } else if (alpha > beta && alpha < pi - beta) {
                a = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y);
                b = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w, y);
            } else if (alpha > pi - beta && alpha < pi) {
                a = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x - Math.floor(0.25 * w), y + h);
                b = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + Math.floor(0.5 * w), y - Math.floor(0.5 * h));
            } else if (alpha < 0 && alpha > -beta) {
                a = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + Math.floor(0.5 * w), y + Math.floor(1.5 * h));
                b = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + Math.floor(1.25 * w), y);
            } else if (alpha < -beta && alpha > -pi + beta) {
                a = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y + h);
                b = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w, y + h);
            } else if (alpha < -pi + beta && alpha > -pi) {
                a = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x - Math.floor(0.25 * w), y);
                b = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + Math.floor(0.5 * w), y + Math.floor(1.5 * h));
            }
        }
        result = (0, $f7ff90b8964488a6$export$bc86dfbf7795668c)(cx, cy, next.x, next.y, a.x, a.y, b.x, b.y);
    }
    if (result == null) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(cx, cy);
    return result;
};


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 
const $0abae1ed12d3613d$export$85a76429f0159d08 = (bounds, _vertex, next, orthogonal = false)=>{
    const cx = bounds.getCenterX();
    const cy = bounds.getCenterY();
    const dx = next.x - cx;
    const dy = next.y - cy;
    const alpha = Math.atan2(dy, dx);
    const p = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(0, 0);
    const pi = Math.PI;
    const pi2 = Math.PI / 2;
    const beta = pi2 - alpha;
    const t = Math.atan2(bounds.height, bounds.width);
    if (alpha < -pi + t || alpha > pi - t) {
        // Left edge
        p.x = bounds.x;
        p.y = cy - bounds.width * Math.tan(alpha) / 2;
    } else if (alpha < -t) {
        // Top Edge
        p.y = bounds.y;
        p.x = cx - bounds.height * Math.tan(beta) / 2;
    } else if (alpha < t) {
        // Right Edge
        p.x = bounds.x + bounds.width;
        p.y = cy + bounds.width * Math.tan(alpha) / 2;
    } else {
        // Bottom Edge
        p.y = bounds.y + bounds.height;
        p.x = cx + bounds.height * Math.tan(beta) / 2;
    }
    if (orthogonal) {
        if (next.x >= bounds.x && next.x <= bounds.x + bounds.width) p.x = next.x;
        else if (next.y >= bounds.y && next.y <= bounds.y + bounds.height) p.y = next.y;
        if (next.x < bounds.x) p.x = bounds.x;
        else if (next.x > bounds.x + bounds.width) p.x = bounds.x + bounds.width;
        if (next.y < bounds.y) p.y = bounds.y;
        else if (next.y > bounds.y + bounds.height) p.y = bounds.y + bounds.height;
    }
    return p;
};


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 

const $e43a7f3481965cd8$export$ce71346f9a7744f = (bounds, _vertex, next, orthogonal = false)=>{
    const { x: x } = bounds;
    const { y: y } = bounds;
    const w = bounds.width;
    const h = bounds.height;
    const cx = x + w / 2;
    const cy = y + h / 2;
    const px = next.x;
    const py = next.y;
    // Special case for intersecting the diamond's corners
    if (cx === px) {
        if (cy > py) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(cx, y); // top
        return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(cx, y + h); // bottom
    }
    if (cy === py) {
        if (cx > px) return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, cy); // left
        return new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w, cy); // right
    }
    let tx = cx;
    let ty = cy;
    if (orthogonal) {
        if (px >= x && px <= x + w) tx = px;
        else if (py >= y && py <= y + h) ty = py;
    }
    // In which quadrant will the intersection be?
    // set the slope and offset of the border line accordingly
    if (px < cx) {
        if (py < cy) return (0, $f7ff90b8964488a6$export$bc86dfbf7795668c)(px, py, tx, ty, cx, y, x, cy);
        return (0, $f7ff90b8964488a6$export$bc86dfbf7795668c)(px, py, tx, ty, cx, y + h, x, cy);
    }
    if (py < cy) return (0, $f7ff90b8964488a6$export$bc86dfbf7795668c)(px, py, tx, ty, cx, y, x + w, cy);
    return (0, $f7ff90b8964488a6$export$bc86dfbf7795668c)(px, py, tx, ty, cx, y + h, x + w, cy);
};


/*
Copyright 2021-present The maxGraph project Contributors
Copyright (c) 2006-2015, JGraph Ltd
Copyright (c) 2006-2015, Gaudenz Alder

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 

const $aea660b624fbdd2c$export$35ac075a76ca0ecb = (bounds, vertex, next, orthogonal = false)=>{
    const direction = vertex != null ? vertex.style.direction : null;
    const vertical = direction === 'north' || direction === 'south';
    const { x: x } = bounds;
    const { y: y } = bounds;
    const w = bounds.width;
    const h = bounds.height;
    let cx = x + w / 2;
    let cy = y + h / 2;
    let start = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y);
    let corner = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w, cy);
    let end = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y + h);
    switch(direction){
        case 'north':
            start = end;
            corner = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(cx, y);
            end = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w, y + h);
            break;
        case 'south':
            corner = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(cx, y + h);
            end = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w, y);
            break;
        case 'west':
            start = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w, y);
            corner = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, cy);
            end = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w, y + h);
            break;
    }
    let dx = next.x - cx;
    let dy = next.y - cy;
    const alpha = vertical ? Math.atan2(dx, dy) : Math.atan2(dy, dx);
    const t = vertical ? Math.atan2(w, h) : Math.atan2(h, w);
    let base = false;
    if (direction === 'north' || direction === 'west') base = alpha > -t && alpha < t;
    else base = alpha < -Math.PI + t || alpha > Math.PI - t;
    let result = null;
    if (base) {
        if (orthogonal && (vertical && next.x >= start.x && next.x <= end.x || !vertical && next.y >= start.y && next.y <= end.y)) {
            if (vertical) result = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(next.x, start.y);
            else result = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(start.x, next.y);
        } else switch(direction){
            case 'north':
                result = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w / 2 + h * Math.tan(alpha) / 2, y + h);
                break;
            case 'south':
                result = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w / 2 - h * Math.tan(alpha) / 2, y);
                break;
            case 'west':
                result = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x + w, y + h / 2 + w * Math.tan(alpha) / 2);
                break;
            default:
                result = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(x, y + h / 2 - w * Math.tan(alpha) / 2);
        }
    } else {
        if (orthogonal) {
            const pt = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(cx, cy);
            if (next.y >= y && next.y <= y + h) {
                pt.x = vertical ? cx : direction === 'west' ? x + w : x;
                pt.y = next.y;
            } else if (next.x >= x && next.x <= x + w) {
                pt.x = next.x;
                pt.y = !vertical ? cy : direction === 'north' ? y + h : y;
            }
            // Compute angle
            dx = next.x - pt.x;
            dy = next.y - pt.y;
            cx = pt.x;
            cy = pt.y;
        }
        if (vertical && next.x <= x + w / 2 || !vertical && next.y <= y + h / 2) result = (0, $f7ff90b8964488a6$export$bc86dfbf7795668c)(next.x, next.y, cx, cy, start.x, start.y, corner.x, corner.y);
        else result = (0, $f7ff90b8964488a6$export$bc86dfbf7795668c)(next.x, next.y, cx, cy, corner.x, corner.y, end.x, end.y);
    }
    if (result == null) result = new (0, $d32f79fa744af3c6$export$2e2bcd8739ae039)(cx, cy);
    return result;
};



/*
Copyright 2024-present The maxGraph project Contributors

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/ 



const $55f97ca034a81359$export$ac28a258d726aee0 = ()=>{
    (0, $130af394a0fcdee4$export$28d1530539966ca9).add('elbowEdgeStyle', (0, $dea342649dfec9b9$exports).ElbowConnector, {
        handlerKind: 'elbow',
        isOrthogonal: true
    });
};
const $55f97ca034a81359$export$6445fa81ef3db8c0 = ()=>{
    (0, $130af394a0fcdee4$export$28d1530539966ca9).add('entityRelationEdgeStyle', (0, $dea342649dfec9b9$exports).EntityRelation, {
        allowIntermediateHandles: false,
        isOrthogonal: true
    });
};
const $55f97ca034a81359$export$e74545f9f9076a39 = ()=>{
    (0, $130af394a0fcdee4$export$28d1530539966ca9).add('loopEdgeStyle', (0, $dea342649dfec9b9$exports).Loop, {
        handlerKind: 'elbow',
        isOrthogonal: false
    });
};
const $55f97ca034a81359$export$6bfab76031d5d43c = ()=>{
    (0, $130af394a0fcdee4$export$28d1530539966ca9).add('manhattanEdgeStyle', (0, $dea342649dfec9b9$exports).ManhattanConnector, {
        handlerKind: 'segment',
        isOrthogonal: true
    });
};
const $55f97ca034a81359$export$35695aacdfb8416c = ()=>{
    (0, $130af394a0fcdee4$export$28d1530539966ca9).add('orthogonalEdgeStyle', (0, $dea342649dfec9b9$exports).OrthConnector, {
        handlerKind: 'segment',
        isOrthogonal: true
    });
};
const $55f97ca034a81359$export$a44109b7c4a3af5e = ()=>{
    (0, $130af394a0fcdee4$export$28d1530539966ca9).add('segmentEdgeStyle', (0, $dea342649dfec9b9$exports).SegmentConnector, {
        handlerKind: 'segment',
        isOrthogonal: true
    });
};
const $55f97ca034a81359$export$60b9267c0c8c4e4d = ()=>{
    (0, $130af394a0fcdee4$export$28d1530539966ca9).add('sideToSideEdgeStyle', (0, $dea342649dfec9b9$exports).SideToSide, {
        handlerKind: 'elbow',
        isOrthogonal: true
    });
};
const $55f97ca034a81359$export$2853376805b8e456 = ()=>{
    (0, $130af394a0fcdee4$export$28d1530539966ca9).add('topToBottomEdgeStyle', (0, $dea342649dfec9b9$exports).TopToBottom, {
        handlerKind: 'elbow',
        isOrthogonal: true
    });
};
let $55f97ca034a81359$var$isDefaultEdgeStylesRegistered = false;
const $55f97ca034a81359$export$83a407dfa8de29c4 = ()=>{
    if (!$55f97ca034a81359$var$isDefaultEdgeStylesRegistered) {
        $55f97ca034a81359$export$ac28a258d726aee0();
        $55f97ca034a81359$export$6445fa81ef3db8c0();
        $55f97ca034a81359$export$e74545f9f9076a39();
        $55f97ca034a81359$export$6bfab76031d5d43c();
        $55f97ca034a81359$export$35695aacdfb8416c();
        $55f97ca034a81359$export$a44109b7c4a3af5e();
        $55f97ca034a81359$export$60b9267c0c8c4e4d();
        $55f97ca034a81359$export$2853376805b8e456();
        $55f97ca034a81359$var$isDefaultEdgeStylesRegistered = true;
    }
};
let $55f97ca034a81359$var$isDefaultPerimetersRegistered = false;
const $55f97ca034a81359$export$7ae9ac211beca3ba = ()=>{
    if (!$55f97ca034a81359$var$isDefaultPerimetersRegistered) {
        const perimetersToRegister = [
            [
                'ellipsePerimeter',
                (0, $2f44305691436bfe$exports).EllipsePerimeter
            ],
            [
                'hexagonPerimeter',
                (0, $2f44305691436bfe$exports).HexagonPerimeter
            ],
            [
                'rectanglePerimeter',
                (0, $2f44305691436bfe$exports).RectanglePerimeter
            ],
            [
                'rhombusPerimeter',
                (0, $2f44305691436bfe$exports).RhombusPerimeter
            ],
            [
                'trianglePerimeter',
                (0, $2f44305691436bfe$exports).TrianglePerimeter
            ]
        ];
        for (const [name, perimeter] of perimetersToRegister)(0, $f6ffa40f48aaef80$export$e92e39e3fc5b4647).add(name, perimeter);
        $55f97ca034a81359$var$isDefaultPerimetersRegistered = true;
    }
};
const $55f97ca034a81359$export$26f845420cb4e8b8 = ()=>{
    $55f97ca034a81359$export$bcf49c07ec91f7be();
    $55f97ca034a81359$export$ffa628616c0a8bbd();
};
const $55f97ca034a81359$export$bcf49c07ec91f7be = ()=>{
    (0, $130af394a0fcdee4$export$28d1530539966ca9).clear();
    $55f97ca034a81359$var$isDefaultEdgeStylesRegistered = false;
};
const $55f97ca034a81359$export$ffa628616c0a8bbd = ()=>{
    (0, $f6ffa40f48aaef80$export$e92e39e3fc5b4647).clear();
    $55f97ca034a81359$var$isDefaultPerimetersRegistered = false;
};
let $55f97ca034a81359$var$isDefaultMarkersRegistered = false;
const $55f97ca034a81359$export$15fbd2c621da968e = ()=>{
    if (!$55f97ca034a81359$var$isDefaultMarkersRegistered) {
        const markersToRegister = [
            [
                'classic',
                (0, $c11d809e274fa603$exports).createArrow(2)
            ],
            [
                'classicThin',
                (0, $c11d809e274fa603$exports).createArrow(3)
            ],
            [
                'block',
                (0, $c11d809e274fa603$exports).createArrow(2)
            ],
            [
                'blockThin',
                (0, $c11d809e274fa603$exports).createArrow(3)
            ],
            [
                'open',
                (0, $c11d809e274fa603$exports).createOpenArrow(2)
            ],
            [
                'openThin',
                (0, $c11d809e274fa603$exports).createOpenArrow(3)
            ],
            [
                'oval',
                (0, $c11d809e274fa603$exports).oval
            ],
            [
                'diamond',
                (0, $c11d809e274fa603$exports).diamond
            ],
            [
                'diamondThin',
                (0, $c11d809e274fa603$exports).diamond
            ]
        ];
        for (const [type, factory] of markersToRegister)(0, $22f248acd8a7d0ef$export$fda6e3c4c112260a).add(type, factory);
        $55f97ca034a81359$var$isDefaultMarkersRegistered = true;
    }
};
const $55f97ca034a81359$export$abbd8023046cf02c = ()=>{
    (0, $22f248acd8a7d0ef$export$fda6e3c4c112260a).clear();
    $55f97ca034a81359$var$isDefaultMarkersRegistered = false;
};



// The renderer builds a registered shape with no argument, so these defaults cannot come from a constructor. They are
// also derived from the style, so `resetStyles()` wipes them on every style change. Each one is therefore declared
// twice, as a class field for the first render and in a `resetStyles()` override for every later change, which is why
// it is a named constant rather than a literal.
const $9c48a8eb201833c7$var$RECTANGLE_STROKE_WIDTH = 3;
const $9c48a8eb201833c7$var$RECTANGLE_IS_ROUNDED = true; // force rounded shape
const $9c48a8eb201833c7$var$ELLIPSE_STROKE_WIDTH = 5;
const $9c48a8eb201833c7$export$7b782b7b1381dcb9 = ()=>{
    console.info('Registering custom shapes...');
    (0, $7589a668edfb0759$export$c15282e4d9d6e44e).add('customRectangle', $9c48a8eb201833c7$var$CustomRectangleShape);
    (0, $7589a668edfb0759$export$c15282e4d9d6e44e).add('customEllipse', $9c48a8eb201833c7$var$CustomEllipseShape);
    console.info('Custom shapes registered');
};
class $9c48a8eb201833c7$var$CustomRectangleShape extends (0, $14ee9ba473f8b778$export$2e2bcd8739ae039) {
    strokeWidth = $9c48a8eb201833c7$var$RECTANGLE_STROKE_WIDTH;
    isRounded = $9c48a8eb201833c7$var$RECTANGLE_IS_ROUNDED;
    resetStyles() {
        super.resetStyles();
        this.strokeWidth = $9c48a8eb201833c7$var$RECTANGLE_STROKE_WIDTH;
        this.isRounded = $9c48a8eb201833c7$var$RECTANGLE_IS_ROUNDED;
    }
    paintBackground(c, x, y, w, h) {
        c.setFillColor('Chartreuse');
        super.paintBackground(c, x, y, w, h);
    }
    paintVertexShape(c, x, y, w, h) {
        c.setStrokeColor('Black');
        super.paintVertexShape(c, x, y, w, h);
    }
}
class $9c48a8eb201833c7$var$CustomEllipseShape extends (0, $f3582df951663f77$export$2e2bcd8739ae039) {
    strokeWidth = $9c48a8eb201833c7$var$ELLIPSE_STROKE_WIDTH;
    resetStyles() {
        super.resetStyles();
        this.strokeWidth = $9c48a8eb201833c7$var$ELLIPSE_STROKE_WIDTH;
    }
    paintVertexShape(c, x, y, w, h) {
        c.setFillColor('Yellow');
        c.setStrokeColor('Red');
        super.paintVertexShape(c, x, y, w, h);
    }
}


/**
 * Custom implementation of {@link BaseGraph} that only register the built-in styles required by the example.
 */ class $ddfb02423bbbf20e$var$CustomGraph extends (0, $beb1c49bb5001815$export$44cb372311309cb9) {
    /**
     * Only registers the elements required for this example. Do not let Graph load all default built-in styles.
     */ registerDefaults() {
        // Register builtin shapes
        // RectangleShape is not registered here because it is always available. It is the fallback shape for vertices when no shape is returned by the registry
        (0, $7589a668edfb0759$export$c15282e4d9d6e44e).add('ellipse', (0, $f3582df951663f77$export$2e2bcd8739ae039));
        // Register builtin styles
        (0, $f6ffa40f48aaef80$export$e92e39e3fc5b4647).add('ellipsePerimeter', (0, $2f44305691436bfe$exports).EllipsePerimeter);
        (0, $f6ffa40f48aaef80$export$e92e39e3fc5b4647).add('rectanglePerimeter', (0, $2f44305691436bfe$exports).RectanglePerimeter); // declared in the default vertex style, so must be registered to be used
        (0, $55f97ca034a81359$export$35695aacdfb8416c)();
        const arrowFunction = (0, $c11d809e274fa603$exports).createArrow(2);
        (0, $22f248acd8a7d0ef$export$fda6e3c4c112260a).add('classic', arrowFunction);
        (0, $22f248acd8a7d0ef$export$fda6e3c4c112260a).add('block', arrowFunction);
        // Register custom shapes
        (0, $9c48a8eb201833c7$export$7b782b7b1381dcb9)();
    }
}
const $ddfb02423bbbf20e$export$82c630a16d9c47e8 = (container)=>{
    container ??= document.querySelector('#graph-container');
    // Disables the built-in context menu
    (0, $7f545ffa3f1c932b$export$2e2bcd8739ae039).disableContextMenu(container);
    const graph = new $ddfb02423bbbf20e$var$CustomGraph({
        container: container,
        plugins: [
            (0, $3e6c1027d91142d4$export$2e2bcd8739ae039),
            (0, $eceb7e6f9e281a77$export$2e2bcd8739ae039),
            (0, $82736aee638f8ebe$export$2e2bcd8739ae039),
            (0, $bfdc6dda29863ca3$export$2e2bcd8739ae039),
            (0, $49bd4ce5d7a604a2$export$2e2bcd8739ae039)
        ]
    });
    graph.setPanning(true); // Use mouse right button for panning
    // Customize the rubber band selection
    const rubberBandHandler = graph.getPlugin('RubberBandHandler');
    rubberBandHandler && (rubberBandHandler.fadeOut = true);
    // create a dedicated style for "ellipse" to share properties
    graph.getStylesheet().putCellStyle('myEllipse', {
        perimeter: 'ellipsePerimeter',
        shape: 'ellipse',
        verticalAlign: 'top',
        verticalLabelPosition: 'bottom'
    });
    // Adds cells to the model in a single step
    graph.batchUpdate(()=>{
        const vertex01 = graph.insertVertex({
            value: 'a regular rectangle',
            position: [
                10,
                10
            ],
            size: [
                100,
                100
            ]
        });
        const vertex02 = graph.insertVertex({
            value: 'a regular ellipse',
            position: [
                350,
                90
            ],
            size: [
                50,
                50
            ],
            style: {
                baseStyleNames: [
                    'myEllipse'
                ],
                fillColor: 'orange'
            }
        });
        graph.insertEdge({
            value: 'an orthogonal style edge',
            source: vertex01,
            target: vertex02,
            style: {
                edgeStyle: 'orthogonalEdgeStyle',
                rounded: true
            }
        });
        const vertex11 = graph.insertVertex({
            value: 'a custom rectangle',
            position: [
                20,
                200
            ],
            size: [
                100,
                100
            ],
            style: {
                shape: 'customRectangle'
            }
        });
        const vertex12 = graph.insertVertex({
            value: 'a custom ellipse',
            x: 150,
            y: 350,
            width: 70,
            height: 70,
            style: {
                baseStyleNames: [
                    'myEllipse'
                ],
                shape: 'customEllipse'
            }
        });
        graph.insertEdge({
            value: 'another edge',
            source: vertex11,
            target: vertex12,
            style: {
                endArrow: 'block'
            }
        });
    });
};



var $cBHcM = parcelRequire("cBHcM");
/** Display the maxGraph version in the footer. */ const $abc2e452f4d9c5e4$var$fillFooter = ()=>{
    const footer = document.querySelector('footer');
    footer.innerText = `Built with maxGraph ${(0, $cBHcM).VERSION}`;
};
const $abc2e452f4d9c5e4$export$42458123f73fda52 = (cssSelector, options)=>{
    document.querySelector(cssSelector).innerHTML = `
    <h1>maxGraph <a href="${options.toolUrl}" target="_blank" rel="noopener noreferrer">${options.toolName}</a> TypeScript example</h1>
    <p>Display a test graph. Activated behaviours:</p>
    <ul>
      <li>Panning: use mouse right button</li>
      <li>Cells selection with Rubberband: use mouse left button</li>
    </ul>
    <div id="graph-container"></div>
    <footer></footer>
`;
    $abc2e452f4d9c5e4$var$fillFooter();
};


const $30b8e4fb2c867149$export$27403f92c1682a9 = (cssSelector, options)=>{
    (0, $abc2e452f4d9c5e4$export$42458123f73fda52)(cssSelector, options);
    (0, $ddfb02423bbbf20e$export$82c630a16d9c47e8)();
};


(0, $30b8e4fb2c867149$export$27403f92c1682a9)('#app', {
    toolName: 'Parcel',
    toolUrl: 'https://parceljs.org/'
});


//# sourceMappingURL=parcel-ts.c8a97760.js.map
